webpackJsonp([2],{

/***/ 1098:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = __webpack_require__(782);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _setting = __webpack_require__(841);

var _setting2 = _interopRequireDefault(_setting);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RadioSetting = function (_React$Component) {
    (0, _inherits3.default)(RadioSetting, _React$Component);

    function RadioSetting(props) {
        (0, _classCallCheck3.default)(this, RadioSetting);

        var _this = (0, _possibleConstructorReturn3.default)(this, (RadioSetting.__proto__ || (0, _getPrototypeOf2.default)(RadioSetting)).call(this, props));

        _this.handleChange = _this.handleChange.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(RadioSetting, [{
        key: 'handleChange',
        value: function handleChange(e) {
            this.props.onChange(this.props.id, e.target.value);
        }
    }, {
        key: 'render',
        value: function render() {
            var options = [];
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = (0, _getIterator3.default)(this.props.values), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var _ref2 = _step.value;
                    var value = _ref2.value,
                        text = _ref2.text;

                    options.push(_react2.default.createElement(
                        'div',
                        {
                            className: 'radio',
                            key: value
                        },
                        _react2.default.createElement(
                            'label',
                            null,
                            _react2.default.createElement('input', {
                                type: 'radio',
                                value: value,
                                name: this.props.id,
                                checked: value === this.props.value,
                                onChange: this.handleChange,
                                disabled: this.props.disabled
                            }),
                            text
                        )
                    ));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            return _react2.default.createElement(
                _setting2.default,
                {
                    label: this.props.label,
                    inputId: this.props.id,
                    helpText: this.props.helpText
                },
                options
            );
        }
    }]);
    return RadioSetting;
}(_react2.default.Component); // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = RadioSetting;


RadioSetting.defaultProps = {
    isDisabled: false
};

RadioSetting.propTypes = {
    id: _propTypes2.default.string.isRequired,
    values: _propTypes2.default.array.isRequired,
    label: _propTypes2.default.node.isRequired,
    value: _propTypes2.default.string.isRequired,
    onChange: _propTypes2.default.func.isRequired,
    disabled: _propTypes2.default.bool,
    helpText: _propTypes2.default.node
};

/***/ }),

/***/ 1099:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(114);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _values = __webpack_require__(801);

var _values2 = _interopRequireDefault(_values);

var _getIterator2 = __webpack_require__(782);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _toConsumableArray2 = __webpack_require__(174);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _set = __webpack_require__(305);

var _set2 = _interopRequireDefault(_set);

var _slicedToArray2 = __webpack_require__(845);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = __webpack_require__(1457);

var _entries2 = _interopRequireDefault(_entries);

var _keys = __webpack_require__(116);

var _keys2 = _interopRequireDefault(_keys);

var _stringify = __webpack_require__(275);

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

exports.rolesFromMapping = rolesFromMapping;
exports.mappingValueFromRoles = mappingValueFromRoles;

var _index = __webpack_require__(19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [mappingPartIterator].map(_regenerator2.default.mark); // Copyright (c) 2018-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function teamMapping(permission) {
    return {
        all: [{ roleName: 'team_user', permission: permission, shouldHave: true }],
        team_admin: [{ roleName: 'team_user', permission: permission, shouldHave: false }, { roleName: 'team_admin', permission: permission, shouldHave: true }],
        system_admin: [{ roleName: 'team_user', permission: permission, shouldHave: false }, { roleName: 'team_admin', permission: permission, shouldHave: false }]
    };
}

function channelMapping(permission) {
    return {
        all: [{ roleName: 'channel_user', permission: permission, shouldHave: true }],
        channel_admin: [{ roleName: 'channel_user', permission: permission, shouldHave: false }, { roleName: 'channel_admin', permission: permission, shouldHave: true }, { roleName: 'team_admin', permission: permission, shouldHave: true }],
        team_admin: [{ roleName: 'channel_user', permission: permission, shouldHave: false }, { roleName: 'channel_admin', permission: permission, shouldHave: false }, { roleName: 'team_admin', permission: permission, shouldHave: true }],
        system_admin: [{ roleName: 'channel_user', permission: permission, shouldHave: false }, { roleName: 'channel_admin', permission: permission, shouldHave: false }, { roleName: 'team_admin', permission: permission, shouldHave: false }]
    };
}

function channelTeamMixedMapping(permission) {
    return {
        all: [{ roleName: 'team_user', permission: permission, shouldHave: true }],
        channel_admin: [{ roleName: 'team_user', permission: permission, shouldHave: false }, { roleName: 'channel_admin', permission: permission, shouldHave: true }, { roleName: 'team_admin', permission: permission, shouldHave: true }],
        team_admin: [{ roleName: 'team_user', permission: permission, shouldHave: false }, { roleName: 'channel_admin', permission: permission, shouldHave: false }, { roleName: 'team_admin', permission: permission, shouldHave: true }],
        system_admin: [{ roleName: 'team_user', permission: permission, shouldHave: false }, { roleName: 'channel_admin', permission: permission, shouldHave: false }, { roleName: 'team_admin', permission: permission, shouldHave: false }]
    };
}

var MAPPING = {
    restrictTeamInvite: {
        all: [{ roleName: 'team_user', permission: _index.Permissions.INVITE_USER, shouldHave: true }, { roleName: 'team_user', permission: _index.Permissions.ADD_USER_TO_TEAM, shouldHave: true }],
        team_admin: [{ roleName: 'team_user', permission: _index.Permissions.INVITE_USER, shouldHave: false }, { roleName: 'team_user', permission: _index.Permissions.ADD_USER_TO_TEAM, shouldHave: false }, { roleName: 'team_admin', permission: _index.Permissions.INVITE_USER, shouldHave: true }, { roleName: 'team_admin', permission: _index.Permissions.ADD_USER_TO_TEAM, shouldHave: true }],
        system_admin: [{ roleName: 'team_user', permission: _index.Permissions.INVITE_USER, shouldHave: false }, { roleName: 'team_user', permission: _index.Permissions.ADD_USER_TO_TEAM, shouldHave: false }, { roleName: 'team_admin', permission: _index.Permissions.INVITE_USER, shouldHave: false }, { roleName: 'team_admin', permission: _index.Permissions.ADD_USER_TO_TEAM, shouldHave: false }]
    },
    restrictPublicChannelCreation: (0, _extends3.default)({}, teamMapping(_index.Permissions.CREATE_PUBLIC_CHANNEL)),
    restrictPrivateChannelCreation: (0, _extends3.default)({}, teamMapping(_index.Permissions.CREATE_PRIVATE_CHANNEL)),

    restrictPrivateChannelManageMembers: (0, _extends3.default)({}, channelMapping(_index.Permissions.MANAGE_PRIVATE_CHANNEL_MEMBERS)),

    restrictPublicChannelManagement: (0, _extends3.default)({}, channelTeamMixedMapping(_index.Permissions.MANAGE_PUBLIC_CHANNEL_PROPERTIES)),
    restrictPublicChannelDeletion: (0, _extends3.default)({}, channelTeamMixedMapping(_index.Permissions.DELETE_PUBLIC_CHANNEL)),
    restrictPrivateChannelManagement: (0, _extends3.default)({}, channelTeamMixedMapping(_index.Permissions.MANAGE_PRIVATE_CHANNEL_PROPERTIES)),
    restrictPrivateChannelDeletion: (0, _extends3.default)({}, channelTeamMixedMapping(_index.Permissions.DELETE_PRIVATE_CHANNEL)),

    allowEditPost: {
        always: [{ roleName: 'channel_user', permission: _index.Permissions.EDIT_POST, shouldHave: true }, { roleName: 'system_admin', permission: _index.Permissions.EDIT_POST, shouldHave: true }],
        never: [{ roleName: 'channel_user', permission: _index.Permissions.EDIT_POST, shouldHave: false }, { roleName: 'system_admin', permission: _index.Permissions.EDIT_POST, shouldHave: false }]
    },

    restrictPostDelete: {
        all: [{ roleName: 'channel_user', permission: _index.Permissions.DELETE_POST, shouldHave: true }, { roleName: 'team_admin', permission: _index.Permissions.DELETE_POST, shouldHave: true }, { roleName: 'team_admin', permission: _index.Permissions.DELETE_OTHERS_POSTS, shouldHave: true }],
        team_admin: [{ roleName: 'channel_user', permission: _index.Permissions.DELETE_POST, shouldHave: false }, { roleName: 'team_admin', permission: _index.Permissions.DELETE_POST, shouldHave: true }, { roleName: 'team_admin', permission: _index.Permissions.DELETE_OTHERS_POSTS, shouldHave: true }],
        system_admin: [{ roleName: 'channel_user', permission: _index.Permissions.DELETE_POST, shouldHave: false }, { roleName: 'team_admin', permission: _index.Permissions.DELETE_POST, shouldHave: false }, { roleName: 'team_admin', permission: _index.Permissions.DELETE_OTHERS_POSTS, shouldHave: false }]
    },

    enableTeamCreation: {
        true: [{ roleName: 'system_user', permission: _index.Permissions.CREATE_TEAM, shouldHave: true }],
        false: [{ roleName: 'system_user', permission: _index.Permissions.CREATE_TEAM, shouldHave: false }]
    },

    enableOnlyAdminIntegrations: {
        true: [{ roleName: 'team_user', permission: _index.Permissions.MANAGE_WEBHOOKS, shouldHave: false }, { roleName: 'team_user', permission: _index.Permissions.MANAGE_SLASH_COMMANDS, shouldHave: false }, { roleName: 'system_user', permission: _index.Permissions.MANAGE_OAUTH, shouldHave: false }],
        false: [{ roleName: 'team_user', permission: _index.Permissions.MANAGE_WEBHOOKS, shouldHave: true }, { roleName: 'team_user', permission: _index.Permissions.MANAGE_SLASH_COMMANDS, shouldHave: true }, { roleName: 'system_user', permission: _index.Permissions.MANAGE_OAUTH, shouldHave: true }]
    }
};

/**
 * Get the roles that were changed (but unsaved) for given mapping key/values.
 *
 * @param {object} mappingValues key/value to indicate which mapping items to use to update the roles.
 * @param {object} roles same structure as returned by mattermost-redux `getRoles`.
 * @return {object} the updated roles (only) in the same structure as returned by mattermost-redux `getRoles`.
 */
function rolesFromMapping(mappingValues, roles) {
    var rolesClone = JSON.parse((0, _stringify2.default)(roles));

    // Purge roles that aren't present in MAPPING, we don't care about them.
    purgeNonPertinentRoles(rolesClone);

    (0, _keys2.default)(MAPPING).forEach(function (mappingKey) {
        var value = mappingValues[mappingKey];
        if (value) {
            mutateRolesBasedOnMapping(mappingKey, value, rolesClone);
        }
    });

    // Purge roles that didn't have permissions changes, we don't care about them.
    (0, _entries2.default)(rolesClone).forEach(function (_ref) {
        var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
            roleName = _ref2[0],
            roleClone = _ref2[1];

        var originalPermissionSet = new _set2.default(roles[roleName].permissions);
        var newPermissionSet = new _set2.default(roleClone.permissions);
        var difference = [].concat((0, _toConsumableArray3.default)(newPermissionSet)).filter(function (x) {
            return !originalPermissionSet.has(x);
        });

        if (originalPermissionSet.size === newPermissionSet.size && difference.length === 0) {
            delete rolesClone[roleName];
        }
    });

    return rolesClone;
}

/**
 * Get the mapping value that matches for a given set of roles.
 *
 * @param {string} key to match under in the mapping.
 * @param {object} roles same structure as returned by mattermost-redux `getRoles`.
 * @return {string} the value that the roles/permissions assignment match in the mapping.
 */
function mappingValueFromRoles(key, roles) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = (0, _getIterator3.default)(mappingPartIterator(MAPPING[key], roles)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var o = _step.value;

            if (o.allConditionsAreMet) {
                return o.value;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    throw new Error('No matching mapping value found for key \'' + key + '\' with the given roles.');
}

function purgeNonPertinentRoles(roles) {
    var pertinentRoleNames = roleNamesInMapping();

    (0, _keys2.default)(roles).forEach(function (key) {
        if (!pertinentRoleNames.includes(key)) {
            delete roles[key];
        }
    });
}

function mutateRolesBasedOnMapping(mappingKey, value, roles) {
    var roleRules = MAPPING[mappingKey][value];

    if (typeof roleRules === 'undefined') {
        throw new Error('Value \'' + value + '\' not present in MAPPING for key \'' + mappingKey + '\'.');
    }

    roleRules.forEach(function (item) {
        var role = roles[item.roleName];
        if (item.shouldHave) {
            addPermissionToRole(item.permission, role);
        } else {
            removePermissionFromRole(item.permission, role);
        }
    });
}

// Returns a set of the role names present in MAPPING.
function roleNamesInMapping() {
    var roleNames = [];

    (0, _values2.default)(MAPPING).forEach(function (v1) {
        (0, _values2.default)(v1).forEach(function (v2) {
            var names = v2.map(function (item) {
                return item.roleName;
            }); // eslint-disable-line max-nested-callbacks
            roleNames = roleNames.concat(names);
        });
    });

    return [].concat((0, _toConsumableArray3.default)(new _set2.default(roleNames.map(function (item) {
        return item;
    }))));
}

function mappingPartIterator(mappingPart, roles) {
    var value, roleRules, hasUnmetCondition;
    return _regenerator2.default.wrap(function mappingPartIterator$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.t0 = _regenerator2.default.keys(mappingPart);

                case 1:
                    if ((_context.t1 = _context.t0()).done) {
                        _context.next = 10;
                        break;
                    }

                    value = _context.t1.value;

                    if (!mappingPart.hasOwnProperty(value)) {
                        _context.next = 8;
                        break;
                    }

                    roleRules = mappingPart[value];
                    hasUnmetCondition = roleRules.some(function (item) {
                        var role = roles[item.roleName];
                        return item.shouldHave && !role.permissions.includes(item.permission) || !item.shouldHave && role.permissions.includes(item.permission);
                    });
                    _context.next = 8;
                    return { value: value, allConditionsAreMet: !hasUnmetCondition };

                case 8:
                    _context.next = 1;
                    break;

                case 10:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked[0], this);
}

function addPermissionToRole(permission, role) {
    if (!role.permissions.includes(permission)) {
        role.permissions.push(permission);
    }
}

function removePermissionFromRole(permission, role) {
    var permissionIndex = role.permissions.indexOf(permission);
    if (permissionIndex !== -1) {
        role.permissions.splice(permissionIndex, 1);
    }
}

/***/ }),

/***/ 1452:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createJob = createJob;
exports.getJob = getJob;
exports.getJobs = getJobs;
exports.getJobsByType = getJobsByType;
exports.cancelJob = cancelJob;

var _action_types = __webpack_require__(3);

var _client = __webpack_require__(270);

var _constants = __webpack_require__(19);

var _helpers = __webpack_require__(821);

// Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function createJob(job) {
    return (0, _helpers.bindClientFunc)(_client.Client4.createJob, _action_types.JobTypes.CREATE_JOB_REQUEST, [_action_types.JobTypes.RECEIVED_JOB, _action_types.JobTypes.CREATE_JOB_SUCCESS], _action_types.JobTypes.CREATE_JOB_FAILURE, job);
}

function getJob(id) {
    return (0, _helpers.bindClientFunc)(_client.Client4.getJob, _action_types.JobTypes.GET_JOB_REQUEST, [_action_types.JobTypes.RECEIVED_JOB, _action_types.JobTypes.GET_JOB_SUCCESS], _action_types.JobTypes.GET_JOB_FAILURE, id);
}

function getJobs() {
    var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var perPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _constants.General.JOBS_CHUNK_SIZE;

    return (0, _helpers.bindClientFunc)(_client.Client4.getJobs, _action_types.JobTypes.GET_JOBS_REQUEST, [_action_types.JobTypes.RECEIVED_JOBS, _action_types.JobTypes.GET_JOBS_SUCCESS], _action_types.JobTypes.GET_JOBS_FAILURE, page, perPage);
}

function getJobsByType(type) {
    var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var perPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _constants.General.JOBS_CHUNK_SIZE;

    return (0, _helpers.bindClientFunc)(_client.Client4.getJobsByType, _action_types.JobTypes.GET_JOBS_REQUEST, [_action_types.JobTypes.RECEIVED_JOBS, _action_types.JobTypes.RECEIVED_JOBS_BY_TYPE, _action_types.JobTypes.GET_JOBS_SUCCESS], _action_types.JobTypes.GET_JOBS_FAILURE, type, page, perPage);
}

function cancelJob(job) {
    return (0, _helpers.bindClientFunc)(_client.Client4.cancelJob, _action_types.JobTypes.CANCEL_JOB_REQUEST, _action_types.JobTypes.CANCEL_JOB_SUCCESS, _action_types.JobTypes.CANCEL_JOB_FAILURE, job);
}

/***/ }),

/***/ 1453:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ConnectionSecurityDropdownSettingEmail = ConnectionSecurityDropdownSettingEmail;
exports.ConnectionSecurityDropdownSettingLdap = ConnectionSecurityDropdownSettingLdap;

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _dropdown_setting = __webpack_require__(842);

var _dropdown_setting2 = _interopRequireDefault(_dropdown_setting);

var _admin_definition_constants = __webpack_require__(1454);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function ConnectionSecurityDropdownSettingEmail(props) {
    return _react2.default.createElement(_dropdown_setting2.default, {
        id: 'connectionSecurity',
        values: [{ value: '', text: Utils.localizeMessage('admin.connectionSecurityNone', 'None') }, { value: 'TLS', text: Utils.localizeMessage('admin.connectionSecurityTls', 'TLS (Recommended)') }, { value: 'STARTTLS', text: Utils.localizeMessage('admin.connectionSecurityStart') }],
        label: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'admin.connectionSecurityTitle',
            defaultMessage: 'Connection Security:'
        }),
        value: props.value,
        onChange: props.onChange,
        disabled: props.disabled,
        helpText: _admin_definition_constants.CONNECTION_SECURITY_HELP_TEXT_EMAIL
    });
}
ConnectionSecurityDropdownSettingEmail.defaultProps = {};

ConnectionSecurityDropdownSettingEmail.propTypes = {
    value: _propTypes2.default.string.isRequired,
    onChange: _propTypes2.default.func.isRequired,
    disabled: _propTypes2.default.bool.isRequired
};

function ConnectionSecurityDropdownSettingLdap(props) {
    return _react2.default.createElement(_dropdown_setting2.default, {
        id: 'connectionSecurity',
        values: [{ value: '', text: Utils.localizeMessage('admin.connectionSecurityNone', 'None') }, { value: 'TLS', text: Utils.localizeMessage('admin.connectionSecurityTls', 'TLS (Recommended)') }, { value: 'STARTTLS', text: Utils.localizeMessage('admin.connectionSecurityStart') }],
        label: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'admin.connectionSecurityTitle',
            defaultMessage: 'Connection Security:'
        }),
        value: props.value,
        onChange: props.onChange,
        disabled: props.disabled,
        helpText: _admin_definition_constants.CONNECTION_SECURITY_HELP_TEXT_LDAP
    });
}
ConnectionSecurityDropdownSettingLdap.defaultProps = {};

ConnectionSecurityDropdownSettingLdap.propTypes = {
    value: _propTypes2.default.string.isRequired,
    onChange: _propTypes2.default.func.isRequired,
    disabled: _propTypes2.default.bool.isRequired
};

/***/ }),

/***/ 1454:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LOG_LEVEL_OPTIONS = exports.LOG_FORMAT_HELP_TEXT = exports.WEBSERVER_MODE_HELP_TEXT = exports.CONNECTION_SECURITY_HELP_TEXT_WEBSERVER = exports.CONNECTION_SECURITY_HELP_TEXT_LDAP = exports.CONNECTION_SECURITY_HELP_TEXT_EMAIL = undefined;

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SECTION_NONE = _react2.default.createElement(
    'tr',
    null,
    _react2.default.createElement(
        'td',
        null,
        _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'admin.connectionSecurityNone',
            defaultMessage: 'None'
        })
    ),
    _react2.default.createElement(
        'td',
        null,
        _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'admin.connectionSecurityNoneDescription',
            defaultMessage: 'Mattermost will connect over an insecure connection.'
        })
    )
);

var SECTION_TLS = _react2.default.createElement(
    'tr',
    null,
    _react2.default.createElement(
        'td',
        null,
        _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'admin.connectionSecurityTls',
            defaultMessage: 'TLS'
        })
    ),
    _react2.default.createElement(
        'td',
        null,
        _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'admin.connectionSecurityTlsDescription',
            defaultMessage: 'Encrypts the communication between Mattermost and your server.'
        })
    )
);

var SECTION_STARTTLS = _react2.default.createElement(
    'tr',
    null,
    _react2.default.createElement(
        'td',
        null,
        _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'admin.connectionSecurityStart',
            defaultMessage: 'STARTTLS'
        })
    ),
    _react2.default.createElement(
        'td',
        null,
        _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'admin.connectionSecurityStartDescription',
            defaultMessage: 'Takes an existing insecure connection and attempts to upgrade it to a secure connection using TLS.'
        })
    )
);

var CONNECTION_SECURITY_HELP_TEXT_EMAIL = exports.CONNECTION_SECURITY_HELP_TEXT_EMAIL = _react2.default.createElement(
    'table',
    {
        className: 'table table-bordered table-margin--none',
        cellPadding: '5'
    },
    _react2.default.createElement(
        'tbody',
        null,
        SECTION_NONE,
        SECTION_TLS,
        SECTION_STARTTLS
    )
);

var CONNECTION_SECURITY_HELP_TEXT_LDAP = exports.CONNECTION_SECURITY_HELP_TEXT_LDAP = _react2.default.createElement(
    'table',
    {
        className: 'table table-bordered table-margin--none',
        cellPadding: '5'
    },
    _react2.default.createElement(
        'tbody',
        null,
        SECTION_NONE,
        SECTION_TLS,
        SECTION_STARTTLS
    )
);

var CONNECTION_SECURITY_HELP_TEXT_WEBSERVER = exports.CONNECTION_SECURITY_HELP_TEXT_WEBSERVER = _react2.default.createElement(
    'table',
    {
        className: 'table table-bordered table-margin--none',
        cellPadding: '5'
    },
    _react2.default.createElement(
        'tbody',
        null,
        SECTION_NONE,
        SECTION_TLS
    )
);

var WEBSERVER_MODE_HELP_TEXT = exports.WEBSERVER_MODE_HELP_TEXT = _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
        'table',
        {
            className: 'table table-bordered table-margin--none',
            cellPadding: '5'
        },
        _react2.default.createElement(
            'tbody',
            null,
            _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                    'td',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.webserverModeGzip',
                        defaultMessage: 'gzip'
                    })
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.webserverModeGzipDescription',
                        defaultMessage: 'The Mattermost server will serve static files compressed with gzip.'
                    })
                )
            ),
            _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                    'td',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.webserverModeUncompressed',
                        defaultMessage: 'Uncompressed'
                    })
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.webserverModeUncompressedDescription',
                        defaultMessage: 'The Mattermost server will serve static files uncompressed.'
                    })
                )
            ),
            _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                    'td',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.webserverModeDisabled',
                        defaultMessage: 'Disabled'
                    })
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.webserverModeDisabledDescription',
                        defaultMessage: 'The Mattermost server will not serve static files.'
                    })
                )
            )
        )
    ),
    _react2.default.createElement(
        'p',
        { className: 'help-text' },
        _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'admin.webserverModeHelpText',
            defaultMessage: 'gzip compression applies to static content files. It is recommended to enable gzip to improve performance unless your environment has specific restrictions, such as a web proxy that distributes gzip files poorly.'
        })
    )
);

var LOG_FORMAT_HELP_TEXT = exports.LOG_FORMAT_HELP_TEXT = _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'admin.log.formatDescription',
        defaultMessage: 'Format of log message output. If blank will be set to "[%D %T] [%L] %M", where:'
    }),
    _react2.default.createElement(
        'table',
        {
            className: 'table table-bordered',
            cellPadding: '5'
        },
        _react2.default.createElement(
            'tbody',
            null,
            _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                    'td',
                    null,
                    '%T'
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.log.formatTime',
                        defaultMessage: 'Time (15:04:05 MST)'
                    })
                )
            ),
            _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                    'td',
                    null,
                    '%D'
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.log.formatDateLong',
                        defaultMessage: 'Date (2006/01/02)'
                    })
                )
            ),
            _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                    'td',
                    null,
                    '%d'
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.log.formatDateShort',
                        defaultMessage: 'Date (01/02/06)'
                    })
                )
            ),
            _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                    'td',
                    null,
                    '%L'
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.log.formatLevel',
                        defaultMessage: 'Level (DEBG, INFO, EROR)'
                    })
                )
            ),
            _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                    'td',
                    null,
                    '%S'
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.log.formatSource',
                        defaultMessage: 'Source'
                    })
                )
            ),
            _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                    'td',
                    null,
                    '%M'
                ),
                _react2.default.createElement(
                    'td',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.log.formatMessage',
                        defaultMessage: 'Message'
                    })
                )
            )
        )
    )
);

var LOG_LEVEL_OPTIONS = exports.LOG_LEVEL_OPTIONS = [{
    value: 'DEBUG',
    display_name: 'DEBUG',
    display_name_default: 'DEBUG'
}, {
    value: 'INFO',
    display_name: 'INFO',
    display_name_default: 'INFO'
}, {
    value: 'ERROR',
    display_name: 'ERROR',
    display_name_default: 'ERROR'
}];

/***/ }),

/***/ 1455:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = Banner;

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Banner(props) {
    var title = _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'admin.banner.heading',
        defaultMessage: 'Note:'
    });

    if (props.title) {
        title = props.title;
    }

    return _react2.default.createElement(
        'div',
        { className: 'banner' },
        _react2.default.createElement(
            'div',
            { className: 'banner__content' },
            _react2.default.createElement(
                'h4',
                { className: 'banner__heading' },
                title
            ),
            _react2.default.createElement(
                'p',
                null,
                props.description
            )
        )
    );
} // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

Banner.defaultProps = {};
Banner.propTypes = {
    title: _propTypes2.default.node,
    description: _propTypes2.default.node.isRequired
};

/***/ }),

/***/ 1456:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(277);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _keys = __webpack_require__(116);

var _keys2 = _interopRequireDefault(_keys);

var _getIterator2 = __webpack_require__(782);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _i18n = __webpack_require__(924);

var I18n = _interopRequireWildcard(_i18n);

var _constants = __webpack_require__(29);

var _text_formatting = __webpack_require__(811);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _request_button = __webpack_require__(998);

var _request_button2 = _interopRequireDefault(_request_button);

var _loading_screen = __webpack_require__(792);

var _loading_screen2 = _interopRequireDefault(_loading_screen);

var _admin_settings = __webpack_require__(787);

var _admin_settings2 = _interopRequireDefault(_admin_settings);

var _boolean_setting = __webpack_require__(800);

var _boolean_setting2 = _interopRequireDefault(_boolean_setting);

var _text_setting = __webpack_require__(794);

var _text_setting2 = _interopRequireDefault(_text_setting);

var _dropdown_setting = __webpack_require__(842);

var _dropdown_setting2 = _interopRequireDefault(_dropdown_setting);

var _multiselect_settings = __webpack_require__(2605);

var _multiselect_settings2 = _interopRequireDefault(_multiselect_settings);

var _radio_setting = __webpack_require__(1098);

var _radio_setting2 = _interopRequireDefault(_radio_setting);

var _generated_setting = __webpack_require__(997);

var _generated_setting2 = _interopRequireDefault(_generated_setting);

var _user_autocomplete_setting = __webpack_require__(2606);

var _user_autocomplete_setting2 = _interopRequireDefault(_user_autocomplete_setting);

var _settings_group = __webpack_require__(788);

var _settings_group2 = _interopRequireDefault(_settings_group);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SchemaAdminSettings = function (_AdminSettings) {
    (0, _inherits3.default)(SchemaAdminSettings, _AdminSettings);

    function SchemaAdminSettings(props) {
        var _this$buildSettingFun;

        (0, _classCallCheck3.default)(this, SchemaAdminSettings);

        var _this = (0, _possibleConstructorReturn3.default)(this, (SchemaAdminSettings.__proto__ || (0, _getPrototypeOf2.default)(SchemaAdminSettings)).call(this, props));

        _this.renderTitle = function () {
            if (!_this.props.schema) {
                return '';
            }
            if (_this.props.schema.translate === false) {
                return _this.props.schema.name || _this.props.schema.id;
            }
            return _react2.default.createElement(_reactIntl.FormattedMessage, { id: _this.props.schema.name || _this.props.schema.id });
        };

        _this.renderBanner = function (setting) {
            if (!_this.props.schema) {
                return _react2.default.createElement(
                    'span',
                    null,
                    ''
                );
            }

            if (_this.props.schema.translate === false) {
                return _react2.default.createElement(
                    'span',
                    null,
                    setting.label
                );
            }

            if (typeof setting.label === 'string') {
                if (setting.label_html) {
                    return _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                        id: setting.label,
                        values: setting.label_values,
                        defaultMessage: setting.label_default
                    });
                }
                return _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: setting.label,
                    defaultMessage: setting.label_default,
                    values: setting.label_values
                });
            }
            return setting.label;
        };

        _this.renderHelpText = function (setting) {
            if (!_this.props.schema) {
                return _react2.default.createElement(
                    'span',
                    null,
                    ''
                );
            }

            if (_this.props.schema.translate === false) {
                return _react2.default.createElement(
                    'span',
                    null,
                    setting.help_text
                );
            }

            var helpText = void 0;
            var isHTML = void 0;
            var helpTextValues = void 0;
            var helpTextDefault = void 0;
            if (setting.disabled_help_text && _this.isDisabled(setting)) {
                helpText = setting.disabled_help_text;
                isHTML = setting.disabled_help_text_html;
                helpTextValues = setting.disabled_help_text_values;
                helpTextDefault = setting.disabled_help_text_default;
            } else {
                helpText = setting.help_text;
                isHTML = setting.help_text_html;
                helpTextValues = setting.help_text_values;
                helpTextDefault = setting.help_text_default;
            }

            if (typeof helpText === 'string') {
                if (isHTML) {
                    return _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                        id: helpText,
                        values: helpTextValues,
                        defaultMessage: helpTextDefault
                    });
                }
                return _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: helpText,
                    defaultMessage: helpTextDefault,
                    values: helpTextValues
                });
            }

            return helpText;
        };

        _this.renderLabel = function (setting) {
            if (!_this.props.schema) {
                return '';
            }

            if (_this.props.schema.translate === false) {
                return setting.label;
            }
            return Utils.localizeMessage(setting.label, setting.label_default);
        };

        _this.isDisabled = function (setting) {
            if (setting.needs) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = (0, _getIterator3.default)(setting.needs), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var need = _step.value;

                        var actual = _this.getSettingValue(_this.getSetting(need[0]));
                        var expected = need[1];

                        if (expected instanceof RegExp) {
                            if (!expected.test(actual)) {
                                return true;
                            }
                        } else if (actual !== expected) {
                            return true;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
            if (setting.needs_license && !_this.props.license.IsLicensed) {
                return true;
            }
            if (setting.needs_no_license && _this.props.license.IsLicensed) {
                return true;
            }
            return false;
        };

        _this.buildButtonSetting = function (setting) {
            return _react2.default.createElement(_request_button2.default, {
                key: _this.props.schema.id + '_text_' + setting.key,
                requestAction: setting.action,
                helpText: _this.renderHelpText(setting),
                buttonText: _react2.default.createElement(
                    'span',
                    null,
                    _this.renderLabel(setting)
                ),
                showSuccessMessage: false,
                includeDetailedError: true,
                errorMessage: {
                    id: setting.error_message,
                    defaultMessage: setting.error_message
                }
            });
        };

        _this.buildTextSetting = function (setting) {
            var inputType = 'input';
            if (setting.type === _constants.SettingsTypes.TYPE_NUMBER) {
                inputType = 'number';
            }
            return _react2.default.createElement(_text_setting2.default, {
                key: _this.props.schema.id + '_text_' + setting.key,
                id: setting.key,
                type: inputType,
                label: _this.renderLabel(setting),
                helpText: _this.renderHelpText(setting),
                placeholder: Utils.localizeMessage(setting.placeholder, setting.placeholder_default),
                value: _this.state[setting.key] || '',
                disabled: _this.isDisabled(setting),
                onChange: _this.handleChange
            });
        };

        _this.buildBoolSetting = function (setting) {
            return _react2.default.createElement(_boolean_setting2.default, {
                key: _this.props.schema.id + '_bool_' + setting.key,
                id: setting.key,
                label: _this.renderLabel(setting),
                helpText: _this.renderHelpText(setting),
                value: !_this.isDisabled(setting) && _this.state[setting.key] || false,
                disabled: _this.isDisabled(setting),
                onChange: _this.handleChange
            });
        };

        _this.buildDropdownSetting = function (setting) {
            var options = setting.options || [];
            var values = options.map(function (o) {
                return { value: o.value, text: Utils.localizeMessage(o.display_name) };
            });

            return _react2.default.createElement(_dropdown_setting2.default, {
                key: _this.props.schema.id + '_dropdown_' + setting.key,
                id: setting.key,
                values: values,
                label: _this.renderLabel(setting),
                helpText: _this.renderHelpText(setting),
                value: _this.state[setting.key] || values[0].value,
                disabled: _this.isDisabled(setting),
                onChange: _this.handleChange
            });
        };

        _this.buildLanguageSetting = function (setting) {
            var locales = I18n.getAllLanguages();
            var values = (0, _keys2.default)(locales).map(function (l) {
                return { value: locales[l].value, text: locales[l].name, order: locales[l].order };
            }).sort(function (a, b) {
                return a.order - b.order;
            });

            if (setting.multiple) {
                var noResultText = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: setting.no_result,
                    defaultMessage: setting.no_result_default
                });
                var notPresent = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: setting.not_present,
                    defaultMessage: setting.not_present_default
                });
                return _react2.default.createElement(_multiselect_settings2.default, {
                    key: _this.props.schema.id + '_language_' + setting.key,
                    id: setting.key,
                    label: _this.renderLabel(setting),
                    values: values,
                    helpText: _this.renderHelpText(setting),
                    selected: _this.state[setting.key] && _this.state[setting.key].split(',') || [],
                    disabled: _this.isDisabled(setting),
                    onChange: function onChange(changedId, value) {
                        return _this.handleChange(changedId, value.join(','));
                    },
                    noResultText: noResultText,
                    notPresent: notPresent
                });
            }
            return _react2.default.createElement(_dropdown_setting2.default, {
                key: _this.props.schema.id + '_language_' + setting.key,
                id: setting.key,
                label: _this.renderLabel(setting),
                values: values,
                helpText: _this.renderHelpText(setting),
                value: _this.state[setting.key] || values[0].value,
                disabled: _this.isDisabled(setting),
                onChange: _this.handleChange
            });
        };

        _this.buildRadioSetting = function (setting) {
            var options = setting.options || [];
            var values = options.map(function (o) {
                return { value: o.value, text: o.display_name };
            });

            return _react2.default.createElement(_radio_setting2.default, {
                key: _this.props.schema.id + '_radio_' + setting.key,
                id: setting.key,
                values: values,
                label: _this.renderLabel(setting),
                helpText: _this.renderHelpText(setting),
                value: _this.state[setting.key] || values[0],
                disabled: _this.isDisabled(setting),
                onChange: _this.handleChange
            });
        };

        _this.buildBannerSetting = function (setting) {
            if (_this.isDisabled(setting)) {
                return null;
            }
            return _react2.default.createElement(
                'div',
                {
                    className: 'banner ' + setting.banner_type,
                    key: _this.props.schema.id + '_bool_' + setting.key
                },
                _react2.default.createElement(
                    'div',
                    { className: 'banner__content' },
                    _react2.default.createElement(
                        'span',
                        null,
                        _this.renderBanner(setting)
                    )
                )
            );
        };

        _this.buildGeneratedSetting = function (setting) {
            return _react2.default.createElement(_generated_setting2.default, {
                key: _this.props.schema.id + '_generated_' + setting.key,
                id: setting.key,
                label: _this.renderLabel(setting),
                helpText: _this.renderHelpText(setting),
                regenerateHelpText: setting.regenerate_help_text,
                placeholder: Utils.localizeMessage(setting.placeholder, setting.placeholder_default),
                value: _this.state[setting.key] || '',
                disabled: _this.isDisabled(setting),
                onChange: _this.handleGeneratedChange
            });
        };

        _this.handleGeneratedChange = function (id, s) {
            _this.handleChange(id, s.replace('+', '-').replace('/', '_'));
        };

        _this.buildUsernameSetting = function (setting) {
            return _react2.default.createElement(_user_autocomplete_setting2.default, {
                key: _this.props.schema.id + '_userautocomplete_' + setting.key,
                id: setting.key,
                label: _this.renderLabel(setting),
                helpText: _this.renderHelpText(setting),
                placeholder: Utils.localizeMessage(setting.placeholder, setting.placeholder_default) || Utils.localizeMessage('search_bar.search', 'Search'),
                value: _this.state[setting.key] || '',
                disabled: _this.isDisabled(setting),
                onChange: _this.handleChange
            });
        };

        _this.buildCustomSetting = function (setting) {
            var CustomComponent = setting.component;
            return _react2.default.createElement(CustomComponent, {
                key: _this.props.schema.id + '_userautocomplete_' + setting.key
            });
        };

        _this.renderSettings = function () {
            var schema = _this.props.schema;

            if (!schema) {
                return _react2.default.createElement(_loading_screen2.default, null);
            }

            var settingsList = [];
            if (schema.settings) {
                schema.settings.forEach(function (setting) {
                    if (_this.buildSettingFunctions[setting.type]) {
                        settingsList.push(_this.buildSettingFunctions[setting.type](setting));
                    }
                });
            }

            var header = void 0;
            if (schema.header) {
                header = _react2.default.createElement('div', {
                    className: 'banner',
                    dangerouslySetInnerHTML: { __html: (0, _text_formatting.formatText)(schema.header, { mentionHighlight: false }) }
                });
            }

            var footer = void 0;
            if (schema.footer) {
                footer = _react2.default.createElement('div', {
                    className: 'banner',
                    dangerouslySetInnerHTML: { __html: (0, _text_formatting.formatText)(schema.footer, { mentionHighlight: false }) }
                });
            }

            return _react2.default.createElement(
                _settings_group2.default,
                null,
                header,
                settingsList,
                footer
            );
        };

        _this.render = function () {
            var schema = _this.props.schema;

            if (schema.component) {
                var CustomComponent = schema.component;
                return _react2.default.createElement(CustomComponent, _this.props);
            }
            return _admin_settings2.default.prototype.render.call(_this);
        };

        _this.buildSettingFunctions = (_this$buildSettingFun = {}, (0, _defineProperty3.default)(_this$buildSettingFun, _constants.SettingsTypes.TYPE_TEXT, _this.buildTextSetting), (0, _defineProperty3.default)(_this$buildSettingFun, _constants.SettingsTypes.TYPE_NUMBER, _this.buildTextSetting), (0, _defineProperty3.default)(_this$buildSettingFun, _constants.SettingsTypes.TYPE_BOOL, _this.buildBoolSetting), (0, _defineProperty3.default)(_this$buildSettingFun, _constants.SettingsTypes.TYPE_DROPDOWN, _this.buildDropdownSetting), (0, _defineProperty3.default)(_this$buildSettingFun, _constants.SettingsTypes.TYPE_RADIO, _this.buildRadioSetting), (0, _defineProperty3.default)(_this$buildSettingFun, _constants.SettingsTypes.TYPE_BANNER, _this.buildBannerSetting), (0, _defineProperty3.default)(_this$buildSettingFun, _constants.SettingsTypes.TYPE_GENERATED, _this.buildGeneratedSetting), (0, _defineProperty3.default)(_this$buildSettingFun, _constants.SettingsTypes.TYPE_USERNAME, _this.buildUsernameSetting), (0, _defineProperty3.default)(_this$buildSettingFun, _constants.SettingsTypes.TYPE_BUTTON, _this.buildButtonSetting), (0, _defineProperty3.default)(_this$buildSettingFun, _constants.SettingsTypes.TYPE_LANGUAGE, _this.buildLanguageSetting), (0, _defineProperty3.default)(_this$buildSettingFun, _constants.SettingsTypes.TYPE_CUSTOM, _this.buildCustomSetting), _this$buildSettingFun);
        return _this;
    }

    (0, _createClass3.default)(SchemaAdminSettings, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.schema !== this.props.schema) {
                this.setState(this.getStateFromConfig(nextProps.config, nextProps.schema));
            }
        }
    }, {
        key: 'getConfigFromState',
        value: function getConfigFromState(config) {
            var _this2 = this;

            var schema = this.props.schema;

            if (schema) {
                if (!config[schema.id]) {
                    config[schema.id] = {};
                }

                var configSettings = config[schema.id];

                var settings = schema.settings || [];
                settings.forEach(function (setting) {
                    configSettings[setting.key] = _this2.getSettingValue(setting);
                });
            }

            return config;
        }
    }, {
        key: 'getStateFromConfig',
        value: function getStateFromConfig(config) {
            var schema = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.props.schema;

            var state = {};

            if (schema) {
                var configSettings = config[schema.id] || {};

                var settings = schema.settings || [];
                settings.forEach(function (setting) {
                    state[setting.key] = configSettings[setting.key] == null ? setting.default : configSettings[setting.key];
                });
            }

            return state;
        }
    }, {
        key: 'getSetting',
        value: function getSetting(key) {
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = (0, _getIterator3.default)(this.props.schema.settings), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var setting = _step2.value;

                    if (setting.key === key) {
                        return setting;
                    }
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            return null;
        }
    }, {
        key: 'getSettingValue',
        value: function getSettingValue(setting) {
            // Force boolean values to false when disabled.
            if (setting.type === _constants.SettingsTypes.TYPE_BOOL) {
                if (this.isDisabled(setting)) {
                    return false;
                }
            }

            return this.state[setting.key];
        }
    }]);
    return SchemaAdminSettings;
}(_admin_settings2.default); // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = SchemaAdminSettings;

/***/ }),

/***/ 1457:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1144), __esModule: true };

/***/ }),

/***/ 1458:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _redux = __webpack_require__(1);

var _admin_actions = __webpack_require__(797);

var _admin = __webpack_require__(963);

var _blockable_link = __webpack_require__(2634);

var _blockable_link2 = _interopRequireDefault(_blockable_link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state) {
    return {
        blocked: (0, _admin.getNavigationBlocked)(state)
    };
} // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapDispatchToProps(dispatch) {
    return {
        actions: (0, _redux.bindActionCreators)({
            deferNavigation: _admin_actions.deferNavigation
        }, dispatch)
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_blockable_link2.default);

/***/ }),

/***/ 1459:
/***/ (function(module, exports, __webpack_require__) {

/**
 * @namespace Chart
 */
var Chart = __webpack_require__(2640)();

Chart.helpers = __webpack_require__(789);

// @todo dispatch these helpers into appropriated helpers/helpers.* file and write unit tests!
__webpack_require__(2644)(Chart);

Chart.defaults = __webpack_require__(796);
Chart.Element = __webpack_require__(843);
Chart.elements = __webpack_require__(871);
Chart.Interaction = __webpack_require__(1461);
Chart.platform = __webpack_require__(1462);

__webpack_require__(2655)(Chart);
__webpack_require__(2656)(Chart);
__webpack_require__(2657)(Chart);
__webpack_require__(2658)(Chart);
__webpack_require__(2659)(Chart);
__webpack_require__(2660)(Chart);
__webpack_require__(2661)(Chart);
__webpack_require__(2662)(Chart);

__webpack_require__(2663)(Chart);
__webpack_require__(2664)(Chart);
__webpack_require__(2665)(Chart);
__webpack_require__(2666)(Chart);
__webpack_require__(2667)(Chart);
__webpack_require__(2668)(Chart);

// Controllers must be loaded after elements
// See Chart.core.datasetController.dataElementType
__webpack_require__(2670)(Chart);
__webpack_require__(2671)(Chart);
__webpack_require__(2672)(Chart);
__webpack_require__(2673)(Chart);
__webpack_require__(2674)(Chart);
__webpack_require__(2675)(Chart);
__webpack_require__(2676)(Chart);

__webpack_require__(2677)(Chart);
__webpack_require__(2678)(Chart);
__webpack_require__(2679)(Chart);
__webpack_require__(2680)(Chart);
__webpack_require__(2681)(Chart);
__webpack_require__(2682)(Chart);
__webpack_require__(2683)(Chart);

// Loading built-it plugins
var plugins = [];

plugins.push(
	__webpack_require__(2684)(Chart),
	__webpack_require__(2685)(Chart),
	__webpack_require__(2686)(Chart)
);

Chart.plugins.register(plugins);

Chart.platform.initialize();

module.exports = Chart;
if (typeof window !== 'undefined') {
	window.Chart = Chart;
}

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart.helpers.canvas instead.
 * @namespace Chart.canvasHelpers
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 * @private
 */
Chart.canvasHelpers = Chart.helpers.canvas;


/***/ }),

/***/ 1460:
/***/ (function(module, exports, __webpack_require__) {

/* MIT license */
var convert = __webpack_require__(2645);
var string = __webpack_require__(2647);

var Color = function (obj) {
	if (obj instanceof Color) {
		return obj;
	}
	if (!(this instanceof Color)) {
		return new Color(obj);
	}

	this.valid = false;
	this.values = {
		rgb: [0, 0, 0],
		hsl: [0, 0, 0],
		hsv: [0, 0, 0],
		hwb: [0, 0, 0],
		cmyk: [0, 0, 0, 0],
		alpha: 1
	};

	// parse Color() argument
	var vals;
	if (typeof obj === 'string') {
		vals = string.getRgba(obj);
		if (vals) {
			this.setValues('rgb', vals);
		} else if (vals = string.getHsla(obj)) {
			this.setValues('hsl', vals);
		} else if (vals = string.getHwb(obj)) {
			this.setValues('hwb', vals);
		}
	} else if (typeof obj === 'object') {
		vals = obj;
		if (vals.r !== undefined || vals.red !== undefined) {
			this.setValues('rgb', vals);
		} else if (vals.l !== undefined || vals.lightness !== undefined) {
			this.setValues('hsl', vals);
		} else if (vals.v !== undefined || vals.value !== undefined) {
			this.setValues('hsv', vals);
		} else if (vals.w !== undefined || vals.whiteness !== undefined) {
			this.setValues('hwb', vals);
		} else if (vals.c !== undefined || vals.cyan !== undefined) {
			this.setValues('cmyk', vals);
		}
	}
};

Color.prototype = {
	isValid: function () {
		return this.valid;
	},
	rgb: function () {
		return this.setSpace('rgb', arguments);
	},
	hsl: function () {
		return this.setSpace('hsl', arguments);
	},
	hsv: function () {
		return this.setSpace('hsv', arguments);
	},
	hwb: function () {
		return this.setSpace('hwb', arguments);
	},
	cmyk: function () {
		return this.setSpace('cmyk', arguments);
	},

	rgbArray: function () {
		return this.values.rgb;
	},
	hslArray: function () {
		return this.values.hsl;
	},
	hsvArray: function () {
		return this.values.hsv;
	},
	hwbArray: function () {
		var values = this.values;
		if (values.alpha !== 1) {
			return values.hwb.concat([values.alpha]);
		}
		return values.hwb;
	},
	cmykArray: function () {
		return this.values.cmyk;
	},
	rgbaArray: function () {
		var values = this.values;
		return values.rgb.concat([values.alpha]);
	},
	hslaArray: function () {
		var values = this.values;
		return values.hsl.concat([values.alpha]);
	},
	alpha: function (val) {
		if (val === undefined) {
			return this.values.alpha;
		}
		this.setValues('alpha', val);
		return this;
	},

	red: function (val) {
		return this.setChannel('rgb', 0, val);
	},
	green: function (val) {
		return this.setChannel('rgb', 1, val);
	},
	blue: function (val) {
		return this.setChannel('rgb', 2, val);
	},
	hue: function (val) {
		if (val) {
			val %= 360;
			val = val < 0 ? 360 + val : val;
		}
		return this.setChannel('hsl', 0, val);
	},
	saturation: function (val) {
		return this.setChannel('hsl', 1, val);
	},
	lightness: function (val) {
		return this.setChannel('hsl', 2, val);
	},
	saturationv: function (val) {
		return this.setChannel('hsv', 1, val);
	},
	whiteness: function (val) {
		return this.setChannel('hwb', 1, val);
	},
	blackness: function (val) {
		return this.setChannel('hwb', 2, val);
	},
	value: function (val) {
		return this.setChannel('hsv', 2, val);
	},
	cyan: function (val) {
		return this.setChannel('cmyk', 0, val);
	},
	magenta: function (val) {
		return this.setChannel('cmyk', 1, val);
	},
	yellow: function (val) {
		return this.setChannel('cmyk', 2, val);
	},
	black: function (val) {
		return this.setChannel('cmyk', 3, val);
	},

	hexString: function () {
		return string.hexString(this.values.rgb);
	},
	rgbString: function () {
		return string.rgbString(this.values.rgb, this.values.alpha);
	},
	rgbaString: function () {
		return string.rgbaString(this.values.rgb, this.values.alpha);
	},
	percentString: function () {
		return string.percentString(this.values.rgb, this.values.alpha);
	},
	hslString: function () {
		return string.hslString(this.values.hsl, this.values.alpha);
	},
	hslaString: function () {
		return string.hslaString(this.values.hsl, this.values.alpha);
	},
	hwbString: function () {
		return string.hwbString(this.values.hwb, this.values.alpha);
	},
	keyword: function () {
		return string.keyword(this.values.rgb, this.values.alpha);
	},

	rgbNumber: function () {
		var rgb = this.values.rgb;
		return (rgb[0] << 16) | (rgb[1] << 8) | rgb[2];
	},

	luminosity: function () {
		// http://www.w3.org/TR/WCAG20/#relativeluminancedef
		var rgb = this.values.rgb;
		var lum = [];
		for (var i = 0; i < rgb.length; i++) {
			var chan = rgb[i] / 255;
			lum[i] = (chan <= 0.03928) ? chan / 12.92 : Math.pow(((chan + 0.055) / 1.055), 2.4);
		}
		return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
	},

	contrast: function (color2) {
		// http://www.w3.org/TR/WCAG20/#contrast-ratiodef
		var lum1 = this.luminosity();
		var lum2 = color2.luminosity();
		if (lum1 > lum2) {
			return (lum1 + 0.05) / (lum2 + 0.05);
		}
		return (lum2 + 0.05) / (lum1 + 0.05);
	},

	level: function (color2) {
		var contrastRatio = this.contrast(color2);
		if (contrastRatio >= 7.1) {
			return 'AAA';
		}

		return (contrastRatio >= 4.5) ? 'AA' : '';
	},

	dark: function () {
		// YIQ equation from http://24ways.org/2010/calculating-color-contrast
		var rgb = this.values.rgb;
		var yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
		return yiq < 128;
	},

	light: function () {
		return !this.dark();
	},

	negate: function () {
		var rgb = [];
		for (var i = 0; i < 3; i++) {
			rgb[i] = 255 - this.values.rgb[i];
		}
		this.setValues('rgb', rgb);
		return this;
	},

	lighten: function (ratio) {
		var hsl = this.values.hsl;
		hsl[2] += hsl[2] * ratio;
		this.setValues('hsl', hsl);
		return this;
	},

	darken: function (ratio) {
		var hsl = this.values.hsl;
		hsl[2] -= hsl[2] * ratio;
		this.setValues('hsl', hsl);
		return this;
	},

	saturate: function (ratio) {
		var hsl = this.values.hsl;
		hsl[1] += hsl[1] * ratio;
		this.setValues('hsl', hsl);
		return this;
	},

	desaturate: function (ratio) {
		var hsl = this.values.hsl;
		hsl[1] -= hsl[1] * ratio;
		this.setValues('hsl', hsl);
		return this;
	},

	whiten: function (ratio) {
		var hwb = this.values.hwb;
		hwb[1] += hwb[1] * ratio;
		this.setValues('hwb', hwb);
		return this;
	},

	blacken: function (ratio) {
		var hwb = this.values.hwb;
		hwb[2] += hwb[2] * ratio;
		this.setValues('hwb', hwb);
		return this;
	},

	greyscale: function () {
		var rgb = this.values.rgb;
		// http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
		var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
		this.setValues('rgb', [val, val, val]);
		return this;
	},

	clearer: function (ratio) {
		var alpha = this.values.alpha;
		this.setValues('alpha', alpha - (alpha * ratio));
		return this;
	},

	opaquer: function (ratio) {
		var alpha = this.values.alpha;
		this.setValues('alpha', alpha + (alpha * ratio));
		return this;
	},

	rotate: function (degrees) {
		var hsl = this.values.hsl;
		var hue = (hsl[0] + degrees) % 360;
		hsl[0] = hue < 0 ? 360 + hue : hue;
		this.setValues('hsl', hsl);
		return this;
	},

	/**
	 * Ported from sass implementation in C
	 * https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
	 */
	mix: function (mixinColor, weight) {
		var color1 = this;
		var color2 = mixinColor;
		var p = weight === undefined ? 0.5 : weight;

		var w = 2 * p - 1;
		var a = color1.alpha() - color2.alpha();

		var w1 = (((w * a === -1) ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
		var w2 = 1 - w1;

		return this
			.rgb(
				w1 * color1.red() + w2 * color2.red(),
				w1 * color1.green() + w2 * color2.green(),
				w1 * color1.blue() + w2 * color2.blue()
			)
			.alpha(color1.alpha() * p + color2.alpha() * (1 - p));
	},

	toJSON: function () {
		return this.rgb();
	},

	clone: function () {
		// NOTE(SB): using node-clone creates a dependency to Buffer when using browserify,
		// making the final build way to big to embed in Chart.js. So let's do it manually,
		// assuming that values to clone are 1 dimension arrays containing only numbers,
		// except 'alpha' which is a number.
		var result = new Color();
		var source = this.values;
		var target = result.values;
		var value, type;

		for (var prop in source) {
			if (source.hasOwnProperty(prop)) {
				value = source[prop];
				type = ({}).toString.call(value);
				if (type === '[object Array]') {
					target[prop] = value.slice(0);
				} else if (type === '[object Number]') {
					target[prop] = value;
				} else {
					console.error('unexpected color value:', value);
				}
			}
		}

		return result;
	}
};

Color.prototype.spaces = {
	rgb: ['red', 'green', 'blue'],
	hsl: ['hue', 'saturation', 'lightness'],
	hsv: ['hue', 'saturation', 'value'],
	hwb: ['hue', 'whiteness', 'blackness'],
	cmyk: ['cyan', 'magenta', 'yellow', 'black']
};

Color.prototype.maxes = {
	rgb: [255, 255, 255],
	hsl: [360, 100, 100],
	hsv: [360, 100, 100],
	hwb: [360, 100, 100],
	cmyk: [100, 100, 100, 100]
};

Color.prototype.getValues = function (space) {
	var values = this.values;
	var vals = {};

	for (var i = 0; i < space.length; i++) {
		vals[space.charAt(i)] = values[space][i];
	}

	if (values.alpha !== 1) {
		vals.a = values.alpha;
	}

	// {r: 255, g: 255, b: 255, a: 0.4}
	return vals;
};

Color.prototype.setValues = function (space, vals) {
	var values = this.values;
	var spaces = this.spaces;
	var maxes = this.maxes;
	var alpha = 1;
	var i;

	this.valid = true;

	if (space === 'alpha') {
		alpha = vals;
	} else if (vals.length) {
		// [10, 10, 10]
		values[space] = vals.slice(0, space.length);
		alpha = vals[space.length];
	} else if (vals[space.charAt(0)] !== undefined) {
		// {r: 10, g: 10, b: 10}
		for (i = 0; i < space.length; i++) {
			values[space][i] = vals[space.charAt(i)];
		}

		alpha = vals.a;
	} else if (vals[spaces[space][0]] !== undefined) {
		// {red: 10, green: 10, blue: 10}
		var chans = spaces[space];

		for (i = 0; i < space.length; i++) {
			values[space][i] = vals[chans[i]];
		}

		alpha = vals.alpha;
	}

	values.alpha = Math.max(0, Math.min(1, (alpha === undefined ? values.alpha : alpha)));

	if (space === 'alpha') {
		return false;
	}

	var capped;

	// cap values of the space prior converting all values
	for (i = 0; i < space.length; i++) {
		capped = Math.max(0, Math.min(maxes[space][i], values[space][i]));
		values[space][i] = Math.round(capped);
	}

	// convert to all the other color spaces
	for (var sname in spaces) {
		if (sname !== space) {
			values[sname] = convert[space][sname](values[space]);
		}
	}

	return true;
};

Color.prototype.setSpace = function (space, args) {
	var vals = args[0];

	if (vals === undefined) {
		// color.rgb()
		return this.getValues(space);
	}

	// color.rgb(10, 10, 10)
	if (typeof vals === 'number') {
		vals = Array.prototype.slice.call(args);
	}

	this.setValues(space, vals);
	return this;
};

Color.prototype.setChannel = function (space, index, val) {
	var svalues = this.values[space];
	if (val === undefined) {
		// color.red()
		return svalues[index];
	} else if (val === svalues[index]) {
		// color.red(color.red())
		return this;
	}

	// color.red(100)
	svalues[index] = val;
	this.setValues(space, svalues);

	return this;
};

if (typeof window !== 'undefined') {
	window.Color = Color;
}

module.exports = Color;


/***/ }),

/***/ 1461:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var helpers = __webpack_require__(789);

/**
 * Helper function to get relative position for an event
 * @param {Event|IEvent} event - The event to get the position for
 * @param {Chart} chart - The chart
 * @returns {Point} the event position
 */
function getRelativePosition(e, chart) {
	if (e.native) {
		return {
			x: e.x,
			y: e.y
		};
	}

	return helpers.getRelativePosition(e, chart);
}

/**
 * Helper function to traverse all of the visible elements in the chart
 * @param chart {chart} the chart
 * @param handler {Function} the callback to execute for each visible item
 */
function parseVisibleItems(chart, handler) {
	var datasets = chart.data.datasets;
	var meta, i, j, ilen, jlen;

	for (i = 0, ilen = datasets.length; i < ilen; ++i) {
		if (!chart.isDatasetVisible(i)) {
			continue;
		}

		meta = chart.getDatasetMeta(i);
		for (j = 0, jlen = meta.data.length; j < jlen; ++j) {
			var element = meta.data[j];
			if (!element._view.skip) {
				handler(element);
			}
		}
	}
}

/**
 * Helper function to get the items that intersect the event position
 * @param items {ChartElement[]} elements to filter
 * @param position {Point} the point to be nearest to
 * @return {ChartElement[]} the nearest items
 */
function getIntersectItems(chart, position) {
	var elements = [];

	parseVisibleItems(chart, function(element) {
		if (element.inRange(position.x, position.y)) {
			elements.push(element);
		}
	});

	return elements;
}

/**
 * Helper function to get the items nearest to the event position considering all visible items in teh chart
 * @param chart {Chart} the chart to look at elements from
 * @param position {Point} the point to be nearest to
 * @param intersect {Boolean} if true, only consider items that intersect the position
 * @param distanceMetric {Function} function to provide the distance between points
 * @return {ChartElement[]} the nearest items
 */
function getNearestItems(chart, position, intersect, distanceMetric) {
	var minDistance = Number.POSITIVE_INFINITY;
	var nearestItems = [];

	parseVisibleItems(chart, function(element) {
		if (intersect && !element.inRange(position.x, position.y)) {
			return;
		}

		var center = element.getCenterPoint();
		var distance = distanceMetric(position, center);

		if (distance < minDistance) {
			nearestItems = [element];
			minDistance = distance;
		} else if (distance === minDistance) {
			// Can have multiple items at the same distance in which case we sort by size
			nearestItems.push(element);
		}
	});

	return nearestItems;
}

/**
 * Get a distance metric function for two points based on the
 * axis mode setting
 * @param {String} axis the axis mode. x|y|xy
 */
function getDistanceMetricForAxis(axis) {
	var useX = axis.indexOf('x') !== -1;
	var useY = axis.indexOf('y') !== -1;

	return function(pt1, pt2) {
		var deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
		var deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
		return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
	};
}

function indexMode(chart, e, options) {
	var position = getRelativePosition(e, chart);
	// Default axis for index mode is 'x' to match old behaviour
	options.axis = options.axis || 'x';
	var distanceMetric = getDistanceMetricForAxis(options.axis);
	var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);
	var elements = [];

	if (!items.length) {
		return [];
	}

	chart.data.datasets.forEach(function(dataset, datasetIndex) {
		if (chart.isDatasetVisible(datasetIndex)) {
			var meta = chart.getDatasetMeta(datasetIndex);
			var element = meta.data[items[0]._index];

			// don't count items that are skipped (null data)
			if (element && !element._view.skip) {
				elements.push(element);
			}
		}
	});

	return elements;
}

/**
 * @interface IInteractionOptions
 */
/**
 * If true, only consider items that intersect the point
 * @name IInterfaceOptions#boolean
 * @type Boolean
 */

/**
 * Contains interaction related functions
 * @namespace Chart.Interaction
 */
module.exports = {
	// Helper function for different modes
	modes: {
		single: function(chart, e) {
			var position = getRelativePosition(e, chart);
			var elements = [];

			parseVisibleItems(chart, function(element) {
				if (element.inRange(position.x, position.y)) {
					elements.push(element);
					return elements;
				}
			});

			return elements.slice(0, 1);
		},

		/**
		 * @function Chart.Interaction.modes.label
		 * @deprecated since version 2.4.0
		 * @todo remove at version 3
		 * @private
		 */
		label: indexMode,

		/**
		 * Returns items at the same index. If the options.intersect parameter is true, we only return items if we intersect something
		 * If the options.intersect mode is false, we find the nearest item and return the items at the same index as that item
		 * @function Chart.Interaction.modes.index
		 * @since v2.4.0
		 * @param chart {chart} the chart we are returning items from
		 * @param e {Event} the event we are find things at
		 * @param options {IInteractionOptions} options to use during interaction
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		index: indexMode,

		/**
		 * Returns items in the same dataset. If the options.intersect parameter is true, we only return items if we intersect something
		 * If the options.intersect is false, we find the nearest item and return the items in that dataset
		 * @function Chart.Interaction.modes.dataset
		 * @param chart {chart} the chart we are returning items from
		 * @param e {Event} the event we are find things at
		 * @param options {IInteractionOptions} options to use during interaction
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		dataset: function(chart, e, options) {
			var position = getRelativePosition(e, chart);
			options.axis = options.axis || 'xy';
			var distanceMetric = getDistanceMetricForAxis(options.axis);
			var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);

			if (items.length > 0) {
				items = chart.getDatasetMeta(items[0]._datasetIndex).data;
			}

			return items;
		},

		/**
		 * @function Chart.Interaction.modes.x-axis
		 * @deprecated since version 2.4.0. Use index mode and intersect == true
		 * @todo remove at version 3
		 * @private
		 */
		'x-axis': function(chart, e) {
			return indexMode(chart, e, {intersect: false});
		},

		/**
		 * Point mode returns all elements that hit test based on the event position
		 * of the event
		 * @function Chart.Interaction.modes.intersect
		 * @param chart {chart} the chart we are returning items from
		 * @param e {Event} the event we are find things at
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		point: function(chart, e) {
			var position = getRelativePosition(e, chart);
			return getIntersectItems(chart, position);
		},

		/**
		 * nearest mode returns the element closest to the point
		 * @function Chart.Interaction.modes.intersect
		 * @param chart {chart} the chart we are returning items from
		 * @param e {Event} the event we are find things at
		 * @param options {IInteractionOptions} options to use
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		nearest: function(chart, e, options) {
			var position = getRelativePosition(e, chart);
			options.axis = options.axis || 'xy';
			var distanceMetric = getDistanceMetricForAxis(options.axis);
			var nearestItems = getNearestItems(chart, position, options.intersect, distanceMetric);

			// We have multiple items at the same distance from the event. Now sort by smallest
			if (nearestItems.length > 1) {
				nearestItems.sort(function(a, b) {
					var sizeA = a.getArea();
					var sizeB = b.getArea();
					var ret = sizeA - sizeB;

					if (ret === 0) {
						// if equal sort by dataset index
						ret = a._datasetIndex - b._datasetIndex;
					}

					return ret;
				});
			}

			// Return only 1 item
			return nearestItems.slice(0, 1);
		},

		/**
		 * x mode returns the elements that hit-test at the current x coordinate
		 * @function Chart.Interaction.modes.x
		 * @param chart {chart} the chart we are returning items from
		 * @param e {Event} the event we are find things at
		 * @param options {IInteractionOptions} options to use
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		x: function(chart, e, options) {
			var position = getRelativePosition(e, chart);
			var items = [];
			var intersectsItem = false;

			parseVisibleItems(chart, function(element) {
				if (element.inXRange(position.x)) {
					items.push(element);
				}

				if (element.inRange(position.x, position.y)) {
					intersectsItem = true;
				}
			});

			// If we want to trigger on an intersect and we don't have any items
			// that intersect the position, return nothing
			if (options.intersect && !intersectsItem) {
				items = [];
			}
			return items;
		},

		/**
		 * y mode returns the elements that hit-test at the current y coordinate
		 * @function Chart.Interaction.modes.y
		 * @param chart {chart} the chart we are returning items from
		 * @param e {Event} the event we are find things at
		 * @param options {IInteractionOptions} options to use
		 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
		 */
		y: function(chart, e, options) {
			var position = getRelativePosition(e, chart);
			var items = [];
			var intersectsItem = false;

			parseVisibleItems(chart, function(element) {
				if (element.inYRange(position.y)) {
					items.push(element);
				}

				if (element.inRange(position.x, position.y)) {
					intersectsItem = true;
				}
			});

			// If we want to trigger on an intersect and we don't have any items
			// that intersect the position, return nothing
			if (options.intersect && !intersectsItem) {
				items = [];
			}
			return items;
		}
	}
};


/***/ }),

/***/ 1462:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var helpers = __webpack_require__(789);
var basic = __webpack_require__(2653);
var dom = __webpack_require__(2654);

// @TODO Make possible to select another platform at build time.
var implementation = dom._enabled ? dom : basic;

/**
 * @namespace Chart.platform
 * @see https://chartjs.gitbooks.io/proposals/content/Platform.html
 * @since 2.4.0
 */
module.exports = helpers.extend({
	/**
	 * @since 2.7.0
	 */
	initialize: function() {},

	/**
	 * Called at chart construction time, returns a context2d instance implementing
	 * the [W3C Canvas 2D Context API standard]{@link https://www.w3.org/TR/2dcontext/}.
	 * @param {*} item - The native item from which to acquire context (platform specific)
	 * @param {Object} options - The chart options
	 * @returns {CanvasRenderingContext2D} context2d instance
	 */
	acquireContext: function() {},

	/**
	 * Called at chart destruction time, releases any resources associated to the context
	 * previously returned by the acquireContext() method.
	 * @param {CanvasRenderingContext2D} context - The context2d instance
	 * @returns {Boolean} true if the method succeeded, else false
	 */
	releaseContext: function() {},

	/**
	 * Registers the specified listener on the given chart.
	 * @param {Chart} chart - Chart from which to listen for event
	 * @param {String} type - The ({@link IEvent}) type to listen for
	 * @param {Function} listener - Receives a notification (an object that implements
	 * the {@link IEvent} interface) when an event of the specified type occurs.
	 */
	addEventListener: function() {},

	/**
	 * Removes the specified listener previously registered with addEventListener.
	 * @param {Chart} chart -Chart from which to remove the listener
	 * @param {String} type - The ({@link IEvent}) type to remove
	 * @param {Function} listener - The listener function to remove from the event target.
	 */
	removeEventListener: function() {}

}, implementation);

/**
 * @interface IPlatform
 * Allows abstracting platform dependencies away from the chart
 * @borrows Chart.platform.acquireContext as acquireContext
 * @borrows Chart.platform.releaseContext as releaseContext
 * @borrows Chart.platform.addEventListener as addEventListener
 * @borrows Chart.platform.removeEventListener as removeEventListener
 */

/**
 * @interface IEvent
 * @prop {String} type - The event type name, possible values are:
 * 'contextmenu', 'mouseenter', 'mousedown', 'mousemove', 'mouseup', 'mouseout',
 * 'click', 'dblclick', 'keydown', 'keypress', 'keyup' and 'resize'
 * @prop {*} native - The original native event (null for emulated events, e.g. 'resize')
 * @prop {Number} x - The mouse x position, relative to the canvas (null for incompatible events)
 * @prop {Number} y - The mouse y position, relative to the canvas (null for incompatible events)
 */


/***/ }),

/***/ 1463:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Afrikaans [af]
//! author : Werner Mollentze : https://github.com/wernerm

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var af = moment.defineLocale('af', {
    months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
    monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
    weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
    weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
    weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
    meridiemParse: /vm|nm/i,
    isPM : function (input) {
        return /^nm$/i.test(input);
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 12) {
            return isLower ? 'vm' : 'VM';
        } else {
            return isLower ? 'nm' : 'NM';
        }
    },
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Vandag om] LT',
        nextDay : '[Môre om] LT',
        nextWeek : 'dddd [om] LT',
        lastDay : '[Gister om] LT',
        lastWeek : '[Laas] dddd [om] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'oor %s',
        past : '%s gelede',
        s : '\'n paar sekondes',
        m : '\'n minuut',
        mm : '%d minute',
        h : '\'n uur',
        hh : '%d ure',
        d : '\'n dag',
        dd : '%d dae',
        M : '\'n maand',
        MM : '%d maande',
        y : '\'n jaar',
        yy : '%d jaar'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
    ordinal : function (number) {
        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
    },
    week : {
        dow : 1, // Maandag is die eerste dag van die week.
        doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
    }
});

return af;

})));


/***/ }),

/***/ 1464:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic [ar]
//! author : Abdel Said: https://github.com/abdelsaid
//! author : Ahmed Elkhatib
//! author : forabi https://github.com/forabi

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '١',
    '2': '٢',
    '3': '٣',
    '4': '٤',
    '5': '٥',
    '6': '٦',
    '7': '٧',
    '8': '٨',
    '9': '٩',
    '0': '٠'
};
var numberMap = {
    '١': '1',
    '٢': '2',
    '٣': '3',
    '٤': '4',
    '٥': '5',
    '٦': '6',
    '٧': '7',
    '٨': '8',
    '٩': '9',
    '٠': '0'
};
var pluralForm = function (n) {
    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
};
var plurals = {
    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
};
var pluralize = function (u) {
    return function (number, withoutSuffix, string, isFuture) {
        var f = pluralForm(number),
            str = plurals[u][pluralForm(number)];
        if (f === 2) {
            str = str[withoutSuffix ? 0 : 1];
        }
        return str.replace(/%d/i, number);
    };
};
var months = [
    'كانون الثاني يناير',
    'شباط فبراير',
    'آذار مارس',
    'نيسان أبريل',
    'أيار مايو',
    'حزيران يونيو',
    'تموز يوليو',
    'آب أغسطس',
    'أيلول سبتمبر',
    'تشرين الأول أكتوبر',
    'تشرين الثاني نوفمبر',
    'كانون الأول ديسمبر'
];

var ar = moment.defineLocale('ar', {
    months : months,
    monthsShort : months,
    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'D/\u200FM/\u200FYYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    meridiemParse: /ص|م/,
    isPM : function (input) {
        return 'م' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'ص';
        } else {
            return 'م';
        }
    },
    calendar : {
        sameDay: '[اليوم عند الساعة] LT',
        nextDay: '[غدًا عند الساعة] LT',
        nextWeek: 'dddd [عند الساعة] LT',
        lastDay: '[أمس عند الساعة] LT',
        lastWeek: 'dddd [عند الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'بعد %s',
        past : 'منذ %s',
        s : pluralize('s'),
        m : pluralize('m'),
        mm : pluralize('m'),
        h : pluralize('h'),
        hh : pluralize('h'),
        d : pluralize('d'),
        dd : pluralize('d'),
        M : pluralize('M'),
        MM : pluralize('M'),
        y : pluralize('y'),
        yy : pluralize('y')
    },
    preparse: function (string) {
        return string.replace(/\u200f/g, '').replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
            return numberMap[match];
        }).replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        }).replace(/,/g, '،');
    },
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return ar;

})));


/***/ }),

/***/ 1465:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Algeria) [ar-dz]
//! author : Noureddine LOUAHEDJ : https://github.com/noureddineme

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var arDz = moment.defineLocale('ar-dz', {
    months : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    monthsShort : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'أح_إث_ثلا_أر_خم_جم_سب'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[اليوم على الساعة] LT',
        nextDay: '[غدا على الساعة] LT',
        nextWeek: 'dddd [على الساعة] LT',
        lastDay: '[أمس على الساعة] LT',
        lastWeek: 'dddd [على الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'في %s',
        past : 'منذ %s',
        s : 'ثوان',
        m : 'دقيقة',
        mm : '%d دقائق',
        h : 'ساعة',
        hh : '%d ساعات',
        d : 'يوم',
        dd : '%d أيام',
        M : 'شهر',
        MM : '%d أشهر',
        y : 'سنة',
        yy : '%d سنوات'
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 4  // The week that contains Jan 1st is the first week of the year.
    }
});

return arDz;

})));


/***/ }),

/***/ 1466:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Kuwait) [ar-kw]
//! author : Nusret Parlak: https://github.com/nusretparlak

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var arKw = moment.defineLocale('ar-kw', {
    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[اليوم على الساعة] LT',
        nextDay: '[غدا على الساعة] LT',
        nextWeek: 'dddd [على الساعة] LT',
        lastDay: '[أمس على الساعة] LT',
        lastWeek: 'dddd [على الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'في %s',
        past : 'منذ %s',
        s : 'ثوان',
        m : 'دقيقة',
        mm : '%d دقائق',
        h : 'ساعة',
        hh : '%d ساعات',
        d : 'يوم',
        dd : '%d أيام',
        M : 'شهر',
        MM : '%d أشهر',
        y : 'سنة',
        yy : '%d سنوات'
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return arKw;

})));


/***/ }),

/***/ 1467:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Lybia) [ar-ly]
//! author : Ali Hmer: https://github.com/kikoanis

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '1',
    '2': '2',
    '3': '3',
    '4': '4',
    '5': '5',
    '6': '6',
    '7': '7',
    '8': '8',
    '9': '9',
    '0': '0'
};
var pluralForm = function (n) {
    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
};
var plurals = {
    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
};
var pluralize = function (u) {
    return function (number, withoutSuffix, string, isFuture) {
        var f = pluralForm(number),
            str = plurals[u][pluralForm(number)];
        if (f === 2) {
            str = str[withoutSuffix ? 0 : 1];
        }
        return str.replace(/%d/i, number);
    };
};
var months = [
    'يناير',
    'فبراير',
    'مارس',
    'أبريل',
    'مايو',
    'يونيو',
    'يوليو',
    'أغسطس',
    'سبتمبر',
    'أكتوبر',
    'نوفمبر',
    'ديسمبر'
];

var arLy = moment.defineLocale('ar-ly', {
    months : months,
    monthsShort : months,
    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'D/\u200FM/\u200FYYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    meridiemParse: /ص|م/,
    isPM : function (input) {
        return 'م' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'ص';
        } else {
            return 'م';
        }
    },
    calendar : {
        sameDay: '[اليوم عند الساعة] LT',
        nextDay: '[غدًا عند الساعة] LT',
        nextWeek: 'dddd [عند الساعة] LT',
        lastDay: '[أمس عند الساعة] LT',
        lastWeek: 'dddd [عند الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'بعد %s',
        past : 'منذ %s',
        s : pluralize('s'),
        m : pluralize('m'),
        mm : pluralize('m'),
        h : pluralize('h'),
        hh : pluralize('h'),
        d : pluralize('d'),
        dd : pluralize('d'),
        M : pluralize('M'),
        MM : pluralize('M'),
        y : pluralize('y'),
        yy : pluralize('y')
    },
    preparse: function (string) {
        return string.replace(/\u200f/g, '').replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        }).replace(/,/g, '،');
    },
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return arLy;

})));


/***/ }),

/***/ 1468:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Morocco) [ar-ma]
//! author : ElFadili Yassine : https://github.com/ElFadiliY
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var arMa = moment.defineLocale('ar-ma', {
    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[اليوم على الساعة] LT',
        nextDay: '[غدا على الساعة] LT',
        nextWeek: 'dddd [على الساعة] LT',
        lastDay: '[أمس على الساعة] LT',
        lastWeek: 'dddd [على الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'في %s',
        past : 'منذ %s',
        s : 'ثوان',
        m : 'دقيقة',
        mm : '%d دقائق',
        h : 'ساعة',
        hh : '%d ساعات',
        d : 'يوم',
        dd : '%d أيام',
        M : 'شهر',
        MM : '%d أشهر',
        y : 'سنة',
        yy : '%d سنوات'
    },
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return arMa;

})));


/***/ }),

/***/ 1469:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Saudi Arabia) [ar-sa]
//! author : Suhail Alkowaileet : https://github.com/xsoh

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '١',
    '2': '٢',
    '3': '٣',
    '4': '٤',
    '5': '٥',
    '6': '٦',
    '7': '٧',
    '8': '٨',
    '9': '٩',
    '0': '٠'
};
var numberMap = {
    '١': '1',
    '٢': '2',
    '٣': '3',
    '٤': '4',
    '٥': '5',
    '٦': '6',
    '٧': '7',
    '٨': '8',
    '٩': '9',
    '٠': '0'
};

var arSa = moment.defineLocale('ar-sa', {
    months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    meridiemParse: /ص|م/,
    isPM : function (input) {
        return 'م' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'ص';
        } else {
            return 'م';
        }
    },
    calendar : {
        sameDay: '[اليوم على الساعة] LT',
        nextDay: '[غدا على الساعة] LT',
        nextWeek: 'dddd [على الساعة] LT',
        lastDay: '[أمس على الساعة] LT',
        lastWeek: 'dddd [على الساعة] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'في %s',
        past : 'منذ %s',
        s : 'ثوان',
        m : 'دقيقة',
        mm : '%d دقائق',
        h : 'ساعة',
        hh : '%d ساعات',
        d : 'يوم',
        dd : '%d أيام',
        M : 'شهر',
        MM : '%d أشهر',
        y : 'سنة',
        yy : '%d سنوات'
    },
    preparse: function (string) {
        return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
            return numberMap[match];
        }).replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        }).replace(/,/g, '،');
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return arSa;

})));


/***/ }),

/***/ 1470:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale  :  Arabic (Tunisia) [ar-tn]
//! author : Nader Toukabri : https://github.com/naderio

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var arTn = moment.defineLocale('ar-tn', {
    months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
    weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    weekdaysParseExact : true,
    longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd D MMMM YYYY HH:mm'
    },
    calendar: {
        sameDay: '[اليوم على الساعة] LT',
        nextDay: '[غدا على الساعة] LT',
        nextWeek: 'dddd [على الساعة] LT',
        lastDay: '[أمس على الساعة] LT',
        lastWeek: 'dddd [على الساعة] LT',
        sameElse: 'L'
    },
    relativeTime: {
        future: 'في %s',
        past: 'منذ %s',
        s: 'ثوان',
        m: 'دقيقة',
        mm: '%d دقائق',
        h: 'ساعة',
        hh: '%d ساعات',
        d: 'يوم',
        dd: '%d أيام',
        M: 'شهر',
        MM: '%d أشهر',
        y: 'سنة',
        yy: '%d سنوات'
    },
    week: {
        dow: 1, // Monday is the first day of the week.
        doy: 4 // The week that contains Jan 4th is the first week of the year.
    }
});

return arTn;

})));


/***/ }),

/***/ 1471:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Azerbaijani [az]
//! author : topchiyev : https://github.com/topchiyev

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var suffixes = {
    1: '-inci',
    5: '-inci',
    8: '-inci',
    70: '-inci',
    80: '-inci',
    2: '-nci',
    7: '-nci',
    20: '-nci',
    50: '-nci',
    3: '-üncü',
    4: '-üncü',
    100: '-üncü',
    6: '-ncı',
    9: '-uncu',
    10: '-uncu',
    30: '-uncu',
    60: '-ıncı',
    90: '-ıncı'
};

var az = moment.defineLocale('az', {
    months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
    monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
    weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
    weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
    weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[bugün saat] LT',
        nextDay : '[sabah saat] LT',
        nextWeek : '[gələn həftə] dddd [saat] LT',
        lastDay : '[dünən] LT',
        lastWeek : '[keçən həftə] dddd [saat] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s sonra',
        past : '%s əvvəl',
        s : 'birneçə saniyyə',
        m : 'bir dəqiqə',
        mm : '%d dəqiqə',
        h : 'bir saat',
        hh : '%d saat',
        d : 'bir gün',
        dd : '%d gün',
        M : 'bir ay',
        MM : '%d ay',
        y : 'bir il',
        yy : '%d il'
    },
    meridiemParse: /gecə|səhər|gündüz|axşam/,
    isPM : function (input) {
        return /^(gündüz|axşam)$/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'gecə';
        } else if (hour < 12) {
            return 'səhər';
        } else if (hour < 17) {
            return 'gündüz';
        } else {
            return 'axşam';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
    ordinal : function (number) {
        if (number === 0) {  // special case for zero
            return number + '-ıncı';
        }
        var a = number % 10,
            b = number % 100 - a,
            c = number >= 100 ? 100 : null;
        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return az;

})));


/***/ }),

/***/ 1472:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Belarusian [be]
//! author : Dmitry Demidov : https://github.com/demidov91
//! author: Praleska: http://praleska.pro/
//! Author : Menelion Elensúle : https://github.com/Oire

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function plural(word, num) {
    var forms = word.split('_');
    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
}
function relativeTimeWithPlural(number, withoutSuffix, key) {
    var format = {
        'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
        'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
        'dd': 'дзень_дні_дзён',
        'MM': 'месяц_месяцы_месяцаў',
        'yy': 'год_гады_гадоў'
    };
    if (key === 'm') {
        return withoutSuffix ? 'хвіліна' : 'хвіліну';
    }
    else if (key === 'h') {
        return withoutSuffix ? 'гадзіна' : 'гадзіну';
    }
    else {
        return number + ' ' + plural(format[key], +number);
    }
}

var be = moment.defineLocale('be', {
    months : {
        format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
        standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
    },
    monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
    weekdays : {
        format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
        standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
        isFormat: /\[ ?[Вв] ?(?:мінулую|наступную)? ?\] ?dddd/
    },
    weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
    weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY г.',
        LLL : 'D MMMM YYYY г., HH:mm',
        LLLL : 'dddd, D MMMM YYYY г., HH:mm'
    },
    calendar : {
        sameDay: '[Сёння ў] LT',
        nextDay: '[Заўтра ў] LT',
        lastDay: '[Учора ў] LT',
        nextWeek: function () {
            return '[У] dddd [ў] LT';
        },
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                case 3:
                case 5:
                case 6:
                    return '[У мінулую] dddd [ў] LT';
                case 1:
                case 2:
                case 4:
                    return '[У мінулы] dddd [ў] LT';
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'праз %s',
        past : '%s таму',
        s : 'некалькі секунд',
        m : relativeTimeWithPlural,
        mm : relativeTimeWithPlural,
        h : relativeTimeWithPlural,
        hh : relativeTimeWithPlural,
        d : 'дзень',
        dd : relativeTimeWithPlural,
        M : 'месяц',
        MM : relativeTimeWithPlural,
        y : 'год',
        yy : relativeTimeWithPlural
    },
    meridiemParse: /ночы|раніцы|дня|вечара/,
    isPM : function (input) {
        return /^(дня|вечара)$/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'ночы';
        } else if (hour < 12) {
            return 'раніцы';
        } else if (hour < 17) {
            return 'дня';
        } else {
            return 'вечара';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
    ordinal: function (number, period) {
        switch (period) {
            case 'M':
            case 'd':
            case 'DDD':
            case 'w':
            case 'W':
                return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
            case 'D':
                return number + '-га';
            default:
                return number;
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return be;

})));


/***/ }),

/***/ 1473:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bulgarian [bg]
//! author : Krasen Borisov : https://github.com/kraz

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var bg = moment.defineLocale('bg', {
    months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
    monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
    weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
    weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'D.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY H:mm',
        LLLL : 'dddd, D MMMM YYYY H:mm'
    },
    calendar : {
        sameDay : '[Днес в] LT',
        nextDay : '[Утре в] LT',
        nextWeek : 'dddd [в] LT',
        lastDay : '[Вчера в] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 0:
                case 3:
                case 6:
                    return '[В изминалата] dddd [в] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[В изминалия] dddd [в] LT';
            }
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'след %s',
        past : 'преди %s',
        s : 'няколко секунди',
        m : 'минута',
        mm : '%d минути',
        h : 'час',
        hh : '%d часа',
        d : 'ден',
        dd : '%d дни',
        M : 'месец',
        MM : '%d месеца',
        y : 'година',
        yy : '%d години'
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
    ordinal : function (number) {
        var lastDigit = number % 10,
            last2Digits = number % 100;
        if (number === 0) {
            return number + '-ев';
        } else if (last2Digits === 0) {
            return number + '-ен';
        } else if (last2Digits > 10 && last2Digits < 20) {
            return number + '-ти';
        } else if (lastDigit === 1) {
            return number + '-ви';
        } else if (lastDigit === 2) {
            return number + '-ри';
        } else if (lastDigit === 7 || lastDigit === 8) {
            return number + '-ми';
        } else {
            return number + '-ти';
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return bg;

})));


/***/ }),

/***/ 1474:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bengali [bn]
//! author : Kaushik Gandhi : https://github.com/kaushikgandhi

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '১',
    '2': '২',
    '3': '৩',
    '4': '৪',
    '5': '৫',
    '6': '৬',
    '7': '৭',
    '8': '৮',
    '9': '৯',
    '0': '০'
};
var numberMap = {
    '১': '1',
    '২': '2',
    '৩': '3',
    '৪': '4',
    '৫': '5',
    '৬': '6',
    '৭': '7',
    '৮': '8',
    '৯': '9',
    '০': '0'
};

var bn = moment.defineLocale('bn', {
    months : 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
    monthsShort : 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
    weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
    weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
    weekdaysMin : 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
    longDateFormat : {
        LT : 'A h:mm সময়',
        LTS : 'A h:mm:ss সময়',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm সময়',
        LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
    },
    calendar : {
        sameDay : '[আজ] LT',
        nextDay : '[আগামীকাল] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[গতকাল] LT',
        lastWeek : '[গত] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s পরে',
        past : '%s আগে',
        s : 'কয়েক সেকেন্ড',
        m : 'এক মিনিট',
        mm : '%d মিনিট',
        h : 'এক ঘন্টা',
        hh : '%d ঘন্টা',
        d : 'এক দিন',
        dd : '%d দিন',
        M : 'এক মাস',
        MM : '%d মাস',
        y : 'এক বছর',
        yy : '%d বছর'
    },
    preparse: function (string) {
        return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if ((meridiem === 'রাত' && hour >= 4) ||
                (meridiem === 'দুপুর' && hour < 5) ||
                meridiem === 'বিকাল') {
            return hour + 12;
        } else {
            return hour;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'রাত';
        } else if (hour < 10) {
            return 'সকাল';
        } else if (hour < 17) {
            return 'দুপুর';
        } else if (hour < 20) {
            return 'বিকাল';
        } else {
            return 'রাত';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return bn;

})));


/***/ }),

/***/ 1475:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tibetan [bo]
//! author : Thupten N. Chakrishar : https://github.com/vajradog

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '༡',
    '2': '༢',
    '3': '༣',
    '4': '༤',
    '5': '༥',
    '6': '༦',
    '7': '༧',
    '8': '༨',
    '9': '༩',
    '0': '༠'
};
var numberMap = {
    '༡': '1',
    '༢': '2',
    '༣': '3',
    '༤': '4',
    '༥': '5',
    '༦': '6',
    '༧': '7',
    '༨': '8',
    '༩': '9',
    '༠': '0'
};

var bo = moment.defineLocale('bo', {
    months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
    monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
    weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
    weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
    weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
    longDateFormat : {
        LT : 'A h:mm',
        LTS : 'A h:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm',
        LLLL : 'dddd, D MMMM YYYY, A h:mm'
    },
    calendar : {
        sameDay : '[དི་རིང] LT',
        nextDay : '[སང་ཉིན] LT',
        nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
        lastDay : '[ཁ་སང] LT',
        lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s ལ་',
        past : '%s སྔན་ལ',
        s : 'ལམ་སང',
        m : 'སྐར་མ་གཅིག',
        mm : '%d སྐར་མ',
        h : 'ཆུ་ཚོད་གཅིག',
        hh : '%d ཆུ་ཚོད',
        d : 'ཉིན་གཅིག',
        dd : '%d ཉིན་',
        M : 'ཟླ་བ་གཅིག',
        MM : '%d ཟླ་བ',
        y : 'ལོ་གཅིག',
        yy : '%d ལོ'
    },
    preparse: function (string) {
        return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
                (meridiem === 'ཉིན་གུང' && hour < 5) ||
                meridiem === 'དགོང་དག') {
            return hour + 12;
        } else {
            return hour;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'མཚན་མོ';
        } else if (hour < 10) {
            return 'ཞོགས་ཀས';
        } else if (hour < 17) {
            return 'ཉིན་གུང';
        } else if (hour < 20) {
            return 'དགོང་དག';
        } else {
            return 'མཚན་མོ';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return bo;

})));


/***/ }),

/***/ 1476:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Breton [br]
//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function relativeTimeWithMutation(number, withoutSuffix, key) {
    var format = {
        'mm': 'munutenn',
        'MM': 'miz',
        'dd': 'devezh'
    };
    return number + ' ' + mutation(format[key], number);
}
function specialMutationForYears(number) {
    switch (lastNumber(number)) {
        case 1:
        case 3:
        case 4:
        case 5:
        case 9:
            return number + ' bloaz';
        default:
            return number + ' vloaz';
    }
}
function lastNumber(number) {
    if (number > 9) {
        return lastNumber(number % 10);
    }
    return number;
}
function mutation(text, number) {
    if (number === 2) {
        return softMutation(text);
    }
    return text;
}
function softMutation(text) {
    var mutationTable = {
        'm': 'v',
        'b': 'v',
        'd': 'z'
    };
    if (mutationTable[text.charAt(0)] === undefined) {
        return text;
    }
    return mutationTable[text.charAt(0)] + text.substring(1);
}

var br = moment.defineLocale('br', {
    months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
    monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
    weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
    weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
    weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'h[e]mm A',
        LTS : 'h[e]mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D [a viz] MMMM YYYY',
        LLL : 'D [a viz] MMMM YYYY h[e]mm A',
        LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
    },
    calendar : {
        sameDay : '[Hiziv da] LT',
        nextDay : '[Warc\'hoazh da] LT',
        nextWeek : 'dddd [da] LT',
        lastDay : '[Dec\'h da] LT',
        lastWeek : 'dddd [paset da] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'a-benn %s',
        past : '%s \'zo',
        s : 'un nebeud segondennoù',
        m : 'ur vunutenn',
        mm : relativeTimeWithMutation,
        h : 'un eur',
        hh : '%d eur',
        d : 'un devezh',
        dd : relativeTimeWithMutation,
        M : 'ur miz',
        MM : relativeTimeWithMutation,
        y : 'ur bloaz',
        yy : specialMutationForYears
    },
    dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
    ordinal : function (number) {
        var output = (number === 1) ? 'añ' : 'vet';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return br;

})));


/***/ }),

/***/ 1477:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bosnian [bs]
//! author : Nedim Cholich : https://github.com/frontyard
//! based on (hr) translation by Bojan Marković

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function translate(number, withoutSuffix, key) {
    var result = number + ' ';
    switch (key) {
        case 'm':
            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
        case 'mm':
            if (number === 1) {
                result += 'minuta';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'minute';
            } else {
                result += 'minuta';
            }
            return result;
        case 'h':
            return withoutSuffix ? 'jedan sat' : 'jednog sata';
        case 'hh':
            if (number === 1) {
                result += 'sat';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'sata';
            } else {
                result += 'sati';
            }
            return result;
        case 'dd':
            if (number === 1) {
                result += 'dan';
            } else {
                result += 'dana';
            }
            return result;
        case 'MM':
            if (number === 1) {
                result += 'mjesec';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'mjeseca';
            } else {
                result += 'mjeseci';
            }
            return result;
        case 'yy':
            if (number === 1) {
                result += 'godina';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'godine';
            } else {
                result += 'godina';
            }
            return result;
    }
}

var bs = moment.defineLocale('bs', {
    months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
    monthsParseExact: true,
    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd, D. MMMM YYYY H:mm'
    },
    calendar : {
        sameDay  : '[danas u] LT',
        nextDay  : '[sutra u] LT',
        nextWeek : function () {
            switch (this.day()) {
                case 0:
                    return '[u] [nedjelju] [u] LT';
                case 3:
                    return '[u] [srijedu] [u] LT';
                case 6:
                    return '[u] [subotu] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[u] dddd [u] LT';
            }
        },
        lastDay  : '[jučer u] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 0:
                case 3:
                    return '[prošlu] dddd [u] LT';
                case 6:
                    return '[prošle] [subote] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[prošli] dddd [u] LT';
            }
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'za %s',
        past   : 'prije %s',
        s      : 'par sekundi',
        m      : translate,
        mm     : translate,
        h      : translate,
        hh     : translate,
        d      : 'dan',
        dd     : translate,
        M      : 'mjesec',
        MM     : translate,
        y      : 'godinu',
        yy     : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return bs;

})));


/***/ }),

/***/ 1478:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Catalan [ca]
//! author : Juan G. Hurtado : https://github.com/juanghurtado

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ca = moment.defineLocale('ca', {
    months : {
        standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
        format: 'de gener_de febrer_de març_d\'abril_de maig_de juny_de juliol_d\'agost_de setembre_d\'octubre_de novembre_de desembre'.split('_'),
        isFormat: /D[oD]?(\s)+MMMM/
    },
    monthsShort : 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split('_'),
    monthsParseExact : true,
    weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
    weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
    weekdaysMin : 'Dg_Dl_Dt_Dc_Dj_Dv_Ds'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD/MM/YYYY',
        LL : '[el] D MMMM [de] YYYY',
        ll : 'D MMM YYYY',
        LLL : '[el] D MMMM [de] YYYY [a les] H:mm',
        lll : 'D MMM YYYY, H:mm',
        LLLL : '[el] dddd D MMMM [de] YYYY [a les] H:mm',
        llll : 'ddd D MMM YYYY, H:mm'
    },
    calendar : {
        sameDay : function () {
            return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
        },
        nextDay : function () {
            return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
        },
        nextWeek : function () {
            return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
        },
        lastDay : function () {
            return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
        },
        lastWeek : function () {
            return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'd\'aquí %s',
        past : 'fa %s',
        s : 'uns segons',
        m : 'un minut',
        mm : '%d minuts',
        h : 'una hora',
        hh : '%d hores',
        d : 'un dia',
        dd : '%d dies',
        M : 'un mes',
        MM : '%d mesos',
        y : 'un any',
        yy : '%d anys'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
    ordinal : function (number, period) {
        var output = (number === 1) ? 'r' :
            (number === 2) ? 'n' :
            (number === 3) ? 'r' :
            (number === 4) ? 't' : 'è';
        if (period === 'w' || period === 'W') {
            output = 'a';
        }
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return ca;

})));


/***/ }),

/***/ 1479:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Czech [cs]
//! author : petrbela : https://github.com/petrbela

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_');
var monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
function plural(n) {
    return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
}
function translate(number, withoutSuffix, key, isFuture) {
    var result = number + ' ';
    switch (key) {
        case 's':  // a few seconds / in a few seconds / a few seconds ago
            return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
        case 'm':  // a minute / in a minute / a minute ago
            return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'minuty' : 'minut');
            } else {
                return result + 'minutami';
            }
            break;
        case 'h':  // an hour / in an hour / an hour ago
            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
        case 'hh': // 9 hours / in 9 hours / 9 hours ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'hodiny' : 'hodin');
            } else {
                return result + 'hodinami';
            }
            break;
        case 'd':  // a day / in a day / a day ago
            return (withoutSuffix || isFuture) ? 'den' : 'dnem';
        case 'dd': // 9 days / in 9 days / 9 days ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'dny' : 'dní');
            } else {
                return result + 'dny';
            }
            break;
        case 'M':  // a month / in a month / a month ago
            return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
        case 'MM': // 9 months / in 9 months / 9 months ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'měsíce' : 'měsíců');
            } else {
                return result + 'měsíci';
            }
            break;
        case 'y':  // a year / in a year / a year ago
            return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
        case 'yy': // 9 years / in 9 years / 9 years ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'roky' : 'let');
            } else {
                return result + 'lety';
            }
            break;
    }
}

var cs = moment.defineLocale('cs', {
    months : months,
    monthsShort : monthsShort,
    monthsParse : (function (months, monthsShort) {
        var i, _monthsParse = [];
        for (i = 0; i < 12; i++) {
            // use custom parser to solve problem with July (červenec)
            _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
        }
        return _monthsParse;
    }(months, monthsShort)),
    shortMonthsParse : (function (monthsShort) {
        var i, _shortMonthsParse = [];
        for (i = 0; i < 12; i++) {
            _shortMonthsParse[i] = new RegExp('^' + monthsShort[i] + '$', 'i');
        }
        return _shortMonthsParse;
    }(monthsShort)),
    longMonthsParse : (function (months) {
        var i, _longMonthsParse = [];
        for (i = 0; i < 12; i++) {
            _longMonthsParse[i] = new RegExp('^' + months[i] + '$', 'i');
        }
        return _longMonthsParse;
    }(months)),
    weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
    weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
    weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
    longDateFormat : {
        LT: 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd D. MMMM YYYY H:mm',
        l : 'D. M. YYYY'
    },
    calendar : {
        sameDay: '[dnes v] LT',
        nextDay: '[zítra v] LT',
        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[v neděli v] LT';
                case 1:
                case 2:
                    return '[v] dddd [v] LT';
                case 3:
                    return '[ve středu v] LT';
                case 4:
                    return '[ve čtvrtek v] LT';
                case 5:
                    return '[v pátek v] LT';
                case 6:
                    return '[v sobotu v] LT';
            }
        },
        lastDay: '[včera v] LT',
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[minulou neděli v] LT';
                case 1:
                case 2:
                    return '[minulé] dddd [v] LT';
                case 3:
                    return '[minulou středu v] LT';
                case 4:
                case 5:
                    return '[minulý] dddd [v] LT';
                case 6:
                    return '[minulou sobotu v] LT';
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'za %s',
        past : 'před %s',
        s : translate,
        m : translate,
        mm : translate,
        h : translate,
        hh : translate,
        d : translate,
        dd : translate,
        M : translate,
        MM : translate,
        y : translate,
        yy : translate
    },
    dayOfMonthOrdinalParse : /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return cs;

})));


/***/ }),

/***/ 1480:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chuvash [cv]
//! author : Anatoly Mironov : https://github.com/mirontoli

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var cv = moment.defineLocale('cv', {
    months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
    monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
    weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
    weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
    weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD-MM-YYYY',
        LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
        LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
        LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
    },
    calendar : {
        sameDay: '[Паян] LT [сехетре]',
        nextDay: '[Ыран] LT [сехетре]',
        lastDay: '[Ӗнер] LT [сехетре]',
        nextWeek: '[Ҫитес] dddd LT [сехетре]',
        lastWeek: '[Иртнӗ] dddd LT [сехетре]',
        sameElse: 'L'
    },
    relativeTime : {
        future : function (output) {
            var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
            return output + affix;
        },
        past : '%s каялла',
        s : 'пӗр-ик ҫеккунт',
        m : 'пӗр минут',
        mm : '%d минут',
        h : 'пӗр сехет',
        hh : '%d сехет',
        d : 'пӗр кун',
        dd : '%d кун',
        M : 'пӗр уйӑх',
        MM : '%d уйӑх',
        y : 'пӗр ҫул',
        yy : '%d ҫул'
    },
    dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
    ordinal : '%d-мӗш',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return cv;

})));


/***/ }),

/***/ 1481:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Welsh [cy]
//! author : Robert Allen : https://github.com/robgallen
//! author : https://github.com/ryangreaves

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var cy = moment.defineLocale('cy', {
    months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
    monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
    weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
    weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
    weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
    weekdaysParseExact : true,
    // time formats are the same as en-gb
    longDateFormat: {
        LT: 'HH:mm',
        LTS : 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd, D MMMM YYYY HH:mm'
    },
    calendar: {
        sameDay: '[Heddiw am] LT',
        nextDay: '[Yfory am] LT',
        nextWeek: 'dddd [am] LT',
        lastDay: '[Ddoe am] LT',
        lastWeek: 'dddd [diwethaf am] LT',
        sameElse: 'L'
    },
    relativeTime: {
        future: 'mewn %s',
        past: '%s yn ôl',
        s: 'ychydig eiliadau',
        m: 'munud',
        mm: '%d munud',
        h: 'awr',
        hh: '%d awr',
        d: 'diwrnod',
        dd: '%d diwrnod',
        M: 'mis',
        MM: '%d mis',
        y: 'blwyddyn',
        yy: '%d flynedd'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
    // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
    ordinal: function (number) {
        var b = number,
            output = '',
            lookup = [
                '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
                'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
            ];
        if (b > 20) {
            if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
                output = 'fed'; // not 30ain, 70ain or 90ain
            } else {
                output = 'ain';
            }
        } else if (b > 0) {
            output = lookup[b];
        }
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return cy;

})));


/***/ }),

/***/ 1482:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Danish [da]
//! author : Ulrik Nielsen : https://github.com/mrbase

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var da = moment.defineLocale('da', {
    months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
    weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY HH:mm',
        LLLL : 'dddd [d.] D. MMMM YYYY [kl.] HH:mm'
    },
    calendar : {
        sameDay : '[i dag kl.] LT',
        nextDay : '[i morgen kl.] LT',
        nextWeek : 'på dddd [kl.] LT',
        lastDay : '[i går kl.] LT',
        lastWeek : '[i] dddd[s kl.] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'om %s',
        past : '%s siden',
        s : 'få sekunder',
        m : 'et minut',
        mm : '%d minutter',
        h : 'en time',
        hh : '%d timer',
        d : 'en dag',
        dd : '%d dage',
        M : 'en måned',
        MM : '%d måneder',
        y : 'et år',
        yy : '%d år'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return da;

})));


/***/ }),

/***/ 1483:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German [de]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        'm': ['eine Minute', 'einer Minute'],
        'h': ['eine Stunde', 'einer Stunde'],
        'd': ['ein Tag', 'einem Tag'],
        'dd': [number + ' Tage', number + ' Tagen'],
        'M': ['ein Monat', 'einem Monat'],
        'MM': [number + ' Monate', number + ' Monaten'],
        'y': ['ein Jahr', 'einem Jahr'],
        'yy': [number + ' Jahre', number + ' Jahren']
    };
    return withoutSuffix ? format[key][0] : format[key][1];
}

var de = moment.defineLocale('de', {
    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
    monthsShort : 'Jan._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
    monthsParseExact : true,
    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY HH:mm',
        LLLL : 'dddd, D. MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[heute um] LT [Uhr]',
        sameElse: 'L',
        nextDay: '[morgen um] LT [Uhr]',
        nextWeek: 'dddd [um] LT [Uhr]',
        lastDay: '[gestern um] LT [Uhr]',
        lastWeek: '[letzten] dddd [um] LT [Uhr]'
    },
    relativeTime : {
        future : 'in %s',
        past : 'vor %s',
        s : 'ein paar Sekunden',
        m : processRelativeTime,
        mm : '%d Minuten',
        h : processRelativeTime,
        hh : '%d Stunden',
        d : processRelativeTime,
        dd : processRelativeTime,
        M : processRelativeTime,
        MM : processRelativeTime,
        y : processRelativeTime,
        yy : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return de;

})));


/***/ }),

/***/ 1484:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German (Austria) [de-at]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Martin Groller : https://github.com/MadMG
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        'm': ['eine Minute', 'einer Minute'],
        'h': ['eine Stunde', 'einer Stunde'],
        'd': ['ein Tag', 'einem Tag'],
        'dd': [number + ' Tage', number + ' Tagen'],
        'M': ['ein Monat', 'einem Monat'],
        'MM': [number + ' Monate', number + ' Monaten'],
        'y': ['ein Jahr', 'einem Jahr'],
        'yy': [number + ' Jahre', number + ' Jahren']
    };
    return withoutSuffix ? format[key][0] : format[key][1];
}

var deAt = moment.defineLocale('de-at', {
    months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
    monthsShort : 'Jän._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
    monthsParseExact : true,
    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY HH:mm',
        LLLL : 'dddd, D. MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[heute um] LT [Uhr]',
        sameElse: 'L',
        nextDay: '[morgen um] LT [Uhr]',
        nextWeek: 'dddd [um] LT [Uhr]',
        lastDay: '[gestern um] LT [Uhr]',
        lastWeek: '[letzten] dddd [um] LT [Uhr]'
    },
    relativeTime : {
        future : 'in %s',
        past : 'vor %s',
        s : 'ein paar Sekunden',
        m : processRelativeTime,
        mm : '%d Minuten',
        h : processRelativeTime,
        hh : '%d Stunden',
        d : processRelativeTime,
        dd : processRelativeTime,
        M : processRelativeTime,
        MM : processRelativeTime,
        y : processRelativeTime,
        yy : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return deAt;

})));


/***/ }),

/***/ 1485:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German (Switzerland) [de-ch]
//! author : sschueller : https://github.com/sschueller

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


// based on: https://www.bk.admin.ch/dokumentation/sprachen/04915/05016/index.html?lang=de#

function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        'm': ['eine Minute', 'einer Minute'],
        'h': ['eine Stunde', 'einer Stunde'],
        'd': ['ein Tag', 'einem Tag'],
        'dd': [number + ' Tage', number + ' Tagen'],
        'M': ['ein Monat', 'einem Monat'],
        'MM': [number + ' Monate', number + ' Monaten'],
        'y': ['ein Jahr', 'einem Jahr'],
        'yy': [number + ' Jahre', number + ' Jahren']
    };
    return withoutSuffix ? format[key][0] : format[key][1];
}

var deCh = moment.defineLocale('de-ch', {
    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
    monthsShort : 'Jan._Febr._März_April_Mai_Juni_Juli_Aug._Sept._Okt._Nov._Dez.'.split('_'),
    monthsParseExact : true,
    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
    weekdaysShort : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT: 'HH.mm',
        LTS: 'HH.mm.ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY HH.mm',
        LLLL : 'dddd, D. MMMM YYYY HH.mm'
    },
    calendar : {
        sameDay: '[heute um] LT [Uhr]',
        sameElse: 'L',
        nextDay: '[morgen um] LT [Uhr]',
        nextWeek: 'dddd [um] LT [Uhr]',
        lastDay: '[gestern um] LT [Uhr]',
        lastWeek: '[letzten] dddd [um] LT [Uhr]'
    },
    relativeTime : {
        future : 'in %s',
        past : 'vor %s',
        s : 'ein paar Sekunden',
        m : processRelativeTime,
        mm : '%d Minuten',
        h : processRelativeTime,
        hh : '%d Stunden',
        d : processRelativeTime,
        dd : processRelativeTime,
        M : processRelativeTime,
        MM : processRelativeTime,
        y : processRelativeTime,
        yy : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return deCh;

})));


/***/ }),

/***/ 1486:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maldivian [dv]
//! author : Jawish Hameed : https://github.com/jawish

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = [
    'ޖެނުއަރީ',
    'ފެބްރުއަރީ',
    'މާރިޗު',
    'އޭޕްރީލު',
    'މޭ',
    'ޖޫން',
    'ޖުލައި',
    'އޯގަސްޓު',
    'ސެޕްޓެމްބަރު',
    'އޮކްޓޯބަރު',
    'ނޮވެމްބަރު',
    'ޑިސެމްބަރު'
];
var weekdays = [
    'އާދިއްތަ',
    'ހޯމަ',
    'އަންގާރަ',
    'ބުދަ',
    'ބުރާސްފަތި',
    'ހުކުރު',
    'ހޮނިހިރު'
];

var dv = moment.defineLocale('dv', {
    months : months,
    monthsShort : months,
    weekdays : weekdays,
    weekdaysShort : weekdays,
    weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
    longDateFormat : {

        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'D/M/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    meridiemParse: /މކ|މފ/,
    isPM : function (input) {
        return 'މފ' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'މކ';
        } else {
            return 'މފ';
        }
    },
    calendar : {
        sameDay : '[މިއަދު] LT',
        nextDay : '[މާދަމާ] LT',
        nextWeek : 'dddd LT',
        lastDay : '[އިއްޔެ] LT',
        lastWeek : '[ފާއިތުވި] dddd LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'ތެރޭގައި %s',
        past : 'ކުރިން %s',
        s : 'ސިކުންތުކޮޅެއް',
        m : 'މިނިޓެއް',
        mm : 'މިނިޓު %d',
        h : 'ގަޑިއިރެއް',
        hh : 'ގަޑިއިރު %d',
        d : 'ދުވަހެއް',
        dd : 'ދުވަސް %d',
        M : 'މަހެއް',
        MM : 'މަސް %d',
        y : 'އަހަރެއް',
        yy : 'އަހަރު %d'
    },
    preparse: function (string) {
        return string.replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/,/g, '،');
    },
    week : {
        dow : 7,  // Sunday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return dv;

})));


/***/ }),

/***/ 1487:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Greek [el]
//! author : Aggelos Karalias : https://github.com/mehiel

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

function isFunction(input) {
    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
}


var el = moment.defineLocale('el', {
    monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
    monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
    months : function (momentToFormat, format) {
        if (!momentToFormat) {
            return this._monthsNominativeEl;
        } else if (/D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
            return this._monthsGenitiveEl[momentToFormat.month()];
        } else {
            return this._monthsNominativeEl[momentToFormat.month()];
        }
    },
    monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
    weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
    weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
    weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
    meridiem : function (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'μμ' : 'ΜΜ';
        } else {
            return isLower ? 'πμ' : 'ΠΜ';
        }
    },
    isPM : function (input) {
        return ((input + '').toLowerCase()[0] === 'μ');
    },
    meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendarEl : {
        sameDay : '[Σήμερα {}] LT',
        nextDay : '[Αύριο {}] LT',
        nextWeek : 'dddd [{}] LT',
        lastDay : '[Χθες {}] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 6:
                    return '[το προηγούμενο] dddd [{}] LT';
                default:
                    return '[την προηγούμενη] dddd [{}] LT';
            }
        },
        sameElse : 'L'
    },
    calendar : function (key, mom) {
        var output = this._calendarEl[key],
            hours = mom && mom.hours();
        if (isFunction(output)) {
            output = output.apply(mom);
        }
        return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
    },
    relativeTime : {
        future : 'σε %s',
        past : '%s πριν',
        s : 'λίγα δευτερόλεπτα',
        m : 'ένα λεπτό',
        mm : '%d λεπτά',
        h : 'μία ώρα',
        hh : '%d ώρες',
        d : 'μία μέρα',
        dd : '%d μέρες',
        M : 'ένας μήνας',
        MM : '%d μήνες',
        y : 'ένας χρόνος',
        yy : '%d χρόνια'
    },
    dayOfMonthOrdinalParse: /\d{1,2}η/,
    ordinal: '%dη',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4st is the first week of the year.
    }
});

return el;

})));


/***/ }),

/***/ 1488:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Australia) [en-au]
//! author : Jared Morse : https://github.com/jarcoal

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enAu = moment.defineLocale('en-au', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return enAu;

})));


/***/ }),

/***/ 1489:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Canada) [en-ca]
//! author : Jonathan Abourbih : https://github.com/jonbca

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enCa = moment.defineLocale('en-ca', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'YYYY-MM-DD',
        LL : 'MMMM D, YYYY',
        LLL : 'MMMM D, YYYY h:mm A',
        LLLL : 'dddd, MMMM D, YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    }
});

return enCa;

})));


/***/ }),

/***/ 1490:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (United Kingdom) [en-gb]
//! author : Chris Gedrim : https://github.com/chrisgedrim

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enGb = moment.defineLocale('en-gb', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return enGb;

})));


/***/ }),

/***/ 1491:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Ireland) [en-ie]
//! author : Chris Cartlidge : https://github.com/chriscartlidge

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enIe = moment.defineLocale('en-ie', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD-MM-YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return enIe;

})));


/***/ }),

/***/ 1492:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (New Zealand) [en-nz]
//! author : Luke McGregor : https://github.com/lukemcgregor

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var enNz = moment.defineLocale('en-nz', {
    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'in %s',
        past : '%s ago',
        s : 'a few seconds',
        m : 'a minute',
        mm : '%d minutes',
        h : 'an hour',
        hh : '%d hours',
        d : 'a day',
        dd : '%d days',
        M : 'a month',
        MM : '%d months',
        y : 'a year',
        yy : '%d years'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return enNz;

})));


/***/ }),

/***/ 1493:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Esperanto [eo]
//! author : Colin Dean : https://github.com/colindean
//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
//! comment : miestasmia corrected the translation by colindean

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var eo = moment.defineLocale('eo', {
    months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
    weekdays : 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
    weekdaysShort : 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
    weekdaysMin : 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY-MM-DD',
        LL : 'D[-a de] MMMM, YYYY',
        LLL : 'D[-a de] MMMM, YYYY HH:mm',
        LLLL : 'dddd, [la] D[-a de] MMMM, YYYY HH:mm'
    },
    meridiemParse: /[ap]\.t\.m/i,
    isPM: function (input) {
        return input.charAt(0).toLowerCase() === 'p';
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'p.t.m.' : 'P.T.M.';
        } else {
            return isLower ? 'a.t.m.' : 'A.T.M.';
        }
    },
    calendar : {
        sameDay : '[Hodiaŭ je] LT',
        nextDay : '[Morgaŭ je] LT',
        nextWeek : 'dddd [je] LT',
        lastDay : '[Hieraŭ je] LT',
        lastWeek : '[pasinta] dddd [je] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'post %s',
        past : 'antaŭ %s',
        s : 'sekundoj',
        m : 'minuto',
        mm : '%d minutoj',
        h : 'horo',
        hh : '%d horoj',
        d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
        dd : '%d tagoj',
        M : 'monato',
        MM : '%d monatoj',
        y : 'jaro',
        yy : '%d jaroj'
    },
    dayOfMonthOrdinalParse: /\d{1,2}a/,
    ordinal : '%da',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return eo;

})));


/***/ }),

/***/ 1494:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish [es]
//! author : Julio Napurí : https://github.com/julionc

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

var es = moment.defineLocale('es', {
    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortDot;
        } else if (/-MMM-/.test(format)) {
            return monthsShort[m.month()];
        } else {
            return monthsShortDot[m.month()];
        }
    },
    monthsParseExact : true,
    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D [de] MMMM [de] YYYY',
        LLL : 'D [de] MMMM [de] YYYY H:mm',
        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
    },
    calendar : {
        sameDay : function () {
            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextDay : function () {
            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextWeek : function () {
            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastDay : function () {
            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastWeek : function () {
            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'en %s',
        past : 'hace %s',
        s : 'unos segundos',
        m : 'un minuto',
        mm : '%d minutos',
        h : 'una hora',
        hh : '%d horas',
        d : 'un día',
        dd : '%d días',
        M : 'un mes',
        MM : '%d meses',
        y : 'un año',
        yy : '%d años'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal : '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return es;

})));


/***/ }),

/***/ 1495:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish (Dominican Republic) [es-do]

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

var esDo = moment.defineLocale('es-do', {
    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortDot;
        } else if (/-MMM-/.test(format)) {
            return monthsShort[m.month()];
        } else {
            return monthsShortDot[m.month()];
        }
    },
    monthsParseExact : true,
    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D [de] MMMM [de] YYYY',
        LLL : 'D [de] MMMM [de] YYYY h:mm A',
        LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
    },
    calendar : {
        sameDay : function () {
            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextDay : function () {
            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        nextWeek : function () {
            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastDay : function () {
            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        lastWeek : function () {
            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'en %s',
        past : 'hace %s',
        s : 'unos segundos',
        m : 'un minuto',
        mm : '%d minutos',
        h : 'una hora',
        hh : '%d horas',
        d : 'un día',
        dd : '%d días',
        M : 'un mes',
        MM : '%d meses',
        y : 'un año',
        yy : '%d años'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal : '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return esDo;

})));


/***/ }),

/***/ 1496:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Estonian [et]
//! author : Henry Kehlmann : https://github.com/madhenry
//! improvements : Illimar Tambek : https://github.com/ragulka

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
        'm' : ['ühe minuti', 'üks minut'],
        'mm': [number + ' minuti', number + ' minutit'],
        'h' : ['ühe tunni', 'tund aega', 'üks tund'],
        'hh': [number + ' tunni', number + ' tundi'],
        'd' : ['ühe päeva', 'üks päev'],
        'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
        'MM': [number + ' kuu', number + ' kuud'],
        'y' : ['ühe aasta', 'aasta', 'üks aasta'],
        'yy': [number + ' aasta', number + ' aastat']
    };
    if (withoutSuffix) {
        return format[key][2] ? format[key][2] : format[key][1];
    }
    return isFuture ? format[key][0] : format[key][1];
}

var et = moment.defineLocale('et', {
    months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
    monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
    weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
    weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
    weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
    longDateFormat : {
        LT   : 'H:mm',
        LTS : 'H:mm:ss',
        L    : 'DD.MM.YYYY',
        LL   : 'D. MMMM YYYY',
        LLL  : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd, D. MMMM YYYY H:mm'
    },
    calendar : {
        sameDay  : '[Täna,] LT',
        nextDay  : '[Homme,] LT',
        nextWeek : '[Järgmine] dddd LT',
        lastDay  : '[Eile,] LT',
        lastWeek : '[Eelmine] dddd LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s pärast',
        past   : '%s tagasi',
        s      : processRelativeTime,
        m      : processRelativeTime,
        mm     : processRelativeTime,
        h      : processRelativeTime,
        hh     : processRelativeTime,
        d      : processRelativeTime,
        dd     : '%d päeva',
        M      : processRelativeTime,
        MM     : processRelativeTime,
        y      : processRelativeTime,
        yy     : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return et;

})));


/***/ }),

/***/ 1497:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Basque [eu]
//! author : Eneko Illarramendi : https://github.com/eillarra

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var eu = moment.defineLocale('eu', {
    months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
    monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
    monthsParseExact : true,
    weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
    weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
    weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY-MM-DD',
        LL : 'YYYY[ko] MMMM[ren] D[a]',
        LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
        LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
        l : 'YYYY-M-D',
        ll : 'YYYY[ko] MMM D[a]',
        lll : 'YYYY[ko] MMM D[a] HH:mm',
        llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
    },
    calendar : {
        sameDay : '[gaur] LT[etan]',
        nextDay : '[bihar] LT[etan]',
        nextWeek : 'dddd LT[etan]',
        lastDay : '[atzo] LT[etan]',
        lastWeek : '[aurreko] dddd LT[etan]',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s barru',
        past : 'duela %s',
        s : 'segundo batzuk',
        m : 'minutu bat',
        mm : '%d minutu',
        h : 'ordu bat',
        hh : '%d ordu',
        d : 'egun bat',
        dd : '%d egun',
        M : 'hilabete bat',
        MM : '%d hilabete',
        y : 'urte bat',
        yy : '%d urte'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return eu;

})));


/***/ }),

/***/ 1498:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Persian [fa]
//! author : Ebrahim Byagowi : https://github.com/ebraminio

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '۱',
    '2': '۲',
    '3': '۳',
    '4': '۴',
    '5': '۵',
    '6': '۶',
    '7': '۷',
    '8': '۸',
    '9': '۹',
    '0': '۰'
};
var numberMap = {
    '۱': '1',
    '۲': '2',
    '۳': '3',
    '۴': '4',
    '۵': '5',
    '۶': '6',
    '۷': '7',
    '۸': '8',
    '۹': '9',
    '۰': '0'
};

var fa = moment.defineLocale('fa', {
    months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
    monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
    weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
    weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
    weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    meridiemParse: /قبل از ظهر|بعد از ظهر/,
    isPM: function (input) {
        return /بعد از ظهر/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'قبل از ظهر';
        } else {
            return 'بعد از ظهر';
        }
    },
    calendar : {
        sameDay : '[امروز ساعت] LT',
        nextDay : '[فردا ساعت] LT',
        nextWeek : 'dddd [ساعت] LT',
        lastDay : '[دیروز ساعت] LT',
        lastWeek : 'dddd [پیش] [ساعت] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'در %s',
        past : '%s پیش',
        s : 'چند ثانیه',
        m : 'یک دقیقه',
        mm : '%d دقیقه',
        h : 'یک ساعت',
        hh : '%d ساعت',
        d : 'یک روز',
        dd : '%d روز',
        M : 'یک ماه',
        MM : '%d ماه',
        y : 'یک سال',
        yy : '%d سال'
    },
    preparse: function (string) {
        return string.replace(/[۰-۹]/g, function (match) {
            return numberMap[match];
        }).replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        }).replace(/,/g, '،');
    },
    dayOfMonthOrdinalParse: /\d{1,2}م/,
    ordinal : '%dم',
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12 // The week that contains Jan 1st is the first week of the year.
    }
});

return fa;

})));


/***/ }),

/***/ 1499:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Finnish [fi]
//! author : Tarmo Aidantausta : https://github.com/bleadof

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' ');
var numbersFuture = [
        'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
        numbersPast[7], numbersPast[8], numbersPast[9]
    ];
function translate(number, withoutSuffix, key, isFuture) {
    var result = '';
    switch (key) {
        case 's':
            return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
        case 'm':
            return isFuture ? 'minuutin' : 'minuutti';
        case 'mm':
            result = isFuture ? 'minuutin' : 'minuuttia';
            break;
        case 'h':
            return isFuture ? 'tunnin' : 'tunti';
        case 'hh':
            result = isFuture ? 'tunnin' : 'tuntia';
            break;
        case 'd':
            return isFuture ? 'päivän' : 'päivä';
        case 'dd':
            result = isFuture ? 'päivän' : 'päivää';
            break;
        case 'M':
            return isFuture ? 'kuukauden' : 'kuukausi';
        case 'MM':
            result = isFuture ? 'kuukauden' : 'kuukautta';
            break;
        case 'y':
            return isFuture ? 'vuoden' : 'vuosi';
        case 'yy':
            result = isFuture ? 'vuoden' : 'vuotta';
            break;
    }
    result = verbalNumber(number, isFuture) + ' ' + result;
    return result;
}
function verbalNumber(number, isFuture) {
    return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
}

var fi = moment.defineLocale('fi', {
    months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
    monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
    weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
    weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
    weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD.MM.YYYY',
        LL : 'Do MMMM[ta] YYYY',
        LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
        LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
        l : 'D.M.YYYY',
        ll : 'Do MMM YYYY',
        lll : 'Do MMM YYYY, [klo] HH.mm',
        llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
    },
    calendar : {
        sameDay : '[tänään] [klo] LT',
        nextDay : '[huomenna] [klo] LT',
        nextWeek : 'dddd [klo] LT',
        lastDay : '[eilen] [klo] LT',
        lastWeek : '[viime] dddd[na] [klo] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s päästä',
        past : '%s sitten',
        s : translate,
        m : translate,
        mm : translate,
        h : translate,
        hh : translate,
        d : translate,
        dd : translate,
        M : translate,
        MM : translate,
        y : translate,
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return fi;

})));


/***/ }),

/***/ 1500:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Faroese [fo]
//! author : Ragnar Johannesen : https://github.com/ragnar123

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var fo = moment.defineLocale('fo', {
    months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
    weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
    weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
    weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D. MMMM, YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Í dag kl.] LT',
        nextDay : '[Í morgin kl.] LT',
        nextWeek : 'dddd [kl.] LT',
        lastDay : '[Í gjár kl.] LT',
        lastWeek : '[síðstu] dddd [kl] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'um %s',
        past : '%s síðani',
        s : 'fá sekund',
        m : 'ein minutt',
        mm : '%d minuttir',
        h : 'ein tími',
        hh : '%d tímar',
        d : 'ein dagur',
        dd : '%d dagar',
        M : 'ein mánaði',
        MM : '%d mánaðir',
        y : 'eitt ár',
        yy : '%d ár'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return fo;

})));


/***/ }),

/***/ 1501:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French [fr]
//! author : John Fischer : https://github.com/jfroffice

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var fr = moment.defineLocale('fr', {
    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
    monthsParseExact : true,
    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Aujourd’hui à] LT',
        nextDay : '[Demain à] LT',
        nextWeek : 'dddd [à] LT',
        lastDay : '[Hier à] LT',
        lastWeek : 'dddd [dernier à] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dans %s',
        past : 'il y a %s',
        s : 'quelques secondes',
        m : 'une minute',
        mm : '%d minutes',
        h : 'une heure',
        hh : '%d heures',
        d : 'un jour',
        dd : '%d jours',
        M : 'un mois',
        MM : '%d mois',
        y : 'un an',
        yy : '%d ans'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
    ordinal : function (number, period) {
        switch (period) {
            // TODO: Return 'e' when day of month > 1. Move this case inside
            // block for masculine words below.
            // See https://github.com/moment/moment/issues/3375
            case 'D':
                return number + (number === 1 ? 'er' : '');

            // Words with masculine grammatical gender: mois, trimestre, jour
            default:
            case 'M':
            case 'Q':
            case 'DDD':
            case 'd':
                return number + (number === 1 ? 'er' : 'e');

            // Words with feminine grammatical gender: semaine
            case 'w':
            case 'W':
                return number + (number === 1 ? 're' : 'e');
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return fr;

})));


/***/ }),

/***/ 1502:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French (Canada) [fr-ca]
//! author : Jonathan Abourbih : https://github.com/jonbca

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var frCa = moment.defineLocale('fr-ca', {
    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
    monthsParseExact : true,
    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY-MM-DD',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Aujourd’hui à] LT',
        nextDay : '[Demain à] LT',
        nextWeek : 'dddd [à] LT',
        lastDay : '[Hier à] LT',
        lastWeek : 'dddd [dernier à] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dans %s',
        past : 'il y a %s',
        s : 'quelques secondes',
        m : 'une minute',
        mm : '%d minutes',
        h : 'une heure',
        hh : '%d heures',
        d : 'un jour',
        dd : '%d jours',
        M : 'un mois',
        MM : '%d mois',
        y : 'un an',
        yy : '%d ans'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
    ordinal : function (number, period) {
        switch (period) {
            // Words with masculine grammatical gender: mois, trimestre, jour
            default:
            case 'M':
            case 'Q':
            case 'D':
            case 'DDD':
            case 'd':
                return number + (number === 1 ? 'er' : 'e');

            // Words with feminine grammatical gender: semaine
            case 'w':
            case 'W':
                return number + (number === 1 ? 're' : 'e');
        }
    }
});

return frCa;

})));


/***/ }),

/***/ 1503:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French (Switzerland) [fr-ch]
//! author : Gaspard Bucher : https://github.com/gaspard

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var frCh = moment.defineLocale('fr-ch', {
    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
    monthsParseExact : true,
    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Aujourd’hui à] LT',
        nextDay : '[Demain à] LT',
        nextWeek : 'dddd [à] LT',
        lastDay : '[Hier à] LT',
        lastWeek : 'dddd [dernier à] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dans %s',
        past : 'il y a %s',
        s : 'quelques secondes',
        m : 'une minute',
        mm : '%d minutes',
        h : 'une heure',
        hh : '%d heures',
        d : 'un jour',
        dd : '%d jours',
        M : 'un mois',
        MM : '%d mois',
        y : 'un an',
        yy : '%d ans'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
    ordinal : function (number, period) {
        switch (period) {
            // Words with masculine grammatical gender: mois, trimestre, jour
            default:
            case 'M':
            case 'Q':
            case 'D':
            case 'DDD':
            case 'd':
                return number + (number === 1 ? 'er' : 'e');

            // Words with feminine grammatical gender: semaine
            case 'w':
            case 'W':
                return number + (number === 1 ? 're' : 'e');
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return frCh;

})));


/***/ }),

/***/ 1504:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Frisian [fy]
//! author : Robin van der Vliet : https://github.com/robin0van0der0v

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_');
var monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');

var fy = moment.defineLocale('fy', {
    months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortWithDots;
        } else if (/-MMM-/.test(format)) {
            return monthsShortWithoutDots[m.month()];
        } else {
            return monthsShortWithDots[m.month()];
        }
    },
    monthsParseExact : true,
    weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
    weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
    weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD-MM-YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[hjoed om] LT',
        nextDay: '[moarn om] LT',
        nextWeek: 'dddd [om] LT',
        lastDay: '[juster om] LT',
        lastWeek: '[ôfrûne] dddd [om] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'oer %s',
        past : '%s lyn',
        s : 'in pear sekonden',
        m : 'ien minút',
        mm : '%d minuten',
        h : 'ien oere',
        hh : '%d oeren',
        d : 'ien dei',
        dd : '%d dagen',
        M : 'ien moanne',
        MM : '%d moannen',
        y : 'ien jier',
        yy : '%d jierren'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
    ordinal : function (number) {
        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return fy;

})));


/***/ }),

/***/ 1505:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Scottish Gaelic [gd]
//! author : Jon Ashdown : https://github.com/jonashdown

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = [
    'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
];

var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];

var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];

var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];

var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];

var gd = moment.defineLocale('gd', {
    months : months,
    monthsShort : monthsShort,
    monthsParseExact : true,
    weekdays : weekdays,
    weekdaysShort : weekdaysShort,
    weekdaysMin : weekdaysMin,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[An-diugh aig] LT',
        nextDay : '[A-màireach aig] LT',
        nextWeek : 'dddd [aig] LT',
        lastDay : '[An-dè aig] LT',
        lastWeek : 'dddd [seo chaidh] [aig] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'ann an %s',
        past : 'bho chionn %s',
        s : 'beagan diogan',
        m : 'mionaid',
        mm : '%d mionaidean',
        h : 'uair',
        hh : '%d uairean',
        d : 'latha',
        dd : '%d latha',
        M : 'mìos',
        MM : '%d mìosan',
        y : 'bliadhna',
        yy : '%d bliadhna'
    },
    dayOfMonthOrdinalParse : /\d{1,2}(d|na|mh)/,
    ordinal : function (number) {
        var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return gd;

})));


/***/ }),

/***/ 1506:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Galician [gl]
//! author : Juan G. Hurtado : https://github.com/juanghurtado

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var gl = moment.defineLocale('gl', {
    months : 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
    monthsShort : 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
    monthsParseExact: true,
    weekdays : 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
    weekdaysShort : 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
    weekdaysMin : 'do_lu_ma_mé_xo_ve_sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D [de] MMMM [de] YYYY',
        LLL : 'D [de] MMMM [de] YYYY H:mm',
        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
    },
    calendar : {
        sameDay : function () {
            return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
        },
        nextDay : function () {
            return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
        },
        nextWeek : function () {
            return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
        },
        lastDay : function () {
            return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
        },
        lastWeek : function () {
            return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : function (str) {
            if (str.indexOf('un') === 0) {
                return 'n' + str;
            }
            return 'en ' + str;
        },
        past : 'hai %s',
        s : 'uns segundos',
        m : 'un minuto',
        mm : '%d minutos',
        h : 'unha hora',
        hh : '%d horas',
        d : 'un día',
        dd : '%d días',
        M : 'un mes',
        MM : '%d meses',
        y : 'un ano',
        yy : '%d anos'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal : '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return gl;

})));


/***/ }),

/***/ 1507:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Konkani Latin script [gom-latn]
//! author : The Discoverer : https://github.com/WikiDiscoverer

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        's': ['thodde secondanim', 'thodde second'],
        'm': ['eka mintan', 'ek minute'],
        'mm': [number + ' mintanim', number + ' mintam'],
        'h': ['eka horan', 'ek hor'],
        'hh': [number + ' horanim', number + ' hor'],
        'd': ['eka disan', 'ek dis'],
        'dd': [number + ' disanim', number + ' dis'],
        'M': ['eka mhoinean', 'ek mhoino'],
        'MM': [number + ' mhoineanim', number + ' mhoine'],
        'y': ['eka vorsan', 'ek voros'],
        'yy': [number + ' vorsanim', number + ' vorsam']
    };
    return withoutSuffix ? format[key][0] : format[key][1];
}

var gomLatn = moment.defineLocale('gom-latn', {
    months : 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split('_'),
    monthsShort : 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
    monthsParseExact : true,
    weekdays : 'Aitar_Somar_Mongllar_Budvar_Brestar_Sukrar_Son\'var'.split('_'),
    weekdaysShort : 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
    weekdaysMin : 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'A h:mm [vazta]',
        LTS : 'A h:mm:ss [vazta]',
        L : 'DD-MM-YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY A h:mm [vazta]',
        LLLL : 'dddd, MMMM[achea] Do, YYYY, A h:mm [vazta]',
        llll: 'ddd, D MMM YYYY, A h:mm [vazta]'
    },
    calendar : {
        sameDay: '[Aiz] LT',
        nextDay: '[Faleam] LT',
        nextWeek: '[Ieta to] dddd[,] LT',
        lastDay: '[Kal] LT',
        lastWeek: '[Fatlo] dddd[,] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : '%s',
        past : '%s adim',
        s : processRelativeTime,
        m : processRelativeTime,
        mm : processRelativeTime,
        h : processRelativeTime,
        hh : processRelativeTime,
        d : processRelativeTime,
        dd : processRelativeTime,
        M : processRelativeTime,
        MM : processRelativeTime,
        y : processRelativeTime,
        yy : processRelativeTime
    },
    dayOfMonthOrdinalParse : /\d{1,2}(er)/,
    ordinal : function (number, period) {
        switch (period) {
            // the ordinal 'er' only applies to day of the month
            case 'D':
                return number + 'er';
            default:
            case 'M':
            case 'Q':
            case 'DDD':
            case 'd':
            case 'w':
            case 'W':
                return number;
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    },
    meridiemParse: /rati|sokalli|donparam|sanje/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'rati') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'sokalli') {
            return hour;
        } else if (meridiem === 'donparam') {
            return hour > 12 ? hour : hour + 12;
        } else if (meridiem === 'sanje') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'rati';
        } else if (hour < 12) {
            return 'sokalli';
        } else if (hour < 16) {
            return 'donparam';
        } else if (hour < 20) {
            return 'sanje';
        } else {
            return 'rati';
        }
    }
});

return gomLatn;

})));


/***/ }),

/***/ 1508:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hebrew [he]
//! author : Tomer Cohen : https://github.com/tomer
//! author : Moshe Simantov : https://github.com/DevelopmentIL
//! author : Tal Ater : https://github.com/TalAter

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var he = moment.defineLocale('he', {
    months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
    monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
    weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
    weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
    weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D [ב]MMMM YYYY',
        LLL : 'D [ב]MMMM YYYY HH:mm',
        LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
        l : 'D/M/YYYY',
        ll : 'D MMM YYYY',
        lll : 'D MMM YYYY HH:mm',
        llll : 'ddd, D MMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[היום ב־]LT',
        nextDay : '[מחר ב־]LT',
        nextWeek : 'dddd [בשעה] LT',
        lastDay : '[אתמול ב־]LT',
        lastWeek : '[ביום] dddd [האחרון בשעה] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'בעוד %s',
        past : 'לפני %s',
        s : 'מספר שניות',
        m : 'דקה',
        mm : '%d דקות',
        h : 'שעה',
        hh : function (number) {
            if (number === 2) {
                return 'שעתיים';
            }
            return number + ' שעות';
        },
        d : 'יום',
        dd : function (number) {
            if (number === 2) {
                return 'יומיים';
            }
            return number + ' ימים';
        },
        M : 'חודש',
        MM : function (number) {
            if (number === 2) {
                return 'חודשיים';
            }
            return number + ' חודשים';
        },
        y : 'שנה',
        yy : function (number) {
            if (number === 2) {
                return 'שנתיים';
            } else if (number % 10 === 0 && number !== 10) {
                return number + ' שנה';
            }
            return number + ' שנים';
        }
    },
    meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
    isPM : function (input) {
        return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 5) {
            return 'לפנות בוקר';
        } else if (hour < 10) {
            return 'בבוקר';
        } else if (hour < 12) {
            return isLower ? 'לפנה"צ' : 'לפני הצהריים';
        } else if (hour < 18) {
            return isLower ? 'אחה"צ' : 'אחרי הצהריים';
        } else {
            return 'בערב';
        }
    }
});

return he;

})));


/***/ }),

/***/ 1509:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hindi [hi]
//! author : Mayank Singhal : https://github.com/mayanksinghal

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '१',
    '2': '२',
    '3': '३',
    '4': '४',
    '5': '५',
    '6': '६',
    '7': '७',
    '8': '८',
    '9': '९',
    '0': '०'
};
var numberMap = {
    '१': '1',
    '२': '2',
    '३': '3',
    '४': '4',
    '५': '5',
    '६': '6',
    '७': '7',
    '८': '8',
    '९': '9',
    '०': '0'
};

var hi = moment.defineLocale('hi', {
    months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
    monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
    monthsParseExact: true,
    weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
    weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
    longDateFormat : {
        LT : 'A h:mm बजे',
        LTS : 'A h:mm:ss बजे',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm बजे',
        LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
    },
    calendar : {
        sameDay : '[आज] LT',
        nextDay : '[कल] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[कल] LT',
        lastWeek : '[पिछले] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s में',
        past : '%s पहले',
        s : 'कुछ ही क्षण',
        m : 'एक मिनट',
        mm : '%d मिनट',
        h : 'एक घंटा',
        hh : '%d घंटे',
        d : 'एक दिन',
        dd : '%d दिन',
        M : 'एक महीने',
        MM : '%d महीने',
        y : 'एक वर्ष',
        yy : '%d वर्ष'
    },
    preparse: function (string) {
        return string.replace(/[१२३४५६७८९०]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    // Hindi notation for meridiems are quite fuzzy in practice. While there exists
    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
    meridiemParse: /रात|सुबह|दोपहर|शाम/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'रात') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'सुबह') {
            return hour;
        } else if (meridiem === 'दोपहर') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'शाम') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'रात';
        } else if (hour < 10) {
            return 'सुबह';
        } else if (hour < 17) {
            return 'दोपहर';
        } else if (hour < 20) {
            return 'शाम';
        } else {
            return 'रात';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return hi;

})));


/***/ }),

/***/ 1510:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Croatian [hr]
//! author : Bojan Marković : https://github.com/bmarkovic

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function translate(number, withoutSuffix, key) {
    var result = number + ' ';
    switch (key) {
        case 'm':
            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
        case 'mm':
            if (number === 1) {
                result += 'minuta';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'minute';
            } else {
                result += 'minuta';
            }
            return result;
        case 'h':
            return withoutSuffix ? 'jedan sat' : 'jednog sata';
        case 'hh':
            if (number === 1) {
                result += 'sat';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'sata';
            } else {
                result += 'sati';
            }
            return result;
        case 'dd':
            if (number === 1) {
                result += 'dan';
            } else {
                result += 'dana';
            }
            return result;
        case 'MM':
            if (number === 1) {
                result += 'mjesec';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'mjeseca';
            } else {
                result += 'mjeseci';
            }
            return result;
        case 'yy':
            if (number === 1) {
                result += 'godina';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'godine';
            } else {
                result += 'godina';
            }
            return result;
    }
}

var hr = moment.defineLocale('hr', {
    months : {
        format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
        standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
    },
    monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
    monthsParseExact: true,
    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd, D. MMMM YYYY H:mm'
    },
    calendar : {
        sameDay  : '[danas u] LT',
        nextDay  : '[sutra u] LT',
        nextWeek : function () {
            switch (this.day()) {
                case 0:
                    return '[u] [nedjelju] [u] LT';
                case 3:
                    return '[u] [srijedu] [u] LT';
                case 6:
                    return '[u] [subotu] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[u] dddd [u] LT';
            }
        },
        lastDay  : '[jučer u] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 0:
                case 3:
                    return '[prošlu] dddd [u] LT';
                case 6:
                    return '[prošle] [subote] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[prošli] dddd [u] LT';
            }
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'za %s',
        past   : 'prije %s',
        s      : 'par sekundi',
        m      : translate,
        mm     : translate,
        h      : translate,
        hh     : translate,
        d      : 'dan',
        dd     : translate,
        M      : 'mjesec',
        MM     : translate,
        y      : 'godinu',
        yy     : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return hr;

})));


/***/ }),

/***/ 1511:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hungarian [hu]
//! author : Adam Brunner : https://github.com/adambrunner

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
function translate(number, withoutSuffix, key, isFuture) {
    var num = number,
        suffix;
    switch (key) {
        case 's':
            return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
        case 'm':
            return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
        case 'mm':
            return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
        case 'h':
            return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
        case 'hh':
            return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
        case 'd':
            return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
        case 'dd':
            return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
        case 'M':
            return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
        case 'MM':
            return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
        case 'y':
            return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
        case 'yy':
            return num + (isFuture || withoutSuffix ? ' év' : ' éve');
    }
    return '';
}
function week(isFuture) {
    return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
}

var hu = moment.defineLocale('hu', {
    months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
    monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
    weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
    weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
    weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'YYYY.MM.DD.',
        LL : 'YYYY. MMMM D.',
        LLL : 'YYYY. MMMM D. H:mm',
        LLLL : 'YYYY. MMMM D., dddd H:mm'
    },
    meridiemParse: /de|du/i,
    isPM: function (input) {
        return input.charAt(1).toLowerCase() === 'u';
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 12) {
            return isLower === true ? 'de' : 'DE';
        } else {
            return isLower === true ? 'du' : 'DU';
        }
    },
    calendar : {
        sameDay : '[ma] LT[-kor]',
        nextDay : '[holnap] LT[-kor]',
        nextWeek : function () {
            return week.call(this, true);
        },
        lastDay : '[tegnap] LT[-kor]',
        lastWeek : function () {
            return week.call(this, false);
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s múlva',
        past : '%s',
        s : translate,
        m : translate,
        mm : translate,
        h : translate,
        hh : translate,
        d : translate,
        dd : translate,
        M : translate,
        MM : translate,
        y : translate,
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return hu;

})));


/***/ }),

/***/ 1512:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Armenian [hy-am]
//! author : Armendarabyan : https://github.com/armendarabyan

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var hyAm = moment.defineLocale('hy-am', {
    months : {
        format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
        standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
    },
    monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
    weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
    weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
    weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY թ.',
        LLL : 'D MMMM YYYY թ., HH:mm',
        LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
    },
    calendar : {
        sameDay: '[այսօր] LT',
        nextDay: '[վաղը] LT',
        lastDay: '[երեկ] LT',
        nextWeek: function () {
            return 'dddd [օրը ժամը] LT';
        },
        lastWeek: function () {
            return '[անցած] dddd [օրը ժամը] LT';
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : '%s հետո',
        past : '%s առաջ',
        s : 'մի քանի վայրկյան',
        m : 'րոպե',
        mm : '%d րոպե',
        h : 'ժամ',
        hh : '%d ժամ',
        d : 'օր',
        dd : '%d օր',
        M : 'ամիս',
        MM : '%d ամիս',
        y : 'տարի',
        yy : '%d տարի'
    },
    meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
    isPM: function (input) {
        return /^(ցերեկվա|երեկոյան)$/.test(input);
    },
    meridiem : function (hour) {
        if (hour < 4) {
            return 'գիշերվա';
        } else if (hour < 12) {
            return 'առավոտվա';
        } else if (hour < 17) {
            return 'ցերեկվա';
        } else {
            return 'երեկոյան';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
    ordinal: function (number, period) {
        switch (period) {
            case 'DDD':
            case 'w':
            case 'W':
            case 'DDDo':
                if (number === 1) {
                    return number + '-ին';
                }
                return number + '-րդ';
            default:
                return number;
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return hyAm;

})));


/***/ }),

/***/ 1513:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Indonesian [id]
//! author : Mohammad Satrio Utomo : https://github.com/tyok
//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var id = moment.defineLocale('id', {
    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nov_Des'.split('_'),
    weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
    weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY [pukul] HH.mm',
        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
    },
    meridiemParse: /pagi|siang|sore|malam/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'pagi') {
            return hour;
        } else if (meridiem === 'siang') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === 'sore' || meridiem === 'malam') {
            return hour + 12;
        }
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 11) {
            return 'pagi';
        } else if (hours < 15) {
            return 'siang';
        } else if (hours < 19) {
            return 'sore';
        } else {
            return 'malam';
        }
    },
    calendar : {
        sameDay : '[Hari ini pukul] LT',
        nextDay : '[Besok pukul] LT',
        nextWeek : 'dddd [pukul] LT',
        lastDay : '[Kemarin pukul] LT',
        lastWeek : 'dddd [lalu pukul] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dalam %s',
        past : '%s yang lalu',
        s : 'beberapa detik',
        m : 'semenit',
        mm : '%d menit',
        h : 'sejam',
        hh : '%d jam',
        d : 'sehari',
        dd : '%d hari',
        M : 'sebulan',
        MM : '%d bulan',
        y : 'setahun',
        yy : '%d tahun'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return id;

})));


/***/ }),

/***/ 1514:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Icelandic [is]
//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function plural(n) {
    if (n % 100 === 11) {
        return true;
    } else if (n % 10 === 1) {
        return false;
    }
    return true;
}
function translate(number, withoutSuffix, key, isFuture) {
    var result = number + ' ';
    switch (key) {
        case 's':
            return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
        case 'm':
            return withoutSuffix ? 'mínúta' : 'mínútu';
        case 'mm':
            if (plural(number)) {
                return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
            } else if (withoutSuffix) {
                return result + 'mínúta';
            }
            return result + 'mínútu';
        case 'hh':
            if (plural(number)) {
                return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
            }
            return result + 'klukkustund';
        case 'd':
            if (withoutSuffix) {
                return 'dagur';
            }
            return isFuture ? 'dag' : 'degi';
        case 'dd':
            if (plural(number)) {
                if (withoutSuffix) {
                    return result + 'dagar';
                }
                return result + (isFuture ? 'daga' : 'dögum');
            } else if (withoutSuffix) {
                return result + 'dagur';
            }
            return result + (isFuture ? 'dag' : 'degi');
        case 'M':
            if (withoutSuffix) {
                return 'mánuður';
            }
            return isFuture ? 'mánuð' : 'mánuði';
        case 'MM':
            if (plural(number)) {
                if (withoutSuffix) {
                    return result + 'mánuðir';
                }
                return result + (isFuture ? 'mánuði' : 'mánuðum');
            } else if (withoutSuffix) {
                return result + 'mánuður';
            }
            return result + (isFuture ? 'mánuð' : 'mánuði');
        case 'y':
            return withoutSuffix || isFuture ? 'ár' : 'ári';
        case 'yy':
            if (plural(number)) {
                return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
            }
            return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
    }
}

var is = moment.defineLocale('is', {
    months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
    monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
    weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
    weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
    weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY [kl.] H:mm',
        LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
    },
    calendar : {
        sameDay : '[í dag kl.] LT',
        nextDay : '[á morgun kl.] LT',
        nextWeek : 'dddd [kl.] LT',
        lastDay : '[í gær kl.] LT',
        lastWeek : '[síðasta] dddd [kl.] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'eftir %s',
        past : 'fyrir %s síðan',
        s : translate,
        m : translate,
        mm : translate,
        h : 'klukkustund',
        hh : translate,
        d : translate,
        dd : translate,
        M : translate,
        MM : translate,
        y : translate,
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return is;

})));


/***/ }),

/***/ 1515:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Italian [it]
//! author : Lorenzo : https://github.com/aliem
//! author: Mattia Larentis: https://github.com/nostalgiaz

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var it = moment.defineLocale('it', {
    months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
    monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
    weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
    weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
    weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Oggi alle] LT',
        nextDay: '[Domani alle] LT',
        nextWeek: 'dddd [alle] LT',
        lastDay: '[Ieri alle] LT',
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[la scorsa] dddd [alle] LT';
                default:
                    return '[lo scorso] dddd [alle] LT';
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : function (s) {
            return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
        },
        past : '%s fa',
        s : 'alcuni secondi',
        m : 'un minuto',
        mm : '%d minuti',
        h : 'un\'ora',
        hh : '%d ore',
        d : 'un giorno',
        dd : '%d giorni',
        M : 'un mese',
        MM : '%d mesi',
        y : 'un anno',
        yy : '%d anni'
    },
    dayOfMonthOrdinalParse : /\d{1,2}º/,
    ordinal: '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return it;

})));


/***/ }),

/***/ 1516:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Japanese [ja]
//! author : LI Long : https://github.com/baryon

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ja = moment.defineLocale('ja', {
    months : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
    weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
    weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY/MM/DD',
        LL : 'YYYY年M月D日',
        LLL : 'YYYY年M月D日 HH:mm',
        LLLL : 'YYYY年M月D日 HH:mm dddd',
        l : 'YYYY/MM/DD',
        ll : 'YYYY年M月D日',
        lll : 'YYYY年M月D日 HH:mm',
        llll : 'YYYY年M月D日 HH:mm dddd'
    },
    meridiemParse: /午前|午後/i,
    isPM : function (input) {
        return input === '午後';
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return '午前';
        } else {
            return '午後';
        }
    },
    calendar : {
        sameDay : '[今日] LT',
        nextDay : '[明日] LT',
        nextWeek : '[来週]dddd LT',
        lastDay : '[昨日] LT',
        lastWeek : '[前週]dddd LT',
        sameElse : 'L'
    },
    dayOfMonthOrdinalParse : /\d{1,2}日/,
    ordinal : function (number, period) {
        switch (period) {
            case 'd':
            case 'D':
            case 'DDD':
                return number + '日';
            default:
                return number;
        }
    },
    relativeTime : {
        future : '%s後',
        past : '%s前',
        s : '数秒',
        m : '1分',
        mm : '%d分',
        h : '1時間',
        hh : '%d時間',
        d : '1日',
        dd : '%d日',
        M : '1ヶ月',
        MM : '%dヶ月',
        y : '1年',
        yy : '%d年'
    }
});

return ja;

})));


/***/ }),

/***/ 1517:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Javanese [jv]
//! author : Rony Lantip : https://github.com/lantip
//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var jv = moment.defineLocale('jv', {
    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
    weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
    weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY [pukul] HH.mm',
        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
    },
    meridiemParse: /enjing|siyang|sonten|ndalu/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'enjing') {
            return hour;
        } else if (meridiem === 'siyang') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
            return hour + 12;
        }
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 11) {
            return 'enjing';
        } else if (hours < 15) {
            return 'siyang';
        } else if (hours < 19) {
            return 'sonten';
        } else {
            return 'ndalu';
        }
    },
    calendar : {
        sameDay : '[Dinten puniko pukul] LT',
        nextDay : '[Mbenjang pukul] LT',
        nextWeek : 'dddd [pukul] LT',
        lastDay : '[Kala wingi pukul] LT',
        lastWeek : 'dddd [kepengker pukul] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'wonten ing %s',
        past : '%s ingkang kepengker',
        s : 'sawetawis detik',
        m : 'setunggal menit',
        mm : '%d menit',
        h : 'setunggal jam',
        hh : '%d jam',
        d : 'sedinten',
        dd : '%d dinten',
        M : 'sewulan',
        MM : '%d wulan',
        y : 'setaun',
        yy : '%d taun'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return jv;

})));


/***/ }),

/***/ 1518:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Georgian [ka]
//! author : Irakli Janiashvili : https://github.com/irakli-janiashvili

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ka = moment.defineLocale('ka', {
    months : {
        standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
        format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
    },
    monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
    weekdays : {
        standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
        format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
        isFormat: /(წინა|შემდეგ)/
    },
    weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
    weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendar : {
        sameDay : '[დღეს] LT[-ზე]',
        nextDay : '[ხვალ] LT[-ზე]',
        lastDay : '[გუშინ] LT[-ზე]',
        nextWeek : '[შემდეგ] dddd LT[-ზე]',
        lastWeek : '[წინა] dddd LT-ზე',
        sameElse : 'L'
    },
    relativeTime : {
        future : function (s) {
            return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
                s.replace(/ი$/, 'ში') :
                s + 'ში';
        },
        past : function (s) {
            if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
                return s.replace(/(ი|ე)$/, 'ის უკან');
            }
            if ((/წელი/).test(s)) {
                return s.replace(/წელი$/, 'წლის უკან');
            }
        },
        s : 'რამდენიმე წამი',
        m : 'წუთი',
        mm : '%d წუთი',
        h : 'საათი',
        hh : '%d საათი',
        d : 'დღე',
        dd : '%d დღე',
        M : 'თვე',
        MM : '%d თვე',
        y : 'წელი',
        yy : '%d წელი'
    },
    dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
    ordinal : function (number) {
        if (number === 0) {
            return number;
        }
        if (number === 1) {
            return number + '-ლი';
        }
        if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
            return 'მე-' + number;
        }
        return number + '-ე';
    },
    week : {
        dow : 1,
        doy : 7
    }
});

return ka;

})));


/***/ }),

/***/ 1519:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kazakh [kk]
//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var suffixes = {
    0: '-ші',
    1: '-ші',
    2: '-ші',
    3: '-ші',
    4: '-ші',
    5: '-ші',
    6: '-шы',
    7: '-ші',
    8: '-ші',
    9: '-шы',
    10: '-шы',
    20: '-шы',
    30: '-шы',
    40: '-шы',
    50: '-ші',
    60: '-шы',
    70: '-ші',
    80: '-ші',
    90: '-шы',
    100: '-ші'
};

var kk = moment.defineLocale('kk', {
    months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
    monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
    weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
    weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
    weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Бүгін сағат] LT',
        nextDay : '[Ертең сағат] LT',
        nextWeek : 'dddd [сағат] LT',
        lastDay : '[Кеше сағат] LT',
        lastWeek : '[Өткен аптаның] dddd [сағат] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s ішінде',
        past : '%s бұрын',
        s : 'бірнеше секунд',
        m : 'бір минут',
        mm : '%d минут',
        h : 'бір сағат',
        hh : '%d сағат',
        d : 'бір күн',
        dd : '%d күн',
        M : 'бір ай',
        MM : '%d ай',
        y : 'бір жыл',
        yy : '%d жыл'
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
    ordinal : function (number) {
        var a = number % 10,
            b = number >= 100 ? 100 : null;
        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return kk;

})));


/***/ }),

/***/ 1520:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Cambodian [km]
//! author : Kruy Vanna : https://github.com/kruyvanna

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var km = moment.defineLocale('km', {
    months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
    monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
    weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
    weekdaysShort: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
    weekdaysMin: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
    longDateFormat: {
        LT: 'HH:mm',
        LTS : 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd, D MMMM YYYY HH:mm'
    },
    calendar: {
        sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
        nextDay: '[ស្អែក ម៉ោង] LT',
        nextWeek: 'dddd [ម៉ោង] LT',
        lastDay: '[ម្សិលមិញ ម៉ោង] LT',
        lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
        sameElse: 'L'
    },
    relativeTime: {
        future: '%sទៀត',
        past: '%sមុន',
        s: 'ប៉ុន្មានវិនាទី',
        m: 'មួយនាទី',
        mm: '%d នាទី',
        h: 'មួយម៉ោង',
        hh: '%d ម៉ោង',
        d: 'មួយថ្ងៃ',
        dd: '%d ថ្ងៃ',
        M: 'មួយខែ',
        MM: '%d ខែ',
        y: 'មួយឆ្នាំ',
        yy: '%d ឆ្នាំ'
    },
    week: {
        dow: 1, // Monday is the first day of the week.
        doy: 4 // The week that contains Jan 4th is the first week of the year.
    }
});

return km;

})));


/***/ }),

/***/ 1521:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kannada [kn]
//! author : Rajeev Naik : https://github.com/rajeevnaikte

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '೧',
    '2': '೨',
    '3': '೩',
    '4': '೪',
    '5': '೫',
    '6': '೬',
    '7': '೭',
    '8': '೮',
    '9': '೯',
    '0': '೦'
};
var numberMap = {
    '೧': '1',
    '೨': '2',
    '೩': '3',
    '೪': '4',
    '೫': '5',
    '೬': '6',
    '೭': '7',
    '೮': '8',
    '೯': '9',
    '೦': '0'
};

var kn = moment.defineLocale('kn', {
    months : 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split('_'),
    monthsShort : 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬ_ಅಕ್ಟೋಬ_ನವೆಂಬ_ಡಿಸೆಂಬ'.split('_'),
    monthsParseExact: true,
    weekdays : 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split('_'),
    weekdaysShort : 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
    weekdaysMin : 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
    longDateFormat : {
        LT : 'A h:mm',
        LTS : 'A h:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm',
        LLLL : 'dddd, D MMMM YYYY, A h:mm'
    },
    calendar : {
        sameDay : '[ಇಂದು] LT',
        nextDay : '[ನಾಳೆ] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[ನಿನ್ನೆ] LT',
        lastWeek : '[ಕೊನೆಯ] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s ನಂತರ',
        past : '%s ಹಿಂದೆ',
        s : 'ಕೆಲವು ಕ್ಷಣಗಳು',
        m : 'ಒಂದು ನಿಮಿಷ',
        mm : '%d ನಿಮಿಷ',
        h : 'ಒಂದು ಗಂಟೆ',
        hh : '%d ಗಂಟೆ',
        d : 'ಒಂದು ದಿನ',
        dd : '%d ದಿನ',
        M : 'ಒಂದು ತಿಂಗಳು',
        MM : '%d ತಿಂಗಳು',
        y : 'ಒಂದು ವರ್ಷ',
        yy : '%d ವರ್ಷ'
    },
    preparse: function (string) {
        return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'ರಾತ್ರಿ') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
            return hour;
        } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'ಸಂಜೆ') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'ರಾತ್ರಿ';
        } else if (hour < 10) {
            return 'ಬೆಳಿಗ್ಗೆ';
        } else if (hour < 17) {
            return 'ಮಧ್ಯಾಹ್ನ';
        } else if (hour < 20) {
            return 'ಸಂಜೆ';
        } else {
            return 'ರಾತ್ರಿ';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
    ordinal : function (number) {
        return number + 'ನೇ';
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return kn;

})));


/***/ }),

/***/ 1522:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Korean [ko]
//! author : Kyungwook, Park : https://github.com/kyungw00k
//! author : Jeeeyul Lee <jeeeyul@gmail.com>

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ko = moment.defineLocale('ko', {
    months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
    monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
    weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
    weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
    weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
    longDateFormat : {
        LT : 'A h:mm',
        LTS : 'A h:mm:ss',
        L : 'YYYY.MM.DD',
        LL : 'YYYY년 MMMM D일',
        LLL : 'YYYY년 MMMM D일 A h:mm',
        LLLL : 'YYYY년 MMMM D일 dddd A h:mm',
        l : 'YYYY.MM.DD',
        ll : 'YYYY년 MMMM D일',
        lll : 'YYYY년 MMMM D일 A h:mm',
        llll : 'YYYY년 MMMM D일 dddd A h:mm'
    },
    calendar : {
        sameDay : '오늘 LT',
        nextDay : '내일 LT',
        nextWeek : 'dddd LT',
        lastDay : '어제 LT',
        lastWeek : '지난주 dddd LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s 후',
        past : '%s 전',
        s : '몇 초',
        ss : '%d초',
        m : '1분',
        mm : '%d분',
        h : '한 시간',
        hh : '%d시간',
        d : '하루',
        dd : '%d일',
        M : '한 달',
        MM : '%d달',
        y : '일 년',
        yy : '%d년'
    },
    dayOfMonthOrdinalParse : /\d{1,2}일/,
    ordinal : '%d일',
    meridiemParse : /오전|오후/,
    isPM : function (token) {
        return token === '오후';
    },
    meridiem : function (hour, minute, isUpper) {
        return hour < 12 ? '오전' : '오후';
    }
});

return ko;

})));


/***/ }),

/***/ 1523:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kyrgyz [ky]
//! author : Chyngyz Arystan uulu : https://github.com/chyngyz

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';



var suffixes = {
    0: '-чү',
    1: '-чи',
    2: '-чи',
    3: '-чү',
    4: '-чү',
    5: '-чи',
    6: '-чы',
    7: '-чи',
    8: '-чи',
    9: '-чу',
    10: '-чу',
    20: '-чы',
    30: '-чу',
    40: '-чы',
    50: '-чү',
    60: '-чы',
    70: '-чи',
    80: '-чи',
    90: '-чу',
    100: '-чү'
};

var ky = moment.defineLocale('ky', {
    months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
    monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
    weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
    weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
    weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Бүгүн саат] LT',
        nextDay : '[Эртең саат] LT',
        nextWeek : 'dddd [саат] LT',
        lastDay : '[Кече саат] LT',
        lastWeek : '[Өткен аптанын] dddd [күнү] [саат] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s ичинде',
        past : '%s мурун',
        s : 'бирнече секунд',
        m : 'бир мүнөт',
        mm : '%d мүнөт',
        h : 'бир саат',
        hh : '%d саат',
        d : 'бир күн',
        dd : '%d күн',
        M : 'бир ай',
        MM : '%d ай',
        y : 'бир жыл',
        yy : '%d жыл'
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
    ordinal : function (number) {
        var a = number % 10,
            b = number >= 100 ? 100 : null;
        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return ky;

})));


/***/ }),

/***/ 1524:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Luxembourgish [lb]
//! author : mweimerskirch : https://github.com/mweimerskirch
//! author : David Raison : https://github.com/kwisatz

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        'm': ['eng Minutt', 'enger Minutt'],
        'h': ['eng Stonn', 'enger Stonn'],
        'd': ['een Dag', 'engem Dag'],
        'M': ['ee Mount', 'engem Mount'],
        'y': ['ee Joer', 'engem Joer']
    };
    return withoutSuffix ? format[key][0] : format[key][1];
}
function processFutureTime(string) {
    var number = string.substr(0, string.indexOf(' '));
    if (eifelerRegelAppliesToNumber(number)) {
        return 'a ' + string;
    }
    return 'an ' + string;
}
function processPastTime(string) {
    var number = string.substr(0, string.indexOf(' '));
    if (eifelerRegelAppliesToNumber(number)) {
        return 'viru ' + string;
    }
    return 'virun ' + string;
}
/**
 * Returns true if the word before the given number loses the '-n' ending.
 * e.g. 'an 10 Deeg' but 'a 5 Deeg'
 *
 * @param number {integer}
 * @returns {boolean}
 */
function eifelerRegelAppliesToNumber(number) {
    number = parseInt(number, 10);
    if (isNaN(number)) {
        return false;
    }
    if (number < 0) {
        // Negative Number --> always true
        return true;
    } else if (number < 10) {
        // Only 1 digit
        if (4 <= number && number <= 7) {
            return true;
        }
        return false;
    } else if (number < 100) {
        // 2 digits
        var lastDigit = number % 10, firstDigit = number / 10;
        if (lastDigit === 0) {
            return eifelerRegelAppliesToNumber(firstDigit);
        }
        return eifelerRegelAppliesToNumber(lastDigit);
    } else if (number < 10000) {
        // 3 or 4 digits --> recursively check first digit
        while (number >= 10) {
            number = number / 10;
        }
        return eifelerRegelAppliesToNumber(number);
    } else {
        // Anything larger than 4 digits: recursively check first n-3 digits
        number = number / 1000;
        return eifelerRegelAppliesToNumber(number);
    }
}

var lb = moment.defineLocale('lb', {
    months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
    monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
    monthsParseExact : true,
    weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
    weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
    weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat: {
        LT: 'H:mm [Auer]',
        LTS: 'H:mm:ss [Auer]',
        L: 'DD.MM.YYYY',
        LL: 'D. MMMM YYYY',
        LLL: 'D. MMMM YYYY H:mm [Auer]',
        LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
    },
    calendar: {
        sameDay: '[Haut um] LT',
        sameElse: 'L',
        nextDay: '[Muer um] LT',
        nextWeek: 'dddd [um] LT',
        lastDay: '[Gëschter um] LT',
        lastWeek: function () {
            // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
            switch (this.day()) {
                case 2:
                case 4:
                    return '[Leschten] dddd [um] LT';
                default:
                    return '[Leschte] dddd [um] LT';
            }
        }
    },
    relativeTime : {
        future : processFutureTime,
        past : processPastTime,
        s : 'e puer Sekonnen',
        m : processRelativeTime,
        mm : '%d Minutten',
        h : processRelativeTime,
        hh : '%d Stonnen',
        d : processRelativeTime,
        dd : '%d Deeg',
        M : processRelativeTime,
        MM : '%d Méint',
        y : processRelativeTime,
        yy : '%d Joer'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal: '%d.',
    week: {
        dow: 1, // Monday is the first day of the week.
        doy: 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return lb;

})));


/***/ }),

/***/ 1525:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Lao [lo]
//! author : Ryan Hart : https://github.com/ryanhart2

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var lo = moment.defineLocale('lo', {
    months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
    monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
    weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
    weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
    weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
    },
    meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
    isPM: function (input) {
        return input === 'ຕອນແລງ';
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'ຕອນເຊົ້າ';
        } else {
            return 'ຕອນແລງ';
        }
    },
    calendar : {
        sameDay : '[ມື້ນີ້ເວລາ] LT',
        nextDay : '[ມື້ອື່ນເວລາ] LT',
        nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
        lastDay : '[ມື້ວານນີ້ເວລາ] LT',
        lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'ອີກ %s',
        past : '%sຜ່ານມາ',
        s : 'ບໍ່ເທົ່າໃດວິນາທີ',
        m : '1 ນາທີ',
        mm : '%d ນາທີ',
        h : '1 ຊົ່ວໂມງ',
        hh : '%d ຊົ່ວໂມງ',
        d : '1 ມື້',
        dd : '%d ມື້',
        M : '1 ເດືອນ',
        MM : '%d ເດືອນ',
        y : '1 ປີ',
        yy : '%d ປີ'
    },
    dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
    ordinal : function (number) {
        return 'ທີ່' + number;
    }
});

return lo;

})));


/***/ }),

/***/ 1526:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Lithuanian [lt]
//! author : Mindaugas Mozūras : https://github.com/mmozuras

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var units = {
    'm' : 'minutė_minutės_minutę',
    'mm': 'minutės_minučių_minutes',
    'h' : 'valanda_valandos_valandą',
    'hh': 'valandos_valandų_valandas',
    'd' : 'diena_dienos_dieną',
    'dd': 'dienos_dienų_dienas',
    'M' : 'mėnuo_mėnesio_mėnesį',
    'MM': 'mėnesiai_mėnesių_mėnesius',
    'y' : 'metai_metų_metus',
    'yy': 'metai_metų_metus'
};
function translateSeconds(number, withoutSuffix, key, isFuture) {
    if (withoutSuffix) {
        return 'kelios sekundės';
    } else {
        return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
    }
}
function translateSingular(number, withoutSuffix, key, isFuture) {
    return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
}
function special(number) {
    return number % 10 === 0 || (number > 10 && number < 20);
}
function forms(key) {
    return units[key].split('_');
}
function translate(number, withoutSuffix, key, isFuture) {
    var result = number + ' ';
    if (number === 1) {
        return result + translateSingular(number, withoutSuffix, key[0], isFuture);
    } else if (withoutSuffix) {
        return result + (special(number) ? forms(key)[1] : forms(key)[0]);
    } else {
        if (isFuture) {
            return result + forms(key)[1];
        } else {
            return result + (special(number) ? forms(key)[1] : forms(key)[2]);
        }
    }
}
var lt = moment.defineLocale('lt', {
    months : {
        format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
        standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
        isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
    },
    monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
    weekdays : {
        format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
        standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
        isFormat: /dddd HH:mm/
    },
    weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
    weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY-MM-DD',
        LL : 'YYYY [m.] MMMM D [d.]',
        LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
        LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
        l : 'YYYY-MM-DD',
        ll : 'YYYY [m.] MMMM D [d.]',
        lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
        llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
    },
    calendar : {
        sameDay : '[Šiandien] LT',
        nextDay : '[Rytoj] LT',
        nextWeek : 'dddd LT',
        lastDay : '[Vakar] LT',
        lastWeek : '[Praėjusį] dddd LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'po %s',
        past : 'prieš %s',
        s : translateSeconds,
        m : translateSingular,
        mm : translate,
        h : translateSingular,
        hh : translate,
        d : translateSingular,
        dd : translate,
        M : translateSingular,
        MM : translate,
        y : translateSingular,
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}-oji/,
    ordinal : function (number) {
        return number + '-oji';
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return lt;

})));


/***/ }),

/***/ 1527:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Latvian [lv]
//! author : Kristaps Karlsons : https://github.com/skakri
//! author : Jānis Elmeris : https://github.com/JanisE

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var units = {
    'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
    'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
    'h': 'stundas_stundām_stunda_stundas'.split('_'),
    'hh': 'stundas_stundām_stunda_stundas'.split('_'),
    'd': 'dienas_dienām_diena_dienas'.split('_'),
    'dd': 'dienas_dienām_diena_dienas'.split('_'),
    'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
    'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
    'y': 'gada_gadiem_gads_gadi'.split('_'),
    'yy': 'gada_gadiem_gads_gadi'.split('_')
};
/**
 * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
 */
function format(forms, number, withoutSuffix) {
    if (withoutSuffix) {
        // E.g. "21 minūte", "3 minūtes".
        return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
    } else {
        // E.g. "21 minūtes" as in "pēc 21 minūtes".
        // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
        return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
    }
}
function relativeTimeWithPlural(number, withoutSuffix, key) {
    return number + ' ' + format(units[key], number, withoutSuffix);
}
function relativeTimeWithSingular(number, withoutSuffix, key) {
    return format(units[key], number, withoutSuffix);
}
function relativeSeconds(number, withoutSuffix) {
    return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
}

var lv = moment.defineLocale('lv', {
    months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
    monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
    weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
    weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
    weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY.',
        LL : 'YYYY. [gada] D. MMMM',
        LLL : 'YYYY. [gada] D. MMMM, HH:mm',
        LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
    },
    calendar : {
        sameDay : '[Šodien pulksten] LT',
        nextDay : '[Rīt pulksten] LT',
        nextWeek : 'dddd [pulksten] LT',
        lastDay : '[Vakar pulksten] LT',
        lastWeek : '[Pagājušā] dddd [pulksten] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'pēc %s',
        past : 'pirms %s',
        s : relativeSeconds,
        m : relativeTimeWithSingular,
        mm : relativeTimeWithPlural,
        h : relativeTimeWithSingular,
        hh : relativeTimeWithPlural,
        d : relativeTimeWithSingular,
        dd : relativeTimeWithPlural,
        M : relativeTimeWithSingular,
        MM : relativeTimeWithPlural,
        y : relativeTimeWithSingular,
        yy : relativeTimeWithPlural
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return lv;

})));


/***/ }),

/***/ 1528:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Montenegrin [me]
//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var translator = {
    words: { //Different grammatical cases
        m: ['jedan minut', 'jednog minuta'],
        mm: ['minut', 'minuta', 'minuta'],
        h: ['jedan sat', 'jednog sata'],
        hh: ['sat', 'sata', 'sati'],
        dd: ['dan', 'dana', 'dana'],
        MM: ['mjesec', 'mjeseca', 'mjeseci'],
        yy: ['godina', 'godine', 'godina']
    },
    correctGrammaticalCase: function (number, wordKey) {
        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
    },
    translate: function (number, withoutSuffix, key) {
        var wordKey = translator.words[key];
        if (key.length === 1) {
            return withoutSuffix ? wordKey[0] : wordKey[1];
        } else {
            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
        }
    }
};

var me = moment.defineLocale('me', {
    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
    monthsParseExact : true,
    weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
    weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
    weekdaysParseExact : true,
    longDateFormat: {
        LT: 'H:mm',
        LTS : 'H:mm:ss',
        L: 'DD.MM.YYYY',
        LL: 'D. MMMM YYYY',
        LLL: 'D. MMMM YYYY H:mm',
        LLLL: 'dddd, D. MMMM YYYY H:mm'
    },
    calendar: {
        sameDay: '[danas u] LT',
        nextDay: '[sjutra u] LT',

        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[u] [nedjelju] [u] LT';
                case 3:
                    return '[u] [srijedu] [u] LT';
                case 6:
                    return '[u] [subotu] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[u] dddd [u] LT';
            }
        },
        lastDay  : '[juče u] LT',
        lastWeek : function () {
            var lastWeekDays = [
                '[prošle] [nedjelje] [u] LT',
                '[prošlog] [ponedjeljka] [u] LT',
                '[prošlog] [utorka] [u] LT',
                '[prošle] [srijede] [u] LT',
                '[prošlog] [četvrtka] [u] LT',
                '[prošlog] [petka] [u] LT',
                '[prošle] [subote] [u] LT'
            ];
            return lastWeekDays[this.day()];
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'za %s',
        past   : 'prije %s',
        s      : 'nekoliko sekundi',
        m      : translator.translate,
        mm     : translator.translate,
        h      : translator.translate,
        hh     : translator.translate,
        d      : 'dan',
        dd     : translator.translate,
        M      : 'mjesec',
        MM     : translator.translate,
        y      : 'godinu',
        yy     : translator.translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return me;

})));


/***/ }),

/***/ 1529:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maori [mi]
//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var mi = moment.defineLocale('mi', {
    months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
    monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
    monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
    monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
    monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
    monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
    weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
    weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
    weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
    longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY [i] HH:mm',
        LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
    },
    calendar: {
        sameDay: '[i teie mahana, i] LT',
        nextDay: '[apopo i] LT',
        nextWeek: 'dddd [i] LT',
        lastDay: '[inanahi i] LT',
        lastWeek: 'dddd [whakamutunga i] LT',
        sameElse: 'L'
    },
    relativeTime: {
        future: 'i roto i %s',
        past: '%s i mua',
        s: 'te hēkona ruarua',
        m: 'he meneti',
        mm: '%d meneti',
        h: 'te haora',
        hh: '%d haora',
        d: 'he ra',
        dd: '%d ra',
        M: 'he marama',
        MM: '%d marama',
        y: 'he tau',
        yy: '%d tau'
    },
    dayOfMonthOrdinalParse: /\d{1,2}º/,
    ordinal: '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return mi;

})));


/***/ }),

/***/ 1530:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Macedonian [mk]
//! author : Borislav Mickov : https://github.com/B0k0

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var mk = moment.defineLocale('mk', {
    months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
    monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
    weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
    weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
    weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'D.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY H:mm',
        LLLL : 'dddd, D MMMM YYYY H:mm'
    },
    calendar : {
        sameDay : '[Денес во] LT',
        nextDay : '[Утре во] LT',
        nextWeek : '[Во] dddd [во] LT',
        lastDay : '[Вчера во] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 0:
                case 3:
                case 6:
                    return '[Изминатата] dddd [во] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[Изминатиот] dddd [во] LT';
            }
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'после %s',
        past : 'пред %s',
        s : 'неколку секунди',
        m : 'минута',
        mm : '%d минути',
        h : 'час',
        hh : '%d часа',
        d : 'ден',
        dd : '%d дена',
        M : 'месец',
        MM : '%d месеци',
        y : 'година',
        yy : '%d години'
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
    ordinal : function (number) {
        var lastDigit = number % 10,
            last2Digits = number % 100;
        if (number === 0) {
            return number + '-ев';
        } else if (last2Digits === 0) {
            return number + '-ен';
        } else if (last2Digits > 10 && last2Digits < 20) {
            return number + '-ти';
        } else if (lastDigit === 1) {
            return number + '-ви';
        } else if (lastDigit === 2) {
            return number + '-ри';
        } else if (lastDigit === 7 || lastDigit === 8) {
            return number + '-ми';
        } else {
            return number + '-ти';
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return mk;

})));


/***/ }),

/***/ 1531:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malayalam [ml]
//! author : Floyd Pink : https://github.com/floydpink

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ml = moment.defineLocale('ml', {
    months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
    monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
    monthsParseExact : true,
    weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
    weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
    weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
    longDateFormat : {
        LT : 'A h:mm -നു',
        LTS : 'A h:mm:ss -നു',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm -നു',
        LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
    },
    calendar : {
        sameDay : '[ഇന്ന്] LT',
        nextDay : '[നാളെ] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[ഇന്നലെ] LT',
        lastWeek : '[കഴിഞ്ഞ] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s കഴിഞ്ഞ്',
        past : '%s മുൻപ്',
        s : 'അൽപ നിമിഷങ്ങൾ',
        m : 'ഒരു മിനിറ്റ്',
        mm : '%d മിനിറ്റ്',
        h : 'ഒരു മണിക്കൂർ',
        hh : '%d മണിക്കൂർ',
        d : 'ഒരു ദിവസം',
        dd : '%d ദിവസം',
        M : 'ഒരു മാസം',
        MM : '%d മാസം',
        y : 'ഒരു വർഷം',
        yy : '%d വർഷം'
    },
    meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if ((meridiem === 'രാത്രി' && hour >= 4) ||
                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
                meridiem === 'വൈകുന്നേരം') {
            return hour + 12;
        } else {
            return hour;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'രാത്രി';
        } else if (hour < 12) {
            return 'രാവിലെ';
        } else if (hour < 17) {
            return 'ഉച്ച കഴിഞ്ഞ്';
        } else if (hour < 20) {
            return 'വൈകുന്നേരം';
        } else {
            return 'രാത്രി';
        }
    }
});

return ml;

})));


/***/ }),

/***/ 1532:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Marathi [mr]
//! author : Harshad Kale : https://github.com/kalehv
//! author : Vivek Athalye : https://github.com/vnathalye

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '१',
    '2': '२',
    '3': '३',
    '4': '४',
    '5': '५',
    '6': '६',
    '7': '७',
    '8': '८',
    '9': '९',
    '0': '०'
};
var numberMap = {
    '१': '1',
    '२': '2',
    '३': '3',
    '४': '4',
    '५': '5',
    '६': '6',
    '७': '7',
    '८': '8',
    '९': '9',
    '०': '0'
};

function relativeTimeMr(number, withoutSuffix, string, isFuture)
{
    var output = '';
    if (withoutSuffix) {
        switch (string) {
            case 's': output = 'काही सेकंद'; break;
            case 'm': output = 'एक मिनिट'; break;
            case 'mm': output = '%d मिनिटे'; break;
            case 'h': output = 'एक तास'; break;
            case 'hh': output = '%d तास'; break;
            case 'd': output = 'एक दिवस'; break;
            case 'dd': output = '%d दिवस'; break;
            case 'M': output = 'एक महिना'; break;
            case 'MM': output = '%d महिने'; break;
            case 'y': output = 'एक वर्ष'; break;
            case 'yy': output = '%d वर्षे'; break;
        }
    }
    else {
        switch (string) {
            case 's': output = 'काही सेकंदां'; break;
            case 'm': output = 'एका मिनिटा'; break;
            case 'mm': output = '%d मिनिटां'; break;
            case 'h': output = 'एका तासा'; break;
            case 'hh': output = '%d तासां'; break;
            case 'd': output = 'एका दिवसा'; break;
            case 'dd': output = '%d दिवसां'; break;
            case 'M': output = 'एका महिन्या'; break;
            case 'MM': output = '%d महिन्यां'; break;
            case 'y': output = 'एका वर्षा'; break;
            case 'yy': output = '%d वर्षां'; break;
        }
    }
    return output.replace(/%d/i, number);
}

var mr = moment.defineLocale('mr', {
    months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
    monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
    monthsParseExact : true,
    weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
    weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
    longDateFormat : {
        LT : 'A h:mm वाजता',
        LTS : 'A h:mm:ss वाजता',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm वाजता',
        LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
    },
    calendar : {
        sameDay : '[आज] LT',
        nextDay : '[उद्या] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[काल] LT',
        lastWeek: '[मागील] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future: '%sमध्ये',
        past: '%sपूर्वी',
        s: relativeTimeMr,
        m: relativeTimeMr,
        mm: relativeTimeMr,
        h: relativeTimeMr,
        hh: relativeTimeMr,
        d: relativeTimeMr,
        dd: relativeTimeMr,
        M: relativeTimeMr,
        MM: relativeTimeMr,
        y: relativeTimeMr,
        yy: relativeTimeMr
    },
    preparse: function (string) {
        return string.replace(/[१२३४५६७८९०]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'रात्री') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'सकाळी') {
            return hour;
        } else if (meridiem === 'दुपारी') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'सायंकाळी') {
            return hour + 12;
        }
    },
    meridiem: function (hour, minute, isLower) {
        if (hour < 4) {
            return 'रात्री';
        } else if (hour < 10) {
            return 'सकाळी';
        } else if (hour < 17) {
            return 'दुपारी';
        } else if (hour < 20) {
            return 'सायंकाळी';
        } else {
            return 'रात्री';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return mr;

})));


/***/ }),

/***/ 1533:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malay [ms]
//! author : Weldan Jamili : https://github.com/weldan

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ms = moment.defineLocale('ms', {
    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY [pukul] HH.mm',
        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
    },
    meridiemParse: /pagi|tengahari|petang|malam/,
    meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'pagi') {
            return hour;
        } else if (meridiem === 'tengahari') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === 'petang' || meridiem === 'malam') {
            return hour + 12;
        }
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 11) {
            return 'pagi';
        } else if (hours < 15) {
            return 'tengahari';
        } else if (hours < 19) {
            return 'petang';
        } else {
            return 'malam';
        }
    },
    calendar : {
        sameDay : '[Hari ini pukul] LT',
        nextDay : '[Esok pukul] LT',
        nextWeek : 'dddd [pukul] LT',
        lastDay : '[Kelmarin pukul] LT',
        lastWeek : 'dddd [lepas pukul] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dalam %s',
        past : '%s yang lepas',
        s : 'beberapa saat',
        m : 'seminit',
        mm : '%d minit',
        h : 'sejam',
        hh : '%d jam',
        d : 'sehari',
        dd : '%d hari',
        M : 'sebulan',
        MM : '%d bulan',
        y : 'setahun',
        yy : '%d tahun'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return ms;

})));


/***/ }),

/***/ 1534:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malay [ms-my]
//! note : DEPRECATED, the correct one is [ms]
//! author : Weldan Jamili : https://github.com/weldan

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var msMy = moment.defineLocale('ms-my', {
    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY [pukul] HH.mm',
        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
    },
    meridiemParse: /pagi|tengahari|petang|malam/,
    meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'pagi') {
            return hour;
        } else if (meridiem === 'tengahari') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === 'petang' || meridiem === 'malam') {
            return hour + 12;
        }
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 11) {
            return 'pagi';
        } else if (hours < 15) {
            return 'tengahari';
        } else if (hours < 19) {
            return 'petang';
        } else {
            return 'malam';
        }
    },
    calendar : {
        sameDay : '[Hari ini pukul] LT',
        nextDay : '[Esok pukul] LT',
        nextWeek : 'dddd [pukul] LT',
        lastDay : '[Kelmarin pukul] LT',
        lastWeek : 'dddd [lepas pukul] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dalam %s',
        past : '%s yang lepas',
        s : 'beberapa saat',
        m : 'seminit',
        mm : '%d minit',
        h : 'sejam',
        hh : '%d jam',
        d : 'sehari',
        dd : '%d hari',
        M : 'sebulan',
        MM : '%d bulan',
        y : 'setahun',
        yy : '%d tahun'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return msMy;

})));


/***/ }),

/***/ 1535:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Burmese [my]
//! author : Squar team, mysquar.com
//! author : David Rossellat : https://github.com/gholadr
//! author : Tin Aung Lin : https://github.com/thanyawzinmin

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '၁',
    '2': '၂',
    '3': '၃',
    '4': '၄',
    '5': '၅',
    '6': '၆',
    '7': '၇',
    '8': '၈',
    '9': '၉',
    '0': '၀'
};
var numberMap = {
    '၁': '1',
    '၂': '2',
    '၃': '3',
    '၄': '4',
    '၅': '5',
    '၆': '6',
    '၇': '7',
    '၈': '8',
    '၉': '9',
    '၀': '0'
};

var my = moment.defineLocale('my', {
    months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
    monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
    weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
    weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
    weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),

    longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd D MMMM YYYY HH:mm'
    },
    calendar: {
        sameDay: '[ယနေ.] LT [မှာ]',
        nextDay: '[မနက်ဖြန်] LT [မှာ]',
        nextWeek: 'dddd LT [မှာ]',
        lastDay: '[မနေ.က] LT [မှာ]',
        lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
        sameElse: 'L'
    },
    relativeTime: {
        future: 'လာမည့် %s မှာ',
        past: 'လွန်ခဲ့သော %s က',
        s: 'စက္ကန်.အနည်းငယ်',
        m: 'တစ်မိနစ်',
        mm: '%d မိနစ်',
        h: 'တစ်နာရီ',
        hh: '%d နာရီ',
        d: 'တစ်ရက်',
        dd: '%d ရက်',
        M: 'တစ်လ',
        MM: '%d လ',
        y: 'တစ်နှစ်',
        yy: '%d နှစ်'
    },
    preparse: function (string) {
        return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    week: {
        dow: 1, // Monday is the first day of the week.
        doy: 4 // The week that contains Jan 1st is the first week of the year.
    }
});

return my;

})));


/***/ }),

/***/ 1536:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Norwegian Bokmål [nb]
//! authors : Espen Hovlandsdal : https://github.com/rexxars
//!           Sigurd Gartmann : https://github.com/sigurdga

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var nb = moment.defineLocale('nb', {
    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
    monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
    monthsParseExact : true,
    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
    weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY [kl.] HH:mm',
        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
    },
    calendar : {
        sameDay: '[i dag kl.] LT',
        nextDay: '[i morgen kl.] LT',
        nextWeek: 'dddd [kl.] LT',
        lastDay: '[i går kl.] LT',
        lastWeek: '[forrige] dddd [kl.] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'om %s',
        past : '%s siden',
        s : 'noen sekunder',
        m : 'ett minutt',
        mm : '%d minutter',
        h : 'en time',
        hh : '%d timer',
        d : 'en dag',
        dd : '%d dager',
        M : 'en måned',
        MM : '%d måneder',
        y : 'ett år',
        yy : '%d år'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return nb;

})));


/***/ }),

/***/ 1537:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Nepalese [ne]
//! author : suvash : https://github.com/suvash

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '१',
    '2': '२',
    '3': '३',
    '4': '४',
    '5': '५',
    '6': '६',
    '7': '७',
    '8': '८',
    '9': '९',
    '0': '०'
};
var numberMap = {
    '१': '1',
    '२': '2',
    '३': '3',
    '४': '4',
    '५': '5',
    '६': '6',
    '७': '7',
    '८': '8',
    '९': '9',
    '०': '0'
};

var ne = moment.defineLocale('ne', {
    months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
    monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
    monthsParseExact : true,
    weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
    weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
    weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'Aको h:mm बजे',
        LTS : 'Aको h:mm:ss बजे',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, Aको h:mm बजे',
        LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
    },
    preparse: function (string) {
        return string.replace(/[१२३४५६७८९०]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'राति') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'बिहान') {
            return hour;
        } else if (meridiem === 'दिउँसो') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'साँझ') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 3) {
            return 'राति';
        } else if (hour < 12) {
            return 'बिहान';
        } else if (hour < 16) {
            return 'दिउँसो';
        } else if (hour < 20) {
            return 'साँझ';
        } else {
            return 'राति';
        }
    },
    calendar : {
        sameDay : '[आज] LT',
        nextDay : '[भोलि] LT',
        nextWeek : '[आउँदो] dddd[,] LT',
        lastDay : '[हिजो] LT',
        lastWeek : '[गएको] dddd[,] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%sमा',
        past : '%s अगाडि',
        s : 'केही क्षण',
        m : 'एक मिनेट',
        mm : '%d मिनेट',
        h : 'एक घण्टा',
        hh : '%d घण्टा',
        d : 'एक दिन',
        dd : '%d दिन',
        M : 'एक महिना',
        MM : '%d महिना',
        y : 'एक बर्ष',
        yy : '%d बर्ष'
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return ne;

})));


/***/ }),

/***/ 1538:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Dutch [nl]
//! author : Joris Röling : https://github.com/jorisroling
//! author : Jacob Middag : https://github.com/middagj

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');

var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

var nl = moment.defineLocale('nl', {
    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortWithDots;
        } else if (/-MMM-/.test(format)) {
            return monthsShortWithoutDots[m.month()];
        } else {
            return monthsShortWithDots[m.month()];
        }
    },

    monthsRegex: monthsRegex,
    monthsShortRegex: monthsRegex,
    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

    monthsParse : monthsParse,
    longMonthsParse : monthsParse,
    shortMonthsParse : monthsParse,

    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
    weekdaysMin : 'Zo_Ma_Di_Wo_Do_Vr_Za'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD-MM-YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[vandaag om] LT',
        nextDay: '[morgen om] LT',
        nextWeek: 'dddd [om] LT',
        lastDay: '[gisteren om] LT',
        lastWeek: '[afgelopen] dddd [om] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'over %s',
        past : '%s geleden',
        s : 'een paar seconden',
        m : 'één minuut',
        mm : '%d minuten',
        h : 'één uur',
        hh : '%d uur',
        d : 'één dag',
        dd : '%d dagen',
        M : 'één maand',
        MM : '%d maanden',
        y : 'één jaar',
        yy : '%d jaar'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
    ordinal : function (number) {
        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return nl;

})));


/***/ }),

/***/ 1539:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Dutch (Belgium) [nl-be]
//! author : Joris Röling : https://github.com/jorisroling
//! author : Jacob Middag : https://github.com/middagj

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');

var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

var nlBe = moment.defineLocale('nl-be', {
    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
    monthsShort : function (m, format) {
        if (!m) {
            return monthsShortWithDots;
        } else if (/-MMM-/.test(format)) {
            return monthsShortWithoutDots[m.month()];
        } else {
            return monthsShortWithDots[m.month()];
        }
    },

    monthsRegex: monthsRegex,
    monthsShortRegex: monthsRegex,
    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

    monthsParse : monthsParse,
    longMonthsParse : monthsParse,
    shortMonthsParse : monthsParse,

    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
    weekdaysMin : 'Zo_Ma_Di_Wo_Do_Vr_Za'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[vandaag om] LT',
        nextDay: '[morgen om] LT',
        nextWeek: 'dddd [om] LT',
        lastDay: '[gisteren om] LT',
        lastWeek: '[afgelopen] dddd [om] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'over %s',
        past : '%s geleden',
        s : 'een paar seconden',
        m : 'één minuut',
        mm : '%d minuten',
        h : 'één uur',
        hh : '%d uur',
        d : 'één dag',
        dd : '%d dagen',
        M : 'één maand',
        MM : '%d maanden',
        y : 'één jaar',
        yy : '%d jaar'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
    ordinal : function (number) {
        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return nlBe;

})));


/***/ }),

/***/ 1540:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Nynorsk [nn]
//! author : https://github.com/mechuwind

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var nn = moment.defineLocale('nn', {
    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
    weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
    weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
    weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY [kl.] H:mm',
        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
    },
    calendar : {
        sameDay: '[I dag klokka] LT',
        nextDay: '[I morgon klokka] LT',
        nextWeek: 'dddd [klokka] LT',
        lastDay: '[I går klokka] LT',
        lastWeek: '[Føregåande] dddd [klokka] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'om %s',
        past : '%s sidan',
        s : 'nokre sekund',
        m : 'eit minutt',
        mm : '%d minutt',
        h : 'ein time',
        hh : '%d timar',
        d : 'ein dag',
        dd : '%d dagar',
        M : 'ein månad',
        MM : '%d månader',
        y : 'eit år',
        yy : '%d år'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return nn;

})));


/***/ }),

/***/ 1541:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Punjabi (India) [pa-in]
//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '੧',
    '2': '੨',
    '3': '੩',
    '4': '੪',
    '5': '੫',
    '6': '੬',
    '7': '੭',
    '8': '੮',
    '9': '੯',
    '0': '੦'
};
var numberMap = {
    '੧': '1',
    '੨': '2',
    '੩': '3',
    '੪': '4',
    '੫': '5',
    '੬': '6',
    '੭': '7',
    '੮': '8',
    '੯': '9',
    '੦': '0'
};

var paIn = moment.defineLocale('pa-in', {
    // There are months name as per Nanakshahi Calender but they are not used as rigidly in modern Punjabi.
    months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
    monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
    weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
    weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
    weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
    longDateFormat : {
        LT : 'A h:mm ਵਜੇ',
        LTS : 'A h:mm:ss ਵਜੇ',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
        LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
    },
    calendar : {
        sameDay : '[ਅਜ] LT',
        nextDay : '[ਕਲ] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[ਕਲ] LT',
        lastWeek : '[ਪਿਛਲੇ] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s ਵਿੱਚ',
        past : '%s ਪਿਛਲੇ',
        s : 'ਕੁਝ ਸਕਿੰਟ',
        m : 'ਇਕ ਮਿੰਟ',
        mm : '%d ਮਿੰਟ',
        h : 'ਇੱਕ ਘੰਟਾ',
        hh : '%d ਘੰਟੇ',
        d : 'ਇੱਕ ਦਿਨ',
        dd : '%d ਦਿਨ',
        M : 'ਇੱਕ ਮਹੀਨਾ',
        MM : '%d ਮਹੀਨੇ',
        y : 'ਇੱਕ ਸਾਲ',
        yy : '%d ਸਾਲ'
    },
    preparse: function (string) {
        return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
    meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'ਰਾਤ') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'ਸਵੇਰ') {
            return hour;
        } else if (meridiem === 'ਦੁਪਹਿਰ') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'ਸ਼ਾਮ') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'ਰਾਤ';
        } else if (hour < 10) {
            return 'ਸਵੇਰ';
        } else if (hour < 17) {
            return 'ਦੁਪਹਿਰ';
        } else if (hour < 20) {
            return 'ਸ਼ਾਮ';
        } else {
            return 'ਰਾਤ';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return paIn;

})));


/***/ }),

/***/ 1542:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Polish [pl]
//! author : Rafal Hirsz : https://github.com/evoL

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_');
var monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
function plural(n) {
    return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
}
function translate(number, withoutSuffix, key) {
    var result = number + ' ';
    switch (key) {
        case 'm':
            return withoutSuffix ? 'minuta' : 'minutę';
        case 'mm':
            return result + (plural(number) ? 'minuty' : 'minut');
        case 'h':
            return withoutSuffix  ? 'godzina'  : 'godzinę';
        case 'hh':
            return result + (plural(number) ? 'godziny' : 'godzin');
        case 'MM':
            return result + (plural(number) ? 'miesiące' : 'miesięcy');
        case 'yy':
            return result + (plural(number) ? 'lata' : 'lat');
    }
}

var pl = moment.defineLocale('pl', {
    months : function (momentToFormat, format) {
        if (!momentToFormat) {
            return monthsNominative;
        } else if (format === '') {
            // Hack: if format empty we know this is used to generate
            // RegExp by moment. Give then back both valid forms of months
            // in RegExp ready format.
            return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
        } else if (/D MMMM/.test(format)) {
            return monthsSubjective[momentToFormat.month()];
        } else {
            return monthsNominative[momentToFormat.month()];
        }
    },
    monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
    weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
    weekdaysShort : 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
    weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Dziś o] LT',
        nextDay: '[Jutro o] LT',
        nextWeek: '[W] dddd [o] LT',
        lastDay: '[Wczoraj o] LT',
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[W zeszłą niedzielę o] LT';
                case 3:
                    return '[W zeszłą środę o] LT';
                case 6:
                    return '[W zeszłą sobotę o] LT';
                default:
                    return '[W zeszły] dddd [o] LT';
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'za %s',
        past : '%s temu',
        s : 'kilka sekund',
        m : translate,
        mm : translate,
        h : translate,
        hh : translate,
        d : '1 dzień',
        dd : '%d dni',
        M : 'miesiąc',
        MM : translate,
        y : 'rok',
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return pl;

})));


/***/ }),

/***/ 1543:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Portuguese [pt]
//! author : Jefferson : https://github.com/jalex79

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var pt = moment.defineLocale('pt', {
    months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
    weekdays : 'Domingo_Segunda-Feira_Terça-Feira_Quarta-Feira_Quinta-Feira_Sexta-Feira_Sábado'.split('_'),
    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
    weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D [de] MMMM [de] YYYY',
        LLL : 'D [de] MMMM [de] YYYY HH:mm',
        LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Hoje às] LT',
        nextDay: '[Amanhã às] LT',
        nextWeek: 'dddd [às] LT',
        lastDay: '[Ontem às] LT',
        lastWeek: function () {
            return (this.day() === 0 || this.day() === 6) ?
                '[Último] dddd [às] LT' : // Saturday + Sunday
                '[Última] dddd [às] LT'; // Monday - Friday
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'em %s',
        past : 'há %s',
        s : 'segundos',
        m : 'um minuto',
        mm : '%d minutos',
        h : 'uma hora',
        hh : '%d horas',
        d : 'um dia',
        dd : '%d dias',
        M : 'um mês',
        MM : '%d meses',
        y : 'um ano',
        yy : '%d anos'
    },
    dayOfMonthOrdinalParse: /\d{1,2}º/,
    ordinal : '%dº',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return pt;

})));


/***/ }),

/***/ 1544:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Portuguese (Brazil) [pt-br]
//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ptBr = moment.defineLocale('pt-br', {
    months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
    weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
    weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D [de] MMMM [de] YYYY',
        LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
        LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
    },
    calendar : {
        sameDay: '[Hoje às] LT',
        nextDay: '[Amanhã às] LT',
        nextWeek: 'dddd [às] LT',
        lastDay: '[Ontem às] LT',
        lastWeek: function () {
            return (this.day() === 0 || this.day() === 6) ?
                '[Último] dddd [às] LT' : // Saturday + Sunday
                '[Última] dddd [às] LT'; // Monday - Friday
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'em %s',
        past : '%s atrás',
        s : 'poucos segundos',
        m : 'um minuto',
        mm : '%d minutos',
        h : 'uma hora',
        hh : '%d horas',
        d : 'um dia',
        dd : '%d dias',
        M : 'um mês',
        MM : '%d meses',
        y : 'um ano',
        yy : '%d anos'
    },
    dayOfMonthOrdinalParse: /\d{1,2}º/,
    ordinal : '%dº'
});

return ptBr;

})));


/***/ }),

/***/ 1545:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Romanian [ro]
//! author : Vlad Gurdiga : https://github.com/gurdiga
//! author : Valentin Agachi : https://github.com/avaly

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function relativeTimeWithPlural(number, withoutSuffix, key) {
    var format = {
            'mm': 'minute',
            'hh': 'ore',
            'dd': 'zile',
            'MM': 'luni',
            'yy': 'ani'
        },
        separator = ' ';
    if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
        separator = ' de ';
    }
    return number + separator + format[key];
}

var ro = moment.defineLocale('ro', {
    months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
    monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
    monthsParseExact: true,
    weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
    weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
    weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY H:mm',
        LLLL : 'dddd, D MMMM YYYY H:mm'
    },
    calendar : {
        sameDay: '[azi la] LT',
        nextDay: '[mâine la] LT',
        nextWeek: 'dddd [la] LT',
        lastDay: '[ieri la] LT',
        lastWeek: '[fosta] dddd [la] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'peste %s',
        past : '%s în urmă',
        s : 'câteva secunde',
        m : 'un minut',
        mm : relativeTimeWithPlural,
        h : 'o oră',
        hh : relativeTimeWithPlural,
        d : 'o zi',
        dd : relativeTimeWithPlural,
        M : 'o lună',
        MM : relativeTimeWithPlural,
        y : 'un an',
        yy : relativeTimeWithPlural
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return ro;

})));


/***/ }),

/***/ 1546:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Russian [ru]
//! author : Viktorminator : https://github.com/Viktorminator
//! Author : Menelion Elensúle : https://github.com/Oire
//! author : Коренберг Марк : https://github.com/socketpair

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function plural(word, num) {
    var forms = word.split('_');
    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
}
function relativeTimeWithPlural(number, withoutSuffix, key) {
    var format = {
        'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
        'hh': 'час_часа_часов',
        'dd': 'день_дня_дней',
        'MM': 'месяц_месяца_месяцев',
        'yy': 'год_года_лет'
    };
    if (key === 'm') {
        return withoutSuffix ? 'минута' : 'минуту';
    }
    else {
        return number + ' ' + plural(format[key], +number);
    }
}
var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];

// http://new.gramota.ru/spravka/rules/139-prop : § 103
// Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
// CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
var ru = moment.defineLocale('ru', {
    months : {
        format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
        standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
    },
    monthsShort : {
        // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
        format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
        standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
    },
    weekdays : {
        standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
        format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
        isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
    },
    weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
    weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
    monthsParse : monthsParse,
    longMonthsParse : monthsParse,
    shortMonthsParse : monthsParse,

    // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
    monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

    // копия предыдущего
    monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

    // полные названия с падежами
    monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,

    // Выражение, которое соотвествует только сокращённым формам
    monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY г.',
        LLL : 'D MMMM YYYY г., HH:mm',
        LLLL : 'dddd, D MMMM YYYY г., HH:mm'
    },
    calendar : {
        sameDay: '[Сегодня в] LT',
        nextDay: '[Завтра в] LT',
        lastDay: '[Вчера в] LT',
        nextWeek: function (now) {
            if (now.week() !== this.week()) {
                switch (this.day()) {
                    case 0:
                        return '[В следующее] dddd [в] LT';
                    case 1:
                    case 2:
                    case 4:
                        return '[В следующий] dddd [в] LT';
                    case 3:
                    case 5:
                    case 6:
                        return '[В следующую] dddd [в] LT';
                }
            } else {
                if (this.day() === 2) {
                    return '[Во] dddd [в] LT';
                } else {
                    return '[В] dddd [в] LT';
                }
            }
        },
        lastWeek: function (now) {
            if (now.week() !== this.week()) {
                switch (this.day()) {
                    case 0:
                        return '[В прошлое] dddd [в] LT';
                    case 1:
                    case 2:
                    case 4:
                        return '[В прошлый] dddd [в] LT';
                    case 3:
                    case 5:
                    case 6:
                        return '[В прошлую] dddd [в] LT';
                }
            } else {
                if (this.day() === 2) {
                    return '[Во] dddd [в] LT';
                } else {
                    return '[В] dddd [в] LT';
                }
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'через %s',
        past : '%s назад',
        s : 'несколько секунд',
        m : relativeTimeWithPlural,
        mm : relativeTimeWithPlural,
        h : 'час',
        hh : relativeTimeWithPlural,
        d : 'день',
        dd : relativeTimeWithPlural,
        M : 'месяц',
        MM : relativeTimeWithPlural,
        y : 'год',
        yy : relativeTimeWithPlural
    },
    meridiemParse: /ночи|утра|дня|вечера/i,
    isPM : function (input) {
        return /^(дня|вечера)$/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'ночи';
        } else if (hour < 12) {
            return 'утра';
        } else if (hour < 17) {
            return 'дня';
        } else {
            return 'вечера';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
    ordinal: function (number, period) {
        switch (period) {
            case 'M':
            case 'd':
            case 'DDD':
                return number + '-й';
            case 'D':
                return number + '-го';
            case 'w':
            case 'W':
                return number + '-я';
            default:
                return number;
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return ru;

})));


/***/ }),

/***/ 1547:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Sindhi [sd]
//! author : Narain Sagar : https://github.com/narainsagar

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = [
    'جنوري',
    'فيبروري',
    'مارچ',
    'اپريل',
    'مئي',
    'جون',
    'جولاءِ',
    'آگسٽ',
    'سيپٽمبر',
    'آڪٽوبر',
    'نومبر',
    'ڊسمبر'
];
var days = [
    'آچر',
    'سومر',
    'اڱارو',
    'اربع',
    'خميس',
    'جمع',
    'ڇنڇر'
];

var sd = moment.defineLocale('sd', {
    months : months,
    monthsShort : months,
    weekdays : days,
    weekdaysShort : days,
    weekdaysMin : days,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd، D MMMM YYYY HH:mm'
    },
    meridiemParse: /صبح|شام/,
    isPM : function (input) {
        return 'شام' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'صبح';
        }
        return 'شام';
    },
    calendar : {
        sameDay : '[اڄ] LT',
        nextDay : '[سڀاڻي] LT',
        nextWeek : 'dddd [اڳين هفتي تي] LT',
        lastDay : '[ڪالهه] LT',
        lastWeek : '[گزريل هفتي] dddd [تي] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s پوء',
        past : '%s اڳ',
        s : 'چند سيڪنڊ',
        m : 'هڪ منٽ',
        mm : '%d منٽ',
        h : 'هڪ ڪلاڪ',
        hh : '%d ڪلاڪ',
        d : 'هڪ ڏينهن',
        dd : '%d ڏينهن',
        M : 'هڪ مهينو',
        MM : '%d مهينا',
        y : 'هڪ سال',
        yy : '%d سال'
    },
    preparse: function (string) {
        return string.replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/,/g, '،');
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return sd;

})));


/***/ }),

/***/ 1548:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Northern Sami [se]
//! authors : Bård Rolstad Henriksen : https://github.com/karamell

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';



var se = moment.defineLocale('se', {
    months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
    monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
    weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
    weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
    weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'MMMM D. [b.] YYYY',
        LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
        LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
    },
    calendar : {
        sameDay: '[otne ti] LT',
        nextDay: '[ihttin ti] LT',
        nextWeek: 'dddd [ti] LT',
        lastDay: '[ikte ti] LT',
        lastWeek: '[ovddit] dddd [ti] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : '%s geažes',
        past : 'maŋit %s',
        s : 'moadde sekunddat',
        m : 'okta minuhta',
        mm : '%d minuhtat',
        h : 'okta diimmu',
        hh : '%d diimmut',
        d : 'okta beaivi',
        dd : '%d beaivvit',
        M : 'okta mánnu',
        MM : '%d mánut',
        y : 'okta jahki',
        yy : '%d jagit'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return se;

})));


/***/ }),

/***/ 1549:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Sinhalese [si]
//! author : Sampath Sitinamaluwa : https://github.com/sampathsris

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


/*jshint -W100*/
var si = moment.defineLocale('si', {
    months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
    monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
    weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
    weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
    weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'a h:mm',
        LTS : 'a h:mm:ss',
        L : 'YYYY/MM/DD',
        LL : 'YYYY MMMM D',
        LLL : 'YYYY MMMM D, a h:mm',
        LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
    },
    calendar : {
        sameDay : '[අද] LT[ට]',
        nextDay : '[හෙට] LT[ට]',
        nextWeek : 'dddd LT[ට]',
        lastDay : '[ඊයේ] LT[ට]',
        lastWeek : '[පසුගිය] dddd LT[ට]',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%sකින්',
        past : '%sකට පෙර',
        s : 'තත්පර කිහිපය',
        m : 'මිනිත්තුව',
        mm : 'මිනිත්තු %d',
        h : 'පැය',
        hh : 'පැය %d',
        d : 'දිනය',
        dd : 'දින %d',
        M : 'මාසය',
        MM : 'මාස %d',
        y : 'වසර',
        yy : 'වසර %d'
    },
    dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
    ordinal : function (number) {
        return number + ' වැනි';
    },
    meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
    isPM : function (input) {
        return input === 'ප.ව.' || input === 'පස් වරු';
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'ප.ව.' : 'පස් වරු';
        } else {
            return isLower ? 'පෙ.ව.' : 'පෙර වරු';
        }
    }
});

return si;

})));


/***/ }),

/***/ 1550:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Slovak [sk]
//! author : Martin Minka : https://github.com/k2s
//! based on work of petrbela : https://github.com/petrbela

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_');
var monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
function plural(n) {
    return (n > 1) && (n < 5);
}
function translate(number, withoutSuffix, key, isFuture) {
    var result = number + ' ';
    switch (key) {
        case 's':  // a few seconds / in a few seconds / a few seconds ago
            return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
        case 'm':  // a minute / in a minute / a minute ago
            return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'minúty' : 'minút');
            } else {
                return result + 'minútami';
            }
            break;
        case 'h':  // an hour / in an hour / an hour ago
            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
        case 'hh': // 9 hours / in 9 hours / 9 hours ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'hodiny' : 'hodín');
            } else {
                return result + 'hodinami';
            }
            break;
        case 'd':  // a day / in a day / a day ago
            return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
        case 'dd': // 9 days / in 9 days / 9 days ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'dni' : 'dní');
            } else {
                return result + 'dňami';
            }
            break;
        case 'M':  // a month / in a month / a month ago
            return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
        case 'MM': // 9 months / in 9 months / 9 months ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'mesiace' : 'mesiacov');
            } else {
                return result + 'mesiacmi';
            }
            break;
        case 'y':  // a year / in a year / a year ago
            return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
        case 'yy': // 9 years / in 9 years / 9 years ago
            if (withoutSuffix || isFuture) {
                return result + (plural(number) ? 'roky' : 'rokov');
            } else {
                return result + 'rokmi';
            }
            break;
    }
}

var sk = moment.defineLocale('sk', {
    months : months,
    monthsShort : monthsShort,
    weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
    weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
    weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
    longDateFormat : {
        LT: 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd D. MMMM YYYY H:mm'
    },
    calendar : {
        sameDay: '[dnes o] LT',
        nextDay: '[zajtra o] LT',
        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[v nedeľu o] LT';
                case 1:
                case 2:
                    return '[v] dddd [o] LT';
                case 3:
                    return '[v stredu o] LT';
                case 4:
                    return '[vo štvrtok o] LT';
                case 5:
                    return '[v piatok o] LT';
                case 6:
                    return '[v sobotu o] LT';
            }
        },
        lastDay: '[včera o] LT',
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[minulú nedeľu o] LT';
                case 1:
                case 2:
                    return '[minulý] dddd [o] LT';
                case 3:
                    return '[minulú stredu o] LT';
                case 4:
                case 5:
                    return '[minulý] dddd [o] LT';
                case 6:
                    return '[minulú sobotu o] LT';
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'za %s',
        past : 'pred %s',
        s : translate,
        m : translate,
        mm : translate,
        h : translate,
        hh : translate,
        d : translate,
        dd : translate,
        M : translate,
        MM : translate,
        y : translate,
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return sk;

})));


/***/ }),

/***/ 1551:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Slovenian [sl]
//! author : Robert Sedovšek : https://github.com/sedovsek

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var result = number + ' ';
    switch (key) {
        case 's':
            return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
        case 'm':
            return withoutSuffix ? 'ena minuta' : 'eno minuto';
        case 'mm':
            if (number === 1) {
                result += withoutSuffix ? 'minuta' : 'minuto';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
            } else if (number < 5) {
                result += withoutSuffix || isFuture ? 'minute' : 'minutami';
            } else {
                result += withoutSuffix || isFuture ? 'minut' : 'minutami';
            }
            return result;
        case 'h':
            return withoutSuffix ? 'ena ura' : 'eno uro';
        case 'hh':
            if (number === 1) {
                result += withoutSuffix ? 'ura' : 'uro';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'uri' : 'urama';
            } else if (number < 5) {
                result += withoutSuffix || isFuture ? 'ure' : 'urami';
            } else {
                result += withoutSuffix || isFuture ? 'ur' : 'urami';
            }
            return result;
        case 'd':
            return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
        case 'dd':
            if (number === 1) {
                result += withoutSuffix || isFuture ? 'dan' : 'dnem';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
            } else {
                result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
            }
            return result;
        case 'M':
            return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
        case 'MM':
            if (number === 1) {
                result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
            } else if (number < 5) {
                result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
            } else {
                result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
            }
            return result;
        case 'y':
            return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
        case 'yy':
            if (number === 1) {
                result += withoutSuffix || isFuture ? 'leto' : 'letom';
            } else if (number === 2) {
                result += withoutSuffix || isFuture ? 'leti' : 'letoma';
            } else if (number < 5) {
                result += withoutSuffix || isFuture ? 'leta' : 'leti';
            } else {
                result += withoutSuffix || isFuture ? 'let' : 'leti';
            }
            return result;
    }
}

var sl = moment.defineLocale('sl', {
    months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
    monthsParseExact: true,
    weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
    weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
    weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM YYYY',
        LLL : 'D. MMMM YYYY H:mm',
        LLLL : 'dddd, D. MMMM YYYY H:mm'
    },
    calendar : {
        sameDay  : '[danes ob] LT',
        nextDay  : '[jutri ob] LT',

        nextWeek : function () {
            switch (this.day()) {
                case 0:
                    return '[v] [nedeljo] [ob] LT';
                case 3:
                    return '[v] [sredo] [ob] LT';
                case 6:
                    return '[v] [soboto] [ob] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[v] dddd [ob] LT';
            }
        },
        lastDay  : '[včeraj ob] LT',
        lastWeek : function () {
            switch (this.day()) {
                case 0:
                    return '[prejšnjo] [nedeljo] [ob] LT';
                case 3:
                    return '[prejšnjo] [sredo] [ob] LT';
                case 6:
                    return '[prejšnjo] [soboto] [ob] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[prejšnji] dddd [ob] LT';
            }
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'čez %s',
        past   : 'pred %s',
        s      : processRelativeTime,
        m      : processRelativeTime,
        mm     : processRelativeTime,
        h      : processRelativeTime,
        hh     : processRelativeTime,
        d      : processRelativeTime,
        dd     : processRelativeTime,
        M      : processRelativeTime,
        MM     : processRelativeTime,
        y      : processRelativeTime,
        yy     : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return sl;

})));


/***/ }),

/***/ 1552:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Albanian [sq]
//! author : Flakërim Ismani : https://github.com/flakerimi
//! author : Menelion Elensúle : https://github.com/Oire
//! author : Oerd Cukalla : https://github.com/oerd

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var sq = moment.defineLocale('sq', {
    months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
    monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
    weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
    weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
    weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
    weekdaysParseExact : true,
    meridiemParse: /PD|MD/,
    isPM: function (input) {
        return input.charAt(0) === 'M';
    },
    meridiem : function (hours, minutes, isLower) {
        return hours < 12 ? 'PD' : 'MD';
    },
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Sot në] LT',
        nextDay : '[Nesër në] LT',
        nextWeek : 'dddd [në] LT',
        lastDay : '[Dje në] LT',
        lastWeek : 'dddd [e kaluar në] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'në %s',
        past : '%s më parë',
        s : 'disa sekonda',
        m : 'një minutë',
        mm : '%d minuta',
        h : 'një orë',
        hh : '%d orë',
        d : 'një ditë',
        dd : '%d ditë',
        M : 'një muaj',
        MM : '%d muaj',
        y : 'një vit',
        yy : '%d vite'
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return sq;

})));


/***/ }),

/***/ 1553:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Serbian [sr]
//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var translator = {
    words: { //Different grammatical cases
        m: ['jedan minut', 'jedne minute'],
        mm: ['minut', 'minute', 'minuta'],
        h: ['jedan sat', 'jednog sata'],
        hh: ['sat', 'sata', 'sati'],
        dd: ['dan', 'dana', 'dana'],
        MM: ['mesec', 'meseca', 'meseci'],
        yy: ['godina', 'godine', 'godina']
    },
    correctGrammaticalCase: function (number, wordKey) {
        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
    },
    translate: function (number, withoutSuffix, key) {
        var wordKey = translator.words[key];
        if (key.length === 1) {
            return withoutSuffix ? wordKey[0] : wordKey[1];
        } else {
            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
        }
    }
};

var sr = moment.defineLocale('sr', {
    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
    monthsParseExact: true,
    weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
    weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
    weekdaysParseExact : true,
    longDateFormat: {
        LT: 'H:mm',
        LTS : 'H:mm:ss',
        L: 'DD.MM.YYYY',
        LL: 'D. MMMM YYYY',
        LLL: 'D. MMMM YYYY H:mm',
        LLLL: 'dddd, D. MMMM YYYY H:mm'
    },
    calendar: {
        sameDay: '[danas u] LT',
        nextDay: '[sutra u] LT',
        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[u] [nedelju] [u] LT';
                case 3:
                    return '[u] [sredu] [u] LT';
                case 6:
                    return '[u] [subotu] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[u] dddd [u] LT';
            }
        },
        lastDay  : '[juče u] LT',
        lastWeek : function () {
            var lastWeekDays = [
                '[prošle] [nedelje] [u] LT',
                '[prošlog] [ponedeljka] [u] LT',
                '[prošlog] [utorka] [u] LT',
                '[prošle] [srede] [u] LT',
                '[prošlog] [četvrtka] [u] LT',
                '[prošlog] [petka] [u] LT',
                '[prošle] [subote] [u] LT'
            ];
            return lastWeekDays[this.day()];
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'za %s',
        past   : 'pre %s',
        s      : 'nekoliko sekundi',
        m      : translator.translate,
        mm     : translator.translate,
        h      : translator.translate,
        hh     : translator.translate,
        d      : 'dan',
        dd     : translator.translate,
        M      : 'mesec',
        MM     : translator.translate,
        y      : 'godinu',
        yy     : translator.translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return sr;

})));


/***/ }),

/***/ 1554:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Serbian Cyrillic [sr-cyrl]
//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var translator = {
    words: { //Different grammatical cases
        m: ['један минут', 'једне минуте'],
        mm: ['минут', 'минуте', 'минута'],
        h: ['један сат', 'једног сата'],
        hh: ['сат', 'сата', 'сати'],
        dd: ['дан', 'дана', 'дана'],
        MM: ['месец', 'месеца', 'месеци'],
        yy: ['година', 'године', 'година']
    },
    correctGrammaticalCase: function (number, wordKey) {
        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
    },
    translate: function (number, withoutSuffix, key) {
        var wordKey = translator.words[key];
        if (key.length === 1) {
            return withoutSuffix ? wordKey[0] : wordKey[1];
        } else {
            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
        }
    }
};

var srCyrl = moment.defineLocale('sr-cyrl', {
    months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
    monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
    monthsParseExact: true,
    weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
    weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
    weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
    weekdaysParseExact : true,
    longDateFormat: {
        LT: 'H:mm',
        LTS : 'H:mm:ss',
        L: 'DD.MM.YYYY',
        LL: 'D. MMMM YYYY',
        LLL: 'D. MMMM YYYY H:mm',
        LLLL: 'dddd, D. MMMM YYYY H:mm'
    },
    calendar: {
        sameDay: '[данас у] LT',
        nextDay: '[сутра у] LT',
        nextWeek: function () {
            switch (this.day()) {
                case 0:
                    return '[у] [недељу] [у] LT';
                case 3:
                    return '[у] [среду] [у] LT';
                case 6:
                    return '[у] [суботу] [у] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[у] dddd [у] LT';
            }
        },
        lastDay  : '[јуче у] LT',
        lastWeek : function () {
            var lastWeekDays = [
                '[прошле] [недеље] [у] LT',
                '[прошлог] [понедељка] [у] LT',
                '[прошлог] [уторка] [у] LT',
                '[прошле] [среде] [у] LT',
                '[прошлог] [четвртка] [у] LT',
                '[прошлог] [петка] [у] LT',
                '[прошле] [суботе] [у] LT'
            ];
            return lastWeekDays[this.day()];
        },
        sameElse : 'L'
    },
    relativeTime : {
        future : 'за %s',
        past   : 'пре %s',
        s      : 'неколико секунди',
        m      : translator.translate,
        mm     : translator.translate,
        h      : translator.translate,
        hh     : translator.translate,
        d      : 'дан',
        dd     : translator.translate,
        M      : 'месец',
        MM     : translator.translate,
        y      : 'годину',
        yy     : translator.translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return srCyrl;

})));


/***/ }),

/***/ 1555:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : siSwati [ss]
//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';



var ss = moment.defineLocale('ss', {
    months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
    monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
    weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
    weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
    weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Namuhla nga] LT',
        nextDay : '[Kusasa nga] LT',
        nextWeek : 'dddd [nga] LT',
        lastDay : '[Itolo nga] LT',
        lastWeek : 'dddd [leliphelile] [nga] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'nga %s',
        past : 'wenteka nga %s',
        s : 'emizuzwana lomcane',
        m : 'umzuzu',
        mm : '%d emizuzu',
        h : 'lihora',
        hh : '%d emahora',
        d : 'lilanga',
        dd : '%d emalanga',
        M : 'inyanga',
        MM : '%d tinyanga',
        y : 'umnyaka',
        yy : '%d iminyaka'
    },
    meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
    meridiem : function (hours, minutes, isLower) {
        if (hours < 11) {
            return 'ekuseni';
        } else if (hours < 15) {
            return 'emini';
        } else if (hours < 19) {
            return 'entsambama';
        } else {
            return 'ebusuku';
        }
    },
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'ekuseni') {
            return hour;
        } else if (meridiem === 'emini') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
            if (hour === 0) {
                return 0;
            }
            return hour + 12;
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}/,
    ordinal : '%d',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return ss;

})));


/***/ }),

/***/ 1556:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Swedish [sv]
//! author : Jens Alm : https://github.com/ulmus

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var sv = moment.defineLocale('sv', {
    months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
    weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
    weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
    weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY-MM-DD',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY [kl.] HH:mm',
        LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
        lll : 'D MMM YYYY HH:mm',
        llll : 'ddd D MMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Idag] LT',
        nextDay: '[Imorgon] LT',
        lastDay: '[Igår] LT',
        nextWeek: '[På] dddd LT',
        lastWeek: '[I] dddd[s] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'om %s',
        past : 'för %s sedan',
        s : 'några sekunder',
        m : 'en minut',
        mm : '%d minuter',
        h : 'en timme',
        hh : '%d timmar',
        d : 'en dag',
        dd : '%d dagar',
        M : 'en månad',
        MM : '%d månader',
        y : 'ett år',
        yy : '%d år'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(e|a)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'e' :
            (b === 1) ? 'a' :
            (b === 2) ? 'a' :
            (b === 3) ? 'e' : 'e';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return sv;

})));


/***/ }),

/***/ 1557:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Swahili [sw]
//! author : Fahad Kassim : https://github.com/fadsel

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var sw = moment.defineLocale('sw', {
    months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
    weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
    weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
    weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[leo saa] LT',
        nextDay : '[kesho saa] LT',
        nextWeek : '[wiki ijayo] dddd [saat] LT',
        lastDay : '[jana] LT',
        lastWeek : '[wiki iliyopita] dddd [saat] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s baadaye',
        past : 'tokea %s',
        s : 'hivi punde',
        m : 'dakika moja',
        mm : 'dakika %d',
        h : 'saa limoja',
        hh : 'masaa %d',
        d : 'siku moja',
        dd : 'masiku %d',
        M : 'mwezi mmoja',
        MM : 'miezi %d',
        y : 'mwaka mmoja',
        yy : 'miaka %d'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return sw;

})));


/***/ }),

/***/ 1558:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tamil [ta]
//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var symbolMap = {
    '1': '௧',
    '2': '௨',
    '3': '௩',
    '4': '௪',
    '5': '௫',
    '6': '௬',
    '7': '௭',
    '8': '௮',
    '9': '௯',
    '0': '௦'
};
var numberMap = {
    '௧': '1',
    '௨': '2',
    '௩': '3',
    '௪': '4',
    '௫': '5',
    '௬': '6',
    '௭': '7',
    '௮': '8',
    '௯': '9',
    '௦': '0'
};

var ta = moment.defineLocale('ta', {
    months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
    monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
    weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
    weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
    weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, HH:mm',
        LLLL : 'dddd, D MMMM YYYY, HH:mm'
    },
    calendar : {
        sameDay : '[இன்று] LT',
        nextDay : '[நாளை] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[நேற்று] LT',
        lastWeek : '[கடந்த வாரம்] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s இல்',
        past : '%s முன்',
        s : 'ஒரு சில விநாடிகள்',
        m : 'ஒரு நிமிடம்',
        mm : '%d நிமிடங்கள்',
        h : 'ஒரு மணி நேரம்',
        hh : '%d மணி நேரம்',
        d : 'ஒரு நாள்',
        dd : '%d நாட்கள்',
        M : 'ஒரு மாதம்',
        MM : '%d மாதங்கள்',
        y : 'ஒரு வருடம்',
        yy : '%d ஆண்டுகள்'
    },
    dayOfMonthOrdinalParse: /\d{1,2}வது/,
    ordinal : function (number) {
        return number + 'வது';
    },
    preparse: function (string) {
        return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
            return numberMap[match];
        });
    },
    postformat: function (string) {
        return string.replace(/\d/g, function (match) {
            return symbolMap[match];
        });
    },
    // refer http://ta.wikipedia.org/s/1er1
    meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
    meridiem : function (hour, minute, isLower) {
        if (hour < 2) {
            return ' யாமம்';
        } else if (hour < 6) {
            return ' வைகறை';  // வைகறை
        } else if (hour < 10) {
            return ' காலை'; // காலை
        } else if (hour < 14) {
            return ' நண்பகல்'; // நண்பகல்
        } else if (hour < 18) {
            return ' எற்பாடு'; // எற்பாடு
        } else if (hour < 22) {
            return ' மாலை'; // மாலை
        } else {
            return ' யாமம்';
        }
    },
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'யாமம்') {
            return hour < 2 ? hour : hour + 12;
        } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
            return hour;
        } else if (meridiem === 'நண்பகல்') {
            return hour >= 10 ? hour : hour + 12;
        } else {
            return hour + 12;
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return ta;

})));


/***/ }),

/***/ 1559:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Telugu [te]
//! author : Krishna Chaitanya Thota : https://github.com/kcthota

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var te = moment.defineLocale('te', {
    months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జూలై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
    monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జూలై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
    monthsParseExact : true,
    weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
    weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
    weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
    longDateFormat : {
        LT : 'A h:mm',
        LTS : 'A h:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY, A h:mm',
        LLLL : 'dddd, D MMMM YYYY, A h:mm'
    },
    calendar : {
        sameDay : '[నేడు] LT',
        nextDay : '[రేపు] LT',
        nextWeek : 'dddd, LT',
        lastDay : '[నిన్న] LT',
        lastWeek : '[గత] dddd, LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s లో',
        past : '%s క్రితం',
        s : 'కొన్ని క్షణాలు',
        m : 'ఒక నిమిషం',
        mm : '%d నిమిషాలు',
        h : 'ఒక గంట',
        hh : '%d గంటలు',
        d : 'ఒక రోజు',
        dd : '%d రోజులు',
        M : 'ఒక నెల',
        MM : '%d నెలలు',
        y : 'ఒక సంవత్సరం',
        yy : '%d సంవత్సరాలు'
    },
    dayOfMonthOrdinalParse : /\d{1,2}వ/,
    ordinal : '%dవ',
    meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === 'రాత్రి') {
            return hour < 4 ? hour : hour + 12;
        } else if (meridiem === 'ఉదయం') {
            return hour;
        } else if (meridiem === 'మధ్యాహ్నం') {
            return hour >= 10 ? hour : hour + 12;
        } else if (meridiem === 'సాయంత్రం') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'రాత్రి';
        } else if (hour < 10) {
            return 'ఉదయం';
        } else if (hour < 17) {
            return 'మధ్యాహ్నం';
        } else if (hour < 20) {
            return 'సాయంత్రం';
        } else {
            return 'రాత్రి';
        }
    },
    week : {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    }
});

return te;

})));


/***/ }),

/***/ 1560:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tetun Dili (East Timor) [tet]
//! author : Joshua Brooks : https://github.com/joshbrooks
//! author : Onorio De J. Afonso : https://github.com/marobo

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var tet = moment.defineLocale('tet', {
    months : 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juniu_Juliu_Augustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Aug_Set_Out_Nov_Dez'.split('_'),
    weekdays : 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sexta_Sabadu'.split('_'),
    weekdaysShort : 'Dom_Seg_Ters_Kua_Kint_Sext_Sab'.split('_'),
    weekdaysMin : 'Do_Seg_Te_Ku_Ki_Sex_Sa'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Ohin iha] LT',
        nextDay: '[Aban iha] LT',
        nextWeek: 'dddd [iha] LT',
        lastDay: '[Horiseik iha] LT',
        lastWeek: 'dddd [semana kotuk] [iha] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'iha %s',
        past : '%s liuba',
        s : 'minutu balun',
        m : 'minutu ida',
        mm : 'minutus %d',
        h : 'horas ida',
        hh : 'horas %d',
        d : 'loron ida',
        dd : 'loron %d',
        M : 'fulan ida',
        MM : 'fulan %d',
        y : 'tinan ida',
        yy : 'tinan %d'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return tet;

})));


/***/ }),

/***/ 1561:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Thai [th]
//! author : Kridsada Thanabulpong : https://github.com/sirn

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var th = moment.defineLocale('th', {
    months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
    monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
    monthsParseExact: true,
    weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
    weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
    weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'H:mm',
        LTS : 'H:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY เวลา H:mm',
        LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
    },
    meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
    isPM: function (input) {
        return input === 'หลังเที่ยง';
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'ก่อนเที่ยง';
        } else {
            return 'หลังเที่ยง';
        }
    },
    calendar : {
        sameDay : '[วันนี้ เวลา] LT',
        nextDay : '[พรุ่งนี้ เวลา] LT',
        nextWeek : 'dddd[หน้า เวลา] LT',
        lastDay : '[เมื่อวานนี้ เวลา] LT',
        lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'อีก %s',
        past : '%sที่แล้ว',
        s : 'ไม่กี่วินาที',
        m : '1 นาที',
        mm : '%d นาที',
        h : '1 ชั่วโมง',
        hh : '%d ชั่วโมง',
        d : '1 วัน',
        dd : '%d วัน',
        M : '1 เดือน',
        MM : '%d เดือน',
        y : '1 ปี',
        yy : '%d ปี'
    }
});

return th;

})));


/***/ }),

/***/ 1562:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tagalog (Philippines) [tl-ph]
//! author : Dan Hagman : https://github.com/hagmandan

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var tlPh = moment.defineLocale('tl-ph', {
    months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
    monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
    weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
    weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
    weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'MM/D/YYYY',
        LL : 'MMMM D, YYYY',
        LLL : 'MMMM D, YYYY HH:mm',
        LLLL : 'dddd, MMMM DD, YYYY HH:mm'
    },
    calendar : {
        sameDay: 'LT [ngayong araw]',
        nextDay: '[Bukas ng] LT',
        nextWeek: 'LT [sa susunod na] dddd',
        lastDay: 'LT [kahapon]',
        lastWeek: 'LT [noong nakaraang] dddd',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'sa loob ng %s',
        past : '%s ang nakalipas',
        s : 'ilang segundo',
        m : 'isang minuto',
        mm : '%d minuto',
        h : 'isang oras',
        hh : '%d oras',
        d : 'isang araw',
        dd : '%d araw',
        M : 'isang buwan',
        MM : '%d buwan',
        y : 'isang taon',
        yy : '%d taon'
    },
    dayOfMonthOrdinalParse: /\d{1,2}/,
    ordinal : function (number) {
        return number;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return tlPh;

})));


/***/ }),

/***/ 1563:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Klingon [tlh]
//! author : Dominika Kruk : https://github.com/amaranthrose

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');

function translateFuture(output) {
    var time = output;
    time = (output.indexOf('jaj') !== -1) ?
    time.slice(0, -3) + 'leS' :
    (output.indexOf('jar') !== -1) ?
    time.slice(0, -3) + 'waQ' :
    (output.indexOf('DIS') !== -1) ?
    time.slice(0, -3) + 'nem' :
    time + ' pIq';
    return time;
}

function translatePast(output) {
    var time = output;
    time = (output.indexOf('jaj') !== -1) ?
    time.slice(0, -3) + 'Hu’' :
    (output.indexOf('jar') !== -1) ?
    time.slice(0, -3) + 'wen' :
    (output.indexOf('DIS') !== -1) ?
    time.slice(0, -3) + 'ben' :
    time + ' ret';
    return time;
}

function translate(number, withoutSuffix, string, isFuture) {
    var numberNoun = numberAsNoun(number);
    switch (string) {
        case 'mm':
            return numberNoun + ' tup';
        case 'hh':
            return numberNoun + ' rep';
        case 'dd':
            return numberNoun + ' jaj';
        case 'MM':
            return numberNoun + ' jar';
        case 'yy':
            return numberNoun + ' DIS';
    }
}

function numberAsNoun(number) {
    var hundred = Math.floor((number % 1000) / 100),
    ten = Math.floor((number % 100) / 10),
    one = number % 10,
    word = '';
    if (hundred > 0) {
        word += numbersNouns[hundred] + 'vatlh';
    }
    if (ten > 0) {
        word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
    }
    if (one > 0) {
        word += ((word !== '') ? ' ' : '') + numbersNouns[one];
    }
    return (word === '') ? 'pagh' : word;
}

var tlh = moment.defineLocale('tlh', {
    months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
    monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
    monthsParseExact : true,
    weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
    weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
    weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[DaHjaj] LT',
        nextDay: '[wa’leS] LT',
        nextWeek: 'LLL',
        lastDay: '[wa’Hu’] LT',
        lastWeek: 'LLL',
        sameElse: 'L'
    },
    relativeTime : {
        future : translateFuture,
        past : translatePast,
        s : 'puS lup',
        m : 'wa’ tup',
        mm : translate,
        h : 'wa’ rep',
        hh : translate,
        d : 'wa’ jaj',
        dd : translate,
        M : 'wa’ jar',
        MM : translate,
        y : 'wa’ DIS',
        yy : translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return tlh;

})));


/***/ }),

/***/ 1564:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Turkish [tr]
//! authors : Erhan Gundogan : https://github.com/erhangundogan,
//!           Burak Yiğit Kaya: https://github.com/BYK

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var suffixes = {
    1: '\'inci',
    5: '\'inci',
    8: '\'inci',
    70: '\'inci',
    80: '\'inci',
    2: '\'nci',
    7: '\'nci',
    20: '\'nci',
    50: '\'nci',
    3: '\'üncü',
    4: '\'üncü',
    100: '\'üncü',
    6: '\'ncı',
    9: '\'uncu',
    10: '\'uncu',
    30: '\'uncu',
    60: '\'ıncı',
    90: '\'ıncı'
};

var tr = moment.defineLocale('tr', {
    months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
    monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
    weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
    weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
    weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[bugün saat] LT',
        nextDay : '[yarın saat] LT',
        nextWeek : '[haftaya] dddd [saat] LT',
        lastDay : '[dün] LT',
        lastWeek : '[geçen hafta] dddd [saat] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s sonra',
        past : '%s önce',
        s : 'birkaç saniye',
        m : 'bir dakika',
        mm : '%d dakika',
        h : 'bir saat',
        hh : '%d saat',
        d : 'bir gün',
        dd : '%d gün',
        M : 'bir ay',
        MM : '%d ay',
        y : 'bir yıl',
        yy : '%d yıl'
    },
    dayOfMonthOrdinalParse: /\d{1,2}'(inci|nci|üncü|ncı|uncu|ıncı)/,
    ordinal : function (number) {
        if (number === 0) {  // special case for zero
            return number + '\'ıncı';
        }
        var a = number % 10,
            b = number % 100 - a,
            c = number >= 100 ? 100 : null;
        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return tr;

})));


/***/ }),

/***/ 1565:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Talossan [tzl]
//! author : Robin van der Vliet : https://github.com/robin0van0der0v
//! author : Iustì Canun

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


// After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
// This is currently too difficult (maybe even impossible) to add.
var tzl = moment.defineLocale('tzl', {
    months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
    monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
    weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
    weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
    weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
    longDateFormat : {
        LT : 'HH.mm',
        LTS : 'HH.mm.ss',
        L : 'DD.MM.YYYY',
        LL : 'D. MMMM [dallas] YYYY',
        LLL : 'D. MMMM [dallas] YYYY HH.mm',
        LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
    },
    meridiemParse: /d\'o|d\'a/i,
    isPM : function (input) {
        return 'd\'o' === input.toLowerCase();
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'd\'o' : 'D\'O';
        } else {
            return isLower ? 'd\'a' : 'D\'A';
        }
    },
    calendar : {
        sameDay : '[oxhi à] LT',
        nextDay : '[demà à] LT',
        nextWeek : 'dddd [à] LT',
        lastDay : '[ieiri à] LT',
        lastWeek : '[sür el] dddd [lasteu à] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'osprei %s',
        past : 'ja%s',
        s : processRelativeTime,
        m : processRelativeTime,
        mm : processRelativeTime,
        h : processRelativeTime,
        hh : processRelativeTime,
        d : processRelativeTime,
        dd : processRelativeTime,
        M : processRelativeTime,
        MM : processRelativeTime,
        y : processRelativeTime,
        yy : processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal : '%d.',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
        's': ['viensas secunds', '\'iensas secunds'],
        'm': ['\'n míut', '\'iens míut'],
        'mm': [number + ' míuts', '' + number + ' míuts'],
        'h': ['\'n þora', '\'iensa þora'],
        'hh': [number + ' þoras', '' + number + ' þoras'],
        'd': ['\'n ziua', '\'iensa ziua'],
        'dd': [number + ' ziuas', '' + number + ' ziuas'],
        'M': ['\'n mes', '\'iens mes'],
        'MM': [number + ' mesen', '' + number + ' mesen'],
        'y': ['\'n ar', '\'iens ar'],
        'yy': [number + ' ars', '' + number + ' ars']
    };
    return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
}

return tzl;

})));


/***/ }),

/***/ 1566:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Central Atlas Tamazight [tzm]
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var tzm = moment.defineLocale('tzm', {
    months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
    monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
    weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
    weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
    weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS: 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
        nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
        nextWeek: 'dddd [ⴴ] LT',
        lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
        lastWeek: 'dddd [ⴴ] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
        past : 'ⵢⴰⵏ %s',
        s : 'ⵉⵎⵉⴽ',
        m : 'ⵎⵉⵏⵓⴺ',
        mm : '%d ⵎⵉⵏⵓⴺ',
        h : 'ⵙⴰⵄⴰ',
        hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
        d : 'ⴰⵙⵙ',
        dd : '%d oⵙⵙⴰⵏ',
        M : 'ⴰⵢoⵓⵔ',
        MM : '%d ⵉⵢⵢⵉⵔⵏ',
        y : 'ⴰⵙⴳⴰⵙ',
        yy : '%d ⵉⵙⴳⴰⵙⵏ'
    },
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return tzm;

})));


/***/ }),

/***/ 1567:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Central Atlas Tamazight Latin [tzm-latn]
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var tzmLatn = moment.defineLocale('tzm-latn', {
    months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
    monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
    weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
    weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
    weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[asdkh g] LT',
        nextDay: '[aska g] LT',
        nextWeek: 'dddd [g] LT',
        lastDay: '[assant g] LT',
        lastWeek: 'dddd [g] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : 'dadkh s yan %s',
        past : 'yan %s',
        s : 'imik',
        m : 'minuḍ',
        mm : '%d minuḍ',
        h : 'saɛa',
        hh : '%d tassaɛin',
        d : 'ass',
        dd : '%d ossan',
        M : 'ayowr',
        MM : '%d iyyirn',
        y : 'asgas',
        yy : '%d isgasn'
    },
    week : {
        dow : 6, // Saturday is the first day of the week.
        doy : 12  // The week that contains Jan 1st is the first week of the year.
    }
});

return tzmLatn;

})));


/***/ }),

/***/ 1568:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Ukrainian [uk]
//! author : zemlanin : https://github.com/zemlanin
//! Author : Menelion Elensúle : https://github.com/Oire

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


function plural(word, num) {
    var forms = word.split('_');
    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
}
function relativeTimeWithPlural(number, withoutSuffix, key) {
    var format = {
        'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
        'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
        'dd': 'день_дні_днів',
        'MM': 'місяць_місяці_місяців',
        'yy': 'рік_роки_років'
    };
    if (key === 'm') {
        return withoutSuffix ? 'хвилина' : 'хвилину';
    }
    else if (key === 'h') {
        return withoutSuffix ? 'година' : 'годину';
    }
    else {
        return number + ' ' + plural(format[key], +number);
    }
}
function weekdaysCaseReplace(m, format) {
    var weekdays = {
        'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
        'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
        'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
    };

    if (!m) {
        return weekdays['nominative'];
    }

    var nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
        'accusative' :
        ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
            'genitive' :
            'nominative');
    return weekdays[nounCase][m.day()];
}
function processHoursFunction(str) {
    return function () {
        return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
    };
}

var uk = moment.defineLocale('uk', {
    months : {
        'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
        'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
    },
    monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
    weekdays : weekdaysCaseReplace,
    weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD.MM.YYYY',
        LL : 'D MMMM YYYY р.',
        LLL : 'D MMMM YYYY р., HH:mm',
        LLLL : 'dddd, D MMMM YYYY р., HH:mm'
    },
    calendar : {
        sameDay: processHoursFunction('[Сьогодні '),
        nextDay: processHoursFunction('[Завтра '),
        lastDay: processHoursFunction('[Вчора '),
        nextWeek: processHoursFunction('[У] dddd ['),
        lastWeek: function () {
            switch (this.day()) {
                case 0:
                case 3:
                case 5:
                case 6:
                    return processHoursFunction('[Минулої] dddd [').call(this);
                case 1:
                case 2:
                case 4:
                    return processHoursFunction('[Минулого] dddd [').call(this);
            }
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'за %s',
        past : '%s тому',
        s : 'декілька секунд',
        m : relativeTimeWithPlural,
        mm : relativeTimeWithPlural,
        h : 'годину',
        hh : relativeTimeWithPlural,
        d : 'день',
        dd : relativeTimeWithPlural,
        M : 'місяць',
        MM : relativeTimeWithPlural,
        y : 'рік',
        yy : relativeTimeWithPlural
    },
    // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
    meridiemParse: /ночі|ранку|дня|вечора/,
    isPM: function (input) {
        return /^(дня|вечора)$/.test(input);
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 4) {
            return 'ночі';
        } else if (hour < 12) {
            return 'ранку';
        } else if (hour < 17) {
            return 'дня';
        } else {
            return 'вечора';
        }
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
    ordinal: function (number, period) {
        switch (period) {
            case 'M':
            case 'd':
            case 'DDD':
            case 'w':
            case 'W':
                return number + '-й';
            case 'D':
                return number + '-го';
            default:
                return number;
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return uk;

})));


/***/ }),

/***/ 1569:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Urdu [ur]
//! author : Sawood Alam : https://github.com/ibnesayeed
//! author : Zack : https://github.com/ZackVision

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var months = [
    'جنوری',
    'فروری',
    'مارچ',
    'اپریل',
    'مئی',
    'جون',
    'جولائی',
    'اگست',
    'ستمبر',
    'اکتوبر',
    'نومبر',
    'دسمبر'
];
var days = [
    'اتوار',
    'پیر',
    'منگل',
    'بدھ',
    'جمعرات',
    'جمعہ',
    'ہفتہ'
];

var ur = moment.defineLocale('ur', {
    months : months,
    monthsShort : months,
    weekdays : days,
    weekdaysShort : days,
    weekdaysMin : days,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd، D MMMM YYYY HH:mm'
    },
    meridiemParse: /صبح|شام/,
    isPM : function (input) {
        return 'شام' === input;
    },
    meridiem : function (hour, minute, isLower) {
        if (hour < 12) {
            return 'صبح';
        }
        return 'شام';
    },
    calendar : {
        sameDay : '[آج بوقت] LT',
        nextDay : '[کل بوقت] LT',
        nextWeek : 'dddd [بوقت] LT',
        lastDay : '[گذشتہ روز بوقت] LT',
        lastWeek : '[گذشتہ] dddd [بوقت] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : '%s بعد',
        past : '%s قبل',
        s : 'چند سیکنڈ',
        m : 'ایک منٹ',
        mm : '%d منٹ',
        h : 'ایک گھنٹہ',
        hh : '%d گھنٹے',
        d : 'ایک دن',
        dd : '%d دن',
        M : 'ایک ماہ',
        MM : '%d ماہ',
        y : 'ایک سال',
        yy : '%d سال'
    },
    preparse: function (string) {
        return string.replace(/،/g, ',');
    },
    postformat: function (string) {
        return string.replace(/,/g, '،');
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return ur;

})));


/***/ }),

/***/ 1570:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uzbek [uz]
//! author : Sardor Muminov : https://github.com/muminoff

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var uz = moment.defineLocale('uz', {
    months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
    monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
    weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
    weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
    weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'D MMMM YYYY, dddd HH:mm'
    },
    calendar : {
        sameDay : '[Бугун соат] LT [да]',
        nextDay : '[Эртага] LT [да]',
        nextWeek : 'dddd [куни соат] LT [да]',
        lastDay : '[Кеча соат] LT [да]',
        lastWeek : '[Утган] dddd [куни соат] LT [да]',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'Якин %s ичида',
        past : 'Бир неча %s олдин',
        s : 'фурсат',
        m : 'бир дакика',
        mm : '%d дакика',
        h : 'бир соат',
        hh : '%d соат',
        d : 'бир кун',
        dd : '%d кун',
        M : 'бир ой',
        MM : '%d ой',
        y : 'бир йил',
        yy : '%d йил'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 4th is the first week of the year.
    }
});

return uz;

})));


/***/ }),

/***/ 1571:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uzbek Latin [uz-latn]
//! author : Rasulbek Mirzayev : github.com/Rasulbeeek

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var uzLatn = moment.defineLocale('uz-latn', {
    months : 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split('_'),
    monthsShort : 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
    weekdays : 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split('_'),
    weekdaysShort : 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
    weekdaysMin : 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'D MMMM YYYY, dddd HH:mm'
    },
    calendar : {
        sameDay : '[Bugun soat] LT [da]',
        nextDay : '[Ertaga] LT [da]',
        nextWeek : 'dddd [kuni soat] LT [da]',
        lastDay : '[Kecha soat] LT [da]',
        lastWeek : '[O\'tgan] dddd [kuni soat] LT [da]',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'Yaqin %s ichida',
        past : 'Bir necha %s oldin',
        s : 'soniya',
        m : 'bir daqiqa',
        mm : '%d daqiqa',
        h : 'bir soat',
        hh : '%d soat',
        d : 'bir kun',
        dd : '%d kun',
        M : 'bir oy',
        MM : '%d oy',
        y : 'bir yil',
        yy : '%d yil'
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 7  // The week that contains Jan 1st is the first week of the year.
    }
});

return uzLatn;

})));


/***/ }),

/***/ 1572:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Vietnamese [vi]
//! author : Bang Nguyen : https://github.com/bangnk

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var vi = moment.defineLocale('vi', {
    months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
    monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
    monthsParseExact : true,
    weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
    weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
    weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
    weekdaysParseExact : true,
    meridiemParse: /sa|ch/i,
    isPM : function (input) {
        return /^ch$/i.test(input);
    },
    meridiem : function (hours, minutes, isLower) {
        if (hours < 12) {
            return isLower ? 'sa' : 'SA';
        } else {
            return isLower ? 'ch' : 'CH';
        }
    },
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM [năm] YYYY',
        LLL : 'D MMMM [năm] YYYY HH:mm',
        LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
        l : 'DD/M/YYYY',
        ll : 'D MMM YYYY',
        lll : 'D MMM YYYY HH:mm',
        llll : 'ddd, D MMM YYYY HH:mm'
    },
    calendar : {
        sameDay: '[Hôm nay lúc] LT',
        nextDay: '[Ngày mai lúc] LT',
        nextWeek: 'dddd [tuần tới lúc] LT',
        lastDay: '[Hôm qua lúc] LT',
        lastWeek: 'dddd [tuần rồi lúc] LT',
        sameElse: 'L'
    },
    relativeTime : {
        future : '%s tới',
        past : '%s trước',
        s : 'vài giây',
        m : 'một phút',
        mm : '%d phút',
        h : 'một giờ',
        hh : '%d giờ',
        d : 'một ngày',
        dd : '%d ngày',
        M : 'một tháng',
        MM : '%d tháng',
        y : 'một năm',
        yy : '%d năm'
    },
    dayOfMonthOrdinalParse: /\d{1,2}/,
    ordinal : function (number) {
        return number;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return vi;

})));


/***/ }),

/***/ 1573:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Pseudo [x-pseudo]
//! author : Andrew Hood : https://github.com/andrewhood125

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var xPseudo = moment.defineLocale('x-pseudo', {
    months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
    monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
    monthsParseExact : true,
    weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
    weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
    weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd, D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[T~ódá~ý át] LT',
        nextDay : '[T~ómó~rró~w át] LT',
        nextWeek : 'dddd [át] LT',
        lastDay : '[Ý~ést~érdá~ý át] LT',
        lastWeek : '[L~ást] dddd [át] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'í~ñ %s',
        past : '%s á~gó',
        s : 'á ~féw ~sécó~ñds',
        m : 'á ~míñ~úté',
        mm : '%d m~íñú~tés',
        h : 'á~ñ hó~úr',
        hh : '%d h~óúrs',
        d : 'á ~dáý',
        dd : '%d d~áýs',
        M : 'á ~móñ~th',
        MM : '%d m~óñt~hs',
        y : 'á ~ýéár',
        yy : '%d ý~éárs'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (~~(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return xPseudo;

})));


/***/ }),

/***/ 1574:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Yoruba Nigeria [yo]
//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var yo = moment.defineLocale('yo', {
    months : 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
    monthsShort : 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
    weekdays : 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
    weekdaysShort : 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
    weekdaysMin : 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
    longDateFormat : {
        LT : 'h:mm A',
        LTS : 'h:mm:ss A',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY h:mm A',
        LLLL : 'dddd, D MMMM YYYY h:mm A'
    },
    calendar : {
        sameDay : '[Ònì ni] LT',
        nextDay : '[Ọ̀la ni] LT',
        nextWeek : 'dddd [Ọsẹ̀ tón\'bọ] [ni] LT',
        lastDay : '[Àna ni] LT',
        lastWeek : 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'ní %s',
        past : '%s kọjá',
        s : 'ìsẹjú aayá die',
        m : 'ìsẹjú kan',
        mm : 'ìsẹjú %d',
        h : 'wákati kan',
        hh : 'wákati %d',
        d : 'ọjọ́ kan',
        dd : 'ọjọ́ %d',
        M : 'osù kan',
        MM : 'osù %d',
        y : 'ọdún kan',
        yy : 'ọdún %d'
    },
    dayOfMonthOrdinalParse : /ọjọ́\s\d{1,2}/,
    ordinal : 'ọjọ́ %d',
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4 // The week that contains Jan 4th is the first week of the year.
    }
});

return yo;

})));


/***/ }),

/***/ 1575:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (China) [zh-cn]
//! author : suupic : https://github.com/suupic
//! author : Zeno Zeng : https://github.com/zenozeng

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var zhCn = moment.defineLocale('zh-cn', {
    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
    weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY年MMMD日',
        LL : 'YYYY年MMMD日',
        LLL : 'YYYY年MMMD日Ah点mm分',
        LLLL : 'YYYY年MMMD日ddddAh点mm分',
        l : 'YYYY年MMMD日',
        ll : 'YYYY年MMMD日',
        lll : 'YYYY年MMMD日 HH:mm',
        llll : 'YYYY年MMMD日dddd HH:mm'
    },
    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
    meridiemHour: function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === '凌晨' || meridiem === '早上' ||
                meridiem === '上午') {
            return hour;
        } else if (meridiem === '下午' || meridiem === '晚上') {
            return hour + 12;
        } else {
            // '中午'
            return hour >= 11 ? hour : hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        var hm = hour * 100 + minute;
        if (hm < 600) {
            return '凌晨';
        } else if (hm < 900) {
            return '早上';
        } else if (hm < 1130) {
            return '上午';
        } else if (hm < 1230) {
            return '中午';
        } else if (hm < 1800) {
            return '下午';
        } else {
            return '晚上';
        }
    },
    calendar : {
        sameDay : '[今天]LT',
        nextDay : '[明天]LT',
        nextWeek : '[下]ddddLT',
        lastDay : '[昨天]LT',
        lastWeek : '[上]ddddLT',
        sameElse : 'L'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
    ordinal : function (number, period) {
        switch (period) {
            case 'd':
            case 'D':
            case 'DDD':
                return number + '日';
            case 'M':
                return number + '月';
            case 'w':
            case 'W':
                return number + '周';
            default:
                return number;
        }
    },
    relativeTime : {
        future : '%s内',
        past : '%s前',
        s : '几秒',
        m : '1 分钟',
        mm : '%d 分钟',
        h : '1 小时',
        hh : '%d 小时',
        d : '1 天',
        dd : '%d 天',
        M : '1 个月',
        MM : '%d 个月',
        y : '1 年',
        yy : '%d 年'
    },
    week : {
        // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return zhCn;

})));


/***/ }),

/***/ 1576:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Hong Kong) [zh-hk]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris
//! author : Konstantin : https://github.com/skfd

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var zhHk = moment.defineLocale('zh-hk', {
    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY年MMMD日',
        LL : 'YYYY年MMMD日',
        LLL : 'YYYY年MMMD日 HH:mm',
        LLLL : 'YYYY年MMMD日dddd HH:mm',
        l : 'YYYY年MMMD日',
        ll : 'YYYY年MMMD日',
        lll : 'YYYY年MMMD日 HH:mm',
        llll : 'YYYY年MMMD日dddd HH:mm'
    },
    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
            return hour;
        } else if (meridiem === '中午') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === '下午' || meridiem === '晚上') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        var hm = hour * 100 + minute;
        if (hm < 600) {
            return '凌晨';
        } else if (hm < 900) {
            return '早上';
        } else if (hm < 1130) {
            return '上午';
        } else if (hm < 1230) {
            return '中午';
        } else if (hm < 1800) {
            return '下午';
        } else {
            return '晚上';
        }
    },
    calendar : {
        sameDay : '[今天]LT',
        nextDay : '[明天]LT',
        nextWeek : '[下]ddddLT',
        lastDay : '[昨天]LT',
        lastWeek : '[上]ddddLT',
        sameElse : 'L'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
    ordinal : function (number, period) {
        switch (period) {
            case 'd' :
            case 'D' :
            case 'DDD' :
                return number + '日';
            case 'M' :
                return number + '月';
            case 'w' :
            case 'W' :
                return number + '週';
            default :
                return number;
        }
    },
    relativeTime : {
        future : '%s內',
        past : '%s前',
        s : '幾秒',
        m : '1 分鐘',
        mm : '%d 分鐘',
        h : '1 小時',
        hh : '%d 小時',
        d : '1 天',
        dd : '%d 天',
        M : '1 個月',
        MM : '%d 個月',
        y : '1 年',
        yy : '%d 年'
    }
});

return zhHk;

})));


/***/ }),

/***/ 1577:
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Taiwan) [zh-tw]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris

;(function (global, factory) {
    true ? factory(__webpack_require__(764)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var zhTw = moment.defineLocale('zh-tw', {
    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'YYYY年MMMD日',
        LL : 'YYYY年MMMD日',
        LLL : 'YYYY年MMMD日 HH:mm',
        LLLL : 'YYYY年MMMD日dddd HH:mm',
        l : 'YYYY年MMMD日',
        ll : 'YYYY年MMMD日',
        lll : 'YYYY年MMMD日 HH:mm',
        llll : 'YYYY年MMMD日dddd HH:mm'
    },
    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
    meridiemHour : function (hour, meridiem) {
        if (hour === 12) {
            hour = 0;
        }
        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
            return hour;
        } else if (meridiem === '中午') {
            return hour >= 11 ? hour : hour + 12;
        } else if (meridiem === '下午' || meridiem === '晚上') {
            return hour + 12;
        }
    },
    meridiem : function (hour, minute, isLower) {
        var hm = hour * 100 + minute;
        if (hm < 600) {
            return '凌晨';
        } else if (hm < 900) {
            return '早上';
        } else if (hm < 1130) {
            return '上午';
        } else if (hm < 1230) {
            return '中午';
        } else if (hm < 1800) {
            return '下午';
        } else {
            return '晚上';
        }
    },
    calendar : {
        sameDay : '[今天]LT',
        nextDay : '[明天]LT',
        nextWeek : '[下]ddddLT',
        lastDay : '[昨天]LT',
        lastWeek : '[上]ddddLT',
        sameElse : 'L'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
    ordinal : function (number, period) {
        switch (period) {
            case 'd' :
            case 'D' :
            case 'DDD' :
                return number + '日';
            case 'M' :
                return number + '月';
            case 'w' :
            case 'W' :
                return number + '週';
            default :
                return number;
        }
    },
    relativeTime : {
        future : '%s內',
        past : '%s前',
        s : '幾秒',
        m : '1 分鐘',
        mm : '%d 分鐘',
        h : '1 小時',
        hh : '%d 小時',
        d : '1 天',
        dd : '%d 天',
        M : '1 個月',
        MM : '%d 個月',
        y : '1 年',
        yy : '%d 年'
    }
});

return zhTw;

})));


/***/ }),

/***/ 1578:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(272);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactIntl = __webpack_require__(761);

var _chart = __webpack_require__(1459);

var _chart2 = _interopRequireDefault(_chart);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var LineChart = function (_React$PureComponent) {
    (0, _inherits3.default)(LineChart, _React$PureComponent);

    function LineChart() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, LineChart);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = LineChart.__proto__ || (0, _getPrototypeOf2.default)(LineChart)).call.apply(_ref, [this].concat(args))), _this), _this.chart = null, _this.chartOptions = {
            legend: {
                display: false
            }
        }, _this.initChart = function (update) {
            if (!_this.refs.canvas) {
                return;
            }

            var el = _reactDom2.default.findDOMNode(_this.refs.canvas);
            var ctx = el.getContext('2d');
            _this.chart = new _chart2.default(ctx, { type: 'line', data: _this.props.data, options: _this.chartOptions || {} }); // eslint-disable-line new-cap

            if (update) {
                _this.chart.update();
            }
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(LineChart, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.initChart();
        }
    }, {
        key: 'componentWillUpdate',
        value: function componentWillUpdate(nextProps) {
            var willHaveData = nextProps.data && nextProps.data.labels.length > 0;
            var hasChart = Boolean(this.chart);

            if (!willHaveData && hasChart) {
                // Clean up the rendered chart before we render and destroy its context
                this.chart.destroy();
                this.chart = null;
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            if (Utils.areObjectsEqual(prevProps.data, this.props.data)) {
                return;
            }

            var hasData = this.props.data && this.props.data.labels.length > 0;
            var hasChart = Boolean(this.chart);

            if (hasData) {
                // Update the rendered chart or initialize it as necessary
                this.initChart(hasChart);
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.chart) {
                this.chart.destroy();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var content = void 0;
            if (this.props.data == null) {
                content = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'analytics.chart.loading',
                    defaultMessage: 'Loading...'
                });
            } else if (this.props.data.labels.length === 0) {
                content = _react2.default.createElement(
                    'h5',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'analytics.chart.meaningful',
                        defaultMessage: 'Not enough data for a meaningful representation.'
                    })
                );
            } else {
                content = _react2.default.createElement('canvas', {
                    ref: 'canvas',
                    width: this.props.width,
                    height: this.props.height
                });
            }

            return _react2.default.createElement(
                'div',
                { className: 'col-sm-12' },
                _react2.default.createElement(
                    'div',
                    { className: 'total-count by-day' },
                    _react2.default.createElement(
                        'div',
                        { className: 'title' },
                        this.props.title
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'content' },
                        content
                    )
                )
            );
        }
    }]);
    return LineChart;
}(_react2.default.PureComponent);

LineChart.propTypes = {

    /*
     * Chart title
     */
    title: _propTypes2.default.node.isRequired,

    /*
     * Chart width
     */
    width: _propTypes2.default.number.isRequired,

    /*
     * Chart height
     */
    height: _propTypes2.default.number.isRequired,

    /*
     * Chart data
     */
    data: _propTypes2.default.object
};
exports.default = LineChart;

/***/ }),

/***/ 1579:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StatisticCount = function (_React$PureComponent) {
    (0, _inherits3.default)(StatisticCount, _React$PureComponent);

    function StatisticCount() {
        (0, _classCallCheck3.default)(this, StatisticCount);
        return (0, _possibleConstructorReturn3.default)(this, (StatisticCount.__proto__ || (0, _getPrototypeOf2.default)(StatisticCount)).apply(this, arguments));
    }

    (0, _createClass3.default)(StatisticCount, [{
        key: 'render',
        value: function render() {
            var loading = _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'analytics.chart.loading',
                defaultMessage: 'Loading...'
            });

            return _react2.default.createElement(
                'div',
                { className: 'col-md-3 col-sm-6' },
                _react2.default.createElement(
                    'div',
                    { className: 'total-count' },
                    _react2.default.createElement(
                        'div',
                        { className: 'title' },
                        this.props.title,
                        _react2.default.createElement('i', { className: 'fa ' + this.props.icon })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'content' },
                        isNaN(this.props.count) ? loading : this.props.count
                    )
                )
            );
        }
    }]);
    return StatisticCount;
}(_react2.default.PureComponent); // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

StatisticCount.propTypes = {

    /*
     * Statistic title
     */
    title: _propTypes2.default.node.isRequired,

    /*
     * Statistic icon
     */
    icon: _propTypes2.default.string.isRequired,

    /*
     * Data count
     */
    count: _propTypes2.default.number
};
exports.default = StatisticCount;

/***/ }),

/***/ 1580:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.formatChannelDoughtnutData = formatChannelDoughtnutData;
exports.formatPostDoughtnutData = formatPostDoughtnutData;
exports.formatPostsPerDayData = formatPostsPerDayData;
exports.formatUsersWithPostsPerDayData = formatUsersWithPostsPerDayData;

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function formatChannelDoughtnutData(totalPublic, totalPrivate) {
    var channelTypeData = {
        labels: [Utils.localizeMessage('analytics.system.publicChannels', 'Public Channels'), Utils.localizeMessage('analytics.system.privateGroups', 'Private Channels')],
        datasets: [{
            data: [totalPublic, totalPrivate],
            backgroundColor: ['#46BFBD', '#FDB45C'],
            hoverBackgroundColor: ['#5AD3D1', '#FFC870']
        }]
    };

    return channelTypeData;
}

function formatPostDoughtnutData(filePosts, hashtagPosts, totalPosts) {
    var postTypeData = {
        labels: [Utils.localizeMessage('analytics.system.totalFilePosts', 'Posts with Files'), Utils.localizeMessage('analytics.system.totalHashtagPosts', 'Posts with Hashtags'), Utils.localizeMessage('analytics.system.textPosts', 'Posts with Text-only')],
        datasets: [{
            data: [filePosts, hashtagPosts, totalPosts - filePosts - hashtagPosts],
            backgroundColor: ['#46BFBD', '#F7464A', '#FDB45C'],
            hoverBackgroundColor: ['#5AD3D1', '#FF5A5E', '#FFC870']
        }]
    };

    return postTypeData;
}

function formatPostsPerDayData(data) {
    var chartData = {
        labels: [],
        datasets: [{
            fillColor: 'rgba(151,187,205,0.2)',
            borderColor: 'rgba(151,187,205,1)',
            pointBackgroundColor: 'rgba(151,187,205,1)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(151,187,205,1)',
            data: []
        }]
    };

    for (var index in data) {
        if (data[index]) {
            var row = data[index];
            chartData.labels.push(row.name);
            chartData.datasets[0].data.push(row.value);
        }
    }

    return chartData;
}

function formatUsersWithPostsPerDayData(data) {
    var chartData = {
        labels: [],
        datasets: [{
            label: '',
            fillColor: 'rgba(151,187,205,0.2)',
            borderColor: 'rgba(151,187,205,1)',
            pointBackgroundColor: 'rgba(151,187,205,1)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(151,187,205,1)',
            data: []
        }]
    };

    for (var index in data) {
        if (data[index]) {
            var row = data[index];
            chartData.labels.push(row.name);
            chartData.datasets[0].data.push(row.value);
        }
    }

    return chartData;
}

/***/ }),

/***/ 2567:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _redux = __webpack_require__(1);

var _admin = __webpack_require__(855);

var _admin2 = __webpack_require__(995);

var Selectors = _interopRequireWildcard(_admin2);

var _reactRouterDom = __webpack_require__(269);

var _general = __webpack_require__(113);

var _users = __webpack_require__(777);

var _admin_actions = __webpack_require__(797);

var _admin3 = __webpack_require__(963);

var _admin_console = __webpack_require__(2568);

var _admin_console2 = _interopRequireDefault(_admin_console);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapStateToProps(state) {
    return {
        config: Selectors.getConfig(state),
        license: (0, _general.getLicense)(state),
        navigationBlocked: (0, _admin3.getNavigationBlocked)(state),
        showNavigationPrompt: (0, _admin3.showNavigationPrompt)(state),
        isCurrentUserSystemAdmin: (0, _users.isCurrentUserSystemAdmin)(state)
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: (0, _redux.bindActionCreators)({
            getConfig: _admin.getConfig,
            setNavigationBlocked: _admin_actions.setNavigationBlocked,
            deferNavigation: _admin_actions.deferNavigation,
            cancelNavigation: _admin_actions.cancelNavigation,
            confirmNavigation: _admin_actions.confirmNavigation
        }, dispatch)
    };
}

exports.default = (0, _reactRouterDom.withRouter)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_admin_console2.default));

/***/ }),

/***/ 2568:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = __webpack_require__(116);

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(810);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

__webpack_require__(1411);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(269);

var _announcement_bar = __webpack_require__(882);

var _announcement_bar2 = _interopRequireDefault(_announcement_bar);

var _global_actions = __webpack_require__(778);

var _client_versions_settings = __webpack_require__(2569);

var _client_versions_settings2 = _interopRequireDefault(_client_versions_settings);

var _cluster_settings = __webpack_require__(2570);

var _cluster_settings2 = _interopRequireDefault(_cluster_settings);

var _connection_settings = __webpack_require__(2575);

var _connection_settings2 = _interopRequireDefault(_connection_settings);

var _custom_brand_settings = __webpack_require__(2576);

var _custom_brand_settings2 = _interopRequireDefault(_custom_brand_settings);

var _custom_emoji_settings = __webpack_require__(2579);

var _custom_emoji_settings2 = _interopRequireDefault(_custom_emoji_settings);

var _data_retention_settings = __webpack_require__(2580);

var _data_retention_settings2 = _interopRequireDefault(_data_retention_settings);

var _database_settings = __webpack_require__(2584);

var _database_settings2 = _interopRequireDefault(_database_settings);

var _developer_settings = __webpack_require__(2585);

var _developer_settings2 = _interopRequireDefault(_developer_settings);

var _elasticsearch_settings = __webpack_require__(2586);

var _elasticsearch_settings2 = _interopRequireDefault(_elasticsearch_settings);

var _email_settings = __webpack_require__(2587);

var _email_settings2 = _interopRequireDefault(_email_settings);

var _external_service_settings = __webpack_require__(2590);

var _external_service_settings2 = _interopRequireDefault(_external_service_settings);

var _gitlab_settings = __webpack_require__(2591);

var _gitlab_settings2 = _interopRequireDefault(_gitlab_settings);

var _ldap_settings = __webpack_require__(2592);

var _ldap_settings2 = _interopRequireDefault(_ldap_settings);

var _legal_and_support_settings = __webpack_require__(2593);

var _legal_and_support_settings2 = _interopRequireDefault(_legal_and_support_settings);

var _link_previews_settings = __webpack_require__(2594);

var _link_previews_settings2 = _interopRequireDefault(_link_previews_settings);

var _message_export_settings = __webpack_require__(2595);

var _message_export_settings2 = _interopRequireDefault(_message_export_settings);

var _metrics_settings = __webpack_require__(2596);

var _metrics_settings2 = _interopRequireDefault(_metrics_settings);

var _native_app_link_settings = __webpack_require__(2597);

var _native_app_link_settings2 = _interopRequireDefault(_native_app_link_settings);

var _oauth_settings = __webpack_require__(2598);

var _oauth_settings2 = _interopRequireDefault(_oauth_settings);

var _password_settings = __webpack_require__(2599);

var _password_settings2 = _interopRequireDefault(_password_settings);

var _plugin_settings = __webpack_require__(2600);

var _plugin_settings2 = _interopRequireDefault(_plugin_settings);

var _plugin_management = __webpack_require__(2601);

var _plugin_management2 = _interopRequireDefault(_plugin_management);

var _custom_plugin_settings = __webpack_require__(2603);

var _custom_plugin_settings2 = _interopRequireDefault(_custom_plugin_settings);

var _policy_settings = __webpack_require__(2607);

var _policy_settings2 = _interopRequireDefault(_policy_settings);

var _custom_integrations_settings = __webpack_require__(2611);

var _custom_integrations_settings2 = _interopRequireDefault(_custom_integrations_settings);

var _users_and_teams_settings = __webpack_require__(2613);

var _users_and_teams_settings2 = _interopRequireDefault(_users_and_teams_settings);

var _schema_admin_settings = __webpack_require__(1456);

var _schema_admin_settings2 = _interopRequireDefault(_schema_admin_settings);

var _public_link_settings = __webpack_require__(2615);

var _public_link_settings2 = _interopRequireDefault(_public_link_settings);

var _push_settings = __webpack_require__(2616);

var _push_settings2 = _interopRequireDefault(_push_settings);

var _rate_settings = __webpack_require__(2617);

var _rate_settings2 = _interopRequireDefault(_rate_settings);

var _saml_settings = __webpack_require__(2618);

var _saml_settings2 = _interopRequireDefault(_saml_settings);

var _session_settings = __webpack_require__(2621);

var _session_settings2 = _interopRequireDefault(_session_settings);

var _signup_settings = __webpack_require__(2622);

var _signup_settings2 = _interopRequireDefault(_signup_settings);

var _storage_settings = __webpack_require__(2623);

var _storage_settings2 = _interopRequireDefault(_storage_settings);

var _webrtc_settings = __webpack_require__(2626);

var _webrtc_settings2 = _interopRequireDefault(_webrtc_settings);

var _discard_changes_modal = __webpack_require__(2627);

var _discard_changes_modal2 = _interopRequireDefault(_discard_changes_modal);

var _admin_sidebar = __webpack_require__(2628);

var _admin_sidebar2 = _interopRequireDefault(_admin_sidebar);

var _admin_definition = __webpack_require__(2636);

var _admin_definition2 = _interopRequireDefault(_admin_definition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var SCRoute = function SCRoute(_ref) {
    var Component = _ref.component,
        extraProps = _ref.extraProps,
        rest = (0, _objectWithoutProperties3.default)(_ref, ['component', 'extraProps']);
    return (//eslint-disable-line react/prop-types
        _react2.default.createElement(_reactRouterDom.Route, (0, _extends3.default)({}, rest, {
            render: function render(props) {
                return _react2.default.createElement(Component, (0, _extends3.default)({}, extraProps, props));
            }
        }))
    );
};

var AdminConsole = function (_React$Component) {
    (0, _inherits3.default)(AdminConsole, _React$Component);

    function AdminConsole() {
        (0, _classCallCheck3.default)(this, AdminConsole);
        return (0, _possibleConstructorReturn3.default)(this, (AdminConsole.__proto__ || (0, _getPrototypeOf2.default)(AdminConsole)).apply(this, arguments));
    }

    (0, _createClass3.default)(AdminConsole, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.props.actions.getConfig();
            (0, _global_actions.reloadIfServerVersionChanged)();
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                license = _props.license,
                config = _props.config,
                showNavigationPrompt = _props.showNavigationPrompt;
            var _props$actions = this.props.actions,
                setNavigationBlocked = _props$actions.setNavigationBlocked,
                cancelNavigation = _props$actions.cancelNavigation,
                confirmNavigation = _props$actions.confirmNavigation;


            if (!this.props.isCurrentUserSystemAdmin) {
                return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/' });
            }

            if ((0, _keys2.default)(config).length === 0) {
                return _react2.default.createElement('div', null);
            }
            if (config && (0, _keys2.default)(config).length === 0 && config.constructor === 'Object') {
                return _react2.default.createElement(
                    'div',
                    { className: 'admin-console__wrapper' },
                    _react2.default.createElement(_announcement_bar2.default, null),
                    _react2.default.createElement('div', { className: 'admin-console' })
                );
            }

            var discardChangesModal = _react2.default.createElement(_discard_changes_modal2.default, {
                show: showNavigationPrompt,
                onConfirm: confirmNavigation,
                onCancel: cancelNavigation
            });

            // not every page in the system console will need the license and config, but the vast majority will
            var extraProps = { license: license, config: config, setNavigationBlocked: setNavigationBlocked };
            return _react2.default.createElement(
                'div',
                { className: 'admin-console__wrapper' },
                _react2.default.createElement(_announcement_bar2.default, null),
                _react2.default.createElement(_admin_sidebar2.default, null),
                _react2.default.createElement(
                    'div',
                    { className: 'admin-console' },
                    _react2.default.createElement(
                        _reactRouterDom.Switch,
                        null,
                        _react2.default.createElement(SCRoute, {
                            path: this.props.match.url + '/system_analytics',
                            component: _schema_admin_settings2.default,
                            extraProps: (0, _extends3.default)({}, extraProps, {
                                schema: _admin_definition2.default.reporting.system_analytics.schema
                            })
                        }),
                        _react2.default.createElement(_reactRouterDom.Route, {
                            path: this.props.match.url + '/general',
                            render: function render(props) {
                                return _react2.default.createElement(
                                    _reactRouterDom.Switch,
                                    null,
                                    _react2.default.createElement(SCRoute, {
                                        path: props.match.url + '/configuration',
                                        component: _schema_admin_settings2.default,
                                        extraProps: (0, _extends3.default)({}, extraProps, {
                                            schema: _admin_definition2.default.settings.general.configuration.schema
                                        })
                                    }),
                                    _react2.default.createElement(SCRoute, {
                                        path: props.match.url + '/localization',
                                        component: _schema_admin_settings2.default,
                                        extraProps: (0, _extends3.default)({}, extraProps, {
                                            schema: _admin_definition2.default.settings.general.localization.schema
                                        })
                                    }),
                                    _react2.default.createElement(SCRoute, {
                                        path: props.match.url + '/users_and_teams',
                                        component: _users_and_teams_settings2.default,
                                        extraProps: extraProps
                                    }),
                                    _react2.default.createElement(SCRoute, {
                                        path: props.match.url + '/privacy',
                                        component: _schema_admin_settings2.default,
                                        extraProps: (0, _extends3.default)({}, extraProps, {
                                            schema: _admin_definition2.default.settings.general.privacy.schema
                                        })
                                    }),
                                    _react2.default.createElement(SCRoute, {
                                        path: props.match.url + '/policy',
                                        component: _policy_settings2.default,
                                        extraProps: extraProps
                                    }),
                                    _react2.default.createElement(SCRoute, {
                                        path: props.match.url + '/compliance',
                                        component: _schema_admin_settings2.default,
                                        extraProps: (0, _extends3.default)({}, extraProps, {
                                            schema: _admin_definition2.default.settings.general.compliance.schema
                                        })
                                    }),
                                    _react2.default.createElement(SCRoute, {
                                        path: props.match.url + '/logging',
                                        component: _schema_admin_settings2.default,
                                        extraProps: (0, _extends3.default)({}, extraProps, {
                                            schema: _admin_definition2.default.settings.general.logging.schema
                                        })
                                    }),
                                    _react2.default.createElement(_reactRouterDom.Redirect, { to: props.match.url + '/configuration' })
                                );
                            }
                        }),
                        _react2.default.createElement(_reactRouterDom.Route, {
                            path: this.props.match.url + '/authentication',
                            render: function render(props) {
                                return _react2.default.createElement(
                                    _reactRouterDom.Switch,
                                    null,
                                    _react2.default.createElement(SCRoute, {
                                        path: props.match.url + '/authentication_email',
                                        component: _schema_admin_settings2.default,
                                        extraProps: (0, _extends3.default)({}, extraProps, {
                                            schema: _admin_definition2.default.settings.authentication.email.schema
                                        })
                                    }),
                                    _react2.default.createElement(SCRoute, {
                                        path: props.match.url + '/gitlab',
                                        component: _gitlab_settings2.default,
                                        extraProps: extraProps
                                    }),
                                    _react2.default.createElement(SCRoute, {
                                        path: props.match.url + '/oauth',
                                        component: _oauth_settings2.default,
                                        extraProps: extraProps
                                    }),
                                    _react2.default.createElement(SCRoute, {
                                        path: props.match.url + '/ldap',
                                        component: _ldap_settings2.default,
                                        extraProps: extraProps
                                    }),
                                    _react2.default.createElement(SCRoute, {
                                        path: props.match.url + '/saml',
                                        component: _saml_settings2.default,
                                        extraProps: extraProps
                                    }),
                                    _react2.default.createElement(SCRoute, {
                                        path: props.match.url + '/mfa',
                                        component: _schema_admin_settings2.default,
                                        extraProps: (0, _extends3.default)({}, extraProps, {
                                            schema: _admin_definition2.default.settings.authentication.mfa.schema
                                        })
                                    }),
                                    _react2.default.createElement(_reactRouterDom.Redirect, { to: props.match.url + '/authentication_email' })
                                );
                            }
                        }),
                        _react2.default.createElement(_reactRouterDom.Route, {
                            path: this.props.match.url + '/security',
                            render: function render(props) {
                                return _react2.default.createElement(
                                    _reactRouterDom.Switch,
                                    null,
                                    _react2.default.createElement(SCRoute, {
                                        path: props.match.url + '/sign_up',
                                        component: _signup_settings2.default,
                                        extraProps: extraProps
                                    }),
                                    _react2.default.createElement(SCRoute, {
                                        path: props.match.url + '/password',
                                        component: _password_settings2.default,
                                        extraProps: extraProps
                                    }),
                                    _react2.default.createElement(SCRoute, {
                                        path: props.match.url + '/public_links',
                                        component: _public_link_settings2.default,
                                        extraProps: extraProps
                                    }),
                                    _react2.default.createElement(SCRoute, {
                                        path: props.match.url + '/sessions',
                                        component: _session_settings2.default,
                                        extraProps: extraProps
                                    }),
                                    _react2.default.createElement(SCRoute, {
                                        path: props.match.url + '/connections',
                                        component: _connection_settings2.default,
                                        extraProps: extraProps
                                    }),
                                    _react2.default.createElement(SCRoute, {
                                        path: props.match.url + '/client_versions',
                                        component: _client_versions_settings2.default,
                                        extraProps: extraProps
                                    }),
                                    _react2.default.createElement(_reactRouterDom.Redirect, { to: props.match.url + '/sign_up' })
                                );
                            }
                        }),
                        _react2.default.createElement(_reactRouterDom.Route, {
                            path: this.props.match.url + '/notifications',
                            render: function render(props) {
                                return _react2.default.createElement(
                                    _reactRouterDom.Switch,
                                    null,
                                    _react2.default.createElement(SCRoute, {
                                        path: props.match.url + '/notifications_email',
                                        component: _email_settings2.default,
                                        extraProps: extraProps
                                    }),
                                    _react2.default.createElement(SCRoute, {
                                        path: props.match.url + '/push',
                                        component: _push_settings2.default,
                                        extraProps: extraProps
                                    }),
                                    _react2.default.createElement(_reactRouterDom.Redirect, { to: props.match.url + '/notifications_email' })
                                );
                            }
                        }),
                        _react2.default.createElement(_reactRouterDom.Route, {
                            path: this.props.match.url + '/integrations',
                            render: function render(props) {
                                return _react2.default.createElement(
                                    _reactRouterDom.Switch,
                                    null,
                                    _react2.default.createElement(SCRoute, {
                                        path: props.match.url + '/custom',
                                        component: _custom_integrations_settings2.default,
                                        extraProps: extraProps
                                    }),
                                    _react2.default.createElement(SCRoute, {
                                        path: props.match.url + '/external',
                                        component: _external_service_settings2.default,
                                        extraProps: extraProps
                                    }),
                                    _react2.default.createElement(SCRoute, {
                                        path: props.match.url + '/webrtc',
                                        component: _webrtc_settings2.default,
                                        extraProps: extraProps
                                    }),
                                    _react2.default.createElement(_reactRouterDom.Redirect, { to: props.match.url + '/custom' })
                                );
                            }
                        }),
                        _react2.default.createElement(_reactRouterDom.Route, {
                            path: this.props.match.url + '/plugins',
                            render: function render(props) {
                                return _react2.default.createElement(
                                    _reactRouterDom.Switch,
                                    null,
                                    _react2.default.createElement(SCRoute, {
                                        path: props.match.url + '/configuration',
                                        component: _plugin_settings2.default,
                                        extraProps: extraProps
                                    }),
                                    _react2.default.createElement(SCRoute, {
                                        path: props.match.url + '/management',
                                        component: _plugin_management2.default,
                                        extraProps: extraProps
                                    }),
                                    _react2.default.createElement(SCRoute, {
                                        path: props.match.url + '/custom/:plugin_id',
                                        component: _custom_plugin_settings2.default,
                                        extraProps: extraProps
                                    }),
                                    _react2.default.createElement(_reactRouterDom.Redirect, { to: props.match.url + '/configuration' })
                                );
                            }
                        }),
                        _react2.default.createElement(_reactRouterDom.Route, {
                            path: this.props.match.url + '/files',
                            render: function render(props) {
                                return _react2.default.createElement(
                                    _reactRouterDom.Switch,
                                    null,
                                    _react2.default.createElement(SCRoute, {
                                        path: props.match.url + '/storage',
                                        component: _storage_settings2.default,
                                        extraProps: extraProps
                                    }),
                                    _react2.default.createElement(_reactRouterDom.Redirect, { to: props.match.url + '/storage' })
                                );
                            }
                        }),
                        _react2.default.createElement(_reactRouterDom.Route, {
                            path: this.props.match.url + '/customization',
                            render: function render(props) {
                                return _react2.default.createElement(
                                    _reactRouterDom.Switch,
                                    null,
                                    _react2.default.createElement(SCRoute, {
                                        path: props.match.url + '/custom_brand',
                                        component: _custom_brand_settings2.default,
                                        extraProps: extraProps
                                    }),
                                    _react2.default.createElement(SCRoute, {
                                        path: props.match.url + '/emoji',
                                        component: _custom_emoji_settings2.default,
                                        extraProps: extraProps
                                    }),
                                    _react2.default.createElement(SCRoute, {
                                        path: props.match.url + '/link_previews',
                                        component: _link_previews_settings2.default,
                                        extraProps: extraProps
                                    }),
                                    _react2.default.createElement(SCRoute, {
                                        path: props.match.url + '/legal_and_support',
                                        component: _legal_and_support_settings2.default,
                                        extraProps: extraProps
                                    }),
                                    _react2.default.createElement(SCRoute, {
                                        path: props.match.url + '/native_app_links',
                                        component: _native_app_link_settings2.default,
                                        extraProps: extraProps
                                    }),
                                    _react2.default.createElement(_reactRouterDom.Redirect, { to: props.match.url + '/custom_brand' })
                                );
                            }
                        }),
                        _react2.default.createElement(_reactRouterDom.Route, {
                            path: this.props.match.url + '/compliance',
                            render: function render(props) {
                                return _react2.default.createElement(
                                    _reactRouterDom.Switch,
                                    null,
                                    _react2.default.createElement(SCRoute, {
                                        path: props.match.url + '/data_retention',
                                        component: _data_retention_settings2.default,
                                        extraProps: extraProps
                                    }),
                                    _react2.default.createElement(SCRoute, {
                                        path: props.match.url + '/message_export',
                                        component: _message_export_settings2.default,
                                        extraProps: extraProps
                                    }),
                                    _react2.default.createElement(_reactRouterDom.Redirect, { to: props.match.url + '/data_retention' })
                                );
                            }
                        }),
                        _react2.default.createElement(_reactRouterDom.Route, {
                            path: this.props.match.url + '/advanced',
                            render: function render(props) {
                                return _react2.default.createElement(
                                    _reactRouterDom.Switch,
                                    null,
                                    _react2.default.createElement(SCRoute, {
                                        path: props.match.url + '/rate',
                                        component: _rate_settings2.default,
                                        extraProps: extraProps
                                    }),
                                    _react2.default.createElement(SCRoute, {
                                        path: props.match.url + '/database',
                                        component: _database_settings2.default,
                                        extraProps: extraProps
                                    }),
                                    _react2.default.createElement(SCRoute, {
                                        path: props.match.url + '/elasticsearch',
                                        component: _elasticsearch_settings2.default,
                                        extraProps: extraProps
                                    }),
                                    _react2.default.createElement(SCRoute, {
                                        path: props.match.url + '/developer',
                                        component: _developer_settings2.default,
                                        extraProps: extraProps
                                    }),
                                    _react2.default.createElement(SCRoute, {
                                        path: props.match.url + '/cluster',
                                        component: _cluster_settings2.default,
                                        extraProps: extraProps
                                    }),
                                    _react2.default.createElement(SCRoute, {
                                        path: props.match.url + '/metrics',
                                        component: _metrics_settings2.default,
                                        extraProps: extraProps
                                    }),
                                    _react2.default.createElement(_reactRouterDom.Redirect, { to: props.match.url + '/rate' })
                                );
                            }
                        }),
                        _react2.default.createElement(SCRoute, {
                            path: this.props.match.url + '/users',
                            component: _schema_admin_settings2.default,
                            extraProps: (0, _extends3.default)({}, extraProps, {
                                schema: _admin_definition2.default.reporting.system_users.schema
                            })
                        }),
                        _react2.default.createElement(SCRoute, {
                            path: this.props.match.url + '/team_analytics',
                            component: _schema_admin_settings2.default,
                            extraProps: (0, _extends3.default)({}, extraProps, {
                                schema: _admin_definition2.default.reporting.team_analytics.schema
                            })
                        }),
                        _react2.default.createElement(SCRoute, {
                            path: this.props.match.url + '/license',
                            component: _schema_admin_settings2.default,
                            extraProps: (0, _extends3.default)({}, extraProps, {
                                schema: _admin_definition2.default.other.license.schema
                            })
                        }),
                        _react2.default.createElement(SCRoute, {
                            path: this.props.match.url + '/audits',
                            component: _schema_admin_settings2.default,
                            extraProps: (0, _extends3.default)({}, extraProps, {
                                schema: _admin_definition2.default.other.audits.schema
                            })
                        }),
                        _react2.default.createElement(SCRoute, {
                            path: this.props.match.url + '/logs',
                            component: _schema_admin_settings2.default,
                            extraProps: (0, _extends3.default)({}, extraProps, {
                                schema: _admin_definition2.default.reporting.server_logs.schema
                            })
                        }),
                        _react2.default.createElement(_reactRouterDom.Redirect, { to: this.props.match.url + '/system_analytics' })
                    )
                ),
                discardChangesModal
            );
        }
    }]);
    return AdminConsole;
}(_react2.default.Component);

AdminConsole.propTypes = {

    /*
     * Object representing the config file
     */
    config: _propTypes2.default.object.isRequired,

    /*
     * Object representing the license
     */
    license: _propTypes2.default.object.isRequired,

    /*
     * Object from react-router
     */
    match: _propTypes2.default.shape({
        url: _propTypes2.default.string.isRequired
    }).isRequired,

    /*
     * String whether to show prompt to navigate away
     * from unsaved changes
     */
    showNavigationPrompt: _propTypes2.default.bool.isRequired,

    isCurrentUserSystemAdmin: _propTypes2.default.bool.isRequired,

    actions: _propTypes2.default.shape({

        /*
         * Function to get the config file
         */
        getConfig: _propTypes2.default.func.isRequired,

        /*
         * Function to block navigation when there are unsaved changes
         */
        setNavigationBlocked: _propTypes2.default.func.isRequired,

        /*
         * Function to confirm navigation
         */
        confirmNavigation: _propTypes2.default.func.isRequired,

        /*
         * Function to cancel navigation away from unsaved changes
         */
        cancelNavigation: _propTypes2.default.func.isRequired
    }).isRequired
};
exports.default = AdminConsole;

/***/ }),

/***/ 2569:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _admin_settings = __webpack_require__(787);

var _admin_settings2 = _interopRequireDefault(_admin_settings);

var _settings_group = __webpack_require__(788);

var _settings_group2 = _interopRequireDefault(_settings_group);

var _text_setting = __webpack_require__(794);

var _text_setting2 = _interopRequireDefault(_text_setting);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var ClientVersionsSettings = function (_AdminSettings) {
    (0, _inherits3.default)(ClientVersionsSettings, _AdminSettings);

    function ClientVersionsSettings(props) {
        (0, _classCallCheck3.default)(this, ClientVersionsSettings);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ClientVersionsSettings.__proto__ || (0, _getPrototypeOf2.default)(ClientVersionsSettings)).call(this, props));

        _this.getConfigFromState = _this.getConfigFromState.bind(_this);

        _this.renderSettings = _this.renderSettings.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(ClientVersionsSettings, [{
        key: 'getConfigFromState',
        value: function getConfigFromState(config) {
            config.ClientRequirements.AndroidLatestVersion = this.state.androidLatestVersion;
            config.ClientRequirements.AndroidMinVersion = this.state.androidMinVersion;
            config.ClientRequirements.DesktopLatestVersion = this.state.desktopLatestVersion;
            config.ClientRequirements.DesktopMinVersion = this.state.desktopMinVersion;
            config.ClientRequirements.IosLatestVersion = this.state.iosLatestVersion;
            config.ClientRequirements.IosMinVersion = this.state.iosMinVersion;

            return config;
        }
    }, {
        key: 'getStateFromConfig',
        value: function getStateFromConfig(config) {
            return {
                androidLatestVersion: config.ClientRequirements.AndroidLatestVersion,
                androidMinVersion: config.ClientRequirements.AndroidMinVersion,
                desktopLatestVersion: config.ClientRequirements.DesktopLatestVersion,
                desktopMinVersion: config.ClientRequirements.DesktopMinVersion,
                iosLatestVersion: config.ClientRequirements.IosLatestVersion,
                iosMinVersion: config.ClientRequirements.IosMinVersion
            };
        }
    }, {
        key: 'renderTitle',
        value: function renderTitle() {
            return _react2.default.createElement(
                'h3',
                null,
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'admin.security.client_versions',
                    defaultMessage: 'Client Versions'
                })
            );
        }
    }, {
        key: 'renderSettings',
        value: function renderSettings() {
            return _react2.default.createElement(
                _settings_group2.default,
                null,
                _react2.default.createElement(_text_setting2.default, {
                    id: 'androidLatestVersion',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.client_versions.androidLatestVersion',
                        defaultMessage: 'Latest Android Version'
                    }),
                    placeholder: Utils.localizeMessage('admin.client_versions.androidLatestVersion', 'X.X.X'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.client_versions.androidLatestVersionHelp',
                        defaultMessage: 'The latest released Android version'
                    }),
                    value: this.state.androidLatestVersion,
                    onChange: this.handleChange
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'androidMinVersion',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.client_versions.androidMinVersion',
                        defaultMessage: 'Minimum Android Version'
                    }),
                    placeholder: Utils.localizeMessage('admin.client_versions.androidMinVersion', 'X.X.X'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.client_versions.androidMinVersionHelp',
                        defaultMessage: 'The minimum compliant Android version'
                    }),
                    value: this.state.androidMinVersion,
                    onChange: this.handleChange
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'desktopLatestVersion',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.client_versions.desktopLatestVersion',
                        defaultMessage: 'Latest Desktop Version'
                    }),
                    placeholder: Utils.localizeMessage('admin.client_versions.desktopLatestVersion', 'X.X.X'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.client_versions.desktopLatestVersionHelp',
                        defaultMessage: 'The latest released Desktop version'
                    }),
                    value: this.state.desktopLatestVersion,
                    onChange: this.handleChange
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'desktopMinVersion',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.client_versions.desktopMinVersion',
                        defaultMessage: 'Minimum Desktop Version'
                    }),
                    placeholder: Utils.localizeMessage('admin.client_versions.desktopMinVersion', 'X.X.X'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.client_versions.desktopMinVersionHelp',
                        defaultMessage: 'The minimum compliant Desktop version'
                    }),
                    value: this.state.desktopMinVersion,
                    onChange: this.handleChange
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'iosLatestVersion',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.client_versions.iosLatestVersion',
                        defaultMessage: 'Latest iOS Version'
                    }),
                    placeholder: Utils.localizeMessage('admin.client_versions.iosLatestVersion', 'X.X.X'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.client_versions.iosLatestVersionHelp',
                        defaultMessage: 'The latest released iOS version'
                    }),
                    value: this.state.iosLatestVersion,
                    onChange: this.handleChange
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'iosMinVersion',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.client_versions.iosMinVersion',
                        defaultMessage: 'Minimum iOS Version'
                    }),
                    placeholder: Utils.localizeMessage('admin.client_versions.iosMinVersion', 'X.X.X'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.client_versions.iosMinVersionHelp',
                        defaultMessage: 'The minimum compliant iOS version'
                    }),
                    value: this.state.iosMinVersion,
                    onChange: this.handleChange
                })
            );
        }
    }]);
    return ClientVersionsSettings;
}(_admin_settings2.default);

exports.default = ClientVersionsSettings;

/***/ }),

/***/ 2570:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _client = __webpack_require__(270);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _admin_settings = __webpack_require__(787);

var _admin_settings2 = _interopRequireDefault(_admin_settings);

var _boolean_setting = __webpack_require__(800);

var _boolean_setting2 = _interopRequireDefault(_boolean_setting);

var _cluster_table_container = __webpack_require__(2571);

var _cluster_table_container2 = _interopRequireDefault(_cluster_table_container);

var _settings_group = __webpack_require__(788);

var _settings_group2 = _interopRequireDefault(_settings_group);

var _text_setting = __webpack_require__(794);

var _text_setting2 = _interopRequireDefault(_text_setting);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ClusterSettings = function (_AdminSettings) {
    (0, _inherits3.default)(ClusterSettings, _AdminSettings);

    function ClusterSettings(props) {
        (0, _classCallCheck3.default)(this, ClusterSettings);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ClusterSettings.__proto__ || (0, _getPrototypeOf2.default)(ClusterSettings)).call(this, props));

        _this.getConfigFromState = _this.getConfigFromState.bind(_this);
        _this.renderSettings = _this.renderSettings.bind(_this);
        _this.overrideHandleChange = _this.overrideHandleChange.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(ClusterSettings, [{
        key: 'getConfigFromState',
        value: function getConfigFromState(config) {
            config.ClusterSettings.Enable = this.state.Enable;
            config.ClusterSettings.ClusterName = this.state.ClusterName;
            config.ClusterSettings.OverrideHostname = this.state.OverrideHostname;
            config.ClusterSettings.UseIpAddress = this.state.UseIpAddress;
            config.ClusterSettings.UseExperimentalGossip = this.state.UseExperimentalGossip;
            config.ClusterSettings.ReadOnlyConfig = this.state.ReadOnlyConfig;
            config.ClusterSettings.GossipPort = this.parseIntNonZero(this.state.GossipPort, 8074);
            config.ClusterSettings.StreamingPort = this.parseIntNonZero(this.state.StreamingPort, 8075);
            return config;
        }
    }, {
        key: 'getStateFromConfig',
        value: function getStateFromConfig(config) {
            var settings = config.ClusterSettings;

            return {
                Enable: settings.Enable,
                ClusterName: settings.ClusterName,
                OverrideHostname: settings.OverrideHostname,
                UseIpAddress: settings.UseIpAddress,
                UseExperimentalGossip: settings.UseExperimentalGossip,
                ReadOnlyConfig: settings.ReadOnlyConfig,
                GossipPort: settings.GossipPort,
                StreamingPort: settings.StreamingPort,
                showWarning: false
            };
        }
    }, {
        key: 'renderTitle',
        value: function renderTitle() {
            return _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'admin.advance.cluster',
                defaultMessage: 'High Availability'
            });
        }
    }, {
        key: 'overrideHandleChange',
        value: function overrideHandleChange(id, value) {
            this.setState({
                showWarning: true
            });

            this.handleChange(id, value);
        }
    }, {
        key: 'renderSettings',
        value: function renderSettings() {
            var licenseEnabled = this.props.license.IsLicensed === 'true' && this.props.license.Cluster === 'true';
            if (!licenseEnabled) {
                return null;
            }

            var configLoadedFromCluster = null;

            if (_client.Client4.clusterId) {
                configLoadedFromCluster = _react2.default.createElement(
                    'div',
                    {
                        style: style.configLoadedFromCluster,
                        className: 'alert alert-warning'
                    },
                    _react2.default.createElement('i', { className: 'fa fa-warning' }),
                    _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                        id: 'admin.cluster.loadedFrom',
                        defaultMessage: 'This configuration file was loaded from Node ID {clusterId}. Please see the Troubleshooting Guide in our <a href="http://docs.mattermost.com/deployment/cluster.html" target="_blank">documentation</a> if you are accessing the System Console through a load balancer and experiencing issues.',
                        values: {
                            clusterId: _client.Client4.clusterId
                        }
                    })
                );
            }

            var warning = null;
            if (this.state.showWarning) {
                warning = _react2.default.createElement(
                    'div',
                    {
                        style: style.warning,
                        className: 'alert alert-warning'
                    },
                    _react2.default.createElement('i', { className: 'fa fa-warning' }),
                    _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                        id: 'admin.cluster.should_not_change',
                        defaultMessage: 'WARNING: These settings may not sync with the other servers in the cluster. High Availability inter-node communication will not start until you modify the config.json to be identical on all servers and restart Mattermost. Please see the <a href="http://docs.mattermost.com/deployment/cluster.html" target="_blank">documentation</a> on how to add or remove a server from the cluster. If you are accessing the System Console through a load balancer and experiencing issues, please see the Troubleshooting Guide in our <a href="http://docs.mattermost.com/deployment/cluster.html" target="_blank">documentation</a>.'
                    })
                );
            }

            var clusterTableContainer = null;
            if (this.state.Enable) {
                clusterTableContainer = _react2.default.createElement(_cluster_table_container2.default, null);
            }

            return _react2.default.createElement(
                _settings_group2.default,
                null,
                configLoadedFromCluster,
                clusterTableContainer,
                _react2.default.createElement(
                    'div',
                    { className: 'banner' },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.cluster.noteDescription',
                        defaultMessage: 'Changing properties in this section will require a server restart before taking effect. When High Availability mode is enabled, the System Console is set to read-only and can only be changed from the configuration file unless ReadOnlyConfig is disabled in the configuration file.'
                    })
                ),
                warning,
                _react2.default.createElement(_boolean_setting2.default, {
                    id: 'Enable',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.cluster.enableTitle',
                        defaultMessage: 'Enable High Availability Mode:'
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                        id: 'admin.cluster.enableDescription',
                        defaultMessage: 'When true, Mattermost will run in High Availability mode. Please see <a href="http://docs.mattermost.com/deployment/cluster.html" target="_blank">documentation</a> to learn more about configuring High Availability for Mattermost.'
                    }),
                    value: this.state.Enable,
                    onChange: this.overrideHandleChange
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'ClusterName',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.cluster.ClusterName',
                        defaultMessage: 'Cluster Name:'
                    }),
                    placeholder: Utils.localizeMessage('admin.cluster.ClusterNameEx', 'E.g.: "Production" or "Staging"'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.cluster.ClusterNameDesc',
                        defaultMessage: 'The cluster to join by name.  Only nodes with the same cluster name will join together.  This is to support Blue-Green deployments or staging pointing to the same database.'
                    }),
                    value: this.state.ClusterName,
                    onChange: this.overrideHandleChange
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'OverrideHostname',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.cluster.OverrideHostname',
                        defaultMessage: 'Override Hostname:'
                    }),
                    placeholder: Utils.localizeMessage('admin.cluster.OverrideHostnameEx', 'E.g.: "app-server-01"'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.cluster.OverrideHostnameDesc',
                        defaultMessage: 'The default value of <blank> will attempt to get the Hostname from the OS or use the IP Address.  You can override the hostname of this server with this property.  It is not recommended to override the Hostname unless needed. This property can also be set to a specific IP Address if needed.'
                    }),
                    value: this.state.OverrideHostname,
                    onChange: this.overrideHandleChange
                }),
                _react2.default.createElement(_boolean_setting2.default, {
                    id: 'UseIpAddress',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.cluster.UseIpAddress',
                        defaultMessage: 'Use IP Address:'
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                        id: 'admin.cluster.UseIpAddressDesc',
                        defaultMessage: 'When true, the cluster will attempt to communicate via IP Address vs using the hostname.'
                    }),
                    value: this.state.UseIpAddress,
                    onChange: this.overrideHandleChange
                }),
                _react2.default.createElement(_boolean_setting2.default, {
                    id: 'UseExperimentalGossip',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.cluster.UseExperimentalGossip',
                        defaultMessage: 'Use Experimental Gossip:'
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                        id: 'admin.cluster.UseExperimentalGossipDesc',
                        defaultMessage: 'When true, the server will attempt to communicate via the gossip protocol over the gossip port.  When false the server will attempt to communicate over the streaming port. When false the gossip port and protocol are still used to determine cluster health.'
                    }),
                    value: this.state.UseExperimentalGossip,
                    onChange: this.overrideHandleChange
                }),
                _react2.default.createElement(_boolean_setting2.default, {
                    id: 'ReadOnlyConfig',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.cluster.ReadOnlyConfig',
                        defaultMessage: 'Read Only Config:'
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                        id: 'admin.cluster.ReadOnlyConfigDesc',
                        defaultMessage: 'When true, the server will reject changes made to the configuration file from the system console. When running in production it is recommened to set this to true.'
                    }),
                    value: this.state.ReadOnlyConfig,
                    onChange: this.overrideHandleChange
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'GossipPort',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.cluster.GossipPort',
                        defaultMessage: 'Gossip Port:'
                    }),
                    placeholder: Utils.localizeMessage('admin.cluster.GossipPortEx', 'E.g.: "8074"'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.cluster.GossipPortDesc',
                        defaultMessage: 'The port used for the gossip protocol.  Both UDP and TCP should be allowed on this port.'
                    }),
                    value: this.state.GossipPort,
                    onChange: this.overrideHandleChange
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'StreamingPort',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.cluster.StreamingPort',
                        defaultMessage: 'Streaming Port:'
                    }),
                    placeholder: Utils.localizeMessage('admin.cluster.StreamingPortEx', 'E.g.: "8075"'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.cluster.StreamingPortDesc',
                        defaultMessage: 'The port used for streaming data between servers.'
                    }),
                    value: this.state.StreamingPort,
                    onChange: this.overrideHandleChange
                })
            );
        }
    }]);
    return ClusterSettings;
}(_admin_settings2.default); // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = ClusterSettings;


var style = {
    configLoadedFromCluster: { marginBottom: 10 },
    warning: { marginBottom: 10 }
};

/***/ }),

/***/ 2571:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _admin_actions = __webpack_require__(797);

var _loading_screen = __webpack_require__(792);

var _loading_screen2 = _interopRequireDefault(_loading_screen);

var _cluster_table = __webpack_require__(2572);

var _cluster_table2 = _interopRequireDefault(_cluster_table);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var ClusterTableContainer = function (_React$Component) {
    (0, _inherits3.default)(ClusterTableContainer, _React$Component);

    function ClusterTableContainer(props) {
        (0, _classCallCheck3.default)(this, ClusterTableContainer);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ClusterTableContainer.__proto__ || (0, _getPrototypeOf2.default)(ClusterTableContainer)).call(this, props));

        _this.load = _this.load.bind(_this);
        _this.reload = _this.reload.bind(_this);

        _this.interval = null;

        _this.state = {
            clusterInfos: null
        };
        return _this;
    }

    (0, _createClass3.default)(ClusterTableContainer, [{
        key: 'load',
        value: function load() {
            var _this2 = this;

            (0, _admin_actions.getClusterStatus)(function (data) {
                _this2.setState({
                    clusterInfos: data
                });
            }, null);
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.load();

            // reload the cluster status every 15 seconds
            this.interval = setInterval(this.load, 15000);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.interval) {
                clearInterval(this.interval);
            }
        }
    }, {
        key: 'reload',
        value: function reload(e) {
            if (e) {
                e.preventDefault();
            }

            this.setState({
                clusterInfos: null
            });

            this.load();
        }
    }, {
        key: 'render',
        value: function render() {
            if (this.state.clusterInfos == null) {
                return _react2.default.createElement(_loading_screen2.default, null);
            }

            return _react2.default.createElement(_cluster_table2.default, {
                clusterInfos: this.state.clusterInfos,
                reload: this.reload
            });
        }
    }]);
    return ClusterTableContainer;
}(_react2.default.Component);

exports.default = ClusterTableContainer;

/***/ }),

/***/ 2572:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _status_green = __webpack_require__(2573);

var _status_green2 = _interopRequireDefault(_status_green);

var _status_yellow = __webpack_require__(2574);

var _status_yellow2 = _interopRequireDefault(_status_yellow);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var ClusterTable = function (_React$Component) {
    (0, _inherits3.default)(ClusterTable, _React$Component);

    function ClusterTable() {
        (0, _classCallCheck3.default)(this, ClusterTable);
        return (0, _possibleConstructorReturn3.default)(this, (ClusterTable.__proto__ || (0, _getPrototypeOf2.default)(ClusterTable)).apply(this, arguments));
    }

    (0, _createClass3.default)(ClusterTable, [{
        key: 'render',
        value: function render() {
            var versionMismatch = _react2.default.createElement('img', {
                className: 'cluster-status',
                src: _status_green2.default
            });

            var configMismatch = _react2.default.createElement('img', {
                className: 'cluster-status',
                src: _status_green2.default
            });

            var version = '';
            var configHash = '';
            var singleItem = false;

            if (this.props.clusterInfos.length) {
                version = this.props.clusterInfos[0].version;
                configHash = this.props.clusterInfos[0].config_hash;
                singleItem = this.props.clusterInfos.length === 1;
            }

            this.props.clusterInfos.map(function (clusterInfo) {
                if (clusterInfo.version !== version) {
                    versionMismatch = _react2.default.createElement('img', {
                        className: 'cluster-status',
                        src: _status_yellow2.default
                    });
                }

                if (clusterInfo.config_hash !== configHash) {
                    configMismatch = _react2.default.createElement('img', {
                        className: 'cluster-status',
                        src: _status_yellow2.default
                    });
                }

                return null;
            });

            var items = this.props.clusterInfos.map(function (clusterInfo) {
                var status = null;

                if (clusterInfo.hostname === '') {
                    clusterInfo.hostname = Utils.localizeMessage('admin.cluster.unknown', 'unknown');
                }

                if (clusterInfo.version === '') {
                    clusterInfo.version = Utils.localizeMessage('admin.cluster.unknown', 'unknown');
                }

                if (clusterInfo.config_hash === '') {
                    clusterInfo.config_hash = Utils.localizeMessage('admin.cluster.unknown', 'unknown');
                }

                if (singleItem) {
                    status = _react2.default.createElement('img', {
                        className: 'cluster-status',
                        src: _status_yellow2.default
                    });
                } else {
                    status = _react2.default.createElement('img', {
                        className: 'cluster-status',
                        src: _status_green2.default
                    });
                }

                return _react2.default.createElement(
                    'tr',
                    { key: clusterInfo.ipaddress },
                    _react2.default.createElement(
                        'td',
                        { style: style.clusterCell },
                        status
                    ),
                    _react2.default.createElement(
                        'td',
                        { style: style.clusterCell },
                        clusterInfo.hostname
                    ),
                    _react2.default.createElement(
                        'td',
                        { style: style.clusterCell },
                        versionMismatch,
                        ' ',
                        clusterInfo.version
                    ),
                    _react2.default.createElement(
                        'td',
                        { style: style.clusterCell },
                        _react2.default.createElement(
                            'div',
                            { className: 'config-hash' },
                            configMismatch,
                            ' ',
                            clusterInfo.config_hash
                        )
                    ),
                    _react2.default.createElement(
                        'td',
                        { style: style.clusterCell },
                        clusterInfo.ipaddress
                    )
                );
            });

            return _react2.default.createElement(
                'div',
                {
                    className: 'cluster-panel__table',
                    style: style.clusterTable
                },
                _react2.default.createElement(
                    'div',
                    { className: 'text-right' },
                    _react2.default.createElement(
                        'button',
                        {
                            type: 'submit',
                            className: 'btn btn-link',
                            onClick: this.props.reload
                        },
                        _react2.default.createElement('i', { className: 'fa fa-refresh' }),
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'admin.cluster.status_table.reload',
                            defaultMessage: ' Reload Cluster Status'
                        })
                    )
                ),
                _react2.default.createElement(
                    'table',
                    { className: 'table' },
                    _react2.default.createElement(
                        'thead',
                        null,
                        _react2.default.createElement(
                            'tr',
                            null,
                            _react2.default.createElement(
                                'th',
                                null,
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'admin.cluster.status_table.status',
                                    defaultMessage: 'Status'
                                })
                            ),
                            _react2.default.createElement(
                                'th',
                                null,
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'admin.cluster.status_table.hostname',
                                    defaultMessage: 'Hostname'
                                })
                            ),
                            _react2.default.createElement(
                                'th',
                                null,
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'admin.cluster.status_table.version',
                                    defaultMessage: 'Version'
                                })
                            ),
                            _react2.default.createElement(
                                'th',
                                null,
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'admin.cluster.status_table.config_hash',
                                    defaultMessage: 'Config File MD5'
                                })
                            ),
                            _react2.default.createElement(
                                'th',
                                null,
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'admin.cluster.status_table.url',
                                    defaultMessage: 'Gossip Address'
                                })
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'tbody',
                        null,
                        items
                    )
                )
            );
        }
    }]);
    return ClusterTable;
}(_react2.default.Component);

ClusterTable.propTypes = {
    clusterInfos: _propTypes2.default.array.isRequired,
    reload: _propTypes2.default.func.isRequired
};
exports.default = ClusterTable;


var style = {
    clusterTable: { margin: 10, marginBottom: 30 },
    clusterCell: { whiteSpace: 'nowrap' }
};

/***/ }),

/***/ 2573:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/f2f389817448b841c0d55028e053915e.png";

/***/ }),

/***/ 2574:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "files/cb5754883ea95a8681ed2beec10b8a63.png";

/***/ }),

/***/ 2575:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _admin_settings = __webpack_require__(787);

var _admin_settings2 = _interopRequireDefault(_admin_settings);

var _boolean_setting = __webpack_require__(800);

var _boolean_setting2 = _interopRequireDefault(_boolean_setting);

var _settings_group = __webpack_require__(788);

var _settings_group2 = _interopRequireDefault(_settings_group);

var _text_setting = __webpack_require__(794);

var _text_setting2 = _interopRequireDefault(_text_setting);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ConnectionSettings = function (_AdminSettings) {
    (0, _inherits3.default)(ConnectionSettings, _AdminSettings);

    function ConnectionSettings(props) {
        (0, _classCallCheck3.default)(this, ConnectionSettings);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ConnectionSettings.__proto__ || (0, _getPrototypeOf2.default)(ConnectionSettings)).call(this, props));

        _this.getConfigFromState = _this.getConfigFromState.bind(_this);

        _this.renderSettings = _this.renderSettings.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(ConnectionSettings, [{
        key: 'getConfigFromState',
        value: function getConfigFromState(config) {
            config.ServiceSettings.AllowCorsFrom = this.state.allowCorsFrom;
            config.ServiceSettings.EnableInsecureOutgoingConnections = this.state.enableInsecureOutgoingConnections;

            return config;
        }
    }, {
        key: 'getStateFromConfig',
        value: function getStateFromConfig(config) {
            return {
                allowCorsFrom: config.ServiceSettings.AllowCorsFrom,
                enableInsecureOutgoingConnections: config.ServiceSettings.EnableInsecureOutgoingConnections
            };
        }
    }, {
        key: 'renderTitle',
        value: function renderTitle() {
            return _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'admin.security.connection',
                defaultMessage: 'Connections'
            });
        }
    }, {
        key: 'renderSettings',
        value: function renderSettings() {
            return _react2.default.createElement(
                _settings_group2.default,
                null,
                _react2.default.createElement(_text_setting2.default, {
                    id: 'allowCorsFrom',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.service.corsTitle',
                        defaultMessage: 'Enable cross-origin requests from:'
                    }),
                    placeholder: Utils.localizeMessage('admin.service.corsEx', 'http://example.com'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.service.corsDescription',
                        defaultMessage: 'Enable HTTP Cross origin request from a specific domain. Use "*" if you want to allow CORS from any domain or leave it blank to disable it.'
                    }),
                    value: this.state.allowCorsFrom,
                    onChange: this.handleChange
                }),
                _react2.default.createElement(_boolean_setting2.default, {
                    id: 'enableInsecureOutgoingConnections',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.service.insecureTlsTitle',
                        defaultMessage: 'Enable Insecure Outgoing Connections: '
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.service.insecureTlsDesc',
                        defaultMessage: 'When true, any outgoing HTTPS requests will accept unverified, self-signed certificates. For example, outgoing webhooks to a server with a self-signed TLS certificate, using any domain, will be allowed. Note that this makes these connections susceptible to man-in-the-middle attacks.'
                    }),
                    value: this.state.enableInsecureOutgoingConnections,
                    onChange: this.handleChange
                })
            );
        }
    }]);
    return ConnectionSettings;
}(_admin_settings2.default); // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = ConnectionSettings;

/***/ }),

/***/ 2576:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _admin_settings = __webpack_require__(787);

var _admin_settings2 = _interopRequireDefault(_admin_settings);

var _boolean_setting = __webpack_require__(800);

var _boolean_setting2 = _interopRequireDefault(_boolean_setting);

var _brand_image_setting = __webpack_require__(2577);

var _brand_image_setting2 = _interopRequireDefault(_brand_image_setting);

var _settings_group = __webpack_require__(788);

var _settings_group2 = _interopRequireDefault(_settings_group);

var _text_setting = __webpack_require__(794);

var _text_setting2 = _interopRequireDefault(_text_setting);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CustomBrandSettings = function (_AdminSettings) {
    (0, _inherits3.default)(CustomBrandSettings, _AdminSettings);

    function CustomBrandSettings() {
        (0, _classCallCheck3.default)(this, CustomBrandSettings);
        return (0, _possibleConstructorReturn3.default)(this, (CustomBrandSettings.__proto__ || (0, _getPrototypeOf2.default)(CustomBrandSettings)).apply(this, arguments));
    }

    (0, _createClass3.default)(CustomBrandSettings, [{
        key: 'getConfigFromState',
        value: function getConfigFromState(config) {
            config.TeamSettings.SiteName = this.state.siteName;

            if (this.props.license.IsLicensed === 'true') {
                config.TeamSettings.CustomDescriptionText = this.state.customDescriptionText;
            }

            if (this.props.license.IsLicensed === 'true' && this.props.license.CustomBrand === 'true') {
                config.TeamSettings.EnableCustomBrand = this.state.enableCustomBrand;
                config.TeamSettings.CustomBrandText = this.state.customBrandText;
            }

            return config;
        }
    }, {
        key: 'getStateFromConfig',
        value: function getStateFromConfig(config) {
            return {
                siteName: config.TeamSettings.SiteName,
                enableCustomBrand: config.TeamSettings.EnableCustomBrand,
                customBrandText: config.TeamSettings.CustomBrandText,
                customDescriptionText: config.TeamSettings.CustomDescriptionText
            };
        }
    }, {
        key: 'renderTitle',
        value: function renderTitle() {
            return _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'admin.customization.customBrand',
                defaultMessage: 'Custom Branding'
            });
        }
    }, {
        key: 'renderSettings',
        value: function renderSettings() {
            var enterpriseSettings = [];
            if (this.props.license.IsLicensed === 'true' && this.props.license.CustomBrand === 'true') {
                enterpriseSettings.push(_react2.default.createElement(_text_setting2.default, {
                    key: 'customDescriptionText',
                    id: 'customDescriptionText',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.team.brandDescriptionTitle',
                        defaultMessage: 'Site Description: '
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.team.brandDescriptionHelp',
                        defaultMessage: 'Description of service shown in login screens and UI. When not specified, "All team communication in one place, searchable and accessible anywhere" is displayed.'
                    }),
                    value: this.state.customDescriptionText,
                    placeholder: Utils.localizeMessage('web.root.signup_info', 'All team communication in one place, searchable and accessible anywhere'),
                    onChange: this.handleChange
                }));

                enterpriseSettings.push(_react2.default.createElement(_boolean_setting2.default, {
                    key: 'enableCustomBrand',
                    id: 'enableCustomBrand',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.team.brandTitle',
                        defaultMessage: 'Enable Custom Branding: '
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.team.brandDesc',
                        defaultMessage: 'Enable custom branding to show an image of your choice, uploaded below, and some help text, written below, on the login page.'
                    }),
                    value: this.state.enableCustomBrand,
                    onChange: this.handleChange
                }));

                enterpriseSettings.push(_react2.default.createElement(_brand_image_setting2.default, {
                    key: 'customBrandImage',
                    disabled: !this.state.enableCustomBrand
                }));

                enterpriseSettings.push(_react2.default.createElement(_text_setting2.default, {
                    key: 'customBrandText',
                    id: 'customBrandText',
                    type: 'textarea',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.team.brandTextTitle',
                        defaultMessage: 'Custom Brand Text:'
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.team.brandTextDescription',
                        defaultMessage: 'Text that will appear below your custom brand image on your login screen. Supports Markdown-formatted text. Maximum 500 characters allowed.'
                    }),
                    value: this.state.customBrandText,
                    onChange: this.handleChange,
                    disabled: !this.state.enableCustomBrand
                }));
            }

            return _react2.default.createElement(
                _settings_group2.default,
                null,
                _react2.default.createElement(_text_setting2.default, {
                    id: 'siteName',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.team.siteNameTitle',
                        defaultMessage: 'Site Name:'
                    }),
                    maxLength: _constants2.default.MAX_SITENAME_LENGTH,
                    placeholder: Utils.localizeMessage('admin.team.siteNameExample', 'E.g.: "Mattermost"'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.team.siteNameDescription',
                        defaultMessage: 'Name of service shown in login screens and UI.'
                    }),
                    value: this.state.siteName,
                    onChange: this.handleChange
                }),
                enterpriseSettings
            );
        }
    }]);
    return CustomBrandSettings;
}(_admin_settings2.default); // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = CustomBrandSettings;

/***/ }),

/***/ 2577:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _jquery = __webpack_require__(773);

var _jquery2 = _interopRequireDefault(_jquery);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _client = __webpack_require__(270);

var _admin_actions = __webpack_require__(797);

var _constants = __webpack_require__(29);

var _form_error = __webpack_require__(822);

var _form_error2 = _interopRequireDefault(_form_error);

var _upload_button = __webpack_require__(2578);

var _upload_button2 = _interopRequireDefault(_upload_button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HTTP_STATUS_OK = 200; // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var BrandImageSetting = function (_React$PureComponent) {
    (0, _inherits3.default)(BrandImageSetting, _React$PureComponent);

    function BrandImageSetting(props) {
        (0, _classCallCheck3.default)(this, BrandImageSetting);

        var _this = (0, _possibleConstructorReturn3.default)(this, (BrandImageSetting.__proto__ || (0, _getPrototypeOf2.default)(BrandImageSetting)).call(this, props));

        _this.handleImageChange = _this.handleImageChange.bind(_this);
        _this.handleImageSubmit = _this.handleImageSubmit.bind(_this);

        _this.state = {
            brandImage: null,
            brandImageExists: false,
            brandImageTimestamp: Date.now(),
            error: '',
            status: _constants.UploadStatuses.DEFAULT
        };
        return _this;
    }

    (0, _createClass3.default)(BrandImageSetting, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _this2 = this;

            fetch(_client.Client4.getBrandImageUrl(this.state.brandImageTimestamp)).then(function (resp) {
                if (resp.status === HTTP_STATUS_OK) {
                    _this2.setState({ brandImageExists: true });
                } else {
                    _this2.setState({ brandImageExists: false });
                }
            });
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            if (this.refs.image) {
                var reader = new FileReader();

                var img = this.refs.image;
                reader.onload = function (e) {
                    (0, _jquery2.default)(img).attr('src', e.target.result);
                };

                reader.readAsDataURL(this.state.brandImage);
            }
        }
    }, {
        key: 'handleImageChange',
        value: function handleImageChange() {
            var element = (0, _jquery2.default)(this.refs.fileInput);

            if (element.prop('files').length > 0) {
                this.setState({
                    brandImage: element.prop('files')[0],
                    status: _constants.UploadStatuses.DEFAULT
                });
            }
        }
    }, {
        key: 'handleImageSubmit',
        value: function handleImageSubmit(e) {
            var _this3 = this;

            e.preventDefault();

            if (!this.state.brandImage) {
                return;
            }

            if (this.state.status === _constants.UploadStatuses.LOADING) {
                return;
            }

            this.setState({
                error: '',
                status: _constants.UploadStatuses.LOADING
            });

            (0, _admin_actions.uploadBrandImage)(this.state.brandImage, function () {
                _this3.setState({
                    brandImageExists: true,
                    brandImage: null,
                    brandImageTimestamp: Date.now(),
                    status: _constants.UploadStatuses.COMPLETE
                });
            }, function (err) {
                _this3.setState({
                    error: err.message,
                    status: _constants.UploadStatuses.DEFAULT
                });
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var btnPrimaryClass = 'btn';
            if (this.state.brandImage) {
                btnPrimaryClass += ' btn-primary';
            }

            var letbtnDefaultClass = 'btn';
            if (!this.props.disabled) {
                letbtnDefaultClass += ' btn-default';
            }

            var img = null;
            if (this.state.brandImage) {
                img = _react2.default.createElement('img', {
                    ref: 'image',
                    className: 'brand-img',
                    src: ''
                });
            } else if (this.state.brandImageExists) {
                img = _react2.default.createElement('img', {
                    className: 'brand-img',
                    src: _client.Client4.getBrandImageUrl(this.state.brandImageTimestamp)
                });
            } else {
                img = _react2.default.createElement(
                    'p',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.team.noBrandImage',
                        defaultMessage: 'No brand image uploaded'
                    })
                );
            }

            return _react2.default.createElement(
                'div',
                { className: 'form-group' },
                _react2.default.createElement(
                    'label',
                    { className: 'control-label col-sm-4' },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.team.brandImageTitle',
                        defaultMessage: 'Custom Brand Image:'
                    })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'col-sm-8' },
                    img
                ),
                _react2.default.createElement('div', { className: 'col-sm-4' }),
                _react2.default.createElement(
                    'div',
                    { className: 'col-sm-8' },
                    _react2.default.createElement(
                        'div',
                        { className: 'file__upload' },
                        _react2.default.createElement(
                            'button',
                            {
                                className: letbtnDefaultClass,
                                disabled: this.props.disabled
                            },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'admin.team.chooseImage',
                                defaultMessage: 'Choose New Image'
                            })
                        ),
                        _react2.default.createElement('input', {
                            ref: 'fileInput',
                            type: 'file',
                            accept: '.jpg,.png,.bmp',
                            disabled: this.props.disabled,
                            onChange: this.handleImageChange
                        })
                    ),
                    _react2.default.createElement(_upload_button2.default, {
                        primaryClass: btnPrimaryClass,
                        status: this.state.status,
                        disabled: this.props.disabled || !this.state.brandImage,
                        onClick: this.handleImageSubmit
                    }),
                    _react2.default.createElement('br', null),
                    _react2.default.createElement(_form_error2.default, { error: this.state.error }),
                    _react2.default.createElement(
                        'p',
                        { className: 'help-text no-margin' },
                        _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                            id: 'admin.team.uploadDesc',
                            defaultMessage: 'Customize your user experience by adding a custom image to your login screen. See examples at <a href="http://docs.mattermost.com/administration/config-settings.html#custom-branding" target="_blank">docs.mattermost.com/administration/config-settings.html#custom-branding</a>.'
                        })
                    )
                )
            );
        }
    }]);
    return BrandImageSetting;
}(_react2.default.PureComponent);

BrandImageSetting.propTypes = {

    /*
     * Set to disable the setting
     */
    disabled: _propTypes2.default.bool.isRequired
};
exports.default = BrandImageSetting;

/***/ }),

/***/ 2578:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _constants = __webpack_require__(29);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var UploadButton = function (_React$PureComponent) {
    (0, _inherits3.default)(UploadButton, _React$PureComponent);

    function UploadButton() {
        (0, _classCallCheck3.default)(this, UploadButton);
        return (0, _possibleConstructorReturn3.default)(this, (UploadButton.__proto__ || (0, _getPrototypeOf2.default)(UploadButton)).apply(this, arguments));
    }

    (0, _createClass3.default)(UploadButton, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                status = _props.status,
                primaryClass = _props.primaryClass,
                disabled = _props.disabled,
                onClick = _props.onClick;


            var buttonIcon = void 0;
            var buttonText = void 0;

            switch (status) {
                case _constants.UploadStatuses.LOADING:
                    buttonIcon = _react2.default.createElement('i', { className: 'fa fa-refresh icon--rotate' });
                    buttonText = Utils.localizeMessage('admin.team.uploading', 'Uploading..');
                    break;
                case _constants.UploadStatuses.COMPLETE:
                    buttonIcon = _react2.default.createElement('i', { className: 'fa fa-check' });
                    buttonText = Utils.localizeMessage('admin.team.uploaded', 'Uploaded!');
                    break;
                default:
                    buttonText = Utils.localizeMessage('admin.team.upload', 'Upload');
            }

            return _react2.default.createElement(
                'button',
                {
                    className: primaryClass,
                    disabled: disabled,
                    onClick: onClick,
                    id: 'upload-button'
                },
                buttonIcon,
                ' ',
                buttonText
            );
        }
    }]);
    return UploadButton;
}(_react2.default.PureComponent);

UploadButton.propTypes = {

    /*
     * Upload status - loading, complete, default ('')
     */
    status: _propTypes2.default.string,

    /*
     * Primary class of the button
     */
    primaryClass: _propTypes2.default.string,

    /*
     * Disable the button
     */
    disabled: _propTypes2.default.bool,

    /*
     * Funtion to call on button click
     */
    onClick: _propTypes2.default.func
};
exports.default = UploadButton;

/***/ }),

/***/ 2579:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _admin_settings = __webpack_require__(787);

var _admin_settings2 = _interopRequireDefault(_admin_settings);

var _boolean_setting = __webpack_require__(800);

var _boolean_setting2 = _interopRequireDefault(_boolean_setting);

var _dropdown_setting = __webpack_require__(842);

var _dropdown_setting2 = _interopRequireDefault(_dropdown_setting);

var _settings_group = __webpack_require__(788);

var _settings_group2 = _interopRequireDefault(_settings_group);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CustomEmojiSettings = function (_AdminSettings) {
    (0, _inherits3.default)(CustomEmojiSettings, _AdminSettings);

    function CustomEmojiSettings(props) {
        (0, _classCallCheck3.default)(this, CustomEmojiSettings);

        var _this = (0, _possibleConstructorReturn3.default)(this, (CustomEmojiSettings.__proto__ || (0, _getPrototypeOf2.default)(CustomEmojiSettings)).call(this, props));

        _this.getConfigFromState = _this.getConfigFromState.bind(_this);

        _this.renderSettings = _this.renderSettings.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(CustomEmojiSettings, [{
        key: 'getConfigFromState',
        value: function getConfigFromState(config) {
            config.ServiceSettings.EnableCustomEmoji = this.state.enableCustomEmoji;
            config.ServiceSettings.EnableEmojiPicker = this.state.enableEmojiPicker;

            if (this.props.license.IsLicensed === 'true') {
                config.ServiceSettings.RestrictCustomEmojiCreation = this.state.restrictCustomEmojiCreation;
            }

            return config;
        }
    }, {
        key: 'getStateFromConfig',
        value: function getStateFromConfig(config) {
            return {
                enableCustomEmoji: config.ServiceSettings.EnableCustomEmoji,
                enableEmojiPicker: config.ServiceSettings.EnableEmojiPicker,
                restrictCustomEmojiCreation: config.ServiceSettings.RestrictCustomEmojiCreation
            };
        }
    }, {
        key: 'renderTitle',
        value: function renderTitle() {
            return _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'admin.customization.emoji',
                defaultMessage: 'Emoji'
            });
        }
    }, {
        key: 'renderSettings',
        value: function renderSettings() {
            var restrictSetting = null;
            if (this.props.license.IsLicensed === 'true') {
                restrictSetting = _react2.default.createElement(_dropdown_setting2.default, {
                    id: 'restrictCustomEmojiCreation',
                    values: [{ value: 'all', text: Utils.localizeMessage('admin.customization.restrictCustomEmojiCreationAll', 'Allow everyone to create custom emoji') }, { value: 'admin', text: Utils.localizeMessage('admin.customization.restrictCustomEmojiCreationAdmin', 'Allow System and Team Admins to create custom emoji') }, { value: 'system_admin', text: Utils.localizeMessage('admin.customization.restrictCustomEmojiCreationSystemAdmin', 'Only allow System Admins to create custom emoji') }],
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.customization.restrictCustomEmojiCreationTitle',
                        defaultMessage: 'Restrict Custom Emoji Creation:'
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.customization.restrictCustomEmojiCreationDesc',
                        defaultMessage: 'Restrict the creation of custom emoji to certain users.'
                    }),
                    value: this.state.restrictCustomEmojiCreation,
                    onChange: this.handleChange,
                    disabled: !this.state.enableCustomEmoji
                });
            }

            return _react2.default.createElement(
                _settings_group2.default,
                null,
                _react2.default.createElement(_boolean_setting2.default, {
                    id: 'enableEmojiPicker',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.customization.enableEmojiPickerTitle',
                        defaultMessage: 'Enable Emoji Picker:'
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.customization.enableEmojiPickerDesc',
                        defaultMessage: 'The emoji picker allows users to select emoji to add as reactions or use in messages. Enabling the emoji picker with a large number of custom emoji may slow down performance.'
                    }),
                    value: this.state.enableEmojiPicker,
                    onChange: this.handleChange
                }),
                _react2.default.createElement(_boolean_setting2.default, {
                    id: 'enableCustomEmoji',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.customization.enableCustomEmojiTitle',
                        defaultMessage: 'Enable Custom Emoji:'
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.customization.enableCustomEmojiDesc',
                        defaultMessage: 'Enable users to create custom emoji for use in messages. When enabled, Custom Emoji settings can be accessed by switching to a team and clicking the three dots above the channel sidebar, and selecting "Custom Emoji".'
                    }),
                    value: this.state.enableCustomEmoji,
                    onChange: this.handleChange
                }),
                restrictSetting
            );
        }
    }]);
    return CustomEmojiSettings;
}(_admin_settings2.default); // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = CustomEmojiSettings;

/***/ }),

/***/ 2580:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _constants = __webpack_require__(29);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _confirm_modal = __webpack_require__(819);

var _confirm_modal2 = _interopRequireDefault(_confirm_modal);

var _admin_settings = __webpack_require__(787);

var _admin_settings2 = _interopRequireDefault(_admin_settings);

var _dropdown_setting = __webpack_require__(842);

var _dropdown_setting2 = _interopRequireDefault(_dropdown_setting);

var _jobs = __webpack_require__(996);

var _jobs2 = _interopRequireDefault(_jobs);

var _settings_group = __webpack_require__(788);

var _settings_group2 = _interopRequireDefault(_settings_group);

var _text_setting = __webpack_require__(794);

var _text_setting2 = _interopRequireDefault(_text_setting);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var DataRetentionSettings = function (_AdminSettings) {
    (0, _inherits3.default)(DataRetentionSettings, _AdminSettings);

    function DataRetentionSettings(props) {
        (0, _classCallCheck3.default)(this, DataRetentionSettings);

        var _this = (0, _possibleConstructorReturn3.default)(this, (DataRetentionSettings.__proto__ || (0, _getPrototypeOf2.default)(DataRetentionSettings)).call(this, props));

        _this.handleSubmit = function (e) {
            e.preventDefault();

            _this.setState({ showConfirmModal: true });
        };

        _this.handleSaveConfirmed = function () {
            _this.setState({ showConfirmModal: false });

            _this.doSubmit();
        };

        _this.handleSaveCanceled = function () {
            _this.setState({ showConfirmModal: false });
        };

        _this.getConfigFromState = _this.getConfigFromState.bind(_this);

        _this.renderSettings = _this.renderSettings.bind(_this);
        _this.renderConfirmModal = _this.renderConfirmModal.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(DataRetentionSettings, [{
        key: 'getConfigFromState',
        value: function getConfigFromState(config) {
            config.DataRetentionSettings.EnableMessageDeletion = this.state.enableMessageDeletion === 'true';
            config.DataRetentionSettings.EnableFileDeletion = this.state.enableFileDeletion === 'true';
            config.DataRetentionSettings.MessageRetentionDays = parseInt(this.state.messageRetentionDays, 10);
            config.DataRetentionSettings.FileRetentionDays = parseInt(this.state.fileRetentionDays, 10);
            config.DataRetentionSettings.DeletionJobStartTime = this.state.deletionJobStartTime;

            return config;
        }
    }, {
        key: 'getStateFromConfig',
        value: function getStateFromConfig(config) {
            return {
                enableMessageDeletion: String(config.DataRetentionSettings.EnableMessageDeletion),
                enableFileDeletion: String(config.DataRetentionSettings.EnableFileDeletion),
                messageRetentionDays: config.DataRetentionSettings.MessageRetentionDays,
                fileRetentionDays: config.DataRetentionSettings.FileRetentionDays,
                deletionJobStartTime: config.DataRetentionSettings.DeletionJobStartTime,
                showConfirmModal: false
            };
        }
    }, {
        key: 'renderConfirmModal',
        value: function renderConfirmModal() {
            var title = _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'admin.data_retention.confirmChangesModal.title',
                defaultMessage: 'Confirm data retention policy'
            });

            var messageList = [];

            if (this.state.enableMessageDeletion === 'true') {
                messageList.push(_react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'admin.data_retention.confirmChangesModal.description.itemMessageDeletion',
                    defaultMessage: 'All messages will be permanently deleted after {days} days.',
                    values: {
                        days: _react2.default.createElement(
                            'strong',
                            null,
                            this.state.messageRetentionDays
                        )
                    }
                }));
            } else {
                messageList.push(_react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'admin.data_retention.confirmChangesModal.description.itemMessageIndefinite',
                    defaultMessage: 'All messages will be retained indefinitely.'
                }));
            }

            if (this.state.enableFileDeletion === 'true') {
                messageList.push(_react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'admin.data_retention.confirmChangesModal.description.itemFileDeletion',
                    defaultMessage: 'All files will be permanently deleted after {days} days.',
                    values: {
                        days: _react2.default.createElement(
                            'strong',
                            null,
                            this.state.fileRetentionDays
                        )
                    }
                }));
            } else {
                messageList.push(_react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'admin.data_retention.confirmChangesModal.description.itemFileIndefinite',
                    defaultMessage: 'All files will be retained indefinitely.'
                }));
            }

            var message = _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'p',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.data_retention.confirmChangesModal.description',
                        defaultMessage: 'Are you sure you want to apply the following data retention policy:'
                    })
                ),
                _react2.default.createElement(
                    'ul',
                    null,
                    messageList.map(function (item, index) {
                        return _react2.default.createElement(
                            'li',
                            { key: index },
                            item
                        );
                    })
                ),
                _react2.default.createElement(
                    'p',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.data_retention.confirmChangesModal.clarification',
                        defaultMessage: 'Once deleted, messages and files cannot be retrieved.'
                    })
                )
            );

            var confirmButton = _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'admin.data_retention.confirmChangesModal.confirm',
                defaultMessage: 'Confirm Settings'
            });

            return _react2.default.createElement(_confirm_modal2.default, {
                show: this.state.showConfirmModal,
                title: title,
                message: message,
                confirmButtonText: confirmButton,
                onConfirm: this.handleSaveConfirmed,
                onCancel: this.handleSaveCanceled
            });
        }
    }, {
        key: 'renderTitle',
        value: function renderTitle() {
            return _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'admin.data_retention.title',
                defaultMessage: 'Data Retention Policy (Beta)'
            });
        }
    }, {
        key: 'renderSettings',
        value: function renderSettings() {
            var enableMessageDeletionOptions = [{ value: 'false', text: Utils.localizeMessage('admin.data_retention.keepMessagesIndefinitely', 'Keep all messages indefinitely') }, { value: 'true', text: Utils.localizeMessage('admin.data_retention.keepMessageForTime', 'Keep messages for a set amount of time') }];

            var enableFileDeletionOptions = [{ value: 'false', text: Utils.localizeMessage('admin.data_retention.keepFilesIndefinitely', 'Keep all files indefinitely') }, { value: 'true', text: Utils.localizeMessage('admin.data_retention.keepFilesForTime', 'Keep files for a set amount of time') }];

            var messageRetentionDaysSetting = '';
            if (this.state.enableMessageDeletion === 'true') {
                messageRetentionDaysSetting = _react2.default.createElement(_text_setting2.default, {
                    id: 'messageRetentionDays',
                    label: _react2.default.createElement('span', null),
                    placeholder: Utils.localizeMessage('admin.data_retention.messageRetentionDays.example', 'E.g.: "60"'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.data_retention.messageRetentionDays.description',
                        defaultMessage: 'Set how many days messages are kept in Mattermost. Messages, including file attachments older than the duration you set will be deleted nightly. The minimum time is one day.'
                    }),
                    value: this.state.messageRetentionDays,
                    onChange: this.handleChange
                });
            }

            var fileRetentionDaysSetting = '';
            if (this.state.enableFileDeletion === 'true') {
                fileRetentionDaysSetting = _react2.default.createElement(_text_setting2.default, {
                    id: 'fileRetentionDays',
                    label: _react2.default.createElement('span', null),
                    placeholder: Utils.localizeMessage('admin.data_retention.fileRetentionDays.example', 'E.g.: "60"'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.data_retention.fileRetentionDays.description',
                        defaultMessage: 'Set how many days file uploads are kept in Mattermost. Files older than the duration you set will be deleted nightly. The minimum time is one day.'
                    }),
                    value: this.state.fileRetentionDays,
                    onChange: this.handleChange
                });
            }

            var confirmModal = this.renderConfirmModal();

            return _react2.default.createElement(
                _settings_group2.default,
                null,
                confirmModal,
                _react2.default.createElement(
                    'div',
                    { className: 'banner' },
                    _react2.default.createElement(
                        'div',
                        { className: 'banner__content' },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'admin.data_retention.note.description',
                            defaultMessage: 'Caution: Once a message or a file is deleted, the action is irreversible. Please be careful when setting up a custom data retention policy. See {documentationLink} to learn more.',
                            values: {
                                documentationLink: _react2.default.createElement(
                                    'a',
                                    {
                                        href: 'https://about.mattermost.com/default-dataretention-documentation/',
                                        rel: 'noopener noreferrer',
                                        target: '_blank'
                                    },
                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'admin.data_retention.note.description.documentationLinkText',
                                        defaultMessage: 'documentation'
                                    })
                                )
                            }
                        })
                    )
                ),
                _react2.default.createElement(_dropdown_setting2.default, {
                    id: 'enableMessageDeletion',
                    values: enableMessageDeletionOptions,
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.data_retention.enableMessageDeletion.title',
                        defaultMessage: 'Message Retention:'
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.data_retention.enableMessageDeletion.description',
                        defaultMessage: 'Set how long Mattermost keeps messages in channels and direct messages.'
                    }),
                    value: this.state.enableMessageDeletion,
                    onChange: this.handleChange
                }),
                messageRetentionDaysSetting,
                _react2.default.createElement(_dropdown_setting2.default, {
                    id: 'enableFileDeletion',
                    values: enableFileDeletionOptions,
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.data_retention.enableFileDeletion.title',
                        defaultMessage: 'File Retention:'
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.data_retention.enableFileDeletion.description',
                        defaultMessage: 'Set how long Mattermost keeps file uploads in channels and direct messages.'
                    }),
                    value: this.state.enableFileDeletion,
                    onChange: this.handleChange
                }),
                fileRetentionDaysSetting,
                _react2.default.createElement(_text_setting2.default, {
                    id: 'deletionJobStartTime',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.data_retention.deletionJobStartTime.title',
                        defaultMessage: 'Data Deletion Time:'
                    }),
                    placeholder: Utils.localizeMessage('admin.data_retention.deletionJobStartTime.example', 'E.g.: "02:00"'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.data_retention.deletionJobStartTime.description',
                        defaultMessage: 'Set the start time of the daily scheduled data retention job. Choose a time when fewer people are using your system. Must be a 24-hour time stamp in the form HH:MM.'
                    }),
                    value: this.state.deletionJobStartTime,
                    onChange: this.handleChange
                }),
                _react2.default.createElement(_jobs2.default, {
                    jobType: _constants.JobTypes.DATA_RETENTION,
                    disabled: this.state.enableMessageDeletion !== 'true' && this.state.enableFileDeletion !== 'true',
                    createJobButtonText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.data_retention.createJob.title',
                        defaultMessage: 'Run Deletion Job Now'
                    }),
                    createJobHelpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.data_retention.createJob.help',
                        defaultMessage: 'Initiates a Data Retention deletion job immediately.'
                    })
                })
            );
        }
    }]);
    return DataRetentionSettings;
}(_admin_settings2.default);

exports.default = DataRetentionSettings;

/***/ }),

/***/ 2581:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getAllJobs = getAllJobs;
exports.getJobsByType = getJobsByType;
exports.makeGetJobsByType = makeGetJobsByType;

var _reselect = __webpack_require__(78);

function getAllJobs(state) {
    return state.entities.jobs.jobs;
} // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function getJobsByType(state) {
    return state.entities.jobs.jobsByTypeList;
}

function makeGetJobsByType(type) {
    return (0, _reselect.createSelector)(getJobsByType, function (jobsByType) {
        return Object.values(jobsByType[type] || []);
    });
}

/***/ }),

/***/ 2582:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _job_actions = __webpack_require__(2583);

var _error_store = __webpack_require__(847);

var _error_store2 = _interopRequireDefault(_error_store);

var _constants = __webpack_require__(29);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var JobTable = function (_React$PureComponent) {
    (0, _inherits3.default)(JobTable, _React$PureComponent);

    function JobTable(props) {
        (0, _classCallCheck3.default)(this, JobTable);

        var _this = (0, _possibleConstructorReturn3.default)(this, (JobTable.__proto__ || (0, _getPrototypeOf2.default)(JobTable)).call(this, props));

        _this.getStatus = function (job) {
            if (job.status === _constants.JobStatuses.PENDING) {
                return _react2.default.createElement(
                    'span',
                    {
                        className: 'status-icon-warning',
                        title: Utils.localizeMessage('admin.jobTable.jobId', 'Job ID: ') + job.id
                    },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.jobTable.statusPending',
                        defaultMessage: 'Pending'
                    })
                );
            } else if (job.status === _constants.JobStatuses.IN_PROGRESS) {
                return _react2.default.createElement(
                    'span',
                    {
                        className: 'status-icon-warning',
                        title: Utils.localizeMessage('admin.jobTable.jobId', 'Job ID: ') + job.id
                    },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.jobTable.statusInProgress',
                        defaultMessage: 'In Progress'
                    })
                );
            } else if (job.status === _constants.JobStatuses.SUCCESS) {
                return _react2.default.createElement(
                    'span',
                    {
                        className: 'status-icon-success',
                        title: Utils.localizeMessage('admin.jobTable.jobId', 'Job ID: ') + job.id
                    },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.jobTable.statusSuccess',
                        defaultMessage: 'Success'
                    })
                );
            } else if (job.status === _constants.JobStatuses.ERROR) {
                return _react2.default.createElement(
                    'span',
                    {
                        className: 'status-icon-error',
                        title: Utils.localizeMessage('admin.jobTable.jobId', 'Job ID: ') + job.id
                    },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.jobTable.statusError',
                        defaultMessage: 'Error'
                    })
                );
            } else if (job.status === _constants.JobStatuses.CANCEL_REQUESTED) {
                return _react2.default.createElement(
                    'span',
                    {
                        className: 'status-icon-warning',
                        title: Utils.localizeMessage('admin.jobTable.jobId', 'Job ID: ') + job.id
                    },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.jobTable.statusCanceling',
                        defaultMessage: 'Canceling...'
                    })
                );
            } else if (job.status === _constants.JobStatuses.CANCELED) {
                return _react2.default.createElement(
                    'span',
                    {
                        className: 'status-icon-error',
                        title: Utils.localizeMessage('admin.jobTable.jobId', 'Job ID: ') + job.id
                    },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.jobTable.statusCanceled',
                        defaultMessage: 'Canceled'
                    })
                );
            }

            return _react2.default.createElement(
                'span',
                { title: Utils.localizeMessage('admin.jobTable.jobId', 'Job ID: ') + job.id },
                job.status
            );
        };

        _this.getExtraInfoText = function (job) {
            if (job.data && job.data.error && job.data.error.length > 0) {
                return _react2.default.createElement(
                    'span',
                    { title: job.data.error },
                    job.data.error
                );
            }

            if (_this.props.getExtraInfoText) {
                return _this.props.getExtraInfoText(job);
            }

            return _react2.default.createElement('span', null);
        };

        _this.getRunLength = function (job) {
            var millis = job.last_activity_at - job.start_at;
            if (job.status === _constants.JobStatuses.IN_PROGRESS) {
                var runningMillis = Date.now() - job.start_at;
                if (runningMillis > millis) {
                    millis = runningMillis;
                }
            }

            var lastActivity = Utils.localizeMessage('admin.jobTable.lastActivityAt', 'Last Activity: ') + '--';

            if (job.last_activity_at > 0) {
                lastActivity = Utils.localizeMessage('admin.jobTable.lastActivityAt', 'Last Activity: ') + _this.props.intl.formatDate(new Date(job.last_activity_at), {
                    year: 'numeric',
                    month: 'short',
                    day: '2-digit'
                }) + ' - ' + _this.props.intl.formatTime(new Date(job.last_activity_at), {
                    hour: '2-digit',
                    minute: '2-digit',
                    second: '2-digit'
                });
            }

            var seconds = Math.round(millis / 1000);
            var minutes = Math.round(millis / (1000 * 60));

            if (millis <= 0 || job.status === _constants.JobStatuses.CANCELED) {
                return _react2.default.createElement(
                    'span',
                    { className: 'whitespace--nowrap' },
                    '--'
                );
            }

            if (seconds <= 120) {
                return _react2.default.createElement(
                    'span',
                    {
                        className: 'whitespace--nowrap',
                        title: lastActivity
                    },
                    seconds + Utils.localizeMessage('admin.jobTable.runLengthSeconds', ' seconds')
                );
            }

            return _react2.default.createElement(
                'span',
                {
                    className: 'whitespace--nowrap',
                    title: lastActivity
                },
                minutes + Utils.localizeMessage('admin.jobTable.runLengthMinutes', ' minutes')
            );
        };

        _this.getFinishAt = function (status, millis) {
            if (millis === 0 || status === _constants.JobStatuses.PENDING || status === _constants.JobStatuses.IN_PROGRESS || status === _constants.JobStatuses.CANCEL_REQUESTED) {
                return _react2.default.createElement(
                    'span',
                    { className: 'whitespace--nowrap' },
                    '--'
                );
            }

            var date = new Date(millis);
            return _react2.default.createElement(
                'span',
                { className: 'whitespace--nowrap' },
                _react2.default.createElement(_reactIntl.FormattedDate, {
                    value: date,
                    day: '2-digit',
                    month: 'short',
                    year: 'numeric'
                }),
                ' - ',
                _react2.default.createElement(_reactIntl.FormattedTime, {
                    value: date,
                    hour: '2-digit',
                    minute: '2-digit'
                })
            );
        };

        _this.reload = function () {
            _this.setState({ loading: true });

            _this.props.actions.getJobsByType(_this.props.jobType).then(function () {
                _this.setState({
                    loading: false
                });
            });
        };

        _this.handleCancelJob = function (e) {
            e.preventDefault();
            var jobId = e.currentTarget.getAttribute('data-job-id');

            (0, _job_actions.cancelJob)(jobId, function () {
                _this.reload();
            }, function (err) {
                _error_store2.default.storeLastError(err);
                _error_store2.default.emitChange();
                _this.reload();
            });
        };

        _this.handleCreateJob = function (e) {
            e.preventDefault();

            var job = {
                type: _this.props.jobType
            };

            (0, _job_actions.createJob)(job, function () {
                _this.reload();
            }, function (err) {
                _error_store2.default.storeLastError(err);
                _error_store2.default.emitChange();
                _this.reload();
            });
        };

        _this.getCancelButton = function (job) {
            var cancelButton = null;

            if (!_this.props.disabled && (job.status === _constants.JobStatuses.PENDING || job.status === _constants.JobStatuses.IN_PROGRESS)) {
                cancelButton = _react2.default.createElement(
                    'span',
                    {
                        'data-job-id': job.id,
                        onClick: _this.handleCancelJob,
                        className: 'job-table__cancel-button',
                        title: Utils.localizeMessage('admin.jobTable.cancelButton', 'Cancel')
                    },
                    '×'
                );
            }

            return cancelButton;
        };

        _this.interval = null;

        _this.state = {
            loading: true
        };
        return _this;
    }

    (0, _createClass3.default)(JobTable, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.interval = setInterval(this.reload, 15000);
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            this.props.actions.getJobsByType(this.props.jobType).then(function () {
                return _this2.setState({ loading: false });
            });
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.interval) {
                clearInterval(this.interval);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var items = this.props.jobs.map(function (job) {
                return _react2.default.createElement(
                    'tr',
                    { key: job.id },
                    _react2.default.createElement(
                        'td',
                        {
                            width: '30px',
                            className: 'whitespace--nowrap text-center'
                        },
                        _this3.getCancelButton(job)
                    ),
                    _react2.default.createElement(
                        'td',
                        { className: 'whitespace--nowrap' },
                        _this3.getStatus(job)
                    ),
                    _react2.default.createElement(
                        'td',
                        { className: 'whitespace--nowrap' },
                        _this3.getFinishAt(job.status, job.last_activity_at)
                    ),
                    _react2.default.createElement(
                        'td',
                        { className: 'whitespace--nowrap' },
                        _this3.getRunLength(job)
                    ),
                    _react2.default.createElement(
                        'td',
                        { colSpan: '3' },
                        _this3.getExtraInfoText(job)
                    )
                );
            });

            return _react2.default.createElement(
                'div',
                { className: 'job-table__panel' },
                _react2.default.createElement(
                    'div',
                    { className: 'job-table__create-button' },
                    _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                            'button',
                            {
                                className: 'btn btn-default',
                                onClick: this.handleCreateJob,
                                disabled: this.props.disabled
                            },
                            this.props.createJobButtonText
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'help-text' },
                        this.props.createJobHelpText
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'job-table__table' },
                    _react2.default.createElement(
                        'table',
                        { className: 'table' },
                        _react2.default.createElement(
                            'thead',
                            null,
                            _react2.default.createElement(
                                'tr',
                                null,
                                _react2.default.createElement('th', { width: '30px' }),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'admin.jobTable.headerStatus',
                                        defaultMessage: 'Status'
                                    })
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'admin.jobTable.headerFinishAt',
                                        defaultMessage: 'Finish Time'
                                    })
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'admin.jobTable.headerRunTime',
                                        defaultMessage: 'Run Time'
                                    })
                                ),
                                _react2.default.createElement(
                                    'th',
                                    { colSpan: '3' },
                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'admin.jobTable.headerExtraInfo',
                                        defaultMessage: 'Details'
                                    })
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'tbody',
                            null,
                            items
                        )
                    )
                )
            );
        }
    }]);
    return JobTable;
}(_react2.default.PureComponent); // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

JobTable.propTypes = {

    /**
     * Used for formatting dates
     */
    intl: _reactIntl.intlShape.isRequired,

    /**
     * Array of jobs
     */
    jobs: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,

    actions: _propTypes2.default.shape({

        /**
         * Function to fetch jobs
         */
        getJobsByType: _propTypes2.default.func.isRequired
    }).isRequired,

    /**
     * Function called when displaying extra text.
     */
    getExtraInfoText: _propTypes2.default.func,

    /**
     * Grey buttons out when disabled
     */
    disabled: _propTypes2.default.bool,

    /**
     * Help text under the create job button
     */
    createJobHelpText: _propTypes2.default.element.isRequired,

    /**
     * Button text to create a new job
     */
    createJobButtonText: _propTypes2.default.element.isRequired,

    /**
     * The type of jobs to include in this table.
     */
    jobType: _propTypes2.default.string.isRequired
};
exports.default = (0, _reactIntl.injectIntl)(JobTable);

/***/ }),

/***/ 2583:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.cancelJob = exports.createJob = undefined;

var _regenerator = __webpack_require__(114);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _asyncToGenerator2 = __webpack_require__(115);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var createJob = exports.createJob = function () {
    var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(job, success, error) {
        var _ref2, data, err;

        return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _context.next = 2;
                        return JobsActions.createJob(job)(dispatch, getState);

                    case 2:
                        _ref2 = _context.sent;
                        data = _ref2.data;
                        err = _ref2.error;

                        if (data && success) {
                            success(data);
                        } else if (err && error) {
                            error((0, _extends3.default)({ id: err.server_error_id }, err));
                        }

                    case 6:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    return function createJob(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
    };
}();

var cancelJob = exports.cancelJob = function () {
    var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(jobId, success, error) {
        var _ref4, data, err;

        return _regenerator2.default.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        _context2.next = 2;
                        return JobsActions.cancelJob(jobId)(dispatch, getState);

                    case 2:
                        _ref4 = _context2.sent;
                        data = _ref4.data;
                        err = _ref4.error;

                        if (data && success) {
                            success(data);
                        } else if (err && error) {
                            error((0, _extends3.default)({ id: err.server_error_id }, err));
                        }

                    case 6:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, _callee2, this);
    }));

    return function cancelJob(_x4, _x5, _x6) {
        return _ref3.apply(this, arguments);
    };
}();

var _jobs = __webpack_require__(1452);

var JobsActions = _interopRequireWildcard(_jobs);

var _redux_store = __webpack_require__(271);

var _redux_store2 = _interopRequireDefault(_redux_store);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var dispatch = _redux_store2.default.dispatch;
var getState = _redux_store2.default.getState;

/***/ }),

/***/ 2584:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _admin_actions = __webpack_require__(797);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _admin_settings = __webpack_require__(787);

var _admin_settings2 = _interopRequireDefault(_admin_settings);

var _boolean_setting = __webpack_require__(800);

var _boolean_setting2 = _interopRequireDefault(_boolean_setting);

var _generated_setting = __webpack_require__(997);

var _generated_setting2 = _interopRequireDefault(_generated_setting);

var _request_button = __webpack_require__(998);

var _request_button2 = _interopRequireDefault(_request_button);

var _settings_group = __webpack_require__(788);

var _settings_group2 = _interopRequireDefault(_settings_group);

var _text_setting = __webpack_require__(794);

var _text_setting2 = _interopRequireDefault(_text_setting);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var DatabaseSettings = function (_AdminSettings) {
    (0, _inherits3.default)(DatabaseSettings, _AdminSettings);

    function DatabaseSettings(props) {
        (0, _classCallCheck3.default)(this, DatabaseSettings);

        var _this = (0, _possibleConstructorReturn3.default)(this, (DatabaseSettings.__proto__ || (0, _getPrototypeOf2.default)(DatabaseSettings)).call(this, props));

        _this.getConfigFromState = _this.getConfigFromState.bind(_this);

        _this.renderSettings = _this.renderSettings.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(DatabaseSettings, [{
        key: 'getConfigFromState',
        value: function getConfigFromState(config) {
            // driverName and dataSource are read-only from the UI

            config.SqlSettings.MaxIdleConns = this.parseIntNonZero(this.state.maxIdleConns);
            config.SqlSettings.MaxOpenConns = this.parseIntNonZero(this.state.maxOpenConns);
            config.SqlSettings.AtRestEncryptKey = this.state.atRestEncryptKey;
            config.SqlSettings.Trace = this.state.trace;
            config.SqlSettings.QueryTimeout = this.parseIntNonZero(this.state.queryTimeout);

            return config;
        }
    }, {
        key: 'getStateFromConfig',
        value: function getStateFromConfig(config) {
            return {
                driverName: config.SqlSettings.DriverName,
                dataSource: config.SqlSettings.DataSource,
                maxIdleConns: config.SqlSettings.MaxIdleConns,
                maxOpenConns: config.SqlSettings.MaxOpenConns,
                atRestEncryptKey: config.SqlSettings.AtRestEncryptKey,
                trace: config.SqlSettings.Trace,
                queryTimeout: config.SqlSettings.QueryTimeout
            };
        }
    }, {
        key: 'renderTitle',
        value: function renderTitle() {
            return _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'admin.database.title',
                defaultMessage: 'Database Settings'
            });
        }
    }, {
        key: 'renderSettings',
        value: function renderSettings() {
            var dataSource = '**********' + this.state.dataSource.substring(this.state.dataSource.indexOf('@'));

            var recycleDbButton = _react2.default.createElement('div', null);
            if (this.props.license.IsLicensed === 'true') {
                recycleDbButton = _react2.default.createElement(_request_button2.default, {
                    requestAction: _admin_actions.recycleDatabaseConnection,
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.recycle.recycleDescription',
                        defaultMessage: 'Deployments using multiple databases can switch from one master database to another without restarting the Mattermost server by updating "config.json" to the new desired configuration and using the {reloadConfiguration} feature to load the new settings while the server is running. The administrator should then use {featureName} feature to recycle the database connections based on the new settings.',
                        values: {
                            featureName: _react2.default.createElement(
                                'b',
                                null,
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'admin.recycle.recycleDescription.featureName',
                                    defaultMessage: 'Recycle Database Connections'
                                })
                            ),
                            reloadConfiguration: _react2.default.createElement(
                                'a',
                                { href: '../general/configuration' },
                                _react2.default.createElement(
                                    'b',
                                    null,
                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'admin.recycle.recycleDescription.reloadConfiguration',
                                        defaultMessage: 'Configuration > Reload Configuration from Disk'
                                    })
                                )
                            )
                        }
                    }),
                    buttonText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.recycle.button',
                        defaultMessage: 'Recycle Database Connections'
                    }),
                    showSuccessMessage: false,
                    errorMessage: {
                        id: 'admin.recycle.reloadFail',
                        defaultMessage: 'Recycling unsuccessful: {error}'
                    },
                    includeDetailedError: true
                });
            }

            return _react2.default.createElement(
                _settings_group2.default,
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'banner' },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.sql.noteDescription',
                        defaultMessage: 'Changing properties in this section will require a server restart before taking effect.'
                    })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'form-group' },
                    _react2.default.createElement(
                        'label',
                        {
                            className: 'control-label col-sm-4',
                            htmlFor: 'DriverName'
                        },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'admin.sql.driverName',
                            defaultMessage: 'Driver Name:'
                        })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'col-sm-8' },
                        _react2.default.createElement(
                            'p',
                            { className: 'help-text' },
                            this.state.driverName
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'form-group' },
                    _react2.default.createElement(
                        'label',
                        {
                            className: 'control-label col-sm-4',
                            htmlFor: 'DataSource'
                        },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'admin.sql.dataSource',
                            defaultMessage: 'Data Source:'
                        })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'col-sm-8' },
                        _react2.default.createElement(
                            'p',
                            { className: 'help-text' },
                            dataSource
                        )
                    )
                ),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'maxIdleConns',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.sql.maxConnectionsTitle',
                        defaultMessage: 'Maximum Idle Connections:'
                    }),
                    placeholder: Utils.localizeMessage('admin.sql.maxConnectionsExample', 'E.g.: "10"'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.sql.maxConnectionsDescription',
                        defaultMessage: 'Maximum number of idle connections held open to the database.'
                    }),
                    value: this.state.maxIdleConns,
                    onChange: this.handleChange
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'maxOpenConns',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.sql.maxOpenTitle',
                        defaultMessage: 'Maximum Open Connections:'
                    }),
                    placeholder: Utils.localizeMessage('admin.sql.maxOpenExample', 'E.g.: "10"'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.sql.maxOpenDescription',
                        defaultMessage: 'Maximum number of open connections held open to the database.'
                    }),
                    value: this.state.maxOpenConns,
                    onChange: this.handleChange
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'queryTimeout',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.sql.queryTimeoutTitle',
                        defaultMessage: 'Query Timeout:'
                    }),
                    placeholder: Utils.localizeMessage('admin.sql.queryTimeoutExample', 'E.g.: "30"'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.sql.queryTimeoutDescription',
                        defaultMessage: 'The number of seconds to wait for a response from the database after opening a connection and sending the query. Errors that you see in the UI or in the logs as a result of a query timeout can vary depending on the type of query.'
                    }),
                    value: this.state.queryTimeout,
                    onChange: this.handleChange
                }),
                _react2.default.createElement(_generated_setting2.default, {
                    id: 'atRestEncryptKey',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.sql.keyTitle',
                        defaultMessage: 'At Rest Encrypt Key:'
                    }),
                    placeholder: Utils.localizeMessage('admin.sql.keyExample', 'E.g.: "gxHVDcKUyP2y1eiyW8S8na1UYQAfq6J6"'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.sql.keyDescription',
                        defaultMessage: '32-character salt available to encrypt and decrypt sensitive fields in database.'
                    }),
                    value: this.state.atRestEncryptKey,
                    onChange: this.handleChange
                }),
                _react2.default.createElement(_boolean_setting2.default, {
                    id: 'trace',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.sql.traceTitle',
                        defaultMessage: 'Trace: '
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.sql.traceDescription',
                        defaultMessage: '(Development Mode) When true, executing SQL statements are written to the log.'
                    }),
                    value: this.state.trace,
                    onChange: this.handleChange
                }),
                recycleDbButton
            );
        }
    }]);
    return DatabaseSettings;
}(_admin_settings2.default);

exports.default = DatabaseSettings;

/***/ }),

/***/ 2585:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _admin_settings = __webpack_require__(787);

var _admin_settings2 = _interopRequireDefault(_admin_settings);

var _boolean_setting = __webpack_require__(800);

var _boolean_setting2 = _interopRequireDefault(_boolean_setting);

var _settings_group = __webpack_require__(788);

var _settings_group2 = _interopRequireDefault(_settings_group);

var _text_setting = __webpack_require__(794);

var _text_setting2 = _interopRequireDefault(_text_setting);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeveloperSettings = function (_AdminSettings) {
    (0, _inherits3.default)(DeveloperSettings, _AdminSettings);

    function DeveloperSettings(props) {
        (0, _classCallCheck3.default)(this, DeveloperSettings);

        var _this = (0, _possibleConstructorReturn3.default)(this, (DeveloperSettings.__proto__ || (0, _getPrototypeOf2.default)(DeveloperSettings)).call(this, props));

        _this.getConfigFromState = _this.getConfigFromState.bind(_this);

        _this.renderSettings = _this.renderSettings.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(DeveloperSettings, [{
        key: 'getConfigFromState',
        value: function getConfigFromState(config) {
            config.ServiceSettings.EnableTesting = this.state.enableTesting;
            config.ServiceSettings.EnableDeveloper = this.state.enableDeveloper;
            config.ServiceSettings.AllowedUntrustedInternalConnections = this.state.allowedUntrustedInternalConnections;

            return config;
        }
    }, {
        key: 'getStateFromConfig',
        value: function getStateFromConfig(config) {
            return {
                enableTesting: config.ServiceSettings.EnableTesting,
                enableDeveloper: config.ServiceSettings.EnableDeveloper,
                allowedUntrustedInternalConnections: config.ServiceSettings.AllowedUntrustedInternalConnections
            };
        }
    }, {
        key: 'renderTitle',
        value: function renderTitle() {
            return _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'admin.developer.title',
                defaultMessage: 'Developer Settings'
            });
        }
    }, {
        key: 'renderSettings',
        value: function renderSettings() {
            return _react2.default.createElement(
                _settings_group2.default,
                null,
                _react2.default.createElement(_boolean_setting2.default, {
                    id: 'enableTesting',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.service.testingTitle',
                        defaultMessage: 'Enable Testing Commands: '
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.service.testingDescription',
                        defaultMessage: 'When true, /test slash command is enabled to load test accounts, data and text formatting. Changing this requires a server restart before taking effect.'
                    }),
                    value: this.state.enableTesting,
                    onChange: this.handleChange
                }),
                _react2.default.createElement(_boolean_setting2.default, {
                    id: 'enableDeveloper',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.service.developerTitle',
                        defaultMessage: 'Enable Developer Mode: '
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.service.developerDesc',
                        defaultMessage: 'When true, JavaScript errors are shown in a purple bar at the top of the user interface. Not recommended for use in production. '
                    }),
                    value: this.state.enableDeveloper,
                    onChange: this.handleChange
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'allowedUntrustedInternalConnections',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.service.internalConnectionsTitle',
                        defaultMessage: 'Allow untrusted internal connections to: '
                    }),
                    placeholder: Utils.localizeMessage('admin.service.internalConnectionsEx', 'webhooks.internal.example.com 127.0.0.1 10.0.16.0/28'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                        id: 'admin.service.internalConnectionsDesc',
                        defaultMessage: 'In testing environments, such as when developing integrations locally on a development machine, use this setting to specify domains, IP addresses, or CIDR notations to allow internal connections. <b>Not recommended for use in production</b>, since this can allow a user to extract confidential data from your server or internal network.<br /><br />By default, user-supplied URLs such as those used for Open Graph metadata, webhooks, or slash commands will not be allowed to connect to reserved IP addresses including loopback or link-local addresses used for internal networks. Push notification, OAuth 2.0 and WebRTC server URLs are trusted and not affected by this setting.'
                    }),
                    value: this.state.allowedUntrustedInternalConnections,
                    onChange: this.handleChange
                })
            );
        }
    }]);
    return DeveloperSettings;
}(_admin_settings2.default); // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = DeveloperSettings;

/***/ }),

/***/ 2586:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(275);

var _stringify2 = _interopRequireDefault(_stringify);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(1160);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _admin_actions = __webpack_require__(797);

var _constants = __webpack_require__(29);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _admin_settings = __webpack_require__(787);

var _admin_settings2 = _interopRequireDefault(_admin_settings);

var _boolean_setting = __webpack_require__(800);

var _boolean_setting2 = _interopRequireDefault(_boolean_setting);

var _jobs = __webpack_require__(996);

var _jobs2 = _interopRequireDefault(_jobs);

var _request_button = __webpack_require__(998);

var _request_button2 = _interopRequireDefault(_request_button);

var _settings_group = __webpack_require__(788);

var _settings_group2 = _interopRequireDefault(_settings_group);

var _text_setting = __webpack_require__(794);

var _text_setting2 = _interopRequireDefault(_text_setting);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ElasticsearchSettings = function (_AdminSettings) {
    (0, _inherits3.default)(ElasticsearchSettings, _AdminSettings);

    function ElasticsearchSettings(props) {
        (0, _classCallCheck3.default)(this, ElasticsearchSettings);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ElasticsearchSettings.__proto__ || (0, _getPrototypeOf2.default)(ElasticsearchSettings)).call(this, props));

        _this.getConfigFromState = _this.getConfigFromState.bind(_this);

        _this.doTestConfig = _this.doTestConfig.bind(_this);
        _this.handleChange = _this.handleChange.bind(_this);
        _this.handleSaved = _this.handleSaved.bind(_this);

        _this.renderSettings = _this.renderSettings.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(ElasticsearchSettings, [{
        key: 'getConfigFromState',
        value: function getConfigFromState(config) {
            config.ElasticsearchSettings.ConnectionUrl = this.state.connectionUrl;
            config.ElasticsearchSettings.Username = this.state.username;
            config.ElasticsearchSettings.Password = this.state.password;
            config.ElasticsearchSettings.Sniff = this.state.sniff;
            config.ElasticsearchSettings.EnableIndexing = this.state.enableIndexing;
            config.ElasticsearchSettings.EnableSearching = this.state.enableSearching;

            return config;
        }
    }, {
        key: 'getStateFromConfig',
        value: function getStateFromConfig(config) {
            return {
                connectionUrl: config.ElasticsearchSettings.ConnectionUrl,
                username: config.ElasticsearchSettings.Username,
                password: config.ElasticsearchSettings.Password,
                sniff: config.ElasticsearchSettings.Sniff,
                enableIndexing: config.ElasticsearchSettings.EnableIndexing,
                enableSearching: config.ElasticsearchSettings.EnableSearching,
                configTested: true,
                canSave: true,
                canPurgeAndIndex: config.ElasticsearchSettings.EnableIndexing
            };
        }
    }, {
        key: 'handleChange',
        value: function handleChange(id, value) {
            if (id === 'enableIndexing') {
                if (value === false) {
                    this.setState({
                        enableSearching: false
                    });
                } else {
                    this.setState({
                        canSave: false,
                        configTested: false
                    });
                }
            }

            if (id === 'connectionUrl' || id === 'username' || id === 'password' || id === 'sniff') {
                this.setState({
                    configTested: false,
                    canSave: false
                });
            }

            if (id !== 'enableSearching') {
                this.setState({
                    canPurgeAndIndex: false
                });
            }

            (0, _get3.default)(ElasticsearchSettings.prototype.__proto__ || (0, _getPrototypeOf2.default)(ElasticsearchSettings.prototype), 'handleChange', this).call(this, id, value);
        }
    }, {
        key: 'handleSaved',
        value: function handleSaved() {
            this.setState({
                canPurgeAndIndex: this.state.enableIndexing
            });
        }
    }, {
        key: 'canSave',
        value: function canSave() {
            return this.state.canSave;
        }
    }, {
        key: 'doTestConfig',
        value: function doTestConfig(success, error) {
            var _this2 = this;

            var config = JSON.parse((0, _stringify2.default)(this.props.config));
            this.getConfigFromState(config);

            (0, _admin_actions.elasticsearchTest)(config, function () {
                _this2.setState({
                    configTested: true,
                    canSave: true
                });
                success();
                _this2.doSubmit();
            }, function (err) {
                _this2.setState({
                    configTested: false,
                    canSave: false
                });
                error(err);
            });
        }
    }, {
        key: 'getExtraInfo',
        value: function getExtraInfo(job) {
            if (job.status === _constants.JobStatuses.IN_PROGRESS) {
                return _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'admin.elasticsearch.percentComplete',
                    defaultMessage: '{percent}% Complete',
                    values: { percent: Number(job.progress) }
                });
            }

            return null;
        }
    }, {
        key: 'renderTitle',
        value: function renderTitle() {
            return _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'admin.elasticsearch.title',
                defaultMessage: 'Elasticsearch (Beta)'
            });
        }
    }, {
        key: 'renderSettings',
        value: function renderSettings() {
            return _react2.default.createElement(
                _settings_group2.default,
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'banner' },
                    _react2.default.createElement(
                        'div',
                        { className: 'banner__content' },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'admin.elasticsearch.noteDescription',
                            defaultMessage: 'Changing properties in this section will require a server restart before taking effect.'
                        })
                    )
                ),
                _react2.default.createElement(_boolean_setting2.default, {
                    id: 'enableIndexing',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.elasticsearch.enableIndexingTitle',
                        defaultMessage: 'Enable Elasticsearch Indexing:'
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.elasticsearch.enableIndexingDescription',
                        defaultMessage: 'When true, indexing of new posts occurs automatically. Search queries will use database search until "Enable Elasticsearch for search queries" is enabled. {documentationLink}',
                        values: {
                            documentationLink: _react2.default.createElement(
                                'a',
                                {
                                    href: 'https://about.mattermost.com/default-elasticsearch-documentation/',
                                    rel: 'noopener noreferrer',
                                    target: '_blank'
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'admin.elasticsearch.enableIndexingDescription.documentationLinkText',
                                    defaultMessage: 'Learn more about Elasticsearch in our documentation.'
                                })
                            )
                        }
                    }),
                    value: this.state.enableIndexing,
                    onChange: this.handleChange
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'connectionUrl',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.elasticsearch.connectionUrlTitle',
                        defaultMessage: 'Server Connection Address:'
                    }),
                    placeholder: Utils.localizeMessage('admin.elasticsearch.connectionUrlExample', 'E.g.: "https://elasticsearch.example.org:9200"'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.elasticsearch.connectionUrlDescription',
                        defaultMessage: 'The address of the Elasticsearch server. {documentationLink}',
                        values: {
                            documentationLink: _react2.default.createElement(
                                'a',
                                {
                                    href: 'https://about.mattermost.com/default-elasticsearch-server-setup/',
                                    rel: 'noopener noreferrer',
                                    target: '_blank'
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'admin.elasticsearch.connectionUrlExample.documentationLinkText',
                                    defaultMessage: 'Please see documentation with server setup instructions.'
                                })
                            )
                        }
                    }),
                    value: this.state.connectionUrl,
                    disabled: !this.state.enableIndexing,
                    onChange: this.handleChange
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'username',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.elasticsearch.usernameTitle',
                        defaultMessage: 'Server Username:'
                    }),
                    placeholder: Utils.localizeMessage('admin.elasticsearch.usernameExample', 'E.g.: "elastic"'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.elasticsearch.usernameDescription',
                        defaultMessage: '(Optional) The username to authenticate to the Elasticsearch server.'
                    }),
                    value: this.state.username,
                    disabled: !this.state.enableIndexing,
                    onChange: this.handleChange
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'password',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.elasticsearch.passwordTitle',
                        defaultMessage: 'Server Password:'
                    }),
                    placeholder: Utils.localizeMessage('admin.elasticsearch.password', 'E.g.: "yourpassword"'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.elasticsearch.passwordDescription',
                        defaultMessage: '(Optional) The password to authenticate to the Elasticsearch server.'
                    }),
                    value: this.state.password,
                    disabled: !this.state.enableIndexing,
                    onChange: this.handleChange
                }),
                _react2.default.createElement(_boolean_setting2.default, {
                    id: 'sniff',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.elasticsearch.sniffTitle',
                        defaultMessage: 'Enable Cluster Sniffing:'
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.elasticsearch.sniffDescription',
                        defaultMessage: 'When true, sniffing finds and connects to all data nodes in your cluster automatically.'
                    }),
                    value: this.state.sniff,
                    disabled: !this.state.enableIndexing,
                    onChange: this.handleChange
                }),
                _react2.default.createElement(_request_button2.default, {
                    requestAction: this.doTestConfig,
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.elasticsearch.testHelpText',
                        defaultMessage: 'Tests if the Mattermost server can connect to the Elasticsearch server specified. Testing the connection only saves the configuration if the test is successful. See log file for more detailed error messages.'
                    }),
                    buttonText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.elasticsearch.elasticsearch_test_button',
                        defaultMessage: 'Test Connection'
                    }),
                    successMessage: {
                        id: 'admin.elasticsearch.testConfigSuccess',
                        defaultMessage: 'Test successful. Configuration saved.'
                    },
                    disabled: !this.state.enableIndexing
                }),
                _react2.default.createElement(
                    'div',
                    { className: 'form-group' },
                    _react2.default.createElement(
                        'label',
                        {
                            className: 'control-label col-sm-4'
                        },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'admin.elasticsearch.bulkIndexingTitle',
                            defaultMessage: 'Bulk Indexing:'
                        })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'col-sm-8' },
                        _react2.default.createElement(
                            'div',
                            { className: 'job-table-setting' },
                            _react2.default.createElement(_jobs2.default, {
                                jobType: _constants.JobTypes.ELASTICSEARCH_POST_INDEXING,
                                disabled: !this.state.canPurgeAndIndex,
                                createJobButtonText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'admin.elasticsearch.createJob.title',
                                    defaultMessage: 'Index Now'
                                }),
                                createJobHelpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'admin.elasticsearch.createJob.help',
                                    defaultMessage: 'All posts in the database will be indexed from oldest to newest. Elasticsearch is available during indexing but search results may be incomplete until the indexing job is complete.'
                                }),
                                getExtraInfoText: this.getExtraInfo
                            })
                        )
                    )
                ),
                _react2.default.createElement(_request_button2.default, {
                    requestAction: _admin_actions.elasticsearchPurgeIndexes,
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.elasticsearch.purgeIndexesHelpText',
                        defaultMessage: 'Purging will entirely remove the index on the Elasticsearch server. Search results may be incomplete until a bulk index of the existing post database is rebuilt.'
                    }),
                    buttonText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.elasticsearch.purgeIndexesButton',
                        defaultMessage: 'Purge Index'
                    }),
                    successMessage: {
                        id: 'admin.elasticsearch.purgeIndexesButton.success',
                        defaultMessage: 'Indexes purged successfully.'
                    },
                    errorMessage: {
                        id: 'admin.elasticsearch.purgeIndexesButton.error',
                        defaultMessage: 'Failed to purge indexes: {error}'
                    },
                    disabled: !this.state.canPurgeAndIndex,
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.elasticsearch.purgeIndexesButton.label',
                        defaultMessage: 'Purge Indexes:'
                    })
                }),
                _react2.default.createElement(_boolean_setting2.default, {
                    id: 'enableSearching',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.elasticsearch.enableSearchingTitle',
                        defaultMessage: 'Enable Elasticsearch for search queries:'
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.elasticsearch.enableSearchingDescription',
                        defaultMessage: 'Requires a successful connection to the Elasticsearch server. When true, Elasticsearch will be used for all search queries using the latest index. Search results may be incomplete until a bulk index of the existing post database is finished. When false, database search is used.'
                    }),
                    value: this.state.enableSearching,
                    disabled: !this.state.enableIndexing || !this.state.configTested,
                    onChange: this.handleChange
                })
            );
        }
    }]);
    return ElasticsearchSettings;
}(_admin_settings2.default); // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = ElasticsearchSettings;

/***/ }),

/***/ 2587:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _error_store = __webpack_require__(847);

var _error_store2 = _interopRequireDefault(_error_store);

var _constants = __webpack_require__(29);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _email_connection_test = __webpack_require__(2588);

var _email_connection_test2 = _interopRequireDefault(_email_connection_test);

var _admin_settings = __webpack_require__(787);

var _admin_settings2 = _interopRequireDefault(_admin_settings);

var _boolean_setting = __webpack_require__(800);

var _boolean_setting2 = _interopRequireDefault(_boolean_setting);

var _connection_security_dropdown_setting = __webpack_require__(1453);

var _dropdown_setting = __webpack_require__(842);

var _dropdown_setting2 = _interopRequireDefault(_dropdown_setting);

var _settings_group = __webpack_require__(788);

var _settings_group2 = _interopRequireDefault(_settings_group);

var _text_setting = __webpack_require__(794);

var _text_setting2 = _interopRequireDefault(_text_setting);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var EMAIL_NOTIFICATION_CONTENTS_FULL = 'full';
var EMAIL_NOTIFICATION_CONTENTS_GENERIC = 'generic';

var EmailSettings = function (_AdminSettings) {
    (0, _inherits3.default)(EmailSettings, _AdminSettings);

    function EmailSettings(props) {
        (0, _classCallCheck3.default)(this, EmailSettings);

        var _this = (0, _possibleConstructorReturn3.default)(this, (EmailSettings.__proto__ || (0, _getPrototypeOf2.default)(EmailSettings)).call(this, props));

        _this.getConfigFromState = _this.getConfigFromState.bind(_this);
        _this.handleSaved = _this.handleSaved.bind(_this);
        _this.renderSettings = _this.renderSettings.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(EmailSettings, [{
        key: 'getConfigFromState',
        value: function getConfigFromState(config) {
            config.EmailSettings.SendEmailNotifications = this.state.sendEmailNotifications;
            config.EmailSettings.FeedbackName = this.state.feedbackName;
            config.EmailSettings.FeedbackEmail = this.state.feedbackEmail;
            config.EmailSettings.FeedbackOrganization = this.state.feedbackOrganization;
            config.EmailSettings.EnableSMTPAuth = this.state.enableSMTPAuth;
            config.EmailSettings.SMTPUsername = this.state.smtpUsername;
            config.EmailSettings.SMTPPassword = this.state.smtpPassword;
            config.EmailSettings.SMTPServer = this.state.smtpServer;
            config.EmailSettings.SMTPPort = this.state.smtpPort;
            config.EmailSettings.ConnectionSecurity = this.state.connectionSecurity;
            config.EmailSettings.EnableEmailBatching = this.state.enableEmailBatching;
            config.ServiceSettings.EnableSecurityFixAlert = this.state.enableSecurityFixAlert;
            config.EmailSettings.SkipServerCertificateVerification = this.state.skipServerCertificateVerification;
            config.EmailSettings.EmailNotificationContentsType = this.state.emailNotificationContentsType;

            return config;
        }
    }, {
        key: 'handleSaved',
        value: function handleSaved(newConfig) {
            if (newConfig.EmailSettings.SendEmailNotifications) {
                _error_store2.default.clearError(_constants.ErrorBarTypes.PREVIEW_MODE);
            }
        }
    }, {
        key: 'getStateFromConfig',
        value: function getStateFromConfig(config) {
            return {
                sendEmailNotifications: config.EmailSettings.SendEmailNotifications,
                feedbackName: config.EmailSettings.FeedbackName,
                feedbackEmail: config.EmailSettings.FeedbackEmail,
                feedbackOrganization: config.EmailSettings.FeedbackOrganization,
                enableSMTPAuth: config.EmailSettings.EnableSMTPAuth,
                smtpUsername: config.EmailSettings.SMTPUsername,
                smtpPassword: config.EmailSettings.SMTPPassword,
                smtpServer: config.EmailSettings.SMTPServer,
                smtpPort: config.EmailSettings.SMTPPort,
                connectionSecurity: config.EmailSettings.ConnectionSecurity,
                enableEmailBatching: config.EmailSettings.EnableEmailBatching,
                skipServerCertificateVerification: config.EmailSettings.SkipServerCertificateVerification,
                enableSecurityFixAlert: config.ServiceSettings.EnableSecurityFixAlert,
                emailNotificationContentsType: config.EmailSettings.EmailNotificationContentsType
            };
        }
    }, {
        key: 'renderTitle',
        value: function renderTitle() {
            return _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'admin.notifications.email',
                defaultMessage: 'Email'
            });
        }
    }, {
        key: 'renderSettings',
        value: function renderSettings() {
            var enableEmailBatchingDisabledText = null;

            if (this.props.config.ClusterSettings.Enable) {
                enableEmailBatchingDisabledText = _react2.default.createElement(
                    'span',
                    {
                        key: 'admin.email.enableEmailBatching.clusterEnabled',
                        className: 'help-text'
                    },
                    _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                        id: 'admin.email.enableEmailBatching.clusterEnabled',
                        defaultMessage: 'Email batching cannot be enabled unless the SiteURL is configured in <b>Configuration > SiteURL</b>.'
                    })
                );
            } else if (!this.props.config.ServiceSettings.SiteURL) {
                enableEmailBatchingDisabledText = _react2.default.createElement(
                    'span',
                    {
                        key: 'admin.email.enableEmailBatching.siteURL',
                        className: 'help-text'
                    },
                    _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                        id: 'admin.email.enableEmailBatching.siteURL',
                        defaultMessage: 'Email batching cannot be enabled unless the SiteURL is configured in <b>Configuration > SiteURL</b>.'
                    })
                );
            }

            var emailNotificationContentsTypeDropdown = null;
            var emailNotificationContentsHelpText = null;
            if (this.props.license.EmailNotificationContents === 'true') {
                var emailNotificationContentsTypes = [];
                emailNotificationContentsTypes.push({ value: EMAIL_NOTIFICATION_CONTENTS_FULL, text: Utils.localizeMessage('admin.email.notification.contents.full', 'Send full message contents') });
                emailNotificationContentsTypes.push({ value: EMAIL_NOTIFICATION_CONTENTS_GENERIC, text: Utils.localizeMessage('admin.email.notification.contents.generic', 'Send generic description with only sender name') });

                if (this.state.emailNotificationContentsType === EMAIL_NOTIFICATION_CONTENTS_FULL) {
                    emailNotificationContentsHelpText = _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                        key: 'admin.email.notification.contents.full.description',
                        id: 'admin.email.notification.contents.full.description',
                        defaultMessage: 'Sender name and channel are included in email notifications.</br>Typically used for compliance reasons if Mattermost contains confidential information and policy dictates it cannot be stored in email.'
                    });
                } else if (this.state.emailNotificationContentsType === EMAIL_NOTIFICATION_CONTENTS_GENERIC) {
                    emailNotificationContentsHelpText = _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                        key: 'admin.email.notification.contents.generic.description',
                        id: 'admin.email.notification.contents.generic.description',
                        defaultMessage: 'Only the name of the person who sent the message, with no information about channel name or message contents are included in email notifications.</br>Typically used for compliance reasons if Mattermost contains confidential information and policy dictates it cannot be stored in email.'
                    });
                }

                emailNotificationContentsTypeDropdown = _react2.default.createElement(_dropdown_setting2.default, {
                    id: 'emailNotificationContentsType',
                    values: emailNotificationContentsTypes,
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.email.notification.contents.title',
                        defaultMessage: 'Email Notification Contents: '
                    }),
                    value: this.state.emailNotificationContentsType,
                    onChange: this.handleChange,
                    helpText: emailNotificationContentsHelpText,
                    disabled: !this.state.sendEmailNotifications
                });
            }

            return _react2.default.createElement(
                _settings_group2.default,
                null,
                _react2.default.createElement(_boolean_setting2.default, {
                    id: 'sendEmailNotifications',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.email.notificationsTitle',
                        defaultMessage: 'Enable Email Notifications: '
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                        id: 'admin.email.notificationsDescription',
                        defaultMessage: 'Typically set to true in production. When true, Mattermost attempts to send email notifications. Developers may set this field to false to skip email setup for faster development.<br />Setting this to true removes the Preview Mode banner (requires logging out and logging back in after setting is changed).'
                    }),
                    value: this.state.sendEmailNotifications,
                    onChange: this.handleChange
                }),
                _react2.default.createElement(_boolean_setting2.default, {
                    id: 'enableEmailBatching',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.email.enableEmailBatchingTitle',
                        defaultMessage: 'Enable Email Batching: '
                    }),
                    helpText: [_react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                        key: 'admin.email.enableEmailBatchingDesc',
                        id: 'admin.email.enableEmailBatchingDesc',
                        defaultMessage: 'When true, users will have email notifications for multiple direct messages and mentions combined into a single email. Batching will occur at a default interval of 15 minutes, configurable in Account Settings > Notifications.'
                    }), enableEmailBatchingDisabledText],
                    value: this.state.enableEmailBatching && !this.props.config.ClusterSettings.Enable && Boolean(this.props.config.ServiceSettings.SiteURL),
                    onChange: this.handleChange,
                    disabled: !this.state.sendEmailNotifications || this.props.config.ClusterSettings.Enable || !this.props.config.ServiceSettings.SiteURL
                }),
                emailNotificationContentsTypeDropdown,
                _react2.default.createElement(_text_setting2.default, {
                    id: 'feedbackName',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.email.notificationDisplayTitle',
                        defaultMessage: 'Notification Display Name:'
                    }),
                    placeholder: Utils.localizeMessage('admin.email.notificationDisplayExample', 'Ex: "Mattermost Notification", "System", "No-Reply"'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.email.notificationDisplayDescription',
                        defaultMessage: 'Display name on email account used when sending notification emails from Mattermost.'
                    }),
                    value: this.state.feedbackName,
                    onChange: this.handleChange,
                    disabled: !this.state.sendEmailNotifications
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'feedbackEmail',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.email.notificationEmailTitle',
                        defaultMessage: 'Notification From Address:'
                    }),
                    placeholder: Utils.localizeMessage('admin.email.notificationEmailExample', 'Ex: "mattermost@yourcompany.com", "admin@yourcompany.com"'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.email.notificationEmailDescription',
                        defaultMessage: 'Email address displayed on email account used when sending notification emails from Mattermost.'
                    }),
                    value: this.state.feedbackEmail,
                    onChange: this.handleChange,
                    disabled: !this.state.sendEmailNotifications
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'feedbackOrganization',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.email.notificationOrganization',
                        defaultMessage: 'Notification Footer Mailing Address:'
                    }),
                    placeholder: Utils.localizeMessage('admin.email.notificationOrganizationExample', 'Ex: "© ABC Corporation, 565 Knight Way, Palo Alto, California, 94305, USA"'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.email.notificationOrganizationDescription',
                        defaultMessage: 'Organization name and address displayed on email notifications from Mattermost, such as "\xA9 ABC Corporation, 565 Knight Way, Palo Alto, California, 94305, USA". If the field is left empty, the organization name and address will not be displayed.'
                    }),
                    value: this.state.feedbackOrganization,
                    onChange: this.handleChange,
                    disabled: !this.state.sendEmailNotifications
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'smtpServer',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.email.smtpServerTitle',
                        defaultMessage: 'SMTP Server:'
                    }),
                    placeholder: Utils.localizeMessage('admin.email.smtpServerExample', 'Ex: "smtp.yourcompany.com", "email-smtp.us-east-1.amazonaws.com"'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.email.smtpServerDescription',
                        defaultMessage: 'Location of SMTP email server.'
                    }),
                    value: this.state.smtpServer,
                    onChange: this.handleChange,
                    disabled: !this.state.sendEmailNotifications
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'smtpPort',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.email.smtpPortTitle',
                        defaultMessage: 'SMTP Server Port:'
                    }),
                    placeholder: Utils.localizeMessage('admin.email.smtpPortExample', 'Ex: "25", "465", "587"'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.email.smtpPortDescription',
                        defaultMessage: 'Port of SMTP email server.'
                    }),
                    value: this.state.smtpPort,
                    onChange: this.handleChange,
                    disabled: !this.state.sendEmailNotifications
                }),
                _react2.default.createElement(_boolean_setting2.default, {
                    id: 'enableSMTPAuth',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.email.enableSMTPAuthTitle',
                        defaultMessage: 'Enable SMTP Authentication: '
                    }),
                    helpText: [_react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                        key: 'admin.email.enableSMTPAuthDesc',
                        id: 'admin.email.enableSMTPAuthDesc',
                        defaultMessage: 'When true, SMTP Authentication is enabled.'
                    })],
                    value: this.state.enableSMTPAuth,
                    onChange: this.handleChange,
                    disabled: !this.state.sendEmailNotifications
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'smtpUsername',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.email.smtpUsernameTitle',
                        defaultMessage: 'SMTP Server Username:'
                    }),
                    placeholder: Utils.localizeMessage('admin.email.smtpUsernameExample', 'Ex: "admin@yourcompany.com", "AKIADTOVBGERKLCBV"'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.email.smtpUsernameDescription',
                        defaultMessage: ' Obtain this credential from administrator setting up your email server.'
                    }),
                    value: this.state.smtpUsername,
                    onChange: this.handleChange,
                    disabled: !this.state.sendEmailNotifications || !this.state.enableSMTPAuth
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'smtpPassword',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.email.smtpPasswordTitle',
                        defaultMessage: 'SMTP Server Password:'
                    }),
                    placeholder: Utils.localizeMessage('admin.email.smtpPasswordExample', 'Ex: "yourpassword", "jcuS8PuvcpGhpgHhlcpT1Mx42pnqMxQY"'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.email.smtpPasswordDescription',
                        defaultMessage: ' Obtain this credential from administrator setting up your email server.'
                    }),
                    value: this.state.smtpPassword,
                    onChange: this.handleChange,
                    disabled: !this.state.sendEmailNotifications || !this.state.enableSMTPAuth
                }),
                _react2.default.createElement(_connection_security_dropdown_setting.ConnectionSecurityDropdownSettingEmail, {
                    value: this.state.connectionSecurity,
                    onChange: this.handleChange,
                    disabled: !this.state.sendEmailNotifications
                }),
                _react2.default.createElement(_email_connection_test2.default, {
                    config: this.props.config,
                    getConfigFromState: this.getConfigFromState,
                    disabled: !this.state.sendEmailNotifications
                }),
                _react2.default.createElement(_boolean_setting2.default, {
                    id: 'skipServerCertificateVerification',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.email.skipServerCertificateVerification.title',
                        defaultMessage: 'Skip Server Certificate Verification: '
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.email.skipServerCertificateVerification.description',
                        defaultMessage: 'When true, Mattermost will not verify the email server certificate.'
                    }),
                    value: this.state.skipServerCertificateVerification,
                    onChange: this.handleChange,
                    disabled: !this.state.sendEmailNotifications || this.state.connectionSecurity === ''
                }),
                _react2.default.createElement(_boolean_setting2.default, {
                    id: 'enableSecurityFixAlert',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.service.securityTitle',
                        defaultMessage: 'Enable Security Alerts: '
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.service.securityDesc',
                        defaultMessage: 'When true, System Administrators are notified by email if a relevant security fix alert has been announced in the last 12 hours. Requires email to be enabled.'
                    }),
                    value: this.state.enableSecurityFixAlert,
                    onChange: this.handleChange,
                    disabled: !this.state.sendEmailNotifications
                })
            );
        }
    }]);
    return EmailSettings;
}(_admin_settings2.default);

exports.default = EmailSettings;

/***/ }),

/***/ 2588:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _redux = __webpack_require__(1);

var _admin = __webpack_require__(855);

var _email_connection_test = __webpack_require__(2589);

var _email_connection_test2 = _interopRequireDefault(_email_connection_test);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2018-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(_email_connection_test2.default);


function mapDispatchToProps(dispatch) {
    return {
        actions: (0, _redux.bindActionCreators)({
            testEmail: _admin.testEmail
        }, dispatch)
    };
}

/***/ }),

/***/ 2589:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(275);

var _stringify2 = _interopRequireDefault(_stringify);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var EmailConnectionTestButton = function (_React$Component) {
    (0, _inherits3.default)(EmailConnectionTestButton, _React$Component);
    (0, _createClass3.default)(EmailConnectionTestButton, null, [{
        key: 'propTypes',
        get: function get() {
            return {
                config: _propTypes2.default.object.isRequired,
                getConfigFromState: _propTypes2.default.func.isRequired,
                disabled: _propTypes2.default.bool.isRequired,
                actions: _propTypes2.default.shape({
                    testEmail: _propTypes2.default.func.isRequired
                }).isRequired
            };
        }
    }]);

    function EmailConnectionTestButton(props) {
        (0, _classCallCheck3.default)(this, EmailConnectionTestButton);

        var _this = (0, _possibleConstructorReturn3.default)(this, (EmailConnectionTestButton.__proto__ || (0, _getPrototypeOf2.default)(EmailConnectionTestButton)).call(this, props));

        _this.handleTestConnection = function (e) {
            e.preventDefault();

            _this.setState({
                testing: true,
                success: false,
                fail: null
            });

            var config = JSON.parse((0, _stringify2.default)(_this.props.config));
            _this.props.getConfigFromState(config);

            _this.props.actions.testEmail(config).then(function (data) {
                if (data.error) {
                    var fail = data.error.message;
                    if (data.error.detailed_error) {
                        fail += ' - ' + data.error.detailed_error;
                    }
                    _this.setState({
                        testing: false,
                        fail: fail
                    });
                } else {
                    _this.setState({
                        testing: false,
                        success: true
                    });
                }
            });
        };

        _this.state = {
            testing: false,
            success: false,
            fail: null
        };
        return _this;
    }

    (0, _createClass3.default)(EmailConnectionTestButton, [{
        key: 'render',
        value: function render() {
            var testMessage = null;
            if (this.state.success) {
                testMessage = _react2.default.createElement(
                    'div',
                    { className: 'alert alert-success' },
                    _react2.default.createElement('i', { className: 'fa fa-check' }),
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.email.emailSuccess',
                        defaultMessage: 'No errors were reported while sending an email.  Please check your inbox to make sure.'
                    })
                );
            } else if (this.state.fail) {
                testMessage = _react2.default.createElement(
                    'div',
                    { className: 'alert alert-warning' },
                    _react2.default.createElement('i', { className: 'fa fa-warning' }),
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.email.emailFail',
                        defaultMessage: 'Connection unsuccessful: {error}',
                        values: {
                            error: this.state.fail
                        }
                    })
                );
            }

            var contents = null;
            if (this.state.testing) {
                contents = _react2.default.createElement(
                    'span',
                    null,
                    _react2.default.createElement('span', { className: 'fa fa-refresh icon--rotate' }),
                    Utils.localizeMessage('admin.email.testing', 'Testing...')
                );
            } else {
                contents = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'admin.email.connectionSecurityTest',
                    defaultMessage: 'Test Connection'
                });
            }

            return _react2.default.createElement(
                'div',
                { className: 'form-group email-connection-test' },
                _react2.default.createElement(
                    'div',
                    { className: 'col-sm-offset-4 col-sm-8' },
                    _react2.default.createElement(
                        'div',
                        { className: 'help-text' },
                        _react2.default.createElement(
                            'button',
                            {
                                className: 'btn btn-default',
                                onClick: this.handleTestConnection,
                                disabled: this.props.disabled
                            },
                            contents
                        ),
                        _react2.default.createElement(
                            'div',
                            null,
                            testMessage
                        )
                    )
                )
            );
        }
    }]);
    return EmailConnectionTestButton;
}(_react2.default.Component);

exports.default = EmailConnectionTestButton;

/***/ }),

/***/ 2590:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _admin_settings = __webpack_require__(787);

var _admin_settings2 = _interopRequireDefault(_admin_settings);

var _settings_group = __webpack_require__(788);

var _settings_group2 = _interopRequireDefault(_settings_group);

var _text_setting = __webpack_require__(794);

var _text_setting2 = _interopRequireDefault(_text_setting);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var ExternalServiceSettings = function (_AdminSettings) {
    (0, _inherits3.default)(ExternalServiceSettings, _AdminSettings);

    function ExternalServiceSettings(props) {
        (0, _classCallCheck3.default)(this, ExternalServiceSettings);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ExternalServiceSettings.__proto__ || (0, _getPrototypeOf2.default)(ExternalServiceSettings)).call(this, props));

        _this.getConfigFromState = _this.getConfigFromState.bind(_this);

        _this.renderSettings = _this.renderSettings.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(ExternalServiceSettings, [{
        key: 'getConfigFromState',
        value: function getConfigFromState(config) {
            config.ServiceSettings.GoogleDeveloperKey = this.state.googleDeveloperKey;
            return config;
        }
    }, {
        key: 'getStateFromConfig',
        value: function getStateFromConfig(config) {
            return {
                googleDeveloperKey: config.ServiceSettings.GoogleDeveloperKey
            };
        }
    }, {
        key: 'renderTitle',
        value: function renderTitle() {
            return _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'admin.integrations.external',
                defaultMessage: 'External Services'
            });
        }
    }, {
        key: 'renderSettings',
        value: function renderSettings() {
            return _react2.default.createElement(
                _settings_group2.default,
                null,
                _react2.default.createElement(_text_setting2.default, {
                    id: 'googleDeveloperKey',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.service.googleTitle',
                        defaultMessage: 'Google API Key:'
                    }),
                    placeholder: Utils.localizeMessage('admin.service.googleExample', 'E.g.: "7rAh6iwQCkV4cA1Gsg3fgGOXJAQ43QV"'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                        id: 'admin.service.googleDescription',
                        defaultMessage: 'Set this key to enable the display of titles for embedded YouTube video previews. Without the key, YouTube previews will still be created based on hyperlinks appearing in messages or comments but they will not show the video title. View a <a href="https://www.youtube.com/watch?v=Im69kzhpR3I" target="_blank">Google Developers Tutorial</a> for instructions on how to obtain a key and add YouTube Data API v3 as a service to your key.'
                    }),
                    value: this.state.googleDeveloperKey,
                    onChange: this.handleChange
                })
            );
        }
    }]);
    return ExternalServiceSettings;
}(_admin_settings2.default);

exports.default = ExternalServiceSettings;

/***/ }),

/***/ 2591:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _admin_settings = __webpack_require__(787);

var _admin_settings2 = _interopRequireDefault(_admin_settings);

var _boolean_setting = __webpack_require__(800);

var _boolean_setting2 = _interopRequireDefault(_boolean_setting);

var _settings_group = __webpack_require__(788);

var _settings_group2 = _interopRequireDefault(_settings_group);

var _text_setting = __webpack_require__(794);

var _text_setting2 = _interopRequireDefault(_text_setting);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GitLabSettings = function (_AdminSettings) {
    (0, _inherits3.default)(GitLabSettings, _AdminSettings);

    function GitLabSettings(props) {
        (0, _classCallCheck3.default)(this, GitLabSettings);

        var _this = (0, _possibleConstructorReturn3.default)(this, (GitLabSettings.__proto__ || (0, _getPrototypeOf2.default)(GitLabSettings)).call(this, props));

        _this.getConfigFromState = _this.getConfigFromState.bind(_this);
        _this.renderSettings = _this.renderSettings.bind(_this);
        _this.updateGitLabUrl = _this.updateGitLabUrl.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(GitLabSettings, [{
        key: 'getConfigFromState',
        value: function getConfigFromState(config) {
            config.GitLabSettings.Enable = this.state.enable;
            config.GitLabSettings.Id = this.state.id;
            config.GitLabSettings.Secret = this.state.secret;
            config.GitLabSettings.UserApiEndpoint = this.state.userApiEndpoint;
            config.GitLabSettings.AuthEndpoint = this.state.authEndpoint;
            config.GitLabSettings.TokenEndpoint = this.state.tokenEndpoint;

            return config;
        }
    }, {
        key: 'getStateFromConfig',
        value: function getStateFromConfig(config) {
            return {
                enable: config.GitLabSettings.Enable,
                id: config.GitLabSettings.Id,
                secret: config.GitLabSettings.Secret,
                gitLabUrl: config.GitLabSettings.UserApiEndpoint.replace('/api/v4/user', ''),
                userApiEndpoint: config.GitLabSettings.UserApiEndpoint,
                authEndpoint: config.GitLabSettings.AuthEndpoint,
                tokenEndpoint: config.GitLabSettings.TokenEndpoint
            };
        }
    }, {
        key: 'updateGitLabUrl',
        value: function updateGitLabUrl(id, value) {
            var trimmedValue = value;
            if (value.endsWith('/')) {
                trimmedValue = value.slice(0, -1);
            }

            this.setState({
                saveNeeded: true,
                gitLabUrl: value,
                userApiEndpoint: trimmedValue + '/api/v4/user',
                authEndpoint: trimmedValue + '/oauth/authorize',
                tokenEndpoint: trimmedValue + '/oauth/token'
            });
        }
    }, {
        key: 'renderTitle',
        value: function renderTitle() {
            return _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'admin.authentication.gitlab',
                defaultMessage: 'GitLab'
            });
        }
    }, {
        key: 'renderSettings',
        value: function renderSettings() {
            return _react2.default.createElement(
                _settings_group2.default,
                null,
                _react2.default.createElement(_boolean_setting2.default, {
                    id: 'enable',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.gitlab.enableTitle',
                        defaultMessage: 'Enable authentication with GitLab: '
                    }),
                    helpText: _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'admin.gitlab.enableDescription',
                            defaultMessage: 'When true, Mattermost allows team creation and account signup using GitLab OAuth.'
                        }),
                        _react2.default.createElement('br', null),
                        _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                            id: 'admin.gitlab.EnableHtmlDesc',
                            defaultMessage: '<ol><li>Log in to your GitLab account and go to Profile Settings -> Applications.</li><li>Enter Redirect URIs "<your-mattermost-url>/login/gitlab/complete" (example: http://localhost:8065/login/gitlab/complete) and "<your-mattermost-url>/signup/gitlab/complete". </li><li>Then use "Application Secret Key" and "Application ID" fields from GitLab to complete the options below.</li><li>Complete the Endpoint URLs below. </li></ol>'
                        })
                    ),
                    value: this.state.enable,
                    onChange: this.handleChange
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'id',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.gitlab.clientIdTitle',
                        defaultMessage: 'Application ID:'
                    }),
                    placeholder: Utils.localizeMessage('admin.gitlab.clientIdExample', 'E.g.: "jcuS8PuvcpGhpgHhlcpT1Mx42pnqMxQY"'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.gitlab.clientIdDescription',
                        defaultMessage: 'Obtain this value via the instructions above for logging into GitLab'
                    }),
                    value: this.state.id,
                    onChange: this.handleChange,
                    disabled: !this.state.enable
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'secret',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.gitlab.clientSecretTitle',
                        defaultMessage: 'Application Secret Key:'
                    }),
                    placeholder: Utils.localizeMessage('admin.gitlab.clientSecretExample', 'E.g.: "jcuS8PuvcpGhpgHhlcpT1Mx42pnqMxQY"'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.gitlab.clientSecretDescription',
                        defaultMessage: 'Obtain this value via the instructions above for logging into GitLab.'
                    }),
                    value: this.state.secret,
                    onChange: this.handleChange,
                    disabled: !this.state.enable
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'gitlabUrl',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.gitlab.siteUrl',
                        defaultMessage: 'GitLab Site URL:'
                    }),
                    placeholder: Utils.localizeMessage('admin.gitlab.siteUrlExample', 'E.g.: https://'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.gitlab.siteUrlDescription',
                        defaultMessage: 'Enter the URL of your GitLab instance, e.g. https://example.com:3000. If your GitLab instance is not set up with SSL, start the URL with http:// instead of https://.'
                    }),
                    value: this.state.gitLabUrl,
                    onChange: this.updateGitLabUrl,
                    disabled: !this.state.enable
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'userApiEndpoint',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.gitlab.userTitle',
                        defaultMessage: 'User API Endpoint:'
                    }),
                    placeholder: '',
                    value: this.state.userApiEndpoint,
                    disabled: true
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'authEndpoint',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.gitlab.authTitle',
                        defaultMessage: 'Auth Endpoint:'
                    }),
                    placeholder: '',
                    value: this.state.authEndpoint,
                    disabled: true
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'tokenEndpoint',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.gitlab.tokenTitle',
                        defaultMessage: 'Token Endpoint:'
                    }),
                    placeholder: '',
                    value: this.state.tokenEndpoint,
                    disabled: true
                })
            );
        }
    }]);
    return GitLabSettings;
}(_admin_settings2.default); // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = GitLabSettings;

/***/ }),

/***/ 2592:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _admin_actions = __webpack_require__(797);

var _constants = __webpack_require__(29);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _admin_settings = __webpack_require__(787);

var _admin_settings2 = _interopRequireDefault(_admin_settings);

var _boolean_setting = __webpack_require__(800);

var _boolean_setting2 = _interopRequireDefault(_boolean_setting);

var _connection_security_dropdown_setting = __webpack_require__(1453);

var _jobs = __webpack_require__(996);

var _jobs2 = _interopRequireDefault(_jobs);

var _request_button = __webpack_require__(998);

var _request_button2 = _interopRequireDefault(_request_button);

var _settings_group = __webpack_require__(788);

var _settings_group2 = _interopRequireDefault(_settings_group);

var _text_setting = __webpack_require__(794);

var _text_setting2 = _interopRequireDefault(_text_setting);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var LdapSettings = function (_AdminSettings) {
    (0, _inherits3.default)(LdapSettings, _AdminSettings);

    function LdapSettings(props) {
        (0, _classCallCheck3.default)(this, LdapSettings);

        var _this = (0, _possibleConstructorReturn3.default)(this, (LdapSettings.__proto__ || (0, _getPrototypeOf2.default)(LdapSettings)).call(this, props));

        _this.shouldBeDisabled = function () {
            return !(_this.state.enable || _this.state.enableSync);
        };

        _this.getConfigFromState = _this.getConfigFromState.bind(_this);
        _this.renderSettings = _this.renderSettings.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(LdapSettings, [{
        key: 'getConfigFromState',
        value: function getConfigFromState(config) {
            config.LdapSettings.Enable = this.state.enable;
            config.LdapSettings.EnableSync = this.state.enableSync;
            config.LdapSettings.LdapServer = this.state.ldapServer;
            config.LdapSettings.LdapPort = this.parseIntNonZero(this.state.ldapPort);
            config.LdapSettings.ConnectionSecurity = this.state.connectionSecurity;
            config.LdapSettings.BaseDN = this.state.baseDN;
            config.LdapSettings.BindUsername = this.state.bindUsername;
            config.LdapSettings.BindPassword = this.state.bindPassword;
            config.LdapSettings.UserFilter = this.state.userFilter;
            config.LdapSettings.FirstNameAttribute = this.state.firstNameAttribute;
            config.LdapSettings.LastNameAttribute = this.state.lastNameAttribute;
            config.LdapSettings.NicknameAttribute = this.state.nicknameAttribute;
            config.LdapSettings.EmailAttribute = this.state.emailAttribute;
            config.LdapSettings.UsernameAttribute = this.state.usernameAttribute;
            config.LdapSettings.PositionAttribute = this.state.positionAttribute;
            config.LdapSettings.IdAttribute = this.state.idAttribute;
            config.LdapSettings.SyncIntervalMinutes = this.parseIntNonZero(this.state.syncIntervalMinutes);
            config.LdapSettings.SkipCertificateVerification = this.state.skipCertificateVerification;
            config.LdapSettings.QueryTimeout = this.parseIntNonZero(this.state.queryTimeout);
            config.LdapSettings.MaxPageSize = this.parseInt(this.state.maxPageSize);
            config.LdapSettings.LoginFieldName = this.state.loginFieldName;

            return config;
        }
    }, {
        key: 'getStateFromConfig',
        value: function getStateFromConfig(config) {
            return {
                enable: config.LdapSettings.Enable,
                enableSync: config.LdapSettings.EnableSync,
                ldapServer: config.LdapSettings.LdapServer,
                ldapPort: config.LdapSettings.LdapPort,
                connectionSecurity: config.LdapSettings.ConnectionSecurity,
                baseDN: config.LdapSettings.BaseDN,
                bindUsername: config.LdapSettings.BindUsername,
                bindPassword: config.LdapSettings.BindPassword,
                userFilter: config.LdapSettings.UserFilter,
                firstNameAttribute: config.LdapSettings.FirstNameAttribute,
                lastNameAttribute: config.LdapSettings.LastNameAttribute,
                nicknameAttribute: config.LdapSettings.NicknameAttribute,
                emailAttribute: config.LdapSettings.EmailAttribute,
                usernameAttribute: config.LdapSettings.UsernameAttribute,
                positionAttribute: config.LdapSettings.PositionAttribute,
                idAttribute: config.LdapSettings.IdAttribute,
                syncIntervalMinutes: config.LdapSettings.SyncIntervalMinutes,
                skipCertificateVerification: config.LdapSettings.SkipCertificateVerification,
                queryTimeout: config.LdapSettings.QueryTimeout,
                maxPageSize: config.LdapSettings.MaxPageSize,
                loginFieldName: config.LdapSettings.LoginFieldName
            };
        }
    }, {
        key: 'renderTitle',
        value: function renderTitle() {
            return _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'admin.authentication.ldap',
                defaultMessage: 'AD/LDAP'
            });
        }
    }, {
        key: 'renderJobData',
        value: function renderJobData(job) {
            var mattermostUsers = '0';
            var ldapUsers = '0';
            var deleteCount = '0';
            var updateCount = '0';

            if (job && job.data) {
                if (job.data.mattermost_users_count && job.data.mattermost_users_count.length > 0) {
                    mattermostUsers = job.data.mattermost_users_count;
                }

                if (job.data.ldap_users_count && job.data.ldap_users_count.length > 0) {
                    ldapUsers = job.data.ldap_users_count;
                }

                if (job.data.delete_count && job.data.delete_count.length > 0) {
                    deleteCount = job.data.delete_count;
                }

                if (job.data.update_count && job.data.update_count.length > 0) {
                    updateCount = job.data.update_count;
                }
            }

            return _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'admin.ldap.jobExtraInfo',
                defaultMessage: 'Scanned {ldapUsers} LDAP users, updated {updateCount}, deactivated {deleteCount}',
                values: {
                    mattermostUsers: mattermostUsers,
                    ldapUsers: ldapUsers,
                    deleteCount: deleteCount,
                    updateCount: updateCount
                }
            });
        }
    }, {
        key: 'renderSettings',
        value: function renderSettings() {
            var licenseEnabled = this.props.license.IsLicensed === 'true' && this.props.license.LDAP === 'true';
            if (!licenseEnabled) {
                return null;
            }

            return _react2.default.createElement(
                _settings_group2.default,
                null,
                _react2.default.createElement(_boolean_setting2.default, {
                    id: 'enable',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.ldap.enableTitle',
                        defaultMessage: 'Enable sign-in with AD/LDAP:'
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.ldap.enableDesc',
                        defaultMessage: 'When true, Mattermost allows login using AD/LDAP'
                    }),
                    value: this.state.enable,
                    onChange: this.handleChange
                }),
                _react2.default.createElement(_boolean_setting2.default, {
                    id: 'enableSync',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.ldap.enableSyncTitle',
                        defaultMessage: 'Enable Synchronization with AD/LDAP:'
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.ldap.enableSyncDesc',
                        defaultMessage: 'When true, Mattermost periodically synchronizes users from AD/LDAP. When false, user attributes are updated in Mattermost during user login.'
                    }),
                    value: this.state.enableSync,
                    onChange: this.handleChange
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'ldapServer',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.ldap.serverTitle',
                        defaultMessage: 'AD/LDAP Server:'
                    }),
                    placeholder: Utils.localizeMessage('admin.ldap.serverEx', 'E.g.: "10.0.0.23"'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.ldap.serverDesc',
                        defaultMessage: 'The domain or IP address of AD/LDAP server.'
                    }),
                    value: this.state.ldapServer,
                    onChange: this.handleChange,
                    disabled: this.shouldBeDisabled()
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'ldapPort',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.ldap.portTitle',
                        defaultMessage: 'AD/LDAP Port:'
                    }),
                    placeholder: Utils.localizeMessage('admin.ldap.portEx', 'E.g.: "389"'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.ldap.portDesc',
                        defaultMessage: 'The port Mattermost will use to connect to the AD/LDAP server. Default is 389.'
                    }),
                    value: this.state.ldapPort,
                    onChange: this.handleChange,
                    disabled: this.shouldBeDisabled()
                }),
                _react2.default.createElement(_connection_security_dropdown_setting.ConnectionSecurityDropdownSettingLdap, {
                    value: this.state.connectionSecurity,
                    onChange: this.handleChange,
                    disabled: this.shouldBeDisabled()
                }),
                _react2.default.createElement(_boolean_setting2.default, {
                    id: 'skipCertificateVerification',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.ldap.skipCertificateVerification',
                        defaultMessage: 'Skip Certificate Verification:'
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.ldap.skipCertificateVerificationDesc',
                        defaultMessage: 'Skips the certificate verification step for TLS or STARTTLS connections. Not recommended for production environments where TLS is required. For testing only.'
                    }),
                    value: this.state.skipCertificateVerification,
                    onChange: this.handleChange
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'baseDN',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.ldap.baseTitle',
                        defaultMessage: 'BaseDN:'
                    }),
                    placeholder: Utils.localizeMessage('admin.ldap.baseEx', 'E.g.: "ou=Unit Name,dc=corp,dc=example,dc=com"'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.ldap.baseDesc',
                        defaultMessage: 'The Base DN is the Distinguished Name of the location where Mattermost should start its search for users in the AD/LDAP tree.'
                    }),
                    value: this.state.baseDN,
                    onChange: this.handleChange,
                    disabled: this.shouldBeDisabled()
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'bindUsername',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.ldap.bindUserTitle',
                        defaultMessage: 'Bind Username:'
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.ldap.bindUserDesc',
                        defaultMessage: 'The username used to perform the AD/LDAP search. This should typically be an account created specifically for use with Mattermost. It should have access limited to read the portion of the AD/LDAP tree specified in the BaseDN field.'
                    }),
                    value: this.state.bindUsername,
                    onChange: this.handleChange,
                    disabled: this.shouldBeDisabled()
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'bindPassword',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.ldap.bindPwdTitle',
                        defaultMessage: 'Bind Password:'
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.ldap.bindPwdDesc',
                        defaultMessage: 'Password of the user given in "Bind Username".'
                    }),
                    value: this.state.bindPassword,
                    onChange: this.handleChange,
                    disabled: this.shouldBeDisabled()
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'userFilter',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.ldap.userFilterTitle',
                        defaultMessage: 'User Filter:'
                    }),
                    placeholder: Utils.localizeMessage('admin.ldap.userFilterEx', 'Ex. "(objectClass=user)"'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.ldap.userFilterDisc',
                        defaultMessage: '(Optional) Enter an AD/LDAP Filter to use when searching for user objects. Only the users selected by the query will be able to access Mattermost. For Active Directory, the query to filter out disabled users is (&(objectCategory=Person)(!(UserAccountControl:1.2.840.113556.1.4.803:=2))).'
                    }),
                    value: this.state.userFilter,
                    onChange: this.handleChange,
                    disabled: this.shouldBeDisabled()
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'firstNameAttribute',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.ldap.firstnameAttrTitle',
                        defaultMessage: 'First Name Attribute:'
                    }),
                    placeholder: Utils.localizeMessage('admin.ldap.firstnameAttrEx', 'E.g.: "givenName"'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.ldap.firstnameAttrDesc',
                        defaultMessage: '(Optional) The attribute in the AD/LDAP server that will be used to populate the first name of users in Mattermost.  When set, users will not be able to edit their first name, since it is synchronized with the LDAP server. When left blank, users can set their own first name in Account Settings.'
                    }),
                    value: this.state.firstNameAttribute,
                    onChange: this.handleChange,
                    disabled: this.shouldBeDisabled()
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'lastNameAttribute',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.ldap.lastnameAttrTitle',
                        defaultMessage: 'Last Name Attribute:'
                    }),
                    placeholder: Utils.localizeMessage('admin.ldap.lastnameAttrEx', 'E.g.: "sn"'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.ldap.lastnameAttrDesc',
                        defaultMessage: '(Optional) The attribute in the AD/LDAP server that will be used to populate the last name of users in Mattermost. When set, users will not be able to edit their last name, since it is synchronized with the LDAP server. When left blank, users can set their own last name in Account Settings.'
                    }),
                    value: this.state.lastNameAttribute,
                    onChange: this.handleChange,
                    disabled: this.shouldBeDisabled()
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'nicknameAttribute',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.ldap.nicknameAttrTitle',
                        defaultMessage: 'Nickname Attribute:'
                    }),
                    placeholder: Utils.localizeMessage('admin.ldap.nicknameAttrEx', 'E.g.: "nickname"'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.ldap.nicknameAttrDesc',
                        defaultMessage: '(Optional) The attribute in the AD/LDAP server that will be used to populate the nickname of users in Mattermost. When set, users will not be able to edit their nickname, since it is synchronized with the LDAP server. When left blank, users can set their own nickname in Account Settings.'
                    }),
                    value: this.state.nicknameAttribute,
                    onChange: this.handleChange,
                    disabled: this.shouldBeDisabled()
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'positionAttribute',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.ldap.positionAttrTitle',
                        defaultMessage: 'Position Attribute:'
                    }),
                    placeholder: Utils.localizeMessage('admin.ldap.positionAttrEx', 'E.g.: "title"'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.ldap.positionAttrDesc',
                        defaultMessage: '(Optional) The attribute in the AD/LDAP server that will be used to populate the position field in Mattermost.'
                    }),
                    value: this.state.positionAttribute,
                    onChange: this.handleChange,
                    disabled: this.shouldBeDisabled()
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'emailAttribute',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.ldap.emailAttrTitle',
                        defaultMessage: 'Email Attribute:'
                    }),
                    placeholder: Utils.localizeMessage('admin.ldap.emailAttrEx', 'E.g.: "mail" or "userPrincipalName"'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.ldap.emailAttrDesc',
                        defaultMessage: 'The attribute in the AD/LDAP server that will be used to populate the email addresses of users in Mattermost.'
                    }),
                    value: this.state.emailAttribute,
                    onChange: this.handleChange,
                    disabled: this.shouldBeDisabled()
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'usernameAttribute',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.ldap.usernameAttrTitle',
                        defaultMessage: 'Username Attribute:'
                    }),
                    placeholder: Utils.localizeMessage('admin.ldap.usernameAttrEx', 'E.g.: "sAMAccountName"'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.ldap.uernameAttrDesc',
                        defaultMessage: 'The attribute in the AD/LDAP server that will be used to populate the username field in Mattermost. This may be the same as the ID Attribute.'
                    }),
                    value: this.state.usernameAttribute,
                    onChange: this.handleChange,
                    disabled: this.shouldBeDisabled()
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'idAttribute',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.ldap.idAttrTitle',
                        defaultMessage: 'ID Attribute: '
                    }),
                    placeholder: Utils.localizeMessage('admin.ldap.idAttrEx', 'E.g.: "sAMAccountName"'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.ldap.idAttrDesc',
                        defaultMessage: 'The attribute in the AD/LDAP server that will be used as a unique identifier in Mattermost. It should be an AD/LDAP attribute with a value that does not change, such as username or uid. If a user\u2019s ID Attribute changes, it will create a new Mattermost account unassociated with their old one. This is the value used to log in to Mattermost in the "AD/LDAP Username" field on the sign in page. Normally this attribute is the same as the "Username Attribute" field above. If your team typically uses domain\\\\username to sign in to other services with AD/LDAP, you may choose to put domain\\\\username in this field to maintain consistency between sites.'
                    }),
                    value: this.state.idAttribute,
                    onChange: this.handleChange,
                    disabled: this.shouldBeDisabled()
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'loginFieldName',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.ldap.loginNameTitle',
                        defaultMessage: 'Sign-in Field Default Text:'
                    }),
                    placeholder: Utils.localizeMessage('admin.ldap.loginNameEx', 'E.g.: "AD/LDAP Username"'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.ldap.loginNameDesc',
                        defaultMessage: 'The placeholder text that appears in the login field on the login page. Defaults to "AD/LDAP Username".'
                    }),
                    value: this.state.loginFieldName,
                    onChange: this.handleChange,
                    disabled: this.shouldBeDisabled()
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'syncIntervalMinutes',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.ldap.syncIntervalTitle',
                        defaultMessage: 'Synchronization Interval (minutes):'
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.ldap.syncIntervalHelpText',
                        defaultMessage: 'AD/LDAP Synchronization updates Mattermost user information to reflect updates on the AD/LDAP server. For example, when a user\u2019s name changes on the AD/LDAP server, the change updates in Mattermost when synchronization is performed. Accounts removed from or disabled in the AD/LDAP server have their Mattermost accounts set to "Inactive" and have their account sessions revoked. Mattermost performs synchronization on the interval entered. For example, if 60 is entered, Mattermost synchronizes every 60 minutes.'
                    }),
                    value: this.state.syncIntervalMinutes,
                    onChange: this.handleChange,
                    disabled: this.shouldBeDisabled()
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'maxPageSize',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.ldap.maxPageSizeTitle',
                        defaultMessage: 'Maximum Page Size:'
                    }),
                    placeholder: Utils.localizeMessage('admin.ldap.maxPageSizeEx', 'E.g.: "2000"'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.ldap.maxPageSizeHelpText',
                        defaultMessage: 'The maximum number of users the Mattermost server will request from the AD/LDAP server at one time. 0 is unlimited.'
                    }),
                    value: this.state.maxPageSize,
                    onChange: this.handleChange,
                    disabled: this.shouldBeDisabled()
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'queryTimeout',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.ldap.queryTitle',
                        defaultMessage: 'Query Timeout (seconds):'
                    }),
                    placeholder: Utils.localizeMessage('admin.ldap.queryEx', 'E.g.: "60"'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.ldap.queryDesc',
                        defaultMessage: 'The timeout value for queries to the AD/LDAP server. Increase if you are getting timeout errors caused by a slow AD/LDAP server.'
                    }),
                    value: this.state.queryTimeout,
                    onChange: this.handleChange,
                    disabled: this.shouldBeDisabled()
                }),
                _react2.default.createElement(_request_button2.default, {
                    requestAction: _admin_actions.ldapTest,
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.ldap.testHelpText',
                        defaultMessage: 'Tests if the Mattermost server can connect to the AD/LDAP server specified. See log file for more detailed error messages.'
                    }),
                    buttonText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.ldap.ldap_test_button',
                        defaultMessage: 'AD/LDAP Test'
                    }),
                    disabled: this.shouldBeDisabled(),
                    saveNeeded: this.state.saveNeeded,
                    saveConfigAction: this.doSubmit,
                    errorMessage: {
                        id: 'admin.ldap.testFailure',
                        defaultMessage: 'AD/LDAP Test Failure: {error}'
                    },
                    successMessage: {
                        id: 'admin.ldap.testSuccess',
                        defaultMessage: 'AD/LDAP Test Successful'
                    }
                }),
                _react2.default.createElement(_jobs2.default, {
                    jobType: _constants.JobTypes.LDAP_SYNC,
                    getExtraInfoText: this.renderJobData,
                    disabled: this.shouldBeDisabled(),
                    createJobButtonText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.ldap.sync_button',
                        defaultMessage: 'AD/LDAP Synchronize Now'
                    }),
                    createJobHelpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.ldap.syncNowHelpText',
                        defaultMessage: 'Initiates an AD/LDAP synchronization immediately.'
                    })
                })
            );
        }
    }]);
    return LdapSettings;
}(_admin_settings2.default);

exports.default = LdapSettings;

/***/ }),

/***/ 2593:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _admin_settings = __webpack_require__(787);

var _admin_settings2 = _interopRequireDefault(_admin_settings);

var _settings_group = __webpack_require__(788);

var _settings_group2 = _interopRequireDefault(_settings_group);

var _text_setting = __webpack_require__(794);

var _text_setting2 = _interopRequireDefault(_text_setting);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LegalAndSupportSettings = function (_AdminSettings) {
    (0, _inherits3.default)(LegalAndSupportSettings, _AdminSettings);

    function LegalAndSupportSettings(props) {
        (0, _classCallCheck3.default)(this, LegalAndSupportSettings);

        var _this = (0, _possibleConstructorReturn3.default)(this, (LegalAndSupportSettings.__proto__ || (0, _getPrototypeOf2.default)(LegalAndSupportSettings)).call(this, props));

        _this.getConfigFromState = _this.getConfigFromState.bind(_this);

        _this.renderSettings = _this.renderSettings.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(LegalAndSupportSettings, [{
        key: 'getConfigFromState',
        value: function getConfigFromState(config) {
            config.SupportSettings.TermsOfServiceLink = this.state.termsOfServiceLink;
            config.SupportSettings.PrivacyPolicyLink = this.state.privacyPolicyLink;
            config.SupportSettings.AboutLink = this.state.aboutLink;
            config.SupportSettings.HelpLink = this.state.helpLink;
            config.SupportSettings.ReportAProblemLink = this.state.reportAProblemLink;
            config.SupportSettings.SupportEmail = this.state.supportEmail;

            return config;
        }
    }, {
        key: 'getStateFromConfig',
        value: function getStateFromConfig(config) {
            return {
                termsOfServiceLink: config.SupportSettings.TermsOfServiceLink,
                privacyPolicyLink: config.SupportSettings.PrivacyPolicyLink,
                aboutLink: config.SupportSettings.AboutLink,
                helpLink: config.SupportSettings.HelpLink,
                reportAProblemLink: config.SupportSettings.ReportAProblemLink,
                supportEmail: config.SupportSettings.SupportEmail
            };
        }
    }, {
        key: 'renderTitle',
        value: function renderTitle() {
            return _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'admin.customization.support',
                defaultMessage: 'Legal and Support'
            });
        }
    }, {
        key: 'renderSettings',
        value: function renderSettings() {
            return _react2.default.createElement(
                _settings_group2.default,
                null,
                _react2.default.createElement(_text_setting2.default, {
                    id: 'termsOfServiceLink',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.support.termsTitle',
                        defaultMessage: 'Terms of Service link:'
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.support.termsDesc',
                        defaultMessage: 'Link to the terms under which users may use your online service. By default, this includes the "Mattermost Conditions of Use (End Users)" explaining the terms under which Mattermost software is provided to end users. If you change the default link to add your own terms for using the service you provide, your new terms must include a link to the default terms so end users are aware of the Mattermost Conditions of Use (End User) for Mattermost software.'
                    }),
                    value: this.state.termsOfServiceLink,
                    onChange: this.handleChange
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'privacyPolicyLink',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.support.privacyTitle',
                        defaultMessage: 'Privacy Policy link:'
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.support.privacyDesc',
                        defaultMessage: 'The URL for the Privacy link on the login and sign-up pages. If this field is empty, the Privacy link is hidden from users.'
                    }),
                    value: this.state.privacyPolicyLink,
                    onChange: this.handleChange
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'aboutLink',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.support.aboutTitle',
                        defaultMessage: 'About link:'
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.support.aboutDesc',
                        defaultMessage: 'The URL for the About link on the Mattermost login and sign-up pages. If this field is empty, the About link is hidden from users.'
                    }),
                    value: this.state.aboutLink,
                    onChange: this.handleChange
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'helpLink',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.support.helpTitle',
                        defaultMessage: 'Help link:'
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.support.helpDesc',
                        defaultMessage: 'The URL for the Help link on the Mattermost login page, sign-up pages, and Main Menu. If this field is empty, the Help link is hidden from users.'
                    }),
                    value: this.state.helpLink,
                    onChange: this.handleChange
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'reportAProblemLink',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.support.problemTitle',
                        defaultMessage: 'Report a Problem link:'
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.support.problemDesc',
                        defaultMessage: 'The URL for the Report a Problem link in the Main Menu. If this field is empty, the link is removed from the Main Menu.'
                    }),
                    value: this.state.reportAProblemLink,
                    onChange: this.handleChange
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'supportEmail',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.support.emailTitle',
                        defaultMessage: 'Support Email:'
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.support.emailHelp',
                        defaultMessage: 'Email address displayed on email notifications and during tutorial for end users to ask support questions.'
                    }),
                    value: this.state.supportEmail,
                    onChange: this.handleChange
                })
            );
        }
    }]);
    return LegalAndSupportSettings;
}(_admin_settings2.default); // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = LegalAndSupportSettings;

/***/ }),

/***/ 2594:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _admin_settings = __webpack_require__(787);

var _admin_settings2 = _interopRequireDefault(_admin_settings);

var _boolean_setting = __webpack_require__(800);

var _boolean_setting2 = _interopRequireDefault(_boolean_setting);

var _settings_group = __webpack_require__(788);

var _settings_group2 = _interopRequireDefault(_settings_group);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LinkPreviewsSettings = function (_AdminSettings) {
    (0, _inherits3.default)(LinkPreviewsSettings, _AdminSettings);

    function LinkPreviewsSettings(props) {
        (0, _classCallCheck3.default)(this, LinkPreviewsSettings);

        var _this = (0, _possibleConstructorReturn3.default)(this, (LinkPreviewsSettings.__proto__ || (0, _getPrototypeOf2.default)(LinkPreviewsSettings)).call(this, props));

        _this.getConfigFromState = _this.getConfigFromState.bind(_this);

        _this.renderSettings = _this.renderSettings.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(LinkPreviewsSettings, [{
        key: 'getConfigFromState',
        value: function getConfigFromState(config) {
            config.ServiceSettings.EnableLinkPreviews = this.state.enableLinkPreviews;

            return config;
        }
    }, {
        key: 'getStateFromConfig',
        value: function getStateFromConfig(config) {
            return {
                enableLinkPreviews: config.ServiceSettings.EnableLinkPreviews
            };
        }
    }, {
        key: 'renderTitle',
        value: function renderTitle() {
            return _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'admin.customization.linkPreviews',
                defaultMessage: 'Link Previews'
            });
        }
    }, {
        key: 'renderSettings',
        value: function renderSettings() {
            return _react2.default.createElement(
                _settings_group2.default,
                null,
                _react2.default.createElement(_boolean_setting2.default, {
                    id: 'enableLinkPreviews',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.customization.enableLinkPreviewsTitle',
                        defaultMessage: 'Enable Link Previews:'
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.customization.enableLinkPreviewsDesc',
                        defaultMessage: 'Display a preview of website content below messages, when available. Users can disable these previews from Account Settings > Display > Website Link Previews.'
                    }),
                    value: this.state.enableLinkPreviews,
                    onChange: this.handleChange
                })
            );
        }
    }]);
    return LinkPreviewsSettings;
}(_admin_settings2.default); // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = LinkPreviewsSettings;

/***/ }),

/***/ 2595:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _constants = __webpack_require__(29);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _admin_settings = __webpack_require__(787);

var _admin_settings2 = _interopRequireDefault(_admin_settings);

var _boolean_setting = __webpack_require__(800);

var _boolean_setting2 = _interopRequireDefault(_boolean_setting);

var _dropdown_setting = __webpack_require__(842);

var _dropdown_setting2 = _interopRequireDefault(_dropdown_setting);

var _jobs = __webpack_require__(996);

var _jobs2 = _interopRequireDefault(_jobs);

var _settings_group = __webpack_require__(788);

var _settings_group2 = _interopRequireDefault(_settings_group);

var _text_setting = __webpack_require__(794);

var _text_setting2 = _interopRequireDefault(_text_setting);

var _radio_setting = __webpack_require__(1098);

var _radio_setting2 = _interopRequireDefault(_radio_setting);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var exportFormats = {
    EXPORT_FORMAT_ACTIANCE: 'actiance',
    EXPORT_FORMAT_GLOBALRELAY: 'globalrelay'
};

var MessageExportSettings = function (_AdminSettings) {
    (0, _inherits3.default)(MessageExportSettings, _AdminSettings);

    function MessageExportSettings(props) {
        (0, _classCallCheck3.default)(this, MessageExportSettings);

        var _this = (0, _possibleConstructorReturn3.default)(this, (MessageExportSettings.__proto__ || (0, _getPrototypeOf2.default)(MessageExportSettings)).call(this, props));

        _this.getConfigFromState = _this.getConfigFromState.bind(_this);
        _this.renderSettings = _this.renderSettings.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(MessageExportSettings, [{
        key: 'getConfigFromState',
        value: function getConfigFromState(config) {
            config.MessageExportSettings.EnableExport = this.state.enableComplianceExport;
            config.MessageExportSettings.ExportFormat = this.state.exportFormat;
            config.MessageExportSettings.DailyRunTime = this.state.exportJobStartTime;

            if (this.state.exportFormat === exportFormats.EXPORT_FORMAT_GLOBALRELAY) {
                config.MessageExportSettings.GlobalRelaySettings = {
                    CustomerType: this.state.globalRelayCustomerType,
                    SmtpUsername: this.state.globalRelaySmtpUsername,
                    SmtpPassword: this.state.globalRelaySmtpPassword,
                    EmailAddress: this.state.globalRelayEmailAddress

                };
            }
            return config;
        }
    }, {
        key: 'getStateFromConfig',
        value: function getStateFromConfig(config) {
            var state = {
                enableComplianceExport: config.MessageExportSettings.EnableExport,
                exportFormat: config.MessageExportSettings.ExportFormat,
                exportJobStartTime: config.MessageExportSettings.DailyRunTime
            };
            if (config.MessageExportSettings.GlobalRelaySettings) {
                state.globalRelayCustomerType = config.MessageExportSettings.GlobalRelaySettings.CustomerType;
                state.globalRelaySmtpUsername = config.MessageExportSettings.GlobalRelaySettings.SmtpUsername;
                state.globalRelaySmtpPassword = config.MessageExportSettings.GlobalRelaySettings.SmtpPassword;
                state.globalRelayEmailAddress = config.MessageExportSettings.GlobalRelaySettings.EmailAddress;
            }
            return state;
        }
    }, {
        key: 'renderTitle',
        value: function renderTitle() {
            return _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'admin.complianceExport.title',
                defaultMessage: 'Compliance Export (Beta)'
            });
        }
    }, {
        key: 'renderSettings',
        value: function renderSettings() {
            var exportFormatOptions = [{ value: exportFormats.EXPORT_FORMAT_ACTIANCE, text: Utils.localizeMessage('admin.complianceExport.exportFormat.actiance', 'Actiance XML') }, { value: exportFormats.EXPORT_FORMAT_GLOBALRELAY, text: Utils.localizeMessage('admin.complianceExport.exportFormat.globalrelay', 'GlobalRelay EML') }];

            // if the export format is globalrelay, the user needs to set some additional parameters
            var globalRelaySettings = void 0;
            if (this.state.exportFormat === exportFormats.EXPORT_FORMAT_GLOBALRELAY) {
                var globalRelayCustomerType = _react2.default.createElement(_radio_setting2.default, {
                    id: 'globalRelayCustomerType',
                    values: [{ value: 'A9', text: Utils.localizeMessage('admin.complianceExport.globalRelayCustomerType.a9.description', 'A9/Type 9') }, { value: 'A10', text: Utils.localizeMessage('admin.complianceExport.globalRelayCustomerType.a10.description', 'A10/Type 10') }],
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.complianceExport.globalRelayCustomerType.title',
                        defaultMessage: 'Customer Type:'
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.complianceExport.globalRelayCustomerType.description',
                        defaultMessage: 'The type of GlobalRelay customer account that your organization has.'
                    }),
                    value: this.state.globalRelayCustomerType ? this.state.globalRelayCustomerType : '',
                    disabled: !this.state.enableComplianceExport,
                    onChange: this.handleChange
                });

                var globalRelaySmtpUsername = _react2.default.createElement(_text_setting2.default, {
                    id: 'globalRelaySmtpUsername',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.complianceExport.globalRelaySmtpUsername.title',
                        defaultMessage: 'SMTP Username:'
                    }),
                    placeholder: Utils.localizeMessage('admin.complianceExport.globalRelaySmtpUsername.example', 'E.g.: "globalRelayUser"'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.complianceExport.globalRelaySmtpUsername.description',
                        defaultMessage: 'The username that is used to authenticate against the GlobalRelay SMTP server.'
                    }),
                    value: this.state.globalRelaySmtpUsername ? this.state.globalRelaySmtpUsername : '',
                    disabled: !this.state.enableComplianceExport,
                    onChange: this.handleChange
                });

                var globalRelaySmtpPassword = _react2.default.createElement(_text_setting2.default, {
                    id: 'globalRelaySmtpPassword',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.complianceExport.globalRelaySmtpPassword.title',
                        defaultMessage: 'SMTP Password:'
                    }),
                    placeholder: Utils.localizeMessage('admin.complianceExport.globalRelaySmtpPassword.example', 'E.g.: "globalRelayPassword"'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.complianceExport.globalRelaySmtpPassword.description',
                        defaultMessage: 'The password that is used to authenticate against the GlobalRelay SMTP server.'
                    }),
                    value: this.state.globalRelaySmtpPassword ? this.state.globalRelaySmtpPassword : '',
                    disabled: !this.state.enableComplianceExport,
                    onChange: this.handleChange
                });

                var globalRelayEmail = _react2.default.createElement(_text_setting2.default, {
                    id: 'globalRelayEmailAddress',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.complianceExport.globalRelayEmailAddress.title',
                        defaultMessage: 'Email Address:'
                    }),
                    placeholder: Utils.localizeMessage('admin.complianceExport.globalRelayEmailAddress.example', 'E.g.: "globalrelay@mattermost.com"'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                        id: 'admin.complianceExport.globalRelayEmailAddress.description',
                        defaultMessage: 'The email address that your GlobalRelay server monitors for incoming Compliance Exports.'
                    }),
                    value: this.state.globalRelayEmailAddress ? this.state.globalRelayEmailAddress : '',
                    disabled: !this.state.enableComplianceExport,
                    onChange: this.handleChange
                });

                globalRelaySettings = _react2.default.createElement(
                    _settings_group2.default,
                    { id: 'globalRelaySettings' },
                    globalRelayCustomerType,
                    globalRelaySmtpUsername,
                    globalRelaySmtpPassword,
                    globalRelayEmail
                );
            }

            var dropdownHelpText = _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                id: 'admin.complianceExport.exportFormat.description',
                defaultMessage: 'Format of the compliance export. Corresponds to the system that you want to import the data into.<br><br>For Actiance XML, compliance export files are written to the "exports" subdirectory of the configured <a href="/admin_console/files/storage">Local Storage Directory</a>. For Global Relay EML, they are emailed to the configured email address.'
            });

            return _react2.default.createElement(
                _settings_group2.default,
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'banner' },
                    _react2.default.createElement(
                        'div',
                        { className: 'banner__content' },
                        _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                            id: 'admin.complianceExport.description',
                            defaultMessage: 'This feature supports compliance exports to the Actiance XML and GlobalRelay EML formats, and is currently in beta. Support for the Mattermost CSV format is scheduled for a future release, and will replace the existing <a href=\\"/admin_console/general/compliance\\">Compliance</a> feature.'
                        })
                    )
                ),
                _react2.default.createElement(_boolean_setting2.default, {
                    id: 'enableComplianceExport',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.service.complianceExportTitle',
                        defaultMessage: 'Enable Compliance Export:'
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                        id: 'admin.service.complianceExportDesc',
                        defaultMessage: 'When true, Mattermost will export all messages that were posted in the last 24 hours. The export task is scheduled to run once per day. See <a href=\\"https://about.mattermost.com/default-compliance-export-documentation\\" target=\\"_blank\\">the documentation</a> to learn more.'
                    }),
                    value: this.state.enableComplianceExport,
                    onChange: this.handleChange
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'exportJobStartTime',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.complianceExport.exportJobStartTime.title',
                        defaultMessage: 'Compliance Export Time:'
                    }),
                    placeholder: Utils.localizeMessage('admin.complianceExport.exportJobStartTime.example', 'E.g.: "02:00"'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                        id: 'admin.complianceExport.exportJobStartTime.description',
                        defaultMessage: 'Set the start time of the daily scheduled compliance export job. Choose a time when fewer people are using your system. Must be a 24-hour time stamp in the form HH:MM.'
                    }),
                    value: this.state.exportJobStartTime,
                    disabled: !this.state.enableComplianceExport,
                    onChange: this.handleChange
                }),
                _react2.default.createElement(_dropdown_setting2.default, {
                    id: 'exportFormat',
                    values: exportFormatOptions,
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.complianceExport.exportFormat.title',
                        defaultMessage: 'Export Format:'
                    }),
                    helpText: dropdownHelpText,
                    value: this.state.exportFormat,
                    disabled: !this.state.enableComplianceExport,
                    onChange: this.handleChange
                }),
                globalRelaySettings,
                _react2.default.createElement(_jobs2.default, {
                    jobType: _constants.JobTypes.MESSAGE_EXPORT,
                    disabled: !this.state.enableComplianceExport,
                    createJobButtonText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.complianceExport.createJob.title',
                        defaultMessage: 'Run Compliance Export Job Now'
                    }),
                    createJobHelpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.complianceExport.createJob.help',
                        defaultMessage: 'Initiates a Compliance Export job immediately.'
                    })
                })
            );
        }
    }]);
    return MessageExportSettings;
}(_admin_settings2.default);

exports.default = MessageExportSettings;

/***/ }),

/***/ 2596:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _admin_settings = __webpack_require__(787);

var _admin_settings2 = _interopRequireDefault(_admin_settings);

var _boolean_setting = __webpack_require__(800);

var _boolean_setting2 = _interopRequireDefault(_boolean_setting);

var _settings_group = __webpack_require__(788);

var _settings_group2 = _interopRequireDefault(_settings_group);

var _text_setting = __webpack_require__(794);

var _text_setting2 = _interopRequireDefault(_text_setting);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MetricsSettings = function (_AdminSettings) {
    (0, _inherits3.default)(MetricsSettings, _AdminSettings);

    function MetricsSettings(props) {
        (0, _classCallCheck3.default)(this, MetricsSettings);

        var _this = (0, _possibleConstructorReturn3.default)(this, (MetricsSettings.__proto__ || (0, _getPrototypeOf2.default)(MetricsSettings)).call(this, props));

        _this.getConfigFromState = _this.getConfigFromState.bind(_this);
        _this.renderSettings = _this.renderSettings.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(MetricsSettings, [{
        key: 'getConfigFromState',
        value: function getConfigFromState(config) {
            config.MetricsSettings.Enable = this.state.enable;
            config.MetricsSettings.ListenAddress = this.state.listenAddress;

            return config;
        }
    }, {
        key: 'getStateFromConfig',
        value: function getStateFromConfig(config) {
            var settings = config.MetricsSettings;

            return {
                enable: settings.Enable,
                listenAddress: settings.ListenAddress
            };
        }
    }, {
        key: 'renderTitle',
        value: function renderTitle() {
            return _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'admin.advance.metrics',
                defaultMessage: 'Performance Monitoring'
            });
        }
    }, {
        key: 'renderSettings',
        value: function renderSettings() {
            var licenseEnabled = this.props.license.IsLicensed === 'true' && this.props.license.Metrics === 'true';
            if (!licenseEnabled) {
                return null;
            }

            return _react2.default.createElement(
                _settings_group2.default,
                null,
                _react2.default.createElement(_boolean_setting2.default, {
                    id: 'enable',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.metrics.enableTitle',
                        defaultMessage: 'Enable Performance Monitoring:'
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                        id: 'admin.metrics.enableDescription',
                        defaultMessage: 'When true, Mattermost will enable performance monitoring collection and profiling. Please see <a href="http://docs.mattermost.com/deployment/metrics.html" target="_blank">documentation</a> to learn more about configuring performance monitoring for Mattermost.'
                    }),
                    value: this.state.enable,
                    onChange: this.handleChange
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'listenAddress',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.metrics.listenAddressTitle',
                        defaultMessage: 'Listen Address:'
                    }),
                    placeholder: Utils.localizeMessage('admin.metrics.listenAddressEx', 'E.g.: ":8067"'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.metrics.listenAddressDesc',
                        defaultMessage: 'The address the server will listen on to expose performance metrics.'
                    }),
                    value: this.state.listenAddress,
                    onChange: this.handleChange
                })
            );
        }
    }]);
    return MetricsSettings;
}(_admin_settings2.default); // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = MetricsSettings;

/***/ }),

/***/ 2597:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _admin_settings = __webpack_require__(787);

var _admin_settings2 = _interopRequireDefault(_admin_settings);

var _settings_group = __webpack_require__(788);

var _settings_group2 = _interopRequireDefault(_settings_group);

var _text_setting = __webpack_require__(794);

var _text_setting2 = _interopRequireDefault(_text_setting);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NativeAppLinkSettings = function (_AdminSettings) {
    (0, _inherits3.default)(NativeAppLinkSettings, _AdminSettings);

    function NativeAppLinkSettings(props) {
        (0, _classCallCheck3.default)(this, NativeAppLinkSettings);

        var _this = (0, _possibleConstructorReturn3.default)(this, (NativeAppLinkSettings.__proto__ || (0, _getPrototypeOf2.default)(NativeAppLinkSettings)).call(this, props));

        _this.getConfigFromState = _this.getConfigFromState.bind(_this);

        _this.renderSettings = _this.renderSettings.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(NativeAppLinkSettings, [{
        key: 'getConfigFromState',
        value: function getConfigFromState(config) {
            config.NativeAppSettings.AppDownloadLink = this.state.appDownloadLink;
            config.NativeAppSettings.AndroidAppDownloadLink = this.state.androidAppDownloadLink;
            config.NativeAppSettings.IosAppDownloadLink = this.state.iosAppDownloadLink;

            return config;
        }
    }, {
        key: 'getStateFromConfig',
        value: function getStateFromConfig(config) {
            return {
                appDownloadLink: config.NativeAppSettings.AppDownloadLink,
                androidAppDownloadLink: config.NativeAppSettings.AndroidAppDownloadLink,
                iosAppDownloadLink: config.NativeAppSettings.IosAppDownloadLink
            };
        }
    }, {
        key: 'renderTitle',
        value: function renderTitle() {
            return _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'admin.customization.nativeAppLinks',
                defaultMessage: 'Mattermost App Links'
            });
        }
    }, {
        key: 'renderSettings',
        value: function renderSettings() {
            return _react2.default.createElement(
                _settings_group2.default,
                null,
                _react2.default.createElement(_text_setting2.default, {
                    id: 'appDownloadLink',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.customization.appDownloadLinkTitle',
                        defaultMessage: 'Mattermost Apps Download Page Link:'
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.customization.appDownloadLinkDesc',
                        defaultMessage: 'Add a link to a download page for the Mattermost apps. When a link is present, an option to "Download Mattermost Apps" will be added in the Main Menu so users can find the download page. Leave this field blank to hide the option from the Main Menu.'
                    }),
                    value: this.state.appDownloadLink,
                    onChange: this.handleChange
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'androidAppDownloadLink',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.customization.androidAppDownloadLinkTitle',
                        defaultMessage: 'Android App Download Link:'
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.customization.androidAppDownloadLinkDesc',
                        defaultMessage: 'Add a link to download the Android app. Users who access the site on a mobile web browser will be prompted with a page giving them the option to download the app. Leave this field blank to prevent the page from appearing.'
                    }),
                    value: this.state.androidAppDownloadLink,
                    onChange: this.handleChange
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'iosAppDownloadLink',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.customization.iosAppDownloadLinkTitle',
                        defaultMessage: 'iOS App Download Link:'
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.customization.iosAppDownloadLinkDesc',
                        defaultMessage: 'Add a link to download the iOS app. Users who access the site on a mobile web browser will be prompted with a page giving them the option to download the app. Leave this field blank to prevent the page from appearing.'
                    }),
                    value: this.state.iosAppDownloadLink,
                    onChange: this.handleChange
                })
            );
        }
    }]);
    return NativeAppLinkSettings;
}(_admin_settings2.default); // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = NativeAppLinkSettings;

/***/ }),

/***/ 2598:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _admin_settings = __webpack_require__(787);

var _admin_settings2 = _interopRequireDefault(_admin_settings);

var _dropdown_setting = __webpack_require__(842);

var _dropdown_setting2 = _interopRequireDefault(_dropdown_setting);

var _settings_group = __webpack_require__(788);

var _settings_group2 = _interopRequireDefault(_settings_group);

var _text_setting = __webpack_require__(794);

var _text_setting2 = _interopRequireDefault(_text_setting);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var OAuthSettings = function (_AdminSettings) {
    (0, _inherits3.default)(OAuthSettings, _AdminSettings);

    function OAuthSettings(props) {
        (0, _classCallCheck3.default)(this, OAuthSettings);

        var _this = (0, _possibleConstructorReturn3.default)(this, (OAuthSettings.__proto__ || (0, _getPrototypeOf2.default)(OAuthSettings)).call(this, props));

        _this.updateGitLabUrl = function (id, value) {
            var trimmedValue = value;
            if (value.endsWith('/')) {
                trimmedValue = value.slice(0, -1);
            }

            _this.setState({
                saveNeeded: true,
                gitLabUrl: value,
                userApiEndpoint: trimmedValue + '/api/v4/user',
                authEndpoint: trimmedValue + '/oauth/authorize',
                tokenEndpoint: trimmedValue + '/oauth/token'
            });
        };

        _this.getConfigFromState = _this.getConfigFromState.bind(_this);
        _this.getStateFromConfig = _this.getStateFromConfig.bind(_this);
        _this.renderSettings = _this.renderSettings.bind(_this);
        _this.renderOffice365 = _this.renderOffice365.bind(_this);
        _this.renderGoogle = _this.renderGoogle.bind(_this);
        _this.renderGitLab = _this.renderGitLab.bind(_this);
        _this.changeType = _this.changeType.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(OAuthSettings, [{
        key: 'getConfigFromState',
        value: function getConfigFromState(config) {
            config.GitLabSettings.Enable = false;
            config.GoogleSettings.Enable = false;
            config.Office365Settings.Enable = false;

            if (this.state.oauthType === _constants2.default.GITLAB_SERVICE) {
                config.GitLabSettings.Enable = true;
                config.GitLabSettings.Id = this.state.id;
                config.GitLabSettings.Secret = this.state.secret;
                config.GitLabSettings.UserApiEndpoint = this.state.userApiEndpoint;
                config.GitLabSettings.AuthEndpoint = this.state.authEndpoint;
                config.GitLabSettings.TokenEndpoint = this.state.tokenEndpoint;
            }

            if (this.state.oauthType === _constants2.default.GOOGLE_SERVICE) {
                config.GoogleSettings.Enable = true;
                config.GoogleSettings.Id = this.state.id;
                config.GoogleSettings.Secret = this.state.secret;
                config.GoogleSettings.UserApiEndpoint = 'https://www.googleapis.com/plus/v1/people/me';
                config.GoogleSettings.AuthEndpoint = 'https://accounts.google.com/o/oauth2/v2/auth';
                config.GoogleSettings.TokenEndpoint = 'https://www.googleapis.com/oauth2/v4/token';
                config.GoogleSettings.Scope = 'profile email';
            }

            if (this.state.oauthType === _constants2.default.OFFICE365_SERVICE) {
                config.Office365Settings.Enable = true;
                config.Office365Settings.Id = this.state.id;
                config.Office365Settings.Secret = this.state.secret;
                config.Office365Settings.UserApiEndpoint = 'https://graph.microsoft.com/v1.0/me';
                config.Office365Settings.AuthEndpoint = 'https://login.microsoftonline.com/common/oauth2/v2.0/authorize';
                config.Office365Settings.TokenEndpoint = 'https://login.microsoftonline.com/common/oauth2/v2.0/token';
                config.Office365Settings.Scope = 'User.Read';
            }

            return config;
        }
    }, {
        key: 'getStateFromConfig',
        value: function getStateFromConfig(config) {
            this.config = config;

            var oauthType = 'off';
            var settings = {};
            if (config.GitLabSettings.Enable) {
                oauthType = _constants2.default.GITLAB_SERVICE;
                settings = config.GitLabSettings;
            } else if (config.GoogleSettings.Enable) {
                oauthType = _constants2.default.GOOGLE_SERVICE;
                settings = config.GoogleSettings;
            } else if (config.Office365Settings.Enable) {
                oauthType = _constants2.default.OFFICE365_SERVICE;
                settings = config.Office365Settings;
            }

            return {
                oauthType: oauthType,
                id: settings.Id,
                secret: settings.Secret,
                gitLabUrl: config.GitLabSettings.UserApiEndpoint.replace('/api/v4/user', ''),
                userApiEndpoint: settings.UserApiEndpoint,
                authEndpoint: settings.AuthEndpoint,
                tokenEndpoint: settings.TokenEndpoint
            };
        }
    }, {
        key: 'changeType',
        value: function changeType(id, value) {
            var settings = {};
            var gitLabUrl = '';
            if (value === _constants2.default.GITLAB_SERVICE) {
                settings = this.config.GitLabSettings;
                gitLabUrl = settings.UserApiEndpoint.replace('/api/v4/user', '');
            } else if (value === _constants2.default.GOOGLE_SERVICE) {
                settings = this.config.GoogleSettings;
            } else if (value === _constants2.default.OFFICE365_SERVICE) {
                settings = this.config.Office365Settings;
            }

            this.setState({
                id: settings.Id,
                secret: settings.Secret,
                gitLabUrl: gitLabUrl,
                userApiEndpoint: settings.UserApiEndpoint,
                authEndpoint: settings.AuthEndpoint,
                tokenEndpoint: settings.TokenEndpoint
            });

            this.handleChange(id, value);
        }
    }, {
        key: 'renderTitle',
        value: function renderTitle() {
            return _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'admin.authentication.oauth',
                defaultMessage: 'OAuth 2.0'
            });
        }
    }, {
        key: 'renderGoogle',
        value: function renderGoogle() {
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_text_setting2.default, {
                    id: 'id',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.google.clientIdTitle',
                        defaultMessage: 'Client ID:'
                    }),
                    placeholder: Utils.localizeMessage('admin.google.clientIdExample', 'E.g.: "7602141235235-url0fhs1mayfasbmop5qlfns8dh4.apps.googleusercontent.com"'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.google.clientIdDescription',
                        defaultMessage: 'The Client ID you received when registering your application with Google.'
                    }),
                    value: this.state.id,
                    onChange: this.handleChange
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'secret',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.google.clientSecretTitle',
                        defaultMessage: 'Client Secret:'
                    }),
                    placeholder: Utils.localizeMessage('admin.google.clientSecretExample', 'E.g.: "H8sz0Az-dDs2p15-7QzD231"'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.google.clientSecretDescription',
                        defaultMessage: 'The Client Secret you received when registering your application with Google.'
                    }),
                    value: this.state.secret,
                    onChange: this.handleChange
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'userApiEndpoint',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.google.userTitle',
                        defaultMessage: 'User API Endpoint:'
                    }),
                    value: 'https://www.googleapis.com/plus/v1/people/me',
                    disabled: true
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'authEndpoint',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.google.authTitle',
                        defaultMessage: 'Auth Endpoint:'
                    }),
                    value: 'https://accounts.google.com/o/oauth2/v2/auth',
                    disabled: true
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'tokenEndpoint',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.google.tokenTitle',
                        defaultMessage: 'Token Endpoint:'
                    }),
                    value: 'https://www.googleapis.com/oauth2/v4/token',
                    disabled: true
                })
            );
        }
    }, {
        key: 'renderOffice365',
        value: function renderOffice365() {
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_text_setting2.default, {
                    id: 'id',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.office365.clientIdTitle',
                        defaultMessage: 'Application ID:'
                    }),
                    placeholder: Utils.localizeMessage('admin.office365.clientIdExample', 'E.g.: "adf3sfa2-ag3f-sn4n-ids0-sh1hdax192qq"'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.office365.clientIdDescription',
                        defaultMessage: 'The Application/Client ID you received when registering your application with Microsoft.'
                    }),
                    value: this.state.id,
                    onChange: this.handleChange
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'secret',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.office365.clientSecretTitle',
                        defaultMessage: 'Application Secret Password:'
                    }),
                    placeholder: Utils.localizeMessage('admin.office365.clientSecretExample', 'E.g.: "shAieM47sNBfgl20f8ci294"'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.office365.clientSecretDescription',
                        defaultMessage: 'The Application Secret Password you generated when registering your application with Microsoft.'
                    }),
                    value: this.state.secret,
                    onChange: this.handleChange
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'userApiEndpoint',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.office365.userTitle',
                        defaultMessage: 'User API Endpoint:'
                    }),
                    value: 'https://graph.microsoft.com/v1.0/me',
                    disabled: true
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'authEndpoint',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.office365.authTitle',
                        defaultMessage: 'Auth Endpoint:'
                    }),
                    value: 'https://login.microsoftonline.com/common/oauth2/v2.0/authorize',
                    disabled: true
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'tokenEndpoint',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.office365.tokenTitle',
                        defaultMessage: 'Token Endpoint:'
                    }),
                    value: 'https://login.microsoftonline.com/common/oauth2/v2.0/token',
                    disabled: true
                })
            );
        }
    }, {
        key: 'renderGitLab',
        value: function renderGitLab() {
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_text_setting2.default, {
                    id: 'id',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.gitlab.clientIdTitle',
                        defaultMessage: 'Application ID:'
                    }),
                    placeholder: Utils.localizeMessage('admin.gitlab.clientIdExample', 'E.g.: "jcuS8PuvcpGhpgHhlcpT1Mx42pnqMxQY"'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.gitlab.clientIdDescription',
                        defaultMessage: 'Obtain this value via the instructions above for logging into GitLab'
                    }),
                    value: this.state.id,
                    onChange: this.handleChange
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'secret',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.gitlab.clientSecretTitle',
                        defaultMessage: 'Application Secret Key:'
                    }),
                    placeholder: Utils.localizeMessage('admin.gitlab.clientSecretExample', 'E.g.: "jcuS8PuvcpGhpgHhlcpT1Mx42pnqMxQY"'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.gitlab.clientSecretDescription',
                        defaultMessage: 'Obtain this value via the instructions above for logging into GitLab.'
                    }),
                    value: this.state.secret,
                    onChange: this.handleChange
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'gitlabUrl',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.gitlab.siteUrl',
                        defaultMessage: 'GitLab Site URL:'
                    }),
                    placeholder: Utils.localizeMessage('admin.gitlab.siteUrlExample', 'E.g.: https://'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.gitlab.siteUrlDescription',
                        defaultMessage: 'Enter the URL of your GitLab instance, e.g. https://example.com:3000. If your GitLab instance is not set up with SSL, start the URL with http:// instead of https://.'
                    }),
                    value: this.state.gitLabUrl,
                    onChange: this.updateGitLabUrl
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'userApiEndpoint',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.gitlab.userTitle',
                        defaultMessage: 'User API Endpoint:'
                    }),
                    placeholder: '',
                    value: this.state.userApiEndpoint,
                    disabled: true
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'authEndpoint',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.gitlab.authTitle',
                        defaultMessage: 'Auth Endpoint:'
                    }),
                    placeholder: '',
                    value: this.state.authEndpoint,
                    disabled: true
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'tokenEndpoint',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.gitlab.tokenTitle',
                        defaultMessage: 'Token Endpoint:'
                    }),
                    placeholder: '',
                    value: this.state.tokenEndpoint,
                    disabled: true
                })
            );
        }
    }, {
        key: 'renderSettings',
        value: function renderSettings() {
            var contents = void 0;
            var helpText = void 0;
            if (this.state.oauthType === _constants2.default.GITLAB_SERVICE) {
                contents = this.renderGitLab();
                helpText = _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                    id: 'admin.gitlab.EnableHtmlDesc',
                    defaultMessage: '<ol><li>Log in to your GitLab account and go to Profile Settings -> Applications.</li><li>Enter Redirect URIs "<your-mattermost-url>/login/gitlab/complete" (example: http://localhost:8065/login/gitlab/complete) and "<your-mattermost-url>/signup/gitlab/complete". </li><li>Then use "Application Secret Key" and "Application ID" fields from GitLab to complete the options below.</li><li>Complete the Endpoint URLs below. </li></ol>'
                });
            } else if (this.state.oauthType === _constants2.default.GOOGLE_SERVICE) {
                contents = this.renderGoogle();
                helpText = _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                    id: 'admin.google.EnableHtmlDesc',
                    defaultMessage: '<ol><li><a target="_blank" href="https://accounts.google.com/login">Log in</a> to your Google account.</li><li>Go to <a target="_blank" href="https://console.developers.google.com">https://console.developers.google.com</a>, click <strong>Credentials</strong> in the left hand sidebar and enter "Mattermost - your-company-name" as the <strong>Project Name</strong>, then click <strong>Create</strong>.</li><li>Click the <strong>OAuth consent screen</strong> header and enter "Mattermost" as the <strong>Product name shown to users</strong>, then click <strong>Save</strong>.</li><li>Under the <strong>Credentials</strong> header, click <strong>Create credentials</strong>, choose <strong>OAuth client ID</strong> and select <strong>Web Application</strong>.</li><li>Under <strong>Restrictions</strong> and <strong>Authorized redirect URIs</strong> enter <strong>your-mattermost-url/signup/google/complete</strong> (example: http://localhost:8065/signup/google/complete). Click <strong>Create</strong>.</li><li>Paste the <strong>Client ID</strong> and <strong>Client Secret</strong> to the fields below, then click <strong>Save</strong>.</li><li>Finally, go to <a target="_blank" href="https://console.developers.google.com/apis/api/plus/overview">Google+ API</a> and click <strong>Enable</strong>. This might take a few minutes to propagate through Google`s systems.</li></ol>'
                });
            } else if (this.state.oauthType === _constants2.default.OFFICE365_SERVICE) {
                contents = this.renderOffice365();
                helpText = _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                    id: 'admin.office365.EnableHtmlDesc',
                    defaultMessage: '<ol><li><a target="_blank" href="https://login.microsoftonline.com/">Log in</a> to your Microsoft or Office 365 account. Make sure it`s the account on the same <a target="_blank" href="https://msdn.microsoft.com/en-us/library/azure/jj573650.aspx#Anchor_0">tenant</a> that you would like users to log in with.</li><li>Go to <a target="_blank" href="https://apps.dev.microsoft.com">https://apps.dev.microsoft.com</a>, click <strong>Go to app list</strong> > <strong>Add an app</strong> and use "Mattermost - your-company-name" as the <strong>Application Name</strong>.</li><li>Under <strong>Application Secrets</strong>, click <strong>Generate New Password</strong> and paste it to the <strong>Application Secret Password</strong> field below.</li><li>Under <strong>Platforms</strong>, click <strong>Add Platform</strong>, choose <strong>Web</strong> and enter <strong>your-mattermost-url/signup/office365/complete</strong> (example: http://localhost:8065/signup/office365/complete) under <strong>Redirect URIs</strong>. Also uncheck <strong>Allow Implicit Flow</strong>.</li><li>Finally, click <strong>Save</strong> and then paste the <strong>Application ID</strong> below.</li></ol>'
                });
            }

            var oauthTypes = [];
            oauthTypes.push({ value: 'off', text: Utils.localizeMessage('admin.oauth.off', 'Do not allow sign-in via an OAuth 2.0 provider.') });
            oauthTypes.push({ value: _constants2.default.GITLAB_SERVICE, text: Utils.localizeMessage('admin.oauth.gitlab', 'GitLab') });
            if (this.props.license.IsLicensed === 'true') {
                if (this.props.license.GoogleOAuth === 'true') {
                    oauthTypes.push({ value: _constants2.default.GOOGLE_SERVICE, text: Utils.localizeMessage('admin.oauth.google', 'Google Apps') });
                }
                if (this.props.license.Office365OAuth === 'true') {
                    oauthTypes.push({ value: _constants2.default.OFFICE365_SERVICE, text: Utils.localizeMessage('admin.oauth.office365', 'Office 365 (Beta)') });
                }
            }

            return _react2.default.createElement(
                _settings_group2.default,
                null,
                _react2.default.createElement(_dropdown_setting2.default, {
                    id: 'oauthType',
                    values: oauthTypes,
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.oauth.select',
                        defaultMessage: 'Select OAuth 2.0 Service Provider:'
                    }),
                    helpText: helpText,
                    value: this.state.oauthType,
                    onChange: this.changeType
                }),
                contents
            );
        }
    }]);
    return OAuthSettings;
}(_admin_settings2.default);

exports.default = OAuthSettings;

/***/ }),

/***/ 2599:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = __webpack_require__(172);

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _admin_settings = __webpack_require__(787);

var _admin_settings2 = _interopRequireDefault(_admin_settings);

var _setting = __webpack_require__(841);

var _setting2 = _interopRequireDefault(_setting);

var _settings_group = __webpack_require__(788);

var _settings_group2 = _interopRequireDefault(_settings_group);

var _text_setting = __webpack_require__(794);

var _text_setting2 = _interopRequireDefault(_text_setting);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var PasswordSettings = function (_AdminSettings) {
    (0, _inherits3.default)(PasswordSettings, _AdminSettings);

    function PasswordSettings(props) {
        (0, _classCallCheck3.default)(this, PasswordSettings);

        var _this = (0, _possibleConstructorReturn3.default)(this, (PasswordSettings.__proto__ || (0, _getPrototypeOf2.default)(PasswordSettings)).call(this, props));

        _this.getConfigFromState = _this.getConfigFromState.bind(_this);

        _this.renderSettings = _this.renderSettings.bind(_this);

        _this.getSampleErrorMsg = _this.getSampleErrorMsg.bind(_this);

        _this.handlePasswordLengthChange = _this.handlePasswordLengthChange.bind(_this);
        _this.handleCheckboxChange = _this.handleCheckboxChange.bind(_this);

        _this.state = (0, _assign2.default)(_this.state, {
            passwordMinimumLength: props.config.PasswordSettings.MinimumLength,
            passwordLowercase: props.config.PasswordSettings.Lowercase,
            passwordNumber: props.config.PasswordSettings.Number,
            passwordUppercase: props.config.PasswordSettings.Uppercase,
            passwordSymbol: props.config.PasswordSettings.Symbol,
            maximumLoginAttempts: props.config.ServiceSettings.MaximumLoginAttempts
        });

        // Update sample message from config settings
        _this.sampleErrorMsg = null;
        if (_this.props.license.IsLicensed === 'true' && _this.props.license.PasswordRequirements === 'true') {
            var sampleErrorMsgId = 'user.settings.security.passwordError';
            if (props.config.PasswordSettings.Lowercase) {
                sampleErrorMsgId += 'Lowercase';
            }
            if (props.config.PasswordSettings.Uppercase) {
                sampleErrorMsgId += 'Uppercase';
            }
            if (props.config.PasswordSettings.Number) {
                sampleErrorMsgId += 'Number';
            }
            if (props.config.PasswordSettings.Symbol) {
                sampleErrorMsgId += 'Symbol';
            }
            _this.sampleErrorMsg = _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: sampleErrorMsgId,
                'default': 'Your password must contain between {min} and {max} characters.',
                values: {
                    min: _this.state.passwordMinimumLength || _constants2.default.MIN_PASSWORD_LENGTH,
                    max: _constants2.default.MAX_PASSWORD_LENGTH
                }
            });
        }
        return _this;
    }

    (0, _createClass3.default)(PasswordSettings, [{
        key: 'getConfigFromState',
        value: function getConfigFromState(config) {
            if (this.props.license.IsLicensed === 'true' && this.props.license.PasswordRequirements === 'true') {
                config.PasswordSettings.MinimumLength = this.parseIntNonZero(this.state.passwordMinimumLength, _constants2.default.MIN_PASSWORD_LENGTH);
                config.PasswordSettings.Lowercase = this.refs.lowercase.checked;
                config.PasswordSettings.Uppercase = this.refs.uppercase.checked;
                config.PasswordSettings.Number = this.refs.number.checked;
                config.PasswordSettings.Symbol = this.refs.symbol.checked;
            }

            config.ServiceSettings.MaximumLoginAttempts = this.parseIntNonZero(this.state.maximumLoginAttempts);

            return config;
        }
    }, {
        key: 'getStateFromConfig',
        value: function getStateFromConfig(config) {
            return {
                passwordMinimumLength: config.PasswordSettings.MinimumLength,
                passwordLowercase: config.PasswordSettings.Lowercase,
                passwordNumber: config.PasswordSettings.Number,
                passwordUppercase: config.PasswordSettings.Uppercase,
                passwordSymbol: config.PasswordSettings.Symbol,
                maximumLoginAttempts: config.ServiceSettings.MaximumLoginAttempts
            };
        }
    }, {
        key: 'getSampleErrorMsg',
        value: function getSampleErrorMsg(minLength) {
            if (this.props.license.IsLicensed === 'true' && this.props.license.PasswordRequirements === 'true') {
                if (this.props.config.PasswordSettings.MinimumLength > _constants2.default.MAX_PASSWORD_LENGTH || this.props.config.PasswordSettings.MinimumLength < _constants2.default.MIN_PASSWORD_LENGTH) {
                    return _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'user.settings.security.passwordMinLength',
                        'default': 'Invalid minimum length, cannot show preview.'
                    });
                }
                var sampleErrorMsgId = 'user.settings.security.passwordError';
                if (this.refs.lowercase.checked) {
                    sampleErrorMsgId += 'Lowercase';
                }
                if (this.refs.uppercase.checked) {
                    sampleErrorMsgId += 'Uppercase';
                }
                if (this.refs.number.checked) {
                    sampleErrorMsgId += 'Number';
                }
                if (this.refs.symbol.checked) {
                    sampleErrorMsgId += 'Symbol';
                }
                return _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: sampleErrorMsgId,
                    'default': 'Your password must contain between {min} and {max} characters.',
                    values: {
                        min: minLength || _constants2.default.MIN_PASSWORD_LENGTH,
                        max: _constants2.default.MAX_PASSWORD_LENGTH
                    }
                });
            }

            return null;
        }
    }, {
        key: 'handlePasswordLengthChange',
        value: function handlePasswordLengthChange(id, value) {
            this.sampleErrorMsg = this.getSampleErrorMsg(value);
            this.handleChange(id, value);
        }
    }, {
        key: 'handleCheckboxChange',
        value: function handleCheckboxChange(id, value) {
            this.sampleErrorMsg = this.getSampleErrorMsg(this.state.passwordMinimumLength);
            this.handleChange(id, value);
        }
    }, {
        key: 'renderTitle',
        value: function renderTitle() {
            return _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'admin.security.password',
                defaultMessage: 'Password'
            });
        }
    }, {
        key: 'renderSettings',
        value: function renderSettings() {
            var passwordSettings = null;
            if (this.props.license.IsLicensed === 'true' && this.props.license.PasswordRequirements === 'true') {
                passwordSettings = _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(_text_setting2.default, {
                        id: 'passwordMinimumLength',
                        label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'admin.password.minimumLength',
                            defaultMessage: 'Minimum Password Length:'
                        }),
                        placeholder: Utils.localizeMessage('admin.password.minimumLengthExample', 'E.g.: "5"'),
                        helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'admin.password.minimumLengthDescription',
                            defaultMessage: 'Minimum number of characters required for a valid password. Must be a whole number greater than or equal to {min} and less than or equal to {max}.',
                            values: {
                                min: _constants2.default.MIN_PASSWORD_LENGTH,
                                max: _constants2.default.MAX_PASSWORD_LENGTH
                            }
                        }),
                        value: this.state.passwordMinimumLength,
                        onChange: this.handlePasswordLengthChange
                    }),
                    _react2.default.createElement(
                        _setting2.default,
                        {
                            label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'passwordRequirements',
                                defaultMessage: 'Password Requirements:'
                            })
                        },
                        _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(
                                'label',
                                { className: 'checkbox-inline' },
                                _react2.default.createElement('input', {
                                    type: 'checkbox',
                                    ref: 'lowercase',
                                    defaultChecked: this.state.passwordLowercase,
                                    name: 'admin.password.lowercase',
                                    onChange: this.handleCheckboxChange
                                }),
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'admin.password.lowercase',
                                    defaultMessage: 'At least one lowercase letter'
                                })
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(
                                'label',
                                { className: 'checkbox-inline' },
                                _react2.default.createElement('input', {
                                    type: 'checkbox',
                                    ref: 'uppercase',
                                    defaultChecked: this.state.passwordUppercase,
                                    name: 'admin.password.uppercase',
                                    onChange: this.handleCheckboxChange
                                }),
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'admin.password.uppercase',
                                    defaultMessage: 'At least one uppercase letter'
                                })
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(
                                'label',
                                { className: 'checkbox-inline' },
                                _react2.default.createElement('input', {
                                    type: 'checkbox',
                                    ref: 'number',
                                    defaultChecked: this.state.passwordNumber,
                                    name: 'admin.password.number',
                                    onChange: this.handleCheckboxChange
                                }),
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'admin.password.number',
                                    defaultMessage: 'At least one number'
                                })
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(
                                'label',
                                { className: 'checkbox-inline' },
                                _react2.default.createElement('input', {
                                    type: 'checkbox',
                                    ref: 'symbol',
                                    defaultChecked: this.state.passwordSymbol,
                                    name: 'admin.password.symbol',
                                    onChange: this.handleCheckboxChange
                                }),
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'admin.password.symbol',
                                    defaultMessage: 'At least one symbol (e.g. "~!@#$%^&*()")'
                                })
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement('br', null),
                            _react2.default.createElement(
                                'label',
                                null,
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'admin.password.preview',
                                    defaultMessage: 'Error message preview:'
                                })
                            ),
                            _react2.default.createElement('br', null),
                            this.sampleErrorMsg
                        )
                    )
                );
            }

            return _react2.default.createElement(
                _settings_group2.default,
                null,
                passwordSettings,
                _react2.default.createElement(_text_setting2.default, {
                    id: 'maximumLoginAttempts',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.service.attemptTitle',
                        defaultMessage: 'Maximum Login Attempts:'
                    }),
                    placeholder: Utils.localizeMessage('admin.service.attemptExample', 'E.g.: "10"'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.service.attemptDescription',
                        defaultMessage: 'Login attempts allowed before user is locked out and required to reset password via email.'
                    }),
                    value: this.state.maximumLoginAttempts,
                    onChange: this.handleChange
                })
            );
        }
    }]);
    return PasswordSettings;
}(_admin_settings2.default);

exports.default = PasswordSettings;

/***/ }),

/***/ 2600:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _admin_settings = __webpack_require__(787);

var _admin_settings2 = _interopRequireDefault(_admin_settings);

var _boolean_setting = __webpack_require__(800);

var _boolean_setting2 = _interopRequireDefault(_boolean_setting);

var _settings_group = __webpack_require__(788);

var _settings_group2 = _interopRequireDefault(_settings_group);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PluginSettings = function (_AdminSettings) {
    (0, _inherits3.default)(PluginSettings, _AdminSettings);

    function PluginSettings(props) {
        (0, _classCallCheck3.default)(this, PluginSettings);

        var _this = (0, _possibleConstructorReturn3.default)(this, (PluginSettings.__proto__ || (0, _getPrototypeOf2.default)(PluginSettings)).call(this, props));

        _this.getConfigFromState = _this.getConfigFromState.bind(_this);

        _this.renderSettings = _this.renderSettings.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(PluginSettings, [{
        key: 'getConfigFromState',
        value: function getConfigFromState(config) {
            config.PluginSettings.Enable = this.state.enablePlugins;

            return config;
        }
    }, {
        key: 'getStateFromConfig',
        value: function getStateFromConfig(config) {
            return {
                enablePlugins: config.PluginSettings.Enable
            };
        }
    }, {
        key: 'renderTitle',
        value: function renderTitle() {
            return _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'admin.plugins.settings.title',
                defaultMessage: 'Configuration'
            });
        }
    }, {
        key: 'renderSettings',
        value: function renderSettings() {
            return _react2.default.createElement(
                _settings_group2.default,
                null,
                _react2.default.createElement(_boolean_setting2.default, {
                    id: 'enablePlugins',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.plugins.settings.enable',
                        defaultMessage: 'Enable Plugins: '
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                        id: 'admin.plugins.settings.enableDesc',
                        defaultMessage: 'When true, enables plugins on your Mattermost server. Use plugins to integrate with third-party systems, extend functionality or customize the user interface of your Mattermost server. See <a href="https://about.mattermost.com/default-plugins" target="_blank">documentation</a> to learn more.'
                    }),
                    value: this.state.enablePlugins,
                    onChange: this.handleChange
                })
            );
        }
    }]);
    return PluginSettings;
}(_admin_settings2.default); // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = PluginSettings;

/***/ }),

/***/ 2601:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _reactRedux = __webpack_require__(268);

var _redux = __webpack_require__(1);

var _admin = __webpack_require__(855);

var _plugin_management = __webpack_require__(2602);

var _plugin_management2 = _interopRequireDefault(_plugin_management);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapStateToProps(state, ownProps) {
    return (0, _extends3.default)({}, ownProps, {
        plugins: state.entities.admin.plugins
    });
}

function mapDispatchToProps(dispatch) {
    return {
        actions: (0, _redux.bindActionCreators)({
            uploadPlugin: _admin.uploadPlugin,
            removePlugin: _admin.removePlugin,
            getPlugins: _admin.getPlugins,
            activatePlugin: _admin.activatePlugin,
            deactivatePlugin: _admin.deactivatePlugin
        }, dispatch)
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_plugin_management2.default);

/***/ }),

/***/ 2602:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _values = __webpack_require__(801);

var _values2 = _interopRequireDefault(_values);

var _regenerator = __webpack_require__(114);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(115);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _reactRouterDom = __webpack_require__(269);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _banner = __webpack_require__(1455);

var _banner2 = _interopRequireDefault(_banner);

var _loading_screen = __webpack_require__(792);

var _loading_screen2 = _interopRequireDefault(_loading_screen);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PluginManagement = function (_React$Component) {
    (0, _inherits3.default)(PluginManagement, _React$Component);

    function PluginManagement(props) {
        var _this2 = this;

        (0, _classCallCheck3.default)(this, PluginManagement);

        var _this = (0, _possibleConstructorReturn3.default)(this, (PluginManagement.__proto__ || (0, _getPrototypeOf2.default)(PluginManagement)).call(this, props));

        _this.handleChange = function () {
            var element = _this.refs.fileInput;
            if (element.files.length > 0) {
                _this.setState({ fileSelected: true, fileName: element.files[0].name });
            }
        };

        _this.handleSubmit = function () {
            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(e) {
                var element, file, _ref2, error;

                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                e.preventDefault();

                                element = _this.refs.fileInput;

                                if (!(element.files.length === 0)) {
                                    _context.next = 4;
                                    break;
                                }

                                return _context.abrupt('return');

                            case 4:
                                file = element.files[0];


                                _this.setState({ uploading: true });

                                _context.next = 8;
                                return _this.props.actions.uploadPlugin(file);

                            case 8:
                                _ref2 = _context.sent;
                                error = _ref2.error;

                                _this.setState({ fileSelected: false, fileName: null, uploading: false, serverError: null });
                                Utils.clearFileInput(element);

                                if (error) {
                                    if (error.server_error_id === 'app.plugin.activate.app_error') {
                                        _this.setState({ serverError: Utils.localizeMessage('admin.plugin.error.activate', 'Unable to upload the plugin. It may conflict with another plugin on your server.') });
                                    } else if (error.server_error_id === 'app.plugin.extract.app_error') {
                                        _this.setState({ serverError: Utils.localizeMessage('admin.plugin.error.extract', 'Encountered an error when extracting the plugin. Review your plugin file content and try again.') });
                                    } else {
                                        _this.setState({ serverError: error.message });
                                    }
                                }

                            case 13:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }));

            return function (_x) {
                return _ref.apply(this, arguments);
            };
        }();

        _this.handleRemove = function () {
            var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(e) {
                var pluginId, _ref4, error;

                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                e.preventDefault();
                                pluginId = e.currentTarget.getAttribute('data-plugin-id');

                                _this.setState({ removing: pluginId });

                                _context2.next = 5;
                                return _this.props.actions.removePlugin(pluginId);

                            case 5:
                                _ref4 = _context2.sent;
                                error = _ref4.error;

                                _this.setState({ removing: null });

                                if (error) {
                                    _this.setState({ serverError: error.message });
                                }

                            case 9:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }));

            return function (_x2) {
                return _ref3.apply(this, arguments);
            };
        }();

        _this.handleActivate = function () {
            var _ref5 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(e) {
                var pluginId, _ref6, error;

                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                e.preventDefault();
                                pluginId = e.currentTarget.getAttribute('data-plugin-id');

                                _this.setState({ activating: pluginId });

                                _context3.next = 5;
                                return _this.props.actions.activatePlugin(pluginId);

                            case 5:
                                _ref6 = _context3.sent;
                                error = _ref6.error;

                                _this.setState({ activating: null });

                                if (error) {
                                    _this.setState({ serverError: error.message });
                                }

                            case 9:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this2);
            }));

            return function (_x3) {
                return _ref5.apply(this, arguments);
            };
        }();

        _this.handleDeactivate = function () {
            var _ref7 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4(e) {
                var pluginId, _ref8, error;

                return _regenerator2.default.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                e.preventDefault();
                                pluginId = e.currentTarget.getAttribute('data-plugin-id');

                                _this.setState({ deactivating: pluginId });

                                _context4.next = 5;
                                return _this.props.actions.deactivatePlugin(pluginId);

                            case 5:
                                _ref8 = _context4.sent;
                                error = _ref8.error;

                                _this.setState({ deactivating: null });

                                if (error) {
                                    _this.setState({ serverError: error.message });
                                }

                            case 9:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this2);
            }));

            return function (_x4) {
                return _ref7.apply(this, arguments);
            };
        }();

        _this.buildPluginItem = function (p) {
            var activateButton = void 0;
            if (p.active) {
                var deactivating = _this.state.deactivating === p.id;
                activateButton = _react2.default.createElement(
                    'a',
                    {
                        'data-plugin-id': p.id,
                        disabled: deactivating,
                        onClick: _this.handleDeactivate
                    },
                    deactivating ? _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.plugin.deactivating',
                        defaultMessage: 'Deactivating...'
                    }) : _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.plugin.deactivate',
                        defaultMessage: 'Deactivate'
                    })
                );
            } else {
                var activating = _this.state.activating === p.id;
                activateButton = _react2.default.createElement(
                    'a',
                    {
                        'data-plugin-id': p.id,
                        disabled: activating,
                        onClick: _this.handleActivate
                    },
                    activating ? _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.plugin.activating',
                        defaultMessage: 'Activating...'
                    }) : _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.plugin.activate',
                        defaultMessage: 'Activate'
                    })
                );
            }

            var settingsButton = void 0;
            if (p.settings_schema) {
                settingsButton = _react2.default.createElement(
                    'span',
                    null,
                    ' - ',
                    _react2.default.createElement(
                        _reactRouterDom.Link,
                        {
                            to: '/admin_console/plugins/custom/' + p.id
                        },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'admin.plugin.settingsButton',
                            defaultMessage: 'Settings'
                        })
                    )
                );
            }

            var removeButton = void 0;
            if (!p.prepackaged) {
                var removeButtonText = void 0;
                if (_this.state.removing === p.id) {
                    removeButtonText = _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.plugin.removing',
                        defaultMessage: 'Removing...'
                    });
                } else {
                    removeButtonText = _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.plugin.remove',
                        defaultMessage: 'Remove'
                    });
                }
                removeButton = _react2.default.createElement(
                    'span',
                    null,
                    ' - ',
                    _react2.default.createElement(
                        'a',
                        {
                            'data-plugin-id': p.id,
                            disabled: _this.state.removing === p.id,
                            onClick: _this.handleRemove
                        },
                        removeButtonText
                    )
                );
            }

            var description = void 0;
            if (p.description) {
                description = _react2.default.createElement(
                    'div',
                    { className: 'padding-top' },
                    _react2.default.createElement(
                        'strong',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'admin.plugin.desc',
                            defaultMessage: 'Description:'
                        })
                    ),
                    ' ' + p.description
                );
            }

            var version = void 0;
            if (p.version) {
                version = _react2.default.createElement(
                    'span',
                    null,
                    ', ',
                    _react2.default.createElement(
                        'strong',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'admin.plugin.version',
                            defaultMessage: 'Version:'
                        })
                    ),
                    ' ' + p.version
                );
            }

            var id = _react2.default.createElement(
                'div',
                { className: 'padding-top' },
                _react2.default.createElement(
                    'strong',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.plugin.id',
                        defaultMessage: 'Id:'
                    })
                ),
                ' ' + p.id,
                version
            );

            var prepackagedLabel = void 0;
            if (p.prepackaged) {
                prepackagedLabel = _react2.default.createElement(
                    'span',
                    null,
                    ' - ',
                    _react2.default.createElement(
                        'strong',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'admin.plugin.prepackaged',
                            defaultMessage: 'Pre-packaged'
                        })
                    )
                );
            }

            return _react2.default.createElement(
                'div',
                { key: p.id },
                _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'strong',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'admin.plugin.name',
                            defaultMessage: 'Name:'
                        })
                    ),
                    ' ' + (p.name || ''),
                    prepackagedLabel
                ),
                description,
                id,
                _react2.default.createElement(
                    'div',
                    { className: 'padding-top' },
                    activateButton,
                    removeButton,
                    settingsButton
                ),
                _react2.default.createElement('hr', null)
            );
        };

        _this.state = {
            loading: true,
            fileSelected: false,
            fileName: null,
            serverError: null
        };
        return _this;
    }

    (0, _createClass3.default)(PluginManagement, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this3 = this;

            if (this.props.config.PluginSettings.Enable) {
                this.props.actions.getPlugins().then(function () {
                    return _this3.setState({ loading: false });
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            if (!this.props.config.PluginSettings.Enable) {
                return _react2.default.createElement(
                    'div',
                    { className: 'wrapper--fixed' },
                    _react2.default.createElement(
                        'h3',
                        { className: 'admin-console-header' },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'admin.plugin.management.title',
                            defaultMessage: 'Management'
                        })
                    ),
                    _react2.default.createElement(_banner2.default, {
                        title: _react2.default.createElement('div', null),
                        description: _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                            id: 'admin.plugin.management.banner',
                            defaultMessage: 'Plugins are disabled on your server. To enable them, go to <strong>Plugins > Configuration</strong>.'
                        })
                    })
                );
            }

            var serverError = '';
            if (this.state.serverError) {
                serverError = _react2.default.createElement(
                    'div',
                    { className: 'col-sm-12' },
                    _react2.default.createElement(
                        'div',
                        { className: 'form-group has-error half' },
                        _react2.default.createElement(
                            'label',
                            { className: 'control-label' },
                            this.state.serverError
                        )
                    )
                );
            }

            var btnClass = 'btn';
            if (this.state.fileSelected) {
                btnClass = 'btn btn-primary';
            }

            var fileName = void 0;
            if (this.state.fileName) {
                fileName = this.state.fileName;
            }

            var uploadButtonText = void 0;
            if (this.state.uploading) {
                uploadButtonText = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'admin.plugin.uploading',
                    defaultMessage: 'Uploading...'
                });
            } else {
                uploadButtonText = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'admin.plugin.upload',
                    defaultMessage: 'Upload'
                });
            }

            var pluginsList = void 0;
            var pluginsContainer = void 0;
            var plugins = (0, _values2.default)(this.props.plugins);
            if (this.state.loading) {
                pluginsList = _react2.default.createElement(_loading_screen2.default, null);
            } else if (plugins.length === 0) {
                pluginsContainer = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'admin.plugin.no_plugins',
                    defaultMessage: 'No installed plugins.'
                });
            } else {
                pluginsList = plugins.map(this.buildPluginItem);

                pluginsContainer = _react2.default.createElement(
                    'div',
                    { className: 'alert alert-transparent' },
                    pluginsList
                );
            }

            var enableUploads = this.props.config.PluginSettings.EnableUploads;
            var uploadHelpText = void 0;
            if (enableUploads) {
                uploadHelpText = _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                    id: 'admin.plugin.uploadDesc',
                    defaultMessage: 'Upload a plugin for your Mattermost server. See <a href="https://about.mattermost.com/default-plugin-uploads" target="_blank">documentation</a> to learn more.'
                });
            } else {
                uploadHelpText = _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                    id: 'admin.plugin.uploadDisabledDesc',
                    defaultMessage: 'To enable plugin uploads, go to <strong>Plugins > Configuration</strong>. See <a href="https://about.mattermost.com/default-plugin-uploads" target="_blank">documentation</a> to learn more.'
                });
            }

            var uploadBtnClass = enableUploads ? 'btn btn-primary' : 'btn';

            return _react2.default.createElement(
                'div',
                { className: 'wrapper--fixed' },
                _react2.default.createElement(
                    'h3',
                    { className: 'admin-console-header' },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.plugin.management.title',
                        defaultMessage: 'Management'
                    })
                ),
                _react2.default.createElement(
                    'form',
                    {
                        className: 'form-horizontal',
                        role: 'form'
                    },
                    _react2.default.createElement(
                        'div',
                        { className: 'form-group' },
                        _react2.default.createElement(
                            'label',
                            {
                                className: 'control-label col-sm-4'
                            },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'admin.plugin.uploadTitle',
                                defaultMessage: 'Upload Plugin: '
                            })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-8' },
                            _react2.default.createElement(
                                'div',
                                { className: 'file__upload' },
                                _react2.default.createElement(
                                    'button',
                                    {
                                        className: uploadBtnClass,
                                        disabled: !enableUploads
                                    },
                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'admin.plugin.choose',
                                        defaultMessage: 'Choose File'
                                    })
                                ),
                                _react2.default.createElement('input', {
                                    ref: 'fileInput',
                                    type: 'file',
                                    accept: '.gz',
                                    onChange: this.handleChange,
                                    disabled: !enableUploads
                                })
                            ),
                            _react2.default.createElement(
                                'button',
                                {
                                    className: btnClass,
                                    disabled: !this.state.fileSelected,
                                    onClick: this.handleSubmit
                                },
                                uploadButtonText
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'help-text no-margin' },
                                fileName
                            ),
                            serverError,
                            _react2.default.createElement(
                                'p',
                                { className: 'help-text' },
                                uploadHelpText
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'form-group' },
                        _react2.default.createElement(
                            'label',
                            {
                                className: 'control-label col-sm-4'
                            },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'admin.plugin.installedTitle',
                                defaultMessage: 'Installed Plugins: '
                            })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-8' },
                            _react2.default.createElement(
                                'p',
                                { className: 'help-text' },
                                _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                                    id: 'admin.plugin.installedDesc',
                                    defaultMessage: 'Installed plugins on your Mattermost server. Pre-packaged plugins are installed by default, and can be deactivated but not removed.'
                                })
                            ),
                            _react2.default.createElement('br', null),
                            pluginsContainer
                        )
                    )
                )
            );
        }
    }]);
    return PluginManagement;
}(_react2.default.Component); // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

PluginManagement.propTypes = {

    /*
     * The config
     */
    config: _propTypes2.default.object.isRequired,

    /*
     * Plugins object with ids as keys and manifests as values
     */
    plugins: _propTypes2.default.object.isRequired,

    actions: _propTypes2.default.shape({

        /*
         * Function to upload a plugin
         */
        uploadPlugin: _propTypes2.default.func.isRequired,

        /*
         * Function to remove a plugin
         */
        removePlugin: _propTypes2.default.func.isRequired,

        /*
         * Function to get installed plugins
         */
        getPlugins: _propTypes2.default.func.isRequired,

        /*
         * Function to get installed plugins
         */
        activatePlugin: _propTypes2.default.func.isRequired,

        /*
         * Function to get installed plugins
         */
        deactivatePlugin: _propTypes2.default.func.isRequired
    }).isRequired
};
exports.default = PluginManagement;

/***/ }),

/***/ 2603:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _reactRedux = __webpack_require__(268);

var _custom_plugin_settings = __webpack_require__(2604);

var _custom_plugin_settings2 = _interopRequireDefault(_custom_plugin_settings);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapStateToProps(state, ownProps) {
    var pluginId = ownProps.match.params.plugin_id;
    var plugin = state.entities.admin.plugins[pluginId];
    var settings = plugin && plugin.settings_schema && plugin.settings_schema.settings && plugin.settings_schema.settings.map(function (setting) {
        return (0, _extends3.default)({}, setting, { label: setting.display_name });
    });
    var translate = plugin && plugin.translate || false;
    return {
        schema: plugin ? (0, _extends3.default)({}, plugin.settings_schema, { id: plugin.id, name: plugin.name, settings: settings, translate: translate }) : null
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_custom_plugin_settings2.default);

/***/ }),

/***/ 2604:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _schema_admin_settings = __webpack_require__(1456);

var _schema_admin_settings2 = _interopRequireDefault(_schema_admin_settings);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CustomPluginSettings = function (_SchemaAdminSettings) {
    (0, _inherits3.default)(CustomPluginSettings, _SchemaAdminSettings);

    function CustomPluginSettings() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, CustomPluginSettings);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CustomPluginSettings.__proto__ || (0, _getPrototypeOf2.default)(CustomPluginSettings)).call.apply(_ref, [this].concat(args))), _this), _this.componentWillReceiveProps = function (nextProps) {
            if (nextProps.schema !== _this.props.schema) {
                _this.setState(_this.getStateFromConfig(nextProps.config, nextProps.schema));
            }
        }, _this.getConfigFromState = function (config) {
            var schema = _this.props.schema;

            if (schema) {
                if (!config.PluginSettings.Plugins[schema.id]) {
                    config.PluginSettings.Plugins[schema.id] = {};
                }

                var configSettings = config.PluginSettings.Plugins[schema.id];

                var settings = schema.settings || [];
                settings.forEach(function (setting) {
                    var lowerKey = setting.key.toLowerCase();
                    configSettings[lowerKey] = _this.state[lowerKey];
                });
            }

            return config;
        }, _this.getStateFromConfig = function (config) {
            var schema = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.props.schema;

            var state = {};

            if (schema) {
                var configSettings = config.PluginSettings.Plugins[schema.id] || {};

                var settings = schema.settings || [];
                settings.forEach(function (setting) {
                    var lowerKey = setting.key.toLowerCase();
                    state[lowerKey] = configSettings[lowerKey] == null ? setting.default : configSettings[lowerKey];
                });
            }

            return state;
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    return CustomPluginSettings;
}(_schema_admin_settings2.default); // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = CustomPluginSettings;

/***/ }),

/***/ 2605:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactSelect = __webpack_require__(1333);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _form_error = __webpack_require__(822);

var _form_error2 = _interopRequireDefault(_form_error);

var _setting = __webpack_require__(841);

var _setting2 = _interopRequireDefault(_setting);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MultiSelectSetting = function (_React$Component) {
    (0, _inherits3.default)(MultiSelectSetting, _React$Component);

    function MultiSelectSetting(props) {
        (0, _classCallCheck3.default)(this, MultiSelectSetting);

        var _this = (0, _possibleConstructorReturn3.default)(this, (MultiSelectSetting.__proto__ || (0, _getPrototypeOf2.default)(MultiSelectSetting)).call(this, props));

        _this.handleChange = _this.handleChange.bind(_this);
        _this.state = { error: false };
        return _this;
    }

    (0, _createClass3.default)(MultiSelectSetting, [{
        key: 'handleChange',
        value: function handleChange(newValue) {
            var values = newValue.map(function (n) {
                return n.value;
            });

            if (this.props.selected.length > 0 && this.props.mustBePresent && values.join(',').indexOf(this.props.mustBePresent) === -1) {
                this.setState({ error: this.props.notPresent });
            } else {
                this.props.onChange(this.props.id, values);
                this.setState({ error: false });
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(newProps) {
            if (newProps.selected.length > 0 && newProps.mustBePresent && newProps.selected.join(',').indexOf(newProps.mustBePresent) === -1) {
                this.setState({ error: this.props.notPresent });
            } else {
                this.setState({ error: false });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                _setting2.default,
                {
                    label: this.props.label,
                    inputId: this.props.id,
                    helpText: this.props.helpText
                },
                _react2.default.createElement(_reactSelect2.default, {
                    id: this.props.id,
                    multi: true,
                    labelKey: 'text',
                    options: this.props.values,
                    joinValues: true,
                    clearable: false,
                    disabled: this.props.disabled,
                    noResultsText: this.props.noResultText,
                    onChange: this.handleChange,
                    value: this.props.selected
                }),
                _react2.default.createElement(_form_error2.default, { error: this.state.error })
            );
        }
    }]);
    return MultiSelectSetting;
}(_react2.default.Component); // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = MultiSelectSetting;


MultiSelectSetting.defaultProps = {
    disabled: false
};

MultiSelectSetting.propTypes = {
    id: _propTypes2.default.string.isRequired,
    values: _propTypes2.default.array.isRequired,
    label: _propTypes2.default.node.isRequired,
    selected: _propTypes2.default.array.isRequired,
    mustBePresent: _propTypes2.default.string,
    onChange: _propTypes2.default.func.isRequired,
    disabled: _propTypes2.default.bool,
    helpText: _propTypes2.default.node,
    noResultText: _propTypes2.default.node,
    errorText: _propTypes2.default.node,
    notPresent: _propTypes2.default.node
};

/***/ }),

/***/ 2606:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = __webpack_require__(172);

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _client = __webpack_require__(270);

var _app_dispatcher = __webpack_require__(791);

var _app_dispatcher2 = _interopRequireDefault(_app_dispatcher);

var _user_actions = __webpack_require__(781);

var _constants = __webpack_require__(29);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _setting = __webpack_require__(841);

var _setting2 = _interopRequireDefault(_setting);

var _provider = __webpack_require__(866);

var _provider2 = _interopRequireDefault(_provider);

var _suggestion = __webpack_require__(848);

var _suggestion2 = _interopRequireDefault(_suggestion);

var _suggestion_box = __webpack_require__(929);

var _suggestion_box2 = _interopRequireDefault(_suggestion_box);

var _suggestion_list = __webpack_require__(930);

var _suggestion_list2 = _interopRequireDefault(_suggestion_list);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var UserSuggestion = function (_Suggestion) {
    (0, _inherits3.default)(UserSuggestion, _Suggestion);

    function UserSuggestion() {
        (0, _classCallCheck3.default)(this, UserSuggestion);
        return (0, _possibleConstructorReturn3.default)(this, (UserSuggestion.__proto__ || (0, _getPrototypeOf2.default)(UserSuggestion)).apply(this, arguments));
    }

    (0, _createClass3.default)(UserSuggestion, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                item = _props.item,
                isSelection = _props.isSelection;


            var className = 'suggestion-list__item mentions__name';
            if (isSelection) {
                className += ' suggestion--selected';
            }

            var username = item.username;
            var description = '';

            if ((item.first_name || item.last_name) && item.nickname) {
                description = '- ' + Utils.getFullName(item) + ' (' + item.nickname + ')';
            } else if (item.nickname) {
                description = '- (' + item.nickname + ')';
            } else if (item.first_name || item.last_name) {
                description = '- ' + Utils.getFullName(item);
            }

            return _react2.default.createElement(
                'div',
                {
                    className: className,
                    onClick: this.handleClick
                },
                _react2.default.createElement(
                    'div',
                    { className: 'pull-left' },
                    _react2.default.createElement('img', {
                        className: 'admin-setting-user__image',
                        src: _client.Client4.getUsersRoute() + '/' + item.id + '/image?_=' + (item.last_picture_update || 0)
                    })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'pull-left admin-setting-user--align' },
                    _react2.default.createElement(
                        'span',
                        null,
                        '@' + username
                    ),
                    _react2.default.createElement(
                        'span',
                        { className: 'admin-setting-user__fullname' },
                        ' ',
                        description
                    )
                )
            );
        }
    }]);
    return UserSuggestion;
}(_suggestion2.default);

var UserProvider = function (_Provider) {
    (0, _inherits3.default)(UserProvider, _Provider);

    function UserProvider() {
        (0, _classCallCheck3.default)(this, UserProvider);
        return (0, _possibleConstructorReturn3.default)(this, (UserProvider.__proto__ || (0, _getPrototypeOf2.default)(UserProvider)).apply(this, arguments));
    }

    (0, _createClass3.default)(UserProvider, [{
        key: 'handlePretextChanged',
        value: function handlePretextChanged(suggestionId, pretext) {
            var _this3 = this;

            var normalizedPretext = pretext.toLowerCase();
            this.startNewRequest(suggestionId, normalizedPretext);

            (0, _user_actions.autocompleteUsersInTeam)(normalizedPretext, function (data) {
                if (_this3.shouldCancelDispatch(normalizedPretext)) {
                    return;
                }

                var users = (0, _assign2.default)([], data.users);

                _app_dispatcher2.default.handleServerAction({
                    type: _constants.ActionTypes.SUGGESTION_RECEIVED_SUGGESTIONS,
                    id: suggestionId,
                    matchedPretext: normalizedPretext,
                    terms: users.map(function (user) {
                        return user.username;
                    }),
                    items: users,
                    component: UserSuggestion
                });
            });

            return true;
        }
    }]);
    return UserProvider;
}(_provider2.default);

var UserAutocompleteSetting = function (_React$Component) {
    (0, _inherits3.default)(UserAutocompleteSetting, _React$Component);
    (0, _createClass3.default)(UserAutocompleteSetting, null, [{
        key: 'propTypes',
        get: function get() {
            return {
                id: _propTypes2.default.string.isRequired,
                label: _propTypes2.default.node.isRequired,
                placeholder: _propTypes2.default.string,
                helpText: _propTypes2.default.node,
                value: _propTypes2.default.string,
                onChange: _propTypes2.default.func,
                disabled: _propTypes2.default.bool
            };
        }
    }]);

    function UserAutocompleteSetting(props) {
        (0, _classCallCheck3.default)(this, UserAutocompleteSetting);

        var _this4 = (0, _possibleConstructorReturn3.default)(this, (UserAutocompleteSetting.__proto__ || (0, _getPrototypeOf2.default)(UserAutocompleteSetting)).call(this, props));

        _this4.handleChange = function (e) {
            _this4.props.onChange(_this4.props.id, e.target.value);
        };

        _this4.handleUserSelected = function (user) {
            _this4.props.onChange(_this4.props.id, user.username);
        };

        _this4.userSuggestionProviders = [new UserProvider()];
        return _this4;
    }

    (0, _createClass3.default)(UserAutocompleteSetting, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                _setting2.default,
                {
                    label: this.props.label,
                    helpText: this.props.helpText,
                    inputId: this.props.id
                },
                _react2.default.createElement(
                    'div',
                    {
                        className: 'admin-setting-user__dropdown'
                    },
                    _react2.default.createElement(_suggestion_box2.default, {
                        id: 'admin_user_setting_' + this.props.id,
                        className: 'form-control',
                        placeholder: this.props.placeholder,
                        value: this.props.value,
                        onChange: this.handleChange,
                        onItemSelected: this.handleUserSelected,
                        listComponent: _suggestion_list2.default,
                        listStyle: 'bottom',
                        providers: this.userSuggestionProviders,
                        disabled: this.props.disabled,
                        requiredCharacters: 0,
                        openOnFocus: true
                    })
                )
            );
        }
    }]);
    return UserAutocompleteSetting;
}(_react2.default.Component);

exports.default = UserAutocompleteSetting;

/***/ }),

/***/ 2607:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _redux = __webpack_require__(1);

var _roles = __webpack_require__(860);

var _roles2 = __webpack_require__(276);

var _policy_settings = __webpack_require__(2608);

var _policy_settings2 = _interopRequireDefault(_policy_settings);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state) {
    return {
        roles: (0, _roles2.getRoles)(state)
    };
} // Copyright (c) 2018-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapDispatchToProps(dispatch) {
    return {
        actions: (0, _redux.bindActionCreators)({
            loadRolesIfNeeded: _roles.loadRolesIfNeeded,
            editRole: _roles.editRole
        }, dispatch)
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_policy_settings2.default);

/***/ }),

/***/ 2608:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PolicySettings = undefined;

var _slicedToArray2 = __webpack_require__(845);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = __webpack_require__(1457);

var _entries2 = _interopRequireDefault(_entries);

var _stringify = __webpack_require__(275);

var _stringify2 = _interopRequireDefault(_stringify);

var _regenerator = __webpack_require__(114);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _values = __webpack_require__(801);

var _values2 = _interopRequireDefault(_values);

var _promise = __webpack_require__(283);

var _promise2 = _interopRequireDefault(_promise);

var _asyncToGenerator2 = __webpack_require__(115);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _defineProperty2 = __webpack_require__(277);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = __webpack_require__(44);

var _extends4 = _interopRequireDefault(_extends3);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(761);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _admin_actions = __webpack_require__(797);

var _admin_settings = __webpack_require__(787);

var _admin_settings2 = _interopRequireDefault(_admin_settings);

var _boolean_setting = __webpack_require__(800);

var _boolean_setting2 = _interopRequireDefault(_boolean_setting);

var _color_setting = __webpack_require__(2609);

var _color_setting2 = _interopRequireDefault(_color_setting);

var _dropdown_setting = __webpack_require__(842);

var _dropdown_setting2 = _interopRequireDefault(_dropdown_setting);

var _post_edit_setting = __webpack_require__(2610);

var _post_edit_setting2 = _interopRequireDefault(_post_edit_setting);

var _radio_setting = __webpack_require__(1098);

var _radio_setting2 = _interopRequireDefault(_radio_setting);

var _settings_group = __webpack_require__(788);

var _settings_group2 = _interopRequireDefault(_settings_group);

var _text_setting = __webpack_require__(794);

var _text_setting2 = _interopRequireDefault(_text_setting);

var _policy_roles_adapter = __webpack_require__(1099);

var _loading_screen = __webpack_require__(792);

var _loading_screen2 = _interopRequireDefault(_loading_screen);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var PolicySettings = exports.PolicySettings = function (_AdminSettings) {
    (0, _inherits3.default)(PolicySettings, _AdminSettings);

    function PolicySettings(props) {
        var _this2 = this;

        (0, _classCallCheck3.default)(this, PolicySettings);

        var _this = (0, _possibleConstructorReturn3.default)(this, (PolicySettings.__proto__ || (0, _getPrototypeOf2.default)(PolicySettings)).call(this, props));

        _this.handleChange = function (id, value) {
            var _this$setState;

            _this.setState((_this$setState = {
                saveNeeded: true
            }, (0, _defineProperty3.default)(_this$setState, id, value), (0, _defineProperty3.default)(_this$setState, 'edited', (0, _extends4.default)({}, _this.state.edited, (0, _defineProperty3.default)({}, id, _this.props.intl.formatMessage({ id: 'admin.field_names.' + id, defaultMessage: id })))), _this$setState));

            _this.props.setNavigationBlocked(true);
        };

        _this.handleSubmit = function () {
            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(e) {
                var stateForAdapter, updatedRoles, success, configFieldEdited;
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                e.preventDefault();

                                _this.setState({
                                    saving: true,
                                    serverError: null
                                });

                                stateForAdapter = (0, _extends4.default)({}, _this.state);

                                if (_this.state.allowEditPost === _constants2.default.ALLOW_EDIT_POST_TIME_LIMIT) {
                                    stateForAdapter.allowEditPost = _constants2.default.ALLOW_EDIT_POST_ALWAYS;
                                } else {
                                    // Clear the value if it's not being used in combination with the radio
                                    // post time limit radio button. Clearing this is required to derive the
                                    // correct policy.
                                    _this.setState({ postEditTimeLimit: null });
                                }

                                updatedRoles = (0, _policy_roles_adapter.rolesFromMapping)(stateForAdapter, _this.props.roles);
                                success = true;
                                _context2.next = 8;
                                return _promise2.default.all((0, _values2.default)(updatedRoles).map(function () {
                                    var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(item) {
                                        return _regenerator2.default.wrap(function _callee$(_context) {
                                            while (1) {
                                                switch (_context.prev = _context.next) {
                                                    case 0:
                                                        _context.prev = 0;
                                                        _context.next = 3;
                                                        return _this.props.actions.editRole(item);

                                                    case 3:
                                                        _context.next = 9;
                                                        break;

                                                    case 5:
                                                        _context.prev = 5;
                                                        _context.t0 = _context['catch'](0);

                                                        success = false;
                                                        _this.setState({
                                                            saving: false,
                                                            serverError: _context.t0.message
                                                        });

                                                    case 9:
                                                    case 'end':
                                                        return _context.stop();
                                                }
                                            }
                                        }, _callee, _this2, [[0, 5]]);
                                    }));

                                    return function (_x2) {
                                        return _ref2.apply(this, arguments);
                                    };
                                }()));

                            case 8:

                                if (success) {
                                    configFieldEdited = _this.state.edited.postEditTimeLimit || _this.state.edited.enableBanner || _this.state.edited.bannerText || _this.state.edited.bannerColor || _this.state.edited.bannerTextColor || _this.state.edited.allowBannerDismissal;


                                    if (configFieldEdited) {
                                        _this.doSubmit(function () {
                                            if (!_this.state.serverError) {
                                                _this.setState({ edited: {} });
                                            }
                                        });
                                    } else {
                                        _this.setState({
                                            saving: false,
                                            saveNeeded: false,
                                            serverError: null,
                                            edited: {}
                                        });
                                        _this.props.setNavigationBlocked(false);
                                    }
                                }

                            case 9:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }));

            return function (_x) {
                return _ref.apply(this, arguments);
            };
        }();

        _this.doSubmit = function (callback) {
            _this.setState({
                saving: true,
                serverError: null
            });

            // clone config so that we aren't modifying data in the stores
            var config = JSON.parse((0, _stringify2.default)(_this.props.config));
            config = _this.getConfigFromState(config);

            (0, _admin_actions.saveConfig)(config, function (savedConfig) {
                _this.setState(_this.getStateFromConfig(savedConfig));

                _this.setState({
                    saveNeeded: false,
                    saving: false
                });

                _this.props.setNavigationBlocked(false);

                if (callback) {
                    callback();
                }

                if (_this.handleSaved) {
                    _this.handleSaved(config);
                }
            }, function (err) {
                var errMessage = err.message;
                if (err.id === 'ent.cluster.save_config.error') {
                    errMessage = _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'ent.cluster.save_config_with_roles.error',
                        defaultMessage: 'The following configuration settings cannot be saved when High Availability is enabled and the System Console is in read-only mode: {keys}.',
                        values: {
                            keys: [_this.state.edited.postEditTimeLimit, _this.state.edited.enableBanner, _this.state.edited.bannerText, _this.state.edited.bannerColor, _this.state.edited.bannerTextColor, _this.state.edited.AllowBannerDismissal].filter(function (v) {
                                return v;
                            }).join(', ')
                        }
                    });
                }

                _this.setState({
                    saving: false,
                    serverError: errMessage
                });

                if (callback) {
                    callback();
                }

                if (_this.handleSaved) {
                    _this.handleSaved(config);
                }
            });
        };

        _this.getConfigFromState = function (config) {
            config.ServiceSettings.PostEditTimeLimit = _this.state.postEditTimeLimit ? _this.parseIntNonZero(_this.state.postEditTimeLimit, _constants2.default.UNSET_POST_EDIT_TIME_LIMIT) : _constants2.default.UNSET_POST_EDIT_TIME_LIMIT;
            config.AnnouncementSettings.EnableBanner = _this.state.enableBanner;
            config.AnnouncementSettings.BannerText = _this.state.bannerText;
            config.AnnouncementSettings.BannerColor = _this.state.bannerColor;
            config.AnnouncementSettings.BannerTextColor = _this.state.bannerTextColor;
            config.AnnouncementSettings.AllowBannerDismissal = _this.state.allowBannerDismissal;
            return config;
        };

        _this.renderSettings = function () {
            if (!_this.state.loaded) {
                return _react2.default.createElement(_loading_screen2.default, null);
            }
            return _react2.default.createElement(
                _settings_group2.default,
                null,
                _react2.default.createElement(_dropdown_setting2.default, {
                    id: 'restrictTeamInvite',
                    values: [{ value: _constants2.default.PERMISSIONS_ALL, text: Utils.localizeMessage('admin.general.policy.permissionsAll', 'All team members') }, { value: _constants2.default.PERMISSIONS_TEAM_ADMIN, text: Utils.localizeMessage('admin.general.policy.permissionsAdmin', 'Team and System Admins') }, { value: _constants2.default.PERMISSIONS_SYSTEM_ADMIN, text: Utils.localizeMessage('admin.general.policy.permissionsSystemAdmin', 'System Admins') }],
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.general.policy.teamInviteTitle',
                        defaultMessage: 'Enable sending team invites from:'
                    }),
                    value: _this.state.restrictTeamInvite,
                    onChange: _this.handleChange,
                    helpText: _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                        id: 'admin.general.policy.teamInviteDescription',
                        defaultMessage: 'Set policy on who can invite others to a team using <b>Send Email Invite</b> to invite new users by email, or the <b>Get Team Invite Link</b> and <b>Add Members to Team</b> options from the Main Menu. If <b>Get Team Invite Link</b> is used to share a link, you can expire the invite code from <b>Team Settings</b> > <b>Invite Code</b> after the desired users join the team.'
                    })
                }),
                _react2.default.createElement(_dropdown_setting2.default, {
                    id: 'restrictPublicChannelCreation',
                    values: [{ value: _constants2.default.PERMISSIONS_ALL, text: Utils.localizeMessage('admin.general.policy.permissionsAll', 'All team members') }, { value: _constants2.default.PERMISSIONS_TEAM_ADMIN, text: Utils.localizeMessage('admin.general.policy.permissionsAdmin', 'Team and System Admins') }, { value: _constants2.default.PERMISSIONS_SYSTEM_ADMIN, text: Utils.localizeMessage('admin.general.policy.permissionsSystemAdmin', 'System Admins') }],
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.general.policy.restrictPublicChannelCreationTitle',
                        defaultMessage: 'Enable public channel creation for:'
                    }),
                    value: _this.state.restrictPublicChannelCreation,
                    onChange: _this.handleChange,
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.general.policy.restrictPublicChannelCreationDescription',
                        defaultMessage: 'Set policy on who can create public channels.'
                    })
                }),
                _react2.default.createElement(_dropdown_setting2.default, {
                    id: 'restrictPublicChannelManagement',
                    values: [{ value: _constants2.default.PERMISSIONS_ALL, text: Utils.localizeMessage('admin.general.policy.permissionsAllChannel', 'All channel members') }, { value: _constants2.default.PERMISSIONS_CHANNEL_ADMIN, text: Utils.localizeMessage('admin.general.policy.permissionsChannelAdmin', 'Channel, Team and System Admins') }, { value: _constants2.default.PERMISSIONS_TEAM_ADMIN, text: Utils.localizeMessage('admin.general.policy.permissionsAdmin', 'Team and System Admins') }, { value: _constants2.default.PERMISSIONS_SYSTEM_ADMIN, text: Utils.localizeMessage('admin.general.policy.permissionsSystemAdmin', 'System Admins') }],
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.general.policy.restrictPublicChannelManagementTitle',
                        defaultMessage: 'Enable public channel renaming for:'
                    }),
                    value: _this.state.restrictPublicChannelManagement,
                    onChange: _this.handleChange,
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.general.policy.restrictPublicChannelManagementDescription',
                        defaultMessage: 'Set policy on who can rename and set the header or purpose for public channels.'
                    })
                }),
                _react2.default.createElement(_dropdown_setting2.default, {
                    id: 'restrictPublicChannelDeletion',
                    values: [{ value: _constants2.default.PERMISSIONS_ALL, text: Utils.localizeMessage('admin.general.policy.permissionsAllChannel', 'All channel members') }, { value: _constants2.default.PERMISSIONS_CHANNEL_ADMIN, text: Utils.localizeMessage('admin.general.policy.permissionsChannelAdmin', 'Channel, Team and System Admins') }, { value: _constants2.default.PERMISSIONS_TEAM_ADMIN, text: Utils.localizeMessage('admin.general.policy.permissionsAdmin', 'Team and System Admins') }, { value: _constants2.default.PERMISSIONS_SYSTEM_ADMIN, text: Utils.localizeMessage('admin.general.policy.permissionsSystemAdmin', 'System Admins') }],
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.general.policy.restrictPublicChannelDeletionTitle',
                        defaultMessage: 'Enable public channel deletion for:'
                    }),
                    value: _this.state.restrictPublicChannelDeletion,
                    onChange: _this.handleChange,
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.general.policy.restrictPublicChannelDeletionDescription',
                        defaultMessage: 'Set policy on who can delete public channels. Deleted channels can be recovered from the database using a {commandLineToolLink}.',
                        values: {
                            commandLineToolLink: _react2.default.createElement(
                                'a',
                                {
                                    href: 'https://docs.mattermost.com/administration/command-line-tools.html',
                                    target: '_blank',
                                    rel: 'noopener noreferrer'
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'admin.general.policy.restrictPublicChannelDeletionCommandLineToolLink',
                                    defaultMessage: 'command line tool'
                                })
                            )
                        }
                    })
                }),
                _react2.default.createElement(_dropdown_setting2.default, {
                    id: 'restrictPrivateChannelCreation',
                    values: [{ value: _constants2.default.PERMISSIONS_ALL, text: Utils.localizeMessage('admin.general.policy.permissionsAll', 'All team members') }, { value: _constants2.default.PERMISSIONS_TEAM_ADMIN, text: Utils.localizeMessage('admin.general.policy.permissionsAdmin', 'Team and System Admins') }, { value: _constants2.default.PERMISSIONS_SYSTEM_ADMIN, text: Utils.localizeMessage('admin.general.policy.permissionsSystemAdmin', 'System Admins') }],
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.general.policy.restrictPrivateChannelCreationTitle',
                        defaultMessage: 'Enable private channel creation for:'
                    }),
                    value: _this.state.restrictPrivateChannelCreation,
                    onChange: _this.handleChange,
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.general.policy.restrictPrivateChannelCreationDescription',
                        defaultMessage: 'Set policy on who can create private channels.'
                    })
                }),
                _react2.default.createElement(_dropdown_setting2.default, {
                    id: 'restrictPrivateChannelManagement',
                    values: [{ value: _constants2.default.PERMISSIONS_ALL, text: Utils.localizeMessage('admin.general.policy.permissionsAllChannel', 'All channel members') }, { value: _constants2.default.PERMISSIONS_CHANNEL_ADMIN, text: Utils.localizeMessage('admin.general.policy.permissionsChannelAdmin', 'Channel, Team and System Admins') }, { value: _constants2.default.PERMISSIONS_TEAM_ADMIN, text: Utils.localizeMessage('admin.general.policy.permissionsAdmin', 'Team and System Admins') }, { value: _constants2.default.PERMISSIONS_SYSTEM_ADMIN, text: Utils.localizeMessage('admin.general.policy.permissionsSystemAdmin', 'System Admins') }],
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.general.policy.restrictPrivateChannelManagementTitle',
                        defaultMessage: 'Enable private channel renaming for:'
                    }),
                    value: _this.state.restrictPrivateChannelManagement,
                    onChange: _this.handleChange,
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.general.policy.restrictPrivateChannelManagementDescription',
                        defaultMessage: 'Set policy on who can rename and set the header or purpose for private channels.'
                    })
                }),
                _react2.default.createElement(_dropdown_setting2.default, {
                    id: 'restrictPrivateChannelManageMembers',
                    values: [{ value: _constants2.default.PERMISSIONS_ALL, text: Utils.localizeMessage('admin.general.policy.permissionsAllChannel', 'All channel members') }, { value: _constants2.default.PERMISSIONS_CHANNEL_ADMIN, text: Utils.localizeMessage('admin.general.policy.permissionsChannelAdmin', 'Channel, Team and System Admins') }, { value: _constants2.default.PERMISSIONS_TEAM_ADMIN, text: Utils.localizeMessage('admin.general.policy.permissionsAdmin', 'Team and System Admins') }, { value: _constants2.default.PERMISSIONS_SYSTEM_ADMIN, text: Utils.localizeMessage('admin.general.policy.permissionsSystemAdmin', 'System Admins') }],
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.general.policy.restrictPrivateChannelManageMembersTitle',
                        defaultMessage: 'Enable managing of private group members for:'
                    }),
                    value: _this.state.restrictPrivateChannelManageMembers,
                    onChange: _this.handleChange,
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.general.policy.restrictPrivateChannelManageMembersDescription',
                        defaultMessage: 'Set policy on who can add and remove members from private groups.'
                    })
                }),
                _react2.default.createElement(_dropdown_setting2.default, {
                    id: 'restrictPrivateChannelDeletion',
                    values: [{ value: _constants2.default.PERMISSIONS_ALL, text: Utils.localizeMessage('admin.general.policy.permissionsAllChannel', 'All channel members') }, { value: _constants2.default.PERMISSIONS_CHANNEL_ADMIN, text: Utils.localizeMessage('admin.general.policy.permissionsChannelAdmin', 'Channel, Team and System Admins') }, { value: _constants2.default.PERMISSIONS_TEAM_ADMIN, text: Utils.localizeMessage('admin.general.policy.permissionsAdmin', 'Team and System Admins') }, { value: _constants2.default.PERMISSIONS_SYSTEM_ADMIN, text: Utils.localizeMessage('admin.general.policy.permissionsSystemAdmin', 'System Admins') }],
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.general.policy.restrictPrivateChannelDeletionTitle',
                        defaultMessage: 'Enable private channel deletion for:'
                    }),
                    value: _this.state.restrictPrivateChannelDeletion,
                    onChange: _this.handleChange,
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.general.policy.restrictPrivateChannelDeletionDescription',
                        defaultMessage: 'Set policy on who can delete private channels. Deleted channels can be recovered from the database using a {commandLineToolLink}.',
                        values: {
                            commandLineToolLink: _react2.default.createElement(
                                'a',
                                {
                                    href: 'https://docs.mattermost.com/administration/command-line-tools.html',
                                    target: '_blank',
                                    rel: 'noopener noreferrer'
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'admin.general.policy.restrictPrivateChannelDeletionCommandLineToolLink',
                                    defaultMessage: 'command line tool'
                                })
                            )
                        }
                    })
                }),
                _react2.default.createElement(_radio_setting2.default, {
                    id: 'restrictPostDelete',
                    values: [{ value: _constants2.default.PERMISSIONS_DELETE_POST_ALL, text: Utils.localizeMessage('admin.general.policy.permissionsDeletePostAll', 'Message authors can delete their own messages, and Administrators can delete any message') }, { value: _constants2.default.PERMISSIONS_DELETE_POST_TEAM_ADMIN, text: Utils.localizeMessage('admin.general.policy.permissionsDeletePostAdmin', 'Team Admins and System Admins') }, { value: _constants2.default.PERMISSIONS_DELETE_POST_SYSTEM_ADMIN, text: Utils.localizeMessage('admin.general.policy.permissionsDeletePostSystemAdmin', 'System Admins') }],
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.general.policy.restrictPostDeleteTitle',
                        defaultMessage: 'Allow which users to delete messages:'
                    }),
                    value: _this.state.restrictPostDelete,
                    onChange: _this.handleChange,
                    helpText: _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                        id: 'admin.general.policy.restrictPostDeleteDescription',
                        defaultMessage: 'Set policy on who has permission to delete messages.'
                    })
                }),
                _react2.default.createElement(_post_edit_setting2.default, {
                    id: 'allowEditPost',
                    timeLimitId: 'postEditTimeLimit',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.general.policy.allowEditPostTitle',
                        defaultMessage: 'Allow users to edit their messages:'
                    }),
                    value: _this.state.allowEditPost,
                    timeLimitValue: _this.state.postEditTimeLimit,
                    onChange: _this.handleChange,
                    helpText: _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                        id: 'admin.general.policy.allowEditPostDescription',
                        defaultMessage: 'Set policy on the length of time authors have to edit their messages after posting.'
                    })
                }),
                _react2.default.createElement(_boolean_setting2.default, {
                    id: 'enableBanner',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.general.policy.enableBannerTitle',
                        defaultMessage: 'Enable Announcement Banner:'
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.general.policy.enableBannerDesc',
                        defaultMessage: 'Enable an announcement banner across all teams.'
                    }),
                    value: _this.state.enableBanner,
                    onChange: _this.handleChange
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'bannerText',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.general.policy.bannerTextTitle',
                        defaultMessage: 'Banner Text:'
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.general.policy.bannerTextDesc',
                        defaultMessage: 'Text that will appear in the announcement banner.'
                    }),
                    value: _this.state.bannerText,
                    onChange: _this.handleChange,
                    disabled: !_this.state.enableBanner
                }),
                _react2.default.createElement(_color_setting2.default, {
                    id: 'bannerColor',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.general.policy.bannerColorTitle',
                        defaultMessage: 'Banner Color:'
                    }),
                    value: _this.state.bannerColor,
                    onChange: _this.handleChange,
                    disabled: !_this.state.enableBanner
                }),
                _react2.default.createElement(_color_setting2.default, {
                    id: 'bannerTextColor',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.general.policy.bannerTextColorTitle',
                        defaultMessage: 'Banner Text Color:'
                    }),
                    value: _this.state.bannerTextColor,
                    onChange: _this.handleChange,
                    disabled: !_this.state.enableBanner
                }),
                _react2.default.createElement(_boolean_setting2.default, {
                    id: 'allowBannerDismissal',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.general.policy.allowBannerDismissalTitle',
                        defaultMessage: 'Allow Banner Dismissal:'
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.general.policy.allowBannerDismissalDesc',
                        defaultMessage: 'When true, users can dismiss the banner until its next update. When false, the banner is permanently visible until it is turned off by the System Admin.'
                    }),
                    value: _this.state.allowBannerDismissal,
                    onChange: _this.handleChange,
                    disabled: !_this.state.enableBanner
                })
            );
        };

        _this.roleBasedPolicies = {
            allowEditPost: '',
            restrictPostDelete: '',
            restrictTeamInvite: '',
            restrictPublicChannelCreation: '',
            restrictPrivateChannelCreation: '',
            restrictPublicChannelManagement: '',
            restrictPrivateChannelManagement: '',
            restrictPublicChannelDeletion: '',
            restrictPrivateChannelDeletion: '',
            restrictPrivateChannelManageMembers: ''
        };

        _this.state = (0, _extends4.default)({}, _this.state, _this.roleBasedPolicies, {
            loaded: false,
            edited: {}
        });
        return _this;
    }

    (0, _createClass3.default)(PolicySettings, [{
        key: 'loadPoliciesIntoState',
        value: function loadPoliciesIntoState(props) {
            var _this3 = this;

            var roles = props.roles;


            (0, _entries2.default)(this.roleBasedPolicies).forEach(function (_ref3) {
                var _ref4 = (0, _slicedToArray3.default)(_ref3, 1),
                    key = _ref4[0];

                _this3.roleBasedPolicies[key] = (0, _policy_roles_adapter.mappingValueFromRoles)(key, roles);
            });

            // Adjustment to allowEditPost policy because the roles mapping is the same for 'always' and 'time_limit'
            if (this.roleBasedPolicies.allowEditPost === _constants2.default.ALLOW_EDIT_POST_ALWAYS && this.state.postEditTimeLimit) {
                this.roleBasedPolicies.allowEditPost = _constants2.default.ALLOW_EDIT_POST_TIME_LIMIT;
            }

            this.setState((0, _extends4.default)({}, this.roleBasedPolicies, { loaded: true }));
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.props.actions.loadRolesIfNeeded(['channel_user', 'team_user', 'channel_admin', 'team_admin', 'system_admin']);
            if (this.props.roles.system_user && this.props.roles.system_admin && this.props.roles.team_user && this.props.roles.team_admin && this.props.roles.channel_user && this.props.roles.channel_admin) {
                this.loadPoliciesIntoState(this.props);
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (!this.state.loaded && nextProps.roles.system_user && nextProps.roles.system_admin && nextProps.roles.team_user && nextProps.roles.team_admin && nextProps.roles.channel_user && nextProps.roles.channel_admin) {
                this.loadPoliciesIntoState(nextProps);
            }
        }
    }, {
        key: 'getStateFromConfig',
        value: function getStateFromConfig(config) {
            return {
                postEditTimeLimit: config.ServiceSettings.PostEditTimeLimit === _constants2.default.UNSET_POST_EDIT_TIME_LIMIT ? null : config.ServiceSettings.PostEditTimeLimit,
                enableBanner: config.AnnouncementSettings.EnableBanner,
                bannerText: config.AnnouncementSettings.BannerText,
                bannerColor: config.AnnouncementSettings.BannerColor,
                bannerTextColor: config.AnnouncementSettings.BannerTextColor,
                allowBannerDismissal: config.AnnouncementSettings.AllowBannerDismissal
            };
        }
    }, {
        key: 'renderTitle',
        value: function renderTitle() {
            return _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'admin.general.policy',
                defaultMessage: 'Policy'
            });
        }
    }]);
    return PolicySettings;
}(_admin_settings2.default);

PolicySettings.propTypes = {
    intl: _reactIntl.intlShape.isRequired,
    roles: _propTypes2.default.object.isRequired,
    actions: _propTypes2.default.shape({
        loadRolesIfNeeded: _propTypes2.default.func.isRequired,
        editRole: _propTypes2.default.func.isRequired
    }).isRequired
};
exports.default = (0, _reactIntl.injectIntl)(PolicySettings);

/***/ }),

/***/ 2609:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactColor = __webpack_require__(1368);

var _setting = __webpack_require__(841);

var _setting2 = _interopRequireDefault(_setting);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var ColorSetting = function (_React$PureComponent) {
    (0, _inherits3.default)(ColorSetting, _React$PureComponent);

    function ColorSetting(props) {
        (0, _classCallCheck3.default)(this, ColorSetting);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ColorSetting.__proto__ || (0, _getPrototypeOf2.default)(ColorSetting)).call(this, props));

        _this.handleChange = function (color) {
            _this.props.onChange(_this.props.id, color.hex);
        };

        _this.togglePicker = function () {
            if (_this.props.disabled) {
                _this.setState({ showPicker: false });
            }
            _this.setState({ showPicker: !_this.state.showPicker });
        };

        _this.closePicker = function (e) {
            if (!e.target.closest('.picker-' + _this.props.id)) {
                _this.setState({ showPicker: false });
            }
        };

        _this.onTextInput = function (e) {
            _this.props.onChange(_this.props.id, e.target.value);
        };

        _this.state = {
            showPicker: false
        };
        return _this;
    }

    (0, _createClass3.default)(ColorSetting, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            document.addEventListener('click', this.closePicker);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            document.removeEventListener('click', this.closePicker);
        }
    }, {
        key: 'render',
        value: function render() {
            var picker = void 0;
            if (this.state.showPicker) {
                picker = _react2.default.createElement(
                    'div',
                    { className: 'color-picker__popover picker-' + this.props.id },
                    _react2.default.createElement(_reactColor.ChromePicker, {
                        color: this.props.value,
                        onChange: this.handleChange
                    })
                );
            }

            return _react2.default.createElement(
                _setting2.default,
                {
                    label: this.props.label,
                    helpText: this.props.helpText,
                    inputId: this.props.id
                },
                _react2.default.createElement(
                    'div',
                    { className: 'input-group color-picker colorpicker-element' },
                    _react2.default.createElement('input', {
                        type: 'text',
                        className: 'form-control',
                        value: this.props.value,
                        onChange: this.onTextInput,
                        disabled: this.props.disabled
                    }),
                    _react2.default.createElement(
                        'span',
                        {
                            className: 'input-group-addon picker-' + this.props.id,
                            onClick: this.togglePicker
                        },
                        _react2.default.createElement('i', { style: { backgroundColor: this.props.value } })
                    ),
                    picker
                )
            );
        }
    }]);
    return ColorSetting;
}(_react2.default.PureComponent);

ColorSetting.propTypes = {

    /*
     * The unique identifer for the admin console setting
     */
    id: _propTypes2.default.string.isRequired,

    /*
     * The text/jsx display name for the setting
     */
    label: _propTypes2.default.node.isRequired,

    /*
     * The text/jsx help text to display underneath the setting
     */
    helpText: _propTypes2.default.node,

    /*
     * The hex color value
     */
    value: _propTypes2.default.string.isRequired,

    /*
     * Function called when the input changes
     */
    onChange: _propTypes2.default.func,

    /*
     * Set to disable the setting
     */
    disabled: _propTypes2.default.bool
};
exports.default = ColorSetting;

/***/ }),

/***/ 2610:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _setting = __webpack_require__(841);

var _setting2 = _interopRequireDefault(_setting);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PostEditSetting = function (_React$Component) {
    (0, _inherits3.default)(PostEditSetting, _React$Component);

    function PostEditSetting(props) {
        (0, _classCallCheck3.default)(this, PostEditSetting);

        var _this = (0, _possibleConstructorReturn3.default)(this, (PostEditSetting.__proto__ || (0, _getPrototypeOf2.default)(PostEditSetting)).call(this, props));

        _this.handleChange = _this.handleChange.bind(_this);
        _this.handleTimeLimitChange = _this.handleTimeLimitChange.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(PostEditSetting, [{
        key: 'handleChange',
        value: function handleChange(e) {
            this.props.onChange(this.props.id, e.target.value);
        }
    }, {
        key: 'handleTimeLimitChange',
        value: function handleTimeLimitChange(e) {
            this.props.onChange(this.props.timeLimitId, e.target.value);
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                _setting2.default,
                {
                    label: this.props.label,
                    inputId: this.props.id,
                    helpText: this.props.helpText
                },
                _react2.default.createElement(
                    'div',
                    { className: 'radio' },
                    _react2.default.createElement(
                        'label',
                        null,
                        _react2.default.createElement('input', {
                            type: 'radio',
                            value: _constants2.default.ALLOW_EDIT_POST_ALWAYS,
                            name: this.props.id,
                            checked: this.props.value === _constants2.default.ALLOW_EDIT_POST_ALWAYS,
                            onChange: this.handleChange,
                            disabled: this.props.disabled
                        }),
                        Utils.localizeMessage('admin.general.policy.allowEditPostAlways', 'Any time')
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'radio' },
                    _react2.default.createElement(
                        'label',
                        null,
                        _react2.default.createElement('input', {
                            type: 'radio',
                            value: _constants2.default.ALLOW_EDIT_POST_NEVER,
                            name: this.props.id,
                            checked: this.props.value === _constants2.default.ALLOW_EDIT_POST_NEVER,
                            onChange: this.handleChange,
                            disabled: this.props.disabled
                        }),
                        Utils.localizeMessage('admin.general.policy.allowEditPostNever', 'Never')
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'radio form-inline' },
                    _react2.default.createElement(
                        'label',
                        null,
                        _react2.default.createElement('input', {
                            type: 'radio',
                            value: _constants2.default.ALLOW_EDIT_POST_TIME_LIMIT,
                            name: this.props.id,
                            checked: this.props.value === _constants2.default.ALLOW_EDIT_POST_TIME_LIMIT,
                            onChange: this.handleChange,
                            disabled: this.props.disabled
                        }),
                        _react2.default.createElement('input', {
                            type: 'text',
                            value: this.props.timeLimitValue || '',
                            className: 'form-control',
                            name: this.props.timeLimitId,
                            onChange: this.handleTimeLimitChange,
                            disabled: this.props.disabled || this.props.value !== _constants2.default.ALLOW_EDIT_POST_TIME_LIMIT
                        }),
                        _react2.default.createElement(
                            'span',
                            null,
                            ' ',
                            Utils.localizeMessage('admin.general.policy.allowEditPostTimeLimit', 'seconds after posting')
                        )
                    )
                )
            );
        }
    }]);
    return PostEditSetting;
}(_react2.default.Component); // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = PostEditSetting;


PostEditSetting.defaultProps = {
    isDisabled: false
};

PostEditSetting.propTypes = {
    id: _propTypes2.default.string.isRequired,
    timeLimitId: _propTypes2.default.string.isRequired,
    label: _propTypes2.default.node.isRequired,
    value: _propTypes2.default.string.isRequired,
    timeLimitValue: _propTypes2.default.number,
    onChange: _propTypes2.default.func.isRequired,
    disabled: _propTypes2.default.bool,
    helpText: _propTypes2.default.node
};

/***/ }),

/***/ 2611:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _redux = __webpack_require__(1);

var _roles = __webpack_require__(860);

var _roles2 = __webpack_require__(276);

var _custom_integrations_settings = __webpack_require__(2612);

var _custom_integrations_settings2 = _interopRequireDefault(_custom_integrations_settings);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state) {
    return {
        roles: (0, _roles2.getRoles)(state)
    };
} // Copyright (c) 2018-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapDispatchToProps(dispatch) {
    return {
        actions: (0, _redux.bindActionCreators)({
            loadRolesIfNeeded: _roles.loadRolesIfNeeded,
            editRole: _roles.editRole
        }, dispatch)
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_custom_integrations_settings2.default);

/***/ }),

/***/ 2612:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.WebhookSettings = undefined;

var _stringify = __webpack_require__(275);

var _stringify2 = _interopRequireDefault(_stringify);

var _regenerator = __webpack_require__(114);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _values = __webpack_require__(801);

var _values2 = _interopRequireDefault(_values);

var _promise = __webpack_require__(283);

var _promise2 = _interopRequireDefault(_promise);

var _asyncToGenerator2 = __webpack_require__(115);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _defineProperty2 = __webpack_require__(277);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = __webpack_require__(44);

var _extends4 = _interopRequireDefault(_extends3);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _policy_roles_adapter = __webpack_require__(1099);

var _admin_actions = __webpack_require__(797);

var _admin_settings = __webpack_require__(787);

var _admin_settings2 = _interopRequireDefault(_admin_settings);

var _boolean_setting = __webpack_require__(800);

var _boolean_setting2 = _interopRequireDefault(_boolean_setting);

var _settings_group = __webpack_require__(788);

var _settings_group2 = _interopRequireDefault(_settings_group);

var _loading_screen = __webpack_require__(792);

var _loading_screen2 = _interopRequireDefault(_loading_screen);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WebhookSettings = exports.WebhookSettings = function (_AdminSettings) {
    (0, _inherits3.default)(WebhookSettings, _AdminSettings);

    function WebhookSettings(props) {
        var _this2 = this;

        (0, _classCallCheck3.default)(this, WebhookSettings);

        var _this = (0, _possibleConstructorReturn3.default)(this, (WebhookSettings.__proto__ || (0, _getPrototypeOf2.default)(WebhookSettings)).call(this, props));

        _this.handleChange = function (id, value) {
            var _this$setState;

            _this.setState((_this$setState = {
                saveNeeded: true
            }, (0, _defineProperty3.default)(_this$setState, id, value), (0, _defineProperty3.default)(_this$setState, 'edited', (0, _extends4.default)({}, _this.state.edited, (0, _defineProperty3.default)({}, id, _this.props.intl.formatMessage({ id: 'admin.field_names.' + id, defaultMessage: id })))), _this$setState));

            _this.props.setNavigationBlocked(true);
        };

        _this.handleSubmit = function () {
            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(e) {
                var updatedRoles, success, configFieldEdited;
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                e.preventDefault();

                                _this.setState({
                                    saving: true,
                                    serverError: null
                                });

                                // Purposely converting enableOnlyAdminIntegrations value from boolean to string 'true' or 'false'
                                // so that it can be used as a key in the policy roles adapter mapping.
                                updatedRoles = (0, _policy_roles_adapter.rolesFromMapping)({ enableOnlyAdminIntegrations: _this.state.enableOnlyAdminIntegrations.toString() }, _this.props.roles);
                                success = true;
                                _context2.next = 6;
                                return _promise2.default.all((0, _values2.default)(updatedRoles).map(function () {
                                    var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(item) {
                                        return _regenerator2.default.wrap(function _callee$(_context) {
                                            while (1) {
                                                switch (_context.prev = _context.next) {
                                                    case 0:
                                                        _context.prev = 0;
                                                        _context.next = 3;
                                                        return _this.props.actions.editRole(item);

                                                    case 3:
                                                        _context.next = 9;
                                                        break;

                                                    case 5:
                                                        _context.prev = 5;
                                                        _context.t0 = _context['catch'](0);

                                                        success = false;
                                                        _this.setState({
                                                            saving: false,
                                                            serverError: _context.t0.message
                                                        });

                                                    case 9:
                                                    case 'end':
                                                        return _context.stop();
                                                }
                                            }
                                        }, _callee, _this2, [[0, 5]]);
                                    }));

                                    return function (_x2) {
                                        return _ref2.apply(this, arguments);
                                    };
                                }()));

                            case 6:

                                if (success) {
                                    configFieldEdited = _this.state.edited.enableIncomingWebhooks || _this.state.edited.enableOutgoingWebhooks || _this.state.edited.enableCommands || _this.state.edited.enablePostUsernameOverride || _this.state.edited.enablePostIconOverride || _this.state.edited.enableOAuthServiceProvider || _this.state.edited.enableUserAccessTokens;

                                    if (configFieldEdited) {
                                        _this.doSubmit(function () {
                                            if (!_this.state.serverError) {
                                                _this.setState({ edited: {} });
                                            }
                                        });
                                    } else {
                                        _this.setState({
                                            saving: false,
                                            saveNeeded: false,
                                            serverError: null,
                                            edited: {}
                                        });
                                        _this.props.setNavigationBlocked(false);
                                    }
                                }

                            case 7:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }));

            return function (_x) {
                return _ref.apply(this, arguments);
            };
        }();

        _this.doSubmit = function (callback) {
            _this.setState({
                saving: true,
                serverError: null
            });

            // clone config so that we aren't modifying data in the stores
            var config = JSON.parse((0, _stringify2.default)(_this.props.config));
            config = _this.getConfigFromState(config);

            (0, _admin_actions.saveConfig)(config, function (savedConfig) {
                _this.setState(_this.getStateFromConfig(savedConfig));

                _this.setState({
                    saveNeeded: false,
                    saving: false
                });

                _this.props.setNavigationBlocked(false);

                if (callback) {
                    callback();
                }

                if (_this.handleSaved) {
                    _this.handleSaved(config);
                }
            }, function (err) {
                var errMessage = err.message;
                if (err.id === 'ent.cluster.save_config.error') {
                    errMessage = _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'ent.cluster.save_config_with_roles.error',
                        defaultMessage: 'The following configuration settings cannot be saved when High Availability is enabled and the System Console is in read-only mode: {keys}.',
                        values: {
                            keys: [_this.state.edited.enableIncomingWebhooks, _this.state.edited.enableOutgoingWebhooks, _this.state.edited.enableCommands, _this.state.edited.enablePostUsernameOverride, _this.state.edited.enablePostIconOverride, _this.state.edited.enableOAuthServiceProvider, _this.state.edited.enableUserAccessTokens].filter(function (v) {
                                return v;
                            }).join(', ')
                        }
                    });
                }

                _this.setState({
                    saving: false,
                    serverError: errMessage
                });

                if (callback) {
                    callback();
                }

                if (_this.handleSaved) {
                    _this.handleSaved(config);
                }
            });
        };

        _this.getConfigFromState = function (config) {
            config.ServiceSettings.EnableIncomingWebhooks = _this.state.enableIncomingWebhooks;
            config.ServiceSettings.EnableOutgoingWebhooks = _this.state.enableOutgoingWebhooks;
            config.ServiceSettings.EnableCommands = _this.state.enableCommands;
            config.ServiceSettings.EnablePostUsernameOverride = _this.state.enablePostUsernameOverride;
            config.ServiceSettings.EnablePostIconOverride = _this.state.enablePostIconOverride;
            config.ServiceSettings.EnableOAuthServiceProvider = _this.state.enableOAuthServiceProvider;
            config.ServiceSettings.EnableUserAccessTokens = _this.state.enableUserAccessTokens;

            return config;
        };

        _this.renderSettings = function () {
            if (!_this.state.loaded) {
                return _react2.default.createElement(_loading_screen2.default, null);
            }
            return _react2.default.createElement(
                _settings_group2.default,
                null,
                _react2.default.createElement(_boolean_setting2.default, {
                    id: 'enableIncomingWebhooks',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.service.webhooksTitle',
                        defaultMessage: 'Enable Incoming Webhooks: '
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                        id: 'admin.service.webhooksDescription',
                        defaultMessage: 'When true, incoming webhooks will be allowed. To help combat phishing attacks, all posts from webhooks will be labelled by a BOT tag. See <a href="http://docs.mattermost.com/developer/webhooks-incoming.html" target="_blank">documentation</a> to learn more.'
                    }),
                    value: _this.state.enableIncomingWebhooks,
                    onChange: _this.handleChange
                }),
                _react2.default.createElement(_boolean_setting2.default, {
                    id: 'enableOutgoingWebhooks',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.service.outWebhooksTitle',
                        defaultMessage: 'Enable Outgoing Webhooks: '
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                        id: 'admin.service.outWebhooksDesc',
                        defaultMessage: 'When true, outgoing webhooks will be allowed. See <a href="http://docs.mattermost.com/developer/webhooks-outgoing.html" target="_blank">documentation</a> to learn more.'
                    }),
                    value: _this.state.enableOutgoingWebhooks,
                    onChange: _this.handleChange
                }),
                _react2.default.createElement(_boolean_setting2.default, {
                    id: 'enableCommands',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.service.cmdsTitle',
                        defaultMessage: 'Enable Custom Slash Commands: '
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                        id: 'admin.service.cmdsDesc',
                        defaultMessage: 'When true, custom slash commands will be allowed. See <a href="http://docs.mattermost.com/developer/slash-commands.html" target="_blank">documentation</a> to learn more.'
                    }),
                    value: _this.state.enableCommands,
                    onChange: _this.handleChange
                }),
                _react2.default.createElement(_boolean_setting2.default, {
                    id: 'enableOAuthServiceProvider',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.oauth.providerTitle',
                        defaultMessage: 'Enable OAuth 2.0 Service Provider: '
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                        id: 'admin.oauth.providerDescription',
                        defaultMessage: 'When true, Mattermost can act as an OAuth 2.0 service provider allowing Mattermost to authorize API requests from external applications. See <a href="https://docs.mattermost.com/developer/oauth-2-0-applications.html" target="_blank">documentation</a> to learn more.'
                    }),
                    value: _this.state.enableOAuthServiceProvider,
                    onChange: _this.handleChange
                }),
                _react2.default.createElement(_boolean_setting2.default, {
                    id: 'enableOnlyAdminIntegrations',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.service.integrationAdmin',
                        defaultMessage: 'Restrict managing integrations to Admins:'
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.service.integrationAdminDesc',
                        defaultMessage: 'When true, webhooks and slash commands can only be created, edited and viewed by Team and System Admins, and OAuth 2.0 applications by System Admins. Integrations are available to all users after they have been created by the Admin.'
                    }),
                    value: _this.state.enableOnlyAdminIntegrations,
                    onChange: _this.handleChange
                }),
                _react2.default.createElement(_boolean_setting2.default, {
                    id: 'enablePostUsernameOverride',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.service.overrideTitle',
                        defaultMessage: 'Enable integrations to override usernames:'
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                        id: 'admin.service.overrideDescription',
                        defaultMessage: 'When true, webhooks, slash commands and other integrations, such as <a href="https://docs.mattermost.com/integrations/zapier.html" target="_blank">Zapier</a>, will be allowed to change the username they are posting as. Note: Combined with allowing integrations to override profile picture icons, users may be able to perform phishing attacks by attempting to impersonate other users.'
                    }),
                    value: _this.state.enablePostUsernameOverride,
                    onChange: _this.handleChange
                }),
                _react2.default.createElement(_boolean_setting2.default, {
                    id: 'enablePostIconOverride',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.service.iconTitle',
                        defaultMessage: 'Enable integrations to override profile picture icons:'
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                        id: 'admin.service.iconDescription',
                        defaultMessage: 'When true, webhooks, slash commands and other integrations, such as <a href="https://docs.mattermost.com/integrations/zapier.html" target="_blank">Zapier</a>, will be allowed to change the profile picture they post with. Note: Combined with allowing integrations to override usernames, users may be able to perform phishing attacks by attempting to impersonate other users.'
                    }),
                    value: _this.state.enablePostIconOverride,
                    onChange: _this.handleChange
                }),
                _react2.default.createElement(_boolean_setting2.default, {
                    id: 'enableUserAccessTokens',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.service.userAccessTokensTitle',
                        defaultMessage: 'Enable User Access Tokens: '
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                        id: 'admin.service.userAccessTokensDescription',
                        defaultMessage: 'When true, users can create <a href="https://about.mattermost.com/default-user-access-tokens" target="_blank">user access tokens</a> for integrations in <strong>Account Settings > Security</strong>. They can be used to authenticate against the API and give full access to the account.<br/><br/>To manage who can create personal access tokens or to search users by token ID, go to the <strong>System Console > Users</strong> page.'
                    }),
                    value: _this.state.enableUserAccessTokens,
                    onChange: _this.handleChange
                })
            );
        };

        _this.state = (0, _extends4.default)({}, _this.state, { // Brings the state in from the parent class.
            enableOnlyAdminIntegrations: null,
            loaded: false,
            edited: {}
        });
        return _this;
    }

    (0, _createClass3.default)(WebhookSettings, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.props.actions.loadRolesIfNeeded(['team_user', 'system_user']);
            if (this.props.roles.system_user && this.props.roles.team_user) {
                this.loadPoliciesIntoState(this.props);
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (!this.state.loaded && nextProps.roles.system_user && nextProps.roles.team_user) {
                this.loadPoliciesIntoState(nextProps);
            }
        }
    }, {
        key: 'loadPoliciesIntoState',
        value: function loadPoliciesIntoState(props) {
            var roles = props.roles;

            // Purposely parsing boolean from string 'true' or 'false'
            // because the string comes from the policy roles adapter mapping.

            var enableOnlyAdminIntegrations = (0, _policy_roles_adapter.mappingValueFromRoles)('enableOnlyAdminIntegrations', roles) === 'true';

            this.setState({ enableOnlyAdminIntegrations: enableOnlyAdminIntegrations, loaded: true });
        }
    }, {
        key: 'getStateFromConfig',
        value: function getStateFromConfig(config) {
            return {
                enableIncomingWebhooks: config.ServiceSettings.EnableIncomingWebhooks,
                enableOutgoingWebhooks: config.ServiceSettings.EnableOutgoingWebhooks,
                enableCommands: config.ServiceSettings.EnableCommands,
                enablePostUsernameOverride: config.ServiceSettings.EnablePostUsernameOverride,
                enablePostIconOverride: config.ServiceSettings.EnablePostIconOverride,
                enableOAuthServiceProvider: config.ServiceSettings.EnableOAuthServiceProvider,
                enableUserAccessTokens: config.ServiceSettings.EnableUserAccessTokens
            };
        }
    }, {
        key: 'renderTitle',
        value: function renderTitle() {
            return _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'admin.integrations.custom',
                defaultMessage: 'Custom Integrations'
            });
        }
    }]);
    return WebhookSettings;
}(_admin_settings2.default); // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

WebhookSettings.propTypes = {
    intl: _reactIntl.intlShape.isRequired,
    roles: _propTypes2.default.object.isRequired,
    actions: _propTypes2.default.shape({
        loadRolesIfNeeded: _propTypes2.default.func.isRequired,
        editRole: _propTypes2.default.func.isRequired
    }).isRequired
};
exports.default = (0, _reactIntl.injectIntl)(WebhookSettings);

/***/ }),

/***/ 2613:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _redux = __webpack_require__(1);

var _roles = __webpack_require__(860);

var _roles2 = __webpack_require__(276);

var _users_and_teams_settings = __webpack_require__(2614);

var _users_and_teams_settings2 = _interopRequireDefault(_users_and_teams_settings);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state) {
    return {
        roles: (0, _roles2.getRoles)(state)
    };
} // Copyright (c) 2018-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapDispatchToProps(dispatch) {
    return {
        actions: (0, _redux.bindActionCreators)({
            loadRolesIfNeeded: _roles.loadRolesIfNeeded,
            editRole: _roles.editRole
        }, dispatch)
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_users_and_teams_settings2.default);

/***/ }),

/***/ 2614:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.UsersAndTeamsSettings = undefined;

var _stringify = __webpack_require__(275);

var _stringify2 = _interopRequireDefault(_stringify);

var _regenerator = __webpack_require__(114);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _values = __webpack_require__(801);

var _values2 = _interopRequireDefault(_values);

var _promise = __webpack_require__(283);

var _promise2 = _interopRequireDefault(_promise);

var _asyncToGenerator2 = __webpack_require__(115);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _defineProperty2 = __webpack_require__(277);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = __webpack_require__(44);

var _extends4 = _interopRequireDefault(_extends3);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(761);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _policy_roles_adapter = __webpack_require__(1099);

var _admin_actions = __webpack_require__(797);

var _loading_screen = __webpack_require__(792);

var _loading_screen2 = _interopRequireDefault(_loading_screen);

var _admin_settings = __webpack_require__(787);

var _admin_settings2 = _interopRequireDefault(_admin_settings);

var _boolean_setting = __webpack_require__(800);

var _boolean_setting2 = _interopRequireDefault(_boolean_setting);

var _dropdown_setting = __webpack_require__(842);

var _dropdown_setting2 = _interopRequireDefault(_dropdown_setting);

var _settings_group = __webpack_require__(788);

var _settings_group2 = _interopRequireDefault(_settings_group);

var _text_setting = __webpack_require__(794);

var _text_setting2 = _interopRequireDefault(_text_setting);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RESTRICT_DIRECT_MESSAGE_ANY = 'any'; // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var RESTRICT_DIRECT_MESSAGE_TEAM = 'team';

var UsersAndTeamsSettings = exports.UsersAndTeamsSettings = function (_AdminSettings) {
    (0, _inherits3.default)(UsersAndTeamsSettings, _AdminSettings);

    function UsersAndTeamsSettings(props) {
        var _this2 = this;

        (0, _classCallCheck3.default)(this, UsersAndTeamsSettings);

        var _this = (0, _possibleConstructorReturn3.default)(this, (UsersAndTeamsSettings.__proto__ || (0, _getPrototypeOf2.default)(UsersAndTeamsSettings)).call(this, props));

        _this.handleChange = function (id, value) {
            var _this$setState;

            _this.setState((_this$setState = {
                saveNeeded: true
            }, (0, _defineProperty3.default)(_this$setState, id, value), (0, _defineProperty3.default)(_this$setState, 'edited', (0, _extends4.default)({}, _this.state.edited, (0, _defineProperty3.default)({}, id, _this.props.intl.formatMessage({ id: 'admin.field_names.' + id, defaultMessage: id })))), _this$setState));

            _this.props.setNavigationBlocked(true);
        };

        _this.handleSubmit = function () {
            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(e) {
                var updatedRoles, success, configFieldEdited;
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                e.preventDefault();

                                _this.setState({
                                    saving: true,
                                    serverError: null
                                });

                                // Purposely converting enableTeamCreation value from boolean to string 'true' or 'false'
                                // so that it can be used as a key in the policy roles adapter mapping.
                                updatedRoles = (0, _policy_roles_adapter.rolesFromMapping)({ enableTeamCreation: _this.state.enableTeamCreation.toString() }, _this.props.roles);
                                success = true;
                                _context2.next = 6;
                                return _promise2.default.all((0, _values2.default)(updatedRoles).map(function () {
                                    var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(item) {
                                        return _regenerator2.default.wrap(function _callee$(_context) {
                                            while (1) {
                                                switch (_context.prev = _context.next) {
                                                    case 0:
                                                        _context.prev = 0;
                                                        _context.next = 3;
                                                        return _this.props.actions.editRole(item);

                                                    case 3:
                                                        _context.next = 9;
                                                        break;

                                                    case 5:
                                                        _context.prev = 5;
                                                        _context.t0 = _context['catch'](0);

                                                        success = false;
                                                        _this.setState({
                                                            saving: false,
                                                            serverError: _context.t0.message
                                                        });

                                                    case 9:
                                                    case 'end':
                                                        return _context.stop();
                                                }
                                            }
                                        }, _callee, _this2, [[0, 5]]);
                                    }));

                                    return function (_x2) {
                                        return _ref2.apply(this, arguments);
                                    };
                                }()));

                            case 6:

                                if (success) {
                                    configFieldEdited = _this.state.edited.enableUserCreation || _this.state.edited.maxUsersPerTeam || _this.state.edited.restrictCreationToDomains || _this.state.edited.restrictDirectMessage || _this.state.edited.teammateNameDisplay || _this.state.edited.maxChannelsPerTeam || _this.state.edited.maxNotificationsPerChannel || _this.state.edited.enableConfirmNotificationsToChannel;


                                    if (configFieldEdited) {
                                        _this.doSubmit(function () {
                                            if (!_this.state.serverError) {
                                                _this.setState({ edited: {} });
                                            }
                                        });
                                    } else {
                                        _this.setState({
                                            saving: false,
                                            saveNeeded: false,
                                            serverError: null,
                                            edited: {}
                                        });
                                        _this.props.setNavigationBlocked(false);
                                    }
                                }

                            case 7:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }));

            return function (_x) {
                return _ref.apply(this, arguments);
            };
        }();

        _this.doSubmit = function (callback) {
            _this.setState({
                saving: true,
                serverError: null
            });

            // clone config so that we aren't modifying data in the stores
            var config = JSON.parse((0, _stringify2.default)(_this.props.config));
            config = _this.getConfigFromState(config);

            (0, _admin_actions.saveConfig)(config, function (savedConfig) {
                _this.setState(_this.getStateFromConfig(savedConfig));

                _this.setState({
                    saveNeeded: false,
                    saving: false
                });

                _this.props.setNavigationBlocked(false);

                if (callback) {
                    callback();
                }

                if (_this.handleSaved) {
                    _this.handleSaved(config);
                }
            }, function (err) {
                var errMessage = err.message;
                if (err.id === 'ent.cluster.save_config.error') {
                    errMessage = _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'ent.cluster.save_config_with_roles.error',
                        defaultMessage: 'The following configuration settings cannot be saved when High Availability is enabled and the System Console is in read-only mode: {keys}.',
                        values: {
                            keys: [_this.state.edited.enableUserCreation, _this.state.edited.maxUsersPerTeam, _this.state.edited.restrictCreationToDomains, _this.state.edited.restrictDirectMessage, _this.state.edited.teammateNameDisplay, _this.state.edited.maxChannelsPerTeam, _this.state.edited.maxNotificationsPerChannel, _this.state.edited.enableConfirmNotificationsToChannel].filter(function (v) {
                                return v;
                            }).join(', ')
                        }
                    });
                }

                _this.setState({
                    saving: false,
                    serverError: errMessage
                });

                if (callback) {
                    callback();
                }

                if (_this.handleSaved) {
                    _this.handleSaved(config);
                }
            });
        };

        _this.getConfigFromState = function (config) {
            config.TeamSettings.EnableUserCreation = _this.state.enableUserCreation;
            config.TeamSettings.MaxUsersPerTeam = _this.parseIntNonZero(_this.state.maxUsersPerTeam, _constants2.default.DEFAULT_MAX_USERS_PER_TEAM);
            config.TeamSettings.RestrictCreationToDomains = _this.state.restrictCreationToDomains;
            config.TeamSettings.RestrictDirectMessage = _this.state.restrictDirectMessage;
            config.TeamSettings.TeammateNameDisplay = _this.state.teammateNameDisplay;
            config.TeamSettings.MaxChannelsPerTeam = _this.parseIntNonZero(_this.state.maxChannelsPerTeam, _constants2.default.DEFAULT_MAX_CHANNELS_PER_TEAM);
            config.TeamSettings.MaxNotificationsPerChannel = _this.parseIntNonZero(_this.state.maxNotificationsPerChannel, _constants2.default.DEFAULT_MAX_NOTIFICATIONS_PER_CHANNEL);
            config.TeamSettings.EnableConfirmNotificationsToChannel = _this.state.enableConfirmNotificationsToChannel;
            return config;
        };

        _this.renderSettings = function () {
            if (!_this.state.loaded) {
                return _react2.default.createElement(_loading_screen2.default, null);
            }
            return _react2.default.createElement(
                _settings_group2.default,
                null,
                _react2.default.createElement(_boolean_setting2.default, {
                    id: 'enableUserCreation',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.team.userCreationTitle',
                        defaultMessage: 'Enable Account Creation: '
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.team.userCreationDescription',
                        defaultMessage: 'When false, the ability to create accounts is disabled. The create account button displays error when pressed.'
                    }),
                    value: _this.state.enableUserCreation,
                    onChange: _this.handleChange
                }),
                _react2.default.createElement(_boolean_setting2.default, {
                    id: 'enableTeamCreation',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.team.teamCreationTitle',
                        defaultMessage: 'Enable Team Creation: '
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.team.teamCreationDescription',
                        defaultMessage: 'When false, only System Administrators can create teams.'
                    }),
                    value: _this.state.enableTeamCreation,
                    onChange: _this.handleChange
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'maxUsersPerTeam',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.team.maxUsersTitle',
                        defaultMessage: 'Max Users Per Team:'
                    }),
                    placeholder: Utils.localizeMessage('admin.team.maxUsersExample', 'Ex "25"'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.team.maxUsersDescription',
                        defaultMessage: 'Maximum total number of users per team, including both active and inactive users.'
                    }),
                    value: _this.state.maxUsersPerTeam,
                    onChange: _this.handleChange
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'maxChannelsPerTeam',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.team.maxChannelsTitle',
                        defaultMessage: 'Max Channels Per Team:'
                    }),
                    placeholder: Utils.localizeMessage('admin.team.maxChannelsExample', 'Ex "100"'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.team.maxChannelsDescription',
                        defaultMessage: 'Maximum total number of channels per team, including both active and deleted channels.'
                    }),
                    value: _this.state.maxChannelsPerTeam,
                    onChange: _this.handleChange
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'maxNotificationsPerChannel',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.team.maxNotificationsPerChannelTitle',
                        defaultMessage: 'Max Notifications Per Channel:'
                    }),
                    placeholder: Utils.localizeMessage('admin.team.maxNotificationsPerChannelExample', 'Ex "1000"'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.team.maxNotificationsPerChannelDescription',
                        defaultMessage: 'Maximum total number of users in a channel before users typing messages, @all, @here, and @channel no longer send notifications because of performance.'
                    }),
                    value: _this.state.maxNotificationsPerChannel,
                    onChange: _this.handleChange
                }),
                _react2.default.createElement(_boolean_setting2.default, {
                    id: 'enableConfirmNotificationsToChannel',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.team.enableConfirmNotificationsToChannelTitle',
                        defaultMessage: 'Show @channel and @all confirmation dialog: '
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.team.enableConfirmNotificationsToChannelDescription',
                        defaultMessage: 'When true, users will be prompted to confirm when posting @channel and @all in channels with over five members. When false, no confirmation is required.'
                    }),
                    value: _this.state.enableConfirmNotificationsToChannel,
                    onChange: _this.handleChange
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'restrictCreationToDomains',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.team.restrictTitle',
                        defaultMessage: 'Restrict account creation to specified email domains:'
                    }),
                    placeholder: Utils.localizeMessage('admin.team.restrictExample', 'Ex "corp.mattermost.com, mattermost.org"'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.team.restrictDescription',
                        defaultMessage: 'Teams and user accounts can only be created from a specific domain (e.g. "mattermost.org") or list of comma-separated domains (e.g. "corp.mattermost.com, mattermost.org").'
                    }),
                    value: _this.state.restrictCreationToDomains,
                    onChange: _this.handleChange
                }),
                _react2.default.createElement(_dropdown_setting2.default, {
                    id: 'restrictDirectMessage',
                    values: [{ value: RESTRICT_DIRECT_MESSAGE_ANY, text: Utils.localizeMessage('admin.team.restrict_direct_message_any', 'Any user on the Mattermost server') }, { value: RESTRICT_DIRECT_MESSAGE_TEAM, text: Utils.localizeMessage('admin.team.restrict_direct_message_team', 'Any member of the team') }],
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.team.restrictDirectMessage',
                        defaultMessage: 'Enable users to open Direct Message channels with:'
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                        id: 'admin.team.restrictDirectMessageDesc',
                        defaultMessage: '"Any user on the Mattermost server" enables users to open a Direct Message channel with any user on the server, even if they are not on any teams together. "Any member of the team" limits the ability in the Direct Messages "More" menu to only open Direct Message channels with users who are in the same team.<br /><br />Note: This setting only affects the UI, not permissions on the server.'
                    }),
                    value: _this.state.restrictDirectMessage,
                    onChange: _this.handleChange
                }),
                _react2.default.createElement(_dropdown_setting2.default, {
                    id: 'teammateNameDisplay',
                    values: [{ value: _constants2.default.TEAMMATE_NAME_DISPLAY.SHOW_USERNAME, text: Utils.localizeMessage('admin.team.showUsername', 'Show username (default)') }, { value: _constants2.default.TEAMMATE_NAME_DISPLAY.SHOW_NICKNAME_FULLNAME, text: Utils.localizeMessage('admin.team.showNickname', 'Show nickname if one exists, otherwise show first and last name') }, { value: _constants2.default.TEAMMATE_NAME_DISPLAY.SHOW_FULLNAME, text: Utils.localizeMessage('admin.team.showFullname', 'Show first and last name') }],
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.team.teammateNameDisplay',
                        defaultMessage: 'Teammate Name Display:'
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                        id: 'admin.team.teammateNameDisplayDesc',
                        defaultMessage: 'Set how to display users\' names in posts and the Direct Messages list.'
                    }),
                    value: _this.state.teammateNameDisplay,
                    onChange: _this.handleChange
                })
            );
        };

        _this.state = (0, _extends4.default)({}, _this.state, { // Brings the state in from the parent class.
            enableTeamCreation: null,
            loaded: false,
            edited: {}
        });
        return _this;
    }

    (0, _createClass3.default)(UsersAndTeamsSettings, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.props.actions.loadRolesIfNeeded(['system_user']);
            if (this.props.roles.system_user) {
                this.loadPoliciesIntoState(this.props);
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (!this.state.loaded && nextProps.roles.system_user) {
                this.loadPoliciesIntoState(nextProps);
            }
        }
    }, {
        key: 'loadPoliciesIntoState',
        value: function loadPoliciesIntoState(props) {
            var roles = props.roles;

            // Purposely parsing boolean from string 'true' or 'false'
            // because the string comes from the policy roles adapter mapping.

            var enableTeamCreation = (0, _policy_roles_adapter.mappingValueFromRoles)('enableTeamCreation', roles) === 'true';

            this.setState({ enableTeamCreation: enableTeamCreation, loaded: true });
        }
    }, {
        key: 'getStateFromConfig',
        value: function getStateFromConfig(config) {
            return {
                enableUserCreation: config.TeamSettings.EnableUserCreation,
                maxUsersPerTeam: config.TeamSettings.MaxUsersPerTeam,
                restrictCreationToDomains: config.TeamSettings.RestrictCreationToDomains,
                restrictDirectMessage: config.TeamSettings.RestrictDirectMessage,
                teammateNameDisplay: config.TeamSettings.TeammateNameDisplay,
                maxChannelsPerTeam: config.TeamSettings.MaxChannelsPerTeam,
                maxNotificationsPerChannel: config.TeamSettings.MaxNotificationsPerChannel,
                enableConfirmNotificationsToChannel: config.TeamSettings.EnableConfirmNotificationsToChannel
            };
        }
    }, {
        key: 'renderTitle',
        value: function renderTitle() {
            return _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'admin.general.usersAndTeams',
                defaultMessage: 'Users and Teams'
            });
        }
    }]);
    return UsersAndTeamsSettings;
}(_admin_settings2.default);

UsersAndTeamsSettings.propTypes = {
    intl: _reactIntl.intlShape.isRequired,
    roles: _propTypes2.default.object.isRequired,
    actions: _propTypes2.default.shape({
        loadRolesIfNeeded: _propTypes2.default.func.isRequired,
        editRole: _propTypes2.default.func.isRequired
    }).isRequired
};
exports.default = (0, _reactIntl.injectIntl)(UsersAndTeamsSettings);

/***/ }),

/***/ 2615:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _admin_settings = __webpack_require__(787);

var _admin_settings2 = _interopRequireDefault(_admin_settings);

var _boolean_setting = __webpack_require__(800);

var _boolean_setting2 = _interopRequireDefault(_boolean_setting);

var _generated_setting = __webpack_require__(997);

var _generated_setting2 = _interopRequireDefault(_generated_setting);

var _settings_group = __webpack_require__(788);

var _settings_group2 = _interopRequireDefault(_settings_group);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var PublicLinkSettings = function (_AdminSettings) {
    (0, _inherits3.default)(PublicLinkSettings, _AdminSettings);

    function PublicLinkSettings(props) {
        (0, _classCallCheck3.default)(this, PublicLinkSettings);

        var _this = (0, _possibleConstructorReturn3.default)(this, (PublicLinkSettings.__proto__ || (0, _getPrototypeOf2.default)(PublicLinkSettings)).call(this, props));

        _this.getConfigFromState = _this.getConfigFromState.bind(_this);

        _this.renderSettings = _this.renderSettings.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(PublicLinkSettings, [{
        key: 'getConfigFromState',
        value: function getConfigFromState(config) {
            config.FileSettings.EnablePublicLink = this.state.enablePublicLink;
            config.FileSettings.PublicLinkSalt = this.state.publicLinkSalt;

            return config;
        }
    }, {
        key: 'getStateFromConfig',
        value: function getStateFromConfig(config) {
            return {
                enablePublicLink: config.FileSettings.EnablePublicLink,
                publicLinkSalt: config.FileSettings.PublicLinkSalt
            };
        }
    }, {
        key: 'renderTitle',
        value: function renderTitle() {
            return _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'admin.security.public_links',
                defaultMessage: 'Public Links'
            });
        }
    }, {
        key: 'renderSettings',
        value: function renderSettings() {
            return _react2.default.createElement(
                _settings_group2.default,
                null,
                _react2.default.createElement(_boolean_setting2.default, {
                    id: 'enablePublicLink',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.image.shareTitle',
                        defaultMessage: 'Enable Public File Links: '
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.image.shareDescription',
                        defaultMessage: 'Allow users to share public links to files and images.'
                    }),
                    value: this.state.enablePublicLink,
                    onChange: this.handleChange
                }),
                _react2.default.createElement(_generated_setting2.default, {
                    id: 'publicLinkSalt',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.image.publicLinkTitle',
                        defaultMessage: 'Public Link Salt:'
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.image.publicLinkDescription',
                        defaultMessage: '32-character salt added to signing of public image links. Randomly generated on install. Click "Regenerate" to create new salt.'
                    }),
                    value: this.state.publicLinkSalt,
                    onChange: this.handleChange
                })
            );
        }
    }]);
    return PublicLinkSettings;
}(_admin_settings2.default);

exports.default = PublicLinkSettings;

/***/ }),

/***/ 2616:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _admin_settings = __webpack_require__(787);

var _admin_settings2 = _interopRequireDefault(_admin_settings);

var _dropdown_setting = __webpack_require__(842);

var _dropdown_setting2 = _interopRequireDefault(_dropdown_setting);

var _settings_group = __webpack_require__(788);

var _settings_group2 = _interopRequireDefault(_settings_group);

var _text_setting = __webpack_require__(794);

var _text_setting2 = _interopRequireDefault(_text_setting);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var PUSH_NOTIFICATIONS_OFF = 'off';
var PUSH_NOTIFICATIONS_MHPNS = 'mhpns';
var PUSH_NOTIFICATIONS_MTPNS = 'mtpns';
var PUSH_NOTIFICATIONS_CUSTOM = 'custom';

var PushSettings = function (_AdminSettings) {
    (0, _inherits3.default)(PushSettings, _AdminSettings);

    function PushSettings(props) {
        (0, _classCallCheck3.default)(this, PushSettings);

        var _this = (0, _possibleConstructorReturn3.default)(this, (PushSettings.__proto__ || (0, _getPrototypeOf2.default)(PushSettings)).call(this, props));

        _this.canSave = _this.canSave.bind(_this);
        _this.handleAgreeChange = _this.handleAgreeChange.bind(_this);
        _this.getConfigFromState = _this.getConfigFromState.bind(_this);
        _this.renderSettings = _this.renderSettings.bind(_this);
        _this.handleDropdownChange = _this.handleDropdownChange.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(PushSettings, [{
        key: 'canSave',
        value: function canSave() {
            return this.state.pushNotificationServerType !== PUSH_NOTIFICATIONS_MHPNS || this.state.agree;
        }
    }, {
        key: 'handleAgreeChange',
        value: function handleAgreeChange(e) {
            this.setState({
                agree: e.target.checked
            });
        }
    }, {
        key: 'handleDropdownChange',
        value: function handleDropdownChange(id, value) {
            if (id === 'pushNotificationServerType') {
                this.setState({
                    agree: false
                });

                if (value === PUSH_NOTIFICATIONS_MHPNS) {
                    this.setState({
                        pushNotificationServer: _constants2.default.MHPNS
                    });
                } else if (value === PUSH_NOTIFICATIONS_MTPNS) {
                    this.setState({
                        pushNotificationServer: _constants2.default.MTPNS
                    });
                } else if (value === PUSH_NOTIFICATIONS_CUSTOM && (this.state.pushNotificationServerType === PUSH_NOTIFICATIONS_MTPNS || this.state.pushNotificationServerType === PUSH_NOTIFICATIONS_MHPNS)) {
                    this.setState({
                        pushNotificationServer: ''
                    });
                }
            }

            this.handleChange(id, value);
        }
    }, {
        key: 'getConfigFromState',
        value: function getConfigFromState(config) {
            config.EmailSettings.SendPushNotifications = this.state.pushNotificationServerType !== PUSH_NOTIFICATIONS_OFF;
            config.EmailSettings.PushNotificationServer = this.state.pushNotificationServer.trim();
            config.EmailSettings.PushNotificationContents = this.state.pushNotificationContents;

            return config;
        }
    }, {
        key: 'getStateFromConfig',
        value: function getStateFromConfig(config) {
            var pushNotificationServerType = PUSH_NOTIFICATIONS_CUSTOM;
            var agree = false;
            if (!config.EmailSettings.SendPushNotifications) {
                pushNotificationServerType = PUSH_NOTIFICATIONS_OFF;
            } else if (config.EmailSettings.PushNotificationServer === _constants2.default.MHPNS && this.props.license.IsLicensed === 'true' && this.props.license.MHPNS === 'true') {
                pushNotificationServerType = PUSH_NOTIFICATIONS_MHPNS;
                agree = true;
            } else if (config.EmailSettings.PushNotificationServer === _constants2.default.MTPNS) {
                pushNotificationServerType = PUSH_NOTIFICATIONS_MTPNS;
            }

            var pushNotificationServer = config.EmailSettings.PushNotificationServer;
            if (pushNotificationServerType === PUSH_NOTIFICATIONS_MTPNS) {
                pushNotificationServer = _constants2.default.MTPNS;
            } else if (pushNotificationServerType === PUSH_NOTIFICATIONS_MHPNS) {
                pushNotificationServer = _constants2.default.MHPNS;
            }

            return {
                pushNotificationServerType: pushNotificationServerType,
                pushNotificationServer: pushNotificationServer,
                pushNotificationContents: config.EmailSettings.PushNotificationContents,
                agree: agree
            };
        }
    }, {
        key: 'renderTitle',
        value: function renderTitle() {
            return _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'admin.notifications.title',
                defaultMessage: 'Notification Settings'
            });
        }
    }, {
        key: 'renderSettings',
        value: function renderSettings() {
            var pushNotificationServerTypes = [];
            pushNotificationServerTypes.push({ value: PUSH_NOTIFICATIONS_OFF, text: Utils.localizeMessage('admin.email.pushOff', 'Do not send push notifications') });
            if (this.props.license.IsLicensed === 'true' && this.props.license.MHPNS === 'true') {
                pushNotificationServerTypes.push({ value: PUSH_NOTIFICATIONS_MHPNS, text: Utils.localizeMessage('admin.email.mhpns', 'Use encrypted, production-quality HPNS connection to iOS and Android apps') });
            }
            pushNotificationServerTypes.push({ value: PUSH_NOTIFICATIONS_MTPNS, text: Utils.localizeMessage('admin.email.mtpns', 'Use iOS and Android apps on iTunes and Google Play with TPNS') });
            pushNotificationServerTypes.push({ value: PUSH_NOTIFICATIONS_CUSTOM, text: Utils.localizeMessage('admin.email.selfPush', 'Manually enter Push Notification Service location') });

            var sendHelpText = null;
            var pushServerHelpText = null;
            if (this.state.pushNotificationServerType === PUSH_NOTIFICATIONS_OFF) {
                sendHelpText = _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                    id: 'admin.email.pushOffHelp',
                    defaultMessage: 'Please see <a href="https://about.mattermost.com/default-mobile-push-notifications/" target="_blank">documentation on push notifications</a> to learn more about setup options.'
                });
            } else if (this.state.pushNotificationServerType === PUSH_NOTIFICATIONS_MHPNS) {
                pushServerHelpText = _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                    id: 'admin.email.mhpnsHelp',
                    defaultMessage: 'Download <a href="https://about.mattermost.com/mattermost-ios-app/" target="_blank">Mattermost iOS app</a> from iTunes. Download <a href="https://about.mattermost.com/mattermost-android-app/" target="_blank">Mattermost Android app</a> from Google Play. Learn more about the <a href="https://about.mattermost.com/default-hpns/" target="_blank">Mattermost Hosted Push Notification Service</a>.'
                });
            } else if (this.state.pushNotificationServerType === PUSH_NOTIFICATIONS_MTPNS) {
                pushServerHelpText = _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                    id: 'admin.email.mtpnsHelp',
                    defaultMessage: 'Download <a href="https://about.mattermost.com/mattermost-ios-app/" target="_blank">Mattermost iOS app</a> from iTunes. Download <a href="https://about.mattermost.com/mattermost-android-app/" target="_blank">Mattermost Android app</a> from Google Play. Learn more about the <a href="https://about.mattermost.com/default-tpns/" target="_blank">Mattermost Test Push Notification Service</a>.'
                });
            } else {
                pushServerHelpText = _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                    id: 'admin.email.easHelp',
                    defaultMessage: 'Learn more about compiling and deploying your own mobile apps from an <a href="https://about.mattermost.com/default-enterprise-app-store" target="_blank">Enterprise App Store</a>.'
                });
            }

            var tosCheckbox = void 0;
            if (this.state.pushNotificationServerType === PUSH_NOTIFICATIONS_MHPNS) {
                tosCheckbox = _react2.default.createElement(
                    'div',
                    { className: 'form-group' },
                    _react2.default.createElement('div', { className: 'col-sm-4' }),
                    _react2.default.createElement(
                        'div',
                        { className: 'col-sm-8' },
                        _react2.default.createElement('input', {
                            type: 'checkbox',
                            ref: 'agree',
                            checked: this.state.agree,
                            onChange: this.handleAgreeChange
                        }),
                        _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                            id: 'admin.email.agreeHPNS',
                            defaultMessage: ' I understand and accept the Mattermost Hosted Push Notification Service <a href="https://about.mattermost.com/hpns-terms/" target="_blank">Terms of Service</a> and <a href="https://about.mattermost.com/hpns-privacy/" target="_blank">Privacy Policy</a>.'
                        })
                    )
                );
            }

            return _react2.default.createElement(
                _settings_group2.default,
                {
                    header: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.notifications.push',
                        defaultMessage: 'Mobile Push'
                    })
                },
                _react2.default.createElement(_dropdown_setting2.default, {
                    id: 'pushNotificationServerType',
                    values: pushNotificationServerTypes,
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.email.pushTitle',
                        defaultMessage: 'Enable Push Notifications: '
                    }),
                    value: this.state.pushNotificationServerType,
                    onChange: this.handleDropdownChange,
                    helpText: sendHelpText
                }),
                tosCheckbox,
                _react2.default.createElement(_text_setting2.default, {
                    id: 'pushNotificationServer',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.email.pushServerTitle',
                        defaultMessage: 'Push Notification Server:'
                    }),
                    placeholder: Utils.localizeMessage('admin.email.pushServerEx', 'E.g.: "http://push-test.mattermost.com"'),
                    helpText: pushServerHelpText,
                    value: this.state.pushNotificationServer,
                    onChange: this.handleChange,
                    disabled: this.state.pushNotificationServerType !== PUSH_NOTIFICATIONS_CUSTOM
                }),
                _react2.default.createElement(_dropdown_setting2.default, {
                    id: 'pushNotificationContents',
                    values: [{ value: 'generic_no_channel', text: Utils.localizeMessage('admin.email.genericNoChannelPushNotification', '"Send generic description with only sender name') }, { value: 'generic', text: Utils.localizeMessage('admin.email.genericPushNotification', 'Send generic description with sender and channel names') }, { value: 'full', text: Utils.localizeMessage('admin.email.fullPushNotification', 'Send full message snippet') }],
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.email.pushContentTitle',
                        defaultMessage: 'Push Notification Contents:'
                    }),
                    value: this.state.pushNotificationContents,
                    onChange: this.handleDropdownChange,
                    disabled: this.state.pushNotificationServerType === PUSH_NOTIFICATIONS_OFF,
                    helpText: _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                        id: 'admin.email.pushContentDesc',
                        defaultMessage: '"Send generic description with only sender name" includes only the name of the person who sent the message in push notifications, with no information about channel name or message contents.<br /><br />"Send generic description with sender and channel names" includes the name of the person who sent the message and the channel it was sent in, but not the message text.<br /><br />"Send full message snippet" includes a message excerpt in push notifications, which may contain confidential information sent in messages. If your Push Notification Service is outside your firewall, it is *highly recommended* this option only be used with an "https" protocol to encrypt the connection.'
                    })
                })
            );
        }
    }]);
    return PushSettings;
}(_admin_settings2.default);

exports.default = PushSettings;

/***/ }),

/***/ 2617:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _admin_settings = __webpack_require__(787);

var _admin_settings2 = _interopRequireDefault(_admin_settings);

var _boolean_setting = __webpack_require__(800);

var _boolean_setting2 = _interopRequireDefault(_boolean_setting);

var _settings_group = __webpack_require__(788);

var _settings_group2 = _interopRequireDefault(_settings_group);

var _text_setting = __webpack_require__(794);

var _text_setting2 = _interopRequireDefault(_text_setting);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RateSettings = function (_AdminSettings) {
    (0, _inherits3.default)(RateSettings, _AdminSettings);

    function RateSettings(props) {
        (0, _classCallCheck3.default)(this, RateSettings);

        var _this = (0, _possibleConstructorReturn3.default)(this, (RateSettings.__proto__ || (0, _getPrototypeOf2.default)(RateSettings)).call(this, props));

        _this.getConfigFromState = _this.getConfigFromState.bind(_this);

        _this.renderSettings = _this.renderSettings.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(RateSettings, [{
        key: 'getConfigFromState',
        value: function getConfigFromState(config) {
            config.RateLimitSettings.Enable = this.state.enable;
            config.RateLimitSettings.PerSec = this.parseIntNonZero(this.state.perSec);
            config.RateLimitSettings.MaxBurst = this.parseIntNonZero(this.state.maxBurst);
            config.RateLimitSettings.MemoryStoreSize = this.parseIntNonZero(this.state.memoryStoreSize);
            config.RateLimitSettings.VaryByRemoteAddr = this.state.varyByRemoteAddr;
            config.RateLimitSettings.VaryByUser = this.state.varyByUser;
            config.RateLimitSettings.VaryByHeader = this.state.varyByHeader;

            return config;
        }
    }, {
        key: 'getStateFromConfig',
        value: function getStateFromConfig(config) {
            return {
                enable: config.RateLimitSettings.Enable,
                perSec: config.RateLimitSettings.PerSec,
                maxBurst: config.RateLimitSettings.MaxBurst,
                memoryStoreSize: config.RateLimitSettings.MemoryStoreSize,
                varyByRemoteAddr: config.RateLimitSettings.VaryByRemoteAddr,
                varyByUser: config.RateLimitSettings.VaryByUser,
                varyByHeader: config.RateLimitSettings.VaryByHeader
            };
        }
    }, {
        key: 'renderTitle',
        value: function renderTitle() {
            return _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'admin.rate.title',
                defaultMessage: 'Rate Limit Settings'
            });
        }
    }, {
        key: 'renderSettings',
        value: function renderSettings() {
            return _react2.default.createElement(
                _settings_group2.default,
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'banner' },
                    _react2.default.createElement(
                        'div',
                        { className: 'banner__content' },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'admin.rate.noteDescription',
                            defaultMessage: 'Changing properties in this section will require a server restart before taking effect.'
                        })
                    )
                ),
                _react2.default.createElement(_boolean_setting2.default, {
                    id: 'enable',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.rate.enableLimiterTitle',
                        defaultMessage: 'Enable Rate Limiting: '
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.rate.enableLimiterDescription',
                        defaultMessage: 'When true, APIs are throttled at rates specified below.'
                    }),
                    value: this.state.enable,
                    onChange: this.handleChange
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'perSec',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.rate.queriesTitle',
                        defaultMessage: 'Maximum Queries per Second:'
                    }),
                    placeholder: Utils.localizeMessage('admin.rate.queriesExample', 'E.g.: "10"'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.rate.queriesDescription',
                        defaultMessage: 'Throttles API at this number of requests per second.'
                    }),
                    value: this.state.perSec,
                    onChange: this.handleChange,
                    disabled: !this.state.enable
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'maxBurst',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.rate.maxBurst',
                        defaultMessage: 'Maximum Burst Size:'
                    }),
                    placeholder: Utils.localizeMessage('admin.rate.maxBurstExample', 'E.g.: "100"'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.rate.maxBurstDescription',
                        defaultMessage: 'Maximum number of requests allowed beyond the per second query limit.'
                    }),
                    value: this.state.maxBurst,
                    onChange: this.handleChange,
                    disabled: !this.state.enable
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'memoryStoreSize',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.rate.memoryTitle',
                        defaultMessage: 'Memory Store Size:'
                    }),
                    placeholder: Utils.localizeMessage('admin.rate.memoryExample', 'E.g.: "10000"'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.rate.memoryDescription',
                        defaultMessage: 'Maximum number of users sessions connected to the system as determined by "Vary rate limit by remote address" and "Vary rate limit by HTTP header".'
                    }),
                    value: this.state.memoryStoreSize,
                    onChange: this.handleChange,
                    disabled: !this.state.enable
                }),
                _react2.default.createElement(_boolean_setting2.default, {
                    id: 'varyByRemoteAddr',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.rate.remoteTitle',
                        defaultMessage: 'Vary rate limit by remote address: '
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.rate.remoteDescription',
                        defaultMessage: 'When true, rate limit API access by IP address.'
                    }),
                    value: this.state.varyByRemoteAddr,
                    onChange: this.handleChange,
                    disabled: !this.state.enable
                }),
                _react2.default.createElement(_boolean_setting2.default, {
                    id: 'varyByUser',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.rate.varyByUser',
                        defaultMessage: 'Vary rate limit by user: '
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.rate.varyByUserDescription',
                        defaultMessage: 'When true, rate limit API access by user athentication token.'
                    }),
                    value: this.state.varyByUser,
                    onChange: this.handleChange,
                    disabled: !this.state.enable
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'varyByHeader',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.rate.httpHeaderTitle',
                        defaultMessage: 'Vary rate limit by HTTP header:'
                    }),
                    placeholder: Utils.localizeMessage('admin.rate.httpHeaderExample', 'E.g.: "X-Real-IP", "X-Forwarded-For"'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.rate.httpHeaderDescription',
                        defaultMessage: 'When filled in, vary rate limiting by HTTP header field specified (e.g. when configuring NGINX set to "X-Real-IP", when configuring AmazonELB set to "X-Forwarded-For").'
                    }),
                    value: this.state.varyByHeader,
                    onChange: this.handleChange,
                    disabled: !this.state.enable || this.state.varyByRemoteAddr
                })
            );
        }
    }]);
    return RateSettings;
}(_admin_settings2.default); // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = RateSettings;

/***/ }),

/***/ 2618:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(277);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _admin_actions = __webpack_require__(797);

var AdminActions = _interopRequireWildcard(_admin_actions);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _admin_settings = __webpack_require__(787);

var _admin_settings2 = _interopRequireDefault(_admin_settings);

var _boolean_setting = __webpack_require__(800);

var _boolean_setting2 = _interopRequireDefault(_boolean_setting);

var _file_upload_setting = __webpack_require__(2619);

var _file_upload_setting2 = _interopRequireDefault(_file_upload_setting);

var _remove_file_setting = __webpack_require__(2620);

var _remove_file_setting2 = _interopRequireDefault(_remove_file_setting);

var _settings_group = __webpack_require__(788);

var _settings_group2 = _interopRequireDefault(_settings_group);

var _text_setting = __webpack_require__(794);

var _text_setting2 = _interopRequireDefault(_text_setting);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var SamlSettings = function (_AdminSettings) {
    (0, _inherits3.default)(SamlSettings, _AdminSettings);

    function SamlSettings(props) {
        (0, _classCallCheck3.default)(this, SamlSettings);

        var _this = (0, _possibleConstructorReturn3.default)(this, (SamlSettings.__proto__ || (0, _getPrototypeOf2.default)(SamlSettings)).call(this, props));

        _this.getConfigFromState = _this.getConfigFromState.bind(_this);

        _this.renderSettings = _this.renderSettings.bind(_this);
        _this.uploadCertificate = _this.uploadCertificate.bind(_this);
        _this.removeCertificate = _this.removeCertificate.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(SamlSettings, [{
        key: 'getConfigFromState',
        value: function getConfigFromState(config) {
            config.SamlSettings.Enable = this.state.enable;
            config.SamlSettings.EnableSyncWithLdap = this.state.enableSyncWithLdap;
            config.SamlSettings.Verify = this.state.verify;
            config.SamlSettings.Encrypt = this.state.encrypt;
            config.SamlSettings.IdpUrl = this.state.idpUrl;
            config.SamlSettings.IdpDescriptorUrl = this.state.idpDescriptorUrl;
            config.SamlSettings.AssertionConsumerServiceURL = this.state.assertionConsumerServiceURL;
            config.SamlSettings.IdpCertificateFile = this.state.idpCertificateFile;
            config.SamlSettings.PublicCertificateFile = this.state.publicCertificateFile;
            config.SamlSettings.PrivateKeyFile = this.state.privateKeyFile;
            config.SamlSettings.FirstNameAttribute = this.state.firstNameAttribute;
            config.SamlSettings.LastNameAttribute = this.state.lastNameAttribute;
            config.SamlSettings.EmailAttribute = this.state.emailAttribute;
            config.SamlSettings.UsernameAttribute = this.state.usernameAttribute;
            config.SamlSettings.NicknameAttribute = this.state.nicknameAttribute;
            config.SamlSettings.PositionAttribute = this.state.positionAttribute;
            config.SamlSettings.LocaleAttribute = this.state.localeAttribute;
            config.SamlSettings.LoginButtonText = this.state.loginButtonText;

            return config;
        }
    }, {
        key: 'getStateFromConfig',
        value: function getStateFromConfig(config) {
            var settings = config.SamlSettings;

            // pre-populate Service Provider Login URL page
            var siteUrl = config.ServiceSettings.SiteURL;
            var consumerServiceUrl = settings.AssertionConsumerServiceURL;
            if (siteUrl.length > 0 && consumerServiceUrl.length === 0) {
                var addSlashIfNeeded = siteUrl[siteUrl.length - 1] === '/' ? '' : '/';
                consumerServiceUrl = '' + siteUrl + addSlashIfNeeded + 'login/sso/saml';
            }

            return {
                siteUrlSet: siteUrl.length > 0,
                enable: settings.Enable,
                enableSyncWithLdap: settings.EnableSyncWithLdap,
                verify: settings.Verify,
                encrypt: settings.Encrypt,
                idpUrl: settings.IdpUrl,
                idpDescriptorUrl: settings.IdpDescriptorUrl,
                assertionConsumerServiceURL: consumerServiceUrl,
                idpCertificateFile: settings.IdpCertificateFile,
                publicCertificateFile: settings.PublicCertificateFile,
                privateKeyFile: settings.PrivateKeyFile,
                firstNameAttribute: settings.FirstNameAttribute,
                lastNameAttribute: settings.LastNameAttribute,
                emailAttribute: settings.EmailAttribute,
                usernameAttribute: settings.UsernameAttribute,
                nicknameAttribute: settings.NicknameAttribute,
                positionAttribute: settings.PositionAttribute,
                localeAttribute: settings.LocaleAttribute,
                loginButtonText: settings.LoginButtonText
            };
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _this2 = this;

            AdminActions.samlCertificateStatus(function (data) {
                var files = {};
                if (!data.idp_certificate_file) {
                    files.idpCertificateFile = '';
                }

                if (!data.public_certificate_file) {
                    files.publicCertificateFile = '';
                }

                if (!data.private_key_file) {
                    files.privateKeyFile = '';
                }
                _this2.setState(files);
            });
        }
    }, {
        key: 'uploadCertificate',
        value: function uploadCertificate(id, file, callback) {
            var _this3 = this;

            var complete = function complete() {
                var _this3$setState;

                var fileName = file.name;
                _this3.handleChange(id, fileName);
                _this3.setState((_this3$setState = {}, (0, _defineProperty3.default)(_this3$setState, id, fileName), (0, _defineProperty3.default)(_this3$setState, id + 'Error', null), _this3$setState));
                if (callback && typeof callback === 'function') {
                    callback();
                }
            };

            function fail(error) {
                if (callback && typeof callback === 'function') {
                    callback(error.message);
                }
            }

            if (id === 'idpCertificateFile') {
                AdminActions.uploadIdpSamlCertificate(file, complete, fail);
            } else if (id === 'publicCertificateFile') {
                AdminActions.uploadPublicSamlCertificate(file, complete, fail);
            } else if (id === 'privateKeyFile') {
                AdminActions.uploadPrivateSamlCertificate(file, complete, fail);
            }
        }
    }, {
        key: 'removeCertificate',
        value: function removeCertificate(id, callback) {
            var _this4 = this;

            var complete = function complete() {
                var _this4$setState;

                _this4.handleChange(id, '');
                _this4.setState((_this4$setState = {}, (0, _defineProperty3.default)(_this4$setState, id, null), (0, _defineProperty3.default)(_this4$setState, id + 'Error', null), _this4$setState));
            };

            var fail = function fail(error) {
                var _this4$setState2;

                if (callback && typeof callback === 'function') {
                    callback();
                }
                _this4.setState((_this4$setState2 = {}, (0, _defineProperty3.default)(_this4$setState2, id, null), (0, _defineProperty3.default)(_this4$setState2, id + 'Error', error.message), _this4$setState2));
            };

            if (id === 'idpCertificateFile') {
                AdminActions.removeIdpSamlCertificate(complete, fail);
            } else if (id === 'publicCertificateFile') {
                AdminActions.removePublicSamlCertificate(complete, fail);
            } else if (id === 'privateKeyFile') {
                AdminActions.removePrivateSamlCertificate(complete, fail);
            }
        }
    }, {
        key: 'renderTitle',
        value: function renderTitle() {
            return _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'admin.authentication.saml',
                defaultMessage: 'SAML 2.0'
            });
        }
    }, {
        key: 'renderSettings',
        value: function renderSettings() {
            var licenseEnabled = this.props.license.IsLicensed === 'true' && this.props.license.SAML === 'true';
            if (!licenseEnabled) {
                return null;
            }

            var idpCert = void 0;
            var privKey = void 0;
            var pubCert = void 0;

            if (this.state.idpCertificateFile) {
                idpCert = _react2.default.createElement(_remove_file_setting2.default, {
                    id: 'idpCertificateFile',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.saml.idpCertificateFileTitle',
                        defaultMessage: 'Identity Provider Public Certificate:'
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.saml.idpCertificateFileRemoveDesc',
                        defaultMessage: 'Remove the public authentication certificate issued by your Identity Provider.'
                    }),
                    removeButtonText: Utils.localizeMessage('admin.saml.remove.idp_certificate', 'Remove Identity Provider Certificate'),
                    removingText: Utils.localizeMessage('admin.saml.removing.certificate', 'Removing Certificate...'),
                    fileName: this.state.idpCertificateFile,
                    onSubmit: this.removeCertificate,
                    disabled: !this.state.enable
                });
            } else {
                idpCert = _react2.default.createElement(_file_upload_setting2.default, {
                    id: 'idpCertificateFile',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.saml.idpCertificateFileTitle',
                        defaultMessage: 'Identity Provider Public Certificate:'
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.saml.idpCertificateFileDesc',
                        defaultMessage: 'The public authentication certificate issued by your Identity Provider.'
                    }),
                    uploadingText: Utils.localizeMessage('admin.saml.uploading.certificate', 'Uploading Certificate...'),
                    disabled: !this.state.enable,
                    fileType: '.crt,.cer,.cert,.pem',
                    onSubmit: this.uploadCertificate,
                    error: this.state.idpCertificateFileError
                });
            }

            if (this.state.privateKeyFile) {
                privKey = _react2.default.createElement(_remove_file_setting2.default, {
                    id: 'privateKeyFile',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.saml.privateKeyFileTitle',
                        defaultMessage: 'Service Provider Private Key:'
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.saml.privateKeyFileFileRemoveDesc',
                        defaultMessage: 'Remove the private key used to decrypt SAML Assertions from the Identity Provider.'
                    }),
                    removeButtonText: Utils.localizeMessage('admin.saml.remove.privKey', 'Remove Service Provider Private Key'),
                    removingText: Utils.localizeMessage('admin.saml.removing.privKey', 'Removing Private Key...'),
                    fileName: this.state.privateKeyFile,
                    onSubmit: this.removeCertificate,
                    disabled: !this.state.enable || !this.state.encrypt
                });
            } else {
                privKey = _react2.default.createElement(_file_upload_setting2.default, {
                    id: 'privateKeyFile',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.saml.privateKeyFileTitle',
                        defaultMessage: 'Service Provider Private Key:'
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.saml.privateKeyFileFileDesc',
                        defaultMessage: 'The private key used to decrypt SAML Assertions from the Identity Provider.'
                    }),
                    uploadingText: Utils.localizeMessage('admin.saml.uploading.privateKey', 'Uploading Private Key...'),
                    disabled: !this.state.enable || !this.state.encrypt,
                    fileType: '.key',
                    onSubmit: this.uploadCertificate,
                    error: this.state.privateKeyFileError
                });
            }

            if (this.state.publicCertificateFile) {
                pubCert = _react2.default.createElement(_remove_file_setting2.default, {
                    id: 'publicCertificateFile',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.saml.publicCertificateFileTitle',
                        defaultMessage: 'Service Provider Public Certificate:'
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.saml.publicCertificateFileRemoveDesc',
                        defaultMessage: 'Remove the certificate used to generate the signature on a SAML request to the Identity Provider for a service provider initiated SAML login, when Mattermost is the Service Provider.'
                    }),
                    removeButtonText: Utils.localizeMessage('admin.saml.remove.sp_certificate', 'Remove Service Provider Certificate'),
                    removingText: Utils.localizeMessage('admin.saml.removing.certificate', 'Removing Certificate...'),
                    fileName: this.state.publicCertificateFile,
                    onSubmit: this.removeCertificate,
                    disabled: !this.state.enable || !this.state.encrypt
                });
            } else {
                pubCert = _react2.default.createElement(_file_upload_setting2.default, {
                    id: 'publicCertificateFile',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.saml.publicCertificateFileTitle',
                        defaultMessage: 'Service Provider Public Certificate:'
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.saml.publicCertificateFileDesc',
                        defaultMessage: 'The certificate used to generate the signature on a SAML request to the Identity Provider for a service provider initiated SAML login, when Mattermost is the Service Provider.'
                    }),
                    uploadingText: Utils.localizeMessage('admin.saml.uploading.certificate', 'Uploading Certificate...'),
                    disabled: !this.state.enable || !this.state.encrypt,
                    fileType: '.crt,.cer',
                    onSubmit: this.uploadCertificate,
                    error: this.state.publicCertificateFileError
                });
            }

            var consumerServiceUrlHelp = void 0;
            if (this.state.siteUrlSet) {
                consumerServiceUrlHelp = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'admin.saml.assertionConsumerServiceURLPopulatedDesc',
                    defaultMessage: 'This field is also known as the Assertion Consumer Service URL.'
                });
            } else {
                consumerServiceUrlHelp = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'admin.saml.assertionConsumerServiceURLDesc',
                    defaultMessage: 'Enter https://<your-mattermost-url>/login/sso/saml. Make sure you use HTTP or HTTPS in your URL depending on your server configuration. This field is also known as the Assertion Consumer Service URL.'
                });
            }

            return _react2.default.createElement(
                _settings_group2.default,
                null,
                _react2.default.createElement(_boolean_setting2.default, {
                    id: 'enable',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.saml.enableTitle',
                        defaultMessage: 'Enable Login With SAML 2.0:'
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                        id: 'admin.saml.enableDescription',
                        defaultMessage: 'When true, Mattermost allows login using SAML 2.0. Please see <a href="http://docs.mattermost.com/deployment/sso-saml.html" target="_blank">documentation</a> to learn more about configuring SAML for Mattermost.'
                    }),
                    value: this.state.enable,
                    onChange: this.handleChange
                }),
                _react2.default.createElement(_boolean_setting2.default, {
                    id: 'enableSyncWithLdap',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.saml.enableSyncWithLdapTitle',
                        defaultMessage: 'Enable Synchronizing SAML Accounts With AD/LDAP:'
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                        id: 'admin.saml.enableSyncWithLdapDescription',
                        defaultMessage: 'When true, Mattermost periodically synchronizes SAML user attributes, including user deactivation and removal, from AD/LDAP. Enable and configure synchronization settings at <strong>Authentication > AD/LDAP</strong>. When false, user attributes are updated from SAML during user login. See <a href="https://about.mattermost.com/default-saml-ldap-sync" target="_blank">documentation</a> to learn more.'
                    }),
                    value: this.state.enableSyncWithLdap,
                    onChange: this.handleChange,
                    disabled: !this.state.enable
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'idpUrl',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.saml.idpUrlTitle',
                        defaultMessage: 'SAML SSO URL:'
                    }),
                    placeholder: Utils.localizeMessage('admin.saml.idpUrlEx', 'E.g.: "https://idp.example.org/SAML2/SSO/Login"'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.saml.idpUrlDesc',
                        defaultMessage: 'The URL where Mattermost sends a SAML request to start login sequence.'
                    }),
                    value: this.state.idpUrl,
                    onChange: this.handleChange,
                    disabled: !this.state.enable
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'idpDescriptorUrl',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.saml.idpDescriptorUrlTitle',
                        defaultMessage: 'Identity Provider Issuer URL:'
                    }),
                    placeholder: Utils.localizeMessage('admin.saml.idpDescriptorUrlEx', 'E.g.: "https://idp.example.org/SAML2/issuer"'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.saml.idpDescriptorUrlDesc',
                        defaultMessage: 'The issuer URL for the Identity Provider you use for SAML requests.'
                    }),
                    value: this.state.idpDescriptorUrl,
                    onChange: this.handleChange,
                    disabled: !this.state.enable
                }),
                idpCert,
                _react2.default.createElement(_boolean_setting2.default, {
                    id: 'verify',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.saml.verifyTitle',
                        defaultMessage: 'Verify Signature:'
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.saml.verifyDescription',
                        defaultMessage: 'When false, Mattermost will not verify that the signature sent from a SAML Response matches the Service Provider Login URL. Not recommended for production environments. For testing only.'
                    }),
                    value: this.state.verify,
                    disabled: !this.state.enable,
                    onChange: this.handleChange
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'assertionConsumerServiceURL',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.saml.assertionConsumerServiceURLTitle',
                        defaultMessage: 'Service Provider Login URL:'
                    }),
                    placeholder: Utils.localizeMessage('admin.saml.assertionConsumerServiceURLEx', 'E.g.: "https://<your-mattermost-url>/login/sso/saml"'),
                    helpText: consumerServiceUrlHelp,
                    value: this.state.assertionConsumerServiceURL,
                    onChange: this.handleChange,
                    disabled: !this.state.enable || !this.state.verify || this.state.siteUrlSet
                }),
                _react2.default.createElement(_boolean_setting2.default, {
                    id: 'encrypt',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.saml.encryptTitle',
                        defaultMessage: 'Enable Encryption:'
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.saml.encryptDescription',
                        defaultMessage: 'When false, Mattermost will not decrypt SAML Assertions encrypted with your Service Provider Public Certificate. Not recommended for production environments. For testing only.'
                    }),
                    value: this.state.encrypt,
                    disabled: !this.state.enable,
                    onChange: this.handleChange
                }),
                privKey,
                pubCert,
                _react2.default.createElement(_text_setting2.default, {
                    id: 'emailAttribute',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.saml.emailAttrTitle',
                        defaultMessage: 'Email Attribute:'
                    }),
                    placeholder: Utils.localizeMessage('admin.saml.emailAttrEx', 'E.g.: "Email" or "PrimaryEmail"'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.saml.emailAttrDesc',
                        defaultMessage: 'The attribute in the SAML Assertion that will be used to populate the email addresses of users in Mattermost.'
                    }),
                    value: this.state.emailAttribute,
                    onChange: this.handleChange,
                    disabled: !this.state.enable
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'usernameAttribute',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.saml.usernameAttrTitle',
                        defaultMessage: 'Username Attribute:'
                    }),
                    placeholder: Utils.localizeMessage('admin.saml.usernameAttrEx', 'E.g.: "Username"'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.saml.usernameAttrDesc',
                        defaultMessage: 'The attribute in the SAML Assertion that will be used to populate the username field in Mattermost.'
                    }),
                    value: this.state.usernameAttribute,
                    onChange: this.handleChange,
                    disabled: !this.state.enable
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'firstNameAttribute',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.saml.firstnameAttrTitle',
                        defaultMessage: 'First Name Attribute:'
                    }),
                    placeholder: Utils.localizeMessage('admin.saml.firstnameAttrEx', 'E.g.: "FirstName"'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.saml.firstnameAttrDesc',
                        defaultMessage: '(Optional) The attribute in the SAML Assertion that will be used to populate the first name of users in Mattermost.'
                    }),
                    value: this.state.firstNameAttribute,
                    onChange: this.handleChange,
                    disabled: !this.state.enable
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'lastNameAttribute',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.saml.lastnameAttrTitle',
                        defaultMessage: 'Last Name Attribute:'
                    }),
                    placeholder: Utils.localizeMessage('admin.saml.lastnameAttrEx', 'E.g.: "LastName"'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.saml.lastnameAttrDesc',
                        defaultMessage: '(Optional) The attribute in the SAML Assertion that will be used to populate the last name of users in Mattermost.'
                    }),
                    value: this.state.lastNameAttribute,
                    onChange: this.handleChange,
                    disabled: !this.state.enable
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'nicknameAttribute',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.saml.nicknameAttrTitle',
                        defaultMessage: 'Nickname Attribute:'
                    }),
                    placeholder: Utils.localizeMessage('admin.saml.nicknameAttrEx', 'E.g.: "Nickname"'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.saml.nicknameAttrDesc',
                        defaultMessage: '(Optional) The attribute in the SAML Assertion that will be used to populate the nickname of users in Mattermost.'
                    }),
                    value: this.state.nicknameAttribute,
                    onChange: this.handleChange,
                    disabled: !this.state.enable
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'positionAttribute',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.saml.positionAttrTitle',
                        defaultMessage: 'Position Attribute:'
                    }),
                    placeholder: Utils.localizeMessage('admin.saml.positionAttrEx', 'E.g.: "Role"'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.saml.positionAttrDesc',
                        defaultMessage: '(Optional) The attribute in the SAML Assertion that will be used to populate the position of users in Mattermost.'
                    }),
                    value: this.state.positionAttribute,
                    onChange: this.handleChange,
                    disabled: !this.state.enable
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'localeAttribute',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.saml.localeAttrTitle',
                        defaultMessage: 'Preferred Language Attribute:'
                    }),
                    placeholder: Utils.localizeMessage('admin.saml.localeAttrEx', 'E.g.: "Locale" or "PrimaryLanguage"'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.saml.localeAttrDesc',
                        defaultMessage: '(Optional) The attribute in the SAML Assertion that will be used to populate the language of users in Mattermost.'
                    }),
                    value: this.state.localeAttribute,
                    onChange: this.handleChange,
                    disabled: !this.state.enable
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'loginButtonText',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.saml.loginButtonTextTitle',
                        defaultMessage: 'Login Button Text:'
                    }),
                    placeholder: Utils.localizeMessage('admin.saml.loginButtonTextEx', 'E.g.: "With OKTA"'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.saml.loginButtonTextDesc',
                        defaultMessage: '(Optional) The text that appears in the login button on the login page. Defaults to "With SAML".'
                    }),
                    value: this.state.loginButtonText,
                    onChange: this.handleChange,
                    disabled: !this.state.enable
                })
            );
        }
    }]);
    return SamlSettings;
}(_admin_settings2.default);

exports.default = SamlSettings;

/***/ }),

/***/ 2619:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _jquery = __webpack_require__(773);

var _jquery2 = _interopRequireDefault(_jquery);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _setting = __webpack_require__(841);

var _setting2 = _interopRequireDefault(_setting);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var FileUploadSetting = function (_Setting) {
    (0, _inherits3.default)(FileUploadSetting, _Setting);
    (0, _createClass3.default)(FileUploadSetting, null, [{
        key: 'propTypes',
        get: function get() {
            return {
                id: _propTypes2.default.string.isRequired,
                label: _propTypes2.default.node.isRequired,
                helpText: _propTypes2.default.node,
                uploadingText: _propTypes2.default.node,
                onSubmit: _propTypes2.default.func.isRequired,
                disabled: _propTypes2.default.bool,
                fileType: _propTypes2.default.string.isRequired,
                error: _propTypes2.default.string
            };
        }
    }]);

    function FileUploadSetting(props) {
        (0, _classCallCheck3.default)(this, FileUploadSetting);

        var _this = (0, _possibleConstructorReturn3.default)(this, (FileUploadSetting.__proto__ || (0, _getPrototypeOf2.default)(FileUploadSetting)).call(this, props));

        _this.handleChange = _this.handleChange.bind(_this);
        _this.handleSubmit = _this.handleSubmit.bind(_this);

        _this.state = {
            fileName: null,
            serverError: props.error
        };
        return _this;
    }

    (0, _createClass3.default)(FileUploadSetting, [{
        key: 'handleChange',
        value: function handleChange() {
            var files = this.refs.fileInput.files;
            if (files && files.length > 0) {
                this.setState({ fileSelected: true, fileName: files[0].name });
            }
        }
    }, {
        key: 'handleSubmit',
        value: function handleSubmit(e) {
            var _this2 = this;

            e.preventDefault();

            (0, _jquery2.default)(this.refs.upload_button).button('loading');
            this.props.onSubmit(this.props.id, this.refs.fileInput.files[0], function (error) {
                (0, _jquery2.default)(_this2.refs.upload_button).button('reset');
                if (error) {
                    Utils.clearFileInput(_this2.refs.fileInput);
                }
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var serverError = void 0;
            if (this.state.serverError) {
                serverError = _react2.default.createElement(
                    'div',
                    { className: 'form-group has-error' },
                    _react2.default.createElement(
                        'label',
                        { className: 'control-label' },
                        this.state.serverError
                    )
                );
            }

            var btnClass = 'btn';
            if (this.state.fileSelected) {
                btnClass = 'btn btn-primary';
            }

            var fileName = void 0;
            if (this.state.fileName) {
                fileName = this.state.fileName;
            } else {
                fileName = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'admin.file_upload.noFile',
                    defaultMessage: 'No file uploaded'
                });
            }

            return _react2.default.createElement(
                _setting2.default,
                {
                    label: this.props.label,
                    helpText: this.props.helpText,
                    inputId: this.props.id
                },
                _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'div',
                        { className: 'file__upload' },
                        _react2.default.createElement(
                            'button',
                            {
                                className: 'btn btn-default',
                                disabled: this.props.disabled
                            },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'admin.file_upload.chooseFile',
                                defaultMessage: 'Choose File'
                            })
                        ),
                        _react2.default.createElement('input', {
                            ref: 'fileInput',
                            type: 'file',
                            disabled: this.props.disabled,
                            accept: this.props.fileType,
                            onChange: this.handleChange
                        })
                    ),
                    _react2.default.createElement(
                        'button',
                        {
                            className: btnClass,
                            disabled: !this.state.fileSelected,
                            onClick: this.handleSubmit,
                            ref: 'upload_button',
                            'data-loading-text': '<span class=\'glyphicon glyphicon-refresh glyphicon-refresh-animate\'></span> ' + this.props.uploadingText
                        },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'admin.file_upload.uploadFile',
                            defaultMessage: 'Upload'
                        })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'help-text no-margin' },
                        fileName
                    ),
                    serverError
                )
            );
        }
    }]);
    return FileUploadSetting;
}(_setting2.default);

exports.default = FileUploadSetting;

/***/ }),

/***/ 2620:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _jquery = __webpack_require__(773);

var _jquery2 = _interopRequireDefault(_jquery);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _setting = __webpack_require__(841);

var _setting2 = _interopRequireDefault(_setting);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var RemoveFileSetting = function (_Setting) {
    (0, _inherits3.default)(RemoveFileSetting, _Setting);
    (0, _createClass3.default)(RemoveFileSetting, null, [{
        key: 'propTypes',
        get: function get() {
            return {
                id: _propTypes2.default.string.isRequired,
                label: _propTypes2.default.node.isRequired,
                helpText: _propTypes2.default.node,
                removeButtonText: _propTypes2.default.node.isRequired,
                removingText: _propTypes2.default.node,
                fileName: _propTypes2.default.string.isRequired,
                onSubmit: _propTypes2.default.func.isRequired,
                disabled: _propTypes2.default.bool
            };
        }
    }]);

    function RemoveFileSetting(props) {
        (0, _classCallCheck3.default)(this, RemoveFileSetting);

        var _this = (0, _possibleConstructorReturn3.default)(this, (RemoveFileSetting.__proto__ || (0, _getPrototypeOf2.default)(RemoveFileSetting)).call(this, props));

        _this.handleRemove = _this.handleRemove.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(RemoveFileSetting, [{
        key: 'handleRemove',
        value: function handleRemove(e) {
            var _this2 = this;

            e.preventDefault();

            (0, _jquery2.default)(this.refs.remove_button).button('loading');
            this.props.onSubmit(this.props.id, function () {
                (0, _jquery2.default)(_this2.refs.remove_button).button('reset');
            });
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                _setting2.default,
                {
                    label: this.props.label,
                    helpText: this.props.helpText,
                    inputId: this.props.id
                },
                _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'div',
                        { className: 'help-text remove-filename' },
                        this.props.fileName
                    ),
                    _react2.default.createElement(
                        'button',
                        {
                            className: 'btn btn-danger',
                            onClick: this.handleRemove,
                            ref: 'remove_button',
                            disabled: this.props.disabled,
                            'data-loading-text': '<span class=\'glyphicon glyphicon-refresh glyphicon-refresh-animate\'></span> ' + this.props.removingText
                        },
                        this.props.removeButtonText
                    )
                )
            );
        }
    }]);
    return RemoveFileSetting;
}(_setting2.default);

exports.default = RemoveFileSetting;

/***/ }),

/***/ 2621:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _admin_settings = __webpack_require__(787);

var _admin_settings2 = _interopRequireDefault(_admin_settings);

var _settings_group = __webpack_require__(788);

var _settings_group2 = _interopRequireDefault(_settings_group);

var _text_setting = __webpack_require__(794);

var _text_setting2 = _interopRequireDefault(_text_setting);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var MINIMUM_IDLE_TIMEOUT = 5;

var SessionSettings = function (_AdminSettings) {
    (0, _inherits3.default)(SessionSettings, _AdminSettings);

    function SessionSettings(props) {
        (0, _classCallCheck3.default)(this, SessionSettings);

        var _this = (0, _possibleConstructorReturn3.default)(this, (SessionSettings.__proto__ || (0, _getPrototypeOf2.default)(SessionSettings)).call(this, props));

        _this.getConfigFromState = _this.getConfigFromState.bind(_this);

        _this.renderSettings = _this.renderSettings.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(SessionSettings, [{
        key: 'getConfigFromState',
        value: function getConfigFromState(config) {
            config.ServiceSettings.SessionLengthWebInDays = this.parseIntNonZero(this.state.sessionLengthWebInDays);
            config.ServiceSettings.SessionLengthMobileInDays = this.parseIntNonZero(this.state.sessionLengthMobileInDays);
            config.ServiceSettings.SessionLengthSSOInDays = this.parseIntNonZero(this.state.sessionLengthSSOInDays);
            config.ServiceSettings.SessionCacheInMinutes = this.parseIntNonZero(this.state.sessionCacheInMinutes);

            var timeout = this.parseInt(this.state.sessionIdleTimeoutInMinutes);
            if (timeout !== 0 && timeout < MINIMUM_IDLE_TIMEOUT) {
                config.ServiceSettings.SessionIdleTimeoutInMinutes = MINIMUM_IDLE_TIMEOUT;
            } else {
                config.ServiceSettings.SessionIdleTimeoutInMinutes = timeout;
            }

            return config;
        }
    }, {
        key: 'getStateFromConfig',
        value: function getStateFromConfig(config) {
            return {
                sessionLengthWebInDays: config.ServiceSettings.SessionLengthWebInDays,
                sessionLengthMobileInDays: config.ServiceSettings.SessionLengthMobileInDays,
                sessionLengthSSOInDays: config.ServiceSettings.SessionLengthSSOInDays,
                sessionCacheInMinutes: config.ServiceSettings.SessionCacheInMinutes,
                sessionIdleTimeoutInMinutes: config.ServiceSettings.SessionIdleTimeoutInMinutes
            };
        }
    }, {
        key: 'renderTitle',
        value: function renderTitle() {
            return _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'admin.security.session',
                defaultMessage: 'Sessions'
            });
        }
    }, {
        key: 'renderSettings',
        value: function renderSettings() {
            var idleTimeout = void 0;
            if (this.props.license.IsLicensed === 'true' && this.props.license.Compliance === 'true') {
                idleTimeout = _react2.default.createElement(_text_setting2.default, {
                    id: 'sessionIdleTimeoutInMinutes',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.service.sessionIdleTimeout',
                        defaultMessage: 'Session Idle Timeout (minutes):'
                    }),
                    placeholder: Utils.localizeMessage('admin.service.sessionIdleTimeoutEx', 'E.g.: "60"'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                        id: 'admin.service.sessionIdleTimeoutDesc',
                        defaultMessage: 'The number of minutes from the last time a user was active on the system to the expiry of the user\'s session. Once expired, the user will need to log in to continue. Minimum is 5 minutes, and 0 is unlimited.<br/><br/>Applies to the desktop app and browsers. For mobile apps, use an EMM provider to lock the app when not in use. In High Availability mode, enable IP hash load balancing for reliable timeout measurement.'
                    }),
                    value: this.state.sessionIdleTimeoutInMinutes,
                    onChange: this.handleChange
                });
            }

            return _react2.default.createElement(
                _settings_group2.default,
                null,
                _react2.default.createElement(_text_setting2.default, {
                    id: 'sessionLengthWebInDays',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.service.webSessionDays',
                        defaultMessage: 'Session Length AD/LDAP and Email (days):'
                    }),
                    placeholder: Utils.localizeMessage('admin.service.sessionDaysEx', 'E.g.: "30"'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.service.webSessionDaysDesc',
                        defaultMessage: 'The number of days from the last time a user entered their credentials to the expiry of the users session. After changing this setting, the new session length will take effect after the next time the user enters their credentials.'
                    }),
                    value: this.state.sessionLengthWebInDays,
                    onChange: this.handleChange
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'sessionLengthMobileInDays',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.service.mobileSessionDays',
                        defaultMessage: 'Session Length Mobile (days):'
                    }),
                    placeholder: Utils.localizeMessage('admin.service.sessionDaysEx', 'E.g.: "30"'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.service.mobileSessionDaysDesc',
                        defaultMessage: 'The number of days from the last time a user entered their credentials to the expiry of the users session. After changing this setting, the new session length will take effect after the next time the user enters their credentials.'
                    }),
                    value: this.state.sessionLengthMobileInDays,
                    onChange: this.handleChange
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'sessionLengthSSOInDays',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.service.ssoSessionDays',
                        defaultMessage: 'Session Length SSO (days):'
                    }),
                    placeholder: Utils.localizeMessage('admin.service.sessionDaysEx', 'E.g.: "30"'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.service.ssoSessionDaysDesc',
                        defaultMessage: 'The number of days from the last time a user entered their credentials to the expiry of the users session. If the authentication method is SAML or GitLab, the user may automatically be logged back in to Mattermost if they are already logged in to SAML or GitLab. After changing this setting, the setting will take effect after the next time the user enters their credentials. '
                    }),
                    value: this.state.sessionLengthSSOInDays,
                    onChange: this.handleChange
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'sessionCacheInMinutes',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.service.sessionCache',
                        defaultMessage: 'Session Cache (minutes):'
                    }),
                    placeholder: Utils.localizeMessage('admin.service.sessionDaysEx', 'E.g.: "30"'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.service.sessionCacheDesc',
                        defaultMessage: 'The number of minutes to cache a session in memory.'
                    }),
                    value: this.state.sessionCacheInMinutes,
                    onChange: this.handleChange
                }),
                idleTimeout
            );
        }
    }]);
    return SessionSettings;
}(_admin_settings2.default);

exports.default = SessionSettings;

/***/ }),

/***/ 2622:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _admin_settings = __webpack_require__(787);

var _admin_settings2 = _interopRequireDefault(_admin_settings);

var _boolean_setting = __webpack_require__(800);

var _boolean_setting2 = _interopRequireDefault(_boolean_setting);

var _generated_setting = __webpack_require__(997);

var _generated_setting2 = _interopRequireDefault(_generated_setting);

var _settings_group = __webpack_require__(788);

var _settings_group2 = _interopRequireDefault(_settings_group);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var SignupSettings = function (_AdminSettings) {
    (0, _inherits3.default)(SignupSettings, _AdminSettings);

    function SignupSettings(props) {
        (0, _classCallCheck3.default)(this, SignupSettings);

        var _this = (0, _possibleConstructorReturn3.default)(this, (SignupSettings.__proto__ || (0, _getPrototypeOf2.default)(SignupSettings)).call(this, props));

        _this.getConfigFromState = _this.getConfigFromState.bind(_this);

        _this.renderSettings = _this.renderSettings.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(SignupSettings, [{
        key: 'getConfigFromState',
        value: function getConfigFromState(config) {
            config.EmailSettings.RequireEmailVerification = this.state.requireEmailVerification;
            config.EmailSettings.InviteSalt = this.state.inviteSalt;
            config.TeamSettings.EnableOpenServer = this.state.enableOpenServer;

            return config;
        }
    }, {
        key: 'getStateFromConfig',
        value: function getStateFromConfig(config) {
            return {
                requireEmailVerification: config.EmailSettings.RequireEmailVerification,
                inviteSalt: config.EmailSettings.InviteSalt,
                enableOpenServer: config.TeamSettings.EnableOpenServer
            };
        }
    }, {
        key: 'renderTitle',
        value: function renderTitle() {
            return _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'admin.security.signup',
                defaultMessage: 'Signup'
            });
        }
    }, {
        key: 'renderSettings',
        value: function renderSettings() {
            return _react2.default.createElement(
                _settings_group2.default,
                null,
                _react2.default.createElement(_boolean_setting2.default, {
                    id: 'requireEmailVerification',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.email.requireVerificationTitle',
                        defaultMessage: 'Require Email Verification: '
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.email.requireVerificationDescription',
                        defaultMessage: 'Typically set to true in production. When true, Mattermost requires email verification after account creation prior to allowing login. Developers may set this field to false to skip sending verification emails for faster development.'
                    }),
                    value: this.state.requireEmailVerification,
                    onChange: this.handleChange,
                    disabled: this.state.sendEmailNotifications,
                    disabledText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.security.requireEmailVerification.disabled',
                        defaultMessage: 'Email verification cannot be changed while sending emails is disabled.'
                    })
                }),
                _react2.default.createElement(_generated_setting2.default, {
                    id: 'inviteSalt',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.email.inviteSaltTitle',
                        defaultMessage: 'Email Invite Salt:'
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.email.inviteSaltDescription',
                        defaultMessage: '32-character salt added to signing of email invites. Randomly generated on install. Click "Regenerate" to create new salt.'
                    }),
                    value: this.state.inviteSalt,
                    onChange: this.handleChange,
                    disabled: this.state.sendEmailNotifications,
                    disabledText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.security.inviteSalt.disabled',
                        defaultMessage: 'Invite salt cannot be changed while sending emails is disabled.'
                    })
                }),
                _react2.default.createElement(_boolean_setting2.default, {
                    id: 'enableOpenServer',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.team.openServerTitle',
                        defaultMessage: 'Enable Open Server: '
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.team.openServerDescription',
                        defaultMessage: 'When true, anyone can signup for a user account on this server without the need to be invited.'
                    }),
                    value: this.state.enableOpenServer,
                    onChange: this.handleChange
                })
            );
        }
    }]);
    return SignupSettings;
}(_admin_settings2.default);

exports.default = SignupSettings;

/***/ }),

/***/ 2623:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _s3_connection_test = __webpack_require__(2624);

var _s3_connection_test2 = _interopRequireDefault(_s3_connection_test);

var _admin_settings = __webpack_require__(787);

var _admin_settings2 = _interopRequireDefault(_admin_settings);

var _boolean_setting = __webpack_require__(800);

var _boolean_setting2 = _interopRequireDefault(_boolean_setting);

var _dropdown_setting = __webpack_require__(842);

var _dropdown_setting2 = _interopRequireDefault(_dropdown_setting);

var _settings_group = __webpack_require__(788);

var _settings_group2 = _interopRequireDefault(_settings_group);

var _text_setting = __webpack_require__(794);

var _text_setting2 = _interopRequireDefault(_text_setting);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DRIVER_LOCAL = 'local'; // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var DRIVER_S3 = 'amazons3';

var StorageSettings = function (_AdminSettings) {
    (0, _inherits3.default)(StorageSettings, _AdminSettings);

    function StorageSettings(props) {
        (0, _classCallCheck3.default)(this, StorageSettings);

        var _this = (0, _possibleConstructorReturn3.default)(this, (StorageSettings.__proto__ || (0, _getPrototypeOf2.default)(StorageSettings)).call(this, props));

        _this.getConfigFromState = _this.getConfigFromState.bind(_this);

        _this.renderSettings = _this.renderSettings.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(StorageSettings, [{
        key: 'getConfigFromState',
        value: function getConfigFromState(config) {
            config.FileSettings.EnableFileAttachments = this.state.enableFileAttachments;
            config.FileSettings.EnableMobileUpload = this.state.enableMobileUpload;
            config.FileSettings.EnableMobileDownload = this.state.enableMobileDownload;
            config.FileSettings.MaxFileSize = this.parseInt(this.state.maxFileSize) * 1024 * 1024;
            config.FileSettings.DriverName = this.state.driverName;
            config.FileSettings.Directory = this.state.directory;
            config.FileSettings.AmazonS3AccessKeyId = this.state.amazonS3AccessKeyId;
            config.FileSettings.AmazonS3SecretAccessKey = this.state.amazonS3SecretAccessKey;
            config.FileSettings.AmazonS3Bucket = this.state.amazonS3Bucket;
            config.FileSettings.AmazonS3Region = this.state.amazonS3Region;
            config.FileSettings.AmazonS3Endpoint = this.state.amazonS3Endpoint;
            config.FileSettings.AmazonS3SSL = this.state.amazonS3SSL;
            config.FileSettings.AmazonS3SSE = this.state.amazonS3SSE;
            config.FileSettings.AmazonS3Trace = this.state.amazonS3Trace;

            config.ServiceSettings.ImageProxyType = this.state.imageProxyType;
            config.ServiceSettings.ImageProxyOptions = this.state.imageProxyOptions;
            config.ServiceSettings.ImageProxyURL = this.state.imageProxyURL;
            return config;
        }
    }, {
        key: 'getStateFromConfig',
        value: function getStateFromConfig(config) {
            return {
                enableFileAttachments: config.FileSettings.EnableFileAttachments,
                enableMobileUpload: config.FileSettings.EnableMobileUpload,
                enableMobileDownload: config.FileSettings.EnableMobileDownload,
                maxFileSize: config.FileSettings.MaxFileSize / 1024 / 1024,
                driverName: config.FileSettings.DriverName,
                directory: config.FileSettings.Directory,
                amazonS3AccessKeyId: config.FileSettings.AmazonS3AccessKeyId,
                amazonS3SecretAccessKey: config.FileSettings.AmazonS3SecretAccessKey,
                amazonS3Bucket: config.FileSettings.AmazonS3Bucket,
                amazonS3Region: config.FileSettings.AmazonS3Region,
                amazonS3Endpoint: config.FileSettings.AmazonS3Endpoint,
                amazonS3SSL: config.FileSettings.AmazonS3SSL,
                amazonS3SSE: config.FileSettings.AmazonS3SSE,
                amazonS3Trace: config.FileSettings.AmazonS3Trace,

                imageProxyType: config.ServiceSettings.ImageProxyType,
                imageProxyOptions: config.ServiceSettings.ImageProxyOptions,
                imageProxyURL: config.ServiceSettings.ImageProxyURL
            };
        }
    }, {
        key: 'renderTitle',
        value: function renderTitle() {
            return _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'admin.files.storage',
                defaultMessage: 'Storage'
            });
        }
    }, {
        key: 'renderSettings',
        value: function renderSettings() {
            var amazonSSEComp = void 0;
            var mobileUploadDownloadSettings = [];
            if (this.props.license.IsLicensed === 'true' && this.props.license.Compliance === 'true') {
                mobileUploadDownloadSettings.push(_react2.default.createElement(_boolean_setting2.default, {
                    key: 'enableMobileUpload',
                    id: 'enableMobileUpload',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.file.enableMobileUploadTitle',
                        defaultMessage: 'Allow File Uploads on Mobile:'
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.file.enableMobileUploadDesc',
                        defaultMessage: 'When false, disables file uploads on mobile apps. If Allow File Sharing is set to true, users can still upload files from a mobile web browser.'
                    }),
                    value: this.state.enableMobileUpload,
                    onChange: this.handleChange,
                    disabled: !this.state.enableFileAttachments
                }));

                mobileUploadDownloadSettings.push(_react2.default.createElement(_boolean_setting2.default, {
                    key: 'enableMobileDownload',
                    id: 'enableMobileDownload',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.file.enableMobileDownloadTitle',
                        defaultMessage: 'Allow File Downloads on Mobile:'
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.file.enableMobileDownloadDesc',
                        defaultMessage: 'When false, disables file downloads on mobile apps. Users can still download files from a mobile web browser.'
                    }),
                    value: this.state.enableMobileDownload,
                    onChange: this.handleChange,
                    disabled: !this.state.enableFileAttachments
                }));

                amazonSSEComp = _react2.default.createElement(_boolean_setting2.default, {
                    id: 'amazonS3SSE',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.image.amazonS3SSETitle',
                        defaultMessage: 'Enable Server-Side Encryption for Amazon S3:'
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                        id: 'admin.image.amazonS3SSEDescription',
                        defaultMessage: 'When true, encrypt files in Amazon S3 using server-side encryption with Amazon S3-managed keys. See <a href="https://about.mattermost.com/default-server-side-encryption" target="_blank">documentation</a> to learn more.'
                    }),
                    value: this.state.amazonS3SSE,
                    onChange: this.handleChange,
                    disabled: this.state.driverName !== DRIVER_S3
                });
            }

            return _react2.default.createElement(
                _settings_group2.default,
                null,
                _react2.default.createElement(_dropdown_setting2.default, {
                    id: 'driverName',
                    values: [{ value: DRIVER_LOCAL, text: Utils.localizeMessage('admin.image.storeLocal', 'Local File System') }, { value: DRIVER_S3, text: Utils.localizeMessage('admin.image.storeAmazonS3', 'Amazon S3') }],
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.image.storeTitle',
                        defaultMessage: 'File Storage System:'
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                        id: 'admin.image.storeDescription',
                        defaultMessage: 'Storage system where files and image attachments are saved.<br /><br /> Selecting "Amazon S3" enables fields to enter your Amazon credentials and bucket details.<br /><br /> Selecting "Local File System" enables the field to specify a local file directory.'
                    }),
                    value: this.state.driverName,
                    onChange: this.handleChange
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'directory',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.image.localTitle',
                        defaultMessage: 'Local Storage Directory:'
                    }),
                    placeholder: Utils.localizeMessage('admin.image.localExample', 'E.g.: "./data/"'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.image.localDescription',
                        defaultMessage: 'Directory to which files and images are written. If blank, defaults to ./data/.'
                    }),
                    value: this.state.directory,
                    onChange: this.handleChange,
                    disabled: this.state.driverName !== DRIVER_LOCAL
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'amazonS3Bucket',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.image.amazonS3BucketTitle',
                        defaultMessage: 'Amazon S3 Bucket:'
                    }),
                    placeholder: Utils.localizeMessage('admin.image.amazonS3BucketExample', 'E.g.: "mattermost-media"'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.image.amazonS3BucketDescription',
                        defaultMessage: 'Name you selected for your S3 bucket in AWS.'
                    }),
                    value: this.state.amazonS3Bucket,
                    onChange: this.handleChange,
                    disabled: this.state.driverName !== DRIVER_S3
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'amazonS3Region',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.image.amazonS3RegionTitle',
                        defaultMessage: 'Amazon S3 Region:'
                    }),
                    placeholder: Utils.localizeMessage('admin.image.amazonS3RegionExample', 'E.g.: "us-east-1"'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.image.amazonS3RegionDescription',
                        defaultMessage: 'AWS region you selected when creating your S3 bucket. If no region is set, Mattermost attempts to get the appropriate region from AWS, or sets it to "us-east-1" if none found.'
                    }),
                    value: this.state.amazonS3Region,
                    onChange: this.handleChange,
                    disabled: this.state.driverName !== DRIVER_S3
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'amazonS3Endpoint',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.image.amazonS3EndpointTitle',
                        defaultMessage: 'Amazon S3 Endpoint:'
                    }),
                    placeholder: Utils.localizeMessage('admin.image.amazonS3EndpointExample', 'E.g.: "s3.amazonaws.com"'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.image.amazonS3EndpointDescription',
                        defaultMessage: 'Hostname of your S3 Compatible Storage provider. Defaults to "s3.amazonaws.com".'
                    }),
                    value: this.state.amazonS3Endpoint,
                    onChange: this.handleChange,
                    disabled: this.state.driverName !== DRIVER_S3
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'amazonS3AccessKeyId',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.image.amazonS3IdTitle',
                        defaultMessage: 'Amazon S3 Access Key ID:'
                    }),
                    placeholder: Utils.localizeMessage('admin.image.amazonS3IdExample', 'E.g.: "AKIADTOVBGERKLCBV"'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                        id: 'admin.image.amazonS3IdDescription',
                        defaultMessage: '(Optional) Only required if you do not want to authenticate to S3 using an <a target="_blank" href="https://about.mattermost.com/default-iam-role">IAM role</a>. Enter the Access Key ID provided by your Amazon EC2 administrator.'
                    }),
                    value: this.state.amazonS3AccessKeyId,
                    onChange: this.handleChange,
                    disabled: this.state.driverName !== DRIVER_S3
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'amazonS3SecretAccessKey',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.image.amazonS3SecretTitle',
                        defaultMessage: 'Amazon S3 Secret Access Key:'
                    }),
                    placeholder: Utils.localizeMessage('admin.image.amazonS3SecretExample', 'E.g.: "jcuS8PuvcpGhpgHhlcpT1Mx42pnqMxQY"'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.image.amazonS3SecretDescription',
                        defaultMessage: '(Optional) The secret access key associated with your Amazon S3 Access Key ID.'
                    }),
                    value: this.state.amazonS3SecretAccessKey,
                    onChange: this.handleChange,
                    disabled: this.state.driverName !== DRIVER_S3
                }),
                _react2.default.createElement(_boolean_setting2.default, {
                    id: 'amazonS3SSL',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.image.amazonS3SSLTitle',
                        defaultMessage: 'Enable Secure Amazon S3 Connections:'
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.image.amazonS3SSLDescription',
                        defaultMessage: 'When false, allow insecure connections to Amazon S3. Defaults to secure connections only.'
                    }),
                    value: this.state.amazonS3SSL,
                    onChange: this.handleChange,
                    disabled: this.state.driverName !== DRIVER_S3
                }),
                amazonSSEComp,
                _react2.default.createElement(_boolean_setting2.default, {
                    id: 'amazonS3Trace',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.image.amazonS3TraceTitle',
                        defaultMessage: 'Enable Amazon S3 Debugging:'
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.image.amazonS3TraceDescription',
                        defaultMessage: '(Development Mode) When true, log additional debugging information to the system logs.'
                    }),
                    value: this.state.amazonS3Trace,
                    onChange: this.handleChange,
                    disabled: this.state.driverName !== DRIVER_S3
                }),
                _react2.default.createElement(_s3_connection_test2.default, {
                    config: this.props.config,
                    getConfigFromState: this.getConfigFromState,
                    disabled: this.state.driverName !== DRIVER_S3
                }),
                _react2.default.createElement(_boolean_setting2.default, {
                    id: 'enableFileAttachments',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.file.enableFileAttachments',
                        defaultMessage: 'Allow File Sharing:'
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.file.enableFileAttachmentsDesc',
                        defaultMessage: 'When false, disables file sharing on the server. All file and image uploads on messages are forbidden across clients and devices, including mobile.'
                    }),
                    value: this.state.enableFileAttachments,
                    onChange: this.handleChange
                }),
                mobileUploadDownloadSettings,
                _react2.default.createElement(_text_setting2.default, {
                    id: 'maxFileSize',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.image.maxFileSizeTitle',
                        defaultMessage: 'Maximum File Size:'
                    }),
                    placeholder: Utils.localizeMessage('admin.image.maxFileSizeExample', '50'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.image.maxFileSizeDescription',
                        defaultMessage: 'Maximum file size for message attachments in megabytes. Caution: Verify server memory can support your setting choice. Large file sizes increase the risk of server crashes and failed uploads due to network interruptions.'
                    }),
                    value: this.state.maxFileSize,
                    onChange: this.handleChange,
                    disabled: !this.state.enableFileAttachments
                }),
                _react2.default.createElement(_dropdown_setting2.default, {
                    id: 'imageProxyType',
                    values: [{ value: '', text: Utils.localizeMessage('admin.image.proxyTypeNone', 'None') }, { value: 'atmos/camo', text: 'atmos/camo' }],
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.image.proxyType',
                        defaultMessage: 'Image Proxy Type:'
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                        id: 'admin.image.proxyTypeDescription',
                        defaultMessage: 'Configure an image proxy to load all Markdown images through a proxy. The image proxy prevents users from making insecure image requests, provides caching for increased performance, and automates image adjustments such as resizing. See <a href="https://about.mattermost.com/default-image-proxy-documentation">documentation</a> to learn more.'
                    }),
                    value: this.state.imageProxyType,
                    onChange: this.handleChange
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'imageProxyURL',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.image.proxyURL',
                        defaultMessage: 'Image Proxy URL:'
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.image.proxyURLDescription',
                        defaultMessage: 'URL of your image proxy server.'
                    }),
                    value: this.state.imageProxyURL,
                    onChange: this.handleChange,
                    disabled: !this.state.imageProxyType
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'imageProxyOptions',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.image.proxyOptions',
                        defaultMessage: 'Image Proxy Options:'
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.image.proxyOptionsDescription',
                        defaultMessage: 'Additional options such as the URL signing key. Refer to your image proxy documentation to learn more about what options are supported.'
                    }),
                    value: this.state.imageProxyOptions,
                    onChange: this.handleChange,
                    disabled: !this.state.imageProxyType
                })
            );
        }
    }]);
    return StorageSettings;
}(_admin_settings2.default);

exports.default = StorageSettings;

/***/ }),

/***/ 2624:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _redux = __webpack_require__(1);

var _admin = __webpack_require__(855);

var _s3_connection_test = __webpack_require__(2625);

var _s3_connection_test2 = _interopRequireDefault(_s3_connection_test);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2018-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(_s3_connection_test2.default);


function mapDispatchToProps(dispatch) {
    return {
        actions: (0, _redux.bindActionCreators)({
            testS3Connection: _admin.testS3Connection
        }, dispatch)
    };
}

/***/ }),

/***/ 2625:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(275);

var _stringify2 = _interopRequireDefault(_stringify);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2018-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var S3ConnectionTestButton = function (_React$Component) {
    (0, _inherits3.default)(S3ConnectionTestButton, _React$Component);
    (0, _createClass3.default)(S3ConnectionTestButton, null, [{
        key: 'propTypes',
        get: function get() {
            return {
                config: _propTypes2.default.object.isRequired,
                getConfigFromState: _propTypes2.default.func.isRequired,
                disabled: _propTypes2.default.bool.isRequired,
                actions: _propTypes2.default.shape({
                    testS3Connection: _propTypes2.default.func.isRequired
                }).isRequired
            };
        }
    }]);

    function S3ConnectionTestButton(props) {
        (0, _classCallCheck3.default)(this, S3ConnectionTestButton);

        var _this = (0, _possibleConstructorReturn3.default)(this, (S3ConnectionTestButton.__proto__ || (0, _getPrototypeOf2.default)(S3ConnectionTestButton)).call(this, props));

        _this.handleTestConnection = function (e) {
            e.preventDefault();

            _this.setState({
                testing: true,
                success: false,
                fail: null
            });

            var config = JSON.parse((0, _stringify2.default)(_this.props.config));
            _this.props.getConfigFromState(config);

            _this.props.actions.testS3Connection(config).then(function (data) {
                if (data.error) {
                    var fail = data.error.message;
                    if (data.error.detailed_error) {
                        fail += ' - ' + data.error.detailed_error;
                    }
                    _this.setState({
                        testing: false,
                        fail: fail
                    });
                } else {
                    _this.setState({
                        testing: false,
                        success: true
                    });
                }
            });
        };

        _this.state = {
            testing: false,
            success: false,
            fail: null
        };
        return _this;
    }

    (0, _createClass3.default)(S3ConnectionTestButton, [{
        key: 'render',
        value: function render() {
            var testMessage = null;
            if (this.state.success) {
                testMessage = _react2.default.createElement(
                    'div',
                    { className: 'alert alert-success' },
                    _react2.default.createElement('i', { className: 'fa fa-check' }),
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.s3.s3Success',
                        defaultMessage: 'Connection was successful'
                    })
                );
            } else if (this.state.fail) {
                testMessage = _react2.default.createElement(
                    'div',
                    { className: 'alert alert-warning' },
                    _react2.default.createElement('i', { className: 'fa fa-warning' }),
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.s3.s3Fail',
                        defaultMessage: 'Connection unsuccessful: {error}',
                        values: {
                            error: this.state.fail
                        }
                    })
                );
            }

            var contents = null;
            if (this.state.testing) {
                contents = _react2.default.createElement(
                    'span',
                    null,
                    _react2.default.createElement('span', { className: 'fa fa-refresh icon--rotate' }),
                    Utils.localizeMessage('admin.s3.testing', 'Testing...')
                );
            } else {
                contents = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'admin.s3.connectionS3Test',
                    defaultMessage: 'Test Connection'
                });
            }

            return _react2.default.createElement(
                'div',
                { className: 'form-group s3-connection-test' },
                _react2.default.createElement(
                    'div',
                    { className: 'col-sm-offset-4 col-sm-8' },
                    _react2.default.createElement(
                        'div',
                        { className: 'help-text' },
                        _react2.default.createElement(
                            'button',
                            {
                                className: 'btn btn-default',
                                onClick: this.handleTestConnection,
                                disabled: this.props.disabled
                            },
                            contents
                        ),
                        _react2.default.createElement(
                            'div',
                            null,
                            testMessage
                        )
                    )
                )
            );
        }
    }]);
    return S3ConnectionTestButton;
}(_react2.default.Component);

exports.default = S3ConnectionTestButton;

/***/ }),

/***/ 2626:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _admin_settings = __webpack_require__(787);

var _admin_settings2 = _interopRequireDefault(_admin_settings);

var _boolean_setting = __webpack_require__(800);

var _boolean_setting2 = _interopRequireDefault(_boolean_setting);

var _settings_group = __webpack_require__(788);

var _settings_group2 = _interopRequireDefault(_settings_group);

var _text_setting = __webpack_require__(794);

var _text_setting2 = _interopRequireDefault(_text_setting);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WebrtcSettings = function (_AdminSettings) {
    (0, _inherits3.default)(WebrtcSettings, _AdminSettings);

    function WebrtcSettings(props) {
        (0, _classCallCheck3.default)(this, WebrtcSettings);

        var _this = (0, _possibleConstructorReturn3.default)(this, (WebrtcSettings.__proto__ || (0, _getPrototypeOf2.default)(WebrtcSettings)).call(this, props));

        _this.getConfigFromState = _this.getConfigFromState.bind(_this);
        _this.renderSettings = _this.renderSettings.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(WebrtcSettings, [{
        key: 'getConfigFromState',
        value: function getConfigFromState(config) {
            config.WebrtcSettings.Enable = this.state.enableWebrtc;
            config.WebrtcSettings.GatewayWebsocketUrl = this.state.gatewayWebsocketUrl;
            config.WebrtcSettings.GatewayAdminUrl = this.state.gatewayAdminUrl;
            config.WebrtcSettings.GatewayAdminSecret = this.state.gatewayAdminSecret;
            config.WebrtcSettings.StunURI = this.state.stunURI;
            config.WebrtcSettings.TurnURI = this.state.turnURI;
            config.WebrtcSettings.TurnUsername = this.state.turnUsername;
            config.WebrtcSettings.TurnSharedKey = this.state.turnSharedKey;

            return config;
        }
    }, {
        key: 'getStateFromConfig',
        value: function getStateFromConfig(config) {
            var settings = config.WebrtcSettings;

            return {
                hasErrors: false,
                enableWebrtc: settings.Enable,
                gatewayWebsocketUrl: settings.GatewayWebsocketUrl,
                gatewayAdminUrl: settings.GatewayAdminUrl,
                gatewayAdminSecret: settings.GatewayAdminSecret,
                stunURI: settings.StunURI,
                turnURI: settings.TurnURI,
                turnUsername: settings.TurnUsername,
                turnSharedKey: settings.TurnSharedKey
            };
        }
    }, {
        key: 'renderTitle',
        value: function renderTitle() {
            return _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'admin.integrations.webrtc',
                defaultMessage: 'Mattermost WebRTC (Beta)'
            });
        }
    }, {
        key: 'renderSettings',
        value: function renderSettings() {
            return _react2.default.createElement(
                _settings_group2.default,
                null,
                _react2.default.createElement(_boolean_setting2.default, {
                    id: 'enableWebrtc',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.webrtc.enableTitle',
                        defaultMessage: 'Enable Mattermost WebRTC: '
                    }),
                    helpText: _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                        id: 'admin.webrtc.enableDescription',
                        defaultMessage: 'When true, Mattermost allows making <strong>one-on-one</strong> video calls. WebRTC calls are available on Chrome, Firefox and Mattermost Desktop Apps.'
                    }),
                    value: this.state.enableWebrtc,
                    onChange: this.handleChange
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'gatewayWebsocketUrl',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.webrtc.gatewayWebsocketUrlTitle',
                        defaultMessage: 'Gateway WebSocket URL:'
                    }),
                    placeholder: Utils.localizeMessage('admin.webrtc.gatewayWebsocketUrlExample', 'E.g.: "wss://webrtc.mattermost.com:8189"'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.webrtc.gatewayWebsocketUrlDescription',
                        defaultMessage: 'Enter wss://<mattermost-webrtc-gateway-url>:<port>. Make sure you use WS or WSS in your URL depending on your server configuration. This is the WebSocket used to signal and establish communication between the peers.'
                    }),
                    value: this.state.gatewayWebsocketUrl,
                    onChange: this.handleChange,
                    disabled: !this.state.enableWebrtc
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'gatewayAdminUrl',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.webrtc.gatewayAdminUrlTitle',
                        defaultMessage: 'Gateway Admin URL:'
                    }),
                    placeholder: Utils.localizeMessage('admin.webrtc.gatewayAdminUrlExample', 'E.g.: "https://webrtc.mattermost.com:7089/admin"'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.webrtc.gatewayAdminUrlDescription',
                        defaultMessage: 'Enter https://<mattermost-webrtc-gateway-url>:<port>/admin. Make sure you use HTTP or HTTPS in your URL depending on your server configuration. Mattermost WebRTC uses this URL to obtain valid tokens for each peer to establish the connection.'
                    }),
                    value: this.state.gatewayAdminUrl,
                    onChange: this.handleChange,
                    disabled: !this.state.enableWebrtc
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'gatewayAdminSecret',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.webrtc.gatewayAdminSecretTitle',
                        defaultMessage: 'Gateway Admin Secret:'
                    }),
                    placeholder: Utils.localizeMessage('admin.webrtc.gatewayAdminSecretExample', 'E.g.: "PVRzWNN1Tg6szn7IQWvhpAvLByScWxdy"'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.webrtc.gatewayAdminSecretDescription',
                        defaultMessage: 'Enter your admin secret password to access the Gateway Admin URL.'
                    }),
                    value: this.state.gatewayAdminSecret,
                    onChange: this.handleChange,
                    disabled: !this.state.enableWebrtc
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'stunURI',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.webrtc.stunUriTitle',
                        defaultMessage: 'STUN URI:'
                    }),
                    placeholder: Utils.localizeMessage('admin.webrtc.stunUriExample', 'E.g.: "stun:webrtc.mattermost.com:5349"'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.webrtc.stunUriDescription',
                        defaultMessage: 'Enter your STUN URI as stun:<your-stun-url>:<port>. STUN is a standardized network protocol to allow an end host to assist devices to access its public IP address if it is located behind a NAT.'
                    }),
                    value: this.state.stunURI,
                    onChange: this.handleChange,
                    disabled: !this.state.enableWebrtc
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'turnURI',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.webrtc.turnUriTitle',
                        defaultMessage: 'TURN URI:'
                    }),
                    placeholder: Utils.localizeMessage('admin.webrtc.turnUriExample', 'E.g.: "turn:webrtc.mattermost.com:5349"'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.webrtc.turnUriDescription',
                        defaultMessage: 'Enter your TURN URI as turn:<your-turn-url>:<port>. TURN is a standardized network protocol to allow an end host to assist devices to establish a connection by using a relay public IP address if it is located behind a symmetric NAT.'
                    }),
                    value: this.state.turnURI,
                    onChange: this.handleChange,
                    disabled: !this.state.enableWebrtc
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'turnUsername',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.webrtc.turnUsernameTitle',
                        defaultMessage: 'TURN Username:'
                    }),
                    placeholder: Utils.localizeMessage('admin.webrtc.turnUsernameExample', 'E.g.: "myusername"'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.webrtc.turnUsernameDescription',
                        defaultMessage: 'Enter your TURN Server Username.'
                    }),
                    value: this.state.turnUsername,
                    onChange: this.handleChange,
                    disabled: !this.state.enableWebrtc || !this.state.turnURI
                }),
                _react2.default.createElement(_text_setting2.default, {
                    id: 'turnSharedKey',
                    label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.webrtc.turnSharedKeyTitle',
                        defaultMessage: 'TURN Shared Key:'
                    }),
                    placeholder: Utils.localizeMessage('admin.webrtc.turnSharedKeyExample', 'E.g.: "bXdkOWQxc3d0Ynk3emY5ZmsxZ3NtazRjaWg="'),
                    helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.webrtc.turnSharedKeyDescription',
                        defaultMessage: 'Enter your TURN Server Shared Key. This is used to created dynamic passwords to establish the connection. Each password is valid for a short period of time.'
                    }),
                    value: this.state.turnSharedKey,
                    onChange: this.handleChange,
                    disabled: !this.state.enableWebrtc || !this.state.turnURI
                })
            );
        }
    }]);
    return WebrtcSettings;
}(_admin_settings2.default); // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = WebrtcSettings;

/***/ }),

/***/ 2627:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(761);

var _confirm_modal = __webpack_require__(819);

var _confirm_modal2 = _interopRequireDefault(_confirm_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var DiscardChangesModal = function (_React$PureComponent) {
    (0, _inherits3.default)(DiscardChangesModal, _React$PureComponent);

    function DiscardChangesModal() {
        (0, _classCallCheck3.default)(this, DiscardChangesModal);
        return (0, _possibleConstructorReturn3.default)(this, (DiscardChangesModal.__proto__ || (0, _getPrototypeOf2.default)(DiscardChangesModal)).apply(this, arguments));
    }

    (0, _createClass3.default)(DiscardChangesModal, [{
        key: 'render',
        value: function render() {
            var title = _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'discard_changes_modal.title',
                defaultMessage: 'Discard Changes?'
            });

            var message = _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'discard_changes_modal.message',
                defaultMessage: 'You have unsaved changes, are you sure you want to discard them?'
            });

            var buttonClass = 'btn btn-primary';
            var button = _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'discard_changes_modal.leave',
                defaultMessage: 'Yes, Discard'
            });

            var modalClass = 'discard-changes-modal';

            var _props = this.props,
                show = _props.show,
                onConfirm = _props.onConfirm,
                onCancel = _props.onCancel;


            return _react2.default.createElement(_confirm_modal2.default, {
                show: show,
                title: title,
                message: message,
                modalClass: modalClass,
                confirmButtonClass: buttonClass,
                confirmButtonText: button,
                onConfirm: onConfirm,
                onCancel: onCancel
            });
        }
    }]);
    return DiscardChangesModal;
}(_react2.default.PureComponent);

DiscardChangesModal.propTypes = {

    /*
     * Bool whether the modal is shown
     */
    show: _propTypes2.default.bool.isRequired,

    /*
     * Action to call on confirm
     */
    onConfirm: _propTypes2.default.func.isRequired,

    /*
     * Action to call on cancel
     */
    onCancel: _propTypes2.default.func.isRequired

};
exports.default = DiscardChangesModal;

/***/ }),

/***/ 2628:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _redux = __webpack_require__(1);

var _admin = __webpack_require__(855);

var _general = __webpack_require__(113);

var _admin_sidebar = __webpack_require__(2629);

var _admin_sidebar2 = _interopRequireDefault(_admin_sidebar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state) {
    var license = (0, _general.getLicense)(state);
    var config = (0, _general.getConfig)(state);
    var buildEnterpriseReady = config.BuildEnterpriseReady === 'true';
    var siteName = config.SiteName;

    return {
        license: license,
        config: state.entities.admin.config,
        plugins: state.entities.admin.plugins,
        buildEnterpriseReady: buildEnterpriseReady,
        siteName: siteName
    };
} // Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapDispatchToProps(dispatch) {
    return {
        actions: (0, _redux.bindActionCreators)({
            getPlugins: _admin.getPlugins
        }, dispatch)
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps, null, { pure: false })(_admin_sidebar2.default);

/***/ }),

/***/ 2629:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = __webpack_require__(116);

var _keys2 = _interopRequireDefault(_keys);

var _values = __webpack_require__(801);

var _values2 = _interopRequireDefault(_values);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _jquery = __webpack_require__(773);

var _jquery2 = _interopRequireDefault(_jquery);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _admin_sidebar_category = __webpack_require__(2630);

var _admin_sidebar_category2 = _interopRequireDefault(_admin_sidebar_category);

var _admin_sidebar_header = __webpack_require__(2631);

var _admin_sidebar_header2 = _interopRequireDefault(_admin_sidebar_header);

var _admin_sidebar_section = __webpack_require__(2635);

var _admin_sidebar_section2 = _interopRequireDefault(_admin_sidebar_section);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var AdminSidebar = function (_React$Component) {
    (0, _inherits3.default)(AdminSidebar, _React$Component);

    function AdminSidebar() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, AdminSidebar);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AdminSidebar.__proto__ || (0, _getPrototypeOf2.default)(AdminSidebar)).call.apply(_ref, [this].concat(args))), _this), _this.updateTitle = function () {
            var currentSiteName = '';
            if (_this.props.siteName) {
                currentSiteName = ' - ' + _this.props.siteName;
            }

            document.title = Utils.localizeMessage('sidebar_right_menu.console', 'System Console') + currentSiteName;
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(AdminSidebar, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.props.config.PluginSettings.Enable) {
                this.props.actions.getPlugins();
            }

            this.updateTitle();

            if (!Utils.isMobile()) {
                (0, _jquery2.default)('.admin-sidebar .nav-pills__container').perfectScrollbar({
                    suppressScrollX: true
                });
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            if (!Utils.isMobile()) {
                (0, _jquery2.default)('.admin-sidebar .nav-pills__container').perfectScrollbar({
                    suppressScrollX: true
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var oauthSettings = null;
            var ldapSettings = null;
            var samlSettings = null;
            var clusterSettings = null;
            var metricsSettings = null;
            var complianceSettings = null;
            var mfaSettings = null;
            var messageExportSettings = null;
            var complianceSection = null;

            var license = null;
            var audits = null;
            var policy = null;

            if (this.props.buildEnterpriseReady) {
                license = _react2.default.createElement(_admin_sidebar_section2.default, {
                    name: 'license',
                    title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.sidebar.license',
                        defaultMessage: 'Edition and License'
                    })
                });
            }

            if (this.props.license.IsLicensed === 'true') {
                if (this.props.license.LDAP === 'true') {
                    ldapSettings = _react2.default.createElement(_admin_sidebar_section2.default, {
                        name: 'ldap',
                        title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'admin.sidebar.ldap',
                            defaultMessage: 'AD/LDAP'
                        })
                    });
                }

                if (this.props.license.Cluster === 'true') {
                    clusterSettings = _react2.default.createElement(_admin_sidebar_section2.default, {
                        name: 'cluster',
                        title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'admin.sidebar.cluster',
                            defaultMessage: 'High Availability'
                        })
                    });
                }

                if (this.props.license.Metrics === 'true') {
                    metricsSettings = _react2.default.createElement(_admin_sidebar_section2.default, {
                        name: 'metrics',
                        title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'admin.sidebar.metrics',
                            defaultMessage: 'Performance Monitoring'
                        })
                    });
                }

                if (this.props.license.SAML === 'true') {
                    samlSettings = _react2.default.createElement(_admin_sidebar_section2.default, {
                        name: 'saml',
                        title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'admin.sidebar.saml',
                            defaultMessage: 'SAML 2.0'
                        })
                    });
                }

                if (this.props.license.Compliance === 'true') {
                    complianceSettings = _react2.default.createElement(_admin_sidebar_section2.default, {
                        name: 'compliance',
                        title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'admin.sidebar.compliance',
                            defaultMessage: 'Compliance'
                        })
                    });
                }

                if (this.props.license.MFA === 'true') {
                    mfaSettings = _react2.default.createElement(_admin_sidebar_section2.default, {
                        name: 'mfa',
                        title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'admin.sidebar.mfa',
                            defaultMessage: 'MFA'
                        })
                    });
                }

                if (this.props.license.MessageExport === 'true') {
                    messageExportSettings = _react2.default.createElement(_admin_sidebar_section2.default, {
                        name: 'message_export',
                        title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'admin.sidebar.compliance_export',
                            defaultMessage: 'Compliance Export (Beta)'
                        })
                    });
                }

                oauthSettings = _react2.default.createElement(_admin_sidebar_section2.default, {
                    name: 'oauth',
                    title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.sidebar.oauth',
                        defaultMessage: 'OAuth 2.0'
                    })
                });

                policy = _react2.default.createElement(_admin_sidebar_section2.default, {
                    name: 'policy',
                    title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.sidebar.policy',
                        defaultMessage: 'Policy'
                    })
                });
            } else {
                oauthSettings = _react2.default.createElement(_admin_sidebar_section2.default, {
                    name: 'gitlab',
                    title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.sidebar.gitlab',
                        defaultMessage: 'GitLab'
                    })
                });
            }

            if (this.props.license.IsLicensed === 'true') {
                audits = _react2.default.createElement(_admin_sidebar_section2.default, {
                    name: 'audits',
                    title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.sidebar.audits',
                        defaultMessage: 'Complaince and Auditing'
                    })
                });
            }

            var customBranding = null;

            if (this.props.license.IsLicensed === 'true') {
                customBranding = _react2.default.createElement(_admin_sidebar_section2.default, {
                    name: 'custom_brand',
                    title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.sidebar.customBrand',
                        defaultMessage: 'Custom Branding'
                    })
                });
            }

            var otherCategory = null;
            if (license || audits) {
                otherCategory = _react2.default.createElement(
                    _admin_sidebar_category2.default,
                    {
                        parentLink: '/admin_console',
                        icon: 'fa-wrench',
                        title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'admin.sidebar.other',
                            defaultMessage: 'OTHER'
                        })
                    },
                    license,
                    audits
                );
            }

            var webrtcSettings = _react2.default.createElement(_admin_sidebar_section2.default, {
                name: 'webrtc',
                title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'admin.sidebar.webrtc',
                    defaultMessage: 'WebRTC (Beta)'
                })
            });

            var elasticSearchSettings = null;
            if (this.props.license.IsLicensed === 'true' && this.props.license.Elasticsearch === 'true') {
                elasticSearchSettings = _react2.default.createElement(_admin_sidebar_section2.default, {
                    name: 'elasticsearch',
                    title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.sidebar.elasticsearch',
                        defaultMessage: 'Elasticsearch (Beta)'
                    })
                });
            }

            var dataRetentionSettings = null;
            if (this.props.license.IsLicensed === 'true' && this.props.license.DataRetention === 'true') {
                dataRetentionSettings = _react2.default.createElement(_admin_sidebar_section2.default, {
                    name: 'data_retention',
                    title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.sidebar.data_retention',
                        defaultMessage: 'Data Retention Policy (Beta)'
                    })
                });
            }

            var SHOW_CLIENT_VERSIONS = false;
            var clientVersions = null;
            if (SHOW_CLIENT_VERSIONS) {
                clientVersions = _react2.default.createElement(_admin_sidebar_section2.default, {
                    name: 'client_versions',
                    title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.sidebar.client_versions',
                        defaultMessage: 'Client Versions'
                    })
                });
            }

            if (dataRetentionSettings || messageExportSettings) {
                complianceSection = _react2.default.createElement(
                    _admin_sidebar_section2.default,
                    {
                        name: 'compliance',
                        type: 'text',
                        title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'admin.sidebar.compliance',
                            defaultMessage: 'Compliance'
                        })
                    },
                    dataRetentionSettings,
                    messageExportSettings
                );
            }

            var customPlugins = [];
            if (this.props.config.PluginSettings.Enable) {
                (0, _values2.default)(this.props.plugins).forEach(function (p) {
                    if (!p.settings_schema || (0, _keys2.default)(p.settings_schema) === 0) {
                        return;
                    }

                    customPlugins.push(_react2.default.createElement(_admin_sidebar_section2.default, {
                        key: 'customplugin' + p.id,
                        name: 'custom/' + p.id,
                        title: p.name
                    }));
                });
            }

            return _react2.default.createElement(
                'div',
                { className: 'admin-sidebar' },
                _react2.default.createElement(_admin_sidebar_header2.default, null),
                _react2.default.createElement(
                    'div',
                    { className: 'nav-pills__container' },
                    _react2.default.createElement(
                        'ul',
                        { className: 'nav nav-pills nav-stacked' },
                        _react2.default.createElement(
                            _admin_sidebar_category2.default,
                            {
                                parentLink: '/admin_console',
                                icon: 'fa-bar-chart',
                                title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'admin.sidebar.reports',
                                    defaultMessage: 'REPORTING'
                                })
                            },
                            _react2.default.createElement(_admin_sidebar_section2.default, {
                                name: 'system_analytics',
                                title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'admin.sidebar.view_statistics',
                                    defaultMessage: 'Site Statistics'
                                })
                            }),
                            _react2.default.createElement(_admin_sidebar_section2.default, {
                                name: 'team_analytics',
                                title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'admin.sidebar.statistics',
                                    defaultMessage: 'Team Statistics'
                                })
                            }),
                            _react2.default.createElement(_admin_sidebar_section2.default, {
                                name: 'users',
                                title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'admin.sidebar.users',
                                    defaultMessage: 'Users'
                                })
                            }),
                            _react2.default.createElement(_admin_sidebar_section2.default, {
                                name: 'logs',
                                title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'admin.sidebar.logs',
                                    defaultMessage: 'Logs'
                                })
                            })
                        ),
                        _react2.default.createElement(
                            _admin_sidebar_category2.default,
                            {
                                sectionClass: 'sections--settings',
                                parentLink: '/admin_console',
                                icon: 'fa-gear',
                                title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'admin.sidebar.settings',
                                    defaultMessage: 'SETTINGS'
                                })
                            },
                            _react2.default.createElement(
                                _admin_sidebar_section2.default,
                                {
                                    name: 'general',
                                    type: 'text',
                                    title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'admin.sidebar.general',
                                        defaultMessage: 'General'
                                    })
                                },
                                _react2.default.createElement(_admin_sidebar_section2.default, {
                                    name: 'configuration',
                                    title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'admin.sidebar.configuration',
                                        defaultMessage: 'Configuration'
                                    })
                                }),
                                _react2.default.createElement(_admin_sidebar_section2.default, {
                                    name: 'localization',
                                    title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'admin.sidebar.localization',
                                        defaultMessage: 'Localization'
                                    })
                                }),
                                _react2.default.createElement(_admin_sidebar_section2.default, {
                                    name: 'users_and_teams',
                                    title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'admin.sidebar.usersAndTeams',
                                        defaultMessage: 'Users and Teams'
                                    })
                                }),
                                policy,
                                _react2.default.createElement(_admin_sidebar_section2.default, {
                                    name: 'privacy',
                                    title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'admin.sidebar.privacy',
                                        defaultMessage: 'Privacy'
                                    })
                                }),
                                complianceSettings,
                                _react2.default.createElement(_admin_sidebar_section2.default, {
                                    name: 'logging',
                                    title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'admin.sidebar.logging',
                                        defaultMessage: 'Logging'
                                    })
                                })
                            ),
                            _react2.default.createElement(
                                _admin_sidebar_section2.default,
                                {
                                    name: 'authentication',
                                    type: 'text',
                                    title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'admin.sidebar.authentication',
                                        defaultMessage: 'Authentication'
                                    })
                                },
                                _react2.default.createElement(_admin_sidebar_section2.default, {
                                    name: 'authentication_email',
                                    title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'admin.sidebar.email',
                                        defaultMessage: 'Email'
                                    })
                                }),
                                oauthSettings,
                                ldapSettings,
                                samlSettings,
                                mfaSettings
                            ),
                            _react2.default.createElement(
                                _admin_sidebar_section2.default,
                                {
                                    name: 'security',
                                    type: 'text',
                                    title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'admin.sidebar.security',
                                        defaultMessage: 'Security'
                                    })
                                },
                                _react2.default.createElement(_admin_sidebar_section2.default, {
                                    name: 'sign_up',
                                    title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'admin.sidebar.signUp',
                                        defaultMessage: 'Sign Up'
                                    })
                                }),
                                _react2.default.createElement(_admin_sidebar_section2.default, {
                                    name: 'password',
                                    title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'admin.sidebar.password',
                                        defaultMessage: 'Password'
                                    })
                                }),
                                _react2.default.createElement(_admin_sidebar_section2.default, {
                                    name: 'public_links',
                                    title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'admin.sidebar.publicLinks',
                                        defaultMessage: 'Public Links'
                                    })
                                }),
                                _react2.default.createElement(_admin_sidebar_section2.default, {
                                    name: 'sessions',
                                    title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'admin.sidebar.sessions',
                                        defaultMessage: 'Sessions'
                                    })
                                }),
                                _react2.default.createElement(_admin_sidebar_section2.default, {
                                    name: 'connections',
                                    title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'admin.sidebar.connections',
                                        defaultMessage: 'Connections'
                                    })
                                }),
                                clientVersions
                            ),
                            _react2.default.createElement(
                                _admin_sidebar_section2.default,
                                {
                                    name: 'notifications',
                                    type: 'text',
                                    title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'admin.sidebar.notifications',
                                        defaultMessage: 'Notifications'
                                    })
                                },
                                _react2.default.createElement(_admin_sidebar_section2.default, {
                                    name: 'notifications_email',
                                    title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'admin.sidebar.email',
                                        defaultMessage: 'Email'
                                    })
                                }),
                                _react2.default.createElement(_admin_sidebar_section2.default, {
                                    name: 'push',
                                    title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'admin.sidebar.push',
                                        defaultMessage: 'Mobile Push'
                                    })
                                })
                            ),
                            _react2.default.createElement(
                                _admin_sidebar_section2.default,
                                {
                                    name: 'integrations',
                                    type: 'text',
                                    title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'admin.sidebar.integrations',
                                        defaultMessage: 'Integrations'
                                    })
                                },
                                _react2.default.createElement(_admin_sidebar_section2.default, {
                                    name: 'custom',
                                    title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'admin.sidebar.customIntegrations',
                                        defaultMessage: 'Custom Integrations'
                                    })
                                }),
                                webrtcSettings,
                                _react2.default.createElement(_admin_sidebar_section2.default, {
                                    name: 'external',
                                    title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'admin.sidebar.external',
                                        defaultMessage: 'External Services'
                                    })
                                })
                            ),
                            _react2.default.createElement(
                                _admin_sidebar_section2.default,
                                {
                                    name: 'plugins',
                                    type: 'text',
                                    title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'admin.sidebar.plugins',
                                        defaultMessage: 'Plugins (Beta)'
                                    })
                                },
                                _react2.default.createElement(_admin_sidebar_section2.default, {
                                    name: 'configuration',
                                    title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'admin.sidebar.plugins.configuration',
                                        defaultMessage: 'Configuration'
                                    })
                                }),
                                _react2.default.createElement(_admin_sidebar_section2.default, {
                                    name: 'management',
                                    title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'admin.sidebar.plugins.management',
                                        defaultMessage: 'Management'
                                    })
                                }),
                                customPlugins
                            ),
                            _react2.default.createElement(
                                _admin_sidebar_section2.default,
                                {
                                    name: 'files',
                                    type: 'text',
                                    title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'admin.sidebar.files',
                                        defaultMessage: 'Files'
                                    })
                                },
                                _react2.default.createElement(_admin_sidebar_section2.default, {
                                    key: 'storage',
                                    name: 'storage',
                                    title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'admin.sidebar.storage',
                                        defaultMessage: 'Storage'
                                    })
                                })
                            ),
                            _react2.default.createElement(
                                _admin_sidebar_section2.default,
                                {
                                    name: 'customization',
                                    type: 'text',
                                    title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'admin.sidebar.customization',
                                        defaultMessage: 'Customization'
                                    })
                                },
                                customBranding,
                                _react2.default.createElement(_admin_sidebar_section2.default, {
                                    name: 'emoji',
                                    title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'admin.sidebar.emoji',
                                        defaultMessage: 'Emoji'
                                    })
                                }),
                                _react2.default.createElement(_admin_sidebar_section2.default, {
                                    name: 'link_previews',
                                    title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'admin.sidebar.linkPreviews',
                                        defaultMessage: 'Link Previews'
                                    })
                                }),
                                _react2.default.createElement(_admin_sidebar_section2.default, {
                                    name: 'legal_and_support',
                                    title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'admin.sidebar.legalAndSupport',
                                        defaultMessage: 'Legal and Support'
                                    })
                                }),
                                _react2.default.createElement(_admin_sidebar_section2.default, {
                                    name: 'native_app_links',
                                    title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'admin.sidebar.nativeAppLinks',
                                        defaultMessage: 'Mattermost App Links'
                                    })
                                })
                            ),
                            complianceSection,
                            _react2.default.createElement(
                                _admin_sidebar_section2.default,
                                {
                                    name: 'advanced',
                                    type: 'text',
                                    title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'admin.sidebar.advanced',
                                        defaultMessage: 'Advanced'
                                    })
                                },
                                _react2.default.createElement(_admin_sidebar_section2.default, {
                                    name: 'rate',
                                    title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'admin.sidebar.rateLimiting',
                                        defaultMessage: 'Rate Limiting'
                                    })
                                }),
                                _react2.default.createElement(_admin_sidebar_section2.default, {
                                    name: 'database',
                                    title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'admin.sidebar.database',
                                        defaultMessage: 'Database'
                                    })
                                }),
                                elasticSearchSettings,
                                _react2.default.createElement(_admin_sidebar_section2.default, {
                                    name: 'developer',
                                    title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'admin.sidebar.developer',
                                        defaultMessage: 'Developer'
                                    })
                                }),
                                clusterSettings,
                                metricsSettings
                            )
                        ),
                        otherCategory
                    )
                )
            );
        }
    }], [{
        key: 'contextTypes',
        get: function get() {
            return {
                router: _propTypes2.default.object.isRequired
            };
        }
    }]);
    return AdminSidebar;
}(_react2.default.Component);

AdminSidebar.propTypes = {
    license: _propTypes2.default.object.isRequired,
    config: _propTypes2.default.object,
    plugins: _propTypes2.default.object,
    buildEnterpriseReady: _propTypes2.default.bool,
    siteName: _propTypes2.default.string,
    actions: _propTypes2.default.shape({

        /*
         * Function to get installed plugins
         */
        getPlugins: _propTypes2.default.func.isRequired
    }).isRequired
};
AdminSidebar.defaultProps = {
    plugins: {}
};
exports.default = AdminSidebar;

/***/ }),

/***/ 2630:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(269);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AdminSidebarCategory = function (_React$Component) {
    (0, _inherits3.default)(AdminSidebarCategory, _React$Component);

    function AdminSidebarCategory() {
        (0, _classCallCheck3.default)(this, AdminSidebarCategory);
        return (0, _possibleConstructorReturn3.default)(this, (AdminSidebarCategory.__proto__ || (0, _getPrototypeOf2.default)(AdminSidebarCategory)).apply(this, arguments));
    }

    (0, _createClass3.default)(AdminSidebarCategory, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var link = this.props.parentLink;
            var title = _react2.default.createElement(
                'div',
                { className: 'category-title category-title--active' },
                _react2.default.createElement('i', { className: 'category-icon fa ' + this.props.icon }),
                _react2.default.createElement(
                    'span',
                    { className: 'category-title__text' },
                    this.props.title
                ),
                this.props.action
            );

            if (this.props.name) {
                link += '/' + name;
                title = _react2.default.createElement(
                    _reactRouterDom.NavLink,
                    {
                        to: link,
                        className: 'category-title',
                        activeClassName: 'category-title category-title--active'
                    },
                    title
                );
            }

            var clonedChildren = null;
            if (this.props.children) {
                clonedChildren = _react2.default.createElement(_reactRouterDom.Route, {
                    path: link,
                    render: function render() {
                        return _react2.default.createElement(
                            'ul',
                            { className: 'sections ' + _this2.props.sectionClass },
                            _react2.default.Children.map(_this2.props.children, function (child) {
                                if (child === null) {
                                    return null;
                                }

                                return _react2.default.cloneElement(child, {
                                    parentLink: link
                                });
                            })
                        );
                    }
                });
            }

            return _react2.default.createElement(
                'li',
                { className: 'sidebar-category' },
                title,
                clonedChildren
            );
        }
    }], [{
        key: 'propTypes',
        get: function get() {
            return {
                name: _propTypes2.default.string,
                title: _propTypes2.default.node.isRequired,
                icon: _propTypes2.default.string.isRequired,
                sectionClass: _propTypes2.default.string,
                parentLink: _propTypes2.default.string,
                children: _propTypes2.default.node,
                action: _propTypes2.default.node
            };
        }
    }, {
        key: 'defaultProps',
        get: function get() {
            return {
                parentLink: ''
            };
        }
    }, {
        key: 'contextTypes',
        get: function get() {
            return {
                router: _propTypes2.default.object.isRequired
            };
        }
    }]);
    return AdminSidebarCategory;
}(_react2.default.Component); // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = AdminSidebarCategory;

/***/ }),

/***/ 2631:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _jquery = __webpack_require__(773);

var _jquery2 = _interopRequireDefault(_jquery);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _client = __webpack_require__(270);

var _user_store = __webpack_require__(774);

var _user_store2 = _interopRequireDefault(_user_store);

var _admin_navbar_dropdown = __webpack_require__(2632);

var _admin_navbar_dropdown2 = _interopRequireDefault(_admin_navbar_dropdown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var SidebarHeader = function (_React$Component) {
    (0, _inherits3.default)(SidebarHeader, _React$Component);

    function SidebarHeader(props) {
        (0, _classCallCheck3.default)(this, SidebarHeader);

        var _this = (0, _possibleConstructorReturn3.default)(this, (SidebarHeader.__proto__ || (0, _getPrototypeOf2.default)(SidebarHeader)).call(this, props));

        _this.toggleDropdown = function (e) {
            e.preventDefault();

            if (_this.refs.dropdown.blockToggle) {
                _this.refs.dropdown.blockToggle = false;
                return;
            }

            (0, _jquery2.default)('.team__header').find('.dropdown-toggle').dropdown('toggle');
        };

        _this.state = {};
        return _this;
    }

    (0, _createClass3.default)(SidebarHeader, [{
        key: 'render',
        value: function render() {
            var me = _user_store2.default.getCurrentUser();
            var profilePicture = null;

            if (!me) {
                return null;
            }

            if (me.last_picture_update) {
                profilePicture = _react2.default.createElement('img', {
                    className: 'user__picture',
                    src: _client.Client4.getProfilePictureUrl(me.id, me.last_picture_update)
                });
            }

            return _react2.default.createElement(
                'div',
                { className: 'team__header theme' },
                _react2.default.createElement(
                    'a',
                    {
                        href: '#',
                        onClick: this.toggleDropdown
                    },
                    profilePicture,
                    _react2.default.createElement(
                        'div',
                        { className: 'header__info' },
                        _react2.default.createElement(
                            'div',
                            { className: 'team__name' },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'admin.sidebarHeader.systemConsole',
                                defaultMessage: 'System Console'
                            })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'user__name' },
                            '@' + me.username
                        )
                    )
                ),
                _react2.default.createElement(_admin_navbar_dropdown2.default, { ref: 'dropdown' })
            );
        }
    }]);
    return SidebarHeader;
}(_react2.default.Component);

exports.default = SidebarHeader;

/***/ }),

/***/ 2632:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _redux = __webpack_require__(1);

var _admin_actions = __webpack_require__(797);

var _admin = __webpack_require__(963);

var _admin_navbar_dropdown = __webpack_require__(2633);

var _admin_navbar_dropdown2 = _interopRequireDefault(_admin_navbar_dropdown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state) {
    return {
        navigationBlocked: (0, _admin.getNavigationBlocked)(state)
    };
} // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapDispatchToProps(dispatch) {
    return {
        actions: (0, _redux.bindActionCreators)({
            deferNavigation: _admin_actions.deferNavigation
        }, dispatch)
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_admin_navbar_dropdown2.default);

/***/ }),

/***/ 2633:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = __webpack_require__(782);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _jquery = __webpack_require__(773);

var _jquery2 = _interopRequireDefault(_jquery);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(272);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactIntl = __webpack_require__(761);

var _reactRouterDom = __webpack_require__(269);

var _global_actions = __webpack_require__(778);

var GlobalActions = _interopRequireWildcard(_global_actions);

var _team_store = __webpack_require__(779);

var _team_store2 = _interopRequireDefault(_team_store);

var _team_utils = __webpack_require__(960);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _constants = __webpack_require__(29);

var _about_build_modal = __webpack_require__(1049);

var _about_build_modal2 = _interopRequireDefault(_about_build_modal);

var _blockable_link = __webpack_require__(1458);

var _blockable_link2 = _interopRequireDefault(_blockable_link);

var _menu_icon = __webpack_require__(1085);

var _menu_icon2 = _interopRequireDefault(_menu_icon);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var AdminNavbarDropdown = function (_React$Component) {
    (0, _inherits3.default)(AdminNavbarDropdown, _React$Component);

    function AdminNavbarDropdown(props) {
        (0, _classCallCheck3.default)(this, AdminNavbarDropdown);

        var _this = (0, _possibleConstructorReturn3.default)(this, (AdminNavbarDropdown.__proto__ || (0, _getPrototypeOf2.default)(AdminNavbarDropdown)).call(this, props));

        _this.handleAboutModal = function (e) {
            e.preventDefault();

            _this.setState({ showAboutModal: true });
        };

        _this.handleLogout = function (e) {
            if (_this.props.navigationBlocked) {
                e.preventDefault();
                _this.props.actions.deferNavigation(GlobalActions.emitUserLoggedOutEvent);
            } else {
                GlobalActions.emitUserLoggedOutEvent();
            }
        };

        _this.aboutModalDismissed = function () {
            _this.setState({ showAboutModal: false });
        };

        _this.onTeamChange = function () {
            _this.setState({
                teams: _team_store2.default.getAll(),
                teamMembers: _team_store2.default.getMyTeamMembers()
            });
        };

        _this.state = {
            teams: _team_store2.default.getAll(),
            teamMembers: _team_store2.default.getMyTeamMembers(),
            showAboutModal: false
        };
        return _this;
    }

    (0, _createClass3.default)(AdminNavbarDropdown, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            (0, _jquery2.default)(_reactDom2.default.findDOMNode(this.refs.dropdown)).on('hide.bs.dropdown', function () {
                _this2.blockToggle = true;
                setTimeout(function () {
                    _this2.blockToggle = false;
                }, 100);
            });

            _team_store2.default.addChangeListener(this.onTeamChange);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            (0, _jquery2.default)(_reactDom2.default.findDOMNode(this.refs.dropdown)).off('hide.bs.dropdown');
            _team_store2.default.removeChangeListener(this.onTeamChange);
        }
    }, {
        key: 'render',
        value: function render() {
            var teamsArray = []; // Array of team objects
            var teams = []; // Array of team components
            var switchTeams = void 0;

            if (this.state.teamMembers && this.state.teamMembers.length > 0) {
                for (var index in this.state.teamMembers) {
                    if (this.state.teamMembers.hasOwnProperty(index)) {
                        var teamMember = this.state.teamMembers[index];
                        var team = this.state.teams[teamMember.team_id];
                        teamsArray.push(team);
                    }
                }

                teamsArray = (0, _team_utils.filterAndSortTeamsByDisplayName)(teamsArray);

                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = (0, _getIterator3.default)(teamsArray), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var _team = _step.value;

                        teams.push(_react2.default.createElement(
                            'li',
                            { key: 'team_' + _team.name },
                            _react2.default.createElement(
                                _blockable_link2.default,
                                {
                                    id: 'swithTo' + Utils.createSafeId(_team.name),
                                    to: '/' + _team.name + ('/channels/' + _constants.Constants.DEFAULT_CHANNEL)
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'navbar_dropdown.switchTo',
                                    defaultMessage: 'Switch to '
                                }),
                                _team.display_name
                            )
                        ));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                teams.push(_react2.default.createElement('li', {
                    key: 'teamDiv',
                    className: 'divider'
                }));
            } else {
                switchTeams = _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                        _blockable_link2.default,
                        {
                            to: '/select_team'
                        },
                        _react2.default.createElement('i', { className: 'fa fa-exchange' }),
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'admin.nav.switch',
                            defaultMessage: 'Team Selection'
                        })
                    )
                );
            }

            return _react2.default.createElement(
                'ul',
                { className: 'nav navbar-nav navbar-right admin-navbar-dropdown' },
                _react2.default.createElement(
                    'li',
                    {
                        ref: 'dropdown',
                        className: 'dropdown'
                    },
                    _react2.default.createElement(
                        'a',
                        {
                            href: '#',
                            id: 'adminNavbarDropdownButton',
                            className: 'dropdown-toggle admin-navbar-dropdown__toggle',
                            'data-toggle': 'dropdown',
                            role: 'button',
                            'aria-expanded': 'false'
                        },
                        _react2.default.createElement(_menu_icon2.default, { className: 'dropdown__icon admin-navbar-dropdown__icon' })
                    ),
                    _react2.default.createElement(
                        'ul',
                        {
                            className: 'dropdown-menu',
                            role: 'menu'
                        },
                        teams,
                        switchTeams,
                        _react2.default.createElement('li', {
                            key: 'teamDiv',
                            className: 'divider'
                        }),
                        _react2.default.createElement(
                            'li',
                            null,
                            _react2.default.createElement(
                                _reactRouterDom.Link,
                                {
                                    to: 'https://about.mattermost.com/administrators-guide/',
                                    rel: 'noopener noreferrer',
                                    target: '_blank'
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'admin.nav.administratorsGuide',
                                    defaultMessage: 'Administrator Guide'
                                })
                            )
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            _react2.default.createElement(
                                _reactRouterDom.Link,
                                {
                                    to: 'https://about.mattermost.com/troubleshooting-forum/',
                                    rel: 'noopener noreferrer',
                                    target: '_blank'
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'admin.nav.troubleshootingForum',
                                    defaultMessage: 'Troubleshooting Forum'
                                })
                            )
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            _react2.default.createElement(
                                _reactRouterDom.Link,
                                {
                                    to: 'https://about.mattermost.com/commercial-support/',
                                    rel: 'noopener noreferrer',
                                    target: '_blank'
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'admin.nav.commercialSupport',
                                    defaultMessage: 'Commercial Support'
                                })
                            )
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            _react2.default.createElement(
                                'a',
                                {
                                    href: '#',
                                    onClick: this.handleAboutModal
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'navbar_dropdown.about',
                                    defaultMessage: 'About Mattermost'
                                })
                            )
                        ),
                        _react2.default.createElement('li', { className: 'divider' }),
                        _react2.default.createElement(
                            'li',
                            null,
                            _react2.default.createElement(
                                'a',
                                {
                                    href: '#',
                                    id: 'logout',
                                    onClick: this.handleLogout
                                },
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'admin.nav.logout',
                                    defaultMessage: 'Logout'
                                })
                            )
                        ),
                        _react2.default.createElement(_about_build_modal2.default, {
                            show: this.state.showAboutModal,
                            onModalDismissed: this.aboutModalDismissed
                        })
                    )
                )
            );
        }
    }]);
    return AdminNavbarDropdown;
}(_react2.default.Component);

AdminNavbarDropdown.propTypes = {

    /*
     * Bool whether the navigation is blocked by unsaved changes
     */
    navigationBlocked: _propTypes2.default.bool,

    actions: _propTypes2.default.shape({

        /*
         * Action to attempt a navigation and set a callback
         * to execute after the navigation is confirmed
         */
        deferNavigation: _propTypes2.default.func
    }).isRequired
};
exports.default = AdminNavbarDropdown;

/***/ }),

/***/ 2634:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _deleteProperty = __webpack_require__(176);

var _deleteProperty2 = _interopRequireDefault(_deleteProperty);

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterDom = __webpack_require__(269);

var _browser_history = __webpack_require__(273);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var BlockableLink = function (_React$Component) {
    (0, _inherits3.default)(BlockableLink, _React$Component);

    function BlockableLink() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, BlockableLink);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = BlockableLink.__proto__ || (0, _getPrototypeOf2.default)(BlockableLink)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (e) {
            if (_this.props.blocked) {
                e.preventDefault();

                _this.props.actions.deferNavigation(function () {
                    _browser_history.browserHistory.push(_this.props.to);
                });
            }
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(BlockableLink, [{
        key: 'render',
        value: function render() {
            var props = (0, _extends3.default)({}, this.props);
            (0, _deleteProperty2.default)(props, 'blocked');
            (0, _deleteProperty2.default)(props, 'actions');

            return _react2.default.createElement(_reactRouterDom.NavLink, (0, _extends3.default)({}, props, {
                onClick: this.handleClick
            }));
        }
    }]);
    return BlockableLink;
}(_react2.default.Component);

BlockableLink.propTypes = {

    /*
     * Bool whether navigation is blocked
     */
    blocked: _propTypes2.default.bool.isRequired,

    /*
     * String Link destination
     */
    to: _propTypes2.default.string.isRequired,

    actions: _propTypes2.default.shape({

        /*
         * Function for deferring navigation while blocked
         */
        deferNavigation: _propTypes2.default.func.isRequired
    }).isRequired
};
exports.default = BlockableLink;

/***/ }),

/***/ 2635:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _blockable_link = __webpack_require__(1458);

var _blockable_link2 = _interopRequireDefault(_blockable_link);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var AdminSidebarSection = function (_React$Component) {
    (0, _inherits3.default)(AdminSidebarSection, _React$Component);

    function AdminSidebarSection() {
        (0, _classCallCheck3.default)(this, AdminSidebarSection);
        return (0, _possibleConstructorReturn3.default)(this, (AdminSidebarSection.__proto__ || (0, _getPrototypeOf2.default)(AdminSidebarSection)).apply(this, arguments));
    }

    (0, _createClass3.default)(AdminSidebarSection, [{
        key: 'getLink',
        value: function getLink() {
            return this.props.parentLink + '/' + this.props.name;
        }
    }, {
        key: 'render',
        value: function render() {
            var link = this.getLink();

            var clonedChildren = null;
            if (this.props.children) {
                clonedChildren = _react2.default.createElement(
                    'ul',
                    { className: 'nav nav__sub-menu subsections' },
                    _react2.default.Children.map(this.props.children, function (child) {
                        if (child === null) {
                            return null;
                        }

                        return _react2.default.cloneElement(child, {
                            parentLink: link,
                            subsection: true
                        });
                    })
                );
            }

            var className = 'sidebar-section';
            if (this.props.subsection) {
                className += ' sidebar-subsection';
            }

            var sidebarItem = _react2.default.createElement(
                _blockable_link2.default,
                {
                    id: Utils.createSafeId(this.props.name),
                    className: className + '-title',
                    activeClassName: className + '-title ' + className + '-title--active',
                    to: link
                },
                _react2.default.createElement(
                    'span',
                    { className: className + '-title__text' },
                    this.props.title
                ),
                this.props.action
            );

            if (this.props.type === 'text') {
                sidebarItem = _react2.default.createElement(
                    'div',
                    {
                        className: className + '-title'
                    },
                    _react2.default.createElement(
                        'span',
                        { className: className + '-title__text' },
                        this.props.title
                    ),
                    this.props.action
                );
            }

            return _react2.default.createElement(
                'li',
                { className: className },
                sidebarItem,
                clonedChildren
            );
        }
    }], [{
        key: 'propTypes',
        get: function get() {
            return {
                name: _propTypes2.default.string.isRequired,
                title: _propTypes2.default.node.isRequired,
                type: _propTypes2.default.string,
                parentLink: _propTypes2.default.string,
                subsection: _propTypes2.default.bool,
                children: _propTypes2.default.node,
                action: _propTypes2.default.node
            };
        }
    }, {
        key: 'defaultProps',
        get: function get() {
            return {
                parentLink: '',
                subsection: false,
                children: []
            };
        }
    }]);
    return AdminSidebarSection;
}(_react2.default.Component);

exports.default = AdminSidebarSection;

/***/ }),

/***/ 2636:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _constants = __webpack_require__(29);

var _admin_actions = __webpack_require__(797);

var _system_analytics = __webpack_require__(2637);

var _system_analytics2 = _interopRequireDefault(_system_analytics);

var _team_analytics = __webpack_require__(2687);

var _team_analytics2 = _interopRequireDefault(_team_analytics);

var _system_users = __webpack_require__(2690);

var _system_users2 = _interopRequireDefault(_system_users);

var _server_logs = __webpack_require__(2706);

var _server_logs2 = _interopRequireDefault(_server_logs);

var _audits = __webpack_require__(2709);

var _audits2 = _interopRequireDefault(_audits);

var _license_settings = __webpack_require__(2713);

var _license_settings2 = _interopRequireDefault(_license_settings);

var _admin_definition_constants = __webpack_require__(1454);

var DefinitionConstants = _interopRequireWildcard(_admin_definition_constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// admin_definitions data structure define the autogenerated admin_console
// section. It defines the structure of the menu based on sections, subsections
// and pages. Each page contains an schema which defines a component to use for
// render the entire section or the name of the section (name and
// name_default), the section in the config file (id), and a list of options to
// configure (settings).
//
// All text fiels contains a transation key, and the <field>_default string are the
// default text when the translation is still not avaiable (the english version
// of the text).
//
// We can define different types of settings configuration widgets:
//
// Widget:
//   - type: which define the widget type.
//   - label (and label_default): which define the main text of the setting.
//   - needs: a list of pairs of [field, value] to enable/disable the field.
//   - needs_license: True if need to have license to be shown.
//   - needs_no_license: True if need to have not license to be shown.
//
// Custom Widget (extends from Widget):
//   - component: The component used to render the widget
//
// Banner Widget (extends from Widget):
//   - banner_type: The type of banner (options: info or warning)
//
// Setting Widget (extends from Widget):
//   - key: The key to store the configuration in the config file.
//   - help_text (and help_text_default): Long description of the field.
//   - help_text_html: True if the translation text contains html.
//   - help_text_values: Values to fill the translation (if needed).
//
// Bool Widget (extends from Setting Widget)
//
// Number Widget (extends from Setting Widget)
//
// Text Widget (extends from Setting Widget)
//   - placeholder (and placeholder_default): Placeholder text to show in the input.
//
// Button Widget (extends from Setting Widget)
//   - action: A redux action to execute on click.
//   - error_message (and error_message_default): Error to show if action doesn't work.
//
// Language Widget (extends from Setting Widget)
//   - multiple: If you can select multiple languages.
//   - no_result (and no_result_default): Text to show on not results found (only for multiple = true).
//   - not_present (and not_present_default): Text to show when the default language is not present (only for multiple = true).
//
// Dropdown Widget (extends from Setting Widget)
//   - options: List of options of the dropdown (each options has value, display_name and display_name_default fields).

exports.default = {
    reporting: {
        system_analytics: {
            schema: {
                id: 'SystemAnalytics',
                component: _system_analytics2.default
            }
        },
        team_analytics: {
            schema: {
                id: 'TeamAnalytics',
                component: _team_analytics2.default
            }
        },
        system_users: {
            schema: {
                id: 'SystemUsers',
                component: _system_users2.default
            }
        },
        server_logs: {
            schema: {
                id: 'ServerLogs',
                component: _server_logs2.default
            }
        }
    },
    settings: {
        general: {
            configuration: {
                schema: {
                    id: 'ServiceSettings',
                    name: 'admin.general.configuration',
                    name_default: 'Configuration',
                    settings: [{
                        type: _constants.Constants.SettingsTypes.TYPE_BANNER,
                        label: 'admin.rate.noteDescription',
                        label_default: 'Changing properties other than Site URL in this section will require a server restart before taking effect.',
                        banner_type: 'info'
                    }, {
                        type: _constants.Constants.SettingsTypes.TYPE_TEXT,
                        key: 'SiteURL',
                        label: 'admin.service.siteURL',
                        label_default: 'Site URL:',
                        help_text: 'admin.service.siteURLDescription',
                        help_text_default: 'The URL that users will use to access Mattermost. Standard ports, such as 80 and 443, can be omitted, but non-standard ports are required. For example: http://mattermost.example.com:8065. This setting is required.',
                        placeholder: 'admin.service.siteURLExample',
                        placeholder_default: 'E.g.: "https://mattermost.example.com:1234"'
                    }, {
                        type: _constants.Constants.SettingsTypes.TYPE_TEXT,
                        key: 'ListenAddress',
                        label: 'admin.service.listenAddress',
                        label_default: 'Listen Address:',
                        placeholder: 'admin.service.listenExample',
                        placeholder_default: 'E.g.: ":8065"',
                        help_text: 'admin.service.listenDescription',
                        help_text_default: 'The address and port to which to bind and listen. Specifying ":8065" will bind to all network interfaces. Specifying "127.0.0.1:8065" will only bind to the network interface having that IP address. If you choose a port of a lower level (called "system ports" or "well-known ports", in the range of 0-1023), you must have permissions to bind to that port. On Linux you can use: "sudo setcap cap_net_bind_service=+ep ./bin/platform" to allow Mattermost to bind to well-known ports.'
                    }, {
                        type: _constants.Constants.SettingsTypes.TYPE_BOOL,
                        key: 'Forward80To443',
                        label: 'admin.service.forward80To443',
                        label_default: 'Forward port 80 to 443:',
                        help_text: 'admin.service.forward80To443Description',
                        help_text_default: 'Forwards all insecure traffic from port 80 to secure port 443. Not recommended when using a proxy server.',
                        disabled_help_text: 'admin.service.forward80To443Description.disabled',
                        disabled_help_text_default: 'Forwards all insecure traffic from port 80 to secure port 443. Not recommended when using a proxy server.<br /><br />This setting cannot be enabled until your server is <a href="#ListenAddress">listening</a> on port 443.',
                        disabled_help_text_html: true,
                        needs: [['ListenAddress', /:443$/]]
                    }, {
                        type: _constants.Constants.SettingsTypes.TYPE_DROPDOWN,
                        key: 'ConnectionSecurity',
                        label: 'admin.connectionSecurityTitle',
                        label_default: 'Connection Security:',
                        help_text: DefinitionConstants.CONNECTION_SECURITY_HELP_TEXT_WEBSERVER,
                        options: [{
                            value: '',
                            display_name: 'admin.connectionSecurityNone',
                            display_name_default: 'None'
                        }, {
                            value: 'TLS',
                            display_name: 'admin.connectionSecurityTls',
                            display_name_default: 'TLS (Recommended)'
                        }]
                    }, {
                        type: _constants.Constants.SettingsTypes.TYPE_TEXT,
                        key: 'TLSCertFile',
                        label: 'admin.service.tlsCertFile',
                        label_default: 'TLS Certificate File:',
                        help_text: 'admin.service.tlsCertFileDescription',
                        help_text_default: 'The certificate file to use.',
                        needs: [['UseLetsEncrypt', false]]
                    }, {
                        type: _constants.Constants.SettingsTypes.TYPE_TEXT,
                        key: 'TLSKeyFile',
                        label: 'admin.service.tlsKeyFile',
                        label_default: 'TLS Key File:',
                        help_text: 'admin.service.tlsKeyFileDescription',
                        help_text_default: 'The private key file to use.',
                        needs: [['UseLetsEncrypt', false]]
                    }, {
                        type: _constants.Constants.SettingsTypes.TYPE_BOOL,
                        key: 'UseLetsEncrypt',
                        label: 'admin.service.useLetsEncrypt',
                        label_default: 'Use Let\'s Encrypt:',
                        help_text: 'admin.service.useLetsEncryptDescription',
                        help_text_default: 'Enable the automatic retrieval of certificates from Let\'s Encrypt. The certificate will be retrieved when a client attempts to connect from a new domain. This will work with multiple domains.',
                        disabled_help_text: 'admin.service.useLetsEncryptDescription.disabled',
                        disabled_help_text_default: 'Enable the automatic retrieval of certificates from Let\'s Encrypt. The certificate will be retrieved when a client attempts to connect from a new domain. This will work with multiple domains.<br /><br />This setting cannot be enabled unless the <a href="#Forward80To443">Forward port 80 to 443</a> setting is set to true.',
                        disabled_help_text_html: true,
                        needs: [['Forward80To443', true]]
                    }, {
                        type: _constants.Constants.SettingsTypes.TYPE_TEXT,
                        key: 'LetsEncryptCertificateCacheFile',
                        label: 'admin.service.letsEncryptCertificateCacheFile',
                        label_default: 'Let\'s Encrypt Certificate Cache File:',
                        help_text: 'admin.service.letsEncryptCertificateCacheFileDescription',
                        help_text_default: 'Certificates retrieved and other data about the Let\'s Encrypt service will be stored in this file.',
                        needs: [['UseLetsEncrypt', true]]
                    }, {
                        type: _constants.Constants.SettingsTypes.TYPE_NUMBER,
                        key: 'ReadTimeout',
                        label: 'admin.service.readTimeout',
                        label_default: 'Read Timeout:',
                        help_text: 'admin.service.readTimeoutDescription',
                        help_text_default: 'Maximum time allowed from when the connection is accepted to when the request body is fully read.'
                    }, {
                        type: _constants.Constants.SettingsTypes.TYPE_NUMBER,
                        key: 'WriteTimeout',
                        label: 'admin.service.writeTimeout',
                        label_default: 'Write Timeout:',
                        help_text: 'admin.service.writeTimeoutDescription',
                        help_text_default: 'If using HTTP (insecure), this is the maximum time allowed from the end of reading the request headers until the response is written. If using HTTPS, it is the total time from when the connection is accepted until the response is written.'
                    }, {
                        type: _constants.Constants.SettingsTypes.TYPE_BOOL,
                        key: 'EnableAPIv3',
                        label: 'admin.service.enableAPIv3',
                        label_default: 'Allow use of API v3 endpoints:',
                        help_text: 'admin.service.enableAPIv3Description',
                        help_text_default: 'Set to false to disable all version 3 endpoints of the REST API. Integrations that rely on API v3 will fail and can then be identified for migration to API v4. API v3 is deprecated and will be removed in the near future. See <a href="https://api.mattermost.com" target="_blank">https://api.mattermost.com</a> for details.',
                        help_text_html: true
                    }, {
                        type: _constants.Constants.SettingsTypes.TYPE_DROPDOWN,
                        key: 'WebserverMode',
                        label: 'admin.webserverModeTitle',
                        label_default: 'Webserver Mode:',
                        help_text: DefinitionConstants.WEBSERVER_MODE_HELP_TEXT,
                        options: [{
                            value: 'gzip',
                            display_name: 'admin.webserverModeGzip',
                            display_name_default: 'gzip'
                        }, {
                            value: 'uncompressed',
                            display_name: 'admin.webserverModeUncompressed',
                            display_name_default: 'Uncompressed'
                        }, {
                            value: 'disabled',
                            display_name: 'admin.webserverModeDisabled',
                            display_name_default: 'Disabled'
                        }]
                    }, {
                        type: _constants.Constants.SettingsTypes.TYPE_BUTTON,
                        action: _admin_actions.reloadConfig,
                        key: 'ReloadConfigButton',
                        label: 'admin.reload.button',
                        label_default: 'Reload Configuration From Disk',
                        help_text: 'admin.reload.reloadDescription',
                        help_text_default: 'Deployments using multiple databases can switch from one master database to another without restarting the Mattermost server by updating "config.json" to the new desired configuration and using the {featureName} feature to load the new settings while the server is running. The administrator should then use the {recycleDatabaseConnections} feature to recycle the database connections based on the new settings.',
                        help_text_values: {
                            featureName: _react2.default.createElement(
                                'b',
                                null,
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'admin.reload.reloadDescription.featureName',
                                    defaultMessage: 'Reload Configuration from Disk'
                                })
                            ),
                            recycleDatabaseConnections: _react2.default.createElement(
                                'a',
                                { href: '../advanced/database' },
                                _react2.default.createElement(
                                    'b',
                                    null,
                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'admin.reload.reloadDescription.recycleDatabaseConnections',
                                        defaultMessage: 'Database > Recycle Database Connections'
                                    })
                                )
                            )
                        },
                        error_message: 'admin.reload.reloadFail',
                        error_message_default: 'Reload unsuccessful: {error}'
                    }, {
                        type: _constants.Constants.SettingsTypes.TYPE_BUTTON,
                        key: 'PurgeButton',
                        action: _admin_actions.invalidateAllCaches,
                        label: 'admin.purge.button',
                        label_default: 'Purge All Caches',
                        help_text: 'admin.purge.purgeDescription',
                        help_text_default: 'This will purge all the in-memory caches for things like sessions, accounts, channels, etc. Deployments using High Availability will attempt to purge all the servers in the cluster.  Purging the caches may adversely impact performance.',
                        error_message: 'admin.purge.purgeFail',
                        error_message_default: 'Purging unsuccessful: {error}'
                    }]
                }
            },
            localization: {
                schema: {
                    id: 'LocalizationSettings',
                    name: 'admin.general.localization',
                    name_default: 'Localization',
                    settings: [{
                        type: _constants.Constants.SettingsTypes.TYPE_LANGUAGE,
                        key: 'DefaultServerLocale',
                        label: 'admin.general.localization.serverLocaleTitle',
                        label_default: 'Default Server Language:',
                        help_text: 'admin.general.localization.serverLocaleDescription',
                        help_text_default: 'Default language for system messages and logs. Changing this will require a server restart before taking effect.'
                    }, {
                        type: _constants.Constants.SettingsTypes.TYPE_LANGUAGE,
                        key: 'DefaultClientLocale',
                        label: 'admin.general.localization.clientLocaleTitle',
                        label_default: 'Default Client Language:',
                        help_text: 'admin.general.localization.clientLocaleDescription',
                        help_text_default: 'Default language for newly created users and pages where the user hasn\'t logged in.'
                    }, {
                        type: _constants.Constants.SettingsTypes.TYPE_LANGUAGE,
                        key: 'AvailableLocales',
                        label: 'admin.general.localization.availableLocalesTitle',
                        label_default: 'Available Languages:',
                        help_text: 'admin.general.localization.availableLocalesDescription',
                        help_text_html: true,
                        help_text_default: 'Set which languages are available for users in Account Settings (leave this field blank to have all supported languages available). If you’re manually adding new languages, the <strong>Default Client Language</strong> must be added before saving this setting.<br /><br />Would like to help with translations? Join the <a href="http://translate.mattermost.com/" target="_blank">Mattermost Translation Server</a> to contribute.',
                        multiple: true,
                        no_result: 'admin.general.localization.availableLocalesNoResults',
                        no_result_default: 'No results found',
                        not_present: 'admin.general.localization.availableLocalesNotPresent',
                        not_present_default: 'The default client language must be included in the available list'
                    }]
                }
            },
            privacy: {
                schema: {
                    id: 'PrivacySettings',
                    name: 'admin.general.privacy',
                    name_default: 'Privacy',
                    settings: [{
                        type: _constants.Constants.SettingsTypes.TYPE_BOOL,
                        key: 'ShowEmailAddress',
                        label: 'admin.privacy.showEmailTitle',
                        label_default: 'Show Email Address:',
                        help_text: 'admin.privacy.showEmailDescription',
                        help_text_default: 'When false, hides the email address of members from everyone except System Administrators.'
                    }, {
                        type: _constants.Constants.SettingsTypes.TYPE_BOOL,
                        key: 'ShowFullName',
                        label: 'admin.privacy.showFullNameTitle',
                        label_default: 'Show Full Name:',
                        help_text: 'admin.privacy.showFullNameDescription',
                        help_text_default: 'When false, hides the full name of members from everyone except System Administrators. Username is shown in place of full name.'
                    }]
                }
            },
            compliance: {
                schema: {
                    id: 'ComplianceSettings',
                    name: 'admin.compliance.title',
                    name_default: 'Compliance Settings',
                    settings: [{
                        type: _constants.Constants.SettingsTypes.TYPE_BANNER,
                        label: 'admin.compliance.noLicense',
                        label_default: '<h4 class="banner__heading">Note:</h4><p>Compliance is an enterprise feature. Your current license does not support Compliance. Click <a href="http://mattermost.com"target="_blank">here</a> for information and pricing on enterprise licenses.</p>',
                        needs_no_license: true,
                        banner_type: 'warning'
                    }, {
                        type: _constants.Constants.SettingsTypes.TYPE_BOOL,
                        key: 'Enable',
                        label: 'admin.compliance.enableTitle',
                        label_default: 'Enable Compliance Reporting:',
                        help_text: 'admin.compliance.enableDesc',
                        help_text_default: 'When true, Mattermost allows compliance reporting from the <strong>Compliance and Auditing</strong> tab. See <a href="https://docs.mattermost.com/administration/compliance.html" target="_blank">documentation</a> to learn more.',
                        help_text_html: true,
                        needs_license: true
                    }, {
                        type: _constants.Constants.SettingsTypes.TYPE_TEXT,
                        key: 'Directory',
                        label: 'admin.compliance.directoryTitle',
                        label_default: 'Compliance Report Directory:',
                        help_text: 'admin.compliance.directoryDescription',
                        help_text_default: 'Directory to which compliance reports are written. If blank, will be set to ./data/.',
                        placeholder: 'admin.sql.maxOpenExample',
                        placeholder_default: 'E.g.: "10"',
                        needs: [['Enable', true]],
                        needs_license: true
                    }, {
                        type: _constants.Constants.SettingsTypes.TYPE_BOOL,
                        key: 'EnableDaily',
                        label: 'admin.compliance.enableDailyTitle',
                        label_default: 'Enable Daily Report:',
                        help_text: 'admin.compliance.enableDailyDesc',
                        help_text_default: 'When true, Mattermost will generate a daily compliance report.',
                        needs: [['Enable', true]],
                        needs_license: true
                    }]
                }
            },
            logging: {
                schema: {
                    id: 'LogSettings',
                    name: 'admin.general.log',
                    name_default: 'Logging',
                    settings: [{
                        type: _constants.Constants.SettingsTypes.TYPE_BANNER,
                        label: 'admin.log.noteDescription',
                        label_default: 'Changing properties other than <a href="#EnableWebhookDebugging">Enable Webhook Debugging</a> and <a href="#EnableDiagnostics">Enable Diagnostics and Error Reporting</a> in this section will require a server restart before taking effect.',
                        label_html: true,
                        banner_type: 'info'
                    }, {
                        type: _constants.Constants.SettingsTypes.TYPE_BOOL,
                        key: 'EnableConsole',
                        label: 'admin.log.consoleTitle',
                        label_default: 'Output logs to console: ',
                        help_text: 'admin.log.consoleDescription',
                        help_text_default: 'Typically set to false in production. Developers may set this field to true to output log messages to console based on the console level option.  If true, server writes messages to the standard output stream (stdout).'
                    }, {
                        type: _constants.Constants.SettingsTypes.TYPE_DROPDOWN,
                        key: 'ConsoleLevel',
                        label: 'admin.log.levelTitle',
                        label_default: 'Console Log Level:',
                        help_text: 'admin.log.levelDescription',
                        help_text_default: 'This setting determines the level of detail at which log events are written to the console. ERROR: Outputs only error messages. INFO: Outputs error messages and information around startup and initialization. DEBUG: Prints high detail for developers working on debugging issues.',
                        options: DefinitionConstants.LOG_LEVEL_OPTIONS,
                        needs: [['EnableConsole', true]]
                    }, {
                        type: _constants.Constants.SettingsTypes.TYPE_BOOL,
                        key: 'EnableFile',
                        label: 'admin.log.fileTitle',
                        label_default: 'Output logs to file: ',
                        help_text: 'admin.log.fileDescription',
                        help_text_default: 'Typically set to true in production. When true, logged events are written to the mattermost.log file in the directory specified in the File Log Directory field. The logs are rotated at 10,000 lines and archived to a file in the same directory, and given a name with a datestamp and serial number. For example, mattermost.2017-03-31.001.'
                    }, {
                        type: _constants.Constants.SettingsTypes.TYPE_DROPDOWN,
                        key: 'FileLevel',
                        label: 'admin.log.fileLevelTitle',
                        label_default: 'File Log Level:',
                        help_text: 'admin.log.fileLevelDescription',
                        help_text_default: 'This setting determines the level of detail at which log events are written to the log file. ERROR: Outputs only error messages. INFO: Outputs error messages and information around startup and initialization. DEBUG: Prints high detail for developers working on debugging issues.',
                        options: DefinitionConstants.LOG_LEVEL_OPTIONS,
                        needs: [['EnableFile', true]]
                    }, {
                        type: _constants.Constants.SettingsTypes.TYPE_TEXT,
                        key: 'FileLocation',
                        label: 'admin.log.locationTitle',
                        label_default: 'File Log Directory:',
                        help_text: 'admin.log.locationDescription',
                        help_text_default: 'The location of the log files. If blank, they are stored in the ./logs directory. The path that you set must exist and Mattermost must have write permissions in it.',
                        placeholder: 'admin.log.locationPlaceholder',
                        placeholder_default: 'Enter your file location',
                        needs: [['EnableFile', true]]
                    }, {
                        type: _constants.Constants.SettingsTypes.TYPE_TEXT,
                        key: 'FileFormat',
                        label: 'admin.log.formatTitle',
                        label_default: 'File Log Format:',
                        help_text: DefinitionConstants.LOG_FORMAT_HELP_TEXT,
                        placeholder: 'admin.log.formatPlaceholder',
                        placeholder_default: 'Enter your file format',
                        needs: [['EnableFile', true]]
                    }, {
                        type: _constants.Constants.SettingsTypes.TYPE_BOOL,
                        key: 'EnableWebhookDebugging',
                        label: 'admin.log.enableWebhookDebugging',
                        label_default: 'Enable Webhook Debugging:',
                        help_text: 'admin.log.enableWebhookDebuggingDescription',
                        help_text_default: 'To output the request body of incoming webhooks to the console, enable this setting and set {boldedConsoleLogLevel} to "DEBUG". Disable this setting to remove webhook request body information from console logs when in DEBUG mode.',
                        help_text_values: {
                            boldedConsoleLogLevel: _react2.default.createElement(
                                'strong',
                                null,
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'admin.log.consoleLogLevel',
                                    defaultMessage: 'Console Log Level'
                                })
                            )
                        }
                    }, {
                        type: _constants.Constants.SettingsTypes.TYPE_BOOL,
                        key: 'EnableDiagnostics',
                        label: 'admin.log.enableDiagnostics',
                        label_default: 'Enable Diagnostics and Error Reporting:',
                        help_text: 'admin.log.enableDiagnosticsDescription',
                        help_text_default: 'Enable this feature to improve the quality and performance of Mattermost by sending error reporting and diagnostic information to Mattermost, Inc. Read our <a href="https://about.mattermost.com/default-privacy-policy/" target="_blank">privacy policy</a> to learn more.',
                        help_text_html: true
                    }]
                }
            }
        },
        authentication: {
            email: {
                schema: {
                    id: 'EmailSettings',
                    name: 'admin.authentication.email',
                    name_default: 'Email Authentication',
                    settings: [{
                        type: _constants.Constants.SettingsTypes.TYPE_BOOL,
                        key: 'EnableSignUpWithEmail',
                        label: 'admin.email.allowSignupTitle',
                        label_default: 'Enable account creation with email:',
                        help_text: 'admin.email.allowSignupDescription',
                        help_text_default: 'When true, Mattermost allows account creation using email and password. This value should be false only when you want to limit sign up to a single sign-on service like AD/LDAP, SAML or GitLab.'
                    }, {
                        type: _constants.Constants.SettingsTypes.TYPE_BOOL,
                        key: 'EnableSignInWithEmail',
                        label: 'admin.email.allowEmailSignInTitle',
                        label_default: 'Enable sign-in with email:',
                        help_text: 'admin.email.allowEmailSignInDescription',
                        help_text_default: 'When true, Mattermost allows users to sign in using their email and password.'
                    }, {
                        type: _constants.Constants.SettingsTypes.TYPE_BOOL,
                        key: 'EnableSignInWithUsername',
                        label: 'admin.email.allowUsernameSignInTitle',
                        label_default: 'Enable sign-in with username:',
                        help_text: 'admin.email.allowUsernameSignInDescription',
                        help_text_default: 'When true, users with email login can sign in using their username and password. This setting does not affect AD/LDAP login.'
                    }]
                }
            },
            mfa: {
                schema: {
                    id: 'ServiceSettings',
                    name: 'admin.mfa.title',
                    name_default: 'Multi-factor Authentication',
                    settings: [{
                        type: _constants.Constants.SettingsTypes.TYPE_BANNER,
                        label: 'admin.mfa.bannerDesc',
                        label_default: '<a href=\'https://docs.mattermost.com/deployment/auth.html\' target=\'_blank\'>Multi-factor authentication</a> is available for accounts with AD/LDAP or email login. If other login methods are used, MFA should be configured with the authentication provider.',
                        label_html: true,
                        banner_type: 'info'
                    }, {
                        type: _constants.Constants.SettingsTypes.TYPE_BOOL,
                        key: 'EnableMultifactorAuthentication',
                        label: 'admin.service.mfaTitle',
                        label_default: 'Enable Multi-factor Authentication:',
                        help_text: 'admin.service.mfaDesc',
                        help_text_default: 'When true, users with AD/LDAP or email login can add multi-factor authentication to their account using Google Authenticator.'
                    }, {
                        type: _constants.Constants.SettingsTypes.TYPE_BOOL,
                        key: 'EnforceMultifactorAuthentication',
                        label: 'admin.service.enforceMfaTitle',
                        label_default: 'Enforce Multi-factor Authentication:',
                        help_text: 'admin.service.enforceMfaDesc',
                        help_text_html: true,
                        help_text_default: 'When true, <a href=\'https://docs.mattermost.com/deployment/auth.html\' target=\'_blank\'>multi-factor authentication</a> is required for login. New users will be required to configure MFA on signup. Logged in users without MFA configured are redirected to the MFA setup page until configuration is complete.<br/><br/>If your system has users with login methods other than AD/LDAP and email, MFA must be enforced with the authentication provider outside of Mattermost.',
                        needs: [['EnableMultifactorAuthentication', true]]
                    }]
                }
            }
        },
        security: {},
        notifications: {},
        plugins: {},
        files: {},
        customization: {},
        compliance: {},
        advanced: {}
    },
    other: {
        license: {
            schema: {
                id: 'LicenseSettings',
                component: _license_settings2.default
            }
        },
        audits: {
            schema: {
                id: 'Audits',
                component: _audits2.default
            }
        }
    }
}; // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

/***/ }),

/***/ 2637:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _general = __webpack_require__(113);

var _system_analytics = __webpack_require__(2638);

var _system_analytics2 = _interopRequireDefault(_system_analytics);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state) {
    var license = (0, _general.getLicense)(state);
    var isLicensed = license.IsLicensed === 'true';

    return {
        isLicensed: isLicensed
    };
} // Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_system_analytics2.default);

/***/ }),

/***/ 2638:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _admin_actions = __webpack_require__(797);

var AdminActions = _interopRequireWildcard(_admin_actions);

var _analytics_store = __webpack_require__(964);

var _analytics_store2 = _interopRequireDefault(_analytics_store);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _doughnut_chart = __webpack_require__(2639);

var _doughnut_chart2 = _interopRequireDefault(_doughnut_chart);

var _line_chart = __webpack_require__(1578);

var _line_chart2 = _interopRequireDefault(_line_chart);

var _statistic_count = __webpack_require__(1579);

var _statistic_count2 = _interopRequireDefault(_statistic_count);

var _format = __webpack_require__(1580);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StatTypes = _constants2.default.StatTypes; // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var SystemAnalytics = function (_React$Component) {
    (0, _inherits3.default)(SystemAnalytics, _React$Component);

    function SystemAnalytics(props) {
        (0, _classCallCheck3.default)(this, SystemAnalytics);

        var _this = (0, _possibleConstructorReturn3.default)(this, (SystemAnalytics.__proto__ || (0, _getPrototypeOf2.default)(SystemAnalytics)).call(this, props));

        _this.onChange = function () {
            _this.setState({ stats: _analytics_store2.default.getAllSystem() });
        };

        _this.state = { stats: _analytics_store2.default.getAllSystem() };
        return _this;
    }

    (0, _createClass3.default)(SystemAnalytics, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _analytics_store2.default.addChangeListener(this.onChange);

            AdminActions.getStandardAnalytics();
            AdminActions.getPostsPerDayAnalytics();
            AdminActions.getUsersPerDayAnalytics();

            if (this.props.isLicensed) {
                AdminActions.getAdvancedAnalytics();
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _analytics_store2.default.removeChangeListener(this.onChange);
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState) {
            if (!Utils.areObjectsEqual(nextState.stats, this.state.stats)) {
                return true;
            }

            return false;
        }
    }, {
        key: 'render',
        value: function render() {
            var stats = this.state.stats;
            var isLicensed = this.props.isLicensed;
            var skippedIntensiveQueries = stats[StatTypes.TOTAL_POSTS] === -1;
            var postCountsDay = (0, _format.formatPostsPerDayData)(stats[StatTypes.POST_PER_DAY]);
            var userCountsWithPostsDay = (0, _format.formatUsersWithPostsPerDayData)(stats[StatTypes.USERS_WITH_POSTS_PER_DAY]);

            var banner = void 0;
            var postCount = void 0;
            var postTotalGraph = void 0;
            var activeUserGraph = void 0;
            if (skippedIntensiveQueries) {
                banner = _react2.default.createElement(
                    'div',
                    { className: 'banner' },
                    _react2.default.createElement(
                        'div',
                        { className: 'banner__content' },
                        _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                            id: 'analytics.system.skippedIntensiveQueries',
                            defaultMessage: 'To maximize performance, some statistics are disabled. You can <a href=\'https://docs.mattermost.com/administration/statistics.html\' target=\'_blank\'>re-enable them in config.json</a>.'
                        })
                    )
                );
            } else {
                postCount = _react2.default.createElement(_statistic_count2.default, {
                    title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'analytics.system.totalPosts',
                        defaultMessage: 'Total Posts'
                    }),
                    icon: 'fa-comment',
                    count: stats[StatTypes.TOTAL_POSTS]
                });

                postTotalGraph = _react2.default.createElement(
                    'div',
                    { className: 'row' },
                    _react2.default.createElement(_line_chart2.default, {
                        title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'analytics.system.totalPosts',
                            defaultMessage: 'Total Posts'
                        }),
                        data: postCountsDay,
                        width: 740,
                        height: 225
                    })
                );

                activeUserGraph = _react2.default.createElement(
                    'div',
                    { className: 'row' },
                    _react2.default.createElement(_line_chart2.default, {
                        title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'analytics.system.activeUsers',
                            defaultMessage: 'Active Users With Posts'
                        }),
                        data: userCountsWithPostsDay,
                        width: 740,
                        height: 225
                    })
                );
            }

            var advancedStats = void 0;
            var advancedGraphs = void 0;
            var sessionCount = void 0;
            var commandCount = void 0;
            var incomingCount = void 0;
            var outgoingCount = void 0;
            if (this.props.isLicensed) {
                sessionCount = _react2.default.createElement(_statistic_count2.default, {
                    title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'analytics.system.totalSessions',
                        defaultMessage: 'Total Sessions'
                    }),
                    icon: 'fa-signal',
                    count: stats[StatTypes.TOTAL_SESSIONS]
                });

                commandCount = _react2.default.createElement(_statistic_count2.default, {
                    title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'analytics.system.totalCommands',
                        defaultMessage: 'Total Commands'
                    }),
                    icon: 'fa-terminal',
                    count: stats[StatTypes.TOTAL_COMMANDS]
                });

                incomingCount = _react2.default.createElement(_statistic_count2.default, {
                    title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'analytics.system.totalIncomingWebhooks',
                        defaultMessage: 'Incoming Webhooks'
                    }),
                    icon: 'fa-arrow-down',
                    count: stats[StatTypes.TOTAL_IHOOKS]
                });

                outgoingCount = _react2.default.createElement(_statistic_count2.default, {
                    title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'analytics.system.totalOutgoingWebhooks',
                        defaultMessage: 'Outgoing Webhooks'
                    }),
                    icon: 'fa-arrow-up',
                    count: stats[StatTypes.TOTAL_OHOOKS]
                });

                advancedStats = _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(_statistic_count2.default, {
                        title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'analytics.system.totalWebsockets',
                            defaultMessage: 'WebSocket Conns'
                        }),
                        icon: 'fa-user',
                        count: stats[StatTypes.TOTAL_WEBSOCKET_CONNECTIONS]
                    }),
                    _react2.default.createElement(_statistic_count2.default, {
                        title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'analytics.system.totalMasterDbConnections',
                            defaultMessage: 'Master DB Conns'
                        }),
                        icon: 'fa-terminal',
                        count: stats[StatTypes.TOTAL_MASTER_DB_CONNECTIONS]
                    }),
                    _react2.default.createElement(_statistic_count2.default, {
                        title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'analytics.system.totalReadDbConnections',
                            defaultMessage: 'Replica DB Conns'
                        }),
                        icon: 'fa-terminal',
                        count: stats[StatTypes.TOTAL_READ_DB_CONNECTIONS]
                    })
                );

                var channelTypeData = (0, _format.formatChannelDoughtnutData)(stats[StatTypes.TOTAL_PUBLIC_CHANNELS], stats[StatTypes.TOTAL_PRIVATE_GROUPS]);
                var postTypeData = (0, _format.formatPostDoughtnutData)(stats[StatTypes.TOTAL_FILE_POSTS], stats[StatTypes.TOTAL_HASHTAG_POSTS], stats[StatTypes.TOTAL_POSTS]);

                var postTypeGraph = void 0;
                if (stats[StatTypes.TOTAL_POSTS] !== -1) {
                    postTypeGraph = _react2.default.createElement(_doughnut_chart2.default, {
                        title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'analytics.system.postTypes',
                            defaultMessage: 'Posts, Files and Hashtags'
                        }),
                        data: postTypeData,
                        width: 300,
                        height: 225
                    });
                }

                advancedGraphs = _react2.default.createElement(
                    'div',
                    { className: 'row' },
                    _react2.default.createElement(_doughnut_chart2.default, {
                        title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'analytics.system.channelTypes',
                            defaultMessage: 'Channel Types'
                        }),
                        data: channelTypeData,
                        width: 300,
                        height: 225
                    }),
                    postTypeGraph
                );
            }

            var userCount = _react2.default.createElement(_statistic_count2.default, {
                title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'analytics.system.totalUsers',
                    defaultMessage: 'Total Users'
                }),
                icon: 'fa-user',
                count: stats[StatTypes.TOTAL_USERS]
            });

            var teamCount = _react2.default.createElement(_statistic_count2.default, {
                title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'analytics.system.totalTeams',
                    defaultMessage: 'Total Teams'
                }),
                icon: 'fa-users',
                count: stats[StatTypes.TOTAL_TEAMS]
            });

            var channelCount = _react2.default.createElement(_statistic_count2.default, {
                title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'analytics.system.totalChannels',
                    defaultMessage: 'Total Channels'
                }),
                icon: 'fa-globe',
                count: stats[StatTypes.TOTAL_PUBLIC_CHANNELS] + stats[StatTypes.TOTAL_PRIVATE_GROUPS]
            });

            var dailyActiveUsers = _react2.default.createElement(_statistic_count2.default, {
                title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'analytics.system.dailyActiveUsers',
                    defaultMessage: 'Daily Active Users'
                }),
                icon: 'fa-users',
                count: stats[StatTypes.DAILY_ACTIVE_USERS]
            });

            var monthlyActiveUsers = _react2.default.createElement(_statistic_count2.default, {
                title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'analytics.system.monthlyActiveUsers',
                    defaultMessage: 'Monthly Active Users'
                }),
                icon: 'fa-users',
                count: stats[StatTypes.MONTHLY_ACTIVE_USERS]
            });

            var firstRow = void 0;
            var secondRow = void 0;
            if (isLicensed && skippedIntensiveQueries) {
                firstRow = _react2.default.createElement(
                    'div',
                    null,
                    userCount,
                    teamCount,
                    channelCount,
                    sessionCount
                );

                secondRow = _react2.default.createElement(
                    'div',
                    null,
                    commandCount,
                    incomingCount,
                    outgoingCount
                );
            } else if (isLicensed && !skippedIntensiveQueries) {
                firstRow = _react2.default.createElement(
                    'div',
                    null,
                    userCount,
                    teamCount,
                    channelCount,
                    postCount
                );

                secondRow = _react2.default.createElement(
                    'div',
                    null,
                    sessionCount,
                    commandCount,
                    incomingCount,
                    outgoingCount
                );
            } else if (!isLicensed) {
                firstRow = _react2.default.createElement(
                    'div',
                    null,
                    userCount,
                    teamCount,
                    channelCount,
                    postCount
                );
            }

            var thirdRow = _react2.default.createElement(
                'div',
                null,
                dailyActiveUsers,
                monthlyActiveUsers
            );

            return _react2.default.createElement(
                'div',
                { className: 'wrapper--fixed team_statistics' },
                _react2.default.createElement(
                    'h3',
                    { className: 'admin-console-header' },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'analytics.system.title',
                        defaultMessage: 'System Statistics'
                    })
                ),
                banner,
                _react2.default.createElement(
                    'div',
                    { className: 'row' },
                    firstRow,
                    secondRow,
                    thirdRow,
                    advancedStats
                ),
                advancedGraphs,
                postTotalGraph,
                activeUserGraph
            );
        }
    }]);
    return SystemAnalytics;
}(_react2.default.Component);

SystemAnalytics.propTypes = {
    isLicensed: _propTypes2.default.bool.isRequired
};
exports.default = SystemAnalytics;

/***/ }),

/***/ 2639:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(272);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactIntl = __webpack_require__(761);

var _chart = __webpack_require__(1459);

var _chart2 = _interopRequireDefault(_chart);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var DoughnutChart = function (_React$PureComponent) {
    (0, _inherits3.default)(DoughnutChart, _React$PureComponent);

    function DoughnutChart() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, DoughnutChart);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DoughnutChart.__proto__ || (0, _getPrototypeOf2.default)(DoughnutChart)).call.apply(_ref, [this].concat(args))), _this), _this.chart = null, _this.initChart = function (update) {
            if (!_this.refs.canvas) {
                return;
            }
            var el = _reactDom2.default.findDOMNode(_this.refs.canvas);
            var ctx = el.getContext('2d');
            _this.chart = new _chart2.default(ctx, { type: 'doughnut', data: _this.props.data, options: {} }); //eslint-disable-line new-cap
            if (update) {
                _this.chart.update();
            }
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(DoughnutChart, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.initChart();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            if (!Utils.areObjectsEqual(prevProps.data, this.props.data)) {
                this.initChart(true);
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.chart && this.refs.canvas) {
                this.chart.destroy();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var content = void 0;
            if (this.props.data == null) {
                content = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'analytics.chart.loading',
                    defaultMessage: 'Loading...'
                });
            } else {
                content = _react2.default.createElement('canvas', {
                    ref: 'canvas',
                    width: this.props.width,
                    height: this.props.height
                });
            }

            return _react2.default.createElement(
                'div',
                { className: 'col-sm-6' },
                _react2.default.createElement(
                    'div',
                    { className: 'total-count' },
                    _react2.default.createElement(
                        'div',
                        { className: 'title' },
                        this.props.title
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'content' },
                        content
                    )
                )
            );
        }
    }]);
    return DoughnutChart;
}(_react2.default.PureComponent);

DoughnutChart.propTypes = {

    /*
     * Chart title
     */
    title: _propTypes2.default.node,

    /*
     * Chart width
     */
    width: _propTypes2.default.number,

    /*
     * Chart height
     */
    height: _propTypes2.default.number,

    /*
     * Chart data
     */
    data: _propTypes2.default.object
};
exports.default = DoughnutChart;

/***/ }),

/***/ 2640:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(796);

defaults._set('global', {
	responsive: true,
	responsiveAnimationDuration: 0,
	maintainAspectRatio: true,
	events: ['mousemove', 'mouseout', 'click', 'touchstart', 'touchmove'],
	hover: {
		onHover: null,
		mode: 'nearest',
		intersect: true,
		animationDuration: 400
	},
	onClick: null,
	defaultColor: 'rgba(0,0,0,0.1)',
	defaultFontColor: '#666',
	defaultFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
	defaultFontSize: 12,
	defaultFontStyle: 'normal',
	showLines: true,

	// Element defaults defined in element extensions
	elements: {},

	// Layout options such as padding
	layout: {
		padding: {
			top: 0,
			right: 0,
			bottom: 0,
			left: 0
		}
	}
});

module.exports = function() {

	// Occupy the global variable of Chart, and create a simple base class
	var Chart = function(item, config) {
		this.construct(item, config);
		return this;
	};

	Chart.Chart = Chart;

	return Chart;
};


/***/ }),

/***/ 2641:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var helpers = __webpack_require__(999);

/**
 * Easing functions adapted from Robert Penner's easing equations.
 * @namespace Chart.helpers.easingEffects
 * @see http://www.robertpenner.com/easing/
 */
var effects = {
	linear: function(t) {
		return t;
	},

	easeInQuad: function(t) {
		return t * t;
	},

	easeOutQuad: function(t) {
		return -t * (t - 2);
	},

	easeInOutQuad: function(t) {
		if ((t /= 0.5) < 1) {
			return 0.5 * t * t;
		}
		return -0.5 * ((--t) * (t - 2) - 1);
	},

	easeInCubic: function(t) {
		return t * t * t;
	},

	easeOutCubic: function(t) {
		return (t = t - 1) * t * t + 1;
	},

	easeInOutCubic: function(t) {
		if ((t /= 0.5) < 1) {
			return 0.5 * t * t * t;
		}
		return 0.5 * ((t -= 2) * t * t + 2);
	},

	easeInQuart: function(t) {
		return t * t * t * t;
	},

	easeOutQuart: function(t) {
		return -((t = t - 1) * t * t * t - 1);
	},

	easeInOutQuart: function(t) {
		if ((t /= 0.5) < 1) {
			return 0.5 * t * t * t * t;
		}
		return -0.5 * ((t -= 2) * t * t * t - 2);
	},

	easeInQuint: function(t) {
		return t * t * t * t * t;
	},

	easeOutQuint: function(t) {
		return (t = t - 1) * t * t * t * t + 1;
	},

	easeInOutQuint: function(t) {
		if ((t /= 0.5) < 1) {
			return 0.5 * t * t * t * t * t;
		}
		return 0.5 * ((t -= 2) * t * t * t * t + 2);
	},

	easeInSine: function(t) {
		return -Math.cos(t * (Math.PI / 2)) + 1;
	},

	easeOutSine: function(t) {
		return Math.sin(t * (Math.PI / 2));
	},

	easeInOutSine: function(t) {
		return -0.5 * (Math.cos(Math.PI * t) - 1);
	},

	easeInExpo: function(t) {
		return (t === 0) ? 0 : Math.pow(2, 10 * (t - 1));
	},

	easeOutExpo: function(t) {
		return (t === 1) ? 1 : -Math.pow(2, -10 * t) + 1;
	},

	easeInOutExpo: function(t) {
		if (t === 0) {
			return 0;
		}
		if (t === 1) {
			return 1;
		}
		if ((t /= 0.5) < 1) {
			return 0.5 * Math.pow(2, 10 * (t - 1));
		}
		return 0.5 * (-Math.pow(2, -10 * --t) + 2);
	},

	easeInCirc: function(t) {
		if (t >= 1) {
			return t;
		}
		return -(Math.sqrt(1 - t * t) - 1);
	},

	easeOutCirc: function(t) {
		return Math.sqrt(1 - (t = t - 1) * t);
	},

	easeInOutCirc: function(t) {
		if ((t /= 0.5) < 1) {
			return -0.5 * (Math.sqrt(1 - t * t) - 1);
		}
		return 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1);
	},

	easeInElastic: function(t) {
		var s = 1.70158;
		var p = 0;
		var a = 1;
		if (t === 0) {
			return 0;
		}
		if (t === 1) {
			return 1;
		}
		if (!p) {
			p = 0.3;
		}
		if (a < 1) {
			a = 1;
			s = p / 4;
		} else {
			s = p / (2 * Math.PI) * Math.asin(1 / a);
		}
		return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
	},

	easeOutElastic: function(t) {
		var s = 1.70158;
		var p = 0;
		var a = 1;
		if (t === 0) {
			return 0;
		}
		if (t === 1) {
			return 1;
		}
		if (!p) {
			p = 0.3;
		}
		if (a < 1) {
			a = 1;
			s = p / 4;
		} else {
			s = p / (2 * Math.PI) * Math.asin(1 / a);
		}
		return a * Math.pow(2, -10 * t) * Math.sin((t - s) * (2 * Math.PI) / p) + 1;
	},

	easeInOutElastic: function(t) {
		var s = 1.70158;
		var p = 0;
		var a = 1;
		if (t === 0) {
			return 0;
		}
		if ((t /= 0.5) === 2) {
			return 1;
		}
		if (!p) {
			p = 0.45;
		}
		if (a < 1) {
			a = 1;
			s = p / 4;
		} else {
			s = p / (2 * Math.PI) * Math.asin(1 / a);
		}
		if (t < 1) {
			return -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
		}
		return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p) * 0.5 + 1;
	},
	easeInBack: function(t) {
		var s = 1.70158;
		return t * t * ((s + 1) * t - s);
	},

	easeOutBack: function(t) {
		var s = 1.70158;
		return (t = t - 1) * t * ((s + 1) * t + s) + 1;
	},

	easeInOutBack: function(t) {
		var s = 1.70158;
		if ((t /= 0.5) < 1) {
			return 0.5 * (t * t * (((s *= (1.525)) + 1) * t - s));
		}
		return 0.5 * ((t -= 2) * t * (((s *= (1.525)) + 1) * t + s) + 2);
	},

	easeInBounce: function(t) {
		return 1 - effects.easeOutBounce(1 - t);
	},

	easeOutBounce: function(t) {
		if (t < (1 / 2.75)) {
			return 7.5625 * t * t;
		}
		if (t < (2 / 2.75)) {
			return 7.5625 * (t -= (1.5 / 2.75)) * t + 0.75;
		}
		if (t < (2.5 / 2.75)) {
			return 7.5625 * (t -= (2.25 / 2.75)) * t + 0.9375;
		}
		return 7.5625 * (t -= (2.625 / 2.75)) * t + 0.984375;
	},

	easeInOutBounce: function(t) {
		if (t < 0.5) {
			return effects.easeInBounce(t * 2) * 0.5;
		}
		return effects.easeOutBounce(t * 2 - 1) * 0.5 + 0.5;
	}
};

module.exports = {
	effects: effects
};

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart.helpers.easing.effects instead.
 * @function Chart.helpers.easingEffects
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.easingEffects = effects;


/***/ }),

/***/ 2642:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var helpers = __webpack_require__(999);

/**
 * @namespace Chart.helpers.canvas
 */
var exports = module.exports = {
	/**
	 * Clears the entire canvas associated to the given `chart`.
	 * @param {Chart} chart - The chart for which to clear the canvas.
	 */
	clear: function(chart) {
		chart.ctx.clearRect(0, 0, chart.width, chart.height);
	},

	/**
	 * Creates a "path" for a rectangle with rounded corners at position (x, y) with a
	 * given size (width, height) and the same `radius` for all corners.
	 * @param {CanvasRenderingContext2D} ctx - The canvas 2D Context.
	 * @param {Number} x - The x axis of the coordinate for the rectangle starting point.
	 * @param {Number} y - The y axis of the coordinate for the rectangle starting point.
	 * @param {Number} width - The rectangle's width.
	 * @param {Number} height - The rectangle's height.
	 * @param {Number} radius - The rounded amount (in pixels) for the four corners.
	 * @todo handle `radius` as top-left, top-right, bottom-right, bottom-left array/object?
	 */
	roundedRect: function(ctx, x, y, width, height, radius) {
		if (radius) {
			var rx = Math.min(radius, width / 2);
			var ry = Math.min(radius, height / 2);

			ctx.moveTo(x + rx, y);
			ctx.lineTo(x + width - rx, y);
			ctx.quadraticCurveTo(x + width, y, x + width, y + ry);
			ctx.lineTo(x + width, y + height - ry);
			ctx.quadraticCurveTo(x + width, y + height, x + width - rx, y + height);
			ctx.lineTo(x + rx, y + height);
			ctx.quadraticCurveTo(x, y + height, x, y + height - ry);
			ctx.lineTo(x, y + ry);
			ctx.quadraticCurveTo(x, y, x + rx, y);
		} else {
			ctx.rect(x, y, width, height);
		}
	},

	drawPoint: function(ctx, style, radius, x, y) {
		var type, edgeLength, xOffset, yOffset, height, size;

		if (style && typeof style === 'object') {
			type = style.toString();
			if (type === '[object HTMLImageElement]' || type === '[object HTMLCanvasElement]') {
				ctx.drawImage(style, x - style.width / 2, y - style.height / 2, style.width, style.height);
				return;
			}
		}

		if (isNaN(radius) || radius <= 0) {
			return;
		}

		switch (style) {
		// Default includes circle
		default:
			ctx.beginPath();
			ctx.arc(x, y, radius, 0, Math.PI * 2);
			ctx.closePath();
			ctx.fill();
			break;
		case 'triangle':
			ctx.beginPath();
			edgeLength = 3 * radius / Math.sqrt(3);
			height = edgeLength * Math.sqrt(3) / 2;
			ctx.moveTo(x - edgeLength / 2, y + height / 3);
			ctx.lineTo(x + edgeLength / 2, y + height / 3);
			ctx.lineTo(x, y - 2 * height / 3);
			ctx.closePath();
			ctx.fill();
			break;
		case 'rect':
			size = 1 / Math.SQRT2 * radius;
			ctx.beginPath();
			ctx.fillRect(x - size, y - size, 2 * size, 2 * size);
			ctx.strokeRect(x - size, y - size, 2 * size, 2 * size);
			break;
		case 'rectRounded':
			var offset = radius / Math.SQRT2;
			var leftX = x - offset;
			var topY = y - offset;
			var sideSize = Math.SQRT2 * radius;
			ctx.beginPath();
			this.roundedRect(ctx, leftX, topY, sideSize, sideSize, radius / 2);
			ctx.closePath();
			ctx.fill();
			break;
		case 'rectRot':
			size = 1 / Math.SQRT2 * radius;
			ctx.beginPath();
			ctx.moveTo(x - size, y);
			ctx.lineTo(x, y + size);
			ctx.lineTo(x + size, y);
			ctx.lineTo(x, y - size);
			ctx.closePath();
			ctx.fill();
			break;
		case 'cross':
			ctx.beginPath();
			ctx.moveTo(x, y + radius);
			ctx.lineTo(x, y - radius);
			ctx.moveTo(x - radius, y);
			ctx.lineTo(x + radius, y);
			ctx.closePath();
			break;
		case 'crossRot':
			ctx.beginPath();
			xOffset = Math.cos(Math.PI / 4) * radius;
			yOffset = Math.sin(Math.PI / 4) * radius;
			ctx.moveTo(x - xOffset, y - yOffset);
			ctx.lineTo(x + xOffset, y + yOffset);
			ctx.moveTo(x - xOffset, y + yOffset);
			ctx.lineTo(x + xOffset, y - yOffset);
			ctx.closePath();
			break;
		case 'star':
			ctx.beginPath();
			ctx.moveTo(x, y + radius);
			ctx.lineTo(x, y - radius);
			ctx.moveTo(x - radius, y);
			ctx.lineTo(x + radius, y);
			xOffset = Math.cos(Math.PI / 4) * radius;
			yOffset = Math.sin(Math.PI / 4) * radius;
			ctx.moveTo(x - xOffset, y - yOffset);
			ctx.lineTo(x + xOffset, y + yOffset);
			ctx.moveTo(x - xOffset, y + yOffset);
			ctx.lineTo(x + xOffset, y - yOffset);
			ctx.closePath();
			break;
		case 'line':
			ctx.beginPath();
			ctx.moveTo(x - radius, y);
			ctx.lineTo(x + radius, y);
			ctx.closePath();
			break;
		case 'dash':
			ctx.beginPath();
			ctx.moveTo(x, y);
			ctx.lineTo(x + radius, y);
			ctx.closePath();
			break;
		}

		ctx.stroke();
	},

	clipArea: function(ctx, area) {
		ctx.save();
		ctx.beginPath();
		ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
		ctx.clip();
	},

	unclipArea: function(ctx) {
		ctx.restore();
	},

	lineTo: function(ctx, previous, target, flip) {
		if (target.steppedLine) {
			if ((target.steppedLine === 'after' && !flip) || (target.steppedLine !== 'after' && flip)) {
				ctx.lineTo(previous.x, target.y);
			} else {
				ctx.lineTo(target.x, previous.y);
			}
			ctx.lineTo(target.x, target.y);
			return;
		}

		if (!target.tension) {
			ctx.lineTo(target.x, target.y);
			return;
		}

		ctx.bezierCurveTo(
			flip ? previous.controlPointPreviousX : previous.controlPointNextX,
			flip ? previous.controlPointPreviousY : previous.controlPointNextY,
			flip ? target.controlPointNextX : target.controlPointPreviousX,
			flip ? target.controlPointNextY : target.controlPointPreviousY,
			target.x,
			target.y);
	}
};

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart.helpers.canvas.clear instead.
 * @namespace Chart.helpers.clear
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.clear = exports.clear;

/**
 * Provided for backward compatibility, use Chart.helpers.canvas.roundedRect instead.
 * @namespace Chart.helpers.drawRoundedRectangle
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.drawRoundedRectangle = function(ctx) {
	ctx.beginPath();
	exports.roundedRect.apply(exports, arguments);
	ctx.closePath();
};


/***/ }),

/***/ 2643:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var helpers = __webpack_require__(999);

/**
 * @alias Chart.helpers.options
 * @namespace
 */
module.exports = {
	/**
	 * Converts the given line height `value` in pixels for a specific font `size`.
	 * @param {Number|String} value - The lineHeight to parse (eg. 1.6, '14px', '75%', '1.6em').
	 * @param {Number} size - The font size (in pixels) used to resolve relative `value`.
	 * @returns {Number} The effective line height in pixels (size * 1.2 if value is invalid).
	 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/line-height
	 * @since 2.7.0
	 */
	toLineHeight: function(value, size) {
		var matches = ('' + value).match(/^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/);
		if (!matches || matches[1] === 'normal') {
			return size * 1.2;
		}

		value = +matches[2];

		switch (matches[3]) {
		case 'px':
			return value;
		case '%':
			value /= 100;
			break;
		default:
			break;
		}

		return size * value;
	},

	/**
	 * Converts the given value into a padding object with pre-computed width/height.
	 * @param {Number|Object} value - If a number, set the value to all TRBL component,
	 *  else, if and object, use defined properties and sets undefined ones to 0.
	 * @returns {Object} The padding values (top, right, bottom, left, width, height)
	 * @since 2.7.0
	 */
	toPadding: function(value) {
		var t, r, b, l;

		if (helpers.isObject(value)) {
			t = +value.top || 0;
			r = +value.right || 0;
			b = +value.bottom || 0;
			l = +value.left || 0;
		} else {
			t = r = b = l = +value || 0;
		}

		return {
			top: t,
			right: r,
			bottom: b,
			left: l,
			height: t + b,
			width: l + r
		};
	},

	/**
	 * Evaluates the given `inputs` sequentially and returns the first defined value.
	 * @param {Array[]} inputs - An array of values, falling back to the last value.
	 * @param {Object} [context] - If defined and the current value is a function, the value
	 * is called with `context` as first argument and the result becomes the new input.
	 * @param {Number} [index] - If defined and the current value is an array, the value
	 * at `index` become the new input.
	 * @since 2.7.0
	 */
	resolve: function(inputs, context, index) {
		var i, ilen, value;

		for (i = 0, ilen = inputs.length; i < ilen; ++i) {
			value = inputs[i];
			if (value === undefined) {
				continue;
			}
			if (context !== undefined && typeof value === 'function') {
				value = value(context);
			}
			if (index !== undefined && helpers.isArray(value)) {
				value = value[index];
			}
			if (value !== undefined) {
				return value;
			}
		}
	}
};


/***/ }),

/***/ 2644:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* global window: false */
/* global document: false */


var color = __webpack_require__(1460);
var defaults = __webpack_require__(796);
var helpers = __webpack_require__(789);

module.exports = function(Chart) {

	// -- Basic js utility methods

	helpers.configMerge = function(/* objects ... */) {
		return helpers.merge(helpers.clone(arguments[0]), [].slice.call(arguments, 1), {
			merger: function(key, target, source, options) {
				var tval = target[key] || {};
				var sval = source[key];

				if (key === 'scales') {
					// scale config merging is complex. Add our own function here for that
					target[key] = helpers.scaleMerge(tval, sval);
				} else if (key === 'scale') {
					// used in polar area & radar charts since there is only one scale
					target[key] = helpers.merge(tval, [Chart.scaleService.getScaleDefaults(sval.type), sval]);
				} else {
					helpers._merger(key, target, source, options);
				}
			}
		});
	};

	helpers.scaleMerge = function(/* objects ... */) {
		return helpers.merge(helpers.clone(arguments[0]), [].slice.call(arguments, 1), {
			merger: function(key, target, source, options) {
				if (key === 'xAxes' || key === 'yAxes') {
					var slen = source[key].length;
					var i, type, scale;

					if (!target[key]) {
						target[key] = [];
					}

					for (i = 0; i < slen; ++i) {
						scale = source[key][i];
						type = helpers.valueOrDefault(scale.type, key === 'xAxes' ? 'category' : 'linear');

						if (i >= target[key].length) {
							target[key].push({});
						}

						if (!target[key][i].type || (scale.type && scale.type !== target[key][i].type)) {
							// new/untyped scale or type changed: let's apply the new defaults
							// then merge source scale to correctly overwrite the defaults.
							helpers.merge(target[key][i], [Chart.scaleService.getScaleDefaults(type), scale]);
						} else {
							// scales type are the same
							helpers.merge(target[key][i], scale);
						}
					}
				} else {
					helpers._merger(key, target, source, options);
				}
			}
		});
	};

	helpers.where = function(collection, filterCallback) {
		if (helpers.isArray(collection) && Array.prototype.filter) {
			return collection.filter(filterCallback);
		}
		var filtered = [];

		helpers.each(collection, function(item) {
			if (filterCallback(item)) {
				filtered.push(item);
			}
		});

		return filtered;
	};
	helpers.findIndex = Array.prototype.findIndex ?
		function(array, callback, scope) {
			return array.findIndex(callback, scope);
		} :
		function(array, callback, scope) {
			scope = scope === undefined ? array : scope;
			for (var i = 0, ilen = array.length; i < ilen; ++i) {
				if (callback.call(scope, array[i], i, array)) {
					return i;
				}
			}
			return -1;
		};
	helpers.findNextWhere = function(arrayToSearch, filterCallback, startIndex) {
		// Default to start of the array
		if (helpers.isNullOrUndef(startIndex)) {
			startIndex = -1;
		}
		for (var i = startIndex + 1; i < arrayToSearch.length; i++) {
			var currentItem = arrayToSearch[i];
			if (filterCallback(currentItem)) {
				return currentItem;
			}
		}
	};
	helpers.findPreviousWhere = function(arrayToSearch, filterCallback, startIndex) {
		// Default to end of the array
		if (helpers.isNullOrUndef(startIndex)) {
			startIndex = arrayToSearch.length;
		}
		for (var i = startIndex - 1; i >= 0; i--) {
			var currentItem = arrayToSearch[i];
			if (filterCallback(currentItem)) {
				return currentItem;
			}
		}
	};

	// -- Math methods
	helpers.isNumber = function(n) {
		return !isNaN(parseFloat(n)) && isFinite(n);
	};
	helpers.almostEquals = function(x, y, epsilon) {
		return Math.abs(x - y) < epsilon;
	};
	helpers.almostWhole = function(x, epsilon) {
		var rounded = Math.round(x);
		return (((rounded - epsilon) < x) && ((rounded + epsilon) > x));
	};
	helpers.max = function(array) {
		return array.reduce(function(max, value) {
			if (!isNaN(value)) {
				return Math.max(max, value);
			}
			return max;
		}, Number.NEGATIVE_INFINITY);
	};
	helpers.min = function(array) {
		return array.reduce(function(min, value) {
			if (!isNaN(value)) {
				return Math.min(min, value);
			}
			return min;
		}, Number.POSITIVE_INFINITY);
	};
	helpers.sign = Math.sign ?
		function(x) {
			return Math.sign(x);
		} :
		function(x) {
			x = +x; // convert to a number
			if (x === 0 || isNaN(x)) {
				return x;
			}
			return x > 0 ? 1 : -1;
		};
	helpers.log10 = Math.log10 ?
		function(x) {
			return Math.log10(x);
		} :
		function(x) {
			return Math.log(x) / Math.LN10;
		};
	helpers.toRadians = function(degrees) {
		return degrees * (Math.PI / 180);
	};
	helpers.toDegrees = function(radians) {
		return radians * (180 / Math.PI);
	};
	// Gets the angle from vertical upright to the point about a centre.
	helpers.getAngleFromPoint = function(centrePoint, anglePoint) {
		var distanceFromXCenter = anglePoint.x - centrePoint.x;
		var distanceFromYCenter = anglePoint.y - centrePoint.y;
		var radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);

		var angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);

		if (angle < (-0.5 * Math.PI)) {
			angle += 2.0 * Math.PI; // make sure the returned angle is in the range of (-PI/2, 3PI/2]
		}

		return {
			angle: angle,
			distance: radialDistanceFromCenter
		};
	};
	helpers.distanceBetweenPoints = function(pt1, pt2) {
		return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
	};
	helpers.aliasPixel = function(pixelWidth) {
		return (pixelWidth % 2 === 0) ? 0 : 0.5;
	};
	helpers.splineCurve = function(firstPoint, middlePoint, afterPoint, t) {
		// Props to Rob Spencer at scaled innovation for his post on splining between points
		// http://scaledinnovation.com/analytics/splines/aboutSplines.html

		// This function must also respect "skipped" points

		var previous = firstPoint.skip ? middlePoint : firstPoint;
		var current = middlePoint;
		var next = afterPoint.skip ? middlePoint : afterPoint;

		var d01 = Math.sqrt(Math.pow(current.x - previous.x, 2) + Math.pow(current.y - previous.y, 2));
		var d12 = Math.sqrt(Math.pow(next.x - current.x, 2) + Math.pow(next.y - current.y, 2));

		var s01 = d01 / (d01 + d12);
		var s12 = d12 / (d01 + d12);

		// If all points are the same, s01 & s02 will be inf
		s01 = isNaN(s01) ? 0 : s01;
		s12 = isNaN(s12) ? 0 : s12;

		var fa = t * s01; // scaling factor for triangle Ta
		var fb = t * s12;

		return {
			previous: {
				x: current.x - fa * (next.x - previous.x),
				y: current.y - fa * (next.y - previous.y)
			},
			next: {
				x: current.x + fb * (next.x - previous.x),
				y: current.y + fb * (next.y - previous.y)
			}
		};
	};
	helpers.EPSILON = Number.EPSILON || 1e-14;
	helpers.splineCurveMonotone = function(points) {
		// This function calculates Bézier control points in a similar way than |splineCurve|,
		// but preserves monotonicity of the provided data and ensures no local extremums are added
		// between the dataset discrete points due to the interpolation.
		// See : https://en.wikipedia.org/wiki/Monotone_cubic_interpolation

		var pointsWithTangents = (points || []).map(function(point) {
			return {
				model: point._model,
				deltaK: 0,
				mK: 0
			};
		});

		// Calculate slopes (deltaK) and initialize tangents (mK)
		var pointsLen = pointsWithTangents.length;
		var i, pointBefore, pointCurrent, pointAfter;
		for (i = 0; i < pointsLen; ++i) {
			pointCurrent = pointsWithTangents[i];
			if (pointCurrent.model.skip) {
				continue;
			}

			pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
			pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
			if (pointAfter && !pointAfter.model.skip) {
				var slopeDeltaX = (pointAfter.model.x - pointCurrent.model.x);

				// In the case of two points that appear at the same x pixel, slopeDeltaX is 0
				pointCurrent.deltaK = slopeDeltaX !== 0 ? (pointAfter.model.y - pointCurrent.model.y) / slopeDeltaX : 0;
			}

			if (!pointBefore || pointBefore.model.skip) {
				pointCurrent.mK = pointCurrent.deltaK;
			} else if (!pointAfter || pointAfter.model.skip) {
				pointCurrent.mK = pointBefore.deltaK;
			} else if (this.sign(pointBefore.deltaK) !== this.sign(pointCurrent.deltaK)) {
				pointCurrent.mK = 0;
			} else {
				pointCurrent.mK = (pointBefore.deltaK + pointCurrent.deltaK) / 2;
			}
		}

		// Adjust tangents to ensure monotonic properties
		var alphaK, betaK, tauK, squaredMagnitude;
		for (i = 0; i < pointsLen - 1; ++i) {
			pointCurrent = pointsWithTangents[i];
			pointAfter = pointsWithTangents[i + 1];
			if (pointCurrent.model.skip || pointAfter.model.skip) {
				continue;
			}

			if (helpers.almostEquals(pointCurrent.deltaK, 0, this.EPSILON)) {
				pointCurrent.mK = pointAfter.mK = 0;
				continue;
			}

			alphaK = pointCurrent.mK / pointCurrent.deltaK;
			betaK = pointAfter.mK / pointCurrent.deltaK;
			squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
			if (squaredMagnitude <= 9) {
				continue;
			}

			tauK = 3 / Math.sqrt(squaredMagnitude);
			pointCurrent.mK = alphaK * tauK * pointCurrent.deltaK;
			pointAfter.mK = betaK * tauK * pointCurrent.deltaK;
		}

		// Compute control points
		var deltaX;
		for (i = 0; i < pointsLen; ++i) {
			pointCurrent = pointsWithTangents[i];
			if (pointCurrent.model.skip) {
				continue;
			}

			pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
			pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
			if (pointBefore && !pointBefore.model.skip) {
				deltaX = (pointCurrent.model.x - pointBefore.model.x) / 3;
				pointCurrent.model.controlPointPreviousX = pointCurrent.model.x - deltaX;
				pointCurrent.model.controlPointPreviousY = pointCurrent.model.y - deltaX * pointCurrent.mK;
			}
			if (pointAfter && !pointAfter.model.skip) {
				deltaX = (pointAfter.model.x - pointCurrent.model.x) / 3;
				pointCurrent.model.controlPointNextX = pointCurrent.model.x + deltaX;
				pointCurrent.model.controlPointNextY = pointCurrent.model.y + deltaX * pointCurrent.mK;
			}
		}
	};
	helpers.nextItem = function(collection, index, loop) {
		if (loop) {
			return index >= collection.length - 1 ? collection[0] : collection[index + 1];
		}
		return index >= collection.length - 1 ? collection[collection.length - 1] : collection[index + 1];
	};
	helpers.previousItem = function(collection, index, loop) {
		if (loop) {
			return index <= 0 ? collection[collection.length - 1] : collection[index - 1];
		}
		return index <= 0 ? collection[0] : collection[index - 1];
	};
	// Implementation of the nice number algorithm used in determining where axis labels will go
	helpers.niceNum = function(range, round) {
		var exponent = Math.floor(helpers.log10(range));
		var fraction = range / Math.pow(10, exponent);
		var niceFraction;

		if (round) {
			if (fraction < 1.5) {
				niceFraction = 1;
			} else if (fraction < 3) {
				niceFraction = 2;
			} else if (fraction < 7) {
				niceFraction = 5;
			} else {
				niceFraction = 10;
			}
		} else if (fraction <= 1.0) {
			niceFraction = 1;
		} else if (fraction <= 2) {
			niceFraction = 2;
		} else if (fraction <= 5) {
			niceFraction = 5;
		} else {
			niceFraction = 10;
		}

		return niceFraction * Math.pow(10, exponent);
	};
	// Request animation polyfill - http://www.paulirish.com/2011/requestanimationframe-for-smart-animating/
	helpers.requestAnimFrame = (function() {
		if (typeof window === 'undefined') {
			return function(callback) {
				callback();
			};
		}
		return window.requestAnimationFrame ||
			window.webkitRequestAnimationFrame ||
			window.mozRequestAnimationFrame ||
			window.oRequestAnimationFrame ||
			window.msRequestAnimationFrame ||
			function(callback) {
				return window.setTimeout(callback, 1000 / 60);
			};
	}());
	// -- DOM methods
	helpers.getRelativePosition = function(evt, chart) {
		var mouseX, mouseY;
		var e = evt.originalEvent || evt;
		var canvas = evt.currentTarget || evt.srcElement;
		var boundingRect = canvas.getBoundingClientRect();

		var touches = e.touches;
		if (touches && touches.length > 0) {
			mouseX = touches[0].clientX;
			mouseY = touches[0].clientY;

		} else {
			mouseX = e.clientX;
			mouseY = e.clientY;
		}

		// Scale mouse coordinates into canvas coordinates
		// by following the pattern laid out by 'jerryj' in the comments of
		// http://www.html5canvastutorials.com/advanced/html5-canvas-mouse-coordinates/
		var paddingLeft = parseFloat(helpers.getStyle(canvas, 'padding-left'));
		var paddingTop = parseFloat(helpers.getStyle(canvas, 'padding-top'));
		var paddingRight = parseFloat(helpers.getStyle(canvas, 'padding-right'));
		var paddingBottom = parseFloat(helpers.getStyle(canvas, 'padding-bottom'));
		var width = boundingRect.right - boundingRect.left - paddingLeft - paddingRight;
		var height = boundingRect.bottom - boundingRect.top - paddingTop - paddingBottom;

		// We divide by the current device pixel ratio, because the canvas is scaled up by that amount in each direction. However
		// the backend model is in unscaled coordinates. Since we are going to deal with our model coordinates, we go back here
		mouseX = Math.round((mouseX - boundingRect.left - paddingLeft) / (width) * canvas.width / chart.currentDevicePixelRatio);
		mouseY = Math.round((mouseY - boundingRect.top - paddingTop) / (height) * canvas.height / chart.currentDevicePixelRatio);

		return {
			x: mouseX,
			y: mouseY
		};

	};

	// Private helper function to convert max-width/max-height values that may be percentages into a number
	function parseMaxStyle(styleValue, node, parentProperty) {
		var valueInPixels;
		if (typeof styleValue === 'string') {
			valueInPixels = parseInt(styleValue, 10);

			if (styleValue.indexOf('%') !== -1) {
				// percentage * size in dimension
				valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
			}
		} else {
			valueInPixels = styleValue;
		}

		return valueInPixels;
	}

	/**
	 * Returns if the given value contains an effective constraint.
	 * @private
	 */
	function isConstrainedValue(value) {
		return value !== undefined && value !== null && value !== 'none';
	}

	// Private helper to get a constraint dimension
	// @param domNode : the node to check the constraint on
	// @param maxStyle : the style that defines the maximum for the direction we are using (maxWidth / maxHeight)
	// @param percentageProperty : property of parent to use when calculating width as a percentage
	// @see http://www.nathanaeljones.com/blog/2013/reading-max-width-cross-browser
	function getConstraintDimension(domNode, maxStyle, percentageProperty) {
		var view = document.defaultView;
		var parentNode = domNode.parentNode;
		var constrainedNode = view.getComputedStyle(domNode)[maxStyle];
		var constrainedContainer = view.getComputedStyle(parentNode)[maxStyle];
		var hasCNode = isConstrainedValue(constrainedNode);
		var hasCContainer = isConstrainedValue(constrainedContainer);
		var infinity = Number.POSITIVE_INFINITY;

		if (hasCNode || hasCContainer) {
			return Math.min(
				hasCNode ? parseMaxStyle(constrainedNode, domNode, percentageProperty) : infinity,
				hasCContainer ? parseMaxStyle(constrainedContainer, parentNode, percentageProperty) : infinity);
		}

		return 'none';
	}
	// returns Number or undefined if no constraint
	helpers.getConstraintWidth = function(domNode) {
		return getConstraintDimension(domNode, 'max-width', 'clientWidth');
	};
	// returns Number or undefined if no constraint
	helpers.getConstraintHeight = function(domNode) {
		return getConstraintDimension(domNode, 'max-height', 'clientHeight');
	};
	helpers.getMaximumWidth = function(domNode) {
		var container = domNode.parentNode;
		if (!container) {
			return domNode.clientWidth;
		}

		var paddingLeft = parseInt(helpers.getStyle(container, 'padding-left'), 10);
		var paddingRight = parseInt(helpers.getStyle(container, 'padding-right'), 10);
		var w = container.clientWidth - paddingLeft - paddingRight;
		var cw = helpers.getConstraintWidth(domNode);
		return isNaN(cw) ? w : Math.min(w, cw);
	};
	helpers.getMaximumHeight = function(domNode) {
		var container = domNode.parentNode;
		if (!container) {
			return domNode.clientHeight;
		}

		var paddingTop = parseInt(helpers.getStyle(container, 'padding-top'), 10);
		var paddingBottom = parseInt(helpers.getStyle(container, 'padding-bottom'), 10);
		var h = container.clientHeight - paddingTop - paddingBottom;
		var ch = helpers.getConstraintHeight(domNode);
		return isNaN(ch) ? h : Math.min(h, ch);
	};
	helpers.getStyle = function(el, property) {
		return el.currentStyle ?
			el.currentStyle[property] :
			document.defaultView.getComputedStyle(el, null).getPropertyValue(property);
	};
	helpers.retinaScale = function(chart, forceRatio) {
		var pixelRatio = chart.currentDevicePixelRatio = forceRatio || window.devicePixelRatio || 1;
		if (pixelRatio === 1) {
			return;
		}

		var canvas = chart.canvas;
		var height = chart.height;
		var width = chart.width;

		canvas.height = height * pixelRatio;
		canvas.width = width * pixelRatio;
		chart.ctx.scale(pixelRatio, pixelRatio);

		// If no style has been set on the canvas, the render size is used as display size,
		// making the chart visually bigger, so let's enforce it to the "correct" values.
		// See https://github.com/chartjs/Chart.js/issues/3575
		canvas.style.height = height + 'px';
		canvas.style.width = width + 'px';
	};
	// -- Canvas methods
	helpers.fontString = function(pixelSize, fontStyle, fontFamily) {
		return fontStyle + ' ' + pixelSize + 'px ' + fontFamily;
	};
	helpers.longestText = function(ctx, font, arrayOfThings, cache) {
		cache = cache || {};
		var data = cache.data = cache.data || {};
		var gc = cache.garbageCollect = cache.garbageCollect || [];

		if (cache.font !== font) {
			data = cache.data = {};
			gc = cache.garbageCollect = [];
			cache.font = font;
		}

		ctx.font = font;
		var longest = 0;
		helpers.each(arrayOfThings, function(thing) {
			// Undefined strings and arrays should not be measured
			if (thing !== undefined && thing !== null && helpers.isArray(thing) !== true) {
				longest = helpers.measureText(ctx, data, gc, longest, thing);
			} else if (helpers.isArray(thing)) {
				// if it is an array lets measure each element
				// to do maybe simplify this function a bit so we can do this more recursively?
				helpers.each(thing, function(nestedThing) {
					// Undefined strings and arrays should not be measured
					if (nestedThing !== undefined && nestedThing !== null && !helpers.isArray(nestedThing)) {
						longest = helpers.measureText(ctx, data, gc, longest, nestedThing);
					}
				});
			}
		});

		var gcLen = gc.length / 2;
		if (gcLen > arrayOfThings.length) {
			for (var i = 0; i < gcLen; i++) {
				delete data[gc[i]];
			}
			gc.splice(0, gcLen);
		}
		return longest;
	};
	helpers.measureText = function(ctx, data, gc, longest, string) {
		var textWidth = data[string];
		if (!textWidth) {
			textWidth = data[string] = ctx.measureText(string).width;
			gc.push(string);
		}
		if (textWidth > longest) {
			longest = textWidth;
		}
		return longest;
	};
	helpers.numberOfLabelLines = function(arrayOfThings) {
		var numberOfLines = 1;
		helpers.each(arrayOfThings, function(thing) {
			if (helpers.isArray(thing)) {
				if (thing.length > numberOfLines) {
					numberOfLines = thing.length;
				}
			}
		});
		return numberOfLines;
	};

	helpers.color = !color ?
		function(value) {
			console.error('Color.js not found!');
			return value;
		} :
		function(value) {
			/* global CanvasGradient */
			if (value instanceof CanvasGradient) {
				value = defaults.global.defaultColor;
			}

			return color(value);
		};

	helpers.getHoverColor = function(colorValue) {
		/* global CanvasPattern */
		return (colorValue instanceof CanvasPattern) ?
			colorValue :
			helpers.color(colorValue).saturate(0.5).darken(0.1).rgbString();
	};
};


/***/ }),

/***/ 2645:
/***/ (function(module, exports, __webpack_require__) {

var conversions = __webpack_require__(2646);

var convert = function() {
   return new Converter();
}

for (var func in conversions) {
  // export Raw versions
  convert[func + "Raw"] =  (function(func) {
    // accept array or plain args
    return function(arg) {
      if (typeof arg == "number")
        arg = Array.prototype.slice.call(arguments);
      return conversions[func](arg);
    }
  })(func);

  var pair = /(\w+)2(\w+)/.exec(func),
      from = pair[1],
      to = pair[2];

  // export rgb2hsl and ["rgb"]["hsl"]
  convert[from] = convert[from] || {};

  convert[from][to] = convert[func] = (function(func) { 
    return function(arg) {
      if (typeof arg == "number")
        arg = Array.prototype.slice.call(arguments);
      
      var val = conversions[func](arg);
      if (typeof val == "string" || val === undefined)
        return val; // keyword

      for (var i = 0; i < val.length; i++)
        val[i] = Math.round(val[i]);
      return val;
    }
  })(func);
}


/* Converter does lazy conversion and caching */
var Converter = function() {
   this.convs = {};
};

/* Either get the values for a space or
  set the values for a space, depending on args */
Converter.prototype.routeSpace = function(space, args) {
   var values = args[0];
   if (values === undefined) {
      // color.rgb()
      return this.getValues(space);
   }
   // color.rgb(10, 10, 10)
   if (typeof values == "number") {
      values = Array.prototype.slice.call(args);        
   }

   return this.setValues(space, values);
};
  
/* Set the values for a space, invalidating cache */
Converter.prototype.setValues = function(space, values) {
   this.space = space;
   this.convs = {};
   this.convs[space] = values;
   return this;
};

/* Get the values for a space. If there's already
  a conversion for the space, fetch it, otherwise
  compute it */
Converter.prototype.getValues = function(space) {
   var vals = this.convs[space];
   if (!vals) {
      var fspace = this.space,
          from = this.convs[fspace];
      vals = convert[fspace][space](from);

      this.convs[space] = vals;
   }
  return vals;
};

["rgb", "hsl", "hsv", "cmyk", "keyword"].forEach(function(space) {
   Converter.prototype[space] = function(vals) {
      return this.routeSpace(space, arguments);
   }
});

module.exports = convert;

/***/ }),

/***/ 2646:
/***/ (function(module, exports) {

/* MIT license */

module.exports = {
  rgb2hsl: rgb2hsl,
  rgb2hsv: rgb2hsv,
  rgb2hwb: rgb2hwb,
  rgb2cmyk: rgb2cmyk,
  rgb2keyword: rgb2keyword,
  rgb2xyz: rgb2xyz,
  rgb2lab: rgb2lab,
  rgb2lch: rgb2lch,

  hsl2rgb: hsl2rgb,
  hsl2hsv: hsl2hsv,
  hsl2hwb: hsl2hwb,
  hsl2cmyk: hsl2cmyk,
  hsl2keyword: hsl2keyword,

  hsv2rgb: hsv2rgb,
  hsv2hsl: hsv2hsl,
  hsv2hwb: hsv2hwb,
  hsv2cmyk: hsv2cmyk,
  hsv2keyword: hsv2keyword,

  hwb2rgb: hwb2rgb,
  hwb2hsl: hwb2hsl,
  hwb2hsv: hwb2hsv,
  hwb2cmyk: hwb2cmyk,
  hwb2keyword: hwb2keyword,

  cmyk2rgb: cmyk2rgb,
  cmyk2hsl: cmyk2hsl,
  cmyk2hsv: cmyk2hsv,
  cmyk2hwb: cmyk2hwb,
  cmyk2keyword: cmyk2keyword,

  keyword2rgb: keyword2rgb,
  keyword2hsl: keyword2hsl,
  keyword2hsv: keyword2hsv,
  keyword2hwb: keyword2hwb,
  keyword2cmyk: keyword2cmyk,
  keyword2lab: keyword2lab,
  keyword2xyz: keyword2xyz,

  xyz2rgb: xyz2rgb,
  xyz2lab: xyz2lab,
  xyz2lch: xyz2lch,

  lab2xyz: lab2xyz,
  lab2rgb: lab2rgb,
  lab2lch: lab2lch,

  lch2lab: lch2lab,
  lch2xyz: lch2xyz,
  lch2rgb: lch2rgb
}


function rgb2hsl(rgb) {
  var r = rgb[0]/255,
      g = rgb[1]/255,
      b = rgb[2]/255,
      min = Math.min(r, g, b),
      max = Math.max(r, g, b),
      delta = max - min,
      h, s, l;

  if (max == min)
    h = 0;
  else if (r == max)
    h = (g - b) / delta;
  else if (g == max)
    h = 2 + (b - r) / delta;
  else if (b == max)
    h = 4 + (r - g)/ delta;

  h = Math.min(h * 60, 360);

  if (h < 0)
    h += 360;

  l = (min + max) / 2;

  if (max == min)
    s = 0;
  else if (l <= 0.5)
    s = delta / (max + min);
  else
    s = delta / (2 - max - min);

  return [h, s * 100, l * 100];
}

function rgb2hsv(rgb) {
  var r = rgb[0],
      g = rgb[1],
      b = rgb[2],
      min = Math.min(r, g, b),
      max = Math.max(r, g, b),
      delta = max - min,
      h, s, v;

  if (max == 0)
    s = 0;
  else
    s = (delta/max * 1000)/10;

  if (max == min)
    h = 0;
  else if (r == max)
    h = (g - b) / delta;
  else if (g == max)
    h = 2 + (b - r) / delta;
  else if (b == max)
    h = 4 + (r - g) / delta;

  h = Math.min(h * 60, 360);

  if (h < 0)
    h += 360;

  v = ((max / 255) * 1000) / 10;

  return [h, s, v];
}

function rgb2hwb(rgb) {
  var r = rgb[0],
      g = rgb[1],
      b = rgb[2],
      h = rgb2hsl(rgb)[0],
      w = 1/255 * Math.min(r, Math.min(g, b)),
      b = 1 - 1/255 * Math.max(r, Math.max(g, b));

  return [h, w * 100, b * 100];
}

function rgb2cmyk(rgb) {
  var r = rgb[0] / 255,
      g = rgb[1] / 255,
      b = rgb[2] / 255,
      c, m, y, k;

  k = Math.min(1 - r, 1 - g, 1 - b);
  c = (1 - r - k) / (1 - k) || 0;
  m = (1 - g - k) / (1 - k) || 0;
  y = (1 - b - k) / (1 - k) || 0;
  return [c * 100, m * 100, y * 100, k * 100];
}

function rgb2keyword(rgb) {
  return reverseKeywords[JSON.stringify(rgb)];
}

function rgb2xyz(rgb) {
  var r = rgb[0] / 255,
      g = rgb[1] / 255,
      b = rgb[2] / 255;

  // assume sRGB
  r = r > 0.04045 ? Math.pow(((r + 0.055) / 1.055), 2.4) : (r / 12.92);
  g = g > 0.04045 ? Math.pow(((g + 0.055) / 1.055), 2.4) : (g / 12.92);
  b = b > 0.04045 ? Math.pow(((b + 0.055) / 1.055), 2.4) : (b / 12.92);

  var x = (r * 0.4124) + (g * 0.3576) + (b * 0.1805);
  var y = (r * 0.2126) + (g * 0.7152) + (b * 0.0722);
  var z = (r * 0.0193) + (g * 0.1192) + (b * 0.9505);

  return [x * 100, y *100, z * 100];
}

function rgb2lab(rgb) {
  var xyz = rgb2xyz(rgb),
        x = xyz[0],
        y = xyz[1],
        z = xyz[2],
        l, a, b;

  x /= 95.047;
  y /= 100;
  z /= 108.883;

  x = x > 0.008856 ? Math.pow(x, 1/3) : (7.787 * x) + (16 / 116);
  y = y > 0.008856 ? Math.pow(y, 1/3) : (7.787 * y) + (16 / 116);
  z = z > 0.008856 ? Math.pow(z, 1/3) : (7.787 * z) + (16 / 116);

  l = (116 * y) - 16;
  a = 500 * (x - y);
  b = 200 * (y - z);

  return [l, a, b];
}

function rgb2lch(args) {
  return lab2lch(rgb2lab(args));
}

function hsl2rgb(hsl) {
  var h = hsl[0] / 360,
      s = hsl[1] / 100,
      l = hsl[2] / 100,
      t1, t2, t3, rgb, val;

  if (s == 0) {
    val = l * 255;
    return [val, val, val];
  }

  if (l < 0.5)
    t2 = l * (1 + s);
  else
    t2 = l + s - l * s;
  t1 = 2 * l - t2;

  rgb = [0, 0, 0];
  for (var i = 0; i < 3; i++) {
    t3 = h + 1 / 3 * - (i - 1);
    t3 < 0 && t3++;
    t3 > 1 && t3--;

    if (6 * t3 < 1)
      val = t1 + (t2 - t1) * 6 * t3;
    else if (2 * t3 < 1)
      val = t2;
    else if (3 * t3 < 2)
      val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
    else
      val = t1;

    rgb[i] = val * 255;
  }

  return rgb;
}

function hsl2hsv(hsl) {
  var h = hsl[0],
      s = hsl[1] / 100,
      l = hsl[2] / 100,
      sv, v;

  if(l === 0) {
      // no need to do calc on black
      // also avoids divide by 0 error
      return [0, 0, 0];
  }

  l *= 2;
  s *= (l <= 1) ? l : 2 - l;
  v = (l + s) / 2;
  sv = (2 * s) / (l + s);
  return [h, sv * 100, v * 100];
}

function hsl2hwb(args) {
  return rgb2hwb(hsl2rgb(args));
}

function hsl2cmyk(args) {
  return rgb2cmyk(hsl2rgb(args));
}

function hsl2keyword(args) {
  return rgb2keyword(hsl2rgb(args));
}


function hsv2rgb(hsv) {
  var h = hsv[0] / 60,
      s = hsv[1] / 100,
      v = hsv[2] / 100,
      hi = Math.floor(h) % 6;

  var f = h - Math.floor(h),
      p = 255 * v * (1 - s),
      q = 255 * v * (1 - (s * f)),
      t = 255 * v * (1 - (s * (1 - f))),
      v = 255 * v;

  switch(hi) {
    case 0:
      return [v, t, p];
    case 1:
      return [q, v, p];
    case 2:
      return [p, v, t];
    case 3:
      return [p, q, v];
    case 4:
      return [t, p, v];
    case 5:
      return [v, p, q];
  }
}

function hsv2hsl(hsv) {
  var h = hsv[0],
      s = hsv[1] / 100,
      v = hsv[2] / 100,
      sl, l;

  l = (2 - s) * v;
  sl = s * v;
  sl /= (l <= 1) ? l : 2 - l;
  sl = sl || 0;
  l /= 2;
  return [h, sl * 100, l * 100];
}

function hsv2hwb(args) {
  return rgb2hwb(hsv2rgb(args))
}

function hsv2cmyk(args) {
  return rgb2cmyk(hsv2rgb(args));
}

function hsv2keyword(args) {
  return rgb2keyword(hsv2rgb(args));
}

// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
function hwb2rgb(hwb) {
  var h = hwb[0] / 360,
      wh = hwb[1] / 100,
      bl = hwb[2] / 100,
      ratio = wh + bl,
      i, v, f, n;

  // wh + bl cant be > 1
  if (ratio > 1) {
    wh /= ratio;
    bl /= ratio;
  }

  i = Math.floor(6 * h);
  v = 1 - bl;
  f = 6 * h - i;
  if ((i & 0x01) != 0) {
    f = 1 - f;
  }
  n = wh + f * (v - wh);  // linear interpolation

  switch (i) {
    default:
    case 6:
    case 0: r = v; g = n; b = wh; break;
    case 1: r = n; g = v; b = wh; break;
    case 2: r = wh; g = v; b = n; break;
    case 3: r = wh; g = n; b = v; break;
    case 4: r = n; g = wh; b = v; break;
    case 5: r = v; g = wh; b = n; break;
  }

  return [r * 255, g * 255, b * 255];
}

function hwb2hsl(args) {
  return rgb2hsl(hwb2rgb(args));
}

function hwb2hsv(args) {
  return rgb2hsv(hwb2rgb(args));
}

function hwb2cmyk(args) {
  return rgb2cmyk(hwb2rgb(args));
}

function hwb2keyword(args) {
  return rgb2keyword(hwb2rgb(args));
}

function cmyk2rgb(cmyk) {
  var c = cmyk[0] / 100,
      m = cmyk[1] / 100,
      y = cmyk[2] / 100,
      k = cmyk[3] / 100,
      r, g, b;

  r = 1 - Math.min(1, c * (1 - k) + k);
  g = 1 - Math.min(1, m * (1 - k) + k);
  b = 1 - Math.min(1, y * (1 - k) + k);
  return [r * 255, g * 255, b * 255];
}

function cmyk2hsl(args) {
  return rgb2hsl(cmyk2rgb(args));
}

function cmyk2hsv(args) {
  return rgb2hsv(cmyk2rgb(args));
}

function cmyk2hwb(args) {
  return rgb2hwb(cmyk2rgb(args));
}

function cmyk2keyword(args) {
  return rgb2keyword(cmyk2rgb(args));
}


function xyz2rgb(xyz) {
  var x = xyz[0] / 100,
      y = xyz[1] / 100,
      z = xyz[2] / 100,
      r, g, b;

  r = (x * 3.2406) + (y * -1.5372) + (z * -0.4986);
  g = (x * -0.9689) + (y * 1.8758) + (z * 0.0415);
  b = (x * 0.0557) + (y * -0.2040) + (z * 1.0570);

  // assume sRGB
  r = r > 0.0031308 ? ((1.055 * Math.pow(r, 1.0 / 2.4)) - 0.055)
    : r = (r * 12.92);

  g = g > 0.0031308 ? ((1.055 * Math.pow(g, 1.0 / 2.4)) - 0.055)
    : g = (g * 12.92);

  b = b > 0.0031308 ? ((1.055 * Math.pow(b, 1.0 / 2.4)) - 0.055)
    : b = (b * 12.92);

  r = Math.min(Math.max(0, r), 1);
  g = Math.min(Math.max(0, g), 1);
  b = Math.min(Math.max(0, b), 1);

  return [r * 255, g * 255, b * 255];
}

function xyz2lab(xyz) {
  var x = xyz[0],
      y = xyz[1],
      z = xyz[2],
      l, a, b;

  x /= 95.047;
  y /= 100;
  z /= 108.883;

  x = x > 0.008856 ? Math.pow(x, 1/3) : (7.787 * x) + (16 / 116);
  y = y > 0.008856 ? Math.pow(y, 1/3) : (7.787 * y) + (16 / 116);
  z = z > 0.008856 ? Math.pow(z, 1/3) : (7.787 * z) + (16 / 116);

  l = (116 * y) - 16;
  a = 500 * (x - y);
  b = 200 * (y - z);

  return [l, a, b];
}

function xyz2lch(args) {
  return lab2lch(xyz2lab(args));
}

function lab2xyz(lab) {
  var l = lab[0],
      a = lab[1],
      b = lab[2],
      x, y, z, y2;

  if (l <= 8) {
    y = (l * 100) / 903.3;
    y2 = (7.787 * (y / 100)) + (16 / 116);
  } else {
    y = 100 * Math.pow((l + 16) / 116, 3);
    y2 = Math.pow(y / 100, 1/3);
  }

  x = x / 95.047 <= 0.008856 ? x = (95.047 * ((a / 500) + y2 - (16 / 116))) / 7.787 : 95.047 * Math.pow((a / 500) + y2, 3);

  z = z / 108.883 <= 0.008859 ? z = (108.883 * (y2 - (b / 200) - (16 / 116))) / 7.787 : 108.883 * Math.pow(y2 - (b / 200), 3);

  return [x, y, z];
}

function lab2lch(lab) {
  var l = lab[0],
      a = lab[1],
      b = lab[2],
      hr, h, c;

  hr = Math.atan2(b, a);
  h = hr * 360 / 2 / Math.PI;
  if (h < 0) {
    h += 360;
  }
  c = Math.sqrt(a * a + b * b);
  return [l, c, h];
}

function lab2rgb(args) {
  return xyz2rgb(lab2xyz(args));
}

function lch2lab(lch) {
  var l = lch[0],
      c = lch[1],
      h = lch[2],
      a, b, hr;

  hr = h / 360 * 2 * Math.PI;
  a = c * Math.cos(hr);
  b = c * Math.sin(hr);
  return [l, a, b];
}

function lch2xyz(args) {
  return lab2xyz(lch2lab(args));
}

function lch2rgb(args) {
  return lab2rgb(lch2lab(args));
}

function keyword2rgb(keyword) {
  return cssKeywords[keyword];
}

function keyword2hsl(args) {
  return rgb2hsl(keyword2rgb(args));
}

function keyword2hsv(args) {
  return rgb2hsv(keyword2rgb(args));
}

function keyword2hwb(args) {
  return rgb2hwb(keyword2rgb(args));
}

function keyword2cmyk(args) {
  return rgb2cmyk(keyword2rgb(args));
}

function keyword2lab(args) {
  return rgb2lab(keyword2rgb(args));
}

function keyword2xyz(args) {
  return rgb2xyz(keyword2rgb(args));
}

var cssKeywords = {
  aliceblue:  [240,248,255],
  antiquewhite: [250,235,215],
  aqua: [0,255,255],
  aquamarine: [127,255,212],
  azure:  [240,255,255],
  beige:  [245,245,220],
  bisque: [255,228,196],
  black:  [0,0,0],
  blanchedalmond: [255,235,205],
  blue: [0,0,255],
  blueviolet: [138,43,226],
  brown:  [165,42,42],
  burlywood:  [222,184,135],
  cadetblue:  [95,158,160],
  chartreuse: [127,255,0],
  chocolate:  [210,105,30],
  coral:  [255,127,80],
  cornflowerblue: [100,149,237],
  cornsilk: [255,248,220],
  crimson:  [220,20,60],
  cyan: [0,255,255],
  darkblue: [0,0,139],
  darkcyan: [0,139,139],
  darkgoldenrod:  [184,134,11],
  darkgray: [169,169,169],
  darkgreen:  [0,100,0],
  darkgrey: [169,169,169],
  darkkhaki:  [189,183,107],
  darkmagenta:  [139,0,139],
  darkolivegreen: [85,107,47],
  darkorange: [255,140,0],
  darkorchid: [153,50,204],
  darkred:  [139,0,0],
  darksalmon: [233,150,122],
  darkseagreen: [143,188,143],
  darkslateblue:  [72,61,139],
  darkslategray:  [47,79,79],
  darkslategrey:  [47,79,79],
  darkturquoise:  [0,206,209],
  darkviolet: [148,0,211],
  deeppink: [255,20,147],
  deepskyblue:  [0,191,255],
  dimgray:  [105,105,105],
  dimgrey:  [105,105,105],
  dodgerblue: [30,144,255],
  firebrick:  [178,34,34],
  floralwhite:  [255,250,240],
  forestgreen:  [34,139,34],
  fuchsia:  [255,0,255],
  gainsboro:  [220,220,220],
  ghostwhite: [248,248,255],
  gold: [255,215,0],
  goldenrod:  [218,165,32],
  gray: [128,128,128],
  green:  [0,128,0],
  greenyellow:  [173,255,47],
  grey: [128,128,128],
  honeydew: [240,255,240],
  hotpink:  [255,105,180],
  indianred:  [205,92,92],
  indigo: [75,0,130],
  ivory:  [255,255,240],
  khaki:  [240,230,140],
  lavender: [230,230,250],
  lavenderblush:  [255,240,245],
  lawngreen:  [124,252,0],
  lemonchiffon: [255,250,205],
  lightblue:  [173,216,230],
  lightcoral: [240,128,128],
  lightcyan:  [224,255,255],
  lightgoldenrodyellow: [250,250,210],
  lightgray:  [211,211,211],
  lightgreen: [144,238,144],
  lightgrey:  [211,211,211],
  lightpink:  [255,182,193],
  lightsalmon:  [255,160,122],
  lightseagreen:  [32,178,170],
  lightskyblue: [135,206,250],
  lightslategray: [119,136,153],
  lightslategrey: [119,136,153],
  lightsteelblue: [176,196,222],
  lightyellow:  [255,255,224],
  lime: [0,255,0],
  limegreen:  [50,205,50],
  linen:  [250,240,230],
  magenta:  [255,0,255],
  maroon: [128,0,0],
  mediumaquamarine: [102,205,170],
  mediumblue: [0,0,205],
  mediumorchid: [186,85,211],
  mediumpurple: [147,112,219],
  mediumseagreen: [60,179,113],
  mediumslateblue:  [123,104,238],
  mediumspringgreen:  [0,250,154],
  mediumturquoise:  [72,209,204],
  mediumvioletred:  [199,21,133],
  midnightblue: [25,25,112],
  mintcream:  [245,255,250],
  mistyrose:  [255,228,225],
  moccasin: [255,228,181],
  navajowhite:  [255,222,173],
  navy: [0,0,128],
  oldlace:  [253,245,230],
  olive:  [128,128,0],
  olivedrab:  [107,142,35],
  orange: [255,165,0],
  orangered:  [255,69,0],
  orchid: [218,112,214],
  palegoldenrod:  [238,232,170],
  palegreen:  [152,251,152],
  paleturquoise:  [175,238,238],
  palevioletred:  [219,112,147],
  papayawhip: [255,239,213],
  peachpuff:  [255,218,185],
  peru: [205,133,63],
  pink: [255,192,203],
  plum: [221,160,221],
  powderblue: [176,224,230],
  purple: [128,0,128],
  rebeccapurple: [102, 51, 153],
  red:  [255,0,0],
  rosybrown:  [188,143,143],
  royalblue:  [65,105,225],
  saddlebrown:  [139,69,19],
  salmon: [250,128,114],
  sandybrown: [244,164,96],
  seagreen: [46,139,87],
  seashell: [255,245,238],
  sienna: [160,82,45],
  silver: [192,192,192],
  skyblue:  [135,206,235],
  slateblue:  [106,90,205],
  slategray:  [112,128,144],
  slategrey:  [112,128,144],
  snow: [255,250,250],
  springgreen:  [0,255,127],
  steelblue:  [70,130,180],
  tan:  [210,180,140],
  teal: [0,128,128],
  thistle:  [216,191,216],
  tomato: [255,99,71],
  turquoise:  [64,224,208],
  violet: [238,130,238],
  wheat:  [245,222,179],
  white:  [255,255,255],
  whitesmoke: [245,245,245],
  yellow: [255,255,0],
  yellowgreen:  [154,205,50]
};

var reverseKeywords = {};
for (var key in cssKeywords) {
  reverseKeywords[JSON.stringify(cssKeywords[key])] = key;
}


/***/ }),

/***/ 2647:
/***/ (function(module, exports, __webpack_require__) {

/* MIT license */
var colorNames = __webpack_require__(2648);

module.exports = {
   getRgba: getRgba,
   getHsla: getHsla,
   getRgb: getRgb,
   getHsl: getHsl,
   getHwb: getHwb,
   getAlpha: getAlpha,

   hexString: hexString,
   rgbString: rgbString,
   rgbaString: rgbaString,
   percentString: percentString,
   percentaString: percentaString,
   hslString: hslString,
   hslaString: hslaString,
   hwbString: hwbString,
   keyword: keyword
}

function getRgba(string) {
   if (!string) {
      return;
   }
   var abbr =  /^#([a-fA-F0-9]{3})$/i,
       hex =  /^#([a-fA-F0-9]{6})$/i,
       rgba = /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
       per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
       keyword = /(\w+)/;

   var rgb = [0, 0, 0],
       a = 1,
       match = string.match(abbr);
   if (match) {
      match = match[1];
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = parseInt(match[i] + match[i], 16);
      }
   }
   else if (match = string.match(hex)) {
      match = match[1];
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = parseInt(match.slice(i * 2, i * 2 + 2), 16);
      }
   }
   else if (match = string.match(rgba)) {
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = parseInt(match[i + 1]);
      }
      a = parseFloat(match[4]);
   }
   else if (match = string.match(per)) {
      for (var i = 0; i < rgb.length; i++) {
         rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
      }
      a = parseFloat(match[4]);
   }
   else if (match = string.match(keyword)) {
      if (match[1] == "transparent") {
         return [0, 0, 0, 0];
      }
      rgb = colorNames[match[1]];
      if (!rgb) {
         return;
      }
   }

   for (var i = 0; i < rgb.length; i++) {
      rgb[i] = scale(rgb[i], 0, 255);
   }
   if (!a && a != 0) {
      a = 1;
   }
   else {
      a = scale(a, 0, 1);
   }
   rgb[3] = a;
   return rgb;
}

function getHsla(string) {
   if (!string) {
      return;
   }
   var hsl = /^hsla?\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
   var match = string.match(hsl);
   if (match) {
      var alpha = parseFloat(match[4]);
      var h = scale(parseInt(match[1]), 0, 360),
          s = scale(parseFloat(match[2]), 0, 100),
          l = scale(parseFloat(match[3]), 0, 100),
          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
      return [h, s, l, a];
   }
}

function getHwb(string) {
   if (!string) {
      return;
   }
   var hwb = /^hwb\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
   var match = string.match(hwb);
   if (match) {
    var alpha = parseFloat(match[4]);
      var h = scale(parseInt(match[1]), 0, 360),
          w = scale(parseFloat(match[2]), 0, 100),
          b = scale(parseFloat(match[3]), 0, 100),
          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
      return [h, w, b, a];
   }
}

function getRgb(string) {
   var rgba = getRgba(string);
   return rgba && rgba.slice(0, 3);
}

function getHsl(string) {
  var hsla = getHsla(string);
  return hsla && hsla.slice(0, 3);
}

function getAlpha(string) {
   var vals = getRgba(string);
   if (vals) {
      return vals[3];
   }
   else if (vals = getHsla(string)) {
      return vals[3];
   }
   else if (vals = getHwb(string)) {
      return vals[3];
   }
}

// generators
function hexString(rgb) {
   return "#" + hexDouble(rgb[0]) + hexDouble(rgb[1])
              + hexDouble(rgb[2]);
}

function rgbString(rgba, alpha) {
   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
      return rgbaString(rgba, alpha);
   }
   return "rgb(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2] + ")";
}

function rgbaString(rgba, alpha) {
   if (alpha === undefined) {
      alpha = (rgba[3] !== undefined ? rgba[3] : 1);
   }
   return "rgba(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2]
           + ", " + alpha + ")";
}

function percentString(rgba, alpha) {
   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
      return percentaString(rgba, alpha);
   }
   var r = Math.round(rgba[0]/255 * 100),
       g = Math.round(rgba[1]/255 * 100),
       b = Math.round(rgba[2]/255 * 100);

   return "rgb(" + r + "%, " + g + "%, " + b + "%)";
}

function percentaString(rgba, alpha) {
   var r = Math.round(rgba[0]/255 * 100),
       g = Math.round(rgba[1]/255 * 100),
       b = Math.round(rgba[2]/255 * 100);
   return "rgba(" + r + "%, " + g + "%, " + b + "%, " + (alpha || rgba[3] || 1) + ")";
}

function hslString(hsla, alpha) {
   if (alpha < 1 || (hsla[3] && hsla[3] < 1)) {
      return hslaString(hsla, alpha);
   }
   return "hsl(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%)";
}

function hslaString(hsla, alpha) {
   if (alpha === undefined) {
      alpha = (hsla[3] !== undefined ? hsla[3] : 1);
   }
   return "hsla(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%, "
           + alpha + ")";
}

// hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
// (hwb have alpha optional & 1 is default value)
function hwbString(hwb, alpha) {
   if (alpha === undefined) {
      alpha = (hwb[3] !== undefined ? hwb[3] : 1);
   }
   return "hwb(" + hwb[0] + ", " + hwb[1] + "%, " + hwb[2] + "%"
           + (alpha !== undefined && alpha !== 1 ? ", " + alpha : "") + ")";
}

function keyword(rgb) {
  return reverseNames[rgb.slice(0, 3)];
}

// helpers
function scale(num, min, max) {
   return Math.min(Math.max(min, num), max);
}

function hexDouble(num) {
  var str = num.toString(16).toUpperCase();
  return (str.length < 2) ? "0" + str : str;
}


//create a list of reverse color names
var reverseNames = {};
for (var name in colorNames) {
   reverseNames[colorNames[name]] = name;
}


/***/ }),

/***/ 2648:
/***/ (function(module, exports) {

module.exports = {
	"aliceblue": [240, 248, 255],
	"antiquewhite": [250, 235, 215],
	"aqua": [0, 255, 255],
	"aquamarine": [127, 255, 212],
	"azure": [240, 255, 255],
	"beige": [245, 245, 220],
	"bisque": [255, 228, 196],
	"black": [0, 0, 0],
	"blanchedalmond": [255, 235, 205],
	"blue": [0, 0, 255],
	"blueviolet": [138, 43, 226],
	"brown": [165, 42, 42],
	"burlywood": [222, 184, 135],
	"cadetblue": [95, 158, 160],
	"chartreuse": [127, 255, 0],
	"chocolate": [210, 105, 30],
	"coral": [255, 127, 80],
	"cornflowerblue": [100, 149, 237],
	"cornsilk": [255, 248, 220],
	"crimson": [220, 20, 60],
	"cyan": [0, 255, 255],
	"darkblue": [0, 0, 139],
	"darkcyan": [0, 139, 139],
	"darkgoldenrod": [184, 134, 11],
	"darkgray": [169, 169, 169],
	"darkgreen": [0, 100, 0],
	"darkgrey": [169, 169, 169],
	"darkkhaki": [189, 183, 107],
	"darkmagenta": [139, 0, 139],
	"darkolivegreen": [85, 107, 47],
	"darkorange": [255, 140, 0],
	"darkorchid": [153, 50, 204],
	"darkred": [139, 0, 0],
	"darksalmon": [233, 150, 122],
	"darkseagreen": [143, 188, 143],
	"darkslateblue": [72, 61, 139],
	"darkslategray": [47, 79, 79],
	"darkslategrey": [47, 79, 79],
	"darkturquoise": [0, 206, 209],
	"darkviolet": [148, 0, 211],
	"deeppink": [255, 20, 147],
	"deepskyblue": [0, 191, 255],
	"dimgray": [105, 105, 105],
	"dimgrey": [105, 105, 105],
	"dodgerblue": [30, 144, 255],
	"firebrick": [178, 34, 34],
	"floralwhite": [255, 250, 240],
	"forestgreen": [34, 139, 34],
	"fuchsia": [255, 0, 255],
	"gainsboro": [220, 220, 220],
	"ghostwhite": [248, 248, 255],
	"gold": [255, 215, 0],
	"goldenrod": [218, 165, 32],
	"gray": [128, 128, 128],
	"green": [0, 128, 0],
	"greenyellow": [173, 255, 47],
	"grey": [128, 128, 128],
	"honeydew": [240, 255, 240],
	"hotpink": [255, 105, 180],
	"indianred": [205, 92, 92],
	"indigo": [75, 0, 130],
	"ivory": [255, 255, 240],
	"khaki": [240, 230, 140],
	"lavender": [230, 230, 250],
	"lavenderblush": [255, 240, 245],
	"lawngreen": [124, 252, 0],
	"lemonchiffon": [255, 250, 205],
	"lightblue": [173, 216, 230],
	"lightcoral": [240, 128, 128],
	"lightcyan": [224, 255, 255],
	"lightgoldenrodyellow": [250, 250, 210],
	"lightgray": [211, 211, 211],
	"lightgreen": [144, 238, 144],
	"lightgrey": [211, 211, 211],
	"lightpink": [255, 182, 193],
	"lightsalmon": [255, 160, 122],
	"lightseagreen": [32, 178, 170],
	"lightskyblue": [135, 206, 250],
	"lightslategray": [119, 136, 153],
	"lightslategrey": [119, 136, 153],
	"lightsteelblue": [176, 196, 222],
	"lightyellow": [255, 255, 224],
	"lime": [0, 255, 0],
	"limegreen": [50, 205, 50],
	"linen": [250, 240, 230],
	"magenta": [255, 0, 255],
	"maroon": [128, 0, 0],
	"mediumaquamarine": [102, 205, 170],
	"mediumblue": [0, 0, 205],
	"mediumorchid": [186, 85, 211],
	"mediumpurple": [147, 112, 219],
	"mediumseagreen": [60, 179, 113],
	"mediumslateblue": [123, 104, 238],
	"mediumspringgreen": [0, 250, 154],
	"mediumturquoise": [72, 209, 204],
	"mediumvioletred": [199, 21, 133],
	"midnightblue": [25, 25, 112],
	"mintcream": [245, 255, 250],
	"mistyrose": [255, 228, 225],
	"moccasin": [255, 228, 181],
	"navajowhite": [255, 222, 173],
	"navy": [0, 0, 128],
	"oldlace": [253, 245, 230],
	"olive": [128, 128, 0],
	"olivedrab": [107, 142, 35],
	"orange": [255, 165, 0],
	"orangered": [255, 69, 0],
	"orchid": [218, 112, 214],
	"palegoldenrod": [238, 232, 170],
	"palegreen": [152, 251, 152],
	"paleturquoise": [175, 238, 238],
	"palevioletred": [219, 112, 147],
	"papayawhip": [255, 239, 213],
	"peachpuff": [255, 218, 185],
	"peru": [205, 133, 63],
	"pink": [255, 192, 203],
	"plum": [221, 160, 221],
	"powderblue": [176, 224, 230],
	"purple": [128, 0, 128],
	"rebeccapurple": [102, 51, 153],
	"red": [255, 0, 0],
	"rosybrown": [188, 143, 143],
	"royalblue": [65, 105, 225],
	"saddlebrown": [139, 69, 19],
	"salmon": [250, 128, 114],
	"sandybrown": [244, 164, 96],
	"seagreen": [46, 139, 87],
	"seashell": [255, 245, 238],
	"sienna": [160, 82, 45],
	"silver": [192, 192, 192],
	"skyblue": [135, 206, 235],
	"slateblue": [106, 90, 205],
	"slategray": [112, 128, 144],
	"slategrey": [112, 128, 144],
	"snow": [255, 250, 250],
	"springgreen": [0, 255, 127],
	"steelblue": [70, 130, 180],
	"tan": [210, 180, 140],
	"teal": [0, 128, 128],
	"thistle": [216, 191, 216],
	"tomato": [255, 99, 71],
	"turquoise": [64, 224, 208],
	"violet": [238, 130, 238],
	"wheat": [245, 222, 179],
	"white": [255, 255, 255],
	"whitesmoke": [245, 245, 245],
	"yellow": [255, 255, 0],
	"yellowgreen": [154, 205, 50]
};

/***/ }),

/***/ 2649:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(796);
var Element = __webpack_require__(843);
var helpers = __webpack_require__(789);

defaults._set('global', {
	elements: {
		arc: {
			backgroundColor: defaults.global.defaultColor,
			borderColor: '#fff',
			borderWidth: 2
		}
	}
});

module.exports = Element.extend({
	inLabelRange: function(mouseX) {
		var vm = this._view;

		if (vm) {
			return (Math.pow(mouseX - vm.x, 2) < Math.pow(vm.radius + vm.hoverRadius, 2));
		}
		return false;
	},

	inRange: function(chartX, chartY) {
		var vm = this._view;

		if (vm) {
			var pointRelativePosition = helpers.getAngleFromPoint(vm, {x: chartX, y: chartY});
			var	angle = pointRelativePosition.angle;
			var distance = pointRelativePosition.distance;

			// Sanitise angle range
			var startAngle = vm.startAngle;
			var endAngle = vm.endAngle;
			while (endAngle < startAngle) {
				endAngle += 2.0 * Math.PI;
			}
			while (angle > endAngle) {
				angle -= 2.0 * Math.PI;
			}
			while (angle < startAngle) {
				angle += 2.0 * Math.PI;
			}

			// Check if within the range of the open/close angle
			var betweenAngles = (angle >= startAngle && angle <= endAngle);
			var withinRadius = (distance >= vm.innerRadius && distance <= vm.outerRadius);

			return (betweenAngles && withinRadius);
		}
		return false;
	},

	getCenterPoint: function() {
		var vm = this._view;
		var halfAngle = (vm.startAngle + vm.endAngle) / 2;
		var halfRadius = (vm.innerRadius + vm.outerRadius) / 2;
		return {
			x: vm.x + Math.cos(halfAngle) * halfRadius,
			y: vm.y + Math.sin(halfAngle) * halfRadius
		};
	},

	getArea: function() {
		var vm = this._view;
		return Math.PI * ((vm.endAngle - vm.startAngle) / (2 * Math.PI)) * (Math.pow(vm.outerRadius, 2) - Math.pow(vm.innerRadius, 2));
	},

	tooltipPosition: function() {
		var vm = this._view;
		var centreAngle = vm.startAngle + ((vm.endAngle - vm.startAngle) / 2);
		var rangeFromCentre = (vm.outerRadius - vm.innerRadius) / 2 + vm.innerRadius;

		return {
			x: vm.x + (Math.cos(centreAngle) * rangeFromCentre),
			y: vm.y + (Math.sin(centreAngle) * rangeFromCentre)
		};
	},

	draw: function() {
		var ctx = this._chart.ctx;
		var vm = this._view;
		var sA = vm.startAngle;
		var eA = vm.endAngle;

		ctx.beginPath();

		ctx.arc(vm.x, vm.y, vm.outerRadius, sA, eA);
		ctx.arc(vm.x, vm.y, vm.innerRadius, eA, sA, true);

		ctx.closePath();
		ctx.strokeStyle = vm.borderColor;
		ctx.lineWidth = vm.borderWidth;

		ctx.fillStyle = vm.backgroundColor;

		ctx.fill();
		ctx.lineJoin = 'bevel';

		if (vm.borderWidth) {
			ctx.stroke();
		}
	}
});


/***/ }),

/***/ 2650:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(796);
var Element = __webpack_require__(843);
var helpers = __webpack_require__(789);

var globalDefaults = defaults.global;

defaults._set('global', {
	elements: {
		line: {
			tension: 0.4,
			backgroundColor: globalDefaults.defaultColor,
			borderWidth: 3,
			borderColor: globalDefaults.defaultColor,
			borderCapStyle: 'butt',
			borderDash: [],
			borderDashOffset: 0.0,
			borderJoinStyle: 'miter',
			capBezierPoints: true,
			fill: true, // do we fill in the area between the line and its base axis
		}
	}
});

module.exports = Element.extend({
	draw: function() {
		var me = this;
		var vm = me._view;
		var ctx = me._chart.ctx;
		var spanGaps = vm.spanGaps;
		var points = me._children.slice(); // clone array
		var globalOptionLineElements = globalDefaults.elements.line;
		var lastDrawnIndex = -1;
		var index, current, previous, currentVM;

		// If we are looping, adding the first point again
		if (me._loop && points.length) {
			points.push(points[0]);
		}

		ctx.save();

		// Stroke Line Options
		ctx.lineCap = vm.borderCapStyle || globalOptionLineElements.borderCapStyle;

		// IE 9 and 10 do not support line dash
		if (ctx.setLineDash) {
			ctx.setLineDash(vm.borderDash || globalOptionLineElements.borderDash);
		}

		ctx.lineDashOffset = vm.borderDashOffset || globalOptionLineElements.borderDashOffset;
		ctx.lineJoin = vm.borderJoinStyle || globalOptionLineElements.borderJoinStyle;
		ctx.lineWidth = vm.borderWidth || globalOptionLineElements.borderWidth;
		ctx.strokeStyle = vm.borderColor || globalDefaults.defaultColor;

		// Stroke Line
		ctx.beginPath();
		lastDrawnIndex = -1;

		for (index = 0; index < points.length; ++index) {
			current = points[index];
			previous = helpers.previousItem(points, index);
			currentVM = current._view;

			// First point moves to it's starting position no matter what
			if (index === 0) {
				if (!currentVM.skip) {
					ctx.moveTo(currentVM.x, currentVM.y);
					lastDrawnIndex = index;
				}
			} else {
				previous = lastDrawnIndex === -1 ? previous : points[lastDrawnIndex];

				if (!currentVM.skip) {
					if ((lastDrawnIndex !== (index - 1) && !spanGaps) || lastDrawnIndex === -1) {
						// There was a gap and this is the first point after the gap
						ctx.moveTo(currentVM.x, currentVM.y);
					} else {
						// Line to next point
						helpers.canvas.lineTo(ctx, previous._view, current._view);
					}
					lastDrawnIndex = index;
				}
			}
		}

		ctx.stroke();
		ctx.restore();
	}
});


/***/ }),

/***/ 2651:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(796);
var Element = __webpack_require__(843);
var helpers = __webpack_require__(789);

var defaultColor = defaults.global.defaultColor;

defaults._set('global', {
	elements: {
		point: {
			radius: 3,
			pointStyle: 'circle',
			backgroundColor: defaultColor,
			borderColor: defaultColor,
			borderWidth: 1,
			// Hover
			hitRadius: 1,
			hoverRadius: 4,
			hoverBorderWidth: 1
		}
	}
});

function xRange(mouseX) {
	var vm = this._view;
	return vm ? (Math.pow(mouseX - vm.x, 2) < Math.pow(vm.radius + vm.hitRadius, 2)) : false;
}

function yRange(mouseY) {
	var vm = this._view;
	return vm ? (Math.pow(mouseY - vm.y, 2) < Math.pow(vm.radius + vm.hitRadius, 2)) : false;
}

module.exports = Element.extend({
	inRange: function(mouseX, mouseY) {
		var vm = this._view;
		return vm ? ((Math.pow(mouseX - vm.x, 2) + Math.pow(mouseY - vm.y, 2)) < Math.pow(vm.hitRadius + vm.radius, 2)) : false;
	},

	inLabelRange: xRange,
	inXRange: xRange,
	inYRange: yRange,

	getCenterPoint: function() {
		var vm = this._view;
		return {
			x: vm.x,
			y: vm.y
		};
	},

	getArea: function() {
		return Math.PI * Math.pow(this._view.radius, 2);
	},

	tooltipPosition: function() {
		var vm = this._view;
		return {
			x: vm.x,
			y: vm.y,
			padding: vm.radius + vm.borderWidth
		};
	},

	draw: function(chartArea) {
		var vm = this._view;
		var model = this._model;
		var ctx = this._chart.ctx;
		var pointStyle = vm.pointStyle;
		var radius = vm.radius;
		var x = vm.x;
		var y = vm.y;
		var color = helpers.color;
		var errMargin = 1.01; // 1.01 is margin for Accumulated error. (Especially Edge, IE.)
		var ratio = 0;

		if (vm.skip) {
			return;
		}

		ctx.strokeStyle = vm.borderColor || defaultColor;
		ctx.lineWidth = helpers.valueOrDefault(vm.borderWidth, defaults.global.elements.point.borderWidth);
		ctx.fillStyle = vm.backgroundColor || defaultColor;

		// Cliping for Points.
		// going out from inner charArea?
		if ((chartArea !== undefined) && ((model.x < chartArea.left) || (chartArea.right * errMargin < model.x) || (model.y < chartArea.top) || (chartArea.bottom * errMargin < model.y))) {
			// Point fade out
			if (model.x < chartArea.left) {
				ratio = (x - model.x) / (chartArea.left - model.x);
			} else if (chartArea.right * errMargin < model.x) {
				ratio = (model.x - x) / (model.x - chartArea.right);
			} else if (model.y < chartArea.top) {
				ratio = (y - model.y) / (chartArea.top - model.y);
			} else if (chartArea.bottom * errMargin < model.y) {
				ratio = (model.y - y) / (model.y - chartArea.bottom);
			}
			ratio = Math.round(ratio * 100) / 100;
			ctx.strokeStyle = color(ctx.strokeStyle).alpha(ratio).rgbString();
			ctx.fillStyle = color(ctx.fillStyle).alpha(ratio).rgbString();
		}

		helpers.canvas.drawPoint(ctx, pointStyle, radius, x, y);
	}
});


/***/ }),

/***/ 2652:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(796);
var Element = __webpack_require__(843);

defaults._set('global', {
	elements: {
		rectangle: {
			backgroundColor: defaults.global.defaultColor,
			borderColor: defaults.global.defaultColor,
			borderSkipped: 'bottom',
			borderWidth: 0
		}
	}
});

function isVertical(bar) {
	return bar._view.width !== undefined;
}

/**
 * Helper function to get the bounds of the bar regardless of the orientation
 * @param bar {Chart.Element.Rectangle} the bar
 * @return {Bounds} bounds of the bar
 * @private
 */
function getBarBounds(bar) {
	var vm = bar._view;
	var x1, x2, y1, y2;

	if (isVertical(bar)) {
		// vertical
		var halfWidth = vm.width / 2;
		x1 = vm.x - halfWidth;
		x2 = vm.x + halfWidth;
		y1 = Math.min(vm.y, vm.base);
		y2 = Math.max(vm.y, vm.base);
	} else {
		// horizontal bar
		var halfHeight = vm.height / 2;
		x1 = Math.min(vm.x, vm.base);
		x2 = Math.max(vm.x, vm.base);
		y1 = vm.y - halfHeight;
		y2 = vm.y + halfHeight;
	}

	return {
		left: x1,
		top: y1,
		right: x2,
		bottom: y2
	};
}

module.exports = Element.extend({
	draw: function() {
		var ctx = this._chart.ctx;
		var vm = this._view;
		var left, right, top, bottom, signX, signY, borderSkipped;
		var borderWidth = vm.borderWidth;

		if (!vm.horizontal) {
			// bar
			left = vm.x - vm.width / 2;
			right = vm.x + vm.width / 2;
			top = vm.y;
			bottom = vm.base;
			signX = 1;
			signY = bottom > top ? 1 : -1;
			borderSkipped = vm.borderSkipped || 'bottom';
		} else {
			// horizontal bar
			left = vm.base;
			right = vm.x;
			top = vm.y - vm.height / 2;
			bottom = vm.y + vm.height / 2;
			signX = right > left ? 1 : -1;
			signY = 1;
			borderSkipped = vm.borderSkipped || 'left';
		}

		// Canvas doesn't allow us to stroke inside the width so we can
		// adjust the sizes to fit if we're setting a stroke on the line
		if (borderWidth) {
			// borderWidth shold be less than bar width and bar height.
			var barSize = Math.min(Math.abs(left - right), Math.abs(top - bottom));
			borderWidth = borderWidth > barSize ? barSize : borderWidth;
			var halfStroke = borderWidth / 2;
			// Adjust borderWidth when bar top position is near vm.base(zero).
			var borderLeft = left + (borderSkipped !== 'left' ? halfStroke * signX : 0);
			var borderRight = right + (borderSkipped !== 'right' ? -halfStroke * signX : 0);
			var borderTop = top + (borderSkipped !== 'top' ? halfStroke * signY : 0);
			var borderBottom = bottom + (borderSkipped !== 'bottom' ? -halfStroke * signY : 0);
			// not become a vertical line?
			if (borderLeft !== borderRight) {
				top = borderTop;
				bottom = borderBottom;
			}
			// not become a horizontal line?
			if (borderTop !== borderBottom) {
				left = borderLeft;
				right = borderRight;
			}
		}

		ctx.beginPath();
		ctx.fillStyle = vm.backgroundColor;
		ctx.strokeStyle = vm.borderColor;
		ctx.lineWidth = borderWidth;

		// Corner points, from bottom-left to bottom-right clockwise
		// | 1 2 |
		// | 0 3 |
		var corners = [
			[left, bottom],
			[left, top],
			[right, top],
			[right, bottom]
		];

		// Find first (starting) corner with fallback to 'bottom'
		var borders = ['bottom', 'left', 'top', 'right'];
		var startCorner = borders.indexOf(borderSkipped, 0);
		if (startCorner === -1) {
			startCorner = 0;
		}

		function cornerAt(index) {
			return corners[(startCorner + index) % 4];
		}

		// Draw rectangle from 'startCorner'
		var corner = cornerAt(0);
		ctx.moveTo(corner[0], corner[1]);

		for (var i = 1; i < 4; i++) {
			corner = cornerAt(i);
			ctx.lineTo(corner[0], corner[1]);
		}

		ctx.fill();
		if (borderWidth) {
			ctx.stroke();
		}
	},

	height: function() {
		var vm = this._view;
		return vm.base - vm.y;
	},

	inRange: function(mouseX, mouseY) {
		var inRange = false;

		if (this._view) {
			var bounds = getBarBounds(this);
			inRange = mouseX >= bounds.left && mouseX <= bounds.right && mouseY >= bounds.top && mouseY <= bounds.bottom;
		}

		return inRange;
	},

	inLabelRange: function(mouseX, mouseY) {
		var me = this;
		if (!me._view) {
			return false;
		}

		var inRange = false;
		var bounds = getBarBounds(me);

		if (isVertical(me)) {
			inRange = mouseX >= bounds.left && mouseX <= bounds.right;
		} else {
			inRange = mouseY >= bounds.top && mouseY <= bounds.bottom;
		}

		return inRange;
	},

	inXRange: function(mouseX) {
		var bounds = getBarBounds(this);
		return mouseX >= bounds.left && mouseX <= bounds.right;
	},

	inYRange: function(mouseY) {
		var bounds = getBarBounds(this);
		return mouseY >= bounds.top && mouseY <= bounds.bottom;
	},

	getCenterPoint: function() {
		var vm = this._view;
		var x, y;
		if (isVertical(this)) {
			x = vm.x;
			y = (vm.y + vm.base) / 2;
		} else {
			x = (vm.x + vm.base) / 2;
			y = vm.y;
		}

		return {x: x, y: y};
	},

	getArea: function() {
		var vm = this._view;
		return vm.width * Math.abs(vm.y - vm.base);
	},

	tooltipPosition: function() {
		var vm = this._view;
		return {
			x: vm.x,
			y: vm.y
		};
	}
});


/***/ }),

/***/ 2653:
/***/ (function(module, exports) {

/**
 * Platform fallback implementation (minimal).
 * @see https://github.com/chartjs/Chart.js/pull/4591#issuecomment-319575939
 */

module.exports = {
	acquireContext: function(item) {
		if (item && item.canvas) {
			// Support for any object associated to a canvas (including a context2d)
			item = item.canvas;
		}

		return item && item.getContext('2d') || null;
	}
};


/***/ }),

/***/ 2654:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Chart.Platform implementation for targeting a web browser
 */



var helpers = __webpack_require__(789);

var EXPANDO_KEY = '$chartjs';
var CSS_PREFIX = 'chartjs-';
var CSS_RENDER_MONITOR = CSS_PREFIX + 'render-monitor';
var CSS_RENDER_ANIMATION = CSS_PREFIX + 'render-animation';
var ANIMATION_START_EVENTS = ['animationstart', 'webkitAnimationStart'];

/**
 * DOM event types -> Chart.js event types.
 * Note: only events with different types are mapped.
 * @see https://developer.mozilla.org/en-US/docs/Web/Events
 */
var EVENT_TYPES = {
	touchstart: 'mousedown',
	touchmove: 'mousemove',
	touchend: 'mouseup',
	pointerenter: 'mouseenter',
	pointerdown: 'mousedown',
	pointermove: 'mousemove',
	pointerup: 'mouseup',
	pointerleave: 'mouseout',
	pointerout: 'mouseout'
};

/**
 * The "used" size is the final value of a dimension property after all calculations have
 * been performed. This method uses the computed style of `element` but returns undefined
 * if the computed style is not expressed in pixels. That can happen in some cases where
 * `element` has a size relative to its parent and this last one is not yet displayed,
 * for example because of `display: none` on a parent node.
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/used_value
 * @returns {Number} Size in pixels or undefined if unknown.
 */
function readUsedSize(element, property) {
	var value = helpers.getStyle(element, property);
	var matches = value && value.match(/^(\d+)(\.\d+)?px$/);
	return matches ? Number(matches[1]) : undefined;
}

/**
 * Initializes the canvas style and render size without modifying the canvas display size,
 * since responsiveness is handled by the controller.resize() method. The config is used
 * to determine the aspect ratio to apply in case no explicit height has been specified.
 */
function initCanvas(canvas, config) {
	var style = canvas.style;

	// NOTE(SB) canvas.getAttribute('width') !== canvas.width: in the first case it
	// returns null or '' if no explicit value has been set to the canvas attribute.
	var renderHeight = canvas.getAttribute('height');
	var renderWidth = canvas.getAttribute('width');

	// Chart.js modifies some canvas values that we want to restore on destroy
	canvas[EXPANDO_KEY] = {
		initial: {
			height: renderHeight,
			width: renderWidth,
			style: {
				display: style.display,
				height: style.height,
				width: style.width
			}
		}
	};

	// Force canvas to display as block to avoid extra space caused by inline
	// elements, which would interfere with the responsive resize process.
	// https://github.com/chartjs/Chart.js/issues/2538
	style.display = style.display || 'block';

	if (renderWidth === null || renderWidth === '') {
		var displayWidth = readUsedSize(canvas, 'width');
		if (displayWidth !== undefined) {
			canvas.width = displayWidth;
		}
	}

	if (renderHeight === null || renderHeight === '') {
		if (canvas.style.height === '') {
			// If no explicit render height and style height, let's apply the aspect ratio,
			// which one can be specified by the user but also by charts as default option
			// (i.e. options.aspectRatio). If not specified, use canvas aspect ratio of 2.
			canvas.height = canvas.width / (config.options.aspectRatio || 2);
		} else {
			var displayHeight = readUsedSize(canvas, 'height');
			if (displayWidth !== undefined) {
				canvas.height = displayHeight;
			}
		}
	}

	return canvas;
}

/**
 * Detects support for options object argument in addEventListener.
 * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
 * @private
 */
var supportsEventListenerOptions = (function() {
	var supports = false;
	try {
		var options = Object.defineProperty({}, 'passive', {
			get: function() {
				supports = true;
			}
		});
		window.addEventListener('e', null, options);
	} catch (e) {
		// continue regardless of error
	}
	return supports;
}());

// Default passive to true as expected by Chrome for 'touchstart' and 'touchend' events.
// https://github.com/chartjs/Chart.js/issues/4287
var eventListenerOptions = supportsEventListenerOptions ? {passive: true} : false;

function addEventListener(node, type, listener) {
	node.addEventListener(type, listener, eventListenerOptions);
}

function removeEventListener(node, type, listener) {
	node.removeEventListener(type, listener, eventListenerOptions);
}

function createEvent(type, chart, x, y, nativeEvent) {
	return {
		type: type,
		chart: chart,
		native: nativeEvent || null,
		x: x !== undefined ? x : null,
		y: y !== undefined ? y : null,
	};
}

function fromNativeEvent(event, chart) {
	var type = EVENT_TYPES[event.type] || event.type;
	var pos = helpers.getRelativePosition(event, chart);
	return createEvent(type, chart, pos.x, pos.y, event);
}

function throttled(fn, thisArg) {
	var ticking = false;
	var args = [];

	return function() {
		args = Array.prototype.slice.call(arguments);
		thisArg = thisArg || this;

		if (!ticking) {
			ticking = true;
			helpers.requestAnimFrame.call(window, function() {
				ticking = false;
				fn.apply(thisArg, args);
			});
		}
	};
}

// Implementation based on https://github.com/marcj/css-element-queries
function createResizer(handler) {
	var resizer = document.createElement('div');
	var cls = CSS_PREFIX + 'size-monitor';
	var maxSize = 1000000;
	var style =
		'position:absolute;' +
		'left:0;' +
		'top:0;' +
		'right:0;' +
		'bottom:0;' +
		'overflow:hidden;' +
		'pointer-events:none;' +
		'visibility:hidden;' +
		'z-index:-1;';

	resizer.style.cssText = style;
	resizer.className = cls;
	resizer.innerHTML =
		'<div class="' + cls + '-expand" style="' + style + '">' +
			'<div style="' +
				'position:absolute;' +
				'width:' + maxSize + 'px;' +
				'height:' + maxSize + 'px;' +
				'left:0;' +
				'top:0">' +
			'</div>' +
		'</div>' +
		'<div class="' + cls + '-shrink" style="' + style + '">' +
			'<div style="' +
				'position:absolute;' +
				'width:200%;' +
				'height:200%;' +
				'left:0; ' +
				'top:0">' +
			'</div>' +
		'</div>';

	var expand = resizer.childNodes[0];
	var shrink = resizer.childNodes[1];

	resizer._reset = function() {
		expand.scrollLeft = maxSize;
		expand.scrollTop = maxSize;
		shrink.scrollLeft = maxSize;
		shrink.scrollTop = maxSize;
	};
	var onScroll = function() {
		resizer._reset();
		handler();
	};

	addEventListener(expand, 'scroll', onScroll.bind(expand, 'expand'));
	addEventListener(shrink, 'scroll', onScroll.bind(shrink, 'shrink'));

	return resizer;
}

// https://davidwalsh.name/detect-node-insertion
function watchForRender(node, handler) {
	var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});
	var proxy = expando.renderProxy = function(e) {
		if (e.animationName === CSS_RENDER_ANIMATION) {
			handler();
		}
	};

	helpers.each(ANIMATION_START_EVENTS, function(type) {
		addEventListener(node, type, proxy);
	});

	// #4737: Chrome might skip the CSS animation when the CSS_RENDER_MONITOR class
	// is removed then added back immediately (same animation frame?). Accessing the
	// `offsetParent` property will force a reflow and re-evaluate the CSS animation.
	// https://gist.github.com/paulirish/5d52fb081b3570c81e3a#box-metrics
	// https://github.com/chartjs/Chart.js/issues/4737
	expando.reflow = !!node.offsetParent;

	node.classList.add(CSS_RENDER_MONITOR);
}

function unwatchForRender(node) {
	var expando = node[EXPANDO_KEY] || {};
	var proxy = expando.renderProxy;

	if (proxy) {
		helpers.each(ANIMATION_START_EVENTS, function(type) {
			removeEventListener(node, type, proxy);
		});

		delete expando.renderProxy;
	}

	node.classList.remove(CSS_RENDER_MONITOR);
}

function addResizeListener(node, listener, chart) {
	var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});

	// Let's keep track of this added resizer and thus avoid DOM query when removing it.
	var resizer = expando.resizer = createResizer(throttled(function() {
		if (expando.resizer) {
			return listener(createEvent('resize', chart));
		}
	}));

	// The resizer needs to be attached to the node parent, so we first need to be
	// sure that `node` is attached to the DOM before injecting the resizer element.
	watchForRender(node, function() {
		if (expando.resizer) {
			var container = node.parentNode;
			if (container && container !== resizer.parentNode) {
				container.insertBefore(resizer, container.firstChild);
			}

			// The container size might have changed, let's reset the resizer state.
			resizer._reset();
		}
	});
}

function removeResizeListener(node) {
	var expando = node[EXPANDO_KEY] || {};
	var resizer = expando.resizer;

	delete expando.resizer;
	unwatchForRender(node);

	if (resizer && resizer.parentNode) {
		resizer.parentNode.removeChild(resizer);
	}
}

function injectCSS(platform, css) {
	// http://stackoverflow.com/q/3922139
	var style = platform._style || document.createElement('style');
	if (!platform._style) {
		platform._style = style;
		css = '/* Chart.js */\n' + css;
		style.setAttribute('type', 'text/css');
		document.getElementsByTagName('head')[0].appendChild(style);
	}

	style.appendChild(document.createTextNode(css));
}

module.exports = {
	/**
	 * This property holds whether this platform is enabled for the current environment.
	 * Currently used by platform.js to select the proper implementation.
	 * @private
	 */
	_enabled: typeof window !== 'undefined' && typeof document !== 'undefined',

	initialize: function() {
		var keyframes = 'from{opacity:0.99}to{opacity:1}';

		injectCSS(this,
			// DOM rendering detection
			// https://davidwalsh.name/detect-node-insertion
			'@-webkit-keyframes ' + CSS_RENDER_ANIMATION + '{' + keyframes + '}' +
			'@keyframes ' + CSS_RENDER_ANIMATION + '{' + keyframes + '}' +
			'.' + CSS_RENDER_MONITOR + '{' +
				'-webkit-animation:' + CSS_RENDER_ANIMATION + ' 0.001s;' +
				'animation:' + CSS_RENDER_ANIMATION + ' 0.001s;' +
			'}'
		);
	},

	acquireContext: function(item, config) {
		if (typeof item === 'string') {
			item = document.getElementById(item);
		} else if (item.length) {
			// Support for array based queries (such as jQuery)
			item = item[0];
		}

		if (item && item.canvas) {
			// Support for any object associated to a canvas (including a context2d)
			item = item.canvas;
		}

		// To prevent canvas fingerprinting, some add-ons undefine the getContext
		// method, for example: https://github.com/kkapsner/CanvasBlocker
		// https://github.com/chartjs/Chart.js/issues/2807
		var context = item && item.getContext && item.getContext('2d');

		// `instanceof HTMLCanvasElement/CanvasRenderingContext2D` fails when the item is
		// inside an iframe or when running in a protected environment. We could guess the
		// types from their toString() value but let's keep things flexible and assume it's
		// a sufficient condition if the item has a context2D which has item as `canvas`.
		// https://github.com/chartjs/Chart.js/issues/3887
		// https://github.com/chartjs/Chart.js/issues/4102
		// https://github.com/chartjs/Chart.js/issues/4152
		if (context && context.canvas === item) {
			initCanvas(item, config);
			return context;
		}

		return null;
	},

	releaseContext: function(context) {
		var canvas = context.canvas;
		if (!canvas[EXPANDO_KEY]) {
			return;
		}

		var initial = canvas[EXPANDO_KEY].initial;
		['height', 'width'].forEach(function(prop) {
			var value = initial[prop];
			if (helpers.isNullOrUndef(value)) {
				canvas.removeAttribute(prop);
			} else {
				canvas.setAttribute(prop, value);
			}
		});

		helpers.each(initial.style || {}, function(value, key) {
			canvas.style[key] = value;
		});

		// The canvas render size might have been changed (and thus the state stack discarded),
		// we can't use save() and restore() to restore the initial state. So make sure that at
		// least the canvas context is reset to the default state by setting the canvas width.
		// https://www.w3.org/TR/2011/WD-html5-20110525/the-canvas-element.html
		canvas.width = canvas.width;

		delete canvas[EXPANDO_KEY];
	},

	addEventListener: function(chart, type, listener) {
		var canvas = chart.canvas;
		if (type === 'resize') {
			// Note: the resize event is not supported on all browsers.
			addResizeListener(canvas, listener, chart);
			return;
		}

		var expando = listener[EXPANDO_KEY] || (listener[EXPANDO_KEY] = {});
		var proxies = expando.proxies || (expando.proxies = {});
		var proxy = proxies[chart.id + '_' + type] = function(event) {
			listener(fromNativeEvent(event, chart));
		};

		addEventListener(canvas, type, proxy);
	},

	removeEventListener: function(chart, type, listener) {
		var canvas = chart.canvas;
		if (type === 'resize') {
			// Note: the resize event is not supported on all browsers.
			removeResizeListener(canvas, listener);
			return;
		}

		var expando = listener[EXPANDO_KEY] || {};
		var proxies = expando.proxies || {};
		var proxy = proxies[chart.id + '_' + type];
		if (!proxy) {
			return;
		}

		removeEventListener(canvas, type, proxy);
	}
};

// DEPRECATIONS

/**
 * Provided for backward compatibility, use EventTarget.addEventListener instead.
 * EventTarget.addEventListener compatibility: Chrome, Opera 7, Safari, FF1.5+, IE9+
 * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener
 * @function Chart.helpers.addEvent
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.addEvent = addEventListener;

/**
 * Provided for backward compatibility, use EventTarget.removeEventListener instead.
 * EventTarget.removeEventListener compatibility: Chrome, Opera 7, Safari, FF1.5+, IE9+
 * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/removeEventListener
 * @function Chart.helpers.removeEvent
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.removeEvent = removeEventListener;


/***/ }),

/***/ 2655:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(796);
var Element = __webpack_require__(843);
var helpers = __webpack_require__(789);

defaults._set('global', {
	plugins: {}
});

module.exports = function(Chart) {

	/**
	 * The plugin service singleton
	 * @namespace Chart.plugins
	 * @since 2.1.0
	 */
	Chart.plugins = {
		/**
		 * Globally registered plugins.
		 * @private
		 */
		_plugins: [],

		/**
		 * This identifier is used to invalidate the descriptors cache attached to each chart
		 * when a global plugin is registered or unregistered. In this case, the cache ID is
		 * incremented and descriptors are regenerated during following API calls.
		 * @private
		 */
		_cacheId: 0,

		/**
		 * Registers the given plugin(s) if not already registered.
		 * @param {Array|Object} plugins plugin instance(s).
		 */
		register: function(plugins) {
			var p = this._plugins;
			([]).concat(plugins).forEach(function(plugin) {
				if (p.indexOf(plugin) === -1) {
					p.push(plugin);
				}
			});

			this._cacheId++;
		},

		/**
		 * Unregisters the given plugin(s) only if registered.
		 * @param {Array|Object} plugins plugin instance(s).
		 */
		unregister: function(plugins) {
			var p = this._plugins;
			([]).concat(plugins).forEach(function(plugin) {
				var idx = p.indexOf(plugin);
				if (idx !== -1) {
					p.splice(idx, 1);
				}
			});

			this._cacheId++;
		},

		/**
		 * Remove all registered plugins.
		 * @since 2.1.5
		 */
		clear: function() {
			this._plugins = [];
			this._cacheId++;
		},

		/**
		 * Returns the number of registered plugins?
		 * @returns {Number}
		 * @since 2.1.5
		 */
		count: function() {
			return this._plugins.length;
		},

		/**
		 * Returns all registered plugin instances.
		 * @returns {Array} array of plugin objects.
		 * @since 2.1.5
		 */
		getAll: function() {
			return this._plugins;
		},

		/**
		 * Calls enabled plugins for `chart` on the specified hook and with the given args.
		 * This method immediately returns as soon as a plugin explicitly returns false. The
		 * returned value can be used, for instance, to interrupt the current action.
		 * @param {Object} chart - The chart instance for which plugins should be called.
		 * @param {String} hook - The name of the plugin method to call (e.g. 'beforeUpdate').
		 * @param {Array} [args] - Extra arguments to apply to the hook call.
		 * @returns {Boolean} false if any of the plugins return false, else returns true.
		 */
		notify: function(chart, hook, args) {
			var descriptors = this.descriptors(chart);
			var ilen = descriptors.length;
			var i, descriptor, plugin, params, method;

			for (i = 0; i < ilen; ++i) {
				descriptor = descriptors[i];
				plugin = descriptor.plugin;
				method = plugin[hook];
				if (typeof method === 'function') {
					params = [chart].concat(args || []);
					params.push(descriptor.options);
					if (method.apply(plugin, params) === false) {
						return false;
					}
				}
			}

			return true;
		},

		/**
		 * Returns descriptors of enabled plugins for the given chart.
		 * @returns {Array} [{ plugin, options }]
		 * @private
		 */
		descriptors: function(chart) {
			var cache = chart._plugins || (chart._plugins = {});
			if (cache.id === this._cacheId) {
				return cache.descriptors;
			}

			var plugins = [];
			var descriptors = [];
			var config = (chart && chart.config) || {};
			var options = (config.options && config.options.plugins) || {};

			this._plugins.concat(config.plugins || []).forEach(function(plugin) {
				var idx = plugins.indexOf(plugin);
				if (idx !== -1) {
					return;
				}

				var id = plugin.id;
				var opts = options[id];
				if (opts === false) {
					return;
				}

				if (opts === true) {
					opts = helpers.clone(defaults.global.plugins[id]);
				}

				plugins.push(plugin);
				descriptors.push({
					plugin: plugin,
					options: opts || {}
				});
			});

			cache.descriptors = descriptors;
			cache.id = this._cacheId;
			return descriptors;
		}
	};

	/**
	 * Plugin extension hooks.
	 * @interface IPlugin
	 * @since 2.1.0
	 */
	/**
	 * @method IPlugin#beforeInit
	 * @desc Called before initializing `chart`.
	 * @param {Chart.Controller} chart - The chart instance.
	 * @param {Object} options - The plugin options.
	 */
	/**
	 * @method IPlugin#afterInit
	 * @desc Called after `chart` has been initialized and before the first update.
	 * @param {Chart.Controller} chart - The chart instance.
	 * @param {Object} options - The plugin options.
	 */
	/**
	 * @method IPlugin#beforeUpdate
	 * @desc Called before updating `chart`. If any plugin returns `false`, the update
	 * is cancelled (and thus subsequent render(s)) until another `update` is triggered.
	 * @param {Chart.Controller} chart - The chart instance.
	 * @param {Object} options - The plugin options.
	 * @returns {Boolean} `false` to cancel the chart update.
	 */
	/**
	 * @method IPlugin#afterUpdate
	 * @desc Called after `chart` has been updated and before rendering. Note that this
	 * hook will not be called if the chart update has been previously cancelled.
	 * @param {Chart.Controller} chart - The chart instance.
	 * @param {Object} options - The plugin options.
	 */
	/**
	 * @method IPlugin#beforeDatasetsUpdate
 	 * @desc Called before updating the `chart` datasets. If any plugin returns `false`,
	 * the datasets update is cancelled until another `update` is triggered.
	 * @param {Chart.Controller} chart - The chart instance.
	 * @param {Object} options - The plugin options.
	 * @returns {Boolean} false to cancel the datasets update.
	 * @since version 2.1.5
	 */
	/**
	 * @method IPlugin#afterDatasetsUpdate
	 * @desc Called after the `chart` datasets have been updated. Note that this hook
	 * will not be called if the datasets update has been previously cancelled.
	 * @param {Chart.Controller} chart - The chart instance.
	 * @param {Object} options - The plugin options.
	 * @since version 2.1.5
	 */
	/**
	 * @method IPlugin#beforeDatasetUpdate
 	 * @desc Called before updating the `chart` dataset at the given `args.index`. If any plugin
	 * returns `false`, the datasets update is cancelled until another `update` is triggered.
	 * @param {Chart} chart - The chart instance.
	 * @param {Object} args - The call arguments.
	 * @param {Number} args.index - The dataset index.
	 * @param {Object} args.meta - The dataset metadata.
	 * @param {Object} options - The plugin options.
	 * @returns {Boolean} `false` to cancel the chart datasets drawing.
	 */
	/**
	 * @method IPlugin#afterDatasetUpdate
 	 * @desc Called after the `chart` datasets at the given `args.index` has been updated. Note
	 * that this hook will not be called if the datasets update has been previously cancelled.
	 * @param {Chart} chart - The chart instance.
	 * @param {Object} args - The call arguments.
	 * @param {Number} args.index - The dataset index.
	 * @param {Object} args.meta - The dataset metadata.
	 * @param {Object} options - The plugin options.
	 */
	/**
	 * @method IPlugin#beforeLayout
	 * @desc Called before laying out `chart`. If any plugin returns `false`,
	 * the layout update is cancelled until another `update` is triggered.
	 * @param {Chart.Controller} chart - The chart instance.
	 * @param {Object} options - The plugin options.
	 * @returns {Boolean} `false` to cancel the chart layout.
	 */
	/**
	 * @method IPlugin#afterLayout
	 * @desc Called after the `chart` has been layed out. Note that this hook will not
	 * be called if the layout update has been previously cancelled.
	 * @param {Chart.Controller} chart - The chart instance.
	 * @param {Object} options - The plugin options.
	 */
	/**
	 * @method IPlugin#beforeRender
	 * @desc Called before rendering `chart`. If any plugin returns `false`,
	 * the rendering is cancelled until another `render` is triggered.
	 * @param {Chart.Controller} chart - The chart instance.
	 * @param {Object} options - The plugin options.
	 * @returns {Boolean} `false` to cancel the chart rendering.
	 */
	/**
	 * @method IPlugin#afterRender
	 * @desc Called after the `chart` has been fully rendered (and animation completed). Note
	 * that this hook will not be called if the rendering has been previously cancelled.
	 * @param {Chart.Controller} chart - The chart instance.
	 * @param {Object} options - The plugin options.
	 */
	/**
	 * @method IPlugin#beforeDraw
	 * @desc Called before drawing `chart` at every animation frame specified by the given
	 * easing value. If any plugin returns `false`, the frame drawing is cancelled until
	 * another `render` is triggered.
	 * @param {Chart.Controller} chart - The chart instance.
	 * @param {Number} easingValue - The current animation value, between 0.0 and 1.0.
	 * @param {Object} options - The plugin options.
	 * @returns {Boolean} `false` to cancel the chart drawing.
	 */
	/**
	 * @method IPlugin#afterDraw
	 * @desc Called after the `chart` has been drawn for the specific easing value. Note
	 * that this hook will not be called if the drawing has been previously cancelled.
	 * @param {Chart.Controller} chart - The chart instance.
	 * @param {Number} easingValue - The current animation value, between 0.0 and 1.0.
	 * @param {Object} options - The plugin options.
	 */
	/**
	 * @method IPlugin#beforeDatasetsDraw
 	 * @desc Called before drawing the `chart` datasets. If any plugin returns `false`,
	 * the datasets drawing is cancelled until another `render` is triggered.
	 * @param {Chart.Controller} chart - The chart instance.
	 * @param {Number} easingValue - The current animation value, between 0.0 and 1.0.
	 * @param {Object} options - The plugin options.
	 * @returns {Boolean} `false` to cancel the chart datasets drawing.
	 */
	/**
	 * @method IPlugin#afterDatasetsDraw
	 * @desc Called after the `chart` datasets have been drawn. Note that this hook
	 * will not be called if the datasets drawing has been previously cancelled.
	 * @param {Chart.Controller} chart - The chart instance.
	 * @param {Number} easingValue - The current animation value, between 0.0 and 1.0.
	 * @param {Object} options - The plugin options.
	 */
	/**
	 * @method IPlugin#beforeDatasetDraw
 	 * @desc Called before drawing the `chart` dataset at the given `args.index` (datasets
	 * are drawn in the reverse order). If any plugin returns `false`, the datasets drawing
	 * is cancelled until another `render` is triggered.
	 * @param {Chart} chart - The chart instance.
	 * @param {Object} args - The call arguments.
	 * @param {Number} args.index - The dataset index.
	 * @param {Object} args.meta - The dataset metadata.
	 * @param {Number} args.easingValue - The current animation value, between 0.0 and 1.0.
	 * @param {Object} options - The plugin options.
	 * @returns {Boolean} `false` to cancel the chart datasets drawing.
	 */
	/**
	 * @method IPlugin#afterDatasetDraw
 	 * @desc Called after the `chart` datasets at the given `args.index` have been drawn
	 * (datasets are drawn in the reverse order). Note that this hook will not be called
	 * if the datasets drawing has been previously cancelled.
	 * @param {Chart} chart - The chart instance.
	 * @param {Object} args - The call arguments.
	 * @param {Number} args.index - The dataset index.
	 * @param {Object} args.meta - The dataset metadata.
	 * @param {Number} args.easingValue - The current animation value, between 0.0 and 1.0.
	 * @param {Object} options - The plugin options.
	 */
	/**
  	 * @method IPlugin#beforeTooltipDraw
	 * @desc Called before drawing the `tooltip`. If any plugin returns `false`,
	 * the tooltip drawing is cancelled until another `render` is triggered.
	 * @param {Chart} chart - The chart instance.
	 * @param {Object} args - The call arguments.
	 * @param {Object} args.tooltip - The tooltip.
	 * @param {Number} args.easingValue - The current animation value, between 0.0 and 1.0.
	 * @param {Object} options - The plugin options.
	 * @returns {Boolean} `false` to cancel the chart tooltip drawing.
  	 */
	/**
 	 * @method IPlugin#afterTooltipDraw
  	 * @desc Called after drawing the `tooltip`. Note that this hook will not
 	 * be called if the tooltip drawing has been previously cancelled.
 	 * @param {Chart} chart - The chart instance.
 	 * @param {Object} args - The call arguments.
 	 * @param {Object} args.tooltip - The tooltip.
	 * @param {Number} args.easingValue - The current animation value, between 0.0 and 1.0.
 	 * @param {Object} options - The plugin options.
 	 */
	/**
	 * @method IPlugin#beforeEvent
 	 * @desc Called before processing the specified `event`. If any plugin returns `false`,
	 * the event will be discarded.
	 * @param {Chart.Controller} chart - The chart instance.
	 * @param {IEvent} event - The event object.
	 * @param {Object} options - The plugin options.
	 */
	/**
	 * @method IPlugin#afterEvent
	 * @desc Called after the `event` has been consumed. Note that this hook
	 * will not be called if the `event` has been previously discarded.
	 * @param {Chart.Controller} chart - The chart instance.
	 * @param {IEvent} event - The event object.
	 * @param {Object} options - The plugin options.
	 */
	/**
	 * @method IPlugin#resize
	 * @desc Called after the chart as been resized.
	 * @param {Chart.Controller} chart - The chart instance.
	 * @param {Number} size - The new canvas display size (eq. canvas.style width & height).
	 * @param {Object} options - The plugin options.
	 */
	/**
	 * @method IPlugin#destroy
	 * @desc Called after the chart as been destroyed.
	 * @param {Chart.Controller} chart - The chart instance.
	 * @param {Object} options - The plugin options.
	 */

	/**
	 * Provided for backward compatibility, use Chart.plugins instead
	 * @namespace Chart.pluginService
	 * @deprecated since version 2.1.5
	 * @todo remove at version 3
	 * @private
	 */
	Chart.pluginService = Chart.plugins;

	/**
	 * Provided for backward compatibility, inheriting from Chart.PlugingBase has no
	 * effect, instead simply create/register plugins via plain JavaScript objects.
	 * @interface Chart.PluginBase
	 * @deprecated since version 2.5.0
	 * @todo remove at version 3
	 * @private
	 */
	Chart.PluginBase = Element.extend({});
};


/***/ }),

/***/ 2656:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* global window: false */


var defaults = __webpack_require__(796);
var Element = __webpack_require__(843);
var helpers = __webpack_require__(789);

defaults._set('global', {
	animation: {
		duration: 1000,
		easing: 'easeOutQuart',
		onProgress: helpers.noop,
		onComplete: helpers.noop
	}
});

module.exports = function(Chart) {

	Chart.Animation = Element.extend({
		chart: null, // the animation associated chart instance
		currentStep: 0, // the current animation step
		numSteps: 60, // default number of steps
		easing: '', // the easing to use for this animation
		render: null, // render function used by the animation service

		onAnimationProgress: null, // user specified callback to fire on each step of the animation
		onAnimationComplete: null, // user specified callback to fire when the animation finishes
	});

	Chart.animationService = {
		frameDuration: 17,
		animations: [],
		dropFrames: 0,
		request: null,

		/**
		 * @param {Chart} chart - The chart to animate.
		 * @param {Chart.Animation} animation - The animation that we will animate.
		 * @param {Number} duration - The animation duration in ms.
		 * @param {Boolean} lazy - if true, the chart is not marked as animating to enable more responsive interactions
		 */
		addAnimation: function(chart, animation, duration, lazy) {
			var animations = this.animations;
			var i, ilen;

			animation.chart = chart;

			if (!lazy) {
				chart.animating = true;
			}

			for (i = 0, ilen = animations.length; i < ilen; ++i) {
				if (animations[i].chart === chart) {
					animations[i] = animation;
					return;
				}
			}

			animations.push(animation);

			// If there are no animations queued, manually kickstart a digest, for lack of a better word
			if (animations.length === 1) {
				this.requestAnimationFrame();
			}
		},

		cancelAnimation: function(chart) {
			var index = helpers.findIndex(this.animations, function(animation) {
				return animation.chart === chart;
			});

			if (index !== -1) {
				this.animations.splice(index, 1);
				chart.animating = false;
			}
		},

		requestAnimationFrame: function() {
			var me = this;
			if (me.request === null) {
				// Skip animation frame requests until the active one is executed.
				// This can happen when processing mouse events, e.g. 'mousemove'
				// and 'mouseout' events will trigger multiple renders.
				me.request = helpers.requestAnimFrame.call(window, function() {
					me.request = null;
					me.startDigest();
				});
			}
		},

		/**
		 * @private
		 */
		startDigest: function() {
			var me = this;
			var startTime = Date.now();
			var framesToDrop = 0;

			if (me.dropFrames > 1) {
				framesToDrop = Math.floor(me.dropFrames);
				me.dropFrames = me.dropFrames % 1;
			}

			me.advance(1 + framesToDrop);

			var endTime = Date.now();

			me.dropFrames += (endTime - startTime) / me.frameDuration;

			// Do we have more stuff to animate?
			if (me.animations.length > 0) {
				me.requestAnimationFrame();
			}
		},

		/**
		 * @private
		 */
		advance: function(count) {
			var animations = this.animations;
			var animation, chart;
			var i = 0;

			while (i < animations.length) {
				animation = animations[i];
				chart = animation.chart;

				animation.currentStep = (animation.currentStep || 0) + count;
				animation.currentStep = Math.min(animation.currentStep, animation.numSteps);

				helpers.callback(animation.render, [chart, animation], chart);
				helpers.callback(animation.onAnimationProgress, [animation], chart);

				if (animation.currentStep >= animation.numSteps) {
					helpers.callback(animation.onAnimationComplete, [animation], chart);
					chart.animating = false;
					animations.splice(i, 1);
				} else {
					++i;
				}
			}
		}
	};

	/**
	 * Provided for backward compatibility, use Chart.Animation instead
	 * @prop Chart.Animation#animationObject
	 * @deprecated since version 2.6.0
	 * @todo remove at version 3
	 */
	Object.defineProperty(Chart.Animation.prototype, 'animationObject', {
		get: function() {
			return this;
		}
	});

	/**
	 * Provided for backward compatibility, use Chart.Animation#chart instead
	 * @prop Chart.Animation#chartInstance
	 * @deprecated since version 2.6.0
	 * @todo remove at version 3
	 */
	Object.defineProperty(Chart.Animation.prototype, 'chartInstance', {
		get: function() {
			return this.chart;
		},
		set: function(value) {
			this.chart = value;
		}
	});

};


/***/ }),

/***/ 2657:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(796);
var helpers = __webpack_require__(789);
var Interaction = __webpack_require__(1461);
var platform = __webpack_require__(1462);

module.exports = function(Chart) {
	var plugins = Chart.plugins;

	// Create a dictionary of chart types, to allow for extension of existing types
	Chart.types = {};

	// Store a reference to each instance - allowing us to globally resize chart instances on window resize.
	// Destroy method on the chart will remove the instance of the chart from this reference.
	Chart.instances = {};

	// Controllers available for dataset visualization eg. bar, line, slice, etc.
	Chart.controllers = {};

	/**
	 * Initializes the given config with global and chart default values.
	 */
	function initConfig(config) {
		config = config || {};

		// Do NOT use configMerge() for the data object because this method merges arrays
		// and so would change references to labels and datasets, preventing data updates.
		var data = config.data = config.data || {};
		data.datasets = data.datasets || [];
		data.labels = data.labels || [];

		config.options = helpers.configMerge(
			defaults.global,
			defaults[config.type],
			config.options || {});

		return config;
	}

	/**
	 * Updates the config of the chart
	 * @param chart {Chart} chart to update the options for
	 */
	function updateConfig(chart) {
		var newOptions = chart.options;

		// Update Scale(s) with options
		if (newOptions.scale) {
			chart.scale.options = newOptions.scale;
		} else if (newOptions.scales) {
			newOptions.scales.xAxes.concat(newOptions.scales.yAxes).forEach(function(scaleOptions) {
				chart.scales[scaleOptions.id].options = scaleOptions;
			});
		}

		// Tooltip
		chart.tooltip._options = newOptions.tooltips;
	}

	function positionIsHorizontal(position) {
		return position === 'top' || position === 'bottom';
	}

	helpers.extend(Chart.prototype, /** @lends Chart */ {
		/**
		 * @private
		 */
		construct: function(item, config) {
			var me = this;

			config = initConfig(config);

			var context = platform.acquireContext(item, config);
			var canvas = context && context.canvas;
			var height = canvas && canvas.height;
			var width = canvas && canvas.width;

			me.id = helpers.uid();
			me.ctx = context;
			me.canvas = canvas;
			me.config = config;
			me.width = width;
			me.height = height;
			me.aspectRatio = height ? width / height : null;
			me.options = config.options;
			me._bufferedRender = false;

			/**
			 * Provided for backward compatibility, Chart and Chart.Controller have been merged,
			 * the "instance" still need to be defined since it might be called from plugins.
			 * @prop Chart#chart
			 * @deprecated since version 2.6.0
			 * @todo remove at version 3
			 * @private
			 */
			me.chart = me;
			me.controller = me; // chart.chart.controller #inception

			// Add the chart instance to the global namespace
			Chart.instances[me.id] = me;

			// Define alias to the config data: `chart.data === chart.config.data`
			Object.defineProperty(me, 'data', {
				get: function() {
					return me.config.data;
				},
				set: function(value) {
					me.config.data = value;
				}
			});

			if (!context || !canvas) {
				// The given item is not a compatible context2d element, let's return before finalizing
				// the chart initialization but after setting basic chart / controller properties that
				// can help to figure out that the chart is not valid (e.g chart.canvas !== null);
				// https://github.com/chartjs/Chart.js/issues/2807
				console.error("Failed to create chart: can't acquire context from the given item");
				return;
			}

			me.initialize();
			me.update();
		},

		/**
		 * @private
		 */
		initialize: function() {
			var me = this;

			// Before init plugin notification
			plugins.notify(me, 'beforeInit');

			helpers.retinaScale(me, me.options.devicePixelRatio);

			me.bindEvents();

			if (me.options.responsive) {
				// Initial resize before chart draws (must be silent to preserve initial animations).
				me.resize(true);
			}

			// Make sure scales have IDs and are built before we build any controllers.
			me.ensureScalesHaveIDs();
			me.buildScales();
			me.initToolTip();

			// After init plugin notification
			plugins.notify(me, 'afterInit');

			return me;
		},

		clear: function() {
			helpers.canvas.clear(this);
			return this;
		},

		stop: function() {
			// Stops any current animation loop occurring
			Chart.animationService.cancelAnimation(this);
			return this;
		},

		resize: function(silent) {
			var me = this;
			var options = me.options;
			var canvas = me.canvas;
			var aspectRatio = (options.maintainAspectRatio && me.aspectRatio) || null;

			// the canvas render width and height will be casted to integers so make sure that
			// the canvas display style uses the same integer values to avoid blurring effect.

			// Set to 0 instead of canvas.size because the size defaults to 300x150 if the element is collased
			var newWidth = Math.max(0, Math.floor(helpers.getMaximumWidth(canvas)));
			var newHeight = Math.max(0, Math.floor(aspectRatio ? newWidth / aspectRatio : helpers.getMaximumHeight(canvas)));

			if (me.width === newWidth && me.height === newHeight) {
				return;
			}

			canvas.width = me.width = newWidth;
			canvas.height = me.height = newHeight;
			canvas.style.width = newWidth + 'px';
			canvas.style.height = newHeight + 'px';

			helpers.retinaScale(me, options.devicePixelRatio);

			if (!silent) {
				// Notify any plugins about the resize
				var newSize = {width: newWidth, height: newHeight};
				plugins.notify(me, 'resize', [newSize]);

				// Notify of resize
				if (me.options.onResize) {
					me.options.onResize(me, newSize);
				}

				me.stop();
				me.update(me.options.responsiveAnimationDuration);
			}
		},

		ensureScalesHaveIDs: function() {
			var options = this.options;
			var scalesOptions = options.scales || {};
			var scaleOptions = options.scale;

			helpers.each(scalesOptions.xAxes, function(xAxisOptions, index) {
				xAxisOptions.id = xAxisOptions.id || ('x-axis-' + index);
			});

			helpers.each(scalesOptions.yAxes, function(yAxisOptions, index) {
				yAxisOptions.id = yAxisOptions.id || ('y-axis-' + index);
			});

			if (scaleOptions) {
				scaleOptions.id = scaleOptions.id || 'scale';
			}
		},

		/**
		 * Builds a map of scale ID to scale object for future lookup.
		 */
		buildScales: function() {
			var me = this;
			var options = me.options;
			var scales = me.scales = {};
			var items = [];

			if (options.scales) {
				items = items.concat(
					(options.scales.xAxes || []).map(function(xAxisOptions) {
						return {options: xAxisOptions, dtype: 'category', dposition: 'bottom'};
					}),
					(options.scales.yAxes || []).map(function(yAxisOptions) {
						return {options: yAxisOptions, dtype: 'linear', dposition: 'left'};
					})
				);
			}

			if (options.scale) {
				items.push({
					options: options.scale,
					dtype: 'radialLinear',
					isDefault: true,
					dposition: 'chartArea'
				});
			}

			helpers.each(items, function(item) {
				var scaleOptions = item.options;
				var scaleType = helpers.valueOrDefault(scaleOptions.type, item.dtype);
				var scaleClass = Chart.scaleService.getScaleConstructor(scaleType);
				if (!scaleClass) {
					return;
				}

				if (positionIsHorizontal(scaleOptions.position) !== positionIsHorizontal(item.dposition)) {
					scaleOptions.position = item.dposition;
				}

				var scale = new scaleClass({
					id: scaleOptions.id,
					options: scaleOptions,
					ctx: me.ctx,
					chart: me
				});

				scales[scale.id] = scale;
				scale.mergeTicksOptions();

				// TODO(SB): I think we should be able to remove this custom case (options.scale)
				// and consider it as a regular scale part of the "scales"" map only! This would
				// make the logic easier and remove some useless? custom code.
				if (item.isDefault) {
					me.scale = scale;
				}
			});

			Chart.scaleService.addScalesToLayout(this);
		},

		buildOrUpdateControllers: function() {
			var me = this;
			var types = [];
			var newControllers = [];

			helpers.each(me.data.datasets, function(dataset, datasetIndex) {
				var meta = me.getDatasetMeta(datasetIndex);
				var type = dataset.type || me.config.type;

				if (meta.type && meta.type !== type) {
					me.destroyDatasetMeta(datasetIndex);
					meta = me.getDatasetMeta(datasetIndex);
				}
				meta.type = type;

				types.push(meta.type);

				if (meta.controller) {
					meta.controller.updateIndex(datasetIndex);
				} else {
					var ControllerClass = Chart.controllers[meta.type];
					if (ControllerClass === undefined) {
						throw new Error('"' + meta.type + '" is not a chart type.');
					}

					meta.controller = new ControllerClass(me, datasetIndex);
					newControllers.push(meta.controller);
				}
			}, me);

			return newControllers;
		},

		/**
		 * Reset the elements of all datasets
		 * @private
		 */
		resetElements: function() {
			var me = this;
			helpers.each(me.data.datasets, function(dataset, datasetIndex) {
				me.getDatasetMeta(datasetIndex).controller.reset();
			}, me);
		},

		/**
		* Resets the chart back to it's state before the initial animation
		*/
		reset: function() {
			this.resetElements();
			this.tooltip.initialize();
		},

		update: function(config) {
			var me = this;

			if (!config || typeof config !== 'object') {
				// backwards compatibility
				config = {
					duration: config,
					lazy: arguments[1]
				};
			}

			updateConfig(me);

			if (plugins.notify(me, 'beforeUpdate') === false) {
				return;
			}

			// In case the entire data object changed
			me.tooltip._data = me.data;

			// Make sure dataset controllers are updated and new controllers are reset
			var newControllers = me.buildOrUpdateControllers();

			// Make sure all dataset controllers have correct meta data counts
			helpers.each(me.data.datasets, function(dataset, datasetIndex) {
				me.getDatasetMeta(datasetIndex).controller.buildOrUpdateElements();
			}, me);

			me.updateLayout();

			// Can only reset the new controllers after the scales have been updated
			helpers.each(newControllers, function(controller) {
				controller.reset();
			});

			me.updateDatasets();

			// Need to reset tooltip in case it is displayed with elements that are removed
			// after update.
			me.tooltip.initialize();

			// Last active contains items that were previously in the tooltip.
			// When we reset the tooltip, we need to clear it
			me.lastActive = [];

			// Do this before render so that any plugins that need final scale updates can use it
			plugins.notify(me, 'afterUpdate');

			if (me._bufferedRender) {
				me._bufferedRequest = {
					duration: config.duration,
					easing: config.easing,
					lazy: config.lazy
				};
			} else {
				me.render(config);
			}
		},

		/**
		 * Updates the chart layout unless a plugin returns `false` to the `beforeLayout`
		 * hook, in which case, plugins will not be called on `afterLayout`.
		 * @private
		 */
		updateLayout: function() {
			var me = this;

			if (plugins.notify(me, 'beforeLayout') === false) {
				return;
			}

			Chart.layoutService.update(this, this.width, this.height);

			/**
			 * Provided for backward compatibility, use `afterLayout` instead.
			 * @method IPlugin#afterScaleUpdate
			 * @deprecated since version 2.5.0
			 * @todo remove at version 3
			 * @private
			 */
			plugins.notify(me, 'afterScaleUpdate');
			plugins.notify(me, 'afterLayout');
		},

		/**
		 * Updates all datasets unless a plugin returns `false` to the `beforeDatasetsUpdate`
		 * hook, in which case, plugins will not be called on `afterDatasetsUpdate`.
		 * @private
		 */
		updateDatasets: function() {
			var me = this;

			if (plugins.notify(me, 'beforeDatasetsUpdate') === false) {
				return;
			}

			for (var i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
				me.updateDataset(i);
			}

			plugins.notify(me, 'afterDatasetsUpdate');
		},

		/**
		 * Updates dataset at index unless a plugin returns `false` to the `beforeDatasetUpdate`
		 * hook, in which case, plugins will not be called on `afterDatasetUpdate`.
		 * @private
		 */
		updateDataset: function(index) {
			var me = this;
			var meta = me.getDatasetMeta(index);
			var args = {
				meta: meta,
				index: index
			};

			if (plugins.notify(me, 'beforeDatasetUpdate', [args]) === false) {
				return;
			}

			meta.controller.update();

			plugins.notify(me, 'afterDatasetUpdate', [args]);
		},

		render: function(config) {
			var me = this;

			if (!config || typeof config !== 'object') {
				// backwards compatibility
				config = {
					duration: config,
					lazy: arguments[1]
				};
			}

			var duration = config.duration;
			var lazy = config.lazy;

			if (plugins.notify(me, 'beforeRender') === false) {
				return;
			}

			var animationOptions = me.options.animation;
			var onComplete = function(animation) {
				plugins.notify(me, 'afterRender');
				helpers.callback(animationOptions && animationOptions.onComplete, [animation], me);
			};

			if (animationOptions && ((typeof duration !== 'undefined' && duration !== 0) || (typeof duration === 'undefined' && animationOptions.duration !== 0))) {
				var animation = new Chart.Animation({
					numSteps: (duration || animationOptions.duration) / 16.66, // 60 fps
					easing: config.easing || animationOptions.easing,

					render: function(chart, animationObject) {
						var easingFunction = helpers.easing.effects[animationObject.easing];
						var currentStep = animationObject.currentStep;
						var stepDecimal = currentStep / animationObject.numSteps;

						chart.draw(easingFunction(stepDecimal), stepDecimal, currentStep);
					},

					onAnimationProgress: animationOptions.onProgress,
					onAnimationComplete: onComplete
				});

				Chart.animationService.addAnimation(me, animation, duration, lazy);
			} else {
				me.draw();

				// See https://github.com/chartjs/Chart.js/issues/3781
				onComplete(new Chart.Animation({numSteps: 0, chart: me}));
			}

			return me;
		},

		draw: function(easingValue) {
			var me = this;

			me.clear();

			if (helpers.isNullOrUndef(easingValue)) {
				easingValue = 1;
			}

			me.transition(easingValue);

			if (plugins.notify(me, 'beforeDraw', [easingValue]) === false) {
				return;
			}

			// Draw all the scales
			helpers.each(me.boxes, function(box) {
				box.draw(me.chartArea);
			}, me);

			if (me.scale) {
				me.scale.draw();
			}

			me.drawDatasets(easingValue);
			me._drawTooltip(easingValue);

			plugins.notify(me, 'afterDraw', [easingValue]);
		},

		/**
		 * @private
		 */
		transition: function(easingValue) {
			var me = this;

			for (var i = 0, ilen = (me.data.datasets || []).length; i < ilen; ++i) {
				if (me.isDatasetVisible(i)) {
					me.getDatasetMeta(i).controller.transition(easingValue);
				}
			}

			me.tooltip.transition(easingValue);
		},

		/**
		 * Draws all datasets unless a plugin returns `false` to the `beforeDatasetsDraw`
		 * hook, in which case, plugins will not be called on `afterDatasetsDraw`.
		 * @private
		 */
		drawDatasets: function(easingValue) {
			var me = this;

			if (plugins.notify(me, 'beforeDatasetsDraw', [easingValue]) === false) {
				return;
			}

			// Draw datasets reversed to support proper line stacking
			for (var i = (me.data.datasets || []).length - 1; i >= 0; --i) {
				if (me.isDatasetVisible(i)) {
					me.drawDataset(i, easingValue);
				}
			}

			plugins.notify(me, 'afterDatasetsDraw', [easingValue]);
		},

		/**
		 * Draws dataset at index unless a plugin returns `false` to the `beforeDatasetDraw`
		 * hook, in which case, plugins will not be called on `afterDatasetDraw`.
		 * @private
		 */
		drawDataset: function(index, easingValue) {
			var me = this;
			var meta = me.getDatasetMeta(index);
			var args = {
				meta: meta,
				index: index,
				easingValue: easingValue
			};

			if (plugins.notify(me, 'beforeDatasetDraw', [args]) === false) {
				return;
			}

			meta.controller.draw(easingValue);

			plugins.notify(me, 'afterDatasetDraw', [args]);
		},

		/**
		 * Draws tooltip unless a plugin returns `false` to the `beforeTooltipDraw`
		 * hook, in which case, plugins will not be called on `afterTooltipDraw`.
		 * @private
		 */
		_drawTooltip: function(easingValue) {
			var me = this;
			var tooltip = me.tooltip;
			var args = {
				tooltip: tooltip,
				easingValue: easingValue
			};

			if (plugins.notify(me, 'beforeTooltipDraw', [args]) === false) {
				return;
			}

			tooltip.draw();

			plugins.notify(me, 'afterTooltipDraw', [args]);
		},

		// Get the single element that was clicked on
		// @return : An object containing the dataset index and element index of the matching element. Also contains the rectangle that was draw
		getElementAtEvent: function(e) {
			return Interaction.modes.single(this, e);
		},

		getElementsAtEvent: function(e) {
			return Interaction.modes.label(this, e, {intersect: true});
		},

		getElementsAtXAxis: function(e) {
			return Interaction.modes['x-axis'](this, e, {intersect: true});
		},

		getElementsAtEventForMode: function(e, mode, options) {
			var method = Interaction.modes[mode];
			if (typeof method === 'function') {
				return method(this, e, options);
			}

			return [];
		},

		getDatasetAtEvent: function(e) {
			return Interaction.modes.dataset(this, e, {intersect: true});
		},

		getDatasetMeta: function(datasetIndex) {
			var me = this;
			var dataset = me.data.datasets[datasetIndex];
			if (!dataset._meta) {
				dataset._meta = {};
			}

			var meta = dataset._meta[me.id];
			if (!meta) {
				meta = dataset._meta[me.id] = {
					type: null,
					data: [],
					dataset: null,
					controller: null,
					hidden: null,			// See isDatasetVisible() comment
					xAxisID: null,
					yAxisID: null
				};
			}

			return meta;
		},

		getVisibleDatasetCount: function() {
			var count = 0;
			for (var i = 0, ilen = this.data.datasets.length; i < ilen; ++i) {
				if (this.isDatasetVisible(i)) {
					count++;
				}
			}
			return count;
		},

		isDatasetVisible: function(datasetIndex) {
			var meta = this.getDatasetMeta(datasetIndex);

			// meta.hidden is a per chart dataset hidden flag override with 3 states: if true or false,
			// the dataset.hidden value is ignored, else if null, the dataset hidden state is returned.
			return typeof meta.hidden === 'boolean' ? !meta.hidden : !this.data.datasets[datasetIndex].hidden;
		},

		generateLegend: function() {
			return this.options.legendCallback(this);
		},

		/**
		 * @private
		 */
		destroyDatasetMeta: function(datasetIndex) {
			var id = this.id;
			var dataset = this.data.datasets[datasetIndex];
			var meta = dataset._meta && dataset._meta[id];

			if (meta) {
				meta.controller.destroy();
				delete dataset._meta[id];
			}
		},

		destroy: function() {
			var me = this;
			var canvas = me.canvas;
			var i, ilen;

			me.stop();

			// dataset controllers need to cleanup associated data
			for (i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
				me.destroyDatasetMeta(i);
			}

			if (canvas) {
				me.unbindEvents();
				helpers.canvas.clear(me);
				platform.releaseContext(me.ctx);
				me.canvas = null;
				me.ctx = null;
			}

			plugins.notify(me, 'destroy');

			delete Chart.instances[me.id];
		},

		toBase64Image: function() {
			return this.canvas.toDataURL.apply(this.canvas, arguments);
		},

		initToolTip: function() {
			var me = this;
			me.tooltip = new Chart.Tooltip({
				_chart: me,
				_chartInstance: me, // deprecated, backward compatibility
				_data: me.data,
				_options: me.options.tooltips
			}, me);
		},

		/**
		 * @private
		 */
		bindEvents: function() {
			var me = this;
			var listeners = me._listeners = {};
			var listener = function() {
				me.eventHandler.apply(me, arguments);
			};

			helpers.each(me.options.events, function(type) {
				platform.addEventListener(me, type, listener);
				listeners[type] = listener;
			});

			// Elements used to detect size change should not be injected for non responsive charts.
			// See https://github.com/chartjs/Chart.js/issues/2210
			if (me.options.responsive) {
				listener = function() {
					me.resize();
				};

				platform.addEventListener(me, 'resize', listener);
				listeners.resize = listener;
			}
		},

		/**
		 * @private
		 */
		unbindEvents: function() {
			var me = this;
			var listeners = me._listeners;
			if (!listeners) {
				return;
			}

			delete me._listeners;
			helpers.each(listeners, function(listener, type) {
				platform.removeEventListener(me, type, listener);
			});
		},

		updateHoverStyle: function(elements, mode, enabled) {
			var method = enabled ? 'setHoverStyle' : 'removeHoverStyle';
			var element, i, ilen;

			for (i = 0, ilen = elements.length; i < ilen; ++i) {
				element = elements[i];
				if (element) {
					this.getDatasetMeta(element._datasetIndex).controller[method](element);
				}
			}
		},

		/**
		 * @private
		 */
		eventHandler: function(e) {
			var me = this;
			var tooltip = me.tooltip;

			if (plugins.notify(me, 'beforeEvent', [e]) === false) {
				return;
			}

			// Buffer any update calls so that renders do not occur
			me._bufferedRender = true;
			me._bufferedRequest = null;

			var changed = me.handleEvent(e);
			changed |= tooltip && tooltip.handleEvent(e);

			plugins.notify(me, 'afterEvent', [e]);

			var bufferedRequest = me._bufferedRequest;
			if (bufferedRequest) {
				// If we have an update that was triggered, we need to do a normal render
				me.render(bufferedRequest);
			} else if (changed && !me.animating) {
				// If entering, leaving, or changing elements, animate the change via pivot
				me.stop();

				// We only need to render at this point. Updating will cause scales to be
				// recomputed generating flicker & using more memory than necessary.
				me.render(me.options.hover.animationDuration, true);
			}

			me._bufferedRender = false;
			me._bufferedRequest = null;

			return me;
		},

		/**
		 * Handle an event
		 * @private
		 * @param {IEvent} event the event to handle
		 * @return {Boolean} true if the chart needs to re-render
		 */
		handleEvent: function(e) {
			var me = this;
			var options = me.options || {};
			var hoverOptions = options.hover;
			var changed = false;

			me.lastActive = me.lastActive || [];

			// Find Active Elements for hover and tooltips
			if (e.type === 'mouseout') {
				me.active = [];
			} else {
				me.active = me.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions);
			}

			// Invoke onHover hook
			// Need to call with native event here to not break backwards compatibility
			helpers.callback(options.onHover || options.hover.onHover, [e.native, me.active], me);

			if (e.type === 'mouseup' || e.type === 'click') {
				if (options.onClick) {
					// Use e.native here for backwards compatibility
					options.onClick.call(me, e.native, me.active);
				}
			}

			// Remove styling for last active (even if it may still be active)
			if (me.lastActive.length) {
				me.updateHoverStyle(me.lastActive, hoverOptions.mode, false);
			}

			// Built in hover styling
			if (me.active.length && hoverOptions.mode) {
				me.updateHoverStyle(me.active, hoverOptions.mode, true);
			}

			changed = !helpers.arrayEquals(me.active, me.lastActive);

			// Remember Last Actives
			me.lastActive = me.active;

			return changed;
		}
	});

	/**
	 * Provided for backward compatibility, use Chart instead.
	 * @class Chart.Controller
	 * @deprecated since version 2.6.0
	 * @todo remove at version 3
	 * @private
	 */
	Chart.Controller = Chart;
};


/***/ }),

/***/ 2658:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var helpers = __webpack_require__(789);

module.exports = function(Chart) {

	var arrayEvents = ['push', 'pop', 'shift', 'splice', 'unshift'];

	/**
	 * Hooks the array methods that add or remove values ('push', pop', 'shift', 'splice',
	 * 'unshift') and notify the listener AFTER the array has been altered. Listeners are
	 * called on the 'onData*' callbacks (e.g. onDataPush, etc.) with same arguments.
	 */
	function listenArrayEvents(array, listener) {
		if (array._chartjs) {
			array._chartjs.listeners.push(listener);
			return;
		}

		Object.defineProperty(array, '_chartjs', {
			configurable: true,
			enumerable: false,
			value: {
				listeners: [listener]
			}
		});

		arrayEvents.forEach(function(key) {
			var method = 'onData' + key.charAt(0).toUpperCase() + key.slice(1);
			var base = array[key];

			Object.defineProperty(array, key, {
				configurable: true,
				enumerable: false,
				value: function() {
					var args = Array.prototype.slice.call(arguments);
					var res = base.apply(this, args);

					helpers.each(array._chartjs.listeners, function(object) {
						if (typeof object[method] === 'function') {
							object[method].apply(object, args);
						}
					});

					return res;
				}
			});
		});
	}

	/**
	 * Removes the given array event listener and cleanup extra attached properties (such as
	 * the _chartjs stub and overridden methods) if array doesn't have any more listeners.
	 */
	function unlistenArrayEvents(array, listener) {
		var stub = array._chartjs;
		if (!stub) {
			return;
		}

		var listeners = stub.listeners;
		var index = listeners.indexOf(listener);
		if (index !== -1) {
			listeners.splice(index, 1);
		}

		if (listeners.length > 0) {
			return;
		}

		arrayEvents.forEach(function(key) {
			delete array[key];
		});

		delete array._chartjs;
	}

	// Base class for all dataset controllers (line, bar, etc)
	Chart.DatasetController = function(chart, datasetIndex) {
		this.initialize(chart, datasetIndex);
	};

	helpers.extend(Chart.DatasetController.prototype, {

		/**
		 * Element type used to generate a meta dataset (e.g. Chart.element.Line).
		 * @type {Chart.core.element}
		 */
		datasetElementType: null,

		/**
		 * Element type used to generate a meta data (e.g. Chart.element.Point).
		 * @type {Chart.core.element}
		 */
		dataElementType: null,

		initialize: function(chart, datasetIndex) {
			var me = this;
			me.chart = chart;
			me.index = datasetIndex;
			me.linkScales();
			me.addElements();
		},

		updateIndex: function(datasetIndex) {
			this.index = datasetIndex;
		},

		linkScales: function() {
			var me = this;
			var meta = me.getMeta();
			var dataset = me.getDataset();

			if (meta.xAxisID === null) {
				meta.xAxisID = dataset.xAxisID || me.chart.options.scales.xAxes[0].id;
			}
			if (meta.yAxisID === null) {
				meta.yAxisID = dataset.yAxisID || me.chart.options.scales.yAxes[0].id;
			}
		},

		getDataset: function() {
			return this.chart.data.datasets[this.index];
		},

		getMeta: function() {
			return this.chart.getDatasetMeta(this.index);
		},

		getScaleForId: function(scaleID) {
			return this.chart.scales[scaleID];
		},

		reset: function() {
			this.update(true);
		},

		/**
		 * @private
		 */
		destroy: function() {
			if (this._data) {
				unlistenArrayEvents(this._data, this);
			}
		},

		createMetaDataset: function() {
			var me = this;
			var type = me.datasetElementType;
			return type && new type({
				_chart: me.chart,
				_datasetIndex: me.index
			});
		},

		createMetaData: function(index) {
			var me = this;
			var type = me.dataElementType;
			return type && new type({
				_chart: me.chart,
				_datasetIndex: me.index,
				_index: index
			});
		},

		addElements: function() {
			var me = this;
			var meta = me.getMeta();
			var data = me.getDataset().data || [];
			var metaData = meta.data;
			var i, ilen;

			for (i = 0, ilen = data.length; i < ilen; ++i) {
				metaData[i] = metaData[i] || me.createMetaData(i);
			}

			meta.dataset = meta.dataset || me.createMetaDataset();
		},

		addElementAndReset: function(index) {
			var element = this.createMetaData(index);
			this.getMeta().data.splice(index, 0, element);
			this.updateElement(element, index, true);
		},

		buildOrUpdateElements: function() {
			var me = this;
			var dataset = me.getDataset();
			var data = dataset.data || (dataset.data = []);

			// In order to correctly handle data addition/deletion animation (an thus simulate
			// real-time charts), we need to monitor these data modifications and synchronize
			// the internal meta data accordingly.
			if (me._data !== data) {
				if (me._data) {
					// This case happens when the user replaced the data array instance.
					unlistenArrayEvents(me._data, me);
				}

				listenArrayEvents(data, me);
				me._data = data;
			}

			// Re-sync meta data in case the user replaced the data array or if we missed
			// any updates and so make sure that we handle number of datapoints changing.
			me.resyncElements();
		},

		update: helpers.noop,

		transition: function(easingValue) {
			var meta = this.getMeta();
			var elements = meta.data || [];
			var ilen = elements.length;
			var i = 0;

			for (; i < ilen; ++i) {
				elements[i].transition(easingValue);
			}

			if (meta.dataset) {
				meta.dataset.transition(easingValue);
			}
		},

		draw: function() {
			var meta = this.getMeta();
			var elements = meta.data || [];
			var ilen = elements.length;
			var i = 0;

			if (meta.dataset) {
				meta.dataset.draw();
			}

			for (; i < ilen; ++i) {
				elements[i].draw();
			}
		},

		removeHoverStyle: function(element, elementOpts) {
			var dataset = this.chart.data.datasets[element._datasetIndex];
			var index = element._index;
			var custom = element.custom || {};
			var valueOrDefault = helpers.valueAtIndexOrDefault;
			var model = element._model;

			model.backgroundColor = custom.backgroundColor ? custom.backgroundColor : valueOrDefault(dataset.backgroundColor, index, elementOpts.backgroundColor);
			model.borderColor = custom.borderColor ? custom.borderColor : valueOrDefault(dataset.borderColor, index, elementOpts.borderColor);
			model.borderWidth = custom.borderWidth ? custom.borderWidth : valueOrDefault(dataset.borderWidth, index, elementOpts.borderWidth);
		},

		setHoverStyle: function(element) {
			var dataset = this.chart.data.datasets[element._datasetIndex];
			var index = element._index;
			var custom = element.custom || {};
			var valueOrDefault = helpers.valueAtIndexOrDefault;
			var getHoverColor = helpers.getHoverColor;
			var model = element._model;

			model.backgroundColor = custom.hoverBackgroundColor ? custom.hoverBackgroundColor : valueOrDefault(dataset.hoverBackgroundColor, index, getHoverColor(model.backgroundColor));
			model.borderColor = custom.hoverBorderColor ? custom.hoverBorderColor : valueOrDefault(dataset.hoverBorderColor, index, getHoverColor(model.borderColor));
			model.borderWidth = custom.hoverBorderWidth ? custom.hoverBorderWidth : valueOrDefault(dataset.hoverBorderWidth, index, model.borderWidth);
		},

		/**
		 * @private
		 */
		resyncElements: function() {
			var me = this;
			var meta = me.getMeta();
			var data = me.getDataset().data;
			var numMeta = meta.data.length;
			var numData = data.length;

			if (numData < numMeta) {
				meta.data.splice(numData, numMeta - numData);
			} else if (numData > numMeta) {
				me.insertElements(numMeta, numData - numMeta);
			}
		},

		/**
		 * @private
		 */
		insertElements: function(start, count) {
			for (var i = 0; i < count; ++i) {
				this.addElementAndReset(start + i);
			}
		},

		/**
		 * @private
		 */
		onDataPush: function() {
			this.insertElements(this.getDataset().data.length - 1, arguments.length);
		},

		/**
		 * @private
		 */
		onDataPop: function() {
			this.getMeta().data.pop();
		},

		/**
		 * @private
		 */
		onDataShift: function() {
			this.getMeta().data.shift();
		},

		/**
		 * @private
		 */
		onDataSplice: function(start, count) {
			this.getMeta().data.splice(start, count);
			this.insertElements(start, arguments.length - 2);
		},

		/**
		 * @private
		 */
		onDataUnshift: function() {
			this.insertElements(0, arguments.length);
		}
	});

	Chart.DatasetController.extend = helpers.inherits;
};


/***/ }),

/***/ 2659:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var helpers = __webpack_require__(789);

module.exports = function(Chart) {

	function filterByPosition(array, position) {
		return helpers.where(array, function(v) {
			return v.position === position;
		});
	}

	function sortByWeight(array, reverse) {
		array.forEach(function(v, i) {
			v._tmpIndex_ = i;
			return v;
		});
		array.sort(function(a, b) {
			var v0 = reverse ? b : a;
			var v1 = reverse ? a : b;
			return v0.weight === v1.weight ?
				v0._tmpIndex_ - v1._tmpIndex_ :
				v0.weight - v1.weight;
		});
		array.forEach(function(v) {
			delete v._tmpIndex_;
		});
	}

	/**
	 * @interface ILayoutItem
	 * @prop {String} position - The position of the item in the chart layout. Possible values are
	 * 'left', 'top', 'right', 'bottom', and 'chartArea'
	 * @prop {Number} weight - The weight used to sort the item. Higher weights are further away from the chart area
	 * @prop {Boolean} fullWidth - if true, and the item is horizontal, then push vertical boxes down
	 * @prop {Function} isHorizontal - returns true if the layout item is horizontal (ie. top or bottom)
	 * @prop {Function} update - Takes two parameters: width and height. Returns size of item
	 * @prop {Function} getPadding -  Returns an object with padding on the edges
	 * @prop {Number} width - Width of item. Must be valid after update()
	 * @prop {Number} height - Height of item. Must be valid after update()
	 * @prop {Number} left - Left edge of the item. Set by layout system and cannot be used in update
	 * @prop {Number} top - Top edge of the item. Set by layout system and cannot be used in update
	 * @prop {Number} right - Right edge of the item. Set by layout system and cannot be used in update
	 * @prop {Number} bottom - Bottom edge of the item. Set by layout system and cannot be used in update
	 */

	// The layout service is very self explanatory.  It's responsible for the layout within a chart.
	// Scales, Legends and Plugins all rely on the layout service and can easily register to be placed anywhere they need
	// It is this service's responsibility of carrying out that layout.
	Chart.layoutService = {
		defaults: {},

		/**
		 * Register a box to a chart.
		 * A box is simply a reference to an object that requires layout. eg. Scales, Legend, Title.
		 * @param {Chart} chart - the chart to use
		 * @param {ILayoutItem} item - the item to add to be layed out
		 */
		addBox: function(chart, item) {
			if (!chart.boxes) {
				chart.boxes = [];
			}

			// initialize item with default values
			item.fullWidth = item.fullWidth || false;
			item.position = item.position || 'top';
			item.weight = item.weight || 0;

			chart.boxes.push(item);
		},

		/**
		 * Remove a layoutItem from a chart
		 * @param {Chart} chart - the chart to remove the box from
		 * @param {Object} layoutItem - the item to remove from the layout
		 */
		removeBox: function(chart, layoutItem) {
			var index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
			if (index !== -1) {
				chart.boxes.splice(index, 1);
			}
		},

		/**
		 * Sets (or updates) options on the given `item`.
		 * @param {Chart} chart - the chart in which the item lives (or will be added to)
		 * @param {Object} item - the item to configure with the given options
		 * @param {Object} options - the new item options.
		 */
		configure: function(chart, item, options) {
			var props = ['fullWidth', 'position', 'weight'];
			var ilen = props.length;
			var i = 0;
			var prop;

			for (; i < ilen; ++i) {
				prop = props[i];
				if (options.hasOwnProperty(prop)) {
					item[prop] = options[prop];
				}
			}
		},

		/**
		 * Fits boxes of the given chart into the given size by having each box measure itself
		 * then running a fitting algorithm
		 * @param {Chart} chart - the chart
		 * @param {Number} width - the width to fit into
		 * @param {Number} height - the height to fit into
		 */
		update: function(chart, width, height) {
			if (!chart) {
				return;
			}

			var layoutOptions = chart.options.layout || {};
			var padding = helpers.options.toPadding(layoutOptions.padding);
			var leftPadding = padding.left;
			var rightPadding = padding.right;
			var topPadding = padding.top;
			var bottomPadding = padding.bottom;

			var leftBoxes = filterByPosition(chart.boxes, 'left');
			var rightBoxes = filterByPosition(chart.boxes, 'right');
			var topBoxes = filterByPosition(chart.boxes, 'top');
			var bottomBoxes = filterByPosition(chart.boxes, 'bottom');
			var chartAreaBoxes = filterByPosition(chart.boxes, 'chartArea');

			// Sort boxes by weight. A higher weight is further away from the chart area
			sortByWeight(leftBoxes, true);
			sortByWeight(rightBoxes, false);
			sortByWeight(topBoxes, true);
			sortByWeight(bottomBoxes, false);

			// Essentially we now have any number of boxes on each of the 4 sides.
			// Our canvas looks like the following.
			// The areas L1 and L2 are the left axes. R1 is the right axis, T1 is the top axis and
			// B1 is the bottom axis
			// There are also 4 quadrant-like locations (left to right instead of clockwise) reserved for chart overlays
			// These locations are single-box locations only, when trying to register a chartArea location that is already taken,
			// an error will be thrown.
			//
			// |----------------------------------------------------|
			// |                  T1 (Full Width)                   |
			// |----------------------------------------------------|
			// |    |    |                 T2                  |    |
			// |    |----|-------------------------------------|----|
			// |    |    | C1 |                           | C2 |    |
			// |    |    |----|                           |----|    |
			// |    |    |                                     |    |
			// | L1 | L2 |           ChartArea (C0)            | R1 |
			// |    |    |                                     |    |
			// |    |    |----|                           |----|    |
			// |    |    | C3 |                           | C4 |    |
			// |    |----|-------------------------------------|----|
			// |    |    |                 B1                  |    |
			// |----------------------------------------------------|
			// |                  B2 (Full Width)                   |
			// |----------------------------------------------------|
			//
			// What we do to find the best sizing, we do the following
			// 1. Determine the minimum size of the chart area.
			// 2. Split the remaining width equally between each vertical axis
			// 3. Split the remaining height equally between each horizontal axis
			// 4. Give each layout the maximum size it can be. The layout will return it's minimum size
			// 5. Adjust the sizes of each axis based on it's minimum reported size.
			// 6. Refit each axis
			// 7. Position each axis in the final location
			// 8. Tell the chart the final location of the chart area
			// 9. Tell any axes that overlay the chart area the positions of the chart area

			// Step 1
			var chartWidth = width - leftPadding - rightPadding;
			var chartHeight = height - topPadding - bottomPadding;
			var chartAreaWidth = chartWidth / 2; // min 50%
			var chartAreaHeight = chartHeight / 2; // min 50%

			// Step 2
			var verticalBoxWidth = (width - chartAreaWidth) / (leftBoxes.length + rightBoxes.length);

			// Step 3
			var horizontalBoxHeight = (height - chartAreaHeight) / (topBoxes.length + bottomBoxes.length);

			// Step 4
			var maxChartAreaWidth = chartWidth;
			var maxChartAreaHeight = chartHeight;
			var minBoxSizes = [];

			function getMinimumBoxSize(box) {
				var minSize;
				var isHorizontal = box.isHorizontal();

				if (isHorizontal) {
					minSize = box.update(box.fullWidth ? chartWidth : maxChartAreaWidth, horizontalBoxHeight);
					maxChartAreaHeight -= minSize.height;
				} else {
					minSize = box.update(verticalBoxWidth, chartAreaHeight);
					maxChartAreaWidth -= minSize.width;
				}

				minBoxSizes.push({
					horizontal: isHorizontal,
					minSize: minSize,
					box: box,
				});
			}

			helpers.each(leftBoxes.concat(rightBoxes, topBoxes, bottomBoxes), getMinimumBoxSize);

			// If a horizontal box has padding, we move the left boxes over to avoid ugly charts (see issue #2478)
			var maxHorizontalLeftPadding = 0;
			var maxHorizontalRightPadding = 0;
			var maxVerticalTopPadding = 0;
			var maxVerticalBottomPadding = 0;

			helpers.each(topBoxes.concat(bottomBoxes), function(horizontalBox) {
				if (horizontalBox.getPadding) {
					var boxPadding = horizontalBox.getPadding();
					maxHorizontalLeftPadding = Math.max(maxHorizontalLeftPadding, boxPadding.left);
					maxHorizontalRightPadding = Math.max(maxHorizontalRightPadding, boxPadding.right);
				}
			});

			helpers.each(leftBoxes.concat(rightBoxes), function(verticalBox) {
				if (verticalBox.getPadding) {
					var boxPadding = verticalBox.getPadding();
					maxVerticalTopPadding = Math.max(maxVerticalTopPadding, boxPadding.top);
					maxVerticalBottomPadding = Math.max(maxVerticalBottomPadding, boxPadding.bottom);
				}
			});

			// At this point, maxChartAreaHeight and maxChartAreaWidth are the size the chart area could
			// be if the axes are drawn at their minimum sizes.
			// Steps 5 & 6
			var totalLeftBoxesWidth = leftPadding;
			var totalRightBoxesWidth = rightPadding;
			var totalTopBoxesHeight = topPadding;
			var totalBottomBoxesHeight = bottomPadding;

			// Function to fit a box
			function fitBox(box) {
				var minBoxSize = helpers.findNextWhere(minBoxSizes, function(minBox) {
					return minBox.box === box;
				});

				if (minBoxSize) {
					if (box.isHorizontal()) {
						var scaleMargin = {
							left: Math.max(totalLeftBoxesWidth, maxHorizontalLeftPadding),
							right: Math.max(totalRightBoxesWidth, maxHorizontalRightPadding),
							top: 0,
							bottom: 0
						};

						// Don't use min size here because of label rotation. When the labels are rotated, their rotation highly depends
						// on the margin. Sometimes they need to increase in size slightly
						box.update(box.fullWidth ? chartWidth : maxChartAreaWidth, chartHeight / 2, scaleMargin);
					} else {
						box.update(minBoxSize.minSize.width, maxChartAreaHeight);
					}
				}
			}

			// Update, and calculate the left and right margins for the horizontal boxes
			helpers.each(leftBoxes.concat(rightBoxes), fitBox);

			helpers.each(leftBoxes, function(box) {
				totalLeftBoxesWidth += box.width;
			});

			helpers.each(rightBoxes, function(box) {
				totalRightBoxesWidth += box.width;
			});

			// Set the Left and Right margins for the horizontal boxes
			helpers.each(topBoxes.concat(bottomBoxes), fitBox);

			// Figure out how much margin is on the top and bottom of the vertical boxes
			helpers.each(topBoxes, function(box) {
				totalTopBoxesHeight += box.height;
			});

			helpers.each(bottomBoxes, function(box) {
				totalBottomBoxesHeight += box.height;
			});

			function finalFitVerticalBox(box) {
				var minBoxSize = helpers.findNextWhere(minBoxSizes, function(minSize) {
					return minSize.box === box;
				});

				var scaleMargin = {
					left: 0,
					right: 0,
					top: totalTopBoxesHeight,
					bottom: totalBottomBoxesHeight
				};

				if (minBoxSize) {
					box.update(minBoxSize.minSize.width, maxChartAreaHeight, scaleMargin);
				}
			}

			// Let the left layout know the final margin
			helpers.each(leftBoxes.concat(rightBoxes), finalFitVerticalBox);

			// Recalculate because the size of each layout might have changed slightly due to the margins (label rotation for instance)
			totalLeftBoxesWidth = leftPadding;
			totalRightBoxesWidth = rightPadding;
			totalTopBoxesHeight = topPadding;
			totalBottomBoxesHeight = bottomPadding;

			helpers.each(leftBoxes, function(box) {
				totalLeftBoxesWidth += box.width;
			});

			helpers.each(rightBoxes, function(box) {
				totalRightBoxesWidth += box.width;
			});

			helpers.each(topBoxes, function(box) {
				totalTopBoxesHeight += box.height;
			});
			helpers.each(bottomBoxes, function(box) {
				totalBottomBoxesHeight += box.height;
			});

			// We may be adding some padding to account for rotated x axis labels
			var leftPaddingAddition = Math.max(maxHorizontalLeftPadding - totalLeftBoxesWidth, 0);
			totalLeftBoxesWidth += leftPaddingAddition;
			totalRightBoxesWidth += Math.max(maxHorizontalRightPadding - totalRightBoxesWidth, 0);

			var topPaddingAddition = Math.max(maxVerticalTopPadding - totalTopBoxesHeight, 0);
			totalTopBoxesHeight += topPaddingAddition;
			totalBottomBoxesHeight += Math.max(maxVerticalBottomPadding - totalBottomBoxesHeight, 0);

			// Figure out if our chart area changed. This would occur if the dataset layout label rotation
			// changed due to the application of the margins in step 6. Since we can only get bigger, this is safe to do
			// without calling `fit` again
			var newMaxChartAreaHeight = height - totalTopBoxesHeight - totalBottomBoxesHeight;
			var newMaxChartAreaWidth = width - totalLeftBoxesWidth - totalRightBoxesWidth;

			if (newMaxChartAreaWidth !== maxChartAreaWidth || newMaxChartAreaHeight !== maxChartAreaHeight) {
				helpers.each(leftBoxes, function(box) {
					box.height = newMaxChartAreaHeight;
				});

				helpers.each(rightBoxes, function(box) {
					box.height = newMaxChartAreaHeight;
				});

				helpers.each(topBoxes, function(box) {
					if (!box.fullWidth) {
						box.width = newMaxChartAreaWidth;
					}
				});

				helpers.each(bottomBoxes, function(box) {
					if (!box.fullWidth) {
						box.width = newMaxChartAreaWidth;
					}
				});

				maxChartAreaHeight = newMaxChartAreaHeight;
				maxChartAreaWidth = newMaxChartAreaWidth;
			}

			// Step 7 - Position the boxes
			var left = leftPadding + leftPaddingAddition;
			var top = topPadding + topPaddingAddition;

			function placeBox(box) {
				if (box.isHorizontal()) {
					box.left = box.fullWidth ? leftPadding : totalLeftBoxesWidth;
					box.right = box.fullWidth ? width - rightPadding : totalLeftBoxesWidth + maxChartAreaWidth;
					box.top = top;
					box.bottom = top + box.height;

					// Move to next point
					top = box.bottom;

				} else {

					box.left = left;
					box.right = left + box.width;
					box.top = totalTopBoxesHeight;
					box.bottom = totalTopBoxesHeight + maxChartAreaHeight;

					// Move to next point
					left = box.right;
				}
			}

			helpers.each(leftBoxes.concat(topBoxes), placeBox);

			// Account for chart width and height
			left += maxChartAreaWidth;
			top += maxChartAreaHeight;

			helpers.each(rightBoxes, placeBox);
			helpers.each(bottomBoxes, placeBox);

			// Step 8
			chart.chartArea = {
				left: totalLeftBoxesWidth,
				top: totalTopBoxesHeight,
				right: totalLeftBoxesWidth + maxChartAreaWidth,
				bottom: totalTopBoxesHeight + maxChartAreaHeight
			};

			// Step 9
			helpers.each(chartAreaBoxes, function(box) {
				box.left = chart.chartArea.left;
				box.top = chart.chartArea.top;
				box.right = chart.chartArea.right;
				box.bottom = chart.chartArea.bottom;

				box.update(maxChartAreaWidth, maxChartAreaHeight);
			});
		}
	};
};


/***/ }),

/***/ 2660:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(796);
var helpers = __webpack_require__(789);

module.exports = function(Chart) {

	Chart.scaleService = {
		// Scale registration object. Extensions can register new scale types (such as log or DB scales) and then
		// use the new chart options to grab the correct scale
		constructors: {},
		// Use a registration function so that we can move to an ES6 map when we no longer need to support
		// old browsers

		// Scale config defaults
		defaults: {},
		registerScaleType: function(type, scaleConstructor, scaleDefaults) {
			this.constructors[type] = scaleConstructor;
			this.defaults[type] = helpers.clone(scaleDefaults);
		},
		getScaleConstructor: function(type) {
			return this.constructors.hasOwnProperty(type) ? this.constructors[type] : undefined;
		},
		getScaleDefaults: function(type) {
			// Return the scale defaults merged with the global settings so that we always use the latest ones
			return this.defaults.hasOwnProperty(type) ? helpers.merge({}, [defaults.scale, this.defaults[type]]) : {};
		},
		updateScaleDefaults: function(type, additions) {
			var me = this;
			if (me.defaults.hasOwnProperty(type)) {
				me.defaults[type] = helpers.extend(me.defaults[type], additions);
			}
		},
		addScalesToLayout: function(chart) {
			// Adds each scale to the chart.boxes array to be sized accordingly
			helpers.each(chart.scales, function(scale) {
				// Set ILayoutItem parameters for backwards compatibility
				scale.fullWidth = scale.options.fullWidth;
				scale.position = scale.options.position;
				scale.weight = scale.options.weight;
				Chart.layoutService.addBox(chart, scale);
			});
		}
	};
};


/***/ }),

/***/ 2661:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(796);
var Element = __webpack_require__(843);
var helpers = __webpack_require__(789);
var Ticks = __webpack_require__(942);

defaults._set('scale', {
	display: true,
	position: 'left',
	offset: false,

	// grid line settings
	gridLines: {
		display: true,
		color: 'rgba(0, 0, 0, 0.1)',
		lineWidth: 1,
		drawBorder: true,
		drawOnChartArea: true,
		drawTicks: true,
		tickMarkLength: 10,
		zeroLineWidth: 1,
		zeroLineColor: 'rgba(0,0,0,0.25)',
		zeroLineBorderDash: [],
		zeroLineBorderDashOffset: 0.0,
		offsetGridLines: false,
		borderDash: [],
		borderDashOffset: 0.0
	},

	// scale label
	scaleLabel: {
		// display property
		display: false,

		// actual label
		labelString: '',

		// line height
		lineHeight: 1.2,

		// top/bottom padding
		padding: {
			top: 4,
			bottom: 4
		}
	},

	// label settings
	ticks: {
		beginAtZero: false,
		minRotation: 0,
		maxRotation: 50,
		mirror: false,
		padding: 0,
		reverse: false,
		display: true,
		autoSkip: true,
		autoSkipPadding: 0,
		labelOffset: 0,
		// We pass through arrays to be rendered as multiline labels, we convert Others to strings here.
		callback: Ticks.formatters.values,
		minor: {},
		major: {}
	}
});

function labelsFromTicks(ticks) {
	var labels = [];
	var i, ilen;

	for (i = 0, ilen = ticks.length; i < ilen; ++i) {
		labels.push(ticks[i].label);
	}

	return labels;
}

function getLineValue(scale, index, offsetGridLines) {
	var lineValue = scale.getPixelForTick(index);

	if (offsetGridLines) {
		if (index === 0) {
			lineValue -= (scale.getPixelForTick(1) - lineValue) / 2;
		} else {
			lineValue -= (lineValue - scale.getPixelForTick(index - 1)) / 2;
		}
	}
	return lineValue;
}

module.exports = function(Chart) {

	function computeTextSize(context, tick, font) {
		return helpers.isArray(tick) ?
			helpers.longestText(context, font, tick) :
			context.measureText(tick).width;
	}

	function parseFontOptions(options) {
		var valueOrDefault = helpers.valueOrDefault;
		var globalDefaults = defaults.global;
		var size = valueOrDefault(options.fontSize, globalDefaults.defaultFontSize);
		var style = valueOrDefault(options.fontStyle, globalDefaults.defaultFontStyle);
		var family = valueOrDefault(options.fontFamily, globalDefaults.defaultFontFamily);

		return {
			size: size,
			style: style,
			family: family,
			font: helpers.fontString(size, style, family)
		};
	}

	function parseLineHeight(options) {
		return helpers.options.toLineHeight(
			helpers.valueOrDefault(options.lineHeight, 1.2),
			helpers.valueOrDefault(options.fontSize, defaults.global.defaultFontSize));
	}

	Chart.Scale = Element.extend({
		/**
		 * Get the padding needed for the scale
		 * @method getPadding
		 * @private
		 * @returns {Padding} the necessary padding
		 */
		getPadding: function() {
			var me = this;
			return {
				left: me.paddingLeft || 0,
				top: me.paddingTop || 0,
				right: me.paddingRight || 0,
				bottom: me.paddingBottom || 0
			};
		},

		/**
		 * Returns the scale tick objects ({label, major})
		 * @since 2.7
		 */
		getTicks: function() {
			return this._ticks;
		},

		// These methods are ordered by lifecyle. Utilities then follow.
		// Any function defined here is inherited by all scale types.
		// Any function can be extended by the scale type

		mergeTicksOptions: function() {
			var ticks = this.options.ticks;
			if (ticks.minor === false) {
				ticks.minor = {
					display: false
				};
			}
			if (ticks.major === false) {
				ticks.major = {
					display: false
				};
			}
			for (var key in ticks) {
				if (key !== 'major' && key !== 'minor') {
					if (typeof ticks.minor[key] === 'undefined') {
						ticks.minor[key] = ticks[key];
					}
					if (typeof ticks.major[key] === 'undefined') {
						ticks.major[key] = ticks[key];
					}
				}
			}
		},
		beforeUpdate: function() {
			helpers.callback(this.options.beforeUpdate, [this]);
		},
		update: function(maxWidth, maxHeight, margins) {
			var me = this;
			var i, ilen, labels, label, ticks, tick;

			// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
			me.beforeUpdate();

			// Absorb the master measurements
			me.maxWidth = maxWidth;
			me.maxHeight = maxHeight;
			me.margins = helpers.extend({
				left: 0,
				right: 0,
				top: 0,
				bottom: 0
			}, margins);
			me.longestTextCache = me.longestTextCache || {};

			// Dimensions
			me.beforeSetDimensions();
			me.setDimensions();
			me.afterSetDimensions();

			// Data min/max
			me.beforeDataLimits();
			me.determineDataLimits();
			me.afterDataLimits();

			// Ticks - `this.ticks` is now DEPRECATED!
			// Internal ticks are now stored as objects in the PRIVATE `this._ticks` member
			// and must not be accessed directly from outside this class. `this.ticks` being
			// around for long time and not marked as private, we can't change its structure
			// without unexpected breaking changes. If you need to access the scale ticks,
			// use scale.getTicks() instead.

			me.beforeBuildTicks();

			// New implementations should return an array of objects but for BACKWARD COMPAT,
			// we still support no return (`this.ticks` internally set by calling this method).
			ticks = me.buildTicks() || [];

			me.afterBuildTicks();

			me.beforeTickToLabelConversion();

			// New implementations should return the formatted tick labels but for BACKWARD
			// COMPAT, we still support no return (`this.ticks` internally changed by calling
			// this method and supposed to contain only string values).
			labels = me.convertTicksToLabels(ticks) || me.ticks;

			me.afterTickToLabelConversion();

			me.ticks = labels;   // BACKWARD COMPATIBILITY

			// IMPORTANT: from this point, we consider that `this.ticks` will NEVER change!

			// BACKWARD COMPAT: synchronize `_ticks` with labels (so potentially `this.ticks`)
			for (i = 0, ilen = labels.length; i < ilen; ++i) {
				label = labels[i];
				tick = ticks[i];
				if (!tick) {
					ticks.push(tick = {
						label: label,
						major: false
					});
				} else {
					tick.label = label;
				}
			}

			me._ticks = ticks;

			// Tick Rotation
			me.beforeCalculateTickRotation();
			me.calculateTickRotation();
			me.afterCalculateTickRotation();
			// Fit
			me.beforeFit();
			me.fit();
			me.afterFit();
			//
			me.afterUpdate();

			return me.minSize;

		},
		afterUpdate: function() {
			helpers.callback(this.options.afterUpdate, [this]);
		},

		//

		beforeSetDimensions: function() {
			helpers.callback(this.options.beforeSetDimensions, [this]);
		},
		setDimensions: function() {
			var me = this;
			// Set the unconstrained dimension before label rotation
			if (me.isHorizontal()) {
				// Reset position before calculating rotation
				me.width = me.maxWidth;
				me.left = 0;
				me.right = me.width;
			} else {
				me.height = me.maxHeight;

				// Reset position before calculating rotation
				me.top = 0;
				me.bottom = me.height;
			}

			// Reset padding
			me.paddingLeft = 0;
			me.paddingTop = 0;
			me.paddingRight = 0;
			me.paddingBottom = 0;
		},
		afterSetDimensions: function() {
			helpers.callback(this.options.afterSetDimensions, [this]);
		},

		// Data limits
		beforeDataLimits: function() {
			helpers.callback(this.options.beforeDataLimits, [this]);
		},
		determineDataLimits: helpers.noop,
		afterDataLimits: function() {
			helpers.callback(this.options.afterDataLimits, [this]);
		},

		//
		beforeBuildTicks: function() {
			helpers.callback(this.options.beforeBuildTicks, [this]);
		},
		buildTicks: helpers.noop,
		afterBuildTicks: function() {
			helpers.callback(this.options.afterBuildTicks, [this]);
		},

		beforeTickToLabelConversion: function() {
			helpers.callback(this.options.beforeTickToLabelConversion, [this]);
		},
		convertTicksToLabels: function() {
			var me = this;
			// Convert ticks to strings
			var tickOpts = me.options.ticks;
			me.ticks = me.ticks.map(tickOpts.userCallback || tickOpts.callback, this);
		},
		afterTickToLabelConversion: function() {
			helpers.callback(this.options.afterTickToLabelConversion, [this]);
		},

		//

		beforeCalculateTickRotation: function() {
			helpers.callback(this.options.beforeCalculateTickRotation, [this]);
		},
		calculateTickRotation: function() {
			var me = this;
			var context = me.ctx;
			var tickOpts = me.options.ticks;
			var labels = labelsFromTicks(me._ticks);

			// Get the width of each grid by calculating the difference
			// between x offsets between 0 and 1.
			var tickFont = parseFontOptions(tickOpts);
			context.font = tickFont.font;

			var labelRotation = tickOpts.minRotation || 0;

			if (labels.length && me.options.display && me.isHorizontal()) {
				var originalLabelWidth = helpers.longestText(context, tickFont.font, labels, me.longestTextCache);
				var labelWidth = originalLabelWidth;
				var cosRotation, sinRotation;

				// Allow 3 pixels x2 padding either side for label readability
				var tickWidth = me.getPixelForTick(1) - me.getPixelForTick(0) - 6;

				// Max label rotation can be set or default to 90 - also act as a loop counter
				while (labelWidth > tickWidth && labelRotation < tickOpts.maxRotation) {
					var angleRadians = helpers.toRadians(labelRotation);
					cosRotation = Math.cos(angleRadians);
					sinRotation = Math.sin(angleRadians);

					if (sinRotation * originalLabelWidth > me.maxHeight) {
						// go back one step
						labelRotation--;
						break;
					}

					labelRotation++;
					labelWidth = cosRotation * originalLabelWidth;
				}
			}

			me.labelRotation = labelRotation;
		},
		afterCalculateTickRotation: function() {
			helpers.callback(this.options.afterCalculateTickRotation, [this]);
		},

		//

		beforeFit: function() {
			helpers.callback(this.options.beforeFit, [this]);
		},
		fit: function() {
			var me = this;
			// Reset
			var minSize = me.minSize = {
				width: 0,
				height: 0
			};

			var labels = labelsFromTicks(me._ticks);

			var opts = me.options;
			var tickOpts = opts.ticks;
			var scaleLabelOpts = opts.scaleLabel;
			var gridLineOpts = opts.gridLines;
			var display = opts.display;
			var isHorizontal = me.isHorizontal();

			var tickFont = parseFontOptions(tickOpts);
			var tickMarkLength = opts.gridLines.tickMarkLength;

			// Width
			if (isHorizontal) {
				// subtract the margins to line up with the chartArea if we are a full width scale
				minSize.width = me.isFullWidth() ? me.maxWidth - me.margins.left - me.margins.right : me.maxWidth;
			} else {
				minSize.width = display && gridLineOpts.drawTicks ? tickMarkLength : 0;
			}

			// height
			if (isHorizontal) {
				minSize.height = display && gridLineOpts.drawTicks ? tickMarkLength : 0;
			} else {
				minSize.height = me.maxHeight; // fill all the height
			}

			// Are we showing a title for the scale?
			if (scaleLabelOpts.display && display) {
				var scaleLabelLineHeight = parseLineHeight(scaleLabelOpts);
				var scaleLabelPadding = helpers.options.toPadding(scaleLabelOpts.padding);
				var deltaHeight = scaleLabelLineHeight + scaleLabelPadding.height;

				if (isHorizontal) {
					minSize.height += deltaHeight;
				} else {
					minSize.width += deltaHeight;
				}
			}

			// Don't bother fitting the ticks if we are not showing them
			if (tickOpts.display && display) {
				var largestTextWidth = helpers.longestText(me.ctx, tickFont.font, labels, me.longestTextCache);
				var tallestLabelHeightInLines = helpers.numberOfLabelLines(labels);
				var lineSpace = tickFont.size * 0.5;
				var tickPadding = me.options.ticks.padding;

				if (isHorizontal) {
					// A horizontal axis is more constrained by the height.
					me.longestLabelWidth = largestTextWidth;

					var angleRadians = helpers.toRadians(me.labelRotation);
					var cosRotation = Math.cos(angleRadians);
					var sinRotation = Math.sin(angleRadians);

					// TODO - improve this calculation
					var labelHeight = (sinRotation * largestTextWidth)
						+ (tickFont.size * tallestLabelHeightInLines)
						+ (lineSpace * (tallestLabelHeightInLines - 1))
						+ lineSpace; // padding

					minSize.height = Math.min(me.maxHeight, minSize.height + labelHeight + tickPadding);

					me.ctx.font = tickFont.font;
					var firstLabelWidth = computeTextSize(me.ctx, labels[0], tickFont.font);
					var lastLabelWidth = computeTextSize(me.ctx, labels[labels.length - 1], tickFont.font);

					// Ensure that our ticks are always inside the canvas. When rotated, ticks are right aligned
					// which means that the right padding is dominated by the font height
					if (me.labelRotation !== 0) {
						me.paddingLeft = opts.position === 'bottom' ? (cosRotation * firstLabelWidth) + 3 : (cosRotation * lineSpace) + 3; // add 3 px to move away from canvas edges
						me.paddingRight = opts.position === 'bottom' ? (cosRotation * lineSpace) + 3 : (cosRotation * lastLabelWidth) + 3;
					} else {
						me.paddingLeft = firstLabelWidth / 2 + 3; // add 3 px to move away from canvas edges
						me.paddingRight = lastLabelWidth / 2 + 3;
					}
				} else {
					// A vertical axis is more constrained by the width. Labels are the
					// dominant factor here, so get that length first and account for padding
					if (tickOpts.mirror) {
						largestTextWidth = 0;
					} else {
						// use lineSpace for consistency with horizontal axis
						// tickPadding is not implemented for horizontal
						largestTextWidth += tickPadding + lineSpace;
					}

					minSize.width = Math.min(me.maxWidth, minSize.width + largestTextWidth);

					me.paddingTop = tickFont.size / 2;
					me.paddingBottom = tickFont.size / 2;
				}
			}

			me.handleMargins();

			me.width = minSize.width;
			me.height = minSize.height;
		},

		/**
		 * Handle margins and padding interactions
		 * @private
		 */
		handleMargins: function() {
			var me = this;
			if (me.margins) {
				me.paddingLeft = Math.max(me.paddingLeft - me.margins.left, 0);
				me.paddingTop = Math.max(me.paddingTop - me.margins.top, 0);
				me.paddingRight = Math.max(me.paddingRight - me.margins.right, 0);
				me.paddingBottom = Math.max(me.paddingBottom - me.margins.bottom, 0);
			}
		},

		afterFit: function() {
			helpers.callback(this.options.afterFit, [this]);
		},

		// Shared Methods
		isHorizontal: function() {
			return this.options.position === 'top' || this.options.position === 'bottom';
		},
		isFullWidth: function() {
			return (this.options.fullWidth);
		},

		// Get the correct value. NaN bad inputs, If the value type is object get the x or y based on whether we are horizontal or not
		getRightValue: function(rawValue) {
			// Null and undefined values first
			if (helpers.isNullOrUndef(rawValue)) {
				return NaN;
			}
			// isNaN(object) returns true, so make sure NaN is checking for a number; Discard Infinite values
			if (typeof rawValue === 'number' && !isFinite(rawValue)) {
				return NaN;
			}
			// If it is in fact an object, dive in one more level
			if (rawValue) {
				if (this.isHorizontal()) {
					if (rawValue.x !== undefined) {
						return this.getRightValue(rawValue.x);
					}
				} else if (rawValue.y !== undefined) {
					return this.getRightValue(rawValue.y);
				}
			}

			// Value is good, return it
			return rawValue;
		},

		/**
		 * Used to get the value to display in the tooltip for the data at the given index
		 * @param index
		 * @param datasetIndex
		 */
		getLabelForIndex: helpers.noop,

		/**
		 * Returns the location of the given data point. Value can either be an index or a numerical value
		 * The coordinate (0, 0) is at the upper-left corner of the canvas
		 * @param value
		 * @param index
		 * @param datasetIndex
		 */
		getPixelForValue: helpers.noop,

		/**
		 * Used to get the data value from a given pixel. This is the inverse of getPixelForValue
		 * The coordinate (0, 0) is at the upper-left corner of the canvas
		 * @param pixel
		 */
		getValueForPixel: helpers.noop,

		/**
		 * Returns the location of the tick at the given index
		 * The coordinate (0, 0) is at the upper-left corner of the canvas
		 */
		getPixelForTick: function(index) {
			var me = this;
			var offset = me.options.offset;
			if (me.isHorizontal()) {
				var innerWidth = me.width - (me.paddingLeft + me.paddingRight);
				var tickWidth = innerWidth / Math.max((me._ticks.length - (offset ? 0 : 1)), 1);
				var pixel = (tickWidth * index) + me.paddingLeft;

				if (offset) {
					pixel += tickWidth / 2;
				}

				var finalVal = me.left + Math.round(pixel);
				finalVal += me.isFullWidth() ? me.margins.left : 0;
				return finalVal;
			}
			var innerHeight = me.height - (me.paddingTop + me.paddingBottom);
			return me.top + (index * (innerHeight / (me._ticks.length - 1)));
		},

		/**
		 * Utility for getting the pixel location of a percentage of scale
		 * The coordinate (0, 0) is at the upper-left corner of the canvas
		 */
		getPixelForDecimal: function(decimal) {
			var me = this;
			if (me.isHorizontal()) {
				var innerWidth = me.width - (me.paddingLeft + me.paddingRight);
				var valueOffset = (innerWidth * decimal) + me.paddingLeft;

				var finalVal = me.left + Math.round(valueOffset);
				finalVal += me.isFullWidth() ? me.margins.left : 0;
				return finalVal;
			}
			return me.top + (decimal * me.height);
		},

		/**
		 * Returns the pixel for the minimum chart value
		 * The coordinate (0, 0) is at the upper-left corner of the canvas
		 */
		getBasePixel: function() {
			return this.getPixelForValue(this.getBaseValue());
		},

		getBaseValue: function() {
			var me = this;
			var min = me.min;
			var max = me.max;

			return me.beginAtZero ? 0 :
				min < 0 && max < 0 ? max :
				min > 0 && max > 0 ? min :
				0;
		},

		/**
		 * Returns a subset of ticks to be plotted to avoid overlapping labels.
		 * @private
		 */
		_autoSkip: function(ticks) {
			var skipRatio;
			var me = this;
			var isHorizontal = me.isHorizontal();
			var optionTicks = me.options.ticks.minor;
			var tickCount = ticks.length;
			var labelRotationRadians = helpers.toRadians(me.labelRotation);
			var cosRotation = Math.cos(labelRotationRadians);
			var longestRotatedLabel = me.longestLabelWidth * cosRotation;
			var result = [];
			var i, tick, shouldSkip;

			// figure out the maximum number of gridlines to show
			var maxTicks;
			if (optionTicks.maxTicksLimit) {
				maxTicks = optionTicks.maxTicksLimit;
			}

			if (isHorizontal) {
				skipRatio = false;

				if ((longestRotatedLabel + optionTicks.autoSkipPadding) * tickCount > (me.width - (me.paddingLeft + me.paddingRight))) {
					skipRatio = 1 + Math.floor(((longestRotatedLabel + optionTicks.autoSkipPadding) * tickCount) / (me.width - (me.paddingLeft + me.paddingRight)));
				}

				// if they defined a max number of optionTicks,
				// increase skipRatio until that number is met
				if (maxTicks && tickCount > maxTicks) {
					skipRatio = Math.max(skipRatio, Math.floor(tickCount / maxTicks));
				}
			}

			for (i = 0; i < tickCount; i++) {
				tick = ticks[i];

				// Since we always show the last tick,we need may need to hide the last shown one before
				shouldSkip = (skipRatio > 1 && i % skipRatio > 0) || (i % skipRatio === 0 && i + skipRatio >= tickCount);
				if (shouldSkip && i !== tickCount - 1) {
					// leave tick in place but make sure it's not displayed (#4635)
					delete tick.label;
				}
				result.push(tick);
			}
			return result;
		},

		// Actually draw the scale on the canvas
		// @param {rectangle} chartArea : the area of the chart to draw full grid lines on
		draw: function(chartArea) {
			var me = this;
			var options = me.options;
			if (!options.display) {
				return;
			}

			var context = me.ctx;
			var globalDefaults = defaults.global;
			var optionTicks = options.ticks.minor;
			var optionMajorTicks = options.ticks.major || optionTicks;
			var gridLines = options.gridLines;
			var scaleLabel = options.scaleLabel;

			var isRotated = me.labelRotation !== 0;
			var isHorizontal = me.isHorizontal();

			var ticks = optionTicks.autoSkip ? me._autoSkip(me.getTicks()) : me.getTicks();
			var tickFontColor = helpers.valueOrDefault(optionTicks.fontColor, globalDefaults.defaultFontColor);
			var tickFont = parseFontOptions(optionTicks);
			var majorTickFontColor = helpers.valueOrDefault(optionMajorTicks.fontColor, globalDefaults.defaultFontColor);
			var majorTickFont = parseFontOptions(optionMajorTicks);

			var tl = gridLines.drawTicks ? gridLines.tickMarkLength : 0;

			var scaleLabelFontColor = helpers.valueOrDefault(scaleLabel.fontColor, globalDefaults.defaultFontColor);
			var scaleLabelFont = parseFontOptions(scaleLabel);
			var scaleLabelPadding = helpers.options.toPadding(scaleLabel.padding);
			var labelRotationRadians = helpers.toRadians(me.labelRotation);

			var itemsToDraw = [];

			var xTickStart = options.position === 'right' ? me.left : me.right - tl;
			var xTickEnd = options.position === 'right' ? me.left + tl : me.right;
			var yTickStart = options.position === 'bottom' ? me.top : me.bottom - tl;
			var yTickEnd = options.position === 'bottom' ? me.top + tl : me.bottom;

			helpers.each(ticks, function(tick, index) {
				// autoskipper skipped this tick (#4635)
				if (helpers.isNullOrUndef(tick.label)) {
					return;
				}

				var label = tick.label;
				var lineWidth, lineColor, borderDash, borderDashOffset;
				if (index === me.zeroLineIndex && options.offset === gridLines.offsetGridLines) {
					// Draw the first index specially
					lineWidth = gridLines.zeroLineWidth;
					lineColor = gridLines.zeroLineColor;
					borderDash = gridLines.zeroLineBorderDash;
					borderDashOffset = gridLines.zeroLineBorderDashOffset;
				} else {
					lineWidth = helpers.valueAtIndexOrDefault(gridLines.lineWidth, index);
					lineColor = helpers.valueAtIndexOrDefault(gridLines.color, index);
					borderDash = helpers.valueOrDefault(gridLines.borderDash, globalDefaults.borderDash);
					borderDashOffset = helpers.valueOrDefault(gridLines.borderDashOffset, globalDefaults.borderDashOffset);
				}

				// Common properties
				var tx1, ty1, tx2, ty2, x1, y1, x2, y2, labelX, labelY;
				var textAlign = 'middle';
				var textBaseline = 'middle';
				var tickPadding = optionTicks.padding;

				if (isHorizontal) {
					var labelYOffset = tl + tickPadding;

					if (options.position === 'bottom') {
						// bottom
						textBaseline = !isRotated ? 'top' : 'middle';
						textAlign = !isRotated ? 'center' : 'right';
						labelY = me.top + labelYOffset;
					} else {
						// top
						textBaseline = !isRotated ? 'bottom' : 'middle';
						textAlign = !isRotated ? 'center' : 'left';
						labelY = me.bottom - labelYOffset;
					}

					var xLineValue = getLineValue(me, index, gridLines.offsetGridLines && ticks.length > 1);
					if (xLineValue < me.left) {
						lineColor = 'rgba(0,0,0,0)';
					}
					xLineValue += helpers.aliasPixel(lineWidth);

					labelX = me.getPixelForTick(index) + optionTicks.labelOffset; // x values for optionTicks (need to consider offsetLabel option)

					tx1 = tx2 = x1 = x2 = xLineValue;
					ty1 = yTickStart;
					ty2 = yTickEnd;
					y1 = chartArea.top;
					y2 = chartArea.bottom;
				} else {
					var isLeft = options.position === 'left';
					var labelXOffset;

					if (optionTicks.mirror) {
						textAlign = isLeft ? 'left' : 'right';
						labelXOffset = tickPadding;
					} else {
						textAlign = isLeft ? 'right' : 'left';
						labelXOffset = tl + tickPadding;
					}

					labelX = isLeft ? me.right - labelXOffset : me.left + labelXOffset;

					var yLineValue = getLineValue(me, index, gridLines.offsetGridLines && ticks.length > 1);
					if (yLineValue < me.top) {
						lineColor = 'rgba(0,0,0,0)';
					}
					yLineValue += helpers.aliasPixel(lineWidth);

					labelY = me.getPixelForTick(index) + optionTicks.labelOffset;

					tx1 = xTickStart;
					tx2 = xTickEnd;
					x1 = chartArea.left;
					x2 = chartArea.right;
					ty1 = ty2 = y1 = y2 = yLineValue;
				}

				itemsToDraw.push({
					tx1: tx1,
					ty1: ty1,
					tx2: tx2,
					ty2: ty2,
					x1: x1,
					y1: y1,
					x2: x2,
					y2: y2,
					labelX: labelX,
					labelY: labelY,
					glWidth: lineWidth,
					glColor: lineColor,
					glBorderDash: borderDash,
					glBorderDashOffset: borderDashOffset,
					rotation: -1 * labelRotationRadians,
					label: label,
					major: tick.major,
					textBaseline: textBaseline,
					textAlign: textAlign
				});
			});

			// Draw all of the tick labels, tick marks, and grid lines at the correct places
			helpers.each(itemsToDraw, function(itemToDraw) {
				if (gridLines.display) {
					context.save();
					context.lineWidth = itemToDraw.glWidth;
					context.strokeStyle = itemToDraw.glColor;
					if (context.setLineDash) {
						context.setLineDash(itemToDraw.glBorderDash);
						context.lineDashOffset = itemToDraw.glBorderDashOffset;
					}

					context.beginPath();

					if (gridLines.drawTicks) {
						context.moveTo(itemToDraw.tx1, itemToDraw.ty1);
						context.lineTo(itemToDraw.tx2, itemToDraw.ty2);
					}

					if (gridLines.drawOnChartArea) {
						context.moveTo(itemToDraw.x1, itemToDraw.y1);
						context.lineTo(itemToDraw.x2, itemToDraw.y2);
					}

					context.stroke();
					context.restore();
				}

				if (optionTicks.display) {
					// Make sure we draw text in the correct color and font
					context.save();
					context.translate(itemToDraw.labelX, itemToDraw.labelY);
					context.rotate(itemToDraw.rotation);
					context.font = itemToDraw.major ? majorTickFont.font : tickFont.font;
					context.fillStyle = itemToDraw.major ? majorTickFontColor : tickFontColor;
					context.textBaseline = itemToDraw.textBaseline;
					context.textAlign = itemToDraw.textAlign;

					var label = itemToDraw.label;
					if (helpers.isArray(label)) {
						for (var i = 0, y = 0; i < label.length; ++i) {
							// We just make sure the multiline element is a string here..
							context.fillText('' + label[i], 0, y);
							// apply same lineSpacing as calculated @ L#320
							y += (tickFont.size * 1.5);
						}
					} else {
						context.fillText(label, 0, 0);
					}
					context.restore();
				}
			});

			if (scaleLabel.display) {
				// Draw the scale label
				var scaleLabelX;
				var scaleLabelY;
				var rotation = 0;
				var halfLineHeight = parseLineHeight(scaleLabel) / 2;

				if (isHorizontal) {
					scaleLabelX = me.left + ((me.right - me.left) / 2); // midpoint of the width
					scaleLabelY = options.position === 'bottom'
						? me.bottom - halfLineHeight - scaleLabelPadding.bottom
						: me.top + halfLineHeight + scaleLabelPadding.top;
				} else {
					var isLeft = options.position === 'left';
					scaleLabelX = isLeft
						? me.left + halfLineHeight + scaleLabelPadding.top
						: me.right - halfLineHeight - scaleLabelPadding.top;
					scaleLabelY = me.top + ((me.bottom - me.top) / 2);
					rotation = isLeft ? -0.5 * Math.PI : 0.5 * Math.PI;
				}

				context.save();
				context.translate(scaleLabelX, scaleLabelY);
				context.rotate(rotation);
				context.textAlign = 'center';
				context.textBaseline = 'middle';
				context.fillStyle = scaleLabelFontColor; // render in correct colour
				context.font = scaleLabelFont.font;
				context.fillText(scaleLabel.labelString, 0, 0);
				context.restore();
			}

			if (gridLines.drawBorder) {
				// Draw the line at the edge of the axis
				context.lineWidth = helpers.valueAtIndexOrDefault(gridLines.lineWidth, 0);
				context.strokeStyle = helpers.valueAtIndexOrDefault(gridLines.color, 0);
				var x1 = me.left;
				var x2 = me.right;
				var y1 = me.top;
				var y2 = me.bottom;

				var aliasPixel = helpers.aliasPixel(context.lineWidth);
				if (isHorizontal) {
					y1 = y2 = options.position === 'top' ? me.bottom : me.top;
					y1 += aliasPixel;
					y2 += aliasPixel;
				} else {
					x1 = x2 = options.position === 'left' ? me.right : me.left;
					x1 += aliasPixel;
					x2 += aliasPixel;
				}

				context.beginPath();
				context.moveTo(x1, y1);
				context.lineTo(x2, y2);
				context.stroke();
			}
		}
	});
};


/***/ }),

/***/ 2662:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(796);
var Element = __webpack_require__(843);
var helpers = __webpack_require__(789);

defaults._set('global', {
	tooltips: {
		enabled: true,
		custom: null,
		mode: 'nearest',
		position: 'average',
		intersect: true,
		backgroundColor: 'rgba(0,0,0,0.8)',
		titleFontStyle: 'bold',
		titleSpacing: 2,
		titleMarginBottom: 6,
		titleFontColor: '#fff',
		titleAlign: 'left',
		bodySpacing: 2,
		bodyFontColor: '#fff',
		bodyAlign: 'left',
		footerFontStyle: 'bold',
		footerSpacing: 2,
		footerMarginTop: 6,
		footerFontColor: '#fff',
		footerAlign: 'left',
		yPadding: 6,
		xPadding: 6,
		caretPadding: 2,
		caretSize: 5,
		cornerRadius: 6,
		multiKeyBackground: '#fff',
		displayColors: true,
		borderColor: 'rgba(0,0,0,0)',
		borderWidth: 0,
		callbacks: {
			// Args are: (tooltipItems, data)
			beforeTitle: helpers.noop,
			title: function(tooltipItems, data) {
				// Pick first xLabel for now
				var title = '';
				var labels = data.labels;
				var labelCount = labels ? labels.length : 0;

				if (tooltipItems.length > 0) {
					var item = tooltipItems[0];

					if (item.xLabel) {
						title = item.xLabel;
					} else if (labelCount > 0 && item.index < labelCount) {
						title = labels[item.index];
					}
				}

				return title;
			},
			afterTitle: helpers.noop,

			// Args are: (tooltipItems, data)
			beforeBody: helpers.noop,

			// Args are: (tooltipItem, data)
			beforeLabel: helpers.noop,
			label: function(tooltipItem, data) {
				var label = data.datasets[tooltipItem.datasetIndex].label || '';

				if (label) {
					label += ': ';
				}
				label += tooltipItem.yLabel;
				return label;
			},
			labelColor: function(tooltipItem, chart) {
				var meta = chart.getDatasetMeta(tooltipItem.datasetIndex);
				var activeElement = meta.data[tooltipItem.index];
				var view = activeElement._view;
				return {
					borderColor: view.borderColor,
					backgroundColor: view.backgroundColor
				};
			},
			labelTextColor: function() {
				return this._options.bodyFontColor;
			},
			afterLabel: helpers.noop,

			// Args are: (tooltipItems, data)
			afterBody: helpers.noop,

			// Args are: (tooltipItems, data)
			beforeFooter: helpers.noop,
			footer: helpers.noop,
			afterFooter: helpers.noop
		}
	}
});

module.exports = function(Chart) {

	/**
 	 * Helper method to merge the opacity into a color
 	 */
	function mergeOpacity(colorString, opacity) {
		var color = helpers.color(colorString);
		return color.alpha(opacity * color.alpha()).rgbaString();
	}

	// Helper to push or concat based on if the 2nd parameter is an array or not
	function pushOrConcat(base, toPush) {
		if (toPush) {
			if (helpers.isArray(toPush)) {
				// base = base.concat(toPush);
				Array.prototype.push.apply(base, toPush);
			} else {
				base.push(toPush);
			}
		}

		return base;
	}

	// Private helper to create a tooltip item model
	// @param element : the chart element (point, arc, bar) to create the tooltip item for
	// @return : new tooltip item
	function createTooltipItem(element) {
		var xScale = element._xScale;
		var yScale = element._yScale || element._scale; // handle radar || polarArea charts
		var index = element._index;
		var datasetIndex = element._datasetIndex;

		return {
			xLabel: xScale ? xScale.getLabelForIndex(index, datasetIndex) : '',
			yLabel: yScale ? yScale.getLabelForIndex(index, datasetIndex) : '',
			index: index,
			datasetIndex: datasetIndex,
			x: element._model.x,
			y: element._model.y
		};
	}

	/**
	 * Helper to get the reset model for the tooltip
	 * @param tooltipOpts {Object} the tooltip options
	 */
	function getBaseModel(tooltipOpts) {
		var globalDefaults = defaults.global;
		var valueOrDefault = helpers.valueOrDefault;

		return {
			// Positioning
			xPadding: tooltipOpts.xPadding,
			yPadding: tooltipOpts.yPadding,
			xAlign: tooltipOpts.xAlign,
			yAlign: tooltipOpts.yAlign,

			// Body
			bodyFontColor: tooltipOpts.bodyFontColor,
			_bodyFontFamily: valueOrDefault(tooltipOpts.bodyFontFamily, globalDefaults.defaultFontFamily),
			_bodyFontStyle: valueOrDefault(tooltipOpts.bodyFontStyle, globalDefaults.defaultFontStyle),
			_bodyAlign: tooltipOpts.bodyAlign,
			bodyFontSize: valueOrDefault(tooltipOpts.bodyFontSize, globalDefaults.defaultFontSize),
			bodySpacing: tooltipOpts.bodySpacing,

			// Title
			titleFontColor: tooltipOpts.titleFontColor,
			_titleFontFamily: valueOrDefault(tooltipOpts.titleFontFamily, globalDefaults.defaultFontFamily),
			_titleFontStyle: valueOrDefault(tooltipOpts.titleFontStyle, globalDefaults.defaultFontStyle),
			titleFontSize: valueOrDefault(tooltipOpts.titleFontSize, globalDefaults.defaultFontSize),
			_titleAlign: tooltipOpts.titleAlign,
			titleSpacing: tooltipOpts.titleSpacing,
			titleMarginBottom: tooltipOpts.titleMarginBottom,

			// Footer
			footerFontColor: tooltipOpts.footerFontColor,
			_footerFontFamily: valueOrDefault(tooltipOpts.footerFontFamily, globalDefaults.defaultFontFamily),
			_footerFontStyle: valueOrDefault(tooltipOpts.footerFontStyle, globalDefaults.defaultFontStyle),
			footerFontSize: valueOrDefault(tooltipOpts.footerFontSize, globalDefaults.defaultFontSize),
			_footerAlign: tooltipOpts.footerAlign,
			footerSpacing: tooltipOpts.footerSpacing,
			footerMarginTop: tooltipOpts.footerMarginTop,

			// Appearance
			caretSize: tooltipOpts.caretSize,
			cornerRadius: tooltipOpts.cornerRadius,
			backgroundColor: tooltipOpts.backgroundColor,
			opacity: 0,
			legendColorBackground: tooltipOpts.multiKeyBackground,
			displayColors: tooltipOpts.displayColors,
			borderColor: tooltipOpts.borderColor,
			borderWidth: tooltipOpts.borderWidth
		};
	}

	/**
	 * Get the size of the tooltip
	 */
	function getTooltipSize(tooltip, model) {
		var ctx = tooltip._chart.ctx;

		var height = model.yPadding * 2; // Tooltip Padding
		var width = 0;

		// Count of all lines in the body
		var body = model.body;
		var combinedBodyLength = body.reduce(function(count, bodyItem) {
			return count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length;
		}, 0);
		combinedBodyLength += model.beforeBody.length + model.afterBody.length;

		var titleLineCount = model.title.length;
		var footerLineCount = model.footer.length;
		var titleFontSize = model.titleFontSize;
		var bodyFontSize = model.bodyFontSize;
		var footerFontSize = model.footerFontSize;

		height += titleLineCount * titleFontSize; // Title Lines
		height += titleLineCount ? (titleLineCount - 1) * model.titleSpacing : 0; // Title Line Spacing
		height += titleLineCount ? model.titleMarginBottom : 0; // Title's bottom Margin
		height += combinedBodyLength * bodyFontSize; // Body Lines
		height += combinedBodyLength ? (combinedBodyLength - 1) * model.bodySpacing : 0; // Body Line Spacing
		height += footerLineCount ? model.footerMarginTop : 0; // Footer Margin
		height += footerLineCount * (footerFontSize); // Footer Lines
		height += footerLineCount ? (footerLineCount - 1) * model.footerSpacing : 0; // Footer Line Spacing

		// Title width
		var widthPadding = 0;
		var maxLineWidth = function(line) {
			width = Math.max(width, ctx.measureText(line).width + widthPadding);
		};

		ctx.font = helpers.fontString(titleFontSize, model._titleFontStyle, model._titleFontFamily);
		helpers.each(model.title, maxLineWidth);

		// Body width
		ctx.font = helpers.fontString(bodyFontSize, model._bodyFontStyle, model._bodyFontFamily);
		helpers.each(model.beforeBody.concat(model.afterBody), maxLineWidth);

		// Body lines may include some extra width due to the color box
		widthPadding = model.displayColors ? (bodyFontSize + 2) : 0;
		helpers.each(body, function(bodyItem) {
			helpers.each(bodyItem.before, maxLineWidth);
			helpers.each(bodyItem.lines, maxLineWidth);
			helpers.each(bodyItem.after, maxLineWidth);
		});

		// Reset back to 0
		widthPadding = 0;

		// Footer width
		ctx.font = helpers.fontString(footerFontSize, model._footerFontStyle, model._footerFontFamily);
		helpers.each(model.footer, maxLineWidth);

		// Add padding
		width += 2 * model.xPadding;

		return {
			width: width,
			height: height
		};
	}

	/**
	 * Helper to get the alignment of a tooltip given the size
	 */
	function determineAlignment(tooltip, size) {
		var model = tooltip._model;
		var chart = tooltip._chart;
		var chartArea = tooltip._chart.chartArea;
		var xAlign = 'center';
		var yAlign = 'center';

		if (model.y < size.height) {
			yAlign = 'top';
		} else if (model.y > (chart.height - size.height)) {
			yAlign = 'bottom';
		}

		var lf, rf; // functions to determine left, right alignment
		var olf, orf; // functions to determine if left/right alignment causes tooltip to go outside chart
		var yf; // function to get the y alignment if the tooltip goes outside of the left or right edges
		var midX = (chartArea.left + chartArea.right) / 2;
		var midY = (chartArea.top + chartArea.bottom) / 2;

		if (yAlign === 'center') {
			lf = function(x) {
				return x <= midX;
			};
			rf = function(x) {
				return x > midX;
			};
		} else {
			lf = function(x) {
				return x <= (size.width / 2);
			};
			rf = function(x) {
				return x >= (chart.width - (size.width / 2));
			};
		}

		olf = function(x) {
			return x + size.width > chart.width;
		};
		orf = function(x) {
			return x - size.width < 0;
		};
		yf = function(y) {
			return y <= midY ? 'top' : 'bottom';
		};

		if (lf(model.x)) {
			xAlign = 'left';

			// Is tooltip too wide and goes over the right side of the chart.?
			if (olf(model.x)) {
				xAlign = 'center';
				yAlign = yf(model.y);
			}
		} else if (rf(model.x)) {
			xAlign = 'right';

			// Is tooltip too wide and goes outside left edge of canvas?
			if (orf(model.x)) {
				xAlign = 'center';
				yAlign = yf(model.y);
			}
		}

		var opts = tooltip._options;
		return {
			xAlign: opts.xAlign ? opts.xAlign : xAlign,
			yAlign: opts.yAlign ? opts.yAlign : yAlign
		};
	}

	/**
	 * @Helper to get the location a tooltip needs to be placed at given the initial position (via the vm) and the size and alignment
	 */
	function getBackgroundPoint(vm, size, alignment) {
		// Background Position
		var x = vm.x;
		var y = vm.y;

		var caretSize = vm.caretSize;
		var caretPadding = vm.caretPadding;
		var cornerRadius = vm.cornerRadius;
		var xAlign = alignment.xAlign;
		var yAlign = alignment.yAlign;
		var paddingAndSize = caretSize + caretPadding;
		var radiusAndPadding = cornerRadius + caretPadding;

		if (xAlign === 'right') {
			x -= size.width;
		} else if (xAlign === 'center') {
			x -= (size.width / 2);
		}

		if (yAlign === 'top') {
			y += paddingAndSize;
		} else if (yAlign === 'bottom') {
			y -= size.height + paddingAndSize;
		} else {
			y -= (size.height / 2);
		}

		if (yAlign === 'center') {
			if (xAlign === 'left') {
				x += paddingAndSize;
			} else if (xAlign === 'right') {
				x -= paddingAndSize;
			}
		} else if (xAlign === 'left') {
			x -= radiusAndPadding;
		} else if (xAlign === 'right') {
			x += radiusAndPadding;
		}

		return {
			x: x,
			y: y
		};
	}

	Chart.Tooltip = Element.extend({
		initialize: function() {
			this._model = getBaseModel(this._options);
			this._lastActive = [];
		},

		// Get the title
		// Args are: (tooltipItem, data)
		getTitle: function() {
			var me = this;
			var opts = me._options;
			var callbacks = opts.callbacks;

			var beforeTitle = callbacks.beforeTitle.apply(me, arguments);
			var title = callbacks.title.apply(me, arguments);
			var afterTitle = callbacks.afterTitle.apply(me, arguments);

			var lines = [];
			lines = pushOrConcat(lines, beforeTitle);
			lines = pushOrConcat(lines, title);
			lines = pushOrConcat(lines, afterTitle);

			return lines;
		},

		// Args are: (tooltipItem, data)
		getBeforeBody: function() {
			var lines = this._options.callbacks.beforeBody.apply(this, arguments);
			return helpers.isArray(lines) ? lines : lines !== undefined ? [lines] : [];
		},

		// Args are: (tooltipItem, data)
		getBody: function(tooltipItems, data) {
			var me = this;
			var callbacks = me._options.callbacks;
			var bodyItems = [];

			helpers.each(tooltipItems, function(tooltipItem) {
				var bodyItem = {
					before: [],
					lines: [],
					after: []
				};
				pushOrConcat(bodyItem.before, callbacks.beforeLabel.call(me, tooltipItem, data));
				pushOrConcat(bodyItem.lines, callbacks.label.call(me, tooltipItem, data));
				pushOrConcat(bodyItem.after, callbacks.afterLabel.call(me, tooltipItem, data));

				bodyItems.push(bodyItem);
			});

			return bodyItems;
		},

		// Args are: (tooltipItem, data)
		getAfterBody: function() {
			var lines = this._options.callbacks.afterBody.apply(this, arguments);
			return helpers.isArray(lines) ? lines : lines !== undefined ? [lines] : [];
		},

		// Get the footer and beforeFooter and afterFooter lines
		// Args are: (tooltipItem, data)
		getFooter: function() {
			var me = this;
			var callbacks = me._options.callbacks;

			var beforeFooter = callbacks.beforeFooter.apply(me, arguments);
			var footer = callbacks.footer.apply(me, arguments);
			var afterFooter = callbacks.afterFooter.apply(me, arguments);

			var lines = [];
			lines = pushOrConcat(lines, beforeFooter);
			lines = pushOrConcat(lines, footer);
			lines = pushOrConcat(lines, afterFooter);

			return lines;
		},

		update: function(changed) {
			var me = this;
			var opts = me._options;

			// Need to regenerate the model because its faster than using extend and it is necessary due to the optimization in Chart.Element.transition
			// that does _view = _model if ease === 1. This causes the 2nd tooltip update to set properties in both the view and model at the same time
			// which breaks any animations.
			var existingModel = me._model;
			var model = me._model = getBaseModel(opts);
			var active = me._active;

			var data = me._data;

			// In the case where active.length === 0 we need to keep these at existing values for good animations
			var alignment = {
				xAlign: existingModel.xAlign,
				yAlign: existingModel.yAlign
			};
			var backgroundPoint = {
				x: existingModel.x,
				y: existingModel.y
			};
			var tooltipSize = {
				width: existingModel.width,
				height: existingModel.height
			};
			var tooltipPosition = {
				x: existingModel.caretX,
				y: existingModel.caretY
			};

			var i, len;

			if (active.length) {
				model.opacity = 1;

				var labelColors = [];
				var labelTextColors = [];
				tooltipPosition = Chart.Tooltip.positioners[opts.position].call(me, active, me._eventPosition);

				var tooltipItems = [];
				for (i = 0, len = active.length; i < len; ++i) {
					tooltipItems.push(createTooltipItem(active[i]));
				}

				// If the user provided a filter function, use it to modify the tooltip items
				if (opts.filter) {
					tooltipItems = tooltipItems.filter(function(a) {
						return opts.filter(a, data);
					});
				}

				// If the user provided a sorting function, use it to modify the tooltip items
				if (opts.itemSort) {
					tooltipItems = tooltipItems.sort(function(a, b) {
						return opts.itemSort(a, b, data);
					});
				}

				// Determine colors for boxes
				helpers.each(tooltipItems, function(tooltipItem) {
					labelColors.push(opts.callbacks.labelColor.call(me, tooltipItem, me._chart));
					labelTextColors.push(opts.callbacks.labelTextColor.call(me, tooltipItem, me._chart));
				});


				// Build the Text Lines
				model.title = me.getTitle(tooltipItems, data);
				model.beforeBody = me.getBeforeBody(tooltipItems, data);
				model.body = me.getBody(tooltipItems, data);
				model.afterBody = me.getAfterBody(tooltipItems, data);
				model.footer = me.getFooter(tooltipItems, data);

				// Initial positioning and colors
				model.x = Math.round(tooltipPosition.x);
				model.y = Math.round(tooltipPosition.y);
				model.caretPadding = opts.caretPadding;
				model.labelColors = labelColors;
				model.labelTextColors = labelTextColors;

				// data points
				model.dataPoints = tooltipItems;

				// We need to determine alignment of the tooltip
				tooltipSize = getTooltipSize(this, model);
				alignment = determineAlignment(this, tooltipSize);
				// Final Size and Position
				backgroundPoint = getBackgroundPoint(model, tooltipSize, alignment);
			} else {
				model.opacity = 0;
			}

			model.xAlign = alignment.xAlign;
			model.yAlign = alignment.yAlign;
			model.x = backgroundPoint.x;
			model.y = backgroundPoint.y;
			model.width = tooltipSize.width;
			model.height = tooltipSize.height;

			// Point where the caret on the tooltip points to
			model.caretX = tooltipPosition.x;
			model.caretY = tooltipPosition.y;

			me._model = model;

			if (changed && opts.custom) {
				opts.custom.call(me, model);
			}

			return me;
		},
		drawCaret: function(tooltipPoint, size) {
			var ctx = this._chart.ctx;
			var vm = this._view;
			var caretPosition = this.getCaretPosition(tooltipPoint, size, vm);

			ctx.lineTo(caretPosition.x1, caretPosition.y1);
			ctx.lineTo(caretPosition.x2, caretPosition.y2);
			ctx.lineTo(caretPosition.x3, caretPosition.y3);
		},
		getCaretPosition: function(tooltipPoint, size, vm) {
			var x1, x2, x3, y1, y2, y3;
			var caretSize = vm.caretSize;
			var cornerRadius = vm.cornerRadius;
			var xAlign = vm.xAlign;
			var yAlign = vm.yAlign;
			var ptX = tooltipPoint.x;
			var ptY = tooltipPoint.y;
			var width = size.width;
			var height = size.height;

			if (yAlign === 'center') {
				y2 = ptY + (height / 2);

				if (xAlign === 'left') {
					x1 = ptX;
					x2 = x1 - caretSize;
					x3 = x1;

					y1 = y2 + caretSize;
					y3 = y2 - caretSize;
				} else {
					x1 = ptX + width;
					x2 = x1 + caretSize;
					x3 = x1;

					y1 = y2 - caretSize;
					y3 = y2 + caretSize;
				}
			} else {
				if (xAlign === 'left') {
					x2 = ptX + cornerRadius + (caretSize);
					x1 = x2 - caretSize;
					x3 = x2 + caretSize;
				} else if (xAlign === 'right') {
					x2 = ptX + width - cornerRadius - caretSize;
					x1 = x2 - caretSize;
					x3 = x2 + caretSize;
				} else {
					x2 = ptX + (width / 2);
					x1 = x2 - caretSize;
					x3 = x2 + caretSize;
				}
				if (yAlign === 'top') {
					y1 = ptY;
					y2 = y1 - caretSize;
					y3 = y1;
				} else {
					y1 = ptY + height;
					y2 = y1 + caretSize;
					y3 = y1;
					// invert drawing order
					var tmp = x3;
					x3 = x1;
					x1 = tmp;
				}
			}
			return {x1: x1, x2: x2, x3: x3, y1: y1, y2: y2, y3: y3};
		},
		drawTitle: function(pt, vm, ctx, opacity) {
			var title = vm.title;

			if (title.length) {
				ctx.textAlign = vm._titleAlign;
				ctx.textBaseline = 'top';

				var titleFontSize = vm.titleFontSize;
				var titleSpacing = vm.titleSpacing;

				ctx.fillStyle = mergeOpacity(vm.titleFontColor, opacity);
				ctx.font = helpers.fontString(titleFontSize, vm._titleFontStyle, vm._titleFontFamily);

				var i, len;
				for (i = 0, len = title.length; i < len; ++i) {
					ctx.fillText(title[i], pt.x, pt.y);
					pt.y += titleFontSize + titleSpacing; // Line Height and spacing

					if (i + 1 === title.length) {
						pt.y += vm.titleMarginBottom - titleSpacing; // If Last, add margin, remove spacing
					}
				}
			}
		},
		drawBody: function(pt, vm, ctx, opacity) {
			var bodyFontSize = vm.bodyFontSize;
			var bodySpacing = vm.bodySpacing;
			var body = vm.body;

			ctx.textAlign = vm._bodyAlign;
			ctx.textBaseline = 'top';
			ctx.font = helpers.fontString(bodyFontSize, vm._bodyFontStyle, vm._bodyFontFamily);

			// Before Body
			var xLinePadding = 0;
			var fillLineOfText = function(line) {
				ctx.fillText(line, pt.x + xLinePadding, pt.y);
				pt.y += bodyFontSize + bodySpacing;
			};

			// Before body lines
			ctx.fillStyle = mergeOpacity(vm.bodyFontColor, opacity);
			helpers.each(vm.beforeBody, fillLineOfText);

			var drawColorBoxes = vm.displayColors;
			xLinePadding = drawColorBoxes ? (bodyFontSize + 2) : 0;

			// Draw body lines now
			helpers.each(body, function(bodyItem, i) {
				var textColor = mergeOpacity(vm.labelTextColors[i], opacity);
				ctx.fillStyle = textColor;
				helpers.each(bodyItem.before, fillLineOfText);

				helpers.each(bodyItem.lines, function(line) {
					// Draw Legend-like boxes if needed
					if (drawColorBoxes) {
						// Fill a white rect so that colours merge nicely if the opacity is < 1
						ctx.fillStyle = mergeOpacity(vm.legendColorBackground, opacity);
						ctx.fillRect(pt.x, pt.y, bodyFontSize, bodyFontSize);

						// Border
						ctx.lineWidth = 1;
						ctx.strokeStyle = mergeOpacity(vm.labelColors[i].borderColor, opacity);
						ctx.strokeRect(pt.x, pt.y, bodyFontSize, bodyFontSize);

						// Inner square
						ctx.fillStyle = mergeOpacity(vm.labelColors[i].backgroundColor, opacity);
						ctx.fillRect(pt.x + 1, pt.y + 1, bodyFontSize - 2, bodyFontSize - 2);
						ctx.fillStyle = textColor;
					}

					fillLineOfText(line);
				});

				helpers.each(bodyItem.after, fillLineOfText);
			});

			// Reset back to 0 for after body
			xLinePadding = 0;

			// After body lines
			helpers.each(vm.afterBody, fillLineOfText);
			pt.y -= bodySpacing; // Remove last body spacing
		},
		drawFooter: function(pt, vm, ctx, opacity) {
			var footer = vm.footer;

			if (footer.length) {
				pt.y += vm.footerMarginTop;

				ctx.textAlign = vm._footerAlign;
				ctx.textBaseline = 'top';

				ctx.fillStyle = mergeOpacity(vm.footerFontColor, opacity);
				ctx.font = helpers.fontString(vm.footerFontSize, vm._footerFontStyle, vm._footerFontFamily);

				helpers.each(footer, function(line) {
					ctx.fillText(line, pt.x, pt.y);
					pt.y += vm.footerFontSize + vm.footerSpacing;
				});
			}
		},
		drawBackground: function(pt, vm, ctx, tooltipSize, opacity) {
			ctx.fillStyle = mergeOpacity(vm.backgroundColor, opacity);
			ctx.strokeStyle = mergeOpacity(vm.borderColor, opacity);
			ctx.lineWidth = vm.borderWidth;
			var xAlign = vm.xAlign;
			var yAlign = vm.yAlign;
			var x = pt.x;
			var y = pt.y;
			var width = tooltipSize.width;
			var height = tooltipSize.height;
			var radius = vm.cornerRadius;

			ctx.beginPath();
			ctx.moveTo(x + radius, y);
			if (yAlign === 'top') {
				this.drawCaret(pt, tooltipSize);
			}
			ctx.lineTo(x + width - radius, y);
			ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
			if (yAlign === 'center' && xAlign === 'right') {
				this.drawCaret(pt, tooltipSize);
			}
			ctx.lineTo(x + width, y + height - radius);
			ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
			if (yAlign === 'bottom') {
				this.drawCaret(pt, tooltipSize);
			}
			ctx.lineTo(x + radius, y + height);
			ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
			if (yAlign === 'center' && xAlign === 'left') {
				this.drawCaret(pt, tooltipSize);
			}
			ctx.lineTo(x, y + radius);
			ctx.quadraticCurveTo(x, y, x + radius, y);
			ctx.closePath();

			ctx.fill();

			if (vm.borderWidth > 0) {
				ctx.stroke();
			}
		},
		draw: function() {
			var ctx = this._chart.ctx;
			var vm = this._view;

			if (vm.opacity === 0) {
				return;
			}

			var tooltipSize = {
				width: vm.width,
				height: vm.height
			};
			var pt = {
				x: vm.x,
				y: vm.y
			};

			// IE11/Edge does not like very small opacities, so snap to 0
			var opacity = Math.abs(vm.opacity < 1e-3) ? 0 : vm.opacity;

			// Truthy/falsey value for empty tooltip
			var hasTooltipContent = vm.title.length || vm.beforeBody.length || vm.body.length || vm.afterBody.length || vm.footer.length;

			if (this._options.enabled && hasTooltipContent) {
				// Draw Background
				this.drawBackground(pt, vm, ctx, tooltipSize, opacity);

				// Draw Title, Body, and Footer
				pt.x += vm.xPadding;
				pt.y += vm.yPadding;

				// Titles
				this.drawTitle(pt, vm, ctx, opacity);

				// Body
				this.drawBody(pt, vm, ctx, opacity);

				// Footer
				this.drawFooter(pt, vm, ctx, opacity);
			}
		},

		/**
		 * Handle an event
		 * @private
		 * @param {IEvent} event - The event to handle
		 * @returns {Boolean} true if the tooltip changed
		 */
		handleEvent: function(e) {
			var me = this;
			var options = me._options;
			var changed = false;

			me._lastActive = me._lastActive || [];

			// Find Active Elements for tooltips
			if (e.type === 'mouseout') {
				me._active = [];
			} else {
				me._active = me._chart.getElementsAtEventForMode(e, options.mode, options);
			}

			// Remember Last Actives
			changed = !helpers.arrayEquals(me._active, me._lastActive);

			// If tooltip didn't change, do not handle the target event
			if (!changed) {
				return false;
			}

			me._lastActive = me._active;

			if (options.enabled || options.custom) {
				me._eventPosition = {
					x: e.x,
					y: e.y
				};

				var model = me._model;
				me.update(true);
				me.pivot();

				// See if our tooltip position changed
				changed |= (model.x !== me._model.x) || (model.y !== me._model.y);
			}

			return changed;
		}
	});

	/**
	 * @namespace Chart.Tooltip.positioners
	 */
	Chart.Tooltip.positioners = {
		/**
		 * Average mode places the tooltip at the average position of the elements shown
		 * @function Chart.Tooltip.positioners.average
		 * @param elements {ChartElement[]} the elements being displayed in the tooltip
		 * @returns {Point} tooltip position
		 */
		average: function(elements) {
			if (!elements.length) {
				return false;
			}

			var i, len;
			var x = 0;
			var y = 0;
			var count = 0;

			for (i = 0, len = elements.length; i < len; ++i) {
				var el = elements[i];
				if (el && el.hasValue()) {
					var pos = el.tooltipPosition();
					x += pos.x;
					y += pos.y;
					++count;
				}
			}

			return {
				x: Math.round(x / count),
				y: Math.round(y / count)
			};
		},

		/**
		 * Gets the tooltip position nearest of the item nearest to the event position
		 * @function Chart.Tooltip.positioners.nearest
		 * @param elements {Chart.Element[]} the tooltip elements
		 * @param eventPosition {Point} the position of the event in canvas coordinates
		 * @returns {Point} the tooltip position
		 */
		nearest: function(elements, eventPosition) {
			var x = eventPosition.x;
			var y = eventPosition.y;
			var minDistance = Number.POSITIVE_INFINITY;
			var i, len, nearestElement;

			for (i = 0, len = elements.length; i < len; ++i) {
				var el = elements[i];
				if (el && el.hasValue()) {
					var center = el.getCenterPoint();
					var d = helpers.distanceBetweenPoints(eventPosition, center);

					if (d < minDistance) {
						minDistance = d;
						nearestElement = el;
					}
				}
			}

			if (nearestElement) {
				var tp = nearestElement.tooltipPosition();
				x = tp.x;
				y = tp.y;
			}

			return {
				x: x,
				y: y
			};
		}
	};
};


/***/ }),

/***/ 2663:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var helpers = __webpack_require__(789);
var Ticks = __webpack_require__(942);

module.exports = function(Chart) {

	var noop = helpers.noop;

	Chart.LinearScaleBase = Chart.Scale.extend({
		getRightValue: function(value) {
			if (typeof value === 'string') {
				return +value;
			}
			return Chart.Scale.prototype.getRightValue.call(this, value);
		},

		handleTickRangeOptions: function() {
			var me = this;
			var opts = me.options;
			var tickOpts = opts.ticks;

			// If we are forcing it to begin at 0, but 0 will already be rendered on the chart,
			// do nothing since that would make the chart weird. If the user really wants a weird chart
			// axis, they can manually override it
			if (tickOpts.beginAtZero) {
				var minSign = helpers.sign(me.min);
				var maxSign = helpers.sign(me.max);

				if (minSign < 0 && maxSign < 0) {
					// move the top up to 0
					me.max = 0;
				} else if (minSign > 0 && maxSign > 0) {
					// move the bottom down to 0
					me.min = 0;
				}
			}

			var setMin = tickOpts.min !== undefined || tickOpts.suggestedMin !== undefined;
			var setMax = tickOpts.max !== undefined || tickOpts.suggestedMax !== undefined;

			if (tickOpts.min !== undefined) {
				me.min = tickOpts.min;
			} else if (tickOpts.suggestedMin !== undefined) {
				if (me.min === null) {
					me.min = tickOpts.suggestedMin;
				} else {
					me.min = Math.min(me.min, tickOpts.suggestedMin);
				}
			}

			if (tickOpts.max !== undefined) {
				me.max = tickOpts.max;
			} else if (tickOpts.suggestedMax !== undefined) {
				if (me.max === null) {
					me.max = tickOpts.suggestedMax;
				} else {
					me.max = Math.max(me.max, tickOpts.suggestedMax);
				}
			}

			if (setMin !== setMax) {
				// We set the min or the max but not both.
				// So ensure that our range is good
				// Inverted or 0 length range can happen when
				// ticks.min is set, and no datasets are visible
				if (me.min >= me.max) {
					if (setMin) {
						me.max = me.min + 1;
					} else {
						me.min = me.max - 1;
					}
				}
			}

			if (me.min === me.max) {
				me.max++;

				if (!tickOpts.beginAtZero) {
					me.min--;
				}
			}
		},
		getTickLimit: noop,
		handleDirectionalChanges: noop,

		buildTicks: function() {
			var me = this;
			var opts = me.options;
			var tickOpts = opts.ticks;

			// Figure out what the max number of ticks we can support it is based on the size of
			// the axis area. For now, we say that the minimum tick spacing in pixels must be 50
			// We also limit the maximum number of ticks to 11 which gives a nice 10 squares on
			// the graph. Make sure we always have at least 2 ticks
			var maxTicks = me.getTickLimit();
			maxTicks = Math.max(2, maxTicks);

			var numericGeneratorOptions = {
				maxTicks: maxTicks,
				min: tickOpts.min,
				max: tickOpts.max,
				stepSize: helpers.valueOrDefault(tickOpts.fixedStepSize, tickOpts.stepSize)
			};
			var ticks = me.ticks = Ticks.generators.linear(numericGeneratorOptions, me);

			me.handleDirectionalChanges();

			// At this point, we need to update our max and min given the tick values since we have expanded the
			// range of the scale
			me.max = helpers.max(ticks);
			me.min = helpers.min(ticks);

			if (tickOpts.reverse) {
				ticks.reverse();

				me.start = me.max;
				me.end = me.min;
			} else {
				me.start = me.min;
				me.end = me.max;
			}
		},
		convertTicksToLabels: function() {
			var me = this;
			me.ticksAsNumbers = me.ticks.slice();
			me.zeroLineIndex = me.ticks.indexOf(0);

			Chart.Scale.prototype.convertTicksToLabels.call(me);
		}
	});
};


/***/ }),

/***/ 2664:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function(Chart) {

	// Default config for a category scale
	var defaultConfig = {
		position: 'bottom'
	};

	var DatasetScale = Chart.Scale.extend({
		/**
		* Internal function to get the correct labels. If data.xLabels or data.yLabels are defined, use those
		* else fall back to data.labels
		* @private
		*/
		getLabels: function() {
			var data = this.chart.data;
			return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels;
		},

		determineDataLimits: function() {
			var me = this;
			var labels = me.getLabels();
			me.minIndex = 0;
			me.maxIndex = labels.length - 1;
			var findIndex;

			if (me.options.ticks.min !== undefined) {
				// user specified min value
				findIndex = labels.indexOf(me.options.ticks.min);
				me.minIndex = findIndex !== -1 ? findIndex : me.minIndex;
			}

			if (me.options.ticks.max !== undefined) {
				// user specified max value
				findIndex = labels.indexOf(me.options.ticks.max);
				me.maxIndex = findIndex !== -1 ? findIndex : me.maxIndex;
			}

			me.min = labels[me.minIndex];
			me.max = labels[me.maxIndex];
		},

		buildTicks: function() {
			var me = this;
			var labels = me.getLabels();
			// If we are viewing some subset of labels, slice the original array
			me.ticks = (me.minIndex === 0 && me.maxIndex === labels.length - 1) ? labels : labels.slice(me.minIndex, me.maxIndex + 1);
		},

		getLabelForIndex: function(index, datasetIndex) {
			var me = this;
			var data = me.chart.data;
			var isHorizontal = me.isHorizontal();

			if (data.yLabels && !isHorizontal) {
				return me.getRightValue(data.datasets[datasetIndex].data[index]);
			}
			return me.ticks[index - me.minIndex];
		},

		// Used to get data value locations.  Value can either be an index or a numerical value
		getPixelForValue: function(value, index) {
			var me = this;
			var offset = me.options.offset;
			// 1 is added because we need the length but we have the indexes
			var offsetAmt = Math.max((me.maxIndex + 1 - me.minIndex - (offset ? 0 : 1)), 1);

			// If value is a data object, then index is the index in the data array,
			// not the index of the scale. We need to change that.
			var valueCategory;
			if (value !== undefined && value !== null) {
				valueCategory = me.isHorizontal() ? value.x : value.y;
			}
			if (valueCategory !== undefined || (value !== undefined && isNaN(index))) {
				var labels = me.getLabels();
				value = valueCategory || value;
				var idx = labels.indexOf(value);
				index = idx !== -1 ? idx : index;
			}

			if (me.isHorizontal()) {
				var valueWidth = me.width / offsetAmt;
				var widthOffset = (valueWidth * (index - me.minIndex));

				if (offset) {
					widthOffset += (valueWidth / 2);
				}

				return me.left + Math.round(widthOffset);
			}
			var valueHeight = me.height / offsetAmt;
			var heightOffset = (valueHeight * (index - me.minIndex));

			if (offset) {
				heightOffset += (valueHeight / 2);
			}

			return me.top + Math.round(heightOffset);
		},
		getPixelForTick: function(index) {
			return this.getPixelForValue(this.ticks[index], index + this.minIndex, null);
		},
		getValueForPixel: function(pixel) {
			var me = this;
			var offset = me.options.offset;
			var value;
			var offsetAmt = Math.max((me._ticks.length - (offset ? 0 : 1)), 1);
			var horz = me.isHorizontal();
			var valueDimension = (horz ? me.width : me.height) / offsetAmt;

			pixel -= horz ? me.left : me.top;

			if (offset) {
				pixel -= (valueDimension / 2);
			}

			if (pixel <= 0) {
				value = 0;
			} else {
				value = Math.round(pixel / valueDimension);
			}

			return value + me.minIndex;
		},
		getBasePixel: function() {
			return this.bottom;
		}
	});

	Chart.scaleService.registerScaleType('category', DatasetScale, defaultConfig);

};


/***/ }),

/***/ 2665:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(796);
var helpers = __webpack_require__(789);
var Ticks = __webpack_require__(942);

module.exports = function(Chart) {

	var defaultConfig = {
		position: 'left',
		ticks: {
			callback: Ticks.formatters.linear
		}
	};

	var LinearScale = Chart.LinearScaleBase.extend({

		determineDataLimits: function() {
			var me = this;
			var opts = me.options;
			var chart = me.chart;
			var data = chart.data;
			var datasets = data.datasets;
			var isHorizontal = me.isHorizontal();
			var DEFAULT_MIN = 0;
			var DEFAULT_MAX = 1;

			function IDMatches(meta) {
				return isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id;
			}

			// First Calculate the range
			me.min = null;
			me.max = null;

			var hasStacks = opts.stacked;
			if (hasStacks === undefined) {
				helpers.each(datasets, function(dataset, datasetIndex) {
					if (hasStacks) {
						return;
					}

					var meta = chart.getDatasetMeta(datasetIndex);
					if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta) &&
						meta.stack !== undefined) {
						hasStacks = true;
					}
				});
			}

			if (opts.stacked || hasStacks) {
				var valuesPerStack = {};

				helpers.each(datasets, function(dataset, datasetIndex) {
					var meta = chart.getDatasetMeta(datasetIndex);
					var key = [
						meta.type,
						// we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
						((opts.stacked === undefined && meta.stack === undefined) ? datasetIndex : ''),
						meta.stack
					].join('.');

					if (valuesPerStack[key] === undefined) {
						valuesPerStack[key] = {
							positiveValues: [],
							negativeValues: []
						};
					}

					// Store these per type
					var positiveValues = valuesPerStack[key].positiveValues;
					var negativeValues = valuesPerStack[key].negativeValues;

					if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
						helpers.each(dataset.data, function(rawValue, index) {
							var value = +me.getRightValue(rawValue);
							if (isNaN(value) || meta.data[index].hidden) {
								return;
							}

							positiveValues[index] = positiveValues[index] || 0;
							negativeValues[index] = negativeValues[index] || 0;

							if (opts.relativePoints) {
								positiveValues[index] = 100;
							} else if (value < 0) {
								negativeValues[index] += value;
							} else {
								positiveValues[index] += value;
							}
						});
					}
				});

				helpers.each(valuesPerStack, function(valuesForType) {
					var values = valuesForType.positiveValues.concat(valuesForType.negativeValues);
					var minVal = helpers.min(values);
					var maxVal = helpers.max(values);
					me.min = me.min === null ? minVal : Math.min(me.min, minVal);
					me.max = me.max === null ? maxVal : Math.max(me.max, maxVal);
				});

			} else {
				helpers.each(datasets, function(dataset, datasetIndex) {
					var meta = chart.getDatasetMeta(datasetIndex);
					if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
						helpers.each(dataset.data, function(rawValue, index) {
							var value = +me.getRightValue(rawValue);
							if (isNaN(value) || meta.data[index].hidden) {
								return;
							}

							if (me.min === null) {
								me.min = value;
							} else if (value < me.min) {
								me.min = value;
							}

							if (me.max === null) {
								me.max = value;
							} else if (value > me.max) {
								me.max = value;
							}
						});
					}
				});
			}

			me.min = isFinite(me.min) && !isNaN(me.min) ? me.min : DEFAULT_MIN;
			me.max = isFinite(me.max) && !isNaN(me.max) ? me.max : DEFAULT_MAX;

			// Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
			this.handleTickRangeOptions();
		},
		getTickLimit: function() {
			var maxTicks;
			var me = this;
			var tickOpts = me.options.ticks;

			if (me.isHorizontal()) {
				maxTicks = Math.min(tickOpts.maxTicksLimit ? tickOpts.maxTicksLimit : 11, Math.ceil(me.width / 50));
			} else {
				// The factor of 2 used to scale the font size has been experimentally determined.
				var tickFontSize = helpers.valueOrDefault(tickOpts.fontSize, defaults.global.defaultFontSize);
				maxTicks = Math.min(tickOpts.maxTicksLimit ? tickOpts.maxTicksLimit : 11, Math.ceil(me.height / (2 * tickFontSize)));
			}

			return maxTicks;
		},
		// Called after the ticks are built. We need
		handleDirectionalChanges: function() {
			if (!this.isHorizontal()) {
				// We are in a vertical orientation. The top value is the highest. So reverse the array
				this.ticks.reverse();
			}
		},
		getLabelForIndex: function(index, datasetIndex) {
			return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
		},
		// Utils
		getPixelForValue: function(value) {
			// This must be called after fit has been run so that
			// this.left, this.top, this.right, and this.bottom have been defined
			var me = this;
			var start = me.start;

			var rightValue = +me.getRightValue(value);
			var pixel;
			var range = me.end - start;

			if (me.isHorizontal()) {
				pixel = me.left + (me.width / range * (rightValue - start));
				return Math.round(pixel);
			}

			pixel = me.bottom - (me.height / range * (rightValue - start));
			return Math.round(pixel);
		},
		getValueForPixel: function(pixel) {
			var me = this;
			var isHorizontal = me.isHorizontal();
			var innerDimension = isHorizontal ? me.width : me.height;
			var offset = (isHorizontal ? pixel - me.left : me.bottom - pixel) / innerDimension;
			return me.start + ((me.end - me.start) * offset);
		},
		getPixelForTick: function(index) {
			return this.getPixelForValue(this.ticksAsNumbers[index]);
		}
	});
	Chart.scaleService.registerScaleType('linear', LinearScale, defaultConfig);

};


/***/ }),

/***/ 2666:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var helpers = __webpack_require__(789);
var Ticks = __webpack_require__(942);

module.exports = function(Chart) {

	var defaultConfig = {
		position: 'left',

		// label settings
		ticks: {
			callback: Ticks.formatters.logarithmic
		}
	};

	var LogarithmicScale = Chart.Scale.extend({
		determineDataLimits: function() {
			var me = this;
			var opts = me.options;
			var tickOpts = opts.ticks;
			var chart = me.chart;
			var data = chart.data;
			var datasets = data.datasets;
			var valueOrDefault = helpers.valueOrDefault;
			var isHorizontal = me.isHorizontal();
			function IDMatches(meta) {
				return isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id;
			}

			// Calculate Range
			me.min = null;
			me.max = null;
			me.minNotZero = null;

			var hasStacks = opts.stacked;
			if (hasStacks === undefined) {
				helpers.each(datasets, function(dataset, datasetIndex) {
					if (hasStacks) {
						return;
					}

					var meta = chart.getDatasetMeta(datasetIndex);
					if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta) &&
						meta.stack !== undefined) {
						hasStacks = true;
					}
				});
			}

			if (opts.stacked || hasStacks) {
				var valuesPerStack = {};

				helpers.each(datasets, function(dataset, datasetIndex) {
					var meta = chart.getDatasetMeta(datasetIndex);
					var key = [
						meta.type,
						// we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
						((opts.stacked === undefined && meta.stack === undefined) ? datasetIndex : ''),
						meta.stack
					].join('.');

					if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
						if (valuesPerStack[key] === undefined) {
							valuesPerStack[key] = [];
						}

						helpers.each(dataset.data, function(rawValue, index) {
							var values = valuesPerStack[key];
							var value = +me.getRightValue(rawValue);
							if (isNaN(value) || meta.data[index].hidden) {
								return;
							}

							values[index] = values[index] || 0;

							if (opts.relativePoints) {
								values[index] = 100;
							} else {
								// Don't need to split positive and negative since the log scale can't handle a 0 crossing
								values[index] += value;
							}
						});
					}
				});

				helpers.each(valuesPerStack, function(valuesForType) {
					var minVal = helpers.min(valuesForType);
					var maxVal = helpers.max(valuesForType);
					me.min = me.min === null ? minVal : Math.min(me.min, minVal);
					me.max = me.max === null ? maxVal : Math.max(me.max, maxVal);
				});

			} else {
				helpers.each(datasets, function(dataset, datasetIndex) {
					var meta = chart.getDatasetMeta(datasetIndex);
					if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
						helpers.each(dataset.data, function(rawValue, index) {
							var value = +me.getRightValue(rawValue);
							if (isNaN(value) || meta.data[index].hidden) {
								return;
							}

							if (me.min === null) {
								me.min = value;
							} else if (value < me.min) {
								me.min = value;
							}

							if (me.max === null) {
								me.max = value;
							} else if (value > me.max) {
								me.max = value;
							}

							if (value !== 0 && (me.minNotZero === null || value < me.minNotZero)) {
								me.minNotZero = value;
							}
						});
					}
				});
			}

			me.min = valueOrDefault(tickOpts.min, me.min);
			me.max = valueOrDefault(tickOpts.max, me.max);

			if (me.min === me.max) {
				if (me.min !== 0 && me.min !== null) {
					me.min = Math.pow(10, Math.floor(helpers.log10(me.min)) - 1);
					me.max = Math.pow(10, Math.floor(helpers.log10(me.max)) + 1);
				} else {
					me.min = 1;
					me.max = 10;
				}
			}
		},
		buildTicks: function() {
			var me = this;
			var opts = me.options;
			var tickOpts = opts.ticks;

			var generationOptions = {
				min: tickOpts.min,
				max: tickOpts.max
			};
			var ticks = me.ticks = Ticks.generators.logarithmic(generationOptions, me);

			if (!me.isHorizontal()) {
				// We are in a vertical orientation. The top value is the highest. So reverse the array
				ticks.reverse();
			}

			// At this point, we need to update our max and min given the tick values since we have expanded the
			// range of the scale
			me.max = helpers.max(ticks);
			me.min = helpers.min(ticks);

			if (tickOpts.reverse) {
				ticks.reverse();

				me.start = me.max;
				me.end = me.min;
			} else {
				me.start = me.min;
				me.end = me.max;
			}
		},
		convertTicksToLabels: function() {
			this.tickValues = this.ticks.slice();

			Chart.Scale.prototype.convertTicksToLabels.call(this);
		},
		// Get the correct tooltip label
		getLabelForIndex: function(index, datasetIndex) {
			return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
		},
		getPixelForTick: function(index) {
			return this.getPixelForValue(this.tickValues[index]);
		},
		getPixelForValue: function(value) {
			var me = this;
			var start = me.start;
			var newVal = +me.getRightValue(value);
			var opts = me.options;
			var tickOpts = opts.ticks;
			var innerDimension, pixel, range;

			if (me.isHorizontal()) {
				range = helpers.log10(me.end) - helpers.log10(start); // todo: if start === 0
				if (newVal === 0) {
					pixel = me.left;
				} else {
					innerDimension = me.width;
					pixel = me.left + (innerDimension / range * (helpers.log10(newVal) - helpers.log10(start)));
				}
			} else {
				// Bottom - top since pixels increase downward on a screen
				innerDimension = me.height;
				if (start === 0 && !tickOpts.reverse) {
					range = helpers.log10(me.end) - helpers.log10(me.minNotZero);
					if (newVal === start) {
						pixel = me.bottom;
					} else if (newVal === me.minNotZero) {
						pixel = me.bottom - innerDimension * 0.02;
					} else {
						pixel = me.bottom - innerDimension * 0.02 - (innerDimension * 0.98 / range * (helpers.log10(newVal) - helpers.log10(me.minNotZero)));
					}
				} else if (me.end === 0 && tickOpts.reverse) {
					range = helpers.log10(me.start) - helpers.log10(me.minNotZero);
					if (newVal === me.end) {
						pixel = me.top;
					} else if (newVal === me.minNotZero) {
						pixel = me.top + innerDimension * 0.02;
					} else {
						pixel = me.top + innerDimension * 0.02 + (innerDimension * 0.98 / range * (helpers.log10(newVal) - helpers.log10(me.minNotZero)));
					}
				} else if (newVal === 0) {
					pixel = tickOpts.reverse ? me.top : me.bottom;
				} else {
					range = helpers.log10(me.end) - helpers.log10(start);
					innerDimension = me.height;
					pixel = me.bottom - (innerDimension / range * (helpers.log10(newVal) - helpers.log10(start)));
				}
			}
			return pixel;
		},
		getValueForPixel: function(pixel) {
			var me = this;
			var range = helpers.log10(me.end) - helpers.log10(me.start);
			var value, innerDimension;

			if (me.isHorizontal()) {
				innerDimension = me.width;
				value = me.start * Math.pow(10, (pixel - me.left) * range / innerDimension);
			} else { // todo: if start === 0
				innerDimension = me.height;
				value = Math.pow(10, (me.bottom - pixel) * range / innerDimension) / me.start;
			}
			return value;
		}
	});
	Chart.scaleService.registerScaleType('logarithmic', LogarithmicScale, defaultConfig);

};


/***/ }),

/***/ 2667:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(796);
var helpers = __webpack_require__(789);
var Ticks = __webpack_require__(942);

module.exports = function(Chart) {

	var globalDefaults = defaults.global;

	var defaultConfig = {
		display: true,

		// Boolean - Whether to animate scaling the chart from the centre
		animate: true,
		position: 'chartArea',

		angleLines: {
			display: true,
			color: 'rgba(0, 0, 0, 0.1)',
			lineWidth: 1
		},

		gridLines: {
			circular: false
		},

		// label settings
		ticks: {
			// Boolean - Show a backdrop to the scale label
			showLabelBackdrop: true,

			// String - The colour of the label backdrop
			backdropColor: 'rgba(255,255,255,0.75)',

			// Number - The backdrop padding above & below the label in pixels
			backdropPaddingY: 2,

			// Number - The backdrop padding to the side of the label in pixels
			backdropPaddingX: 2,

			callback: Ticks.formatters.linear
		},

		pointLabels: {
			// Boolean - if true, show point labels
			display: true,

			// Number - Point label font size in pixels
			fontSize: 10,

			// Function - Used to convert point labels
			callback: function(label) {
				return label;
			}
		}
	};

	function getValueCount(scale) {
		var opts = scale.options;
		return opts.angleLines.display || opts.pointLabels.display ? scale.chart.data.labels.length : 0;
	}

	function getPointLabelFontOptions(scale) {
		var pointLabelOptions = scale.options.pointLabels;
		var fontSize = helpers.valueOrDefault(pointLabelOptions.fontSize, globalDefaults.defaultFontSize);
		var fontStyle = helpers.valueOrDefault(pointLabelOptions.fontStyle, globalDefaults.defaultFontStyle);
		var fontFamily = helpers.valueOrDefault(pointLabelOptions.fontFamily, globalDefaults.defaultFontFamily);
		var font = helpers.fontString(fontSize, fontStyle, fontFamily);

		return {
			size: fontSize,
			style: fontStyle,
			family: fontFamily,
			font: font
		};
	}

	function measureLabelSize(ctx, fontSize, label) {
		if (helpers.isArray(label)) {
			return {
				w: helpers.longestText(ctx, ctx.font, label),
				h: (label.length * fontSize) + ((label.length - 1) * 1.5 * fontSize)
			};
		}

		return {
			w: ctx.measureText(label).width,
			h: fontSize
		};
	}

	function determineLimits(angle, pos, size, min, max) {
		if (angle === min || angle === max) {
			return {
				start: pos - (size / 2),
				end: pos + (size / 2)
			};
		} else if (angle < min || angle > max) {
			return {
				start: pos - size - 5,
				end: pos
			};
		}

		return {
			start: pos,
			end: pos + size + 5
		};
	}

	/**
	 * Helper function to fit a radial linear scale with point labels
	 */
	function fitWithPointLabels(scale) {
		/*
		 * Right, this is really confusing and there is a lot of maths going on here
		 * The gist of the problem is here: https://gist.github.com/nnnick/696cc9c55f4b0beb8fe9
		 *
		 * Reaction: https://dl.dropboxusercontent.com/u/34601363/toomuchscience.gif
		 *
		 * Solution:
		 *
		 * We assume the radius of the polygon is half the size of the canvas at first
		 * at each index we check if the text overlaps.
		 *
		 * Where it does, we store that angle and that index.
		 *
		 * After finding the largest index and angle we calculate how much we need to remove
		 * from the shape radius to move the point inwards by that x.
		 *
		 * We average the left and right distances to get the maximum shape radius that can fit in the box
		 * along with labels.
		 *
		 * Once we have that, we can find the centre point for the chart, by taking the x text protrusion
		 * on each side, removing that from the size, halving it and adding the left x protrusion width.
		 *
		 * This will mean we have a shape fitted to the canvas, as large as it can be with the labels
		 * and position it in the most space efficient manner
		 *
		 * https://dl.dropboxusercontent.com/u/34601363/yeahscience.gif
		 */

		var plFont = getPointLabelFontOptions(scale);

		// Get maximum radius of the polygon. Either half the height (minus the text width) or half the width.
		// Use this to calculate the offset + change. - Make sure L/R protrusion is at least 0 to stop issues with centre points
		var largestPossibleRadius = Math.min(scale.height / 2, scale.width / 2);
		var furthestLimits = {
			r: scale.width,
			l: 0,
			t: scale.height,
			b: 0
		};
		var furthestAngles = {};
		var i, textSize, pointPosition;

		scale.ctx.font = plFont.font;
		scale._pointLabelSizes = [];

		var valueCount = getValueCount(scale);
		for (i = 0; i < valueCount; i++) {
			pointPosition = scale.getPointPosition(i, largestPossibleRadius);
			textSize = measureLabelSize(scale.ctx, plFont.size, scale.pointLabels[i] || '');
			scale._pointLabelSizes[i] = textSize;

			// Add quarter circle to make degree 0 mean top of circle
			var angleRadians = scale.getIndexAngle(i);
			var angle = helpers.toDegrees(angleRadians) % 360;
			var hLimits = determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
			var vLimits = determineLimits(angle, pointPosition.y, textSize.h, 90, 270);

			if (hLimits.start < furthestLimits.l) {
				furthestLimits.l = hLimits.start;
				furthestAngles.l = angleRadians;
			}

			if (hLimits.end > furthestLimits.r) {
				furthestLimits.r = hLimits.end;
				furthestAngles.r = angleRadians;
			}

			if (vLimits.start < furthestLimits.t) {
				furthestLimits.t = vLimits.start;
				furthestAngles.t = angleRadians;
			}

			if (vLimits.end > furthestLimits.b) {
				furthestLimits.b = vLimits.end;
				furthestAngles.b = angleRadians;
			}
		}

		scale.setReductions(largestPossibleRadius, furthestLimits, furthestAngles);
	}

	/**
	 * Helper function to fit a radial linear scale with no point labels
	 */
	function fit(scale) {
		var largestPossibleRadius = Math.min(scale.height / 2, scale.width / 2);
		scale.drawingArea = Math.round(largestPossibleRadius);
		scale.setCenterPoint(0, 0, 0, 0);
	}

	function getTextAlignForAngle(angle) {
		if (angle === 0 || angle === 180) {
			return 'center';
		} else if (angle < 180) {
			return 'left';
		}

		return 'right';
	}

	function fillText(ctx, text, position, fontSize) {
		if (helpers.isArray(text)) {
			var y = position.y;
			var spacing = 1.5 * fontSize;

			for (var i = 0; i < text.length; ++i) {
				ctx.fillText(text[i], position.x, y);
				y += spacing;
			}
		} else {
			ctx.fillText(text, position.x, position.y);
		}
	}

	function adjustPointPositionForLabelHeight(angle, textSize, position) {
		if (angle === 90 || angle === 270) {
			position.y -= (textSize.h / 2);
		} else if (angle > 270 || angle < 90) {
			position.y -= textSize.h;
		}
	}

	function drawPointLabels(scale) {
		var ctx = scale.ctx;
		var valueOrDefault = helpers.valueOrDefault;
		var opts = scale.options;
		var angleLineOpts = opts.angleLines;
		var pointLabelOpts = opts.pointLabels;

		ctx.lineWidth = angleLineOpts.lineWidth;
		ctx.strokeStyle = angleLineOpts.color;

		var outerDistance = scale.getDistanceFromCenterForValue(opts.ticks.reverse ? scale.min : scale.max);

		// Point Label Font
		var plFont = getPointLabelFontOptions(scale);

		ctx.textBaseline = 'top';

		for (var i = getValueCount(scale) - 1; i >= 0; i--) {
			if (angleLineOpts.display) {
				var outerPosition = scale.getPointPosition(i, outerDistance);
				ctx.beginPath();
				ctx.moveTo(scale.xCenter, scale.yCenter);
				ctx.lineTo(outerPosition.x, outerPosition.y);
				ctx.stroke();
				ctx.closePath();
			}

			if (pointLabelOpts.display) {
				// Extra 3px out for some label spacing
				var pointLabelPosition = scale.getPointPosition(i, outerDistance + 5);

				// Keep this in loop since we may support array properties here
				var pointLabelFontColor = valueOrDefault(pointLabelOpts.fontColor, globalDefaults.defaultFontColor);
				ctx.font = plFont.font;
				ctx.fillStyle = pointLabelFontColor;

				var angleRadians = scale.getIndexAngle(i);
				var angle = helpers.toDegrees(angleRadians);
				ctx.textAlign = getTextAlignForAngle(angle);
				adjustPointPositionForLabelHeight(angle, scale._pointLabelSizes[i], pointLabelPosition);
				fillText(ctx, scale.pointLabels[i] || '', pointLabelPosition, plFont.size);
			}
		}
	}

	function drawRadiusLine(scale, gridLineOpts, radius, index) {
		var ctx = scale.ctx;
		ctx.strokeStyle = helpers.valueAtIndexOrDefault(gridLineOpts.color, index - 1);
		ctx.lineWidth = helpers.valueAtIndexOrDefault(gridLineOpts.lineWidth, index - 1);

		if (scale.options.gridLines.circular) {
			// Draw circular arcs between the points
			ctx.beginPath();
			ctx.arc(scale.xCenter, scale.yCenter, radius, 0, Math.PI * 2);
			ctx.closePath();
			ctx.stroke();
		} else {
			// Draw straight lines connecting each index
			var valueCount = getValueCount(scale);

			if (valueCount === 0) {
				return;
			}

			ctx.beginPath();
			var pointPosition = scale.getPointPosition(0, radius);
			ctx.moveTo(pointPosition.x, pointPosition.y);

			for (var i = 1; i < valueCount; i++) {
				pointPosition = scale.getPointPosition(i, radius);
				ctx.lineTo(pointPosition.x, pointPosition.y);
			}

			ctx.closePath();
			ctx.stroke();
		}
	}

	function numberOrZero(param) {
		return helpers.isNumber(param) ? param : 0;
	}

	var LinearRadialScale = Chart.LinearScaleBase.extend({
		setDimensions: function() {
			var me = this;
			var opts = me.options;
			var tickOpts = opts.ticks;
			// Set the unconstrained dimension before label rotation
			me.width = me.maxWidth;
			me.height = me.maxHeight;
			me.xCenter = Math.round(me.width / 2);
			me.yCenter = Math.round(me.height / 2);

			var minSize = helpers.min([me.height, me.width]);
			var tickFontSize = helpers.valueOrDefault(tickOpts.fontSize, globalDefaults.defaultFontSize);
			me.drawingArea = opts.display ? (minSize / 2) - (tickFontSize / 2 + tickOpts.backdropPaddingY) : (minSize / 2);
		},
		determineDataLimits: function() {
			var me = this;
			var chart = me.chart;
			var min = Number.POSITIVE_INFINITY;
			var max = Number.NEGATIVE_INFINITY;

			helpers.each(chart.data.datasets, function(dataset, datasetIndex) {
				if (chart.isDatasetVisible(datasetIndex)) {
					var meta = chart.getDatasetMeta(datasetIndex);

					helpers.each(dataset.data, function(rawValue, index) {
						var value = +me.getRightValue(rawValue);
						if (isNaN(value) || meta.data[index].hidden) {
							return;
						}

						min = Math.min(value, min);
						max = Math.max(value, max);
					});
				}
			});

			me.min = (min === Number.POSITIVE_INFINITY ? 0 : min);
			me.max = (max === Number.NEGATIVE_INFINITY ? 0 : max);

			// Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
			me.handleTickRangeOptions();
		},
		getTickLimit: function() {
			var tickOpts = this.options.ticks;
			var tickFontSize = helpers.valueOrDefault(tickOpts.fontSize, globalDefaults.defaultFontSize);
			return Math.min(tickOpts.maxTicksLimit ? tickOpts.maxTicksLimit : 11, Math.ceil(this.drawingArea / (1.5 * tickFontSize)));
		},
		convertTicksToLabels: function() {
			var me = this;

			Chart.LinearScaleBase.prototype.convertTicksToLabels.call(me);

			// Point labels
			me.pointLabels = me.chart.data.labels.map(me.options.pointLabels.callback, me);
		},
		getLabelForIndex: function(index, datasetIndex) {
			return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
		},
		fit: function() {
			if (this.options.pointLabels.display) {
				fitWithPointLabels(this);
			} else {
				fit(this);
			}
		},
		/**
		 * Set radius reductions and determine new radius and center point
		 * @private
		 */
		setReductions: function(largestPossibleRadius, furthestLimits, furthestAngles) {
			var me = this;
			var radiusReductionLeft = furthestLimits.l / Math.sin(furthestAngles.l);
			var radiusReductionRight = Math.max(furthestLimits.r - me.width, 0) / Math.sin(furthestAngles.r);
			var radiusReductionTop = -furthestLimits.t / Math.cos(furthestAngles.t);
			var radiusReductionBottom = -Math.max(furthestLimits.b - me.height, 0) / Math.cos(furthestAngles.b);

			radiusReductionLeft = numberOrZero(radiusReductionLeft);
			radiusReductionRight = numberOrZero(radiusReductionRight);
			radiusReductionTop = numberOrZero(radiusReductionTop);
			radiusReductionBottom = numberOrZero(radiusReductionBottom);

			me.drawingArea = Math.min(
				Math.round(largestPossibleRadius - (radiusReductionLeft + radiusReductionRight) / 2),
				Math.round(largestPossibleRadius - (radiusReductionTop + radiusReductionBottom) / 2));
			me.setCenterPoint(radiusReductionLeft, radiusReductionRight, radiusReductionTop, radiusReductionBottom);
		},
		setCenterPoint: function(leftMovement, rightMovement, topMovement, bottomMovement) {
			var me = this;
			var maxRight = me.width - rightMovement - me.drawingArea;
			var maxLeft = leftMovement + me.drawingArea;
			var maxTop = topMovement + me.drawingArea;
			var maxBottom = me.height - bottomMovement - me.drawingArea;

			me.xCenter = Math.round(((maxLeft + maxRight) / 2) + me.left);
			me.yCenter = Math.round(((maxTop + maxBottom) / 2) + me.top);
		},

		getIndexAngle: function(index) {
			var angleMultiplier = (Math.PI * 2) / getValueCount(this);
			var startAngle = this.chart.options && this.chart.options.startAngle ?
				this.chart.options.startAngle :
				0;

			var startAngleRadians = startAngle * Math.PI * 2 / 360;

			// Start from the top instead of right, so remove a quarter of the circle
			return index * angleMultiplier + startAngleRadians;
		},
		getDistanceFromCenterForValue: function(value) {
			var me = this;

			if (value === null) {
				return 0; // null always in center
			}

			// Take into account half font size + the yPadding of the top value
			var scalingFactor = me.drawingArea / (me.max - me.min);
			if (me.options.ticks.reverse) {
				return (me.max - value) * scalingFactor;
			}
			return (value - me.min) * scalingFactor;
		},
		getPointPosition: function(index, distanceFromCenter) {
			var me = this;
			var thisAngle = me.getIndexAngle(index) - (Math.PI / 2);
			return {
				x: Math.round(Math.cos(thisAngle) * distanceFromCenter) + me.xCenter,
				y: Math.round(Math.sin(thisAngle) * distanceFromCenter) + me.yCenter
			};
		},
		getPointPositionForValue: function(index, value) {
			return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
		},

		getBasePosition: function() {
			var me = this;
			var min = me.min;
			var max = me.max;

			return me.getPointPositionForValue(0,
				me.beginAtZero ? 0 :
				min < 0 && max < 0 ? max :
				min > 0 && max > 0 ? min :
				0);
		},

		draw: function() {
			var me = this;
			var opts = me.options;
			var gridLineOpts = opts.gridLines;
			var tickOpts = opts.ticks;
			var valueOrDefault = helpers.valueOrDefault;

			if (opts.display) {
				var ctx = me.ctx;
				var startAngle = this.getIndexAngle(0);

				// Tick Font
				var tickFontSize = valueOrDefault(tickOpts.fontSize, globalDefaults.defaultFontSize);
				var tickFontStyle = valueOrDefault(tickOpts.fontStyle, globalDefaults.defaultFontStyle);
				var tickFontFamily = valueOrDefault(tickOpts.fontFamily, globalDefaults.defaultFontFamily);
				var tickLabelFont = helpers.fontString(tickFontSize, tickFontStyle, tickFontFamily);

				helpers.each(me.ticks, function(label, index) {
					// Don't draw a centre value (if it is minimum)
					if (index > 0 || tickOpts.reverse) {
						var yCenterOffset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);

						// Draw circular lines around the scale
						if (gridLineOpts.display && index !== 0) {
							drawRadiusLine(me, gridLineOpts, yCenterOffset, index);
						}

						if (tickOpts.display) {
							var tickFontColor = valueOrDefault(tickOpts.fontColor, globalDefaults.defaultFontColor);
							ctx.font = tickLabelFont;

							ctx.save();
							ctx.translate(me.xCenter, me.yCenter);
							ctx.rotate(startAngle);

							if (tickOpts.showLabelBackdrop) {
								var labelWidth = ctx.measureText(label).width;
								ctx.fillStyle = tickOpts.backdropColor;
								ctx.fillRect(
									-labelWidth / 2 - tickOpts.backdropPaddingX,
									-yCenterOffset - tickFontSize / 2 - tickOpts.backdropPaddingY,
									labelWidth + tickOpts.backdropPaddingX * 2,
									tickFontSize + tickOpts.backdropPaddingY * 2
								);
							}

							ctx.textAlign = 'center';
							ctx.textBaseline = 'middle';
							ctx.fillStyle = tickFontColor;
							ctx.fillText(label, 0, -yCenterOffset);
							ctx.restore();
						}
					}
				});

				if (opts.angleLines.display || opts.pointLabels.display) {
					drawPointLabels(me);
				}
			}
		}
	});
	Chart.scaleService.registerScaleType('radialLinear', LinearRadialScale, defaultConfig);

};


/***/ }),

/***/ 2668:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* global window: false */


var moment = __webpack_require__(764);
moment = typeof moment === 'function' ? moment : window.moment;

var defaults = __webpack_require__(796);
var helpers = __webpack_require__(789);

// Integer constants are from the ES6 spec.
var MIN_INTEGER = Number.MIN_SAFE_INTEGER || -9007199254740991;
var MAX_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;

var INTERVALS = {
	millisecond: {
		common: true,
		size: 1,
		steps: [1, 2, 5, 10, 20, 50, 100, 250, 500]
	},
	second: {
		common: true,
		size: 1000,
		steps: [1, 2, 5, 10, 30]
	},
	minute: {
		common: true,
		size: 60000,
		steps: [1, 2, 5, 10, 30]
	},
	hour: {
		common: true,
		size: 3600000,
		steps: [1, 2, 3, 6, 12]
	},
	day: {
		common: true,
		size: 86400000,
		steps: [1, 2, 5]
	},
	week: {
		common: false,
		size: 604800000,
		steps: [1, 2, 3, 4]
	},
	month: {
		common: true,
		size: 2.628e9,
		steps: [1, 2, 3]
	},
	quarter: {
		common: false,
		size: 7.884e9,
		steps: [1, 2, 3, 4]
	},
	year: {
		common: true,
		size: 3.154e10
	}
};

var UNITS = Object.keys(INTERVALS);

function sorter(a, b) {
	return a - b;
}

function arrayUnique(items) {
	var hash = {};
	var out = [];
	var i, ilen, item;

	for (i = 0, ilen = items.length; i < ilen; ++i) {
		item = items[i];
		if (!hash[item]) {
			hash[item] = true;
			out.push(item);
		}
	}

	return out;
}

/**
 * Returns an array of {time, pos} objects used to interpolate a specific `time` or position
 * (`pos`) on the scale, by searching entries before and after the requested value. `pos` is
 * a decimal between 0 and 1: 0 being the start of the scale (left or top) and 1 the other
 * extremity (left + width or top + height). Note that it would be more optimized to directly
 * store pre-computed pixels, but the scale dimensions are not guaranteed at the time we need
 * to create the lookup table. The table ALWAYS contains at least two items: min and max.
 *
 * @param {Number[]} timestamps - timestamps sorted from lowest to highest.
 * @param {String} distribution - If 'linear', timestamps will be spread linearly along the min
 * and max range, so basically, the table will contains only two items: {min, 0} and {max, 1}.
 * If 'series', timestamps will be positioned at the same distance from each other. In this
 * case, only timestamps that break the time linearity are registered, meaning that in the
 * best case, all timestamps are linear, the table contains only min and max.
 */
function buildLookupTable(timestamps, min, max, distribution) {
	if (distribution === 'linear' || !timestamps.length) {
		return [
			{time: min, pos: 0},
			{time: max, pos: 1}
		];
	}

	var table = [];
	var items = [min];
	var i, ilen, prev, curr, next;

	for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
		curr = timestamps[i];
		if (curr > min && curr < max) {
			items.push(curr);
		}
	}

	items.push(max);

	for (i = 0, ilen = items.length; i < ilen; ++i) {
		next = items[i + 1];
		prev = items[i - 1];
		curr = items[i];

		// only add points that breaks the scale linearity
		if (prev === undefined || next === undefined || Math.round((next + prev) / 2) !== curr) {
			table.push({time: curr, pos: i / (ilen - 1)});
		}
	}

	return table;
}

// @see adapted from http://www.anujgakhar.com/2014/03/01/binary-search-in-javascript/
function lookup(table, key, value) {
	var lo = 0;
	var hi = table.length - 1;
	var mid, i0, i1;

	while (lo >= 0 && lo <= hi) {
		mid = (lo + hi) >> 1;
		i0 = table[mid - 1] || null;
		i1 = table[mid];

		if (!i0) {
			// given value is outside table (before first item)
			return {lo: null, hi: i1};
		} else if (i1[key] < value) {
			lo = mid + 1;
		} else if (i0[key] > value) {
			hi = mid - 1;
		} else {
			return {lo: i0, hi: i1};
		}
	}

	// given value is outside table (after last item)
	return {lo: i1, hi: null};
}

/**
 * Linearly interpolates the given source `value` using the table items `skey` values and
 * returns the associated `tkey` value. For example, interpolate(table, 'time', 42, 'pos')
 * returns the position for a timestamp equal to 42. If value is out of bounds, values at
 * index [0, 1] or [n - 1, n] are used for the interpolation.
 */
function interpolate(table, skey, sval, tkey) {
	var range = lookup(table, skey, sval);

	// Note: the lookup table ALWAYS contains at least 2 items (min and max)
	var prev = !range.lo ? table[0] : !range.hi ? table[table.length - 2] : range.lo;
	var next = !range.lo ? table[1] : !range.hi ? table[table.length - 1] : range.hi;

	var span = next[skey] - prev[skey];
	var ratio = span ? (sval - prev[skey]) / span : 0;
	var offset = (next[tkey] - prev[tkey]) * ratio;

	return prev[tkey] + offset;
}

/**
 * Convert the given value to a moment object using the given time options.
 * @see http://momentjs.com/docs/#/parsing/
 */
function momentify(value, options) {
	var parser = options.parser;
	var format = options.parser || options.format;

	if (typeof parser === 'function') {
		return parser(value);
	}

	if (typeof value === 'string' && typeof format === 'string') {
		return moment(value, format);
	}

	if (!(value instanceof moment)) {
		value = moment(value);
	}

	if (value.isValid()) {
		return value;
	}

	// Labels are in an incompatible moment format and no `parser` has been provided.
	// The user might still use the deprecated `format` option to convert his inputs.
	if (typeof format === 'function') {
		return format(value);
	}

	return value;
}

function parse(input, scale) {
	if (helpers.isNullOrUndef(input)) {
		return null;
	}

	var options = scale.options.time;
	var value = momentify(scale.getRightValue(input), options);
	if (!value.isValid()) {
		return null;
	}

	if (options.round) {
		value.startOf(options.round);
	}

	return value.valueOf();
}

/**
 * Returns the number of unit to skip to be able to display up to `capacity` number of ticks
 * in `unit` for the given `min` / `max` range and respecting the interval steps constraints.
 */
function determineStepSize(min, max, unit, capacity) {
	var range = max - min;
	var interval = INTERVALS[unit];
	var milliseconds = interval.size;
	var steps = interval.steps;
	var i, ilen, factor;

	if (!steps) {
		return Math.ceil(range / ((capacity || 1) * milliseconds));
	}

	for (i = 0, ilen = steps.length; i < ilen; ++i) {
		factor = steps[i];
		if (Math.ceil(range / (milliseconds * factor)) <= capacity) {
			break;
		}
	}

	return factor;
}

/**
 * Figures out what unit results in an appropriate number of auto-generated ticks
 */
function determineUnitForAutoTicks(minUnit, min, max, capacity) {
	var ilen = UNITS.length;
	var i, interval, factor;

	for (i = UNITS.indexOf(minUnit); i < ilen - 1; ++i) {
		interval = INTERVALS[UNITS[i]];
		factor = interval.steps ? interval.steps[interval.steps.length - 1] : MAX_INTEGER;

		if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) {
			return UNITS[i];
		}
	}

	return UNITS[ilen - 1];
}

/**
 * Figures out what unit to format a set of ticks with
 */
function determineUnitForFormatting(ticks, minUnit, min, max) {
	var duration = moment.duration(moment(max).diff(moment(min)));
	var ilen = UNITS.length;
	var i, unit;

	for (i = ilen - 1; i >= UNITS.indexOf(minUnit); i--) {
		unit = UNITS[i];
		if (INTERVALS[unit].common && duration.as(unit) >= ticks.length) {
			return unit;
		}
	}

	return UNITS[minUnit ? UNITS.indexOf(minUnit) : 0];
}

function determineMajorUnit(unit) {
	for (var i = UNITS.indexOf(unit) + 1, ilen = UNITS.length; i < ilen; ++i) {
		if (INTERVALS[UNITS[i]].common) {
			return UNITS[i];
		}
	}
}

/**
 * Generates a maximum of `capacity` timestamps between min and max, rounded to the
 * `minor` unit, aligned on the `major` unit and using the given scale time `options`.
 * Important: this method can return ticks outside the min and max range, it's the
 * responsibility of the calling code to clamp values if needed.
 */
function generate(min, max, capacity, options) {
	var timeOpts = options.time;
	var minor = timeOpts.unit || determineUnitForAutoTicks(timeOpts.minUnit, min, max, capacity);
	var major = determineMajorUnit(minor);
	var stepSize = helpers.valueOrDefault(timeOpts.stepSize, timeOpts.unitStepSize);
	var weekday = minor === 'week' ? timeOpts.isoWeekday : false;
	var majorTicksEnabled = options.ticks.major.enabled;
	var interval = INTERVALS[minor];
	var first = moment(min);
	var last = moment(max);
	var ticks = [];
	var time;

	if (!stepSize) {
		stepSize = determineStepSize(min, max, minor, capacity);
	}

	// For 'week' unit, handle the first day of week option
	if (weekday) {
		first = first.isoWeekday(weekday);
		last = last.isoWeekday(weekday);
	}

	// Align first/last ticks on unit
	first = first.startOf(weekday ? 'day' : minor);
	last = last.startOf(weekday ? 'day' : minor);

	// Make sure that the last tick include max
	if (last < max) {
		last.add(1, minor);
	}

	time = moment(first);

	if (majorTicksEnabled && major && !weekday && !timeOpts.round) {
		// Align the first tick on the previous `minor` unit aligned on the `major` unit:
		// we first aligned time on the previous `major` unit then add the number of full
		// stepSize there is between first and the previous major time.
		time.startOf(major);
		time.add(~~((first - time) / (interval.size * stepSize)) * stepSize, minor);
	}

	for (; time < last; time.add(stepSize, minor)) {
		ticks.push(+time);
	}

	ticks.push(+time);

	return ticks;
}

/**
 * Returns the right and left offsets from edges in the form of {left, right}.
 * Offsets are added when the `offset` option is true.
 */
function computeOffsets(table, ticks, min, max, options) {
	var left = 0;
	var right = 0;
	var upper, lower;

	if (options.offset && ticks.length) {
		if (!options.time.min) {
			upper = ticks.length > 1 ? ticks[1] : max;
			lower = ticks[0];
			left = (
				interpolate(table, 'time', upper, 'pos') -
				interpolate(table, 'time', lower, 'pos')
			) / 2;
		}
		if (!options.time.max) {
			upper = ticks[ticks.length - 1];
			lower = ticks.length > 1 ? ticks[ticks.length - 2] : min;
			right = (
				interpolate(table, 'time', upper, 'pos') -
				interpolate(table, 'time', lower, 'pos')
			) / 2;
		}
	}

	return {left: left, right: right};
}

function ticksFromTimestamps(values, majorUnit) {
	var ticks = [];
	var i, ilen, value, major;

	for (i = 0, ilen = values.length; i < ilen; ++i) {
		value = values[i];
		major = majorUnit ? value === +moment(value).startOf(majorUnit) : false;

		ticks.push({
			value: value,
			major: major
		});
	}

	return ticks;
}

module.exports = function(Chart) {

	var defaultConfig = {
		position: 'bottom',

		/**
		 * Data distribution along the scale:
		 * - 'linear': data are spread according to their time (distances can vary),
		 * - 'series': data are spread at the same distance from each other.
		 * @see https://github.com/chartjs/Chart.js/pull/4507
		 * @since 2.7.0
		 */
		distribution: 'linear',

		/**
		 * Scale boundary strategy (bypassed by min/max time options)
		 * - `data`: make sure data are fully visible, ticks outside are removed
		 * - `ticks`: make sure ticks are fully visible, data outside are truncated
		 * @see https://github.com/chartjs/Chart.js/pull/4556
		 * @since 2.7.0
		 */
		bounds: 'data',

		time: {
			parser: false, // false == a pattern string from http://momentjs.com/docs/#/parsing/string-format/ or a custom callback that converts its argument to a moment
			format: false, // DEPRECATED false == date objects, moment object, callback or a pattern string from http://momentjs.com/docs/#/parsing/string-format/
			unit: false, // false == automatic or override with week, month, year, etc.
			round: false, // none, or override with week, month, year, etc.
			displayFormat: false, // DEPRECATED
			isoWeekday: false, // override week start day - see http://momentjs.com/docs/#/get-set/iso-weekday/
			minUnit: 'millisecond',

			// defaults to unit's corresponding unitFormat below or override using pattern string from http://momentjs.com/docs/#/displaying/format/
			displayFormats: {
				millisecond: 'h:mm:ss.SSS a', // 11:20:01.123 AM,
				second: 'h:mm:ss a', // 11:20:01 AM
				minute: 'h:mm a', // 11:20 AM
				hour: 'hA', // 5PM
				day: 'MMM D', // Sep 4
				week: 'll', // Week 46, or maybe "[W]WW - YYYY" ?
				month: 'MMM YYYY', // Sept 2015
				quarter: '[Q]Q - YYYY', // Q3
				year: 'YYYY' // 2015
			},
		},
		ticks: {
			autoSkip: false,

			/**
			 * Ticks generation input values:
			 * - 'auto': generates "optimal" ticks based on scale size and time options.
			 * - 'data': generates ticks from data (including labels from data {t|x|y} objects).
			 * - 'labels': generates ticks from user given `data.labels` values ONLY.
			 * @see https://github.com/chartjs/Chart.js/pull/4507
			 * @since 2.7.0
			 */
			source: 'auto',

			major: {
				enabled: false
			}
		}
	};

	var TimeScale = Chart.Scale.extend({
		initialize: function() {
			if (!moment) {
				throw new Error('Chart.js - Moment.js could not be found! You must include it before Chart.js to use the time scale. Download at https://momentjs.com');
			}

			this.mergeTicksOptions();

			Chart.Scale.prototype.initialize.call(this);
		},

		update: function() {
			var me = this;
			var options = me.options;

			// DEPRECATIONS: output a message only one time per update
			if (options.time && options.time.format) {
				console.warn('options.time.format is deprecated and replaced by options.time.parser.');
			}

			return Chart.Scale.prototype.update.apply(me, arguments);
		},

		/**
		 * Allows data to be referenced via 't' attribute
		 */
		getRightValue: function(rawValue) {
			if (rawValue && rawValue.t !== undefined) {
				rawValue = rawValue.t;
			}
			return Chart.Scale.prototype.getRightValue.call(this, rawValue);
		},

		determineDataLimits: function() {
			var me = this;
			var chart = me.chart;
			var timeOpts = me.options.time;
			var min = MAX_INTEGER;
			var max = MIN_INTEGER;
			var timestamps = [];
			var datasets = [];
			var labels = [];
			var i, j, ilen, jlen, data, timestamp;

			// Convert labels to timestamps
			for (i = 0, ilen = chart.data.labels.length; i < ilen; ++i) {
				labels.push(parse(chart.data.labels[i], me));
			}

			// Convert data to timestamps
			for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
				if (chart.isDatasetVisible(i)) {
					data = chart.data.datasets[i].data;

					// Let's consider that all data have the same format.
					if (helpers.isObject(data[0])) {
						datasets[i] = [];

						for (j = 0, jlen = data.length; j < jlen; ++j) {
							timestamp = parse(data[j], me);
							timestamps.push(timestamp);
							datasets[i][j] = timestamp;
						}
					} else {
						timestamps.push.apply(timestamps, labels);
						datasets[i] = labels.slice(0);
					}
				} else {
					datasets[i] = [];
				}
			}

			if (labels.length) {
				// Sort labels **after** data have been converted
				labels = arrayUnique(labels).sort(sorter);
				min = Math.min(min, labels[0]);
				max = Math.max(max, labels[labels.length - 1]);
			}

			if (timestamps.length) {
				timestamps = arrayUnique(timestamps).sort(sorter);
				min = Math.min(min, timestamps[0]);
				max = Math.max(max, timestamps[timestamps.length - 1]);
			}

			min = parse(timeOpts.min, me) || min;
			max = parse(timeOpts.max, me) || max;

			// In case there is no valid min/max, let's use today limits
			min = min === MAX_INTEGER ? +moment().startOf('day') : min;
			max = max === MIN_INTEGER ? +moment().endOf('day') + 1 : max;

			// Make sure that max is strictly higher than min (required by the lookup table)
			me.min = Math.min(min, max);
			me.max = Math.max(min + 1, max);

			// PRIVATE
			me._horizontal = me.isHorizontal();
			me._table = [];
			me._timestamps = {
				data: timestamps,
				datasets: datasets,
				labels: labels
			};
		},

		buildTicks: function() {
			var me = this;
			var min = me.min;
			var max = me.max;
			var options = me.options;
			var timeOpts = options.time;
			var timestamps = [];
			var ticks = [];
			var i, ilen, timestamp;

			switch (options.ticks.source) {
			case 'data':
				timestamps = me._timestamps.data;
				break;
			case 'labels':
				timestamps = me._timestamps.labels;
				break;
			case 'auto':
			default:
				timestamps = generate(min, max, me.getLabelCapacity(min), options);
			}

			if (options.bounds === 'ticks' && timestamps.length) {
				min = timestamps[0];
				max = timestamps[timestamps.length - 1];
			}

			// Enforce limits with user min/max options
			min = parse(timeOpts.min, me) || min;
			max = parse(timeOpts.max, me) || max;

			// Remove ticks outside the min/max range
			for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
				timestamp = timestamps[i];
				if (timestamp >= min && timestamp <= max) {
					ticks.push(timestamp);
				}
			}

			me.min = min;
			me.max = max;

			// PRIVATE
			me._unit = timeOpts.unit || determineUnitForFormatting(ticks, timeOpts.minUnit, me.min, me.max);
			me._majorUnit = determineMajorUnit(me._unit);
			me._table = buildLookupTable(me._timestamps.data, min, max, options.distribution);
			me._offsets = computeOffsets(me._table, ticks, min, max, options);

			return ticksFromTimestamps(ticks, me._majorUnit);
		},

		getLabelForIndex: function(index, datasetIndex) {
			var me = this;
			var data = me.chart.data;
			var timeOpts = me.options.time;
			var label = data.labels && index < data.labels.length ? data.labels[index] : '';
			var value = data.datasets[datasetIndex].data[index];

			if (helpers.isObject(value)) {
				label = me.getRightValue(value);
			}
			if (timeOpts.tooltipFormat) {
				label = momentify(label, timeOpts).format(timeOpts.tooltipFormat);
			}

			return label;
		},

		/**
		 * Function to format an individual tick mark
		 * @private
		 */
		tickFormatFunction: function(tick, index, ticks, formatOverride) {
			var me = this;
			var options = me.options;
			var time = tick.valueOf();
			var formats = options.time.displayFormats;
			var minorFormat = formats[me._unit];
			var majorUnit = me._majorUnit;
			var majorFormat = formats[majorUnit];
			var majorTime = tick.clone().startOf(majorUnit).valueOf();
			var majorTickOpts = options.ticks.major;
			var major = majorTickOpts.enabled && majorUnit && majorFormat && time === majorTime;
			var label = tick.format(formatOverride ? formatOverride : major ? majorFormat : minorFormat);
			var tickOpts = major ? majorTickOpts : options.ticks.minor;
			var formatter = helpers.valueOrDefault(tickOpts.callback, tickOpts.userCallback);

			return formatter ? formatter(label, index, ticks) : label;
		},

		convertTicksToLabels: function(ticks) {
			var labels = [];
			var i, ilen;

			for (i = 0, ilen = ticks.length; i < ilen; ++i) {
				labels.push(this.tickFormatFunction(moment(ticks[i].value), i, ticks));
			}

			return labels;
		},

		/**
		 * @private
		 */
		getPixelForOffset: function(time) {
			var me = this;
			var size = me._horizontal ? me.width : me.height;
			var start = me._horizontal ? me.left : me.top;
			var pos = interpolate(me._table, 'time', time, 'pos');

			return start + size * (me._offsets.left + pos) / (me._offsets.left + 1 + me._offsets.right);
		},

		getPixelForValue: function(value, index, datasetIndex) {
			var me = this;
			var time = null;

			if (index !== undefined && datasetIndex !== undefined) {
				time = me._timestamps.datasets[datasetIndex][index];
			}

			if (time === null) {
				time = parse(value, me);
			}

			if (time !== null) {
				return me.getPixelForOffset(time);
			}
		},

		getPixelForTick: function(index) {
			var ticks = this.getTicks();
			return index >= 0 && index < ticks.length ?
				this.getPixelForOffset(ticks[index].value) :
				null;
		},

		getValueForPixel: function(pixel) {
			var me = this;
			var size = me._horizontal ? me.width : me.height;
			var start = me._horizontal ? me.left : me.top;
			var pos = (size ? (pixel - start) / size : 0) * (me._offsets.left + 1 + me._offsets.left) - me._offsets.right;
			var time = interpolate(me._table, 'pos', pos, 'time');

			return moment(time);
		},

		/**
		 * Crude approximation of what the label width might be
		 * @private
		 */
		getLabelWidth: function(label) {
			var me = this;
			var ticksOpts = me.options.ticks;
			var tickLabelWidth = me.ctx.measureText(label).width;
			var angle = helpers.toRadians(ticksOpts.maxRotation);
			var cosRotation = Math.cos(angle);
			var sinRotation = Math.sin(angle);
			var tickFontSize = helpers.valueOrDefault(ticksOpts.fontSize, defaults.global.defaultFontSize);

			return (tickLabelWidth * cosRotation) + (tickFontSize * sinRotation);
		},

		/**
		 * @private
		 */
		getLabelCapacity: function(exampleTime) {
			var me = this;

			var formatOverride = me.options.time.displayFormats.millisecond;	// Pick the longest format for guestimation

			var exampleLabel = me.tickFormatFunction(moment(exampleTime), 0, [], formatOverride);
			var tickLabelWidth = me.getLabelWidth(exampleLabel);
			var innerWidth = me.isHorizontal() ? me.width : me.height;

			return Math.floor(innerWidth / tickLabelWidth);
		}
	});

	Chart.scaleService.registerScaleType('time', TimeScale, defaultConfig);
};


/***/ }),

/***/ 2669:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 1463,
	"./af.js": 1463,
	"./ar": 1464,
	"./ar-dz": 1465,
	"./ar-dz.js": 1465,
	"./ar-kw": 1466,
	"./ar-kw.js": 1466,
	"./ar-ly": 1467,
	"./ar-ly.js": 1467,
	"./ar-ma": 1468,
	"./ar-ma.js": 1468,
	"./ar-sa": 1469,
	"./ar-sa.js": 1469,
	"./ar-tn": 1470,
	"./ar-tn.js": 1470,
	"./ar.js": 1464,
	"./az": 1471,
	"./az.js": 1471,
	"./be": 1472,
	"./be.js": 1472,
	"./bg": 1473,
	"./bg.js": 1473,
	"./bn": 1474,
	"./bn.js": 1474,
	"./bo": 1475,
	"./bo.js": 1475,
	"./br": 1476,
	"./br.js": 1476,
	"./bs": 1477,
	"./bs.js": 1477,
	"./ca": 1478,
	"./ca.js": 1478,
	"./cs": 1479,
	"./cs.js": 1479,
	"./cv": 1480,
	"./cv.js": 1480,
	"./cy": 1481,
	"./cy.js": 1481,
	"./da": 1482,
	"./da.js": 1482,
	"./de": 1483,
	"./de-at": 1484,
	"./de-at.js": 1484,
	"./de-ch": 1485,
	"./de-ch.js": 1485,
	"./de.js": 1483,
	"./dv": 1486,
	"./dv.js": 1486,
	"./el": 1487,
	"./el.js": 1487,
	"./en-au": 1488,
	"./en-au.js": 1488,
	"./en-ca": 1489,
	"./en-ca.js": 1489,
	"./en-gb": 1490,
	"./en-gb.js": 1490,
	"./en-ie": 1491,
	"./en-ie.js": 1491,
	"./en-nz": 1492,
	"./en-nz.js": 1492,
	"./eo": 1493,
	"./eo.js": 1493,
	"./es": 1494,
	"./es-do": 1495,
	"./es-do.js": 1495,
	"./es.js": 1494,
	"./et": 1496,
	"./et.js": 1496,
	"./eu": 1497,
	"./eu.js": 1497,
	"./fa": 1498,
	"./fa.js": 1498,
	"./fi": 1499,
	"./fi.js": 1499,
	"./fo": 1500,
	"./fo.js": 1500,
	"./fr": 1501,
	"./fr-ca": 1502,
	"./fr-ca.js": 1502,
	"./fr-ch": 1503,
	"./fr-ch.js": 1503,
	"./fr.js": 1501,
	"./fy": 1504,
	"./fy.js": 1504,
	"./gd": 1505,
	"./gd.js": 1505,
	"./gl": 1506,
	"./gl.js": 1506,
	"./gom-latn": 1507,
	"./gom-latn.js": 1507,
	"./he": 1508,
	"./he.js": 1508,
	"./hi": 1509,
	"./hi.js": 1509,
	"./hr": 1510,
	"./hr.js": 1510,
	"./hu": 1511,
	"./hu.js": 1511,
	"./hy-am": 1512,
	"./hy-am.js": 1512,
	"./id": 1513,
	"./id.js": 1513,
	"./is": 1514,
	"./is.js": 1514,
	"./it": 1515,
	"./it.js": 1515,
	"./ja": 1516,
	"./ja.js": 1516,
	"./jv": 1517,
	"./jv.js": 1517,
	"./ka": 1518,
	"./ka.js": 1518,
	"./kk": 1519,
	"./kk.js": 1519,
	"./km": 1520,
	"./km.js": 1520,
	"./kn": 1521,
	"./kn.js": 1521,
	"./ko": 1522,
	"./ko.js": 1522,
	"./ky": 1523,
	"./ky.js": 1523,
	"./lb": 1524,
	"./lb.js": 1524,
	"./lo": 1525,
	"./lo.js": 1525,
	"./lt": 1526,
	"./lt.js": 1526,
	"./lv": 1527,
	"./lv.js": 1527,
	"./me": 1528,
	"./me.js": 1528,
	"./mi": 1529,
	"./mi.js": 1529,
	"./mk": 1530,
	"./mk.js": 1530,
	"./ml": 1531,
	"./ml.js": 1531,
	"./mr": 1532,
	"./mr.js": 1532,
	"./ms": 1533,
	"./ms-my": 1534,
	"./ms-my.js": 1534,
	"./ms.js": 1533,
	"./my": 1535,
	"./my.js": 1535,
	"./nb": 1536,
	"./nb.js": 1536,
	"./ne": 1537,
	"./ne.js": 1537,
	"./nl": 1538,
	"./nl-be": 1539,
	"./nl-be.js": 1539,
	"./nl.js": 1538,
	"./nn": 1540,
	"./nn.js": 1540,
	"./pa-in": 1541,
	"./pa-in.js": 1541,
	"./pl": 1542,
	"./pl.js": 1542,
	"./pt": 1543,
	"./pt-br": 1544,
	"./pt-br.js": 1544,
	"./pt.js": 1543,
	"./ro": 1545,
	"./ro.js": 1545,
	"./ru": 1546,
	"./ru.js": 1546,
	"./sd": 1547,
	"./sd.js": 1547,
	"./se": 1548,
	"./se.js": 1548,
	"./si": 1549,
	"./si.js": 1549,
	"./sk": 1550,
	"./sk.js": 1550,
	"./sl": 1551,
	"./sl.js": 1551,
	"./sq": 1552,
	"./sq.js": 1552,
	"./sr": 1553,
	"./sr-cyrl": 1554,
	"./sr-cyrl.js": 1554,
	"./sr.js": 1553,
	"./ss": 1555,
	"./ss.js": 1555,
	"./sv": 1556,
	"./sv.js": 1556,
	"./sw": 1557,
	"./sw.js": 1557,
	"./ta": 1558,
	"./ta.js": 1558,
	"./te": 1559,
	"./te.js": 1559,
	"./tet": 1560,
	"./tet.js": 1560,
	"./th": 1561,
	"./th.js": 1561,
	"./tl-ph": 1562,
	"./tl-ph.js": 1562,
	"./tlh": 1563,
	"./tlh.js": 1563,
	"./tr": 1564,
	"./tr.js": 1564,
	"./tzl": 1565,
	"./tzl.js": 1565,
	"./tzm": 1566,
	"./tzm-latn": 1567,
	"./tzm-latn.js": 1567,
	"./tzm.js": 1566,
	"./uk": 1568,
	"./uk.js": 1568,
	"./ur": 1569,
	"./ur.js": 1569,
	"./uz": 1570,
	"./uz-latn": 1571,
	"./uz-latn.js": 1571,
	"./uz.js": 1570,
	"./vi": 1572,
	"./vi.js": 1572,
	"./x-pseudo": 1573,
	"./x-pseudo.js": 1573,
	"./yo": 1574,
	"./yo.js": 1574,
	"./zh-cn": 1575,
	"./zh-cn.js": 1575,
	"./zh-hk": 1576,
	"./zh-hk.js": 1576,
	"./zh-tw": 1577,
	"./zh-tw.js": 1577
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2669;

/***/ }),

/***/ 2670:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(796);
var elements = __webpack_require__(871);
var helpers = __webpack_require__(789);

defaults._set('bar', {
	hover: {
		mode: 'label'
	},

	scales: {
		xAxes: [{
			type: 'category',

			// Specific to Bar Controller
			categoryPercentage: 0.8,
			barPercentage: 0.9,

			// offset settings
			offset: true,

			// grid line settings
			gridLines: {
				offsetGridLines: true
			}
		}],

		yAxes: [{
			type: 'linear'
		}]
	}
});

defaults._set('horizontalBar', {
	hover: {
		mode: 'index',
		axis: 'y'
	},

	scales: {
		xAxes: [{
			type: 'linear',
			position: 'bottom'
		}],

		yAxes: [{
			position: 'left',
			type: 'category',

			// Specific to Horizontal Bar Controller
			categoryPercentage: 0.8,
			barPercentage: 0.9,

			// offset settings
			offset: true,

			// grid line settings
			gridLines: {
				offsetGridLines: true
			}
		}]
	},

	elements: {
		rectangle: {
			borderSkipped: 'left'
		}
	},

	tooltips: {
		callbacks: {
			title: function(item, data) {
				// Pick first xLabel for now
				var title = '';

				if (item.length > 0) {
					if (item[0].yLabel) {
						title = item[0].yLabel;
					} else if (data.labels.length > 0 && item[0].index < data.labels.length) {
						title = data.labels[item[0].index];
					}
				}

				return title;
			},

			label: function(item, data) {
				var datasetLabel = data.datasets[item.datasetIndex].label || '';
				return datasetLabel + ': ' + item.xLabel;
			}
		},
		mode: 'index',
		axis: 'y'
	}
});

module.exports = function(Chart) {

	Chart.controllers.bar = Chart.DatasetController.extend({

		dataElementType: elements.Rectangle,

		initialize: function() {
			var me = this;
			var meta;

			Chart.DatasetController.prototype.initialize.apply(me, arguments);

			meta = me.getMeta();
			meta.stack = me.getDataset().stack;
			meta.bar = true;
		},

		update: function(reset) {
			var me = this;
			var rects = me.getMeta().data;
			var i, ilen;

			me._ruler = me.getRuler();

			for (i = 0, ilen = rects.length; i < ilen; ++i) {
				me.updateElement(rects[i], i, reset);
			}
		},

		updateElement: function(rectangle, index, reset) {
			var me = this;
			var chart = me.chart;
			var meta = me.getMeta();
			var dataset = me.getDataset();
			var custom = rectangle.custom || {};
			var rectangleOptions = chart.options.elements.rectangle;

			rectangle._xScale = me.getScaleForId(meta.xAxisID);
			rectangle._yScale = me.getScaleForId(meta.yAxisID);
			rectangle._datasetIndex = me.index;
			rectangle._index = index;

			rectangle._model = {
				datasetLabel: dataset.label,
				label: chart.data.labels[index],
				borderSkipped: custom.borderSkipped ? custom.borderSkipped : rectangleOptions.borderSkipped,
				backgroundColor: custom.backgroundColor ? custom.backgroundColor : helpers.valueAtIndexOrDefault(dataset.backgroundColor, index, rectangleOptions.backgroundColor),
				borderColor: custom.borderColor ? custom.borderColor : helpers.valueAtIndexOrDefault(dataset.borderColor, index, rectangleOptions.borderColor),
				borderWidth: custom.borderWidth ? custom.borderWidth : helpers.valueAtIndexOrDefault(dataset.borderWidth, index, rectangleOptions.borderWidth)
			};

			me.updateElementGeometry(rectangle, index, reset);

			rectangle.pivot();
		},

		/**
		 * @private
		 */
		updateElementGeometry: function(rectangle, index, reset) {
			var me = this;
			var model = rectangle._model;
			var vscale = me.getValueScale();
			var base = vscale.getBasePixel();
			var horizontal = vscale.isHorizontal();
			var ruler = me._ruler || me.getRuler();
			var vpixels = me.calculateBarValuePixels(me.index, index);
			var ipixels = me.calculateBarIndexPixels(me.index, index, ruler);

			model.horizontal = horizontal;
			model.base = reset ? base : vpixels.base;
			model.x = horizontal ? reset ? base : vpixels.head : ipixels.center;
			model.y = horizontal ? ipixels.center : reset ? base : vpixels.head;
			model.height = horizontal ? ipixels.size : undefined;
			model.width = horizontal ? undefined : ipixels.size;
		},

		/**
		 * @private
		 */
		getValueScaleId: function() {
			return this.getMeta().yAxisID;
		},

		/**
		 * @private
		 */
		getIndexScaleId: function() {
			return this.getMeta().xAxisID;
		},

		/**
		 * @private
		 */
		getValueScale: function() {
			return this.getScaleForId(this.getValueScaleId());
		},

		/**
		 * @private
		 */
		getIndexScale: function() {
			return this.getScaleForId(this.getIndexScaleId());
		},

		/**
		 * Returns the effective number of stacks based on groups and bar visibility.
		 * @private
		 */
		getStackCount: function(last) {
			var me = this;
			var chart = me.chart;
			var scale = me.getIndexScale();
			var stacked = scale.options.stacked;
			var ilen = last === undefined ? chart.data.datasets.length : last + 1;
			var stacks = [];
			var i, meta;

			for (i = 0; i < ilen; ++i) {
				meta = chart.getDatasetMeta(i);
				if (meta.bar && chart.isDatasetVisible(i) &&
					(stacked === false ||
					(stacked === true && stacks.indexOf(meta.stack) === -1) ||
					(stacked === undefined && (meta.stack === undefined || stacks.indexOf(meta.stack) === -1)))) {
					stacks.push(meta.stack);
				}
			}

			return stacks.length;
		},

		/**
		 * Returns the stack index for the given dataset based on groups and bar visibility.
		 * @private
		 */
		getStackIndex: function(datasetIndex) {
			return this.getStackCount(datasetIndex) - 1;
		},

		/**
		 * @private
		 */
		getRuler: function() {
			var me = this;
			var scale = me.getIndexScale();
			var stackCount = me.getStackCount();
			var datasetIndex = me.index;
			var pixels = [];
			var isHorizontal = scale.isHorizontal();
			var start = isHorizontal ? scale.left : scale.top;
			var end = start + (isHorizontal ? scale.width : scale.height);
			var i, ilen;

			for (i = 0, ilen = me.getMeta().data.length; i < ilen; ++i) {
				pixels.push(scale.getPixelForValue(null, i, datasetIndex));
			}

			return {
				pixels: pixels,
				start: start,
				end: end,
				stackCount: stackCount,
				scale: scale
			};
		},

		/**
		 * Note: pixel values are not clamped to the scale area.
		 * @private
		 */
		calculateBarValuePixels: function(datasetIndex, index) {
			var me = this;
			var chart = me.chart;
			var meta = me.getMeta();
			var scale = me.getValueScale();
			var datasets = chart.data.datasets;
			var value = scale.getRightValue(datasets[datasetIndex].data[index]);
			var stacked = scale.options.stacked;
			var stack = meta.stack;
			var start = 0;
			var i, imeta, ivalue, base, head, size;

			if (stacked || (stacked === undefined && stack !== undefined)) {
				for (i = 0; i < datasetIndex; ++i) {
					imeta = chart.getDatasetMeta(i);

					if (imeta.bar &&
						imeta.stack === stack &&
						imeta.controller.getValueScaleId() === scale.id &&
						chart.isDatasetVisible(i)) {

						ivalue = scale.getRightValue(datasets[i].data[index]);
						if ((value < 0 && ivalue < 0) || (value >= 0 && ivalue > 0)) {
							start += ivalue;
						}
					}
				}
			}

			base = scale.getPixelForValue(start);
			head = scale.getPixelForValue(start + value);
			size = (head - base) / 2;

			return {
				size: size,
				base: base,
				head: head,
				center: head + size / 2
			};
		},

		/**
		 * @private
		 */
		calculateBarIndexPixels: function(datasetIndex, index, ruler) {
			var me = this;
			var options = ruler.scale.options;
			var stackIndex = me.getStackIndex(datasetIndex);
			var pixels = ruler.pixels;
			var base = pixels[index];
			var length = pixels.length;
			var start = ruler.start;
			var end = ruler.end;
			var leftSampleSize, rightSampleSize, leftCategorySize, rightCategorySize, fullBarSize, size;

			if (length === 1) {
				leftSampleSize = base > start ? base - start : end - base;
				rightSampleSize = base < end ? end - base : base - start;
			} else {
				if (index > 0) {
					leftSampleSize = (base - pixels[index - 1]) / 2;
					if (index === length - 1) {
						rightSampleSize = leftSampleSize;
					}
				}
				if (index < length - 1) {
					rightSampleSize = (pixels[index + 1] - base) / 2;
					if (index === 0) {
						leftSampleSize = rightSampleSize;
					}
				}
			}

			leftCategorySize = leftSampleSize * options.categoryPercentage;
			rightCategorySize = rightSampleSize * options.categoryPercentage;
			fullBarSize = (leftCategorySize + rightCategorySize) / ruler.stackCount;
			size = fullBarSize * options.barPercentage;

			size = Math.min(
				helpers.valueOrDefault(options.barThickness, size),
				helpers.valueOrDefault(options.maxBarThickness, Infinity));

			base -= leftCategorySize;
			base += fullBarSize * stackIndex;
			base += (fullBarSize - size) / 2;

			return {
				size: size,
				base: base,
				head: base + size,
				center: base + size / 2
			};
		},

		draw: function() {
			var me = this;
			var chart = me.chart;
			var scale = me.getValueScale();
			var rects = me.getMeta().data;
			var dataset = me.getDataset();
			var ilen = rects.length;
			var i = 0;

			helpers.canvas.clipArea(chart.ctx, chart.chartArea);

			for (; i < ilen; ++i) {
				if (!isNaN(scale.getRightValue(dataset.data[i]))) {
					rects[i].draw();
				}
			}

			helpers.canvas.unclipArea(chart.ctx);
		},

		setHoverStyle: function(rectangle) {
			var dataset = this.chart.data.datasets[rectangle._datasetIndex];
			var index = rectangle._index;
			var custom = rectangle.custom || {};
			var model = rectangle._model;

			model.backgroundColor = custom.hoverBackgroundColor ? custom.hoverBackgroundColor : helpers.valueAtIndexOrDefault(dataset.hoverBackgroundColor, index, helpers.getHoverColor(model.backgroundColor));
			model.borderColor = custom.hoverBorderColor ? custom.hoverBorderColor : helpers.valueAtIndexOrDefault(dataset.hoverBorderColor, index, helpers.getHoverColor(model.borderColor));
			model.borderWidth = custom.hoverBorderWidth ? custom.hoverBorderWidth : helpers.valueAtIndexOrDefault(dataset.hoverBorderWidth, index, model.borderWidth);
		},

		removeHoverStyle: function(rectangle) {
			var dataset = this.chart.data.datasets[rectangle._datasetIndex];
			var index = rectangle._index;
			var custom = rectangle.custom || {};
			var model = rectangle._model;
			var rectangleElementOptions = this.chart.options.elements.rectangle;

			model.backgroundColor = custom.backgroundColor ? custom.backgroundColor : helpers.valueAtIndexOrDefault(dataset.backgroundColor, index, rectangleElementOptions.backgroundColor);
			model.borderColor = custom.borderColor ? custom.borderColor : helpers.valueAtIndexOrDefault(dataset.borderColor, index, rectangleElementOptions.borderColor);
			model.borderWidth = custom.borderWidth ? custom.borderWidth : helpers.valueAtIndexOrDefault(dataset.borderWidth, index, rectangleElementOptions.borderWidth);
		}
	});

	Chart.controllers.horizontalBar = Chart.controllers.bar.extend({
		/**
		 * @private
		 */
		getValueScaleId: function() {
			return this.getMeta().xAxisID;
		},

		/**
		 * @private
		 */
		getIndexScaleId: function() {
			return this.getMeta().yAxisID;
		}
	});
};


/***/ }),

/***/ 2671:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(796);
var elements = __webpack_require__(871);
var helpers = __webpack_require__(789);

defaults._set('bubble', {
	hover: {
		mode: 'single'
	},

	scales: {
		xAxes: [{
			type: 'linear', // bubble should probably use a linear scale by default
			position: 'bottom',
			id: 'x-axis-0' // need an ID so datasets can reference the scale
		}],
		yAxes: [{
			type: 'linear',
			position: 'left',
			id: 'y-axis-0'
		}]
	},

	tooltips: {
		callbacks: {
			title: function() {
				// Title doesn't make sense for scatter since we format the data as a point
				return '';
			},
			label: function(item, data) {
				var datasetLabel = data.datasets[item.datasetIndex].label || '';
				var dataPoint = data.datasets[item.datasetIndex].data[item.index];
				return datasetLabel + ': (' + item.xLabel + ', ' + item.yLabel + ', ' + dataPoint.r + ')';
			}
		}
	}
});


module.exports = function(Chart) {

	Chart.controllers.bubble = Chart.DatasetController.extend({
		/**
		 * @protected
		 */
		dataElementType: elements.Point,

		/**
		 * @protected
		 */
		update: function(reset) {
			var me = this;
			var meta = me.getMeta();
			var points = meta.data;

			// Update Points
			helpers.each(points, function(point, index) {
				me.updateElement(point, index, reset);
			});
		},

		/**
		 * @protected
		 */
		updateElement: function(point, index, reset) {
			var me = this;
			var meta = me.getMeta();
			var custom = point.custom || {};
			var xScale = me.getScaleForId(meta.xAxisID);
			var yScale = me.getScaleForId(meta.yAxisID);
			var options = me._resolveElementOptions(point, index);
			var data = me.getDataset().data[index];
			var dsIndex = me.index;

			var x = reset ? xScale.getPixelForDecimal(0.5) : xScale.getPixelForValue(typeof data === 'object' ? data : NaN, index, dsIndex);
			var y = reset ? yScale.getBasePixel() : yScale.getPixelForValue(data, index, dsIndex);

			point._xScale = xScale;
			point._yScale = yScale;
			point._options = options;
			point._datasetIndex = dsIndex;
			point._index = index;
			point._model = {
				backgroundColor: options.backgroundColor,
				borderColor: options.borderColor,
				borderWidth: options.borderWidth,
				hitRadius: options.hitRadius,
				pointStyle: options.pointStyle,
				radius: reset ? 0 : options.radius,
				skip: custom.skip || isNaN(x) || isNaN(y),
				x: x,
				y: y,
			};

			point.pivot();
		},

		/**
		 * @protected
		 */
		setHoverStyle: function(point) {
			var model = point._model;
			var options = point._options;

			model.backgroundColor = helpers.valueOrDefault(options.hoverBackgroundColor, helpers.getHoverColor(options.backgroundColor));
			model.borderColor = helpers.valueOrDefault(options.hoverBorderColor, helpers.getHoverColor(options.borderColor));
			model.borderWidth = helpers.valueOrDefault(options.hoverBorderWidth, options.borderWidth);
			model.radius = options.radius + options.hoverRadius;
		},

		/**
		 * @protected
		 */
		removeHoverStyle: function(point) {
			var model = point._model;
			var options = point._options;

			model.backgroundColor = options.backgroundColor;
			model.borderColor = options.borderColor;
			model.borderWidth = options.borderWidth;
			model.radius = options.radius;
		},

		/**
		 * @private
		 */
		_resolveElementOptions: function(point, index) {
			var me = this;
			var chart = me.chart;
			var datasets = chart.data.datasets;
			var dataset = datasets[me.index];
			var custom = point.custom || {};
			var options = chart.options.elements.point;
			var resolve = helpers.options.resolve;
			var data = dataset.data[index];
			var values = {};
			var i, ilen, key;

			// Scriptable options
			var context = {
				chart: chart,
				dataIndex: index,
				dataset: dataset,
				datasetIndex: me.index
			};

			var keys = [
				'backgroundColor',
				'borderColor',
				'borderWidth',
				'hoverBackgroundColor',
				'hoverBorderColor',
				'hoverBorderWidth',
				'hoverRadius',
				'hitRadius',
				'pointStyle'
			];

			for (i = 0, ilen = keys.length; i < ilen; ++i) {
				key = keys[i];
				values[key] = resolve([
					custom[key],
					dataset[key],
					options[key]
				], context, index);
			}

			// Custom radius resolution
			values.radius = resolve([
				custom.radius,
				data ? data.r : undefined,
				dataset.radius,
				options.radius
			], context, index);

			return values;
		}
	});
};


/***/ }),

/***/ 2672:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(796);
var elements = __webpack_require__(871);
var helpers = __webpack_require__(789);

defaults._set('doughnut', {
	animation: {
		// Boolean - Whether we animate the rotation of the Doughnut
		animateRotate: true,
		// Boolean - Whether we animate scaling the Doughnut from the centre
		animateScale: false
	},
	hover: {
		mode: 'single'
	},
	legendCallback: function(chart) {
		var text = [];
		text.push('<ul class="' + chart.id + '-legend">');

		var data = chart.data;
		var datasets = data.datasets;
		var labels = data.labels;

		if (datasets.length) {
			for (var i = 0; i < datasets[0].data.length; ++i) {
				text.push('<li><span style="background-color:' + datasets[0].backgroundColor[i] + '"></span>');
				if (labels[i]) {
					text.push(labels[i]);
				}
				text.push('</li>');
			}
		}

		text.push('</ul>');
		return text.join('');
	},
	legend: {
		labels: {
			generateLabels: function(chart) {
				var data = chart.data;
				if (data.labels.length && data.datasets.length) {
					return data.labels.map(function(label, i) {
						var meta = chart.getDatasetMeta(0);
						var ds = data.datasets[0];
						var arc = meta.data[i];
						var custom = arc && arc.custom || {};
						var valueAtIndexOrDefault = helpers.valueAtIndexOrDefault;
						var arcOpts = chart.options.elements.arc;
						var fill = custom.backgroundColor ? custom.backgroundColor : valueAtIndexOrDefault(ds.backgroundColor, i, arcOpts.backgroundColor);
						var stroke = custom.borderColor ? custom.borderColor : valueAtIndexOrDefault(ds.borderColor, i, arcOpts.borderColor);
						var bw = custom.borderWidth ? custom.borderWidth : valueAtIndexOrDefault(ds.borderWidth, i, arcOpts.borderWidth);

						return {
							text: label,
							fillStyle: fill,
							strokeStyle: stroke,
							lineWidth: bw,
							hidden: isNaN(ds.data[i]) || meta.data[i].hidden,

							// Extra data used for toggling the correct item
							index: i
						};
					});
				}
				return [];
			}
		},

		onClick: function(e, legendItem) {
			var index = legendItem.index;
			var chart = this.chart;
			var i, ilen, meta;

			for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
				meta = chart.getDatasetMeta(i);
				// toggle visibility of index if exists
				if (meta.data[index]) {
					meta.data[index].hidden = !meta.data[index].hidden;
				}
			}

			chart.update();
		}
	},

	// The percentage of the chart that we cut out of the middle.
	cutoutPercentage: 50,

	// The rotation of the chart, where the first data arc begins.
	rotation: Math.PI * -0.5,

	// The total circumference of the chart.
	circumference: Math.PI * 2.0,

	// Need to override these to give a nice default
	tooltips: {
		callbacks: {
			title: function() {
				return '';
			},
			label: function(tooltipItem, data) {
				var dataLabel = data.labels[tooltipItem.index];
				var value = ': ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];

				if (helpers.isArray(dataLabel)) {
					// show value on first line of multiline label
					// need to clone because we are changing the value
					dataLabel = dataLabel.slice();
					dataLabel[0] += value;
				} else {
					dataLabel += value;
				}

				return dataLabel;
			}
		}
	}
});

defaults._set('pie', helpers.clone(defaults.doughnut));
defaults._set('pie', {
	cutoutPercentage: 0
});

module.exports = function(Chart) {

	Chart.controllers.doughnut = Chart.controllers.pie = Chart.DatasetController.extend({

		dataElementType: elements.Arc,

		linkScales: helpers.noop,

		// Get index of the dataset in relation to the visible datasets. This allows determining the inner and outer radius correctly
		getRingIndex: function(datasetIndex) {
			var ringIndex = 0;

			for (var j = 0; j < datasetIndex; ++j) {
				if (this.chart.isDatasetVisible(j)) {
					++ringIndex;
				}
			}

			return ringIndex;
		},

		update: function(reset) {
			var me = this;
			var chart = me.chart;
			var chartArea = chart.chartArea;
			var opts = chart.options;
			var arcOpts = opts.elements.arc;
			var availableWidth = chartArea.right - chartArea.left - arcOpts.borderWidth;
			var availableHeight = chartArea.bottom - chartArea.top - arcOpts.borderWidth;
			var minSize = Math.min(availableWidth, availableHeight);
			var offset = {x: 0, y: 0};
			var meta = me.getMeta();
			var cutoutPercentage = opts.cutoutPercentage;
			var circumference = opts.circumference;

			// If the chart's circumference isn't a full circle, calculate minSize as a ratio of the width/height of the arc
			if (circumference < Math.PI * 2.0) {
				var startAngle = opts.rotation % (Math.PI * 2.0);
				startAngle += Math.PI * 2.0 * (startAngle >= Math.PI ? -1 : startAngle < -Math.PI ? 1 : 0);
				var endAngle = startAngle + circumference;
				var start = {x: Math.cos(startAngle), y: Math.sin(startAngle)};
				var end = {x: Math.cos(endAngle), y: Math.sin(endAngle)};
				var contains0 = (startAngle <= 0 && endAngle >= 0) || (startAngle <= Math.PI * 2.0 && Math.PI * 2.0 <= endAngle);
				var contains90 = (startAngle <= Math.PI * 0.5 && Math.PI * 0.5 <= endAngle) || (startAngle <= Math.PI * 2.5 && Math.PI * 2.5 <= endAngle);
				var contains180 = (startAngle <= -Math.PI && -Math.PI <= endAngle) || (startAngle <= Math.PI && Math.PI <= endAngle);
				var contains270 = (startAngle <= -Math.PI * 0.5 && -Math.PI * 0.5 <= endAngle) || (startAngle <= Math.PI * 1.5 && Math.PI * 1.5 <= endAngle);
				var cutout = cutoutPercentage / 100.0;
				var min = {x: contains180 ? -1 : Math.min(start.x * (start.x < 0 ? 1 : cutout), end.x * (end.x < 0 ? 1 : cutout)), y: contains270 ? -1 : Math.min(start.y * (start.y < 0 ? 1 : cutout), end.y * (end.y < 0 ? 1 : cutout))};
				var max = {x: contains0 ? 1 : Math.max(start.x * (start.x > 0 ? 1 : cutout), end.x * (end.x > 0 ? 1 : cutout)), y: contains90 ? 1 : Math.max(start.y * (start.y > 0 ? 1 : cutout), end.y * (end.y > 0 ? 1 : cutout))};
				var size = {width: (max.x - min.x) * 0.5, height: (max.y - min.y) * 0.5};
				minSize = Math.min(availableWidth / size.width, availableHeight / size.height);
				offset = {x: (max.x + min.x) * -0.5, y: (max.y + min.y) * -0.5};
			}

			chart.borderWidth = me.getMaxBorderWidth(meta.data);
			chart.outerRadius = Math.max((minSize - chart.borderWidth) / 2, 0);
			chart.innerRadius = Math.max(cutoutPercentage ? (chart.outerRadius / 100) * (cutoutPercentage) : 0, 0);
			chart.radiusLength = (chart.outerRadius - chart.innerRadius) / chart.getVisibleDatasetCount();
			chart.offsetX = offset.x * chart.outerRadius;
			chart.offsetY = offset.y * chart.outerRadius;

			meta.total = me.calculateTotal();

			me.outerRadius = chart.outerRadius - (chart.radiusLength * me.getRingIndex(me.index));
			me.innerRadius = Math.max(me.outerRadius - chart.radiusLength, 0);

			helpers.each(meta.data, function(arc, index) {
				me.updateElement(arc, index, reset);
			});
		},

		updateElement: function(arc, index, reset) {
			var me = this;
			var chart = me.chart;
			var chartArea = chart.chartArea;
			var opts = chart.options;
			var animationOpts = opts.animation;
			var centerX = (chartArea.left + chartArea.right) / 2;
			var centerY = (chartArea.top + chartArea.bottom) / 2;
			var startAngle = opts.rotation; // non reset case handled later
			var endAngle = opts.rotation; // non reset case handled later
			var dataset = me.getDataset();
			var circumference = reset && animationOpts.animateRotate ? 0 : arc.hidden ? 0 : me.calculateCircumference(dataset.data[index]) * (opts.circumference / (2.0 * Math.PI));
			var innerRadius = reset && animationOpts.animateScale ? 0 : me.innerRadius;
			var outerRadius = reset && animationOpts.animateScale ? 0 : me.outerRadius;
			var valueAtIndexOrDefault = helpers.valueAtIndexOrDefault;

			helpers.extend(arc, {
				// Utility
				_datasetIndex: me.index,
				_index: index,

				// Desired view properties
				_model: {
					x: centerX + chart.offsetX,
					y: centerY + chart.offsetY,
					startAngle: startAngle,
					endAngle: endAngle,
					circumference: circumference,
					outerRadius: outerRadius,
					innerRadius: innerRadius,
					label: valueAtIndexOrDefault(dataset.label, index, chart.data.labels[index])
				}
			});

			var model = arc._model;
			// Resets the visual styles
			this.removeHoverStyle(arc);

			// Set correct angles if not resetting
			if (!reset || !animationOpts.animateRotate) {
				if (index === 0) {
					model.startAngle = opts.rotation;
				} else {
					model.startAngle = me.getMeta().data[index - 1]._model.endAngle;
				}

				model.endAngle = model.startAngle + model.circumference;
			}

			arc.pivot();
		},

		removeHoverStyle: function(arc) {
			Chart.DatasetController.prototype.removeHoverStyle.call(this, arc, this.chart.options.elements.arc);
		},

		calculateTotal: function() {
			var dataset = this.getDataset();
			var meta = this.getMeta();
			var total = 0;
			var value;

			helpers.each(meta.data, function(element, index) {
				value = dataset.data[index];
				if (!isNaN(value) && !element.hidden) {
					total += Math.abs(value);
				}
			});

			/* if (total === 0) {
				total = NaN;
			}*/

			return total;
		},

		calculateCircumference: function(value) {
			var total = this.getMeta().total;
			if (total > 0 && !isNaN(value)) {
				return (Math.PI * 2.0) * (value / total);
			}
			return 0;
		},

		// gets the max border or hover width to properly scale pie charts
		getMaxBorderWidth: function(arcs) {
			var max = 0;
			var index = this.index;
			var length = arcs.length;
			var borderWidth;
			var hoverWidth;

			for (var i = 0; i < length; i++) {
				borderWidth = arcs[i]._model ? arcs[i]._model.borderWidth : 0;
				hoverWidth = arcs[i]._chart ? arcs[i]._chart.config.data.datasets[index].hoverBorderWidth : 0;

				max = borderWidth > max ? borderWidth : max;
				max = hoverWidth > max ? hoverWidth : max;
			}
			return max;
		}
	});
};


/***/ }),

/***/ 2673:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(796);
var elements = __webpack_require__(871);
var helpers = __webpack_require__(789);

defaults._set('line', {
	showLines: true,
	spanGaps: false,

	hover: {
		mode: 'label'
	},

	scales: {
		xAxes: [{
			type: 'category',
			id: 'x-axis-0'
		}],
		yAxes: [{
			type: 'linear',
			id: 'y-axis-0'
		}]
	}
});

module.exports = function(Chart) {

	function lineEnabled(dataset, options) {
		return helpers.valueOrDefault(dataset.showLine, options.showLines);
	}

	Chart.controllers.line = Chart.DatasetController.extend({

		datasetElementType: elements.Line,

		dataElementType: elements.Point,

		update: function(reset) {
			var me = this;
			var meta = me.getMeta();
			var line = meta.dataset;
			var points = meta.data || [];
			var options = me.chart.options;
			var lineElementOptions = options.elements.line;
			var scale = me.getScaleForId(meta.yAxisID);
			var i, ilen, custom;
			var dataset = me.getDataset();
			var showLine = lineEnabled(dataset, options);

			// Update Line
			if (showLine) {
				custom = line.custom || {};

				// Compatibility: If the properties are defined with only the old name, use those values
				if ((dataset.tension !== undefined) && (dataset.lineTension === undefined)) {
					dataset.lineTension = dataset.tension;
				}

				// Utility
				line._scale = scale;
				line._datasetIndex = me.index;
				// Data
				line._children = points;
				// Model
				line._model = {
					// Appearance
					// The default behavior of lines is to break at null values, according
					// to https://github.com/chartjs/Chart.js/issues/2435#issuecomment-216718158
					// This option gives lines the ability to span gaps
					spanGaps: dataset.spanGaps ? dataset.spanGaps : options.spanGaps,
					tension: custom.tension ? custom.tension : helpers.valueOrDefault(dataset.lineTension, lineElementOptions.tension),
					backgroundColor: custom.backgroundColor ? custom.backgroundColor : (dataset.backgroundColor || lineElementOptions.backgroundColor),
					borderWidth: custom.borderWidth ? custom.borderWidth : (dataset.borderWidth || lineElementOptions.borderWidth),
					borderColor: custom.borderColor ? custom.borderColor : (dataset.borderColor || lineElementOptions.borderColor),
					borderCapStyle: custom.borderCapStyle ? custom.borderCapStyle : (dataset.borderCapStyle || lineElementOptions.borderCapStyle),
					borderDash: custom.borderDash ? custom.borderDash : (dataset.borderDash || lineElementOptions.borderDash),
					borderDashOffset: custom.borderDashOffset ? custom.borderDashOffset : (dataset.borderDashOffset || lineElementOptions.borderDashOffset),
					borderJoinStyle: custom.borderJoinStyle ? custom.borderJoinStyle : (dataset.borderJoinStyle || lineElementOptions.borderJoinStyle),
					fill: custom.fill ? custom.fill : (dataset.fill !== undefined ? dataset.fill : lineElementOptions.fill),
					steppedLine: custom.steppedLine ? custom.steppedLine : helpers.valueOrDefault(dataset.steppedLine, lineElementOptions.stepped),
					cubicInterpolationMode: custom.cubicInterpolationMode ? custom.cubicInterpolationMode : helpers.valueOrDefault(dataset.cubicInterpolationMode, lineElementOptions.cubicInterpolationMode),
				};

				line.pivot();
			}

			// Update Points
			for (i = 0, ilen = points.length; i < ilen; ++i) {
				me.updateElement(points[i], i, reset);
			}

			if (showLine && line._model.tension !== 0) {
				me.updateBezierControlPoints();
			}

			// Now pivot the point for animation
			for (i = 0, ilen = points.length; i < ilen; ++i) {
				points[i].pivot();
			}
		},

		getPointBackgroundColor: function(point, index) {
			var backgroundColor = this.chart.options.elements.point.backgroundColor;
			var dataset = this.getDataset();
			var custom = point.custom || {};

			if (custom.backgroundColor) {
				backgroundColor = custom.backgroundColor;
			} else if (dataset.pointBackgroundColor) {
				backgroundColor = helpers.valueAtIndexOrDefault(dataset.pointBackgroundColor, index, backgroundColor);
			} else if (dataset.backgroundColor) {
				backgroundColor = dataset.backgroundColor;
			}

			return backgroundColor;
		},

		getPointBorderColor: function(point, index) {
			var borderColor = this.chart.options.elements.point.borderColor;
			var dataset = this.getDataset();
			var custom = point.custom || {};

			if (custom.borderColor) {
				borderColor = custom.borderColor;
			} else if (dataset.pointBorderColor) {
				borderColor = helpers.valueAtIndexOrDefault(dataset.pointBorderColor, index, borderColor);
			} else if (dataset.borderColor) {
				borderColor = dataset.borderColor;
			}

			return borderColor;
		},

		getPointBorderWidth: function(point, index) {
			var borderWidth = this.chart.options.elements.point.borderWidth;
			var dataset = this.getDataset();
			var custom = point.custom || {};

			if (!isNaN(custom.borderWidth)) {
				borderWidth = custom.borderWidth;
			} else if (!isNaN(dataset.pointBorderWidth) || helpers.isArray(dataset.pointBorderWidth)) {
				borderWidth = helpers.valueAtIndexOrDefault(dataset.pointBorderWidth, index, borderWidth);
			} else if (!isNaN(dataset.borderWidth)) {
				borderWidth = dataset.borderWidth;
			}

			return borderWidth;
		},

		updateElement: function(point, index, reset) {
			var me = this;
			var meta = me.getMeta();
			var custom = point.custom || {};
			var dataset = me.getDataset();
			var datasetIndex = me.index;
			var value = dataset.data[index];
			var yScale = me.getScaleForId(meta.yAxisID);
			var xScale = me.getScaleForId(meta.xAxisID);
			var pointOptions = me.chart.options.elements.point;
			var x, y;

			// Compatibility: If the properties are defined with only the old name, use those values
			if ((dataset.radius !== undefined) && (dataset.pointRadius === undefined)) {
				dataset.pointRadius = dataset.radius;
			}
			if ((dataset.hitRadius !== undefined) && (dataset.pointHitRadius === undefined)) {
				dataset.pointHitRadius = dataset.hitRadius;
			}

			x = xScale.getPixelForValue(typeof value === 'object' ? value : NaN, index, datasetIndex);
			y = reset ? yScale.getBasePixel() : me.calculatePointY(value, index, datasetIndex);

			// Utility
			point._xScale = xScale;
			point._yScale = yScale;
			point._datasetIndex = datasetIndex;
			point._index = index;

			// Desired view properties
			point._model = {
				x: x,
				y: y,
				skip: custom.skip || isNaN(x) || isNaN(y),
				// Appearance
				radius: custom.radius || helpers.valueAtIndexOrDefault(dataset.pointRadius, index, pointOptions.radius),
				pointStyle: custom.pointStyle || helpers.valueAtIndexOrDefault(dataset.pointStyle, index, pointOptions.pointStyle),
				backgroundColor: me.getPointBackgroundColor(point, index),
				borderColor: me.getPointBorderColor(point, index),
				borderWidth: me.getPointBorderWidth(point, index),
				tension: meta.dataset._model ? meta.dataset._model.tension : 0,
				steppedLine: meta.dataset._model ? meta.dataset._model.steppedLine : false,
				// Tooltip
				hitRadius: custom.hitRadius || helpers.valueAtIndexOrDefault(dataset.pointHitRadius, index, pointOptions.hitRadius)
			};
		},

		calculatePointY: function(value, index, datasetIndex) {
			var me = this;
			var chart = me.chart;
			var meta = me.getMeta();
			var yScale = me.getScaleForId(meta.yAxisID);
			var sumPos = 0;
			var sumNeg = 0;
			var i, ds, dsMeta;

			if (yScale.options.stacked) {
				for (i = 0; i < datasetIndex; i++) {
					ds = chart.data.datasets[i];
					dsMeta = chart.getDatasetMeta(i);
					if (dsMeta.type === 'line' && dsMeta.yAxisID === yScale.id && chart.isDatasetVisible(i)) {
						var stackedRightValue = Number(yScale.getRightValue(ds.data[index]));
						if (stackedRightValue < 0) {
							sumNeg += stackedRightValue || 0;
						} else {
							sumPos += stackedRightValue || 0;
						}
					}
				}

				var rightValue = Number(yScale.getRightValue(value));
				if (rightValue < 0) {
					return yScale.getPixelForValue(sumNeg + rightValue);
				}
				return yScale.getPixelForValue(sumPos + rightValue);
			}

			return yScale.getPixelForValue(value);
		},

		updateBezierControlPoints: function() {
			var me = this;
			var meta = me.getMeta();
			var area = me.chart.chartArea;
			var points = (meta.data || []);
			var i, ilen, point, model, controlPoints;

			// Only consider points that are drawn in case the spanGaps option is used
			if (meta.dataset._model.spanGaps) {
				points = points.filter(function(pt) {
					return !pt._model.skip;
				});
			}

			function capControlPoint(pt, min, max) {
				return Math.max(Math.min(pt, max), min);
			}

			if (meta.dataset._model.cubicInterpolationMode === 'monotone') {
				helpers.splineCurveMonotone(points);
			} else {
				for (i = 0, ilen = points.length; i < ilen; ++i) {
					point = points[i];
					model = point._model;
					controlPoints = helpers.splineCurve(
						helpers.previousItem(points, i)._model,
						model,
						helpers.nextItem(points, i)._model,
						meta.dataset._model.tension
					);
					model.controlPointPreviousX = controlPoints.previous.x;
					model.controlPointPreviousY = controlPoints.previous.y;
					model.controlPointNextX = controlPoints.next.x;
					model.controlPointNextY = controlPoints.next.y;
				}
			}

			if (me.chart.options.elements.line.capBezierPoints) {
				for (i = 0, ilen = points.length; i < ilen; ++i) {
					model = points[i]._model;
					model.controlPointPreviousX = capControlPoint(model.controlPointPreviousX, area.left, area.right);
					model.controlPointPreviousY = capControlPoint(model.controlPointPreviousY, area.top, area.bottom);
					model.controlPointNextX = capControlPoint(model.controlPointNextX, area.left, area.right);
					model.controlPointNextY = capControlPoint(model.controlPointNextY, area.top, area.bottom);
				}
			}
		},

		draw: function() {
			var me = this;
			var chart = me.chart;
			var meta = me.getMeta();
			var points = meta.data || [];
			var area = chart.chartArea;
			var ilen = points.length;
			var i = 0;

			helpers.canvas.clipArea(chart.ctx, area);

			if (lineEnabled(me.getDataset(), chart.options)) {
				meta.dataset.draw();
			}

			helpers.canvas.unclipArea(chart.ctx);

			// Draw the points
			for (; i < ilen; ++i) {
				points[i].draw(area);
			}
		},

		setHoverStyle: function(point) {
			// Point
			var dataset = this.chart.data.datasets[point._datasetIndex];
			var index = point._index;
			var custom = point.custom || {};
			var model = point._model;

			model.radius = custom.hoverRadius || helpers.valueAtIndexOrDefault(dataset.pointHoverRadius, index, this.chart.options.elements.point.hoverRadius);
			model.backgroundColor = custom.hoverBackgroundColor || helpers.valueAtIndexOrDefault(dataset.pointHoverBackgroundColor, index, helpers.getHoverColor(model.backgroundColor));
			model.borderColor = custom.hoverBorderColor || helpers.valueAtIndexOrDefault(dataset.pointHoverBorderColor, index, helpers.getHoverColor(model.borderColor));
			model.borderWidth = custom.hoverBorderWidth || helpers.valueAtIndexOrDefault(dataset.pointHoverBorderWidth, index, model.borderWidth);
		},

		removeHoverStyle: function(point) {
			var me = this;
			var dataset = me.chart.data.datasets[point._datasetIndex];
			var index = point._index;
			var custom = point.custom || {};
			var model = point._model;

			// Compatibility: If the properties are defined with only the old name, use those values
			if ((dataset.radius !== undefined) && (dataset.pointRadius === undefined)) {
				dataset.pointRadius = dataset.radius;
			}

			model.radius = custom.radius || helpers.valueAtIndexOrDefault(dataset.pointRadius, index, me.chart.options.elements.point.radius);
			model.backgroundColor = me.getPointBackgroundColor(point, index);
			model.borderColor = me.getPointBorderColor(point, index);
			model.borderWidth = me.getPointBorderWidth(point, index);
		}
	});
};


/***/ }),

/***/ 2674:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(796);
var elements = __webpack_require__(871);
var helpers = __webpack_require__(789);

defaults._set('polarArea', {
	scale: {
		type: 'radialLinear',
		angleLines: {
			display: false
		},
		gridLines: {
			circular: true
		},
		pointLabels: {
			display: false
		},
		ticks: {
			beginAtZero: true
		}
	},

	// Boolean - Whether to animate the rotation of the chart
	animation: {
		animateRotate: true,
		animateScale: true
	},

	startAngle: -0.5 * Math.PI,
	legendCallback: function(chart) {
		var text = [];
		text.push('<ul class="' + chart.id + '-legend">');

		var data = chart.data;
		var datasets = data.datasets;
		var labels = data.labels;

		if (datasets.length) {
			for (var i = 0; i < datasets[0].data.length; ++i) {
				text.push('<li><span style="background-color:' + datasets[0].backgroundColor[i] + '"></span>');
				if (labels[i]) {
					text.push(labels[i]);
				}
				text.push('</li>');
			}
		}

		text.push('</ul>');
		return text.join('');
	},
	legend: {
		labels: {
			generateLabels: function(chart) {
				var data = chart.data;
				if (data.labels.length && data.datasets.length) {
					return data.labels.map(function(label, i) {
						var meta = chart.getDatasetMeta(0);
						var ds = data.datasets[0];
						var arc = meta.data[i];
						var custom = arc.custom || {};
						var valueAtIndexOrDefault = helpers.valueAtIndexOrDefault;
						var arcOpts = chart.options.elements.arc;
						var fill = custom.backgroundColor ? custom.backgroundColor : valueAtIndexOrDefault(ds.backgroundColor, i, arcOpts.backgroundColor);
						var stroke = custom.borderColor ? custom.borderColor : valueAtIndexOrDefault(ds.borderColor, i, arcOpts.borderColor);
						var bw = custom.borderWidth ? custom.borderWidth : valueAtIndexOrDefault(ds.borderWidth, i, arcOpts.borderWidth);

						return {
							text: label,
							fillStyle: fill,
							strokeStyle: stroke,
							lineWidth: bw,
							hidden: isNaN(ds.data[i]) || meta.data[i].hidden,

							// Extra data used for toggling the correct item
							index: i
						};
					});
				}
				return [];
			}
		},

		onClick: function(e, legendItem) {
			var index = legendItem.index;
			var chart = this.chart;
			var i, ilen, meta;

			for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
				meta = chart.getDatasetMeta(i);
				meta.data[index].hidden = !meta.data[index].hidden;
			}

			chart.update();
		}
	},

	// Need to override these to give a nice default
	tooltips: {
		callbacks: {
			title: function() {
				return '';
			},
			label: function(item, data) {
				return data.labels[item.index] + ': ' + item.yLabel;
			}
		}
	}
});

module.exports = function(Chart) {

	Chart.controllers.polarArea = Chart.DatasetController.extend({

		dataElementType: elements.Arc,

		linkScales: helpers.noop,

		update: function(reset) {
			var me = this;
			var chart = me.chart;
			var chartArea = chart.chartArea;
			var meta = me.getMeta();
			var opts = chart.options;
			var arcOpts = opts.elements.arc;
			var minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
			chart.outerRadius = Math.max((minSize - arcOpts.borderWidth / 2) / 2, 0);
			chart.innerRadius = Math.max(opts.cutoutPercentage ? (chart.outerRadius / 100) * (opts.cutoutPercentage) : 1, 0);
			chart.radiusLength = (chart.outerRadius - chart.innerRadius) / chart.getVisibleDatasetCount();

			me.outerRadius = chart.outerRadius - (chart.radiusLength * me.index);
			me.innerRadius = me.outerRadius - chart.radiusLength;

			meta.count = me.countVisibleElements();

			helpers.each(meta.data, function(arc, index) {
				me.updateElement(arc, index, reset);
			});
		},

		updateElement: function(arc, index, reset) {
			var me = this;
			var chart = me.chart;
			var dataset = me.getDataset();
			var opts = chart.options;
			var animationOpts = opts.animation;
			var scale = chart.scale;
			var labels = chart.data.labels;

			var circumference = me.calculateCircumference(dataset.data[index]);
			var centerX = scale.xCenter;
			var centerY = scale.yCenter;

			// If there is NaN data before us, we need to calculate the starting angle correctly.
			// We could be way more efficient here, but its unlikely that the polar area chart will have a lot of data
			var visibleCount = 0;
			var meta = me.getMeta();
			for (var i = 0; i < index; ++i) {
				if (!isNaN(dataset.data[i]) && !meta.data[i].hidden) {
					++visibleCount;
				}
			}

			// var negHalfPI = -0.5 * Math.PI;
			var datasetStartAngle = opts.startAngle;
			var distance = arc.hidden ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
			var startAngle = datasetStartAngle + (circumference * visibleCount);
			var endAngle = startAngle + (arc.hidden ? 0 : circumference);

			var resetRadius = animationOpts.animateScale ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);

			helpers.extend(arc, {
				// Utility
				_datasetIndex: me.index,
				_index: index,
				_scale: scale,

				// Desired view properties
				_model: {
					x: centerX,
					y: centerY,
					innerRadius: 0,
					outerRadius: reset ? resetRadius : distance,
					startAngle: reset && animationOpts.animateRotate ? datasetStartAngle : startAngle,
					endAngle: reset && animationOpts.animateRotate ? datasetStartAngle : endAngle,
					label: helpers.valueAtIndexOrDefault(labels, index, labels[index])
				}
			});

			// Apply border and fill style
			me.removeHoverStyle(arc);

			arc.pivot();
		},

		removeHoverStyle: function(arc) {
			Chart.DatasetController.prototype.removeHoverStyle.call(this, arc, this.chart.options.elements.arc);
		},

		countVisibleElements: function() {
			var dataset = this.getDataset();
			var meta = this.getMeta();
			var count = 0;

			helpers.each(meta.data, function(element, index) {
				if (!isNaN(dataset.data[index]) && !element.hidden) {
					count++;
				}
			});

			return count;
		},

		calculateCircumference: function(value) {
			var count = this.getMeta().count;
			if (count > 0 && !isNaN(value)) {
				return (2 * Math.PI) / count;
			}
			return 0;
		}
	});
};


/***/ }),

/***/ 2675:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(796);
var elements = __webpack_require__(871);
var helpers = __webpack_require__(789);

defaults._set('radar', {
	scale: {
		type: 'radialLinear'
	},
	elements: {
		line: {
			tension: 0 // no bezier in radar
		}
	}
});

module.exports = function(Chart) {

	Chart.controllers.radar = Chart.DatasetController.extend({

		datasetElementType: elements.Line,

		dataElementType: elements.Point,

		linkScales: helpers.noop,

		update: function(reset) {
			var me = this;
			var meta = me.getMeta();
			var line = meta.dataset;
			var points = meta.data;
			var custom = line.custom || {};
			var dataset = me.getDataset();
			var lineElementOptions = me.chart.options.elements.line;
			var scale = me.chart.scale;

			// Compatibility: If the properties are defined with only the old name, use those values
			if ((dataset.tension !== undefined) && (dataset.lineTension === undefined)) {
				dataset.lineTension = dataset.tension;
			}

			helpers.extend(meta.dataset, {
				// Utility
				_datasetIndex: me.index,
				_scale: scale,
				// Data
				_children: points,
				_loop: true,
				// Model
				_model: {
					// Appearance
					tension: custom.tension ? custom.tension : helpers.valueOrDefault(dataset.lineTension, lineElementOptions.tension),
					backgroundColor: custom.backgroundColor ? custom.backgroundColor : (dataset.backgroundColor || lineElementOptions.backgroundColor),
					borderWidth: custom.borderWidth ? custom.borderWidth : (dataset.borderWidth || lineElementOptions.borderWidth),
					borderColor: custom.borderColor ? custom.borderColor : (dataset.borderColor || lineElementOptions.borderColor),
					fill: custom.fill ? custom.fill : (dataset.fill !== undefined ? dataset.fill : lineElementOptions.fill),
					borderCapStyle: custom.borderCapStyle ? custom.borderCapStyle : (dataset.borderCapStyle || lineElementOptions.borderCapStyle),
					borderDash: custom.borderDash ? custom.borderDash : (dataset.borderDash || lineElementOptions.borderDash),
					borderDashOffset: custom.borderDashOffset ? custom.borderDashOffset : (dataset.borderDashOffset || lineElementOptions.borderDashOffset),
					borderJoinStyle: custom.borderJoinStyle ? custom.borderJoinStyle : (dataset.borderJoinStyle || lineElementOptions.borderJoinStyle),
				}
			});

			meta.dataset.pivot();

			// Update Points
			helpers.each(points, function(point, index) {
				me.updateElement(point, index, reset);
			}, me);

			// Update bezier control points
			me.updateBezierControlPoints();
		},
		updateElement: function(point, index, reset) {
			var me = this;
			var custom = point.custom || {};
			var dataset = me.getDataset();
			var scale = me.chart.scale;
			var pointElementOptions = me.chart.options.elements.point;
			var pointPosition = scale.getPointPositionForValue(index, dataset.data[index]);

			// Compatibility: If the properties are defined with only the old name, use those values
			if ((dataset.radius !== undefined) && (dataset.pointRadius === undefined)) {
				dataset.pointRadius = dataset.radius;
			}
			if ((dataset.hitRadius !== undefined) && (dataset.pointHitRadius === undefined)) {
				dataset.pointHitRadius = dataset.hitRadius;
			}

			helpers.extend(point, {
				// Utility
				_datasetIndex: me.index,
				_index: index,
				_scale: scale,

				// Desired view properties
				_model: {
					x: reset ? scale.xCenter : pointPosition.x, // value not used in dataset scale, but we want a consistent API between scales
					y: reset ? scale.yCenter : pointPosition.y,

					// Appearance
					tension: custom.tension ? custom.tension : helpers.valueOrDefault(dataset.lineTension, me.chart.options.elements.line.tension),
					radius: custom.radius ? custom.radius : helpers.valueAtIndexOrDefault(dataset.pointRadius, index, pointElementOptions.radius),
					backgroundColor: custom.backgroundColor ? custom.backgroundColor : helpers.valueAtIndexOrDefault(dataset.pointBackgroundColor, index, pointElementOptions.backgroundColor),
					borderColor: custom.borderColor ? custom.borderColor : helpers.valueAtIndexOrDefault(dataset.pointBorderColor, index, pointElementOptions.borderColor),
					borderWidth: custom.borderWidth ? custom.borderWidth : helpers.valueAtIndexOrDefault(dataset.pointBorderWidth, index, pointElementOptions.borderWidth),
					pointStyle: custom.pointStyle ? custom.pointStyle : helpers.valueAtIndexOrDefault(dataset.pointStyle, index, pointElementOptions.pointStyle),

					// Tooltip
					hitRadius: custom.hitRadius ? custom.hitRadius : helpers.valueAtIndexOrDefault(dataset.pointHitRadius, index, pointElementOptions.hitRadius)
				}
			});

			point._model.skip = custom.skip ? custom.skip : (isNaN(point._model.x) || isNaN(point._model.y));
		},
		updateBezierControlPoints: function() {
			var chartArea = this.chart.chartArea;
			var meta = this.getMeta();

			helpers.each(meta.data, function(point, index) {
				var model = point._model;
				var controlPoints = helpers.splineCurve(
					helpers.previousItem(meta.data, index, true)._model,
					model,
					helpers.nextItem(meta.data, index, true)._model,
					model.tension
				);

				// Prevent the bezier going outside of the bounds of the graph
				model.controlPointPreviousX = Math.max(Math.min(controlPoints.previous.x, chartArea.right), chartArea.left);
				model.controlPointPreviousY = Math.max(Math.min(controlPoints.previous.y, chartArea.bottom), chartArea.top);

				model.controlPointNextX = Math.max(Math.min(controlPoints.next.x, chartArea.right), chartArea.left);
				model.controlPointNextY = Math.max(Math.min(controlPoints.next.y, chartArea.bottom), chartArea.top);

				// Now pivot the point for animation
				point.pivot();
			});
		},

		setHoverStyle: function(point) {
			// Point
			var dataset = this.chart.data.datasets[point._datasetIndex];
			var custom = point.custom || {};
			var index = point._index;
			var model = point._model;

			model.radius = custom.hoverRadius ? custom.hoverRadius : helpers.valueAtIndexOrDefault(dataset.pointHoverRadius, index, this.chart.options.elements.point.hoverRadius);
			model.backgroundColor = custom.hoverBackgroundColor ? custom.hoverBackgroundColor : helpers.valueAtIndexOrDefault(dataset.pointHoverBackgroundColor, index, helpers.getHoverColor(model.backgroundColor));
			model.borderColor = custom.hoverBorderColor ? custom.hoverBorderColor : helpers.valueAtIndexOrDefault(dataset.pointHoverBorderColor, index, helpers.getHoverColor(model.borderColor));
			model.borderWidth = custom.hoverBorderWidth ? custom.hoverBorderWidth : helpers.valueAtIndexOrDefault(dataset.pointHoverBorderWidth, index, model.borderWidth);
		},

		removeHoverStyle: function(point) {
			var dataset = this.chart.data.datasets[point._datasetIndex];
			var custom = point.custom || {};
			var index = point._index;
			var model = point._model;
			var pointElementOptions = this.chart.options.elements.point;

			model.radius = custom.radius ? custom.radius : helpers.valueAtIndexOrDefault(dataset.pointRadius, index, pointElementOptions.radius);
			model.backgroundColor = custom.backgroundColor ? custom.backgroundColor : helpers.valueAtIndexOrDefault(dataset.pointBackgroundColor, index, pointElementOptions.backgroundColor);
			model.borderColor = custom.borderColor ? custom.borderColor : helpers.valueAtIndexOrDefault(dataset.pointBorderColor, index, pointElementOptions.borderColor);
			model.borderWidth = custom.borderWidth ? custom.borderWidth : helpers.valueAtIndexOrDefault(dataset.pointBorderWidth, index, pointElementOptions.borderWidth);
		}
	});
};


/***/ }),

/***/ 2676:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(796);

defaults._set('scatter', {
	hover: {
		mode: 'single'
	},

	scales: {
		xAxes: [{
			id: 'x-axis-1',    // need an ID so datasets can reference the scale
			type: 'linear',    // scatter should not use a category axis
			position: 'bottom'
		}],
		yAxes: [{
			id: 'y-axis-1',
			type: 'linear',
			position: 'left'
		}]
	},

	showLines: false,

	tooltips: {
		callbacks: {
			title: function() {
				return '';     // doesn't make sense for scatter since data are formatted as a point
			},
			label: function(item) {
				return '(' + item.xLabel + ', ' + item.yLabel + ')';
			}
		}
	}
});

module.exports = function(Chart) {

	// Scatter charts use line controllers
	Chart.controllers.scatter = Chart.controllers.line;

};


/***/ }),

/***/ 2677:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function(Chart) {

	Chart.Bar = function(context, config) {
		config.type = 'bar';

		return new Chart(context, config);
	};

};


/***/ }),

/***/ 2678:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function(Chart) {

	Chart.Bubble = function(context, config) {
		config.type = 'bubble';
		return new Chart(context, config);
	};

};


/***/ }),

/***/ 2679:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function(Chart) {

	Chart.Doughnut = function(context, config) {
		config.type = 'doughnut';

		return new Chart(context, config);
	};

};


/***/ }),

/***/ 2680:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function(Chart) {

	Chart.Line = function(context, config) {
		config.type = 'line';

		return new Chart(context, config);
	};

};


/***/ }),

/***/ 2681:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function(Chart) {

	Chart.PolarArea = function(context, config) {
		config.type = 'polarArea';

		return new Chart(context, config);
	};

};


/***/ }),

/***/ 2682:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function(Chart) {

	Chart.Radar = function(context, config) {
		config.type = 'radar';

		return new Chart(context, config);
	};

};


/***/ }),

/***/ 2683:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function(Chart) {
	Chart.Scatter = function(context, config) {
		config.type = 'scatter';
		return new Chart(context, config);
	};
};


/***/ }),

/***/ 2684:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Plugin based on discussion from the following Chart.js issues:
 * @see https://github.com/chartjs/Chart.js/issues/2380#issuecomment-279961569
 * @see https://github.com/chartjs/Chart.js/issues/2440#issuecomment-256461897
 */



var defaults = __webpack_require__(796);
var elements = __webpack_require__(871);
var helpers = __webpack_require__(789);

defaults._set('global', {
	plugins: {
		filler: {
			propagate: true
		}
	}
});

module.exports = function() {

	var mappers = {
		dataset: function(source) {
			var index = source.fill;
			var chart = source.chart;
			var meta = chart.getDatasetMeta(index);
			var visible = meta && chart.isDatasetVisible(index);
			var points = (visible && meta.dataset._children) || [];
			var length = points.length || 0;

			return !length ? null : function(point, i) {
				return (i < length && points[i]._view) || null;
			};
		},

		boundary: function(source) {
			var boundary = source.boundary;
			var x = boundary ? boundary.x : null;
			var y = boundary ? boundary.y : null;

			return function(point) {
				return {
					x: x === null ? point.x : x,
					y: y === null ? point.y : y,
				};
			};
		}
	};

	// @todo if (fill[0] === '#')
	function decodeFill(el, index, count) {
		var model = el._model || {};
		var fill = model.fill;
		var target;

		if (fill === undefined) {
			fill = !!model.backgroundColor;
		}

		if (fill === false || fill === null) {
			return false;
		}

		if (fill === true) {
			return 'origin';
		}

		target = parseFloat(fill, 10);
		if (isFinite(target) && Math.floor(target) === target) {
			if (fill[0] === '-' || fill[0] === '+') {
				target = index + target;
			}

			if (target === index || target < 0 || target >= count) {
				return false;
			}

			return target;
		}

		switch (fill) {
		// compatibility
		case 'bottom':
			return 'start';
		case 'top':
			return 'end';
		case 'zero':
			return 'origin';
		// supported boundaries
		case 'origin':
		case 'start':
		case 'end':
			return fill;
		// invalid fill values
		default:
			return false;
		}
	}

	function computeBoundary(source) {
		var model = source.el._model || {};
		var scale = source.el._scale || {};
		var fill = source.fill;
		var target = null;
		var horizontal;

		if (isFinite(fill)) {
			return null;
		}

		// Backward compatibility: until v3, we still need to support boundary values set on
		// the model (scaleTop, scaleBottom and scaleZero) because some external plugins and
		// controllers might still use it (e.g. the Smith chart).

		if (fill === 'start') {
			target = model.scaleBottom === undefined ? scale.bottom : model.scaleBottom;
		} else if (fill === 'end') {
			target = model.scaleTop === undefined ? scale.top : model.scaleTop;
		} else if (model.scaleZero !== undefined) {
			target = model.scaleZero;
		} else if (scale.getBasePosition) {
			target = scale.getBasePosition();
		} else if (scale.getBasePixel) {
			target = scale.getBasePixel();
		}

		if (target !== undefined && target !== null) {
			if (target.x !== undefined && target.y !== undefined) {
				return target;
			}

			if (typeof target === 'number' && isFinite(target)) {
				horizontal = scale.isHorizontal();
				return {
					x: horizontal ? target : null,
					y: horizontal ? null : target
				};
			}
		}

		return null;
	}

	function resolveTarget(sources, index, propagate) {
		var source = sources[index];
		var fill = source.fill;
		var visited = [index];
		var target;

		if (!propagate) {
			return fill;
		}

		while (fill !== false && visited.indexOf(fill) === -1) {
			if (!isFinite(fill)) {
				return fill;
			}

			target = sources[fill];
			if (!target) {
				return false;
			}

			if (target.visible) {
				return fill;
			}

			visited.push(fill);
			fill = target.fill;
		}

		return false;
	}

	function createMapper(source) {
		var fill = source.fill;
		var type = 'dataset';

		if (fill === false) {
			return null;
		}

		if (!isFinite(fill)) {
			type = 'boundary';
		}

		return mappers[type](source);
	}

	function isDrawable(point) {
		return point && !point.skip;
	}

	function drawArea(ctx, curve0, curve1, len0, len1) {
		var i;

		if (!len0 || !len1) {
			return;
		}

		// building first area curve (normal)
		ctx.moveTo(curve0[0].x, curve0[0].y);
		for (i = 1; i < len0; ++i) {
			helpers.canvas.lineTo(ctx, curve0[i - 1], curve0[i]);
		}

		// joining the two area curves
		ctx.lineTo(curve1[len1 - 1].x, curve1[len1 - 1].y);

		// building opposite area curve (reverse)
		for (i = len1 - 1; i > 0; --i) {
			helpers.canvas.lineTo(ctx, curve1[i], curve1[i - 1], true);
		}
	}

	function doFill(ctx, points, mapper, view, color, loop) {
		var count = points.length;
		var span = view.spanGaps;
		var curve0 = [];
		var curve1 = [];
		var len0 = 0;
		var len1 = 0;
		var i, ilen, index, p0, p1, d0, d1;

		ctx.beginPath();

		for (i = 0, ilen = (count + !!loop); i < ilen; ++i) {
			index = i % count;
			p0 = points[index]._view;
			p1 = mapper(p0, index, view);
			d0 = isDrawable(p0);
			d1 = isDrawable(p1);

			if (d0 && d1) {
				len0 = curve0.push(p0);
				len1 = curve1.push(p1);
			} else if (len0 && len1) {
				if (!span) {
					drawArea(ctx, curve0, curve1, len0, len1);
					len0 = len1 = 0;
					curve0 = [];
					curve1 = [];
				} else {
					if (d0) {
						curve0.push(p0);
					}
					if (d1) {
						curve1.push(p1);
					}
				}
			}
		}

		drawArea(ctx, curve0, curve1, len0, len1);

		ctx.closePath();
		ctx.fillStyle = color;
		ctx.fill();
	}

	return {
		id: 'filler',

		afterDatasetsUpdate: function(chart, options) {
			var count = (chart.data.datasets || []).length;
			var propagate = options.propagate;
			var sources = [];
			var meta, i, el, source;

			for (i = 0; i < count; ++i) {
				meta = chart.getDatasetMeta(i);
				el = meta.dataset;
				source = null;

				if (el && el._model && el instanceof elements.Line) {
					source = {
						visible: chart.isDatasetVisible(i),
						fill: decodeFill(el, i, count),
						chart: chart,
						el: el
					};
				}

				meta.$filler = source;
				sources.push(source);
			}

			for (i = 0; i < count; ++i) {
				source = sources[i];
				if (!source) {
					continue;
				}

				source.fill = resolveTarget(sources, i, propagate);
				source.boundary = computeBoundary(source);
				source.mapper = createMapper(source);
			}
		},

		beforeDatasetDraw: function(chart, args) {
			var meta = args.meta.$filler;
			if (!meta) {
				return;
			}

			var ctx = chart.ctx;
			var el = meta.el;
			var view = el._view;
			var points = el._children || [];
			var mapper = meta.mapper;
			var color = view.backgroundColor || defaults.global.defaultColor;

			if (mapper && color && points.length) {
				helpers.canvas.clipArea(ctx, chart.chartArea);
				doFill(ctx, points, mapper, view, color, el._loop);
				helpers.canvas.unclipArea(ctx);
			}
		}
	};
};


/***/ }),

/***/ 2685:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(796);
var Element = __webpack_require__(843);
var helpers = __webpack_require__(789);

defaults._set('global', {
	legend: {
		display: true,
		position: 'top',
		fullWidth: true,
		reverse: false,
		weight: 1000,

		// a callback that will handle
		onClick: function(e, legendItem) {
			var index = legendItem.datasetIndex;
			var ci = this.chart;
			var meta = ci.getDatasetMeta(index);

			// See controller.isDatasetVisible comment
			meta.hidden = meta.hidden === null ? !ci.data.datasets[index].hidden : null;

			// We hid a dataset ... rerender the chart
			ci.update();
		},

		onHover: null,

		labels: {
			boxWidth: 40,
			padding: 10,
			// Generates labels shown in the legend
			// Valid properties to return:
			// text : text to display
			// fillStyle : fill of coloured box
			// strokeStyle: stroke of coloured box
			// hidden : if this legend item refers to a hidden item
			// lineCap : cap style for line
			// lineDash
			// lineDashOffset :
			// lineJoin :
			// lineWidth :
			generateLabels: function(chart) {
				var data = chart.data;
				return helpers.isArray(data.datasets) ? data.datasets.map(function(dataset, i) {
					return {
						text: dataset.label,
						fillStyle: (!helpers.isArray(dataset.backgroundColor) ? dataset.backgroundColor : dataset.backgroundColor[0]),
						hidden: !chart.isDatasetVisible(i),
						lineCap: dataset.borderCapStyle,
						lineDash: dataset.borderDash,
						lineDashOffset: dataset.borderDashOffset,
						lineJoin: dataset.borderJoinStyle,
						lineWidth: dataset.borderWidth,
						strokeStyle: dataset.borderColor,
						pointStyle: dataset.pointStyle,

						// Below is extra data used for toggling the datasets
						datasetIndex: i
					};
				}, this) : [];
			}
		}
	},

	legendCallback: function(chart) {
		var text = [];
		text.push('<ul class="' + chart.id + '-legend">');
		for (var i = 0; i < chart.data.datasets.length; i++) {
			text.push('<li><span style="background-color:' + chart.data.datasets[i].backgroundColor + '"></span>');
			if (chart.data.datasets[i].label) {
				text.push(chart.data.datasets[i].label);
			}
			text.push('</li>');
		}
		text.push('</ul>');
		return text.join('');
	}
});

module.exports = function(Chart) {

	var layout = Chart.layoutService;
	var noop = helpers.noop;

	/**
	 * Helper function to get the box width based on the usePointStyle option
	 * @param labelopts {Object} the label options on the legend
	 * @param fontSize {Number} the label font size
	 * @return {Number} width of the color box area
	 */
	function getBoxWidth(labelOpts, fontSize) {
		return labelOpts.usePointStyle ?
			fontSize * Math.SQRT2 :
			labelOpts.boxWidth;
	}

	Chart.Legend = Element.extend({

		initialize: function(config) {
			helpers.extend(this, config);

			// Contains hit boxes for each dataset (in dataset order)
			this.legendHitBoxes = [];

			// Are we in doughnut mode which has a different data type
			this.doughnutMode = false;
		},

		// These methods are ordered by lifecycle. Utilities then follow.
		// Any function defined here is inherited by all legend types.
		// Any function can be extended by the legend type

		beforeUpdate: noop,
		update: function(maxWidth, maxHeight, margins) {
			var me = this;

			// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
			me.beforeUpdate();

			// Absorb the master measurements
			me.maxWidth = maxWidth;
			me.maxHeight = maxHeight;
			me.margins = margins;

			// Dimensions
			me.beforeSetDimensions();
			me.setDimensions();
			me.afterSetDimensions();
			// Labels
			me.beforeBuildLabels();
			me.buildLabels();
			me.afterBuildLabels();

			// Fit
			me.beforeFit();
			me.fit();
			me.afterFit();
			//
			me.afterUpdate();

			return me.minSize;
		},
		afterUpdate: noop,

		//

		beforeSetDimensions: noop,
		setDimensions: function() {
			var me = this;
			// Set the unconstrained dimension before label rotation
			if (me.isHorizontal()) {
				// Reset position before calculating rotation
				me.width = me.maxWidth;
				me.left = 0;
				me.right = me.width;
			} else {
				me.height = me.maxHeight;

				// Reset position before calculating rotation
				me.top = 0;
				me.bottom = me.height;
			}

			// Reset padding
			me.paddingLeft = 0;
			me.paddingTop = 0;
			me.paddingRight = 0;
			me.paddingBottom = 0;

			// Reset minSize
			me.minSize = {
				width: 0,
				height: 0
			};
		},
		afterSetDimensions: noop,

		//

		beforeBuildLabels: noop,
		buildLabels: function() {
			var me = this;
			var labelOpts = me.options.labels || {};
			var legendItems = helpers.callback(labelOpts.generateLabels, [me.chart], me) || [];

			if (labelOpts.filter) {
				legendItems = legendItems.filter(function(item) {
					return labelOpts.filter(item, me.chart.data);
				});
			}

			if (me.options.reverse) {
				legendItems.reverse();
			}

			me.legendItems = legendItems;
		},
		afterBuildLabels: noop,

		//

		beforeFit: noop,
		fit: function() {
			var me = this;
			var opts = me.options;
			var labelOpts = opts.labels;
			var display = opts.display;

			var ctx = me.ctx;

			var globalDefault = defaults.global;
			var valueOrDefault = helpers.valueOrDefault;
			var fontSize = valueOrDefault(labelOpts.fontSize, globalDefault.defaultFontSize);
			var fontStyle = valueOrDefault(labelOpts.fontStyle, globalDefault.defaultFontStyle);
			var fontFamily = valueOrDefault(labelOpts.fontFamily, globalDefault.defaultFontFamily);
			var labelFont = helpers.fontString(fontSize, fontStyle, fontFamily);

			// Reset hit boxes
			var hitboxes = me.legendHitBoxes = [];

			var minSize = me.minSize;
			var isHorizontal = me.isHorizontal();

			if (isHorizontal) {
				minSize.width = me.maxWidth; // fill all the width
				minSize.height = display ? 10 : 0;
			} else {
				minSize.width = display ? 10 : 0;
				minSize.height = me.maxHeight; // fill all the height
			}

			// Increase sizes here
			if (display) {
				ctx.font = labelFont;

				if (isHorizontal) {
					// Labels

					// Width of each line of legend boxes. Labels wrap onto multiple lines when there are too many to fit on one
					var lineWidths = me.lineWidths = [0];
					var totalHeight = me.legendItems.length ? fontSize + (labelOpts.padding) : 0;

					ctx.textAlign = 'left';
					ctx.textBaseline = 'top';

					helpers.each(me.legendItems, function(legendItem, i) {
						var boxWidth = getBoxWidth(labelOpts, fontSize);
						var width = boxWidth + (fontSize / 2) + ctx.measureText(legendItem.text).width;

						if (lineWidths[lineWidths.length - 1] + width + labelOpts.padding >= me.width) {
							totalHeight += fontSize + (labelOpts.padding);
							lineWidths[lineWidths.length] = me.left;
						}

						// Store the hitbox width and height here. Final position will be updated in `draw`
						hitboxes[i] = {
							left: 0,
							top: 0,
							width: width,
							height: fontSize
						};

						lineWidths[lineWidths.length - 1] += width + labelOpts.padding;
					});

					minSize.height += totalHeight;

				} else {
					var vPadding = labelOpts.padding;
					var columnWidths = me.columnWidths = [];
					var totalWidth = labelOpts.padding;
					var currentColWidth = 0;
					var currentColHeight = 0;
					var itemHeight = fontSize + vPadding;

					helpers.each(me.legendItems, function(legendItem, i) {
						var boxWidth = getBoxWidth(labelOpts, fontSize);
						var itemWidth = boxWidth + (fontSize / 2) + ctx.measureText(legendItem.text).width;

						// If too tall, go to new column
						if (currentColHeight + itemHeight > minSize.height) {
							totalWidth += currentColWidth + labelOpts.padding;
							columnWidths.push(currentColWidth); // previous column width

							currentColWidth = 0;
							currentColHeight = 0;
						}

						// Get max width
						currentColWidth = Math.max(currentColWidth, itemWidth);
						currentColHeight += itemHeight;

						// Store the hitbox width and height here. Final position will be updated in `draw`
						hitboxes[i] = {
							left: 0,
							top: 0,
							width: itemWidth,
							height: fontSize
						};
					});

					totalWidth += currentColWidth;
					columnWidths.push(currentColWidth);
					minSize.width += totalWidth;
				}
			}

			me.width = minSize.width;
			me.height = minSize.height;
		},
		afterFit: noop,

		// Shared Methods
		isHorizontal: function() {
			return this.options.position === 'top' || this.options.position === 'bottom';
		},

		// Actually draw the legend on the canvas
		draw: function() {
			var me = this;
			var opts = me.options;
			var labelOpts = opts.labels;
			var globalDefault = defaults.global;
			var lineDefault = globalDefault.elements.line;
			var legendWidth = me.width;
			var lineWidths = me.lineWidths;

			if (opts.display) {
				var ctx = me.ctx;
				var valueOrDefault = helpers.valueOrDefault;
				var fontColor = valueOrDefault(labelOpts.fontColor, globalDefault.defaultFontColor);
				var fontSize = valueOrDefault(labelOpts.fontSize, globalDefault.defaultFontSize);
				var fontStyle = valueOrDefault(labelOpts.fontStyle, globalDefault.defaultFontStyle);
				var fontFamily = valueOrDefault(labelOpts.fontFamily, globalDefault.defaultFontFamily);
				var labelFont = helpers.fontString(fontSize, fontStyle, fontFamily);
				var cursor;

				// Canvas setup
				ctx.textAlign = 'left';
				ctx.textBaseline = 'middle';
				ctx.lineWidth = 0.5;
				ctx.strokeStyle = fontColor; // for strikethrough effect
				ctx.fillStyle = fontColor; // render in correct colour
				ctx.font = labelFont;

				var boxWidth = getBoxWidth(labelOpts, fontSize);
				var hitboxes = me.legendHitBoxes;

				// current position
				var drawLegendBox = function(x, y, legendItem) {
					if (isNaN(boxWidth) || boxWidth <= 0) {
						return;
					}

					// Set the ctx for the box
					ctx.save();

					ctx.fillStyle = valueOrDefault(legendItem.fillStyle, globalDefault.defaultColor);
					ctx.lineCap = valueOrDefault(legendItem.lineCap, lineDefault.borderCapStyle);
					ctx.lineDashOffset = valueOrDefault(legendItem.lineDashOffset, lineDefault.borderDashOffset);
					ctx.lineJoin = valueOrDefault(legendItem.lineJoin, lineDefault.borderJoinStyle);
					ctx.lineWidth = valueOrDefault(legendItem.lineWidth, lineDefault.borderWidth);
					ctx.strokeStyle = valueOrDefault(legendItem.strokeStyle, globalDefault.defaultColor);
					var isLineWidthZero = (valueOrDefault(legendItem.lineWidth, lineDefault.borderWidth) === 0);

					if (ctx.setLineDash) {
						// IE 9 and 10 do not support line dash
						ctx.setLineDash(valueOrDefault(legendItem.lineDash, lineDefault.borderDash));
					}

					if (opts.labels && opts.labels.usePointStyle) {
						// Recalculate x and y for drawPoint() because its expecting
						// x and y to be center of figure (instead of top left)
						var radius = fontSize * Math.SQRT2 / 2;
						var offSet = radius / Math.SQRT2;
						var centerX = x + offSet;
						var centerY = y + offSet;

						// Draw pointStyle as legend symbol
						helpers.canvas.drawPoint(ctx, legendItem.pointStyle, radius, centerX, centerY);
					} else {
						// Draw box as legend symbol
						if (!isLineWidthZero) {
							ctx.strokeRect(x, y, boxWidth, fontSize);
						}
						ctx.fillRect(x, y, boxWidth, fontSize);
					}

					ctx.restore();
				};
				var fillText = function(x, y, legendItem, textWidth) {
					var halfFontSize = fontSize / 2;
					var xLeft = boxWidth + halfFontSize + x;
					var yMiddle = y + halfFontSize;

					ctx.fillText(legendItem.text, xLeft, yMiddle);

					if (legendItem.hidden) {
						// Strikethrough the text if hidden
						ctx.beginPath();
						ctx.lineWidth = 2;
						ctx.moveTo(xLeft, yMiddle);
						ctx.lineTo(xLeft + textWidth, yMiddle);
						ctx.stroke();
					}
				};

				// Horizontal
				var isHorizontal = me.isHorizontal();
				if (isHorizontal) {
					cursor = {
						x: me.left + ((legendWidth - lineWidths[0]) / 2),
						y: me.top + labelOpts.padding,
						line: 0
					};
				} else {
					cursor = {
						x: me.left + labelOpts.padding,
						y: me.top + labelOpts.padding,
						line: 0
					};
				}

				var itemHeight = fontSize + labelOpts.padding;
				helpers.each(me.legendItems, function(legendItem, i) {
					var textWidth = ctx.measureText(legendItem.text).width;
					var width = boxWidth + (fontSize / 2) + textWidth;
					var x = cursor.x;
					var y = cursor.y;

					if (isHorizontal) {
						if (x + width >= legendWidth) {
							y = cursor.y += itemHeight;
							cursor.line++;
							x = cursor.x = me.left + ((legendWidth - lineWidths[cursor.line]) / 2);
						}
					} else if (y + itemHeight > me.bottom) {
						x = cursor.x = x + me.columnWidths[cursor.line] + labelOpts.padding;
						y = cursor.y = me.top + labelOpts.padding;
						cursor.line++;
					}

					drawLegendBox(x, y, legendItem);

					hitboxes[i].left = x;
					hitboxes[i].top = y;

					// Fill the actual label
					fillText(x, y, legendItem, textWidth);

					if (isHorizontal) {
						cursor.x += width + (labelOpts.padding);
					} else {
						cursor.y += itemHeight;
					}

				});
			}
		},

		/**
		 * Handle an event
		 * @private
		 * @param {IEvent} event - The event to handle
		 * @return {Boolean} true if a change occured
		 */
		handleEvent: function(e) {
			var me = this;
			var opts = me.options;
			var type = e.type === 'mouseup' ? 'click' : e.type;
			var changed = false;

			if (type === 'mousemove') {
				if (!opts.onHover) {
					return;
				}
			} else if (type === 'click') {
				if (!opts.onClick) {
					return;
				}
			} else {
				return;
			}

			// Chart event already has relative position in it
			var x = e.x;
			var y = e.y;

			if (x >= me.left && x <= me.right && y >= me.top && y <= me.bottom) {
				// See if we are touching one of the dataset boxes
				var lh = me.legendHitBoxes;
				for (var i = 0; i < lh.length; ++i) {
					var hitBox = lh[i];

					if (x >= hitBox.left && x <= hitBox.left + hitBox.width && y >= hitBox.top && y <= hitBox.top + hitBox.height) {
						// Touching an element
						if (type === 'click') {
							// use e.native for backwards compatibility
							opts.onClick.call(me, e.native, me.legendItems[i]);
							changed = true;
							break;
						} else if (type === 'mousemove') {
							// use e.native for backwards compatibility
							opts.onHover.call(me, e.native, me.legendItems[i]);
							changed = true;
							break;
						}
					}
				}
			}

			return changed;
		}
	});

	function createNewLegendAndAttach(chart, legendOpts) {
		var legend = new Chart.Legend({
			ctx: chart.ctx,
			options: legendOpts,
			chart: chart
		});

		layout.configure(chart, legend, legendOpts);
		layout.addBox(chart, legend);
		chart.legend = legend;
	}

	return {
		id: 'legend',

		beforeInit: function(chart) {
			var legendOpts = chart.options.legend;

			if (legendOpts) {
				createNewLegendAndAttach(chart, legendOpts);
			}
		},

		beforeUpdate: function(chart) {
			var legendOpts = chart.options.legend;
			var legend = chart.legend;

			if (legendOpts) {
				helpers.mergeIf(legendOpts, defaults.global.legend);

				if (legend) {
					layout.configure(chart, legend, legendOpts);
					legend.options = legendOpts;
				} else {
					createNewLegendAndAttach(chart, legendOpts);
				}
			} else if (legend) {
				layout.removeBox(chart, legend);
				delete chart.legend;
			}
		},

		afterEvent: function(chart, e) {
			var legend = chart.legend;
			if (legend) {
				legend.handleEvent(e);
			}
		}
	};
};


/***/ }),

/***/ 2686:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(796);
var Element = __webpack_require__(843);
var helpers = __webpack_require__(789);

defaults._set('global', {
	title: {
		display: false,
		fontStyle: 'bold',
		fullWidth: true,
		lineHeight: 1.2,
		padding: 10,
		position: 'top',
		text: '',
		weight: 2000         // by default greater than legend (1000) to be above
	}
});

module.exports = function(Chart) {

	var layout = Chart.layoutService;
	var noop = helpers.noop;

	Chart.Title = Element.extend({
		initialize: function(config) {
			var me = this;
			helpers.extend(me, config);

			// Contains hit boxes for each dataset (in dataset order)
			me.legendHitBoxes = [];
		},

		// These methods are ordered by lifecycle. Utilities then follow.

		beforeUpdate: noop,
		update: function(maxWidth, maxHeight, margins) {
			var me = this;

			// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
			me.beforeUpdate();

			// Absorb the master measurements
			me.maxWidth = maxWidth;
			me.maxHeight = maxHeight;
			me.margins = margins;

			// Dimensions
			me.beforeSetDimensions();
			me.setDimensions();
			me.afterSetDimensions();
			// Labels
			me.beforeBuildLabels();
			me.buildLabels();
			me.afterBuildLabels();

			// Fit
			me.beforeFit();
			me.fit();
			me.afterFit();
			//
			me.afterUpdate();

			return me.minSize;

		},
		afterUpdate: noop,

		//

		beforeSetDimensions: noop,
		setDimensions: function() {
			var me = this;
			// Set the unconstrained dimension before label rotation
			if (me.isHorizontal()) {
				// Reset position before calculating rotation
				me.width = me.maxWidth;
				me.left = 0;
				me.right = me.width;
			} else {
				me.height = me.maxHeight;

				// Reset position before calculating rotation
				me.top = 0;
				me.bottom = me.height;
			}

			// Reset padding
			me.paddingLeft = 0;
			me.paddingTop = 0;
			me.paddingRight = 0;
			me.paddingBottom = 0;

			// Reset minSize
			me.minSize = {
				width: 0,
				height: 0
			};
		},
		afterSetDimensions: noop,

		//

		beforeBuildLabels: noop,
		buildLabels: noop,
		afterBuildLabels: noop,

		//

		beforeFit: noop,
		fit: function() {
			var me = this;
			var valueOrDefault = helpers.valueOrDefault;
			var opts = me.options;
			var display = opts.display;
			var fontSize = valueOrDefault(opts.fontSize, defaults.global.defaultFontSize);
			var minSize = me.minSize;
			var lineCount = helpers.isArray(opts.text) ? opts.text.length : 1;
			var lineHeight = helpers.options.toLineHeight(opts.lineHeight, fontSize);
			var textSize = display ? (lineCount * lineHeight) + (opts.padding * 2) : 0;

			if (me.isHorizontal()) {
				minSize.width = me.maxWidth; // fill all the width
				minSize.height = textSize;
			} else {
				minSize.width = textSize;
				minSize.height = me.maxHeight; // fill all the height
			}

			me.width = minSize.width;
			me.height = minSize.height;

		},
		afterFit: noop,

		// Shared Methods
		isHorizontal: function() {
			var pos = this.options.position;
			return pos === 'top' || pos === 'bottom';
		},

		// Actually draw the title block on the canvas
		draw: function() {
			var me = this;
			var ctx = me.ctx;
			var valueOrDefault = helpers.valueOrDefault;
			var opts = me.options;
			var globalDefaults = defaults.global;

			if (opts.display) {
				var fontSize = valueOrDefault(opts.fontSize, globalDefaults.defaultFontSize);
				var fontStyle = valueOrDefault(opts.fontStyle, globalDefaults.defaultFontStyle);
				var fontFamily = valueOrDefault(opts.fontFamily, globalDefaults.defaultFontFamily);
				var titleFont = helpers.fontString(fontSize, fontStyle, fontFamily);
				var lineHeight = helpers.options.toLineHeight(opts.lineHeight, fontSize);
				var offset = lineHeight / 2 + opts.padding;
				var rotation = 0;
				var top = me.top;
				var left = me.left;
				var bottom = me.bottom;
				var right = me.right;
				var maxWidth, titleX, titleY;

				ctx.fillStyle = valueOrDefault(opts.fontColor, globalDefaults.defaultFontColor); // render in correct colour
				ctx.font = titleFont;

				// Horizontal
				if (me.isHorizontal()) {
					titleX = left + ((right - left) / 2); // midpoint of the width
					titleY = top + offset;
					maxWidth = right - left;
				} else {
					titleX = opts.position === 'left' ? left + offset : right - offset;
					titleY = top + ((bottom - top) / 2);
					maxWidth = bottom - top;
					rotation = Math.PI * (opts.position === 'left' ? -0.5 : 0.5);
				}

				ctx.save();
				ctx.translate(titleX, titleY);
				ctx.rotate(rotation);
				ctx.textAlign = 'center';
				ctx.textBaseline = 'middle';

				var text = opts.text;
				if (helpers.isArray(text)) {
					var y = 0;
					for (var i = 0; i < text.length; ++i) {
						ctx.fillText(text[i], 0, y, maxWidth);
						y += lineHeight;
					}
				} else {
					ctx.fillText(text, 0, 0, maxWidth);
				}

				ctx.restore();
			}
		}
	});

	function createNewTitleBlockAndAttach(chart, titleOpts) {
		var title = new Chart.Title({
			ctx: chart.ctx,
			options: titleOpts,
			chart: chart
		});

		layout.configure(chart, title, titleOpts);
		layout.addBox(chart, title);
		chart.titleBlock = title;
	}

	return {
		id: 'title',

		beforeInit: function(chart) {
			var titleOpts = chart.options.title;

			if (titleOpts) {
				createNewTitleBlockAndAttach(chart, titleOpts);
			}
		},

		beforeUpdate: function(chart) {
			var titleOpts = chart.options.title;
			var titleBlock = chart.titleBlock;

			if (titleOpts) {
				helpers.mergeIf(titleOpts, defaults.global.title);

				if (titleBlock) {
					layout.configure(chart, titleBlock, titleOpts);
					titleBlock.options = titleOpts;
				} else {
					createNewTitleBlockAndAttach(chart, titleOpts);
				}
			} else if (titleBlock) {
				Chart.layoutService.removeBox(chart, titleBlock);
				delete chart.titleBlock;
			}
		}
	};
};


/***/ }),

/***/ 2687:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _reactRedux = __webpack_require__(268);

var _redux = __webpack_require__(1);

var _teams = __webpack_require__(816);

var _users = __webpack_require__(786);

var _teams2 = __webpack_require__(274);

var _browser_store = __webpack_require__(825);

var _browser_store2 = _interopRequireDefault(_browser_store);

var _team_analytics = __webpack_require__(2688);

var _team_analytics2 = _interopRequireDefault(_team_analytics);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LAST_ANALYTICS_TEAM = 'last_analytics_team'; // Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapStateToProps(state, ownProps) {
    var teams = (0, _teams2.getTeamsList)(state);
    var teamId = _browser_store2.default.getGlobalItem(LAST_ANALYTICS_TEAM, teams.length > 0 ? teams[0].id : '');

    return (0, _extends3.default)({
        initialTeam: state.entities.teams.teams[teamId],
        teams: teams
    }, ownProps);
}

function mapDispatchToProps(dispatch) {
    return {
        actions: (0, _redux.bindActionCreators)({
            getTeams: _teams.getTeams,
            getProfilesInTeam: _users.getProfilesInTeam
        }, dispatch)
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_team_analytics2.default);

/***/ }),

/***/ 2688:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(114);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(115);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

exports.formatRecentUsersData = formatRecentUsersData;
exports.formatNewUsersData = formatNewUsersData;

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _constants = __webpack_require__(19);

var _admin_actions = __webpack_require__(797);

var AdminActions = _interopRequireWildcard(_admin_actions);

var _analytics_store = __webpack_require__(964);

var _analytics_store2 = _interopRequireDefault(_analytics_store);

var _browser_store = __webpack_require__(825);

var _browser_store2 = _interopRequireDefault(_browser_store);

var _constants2 = __webpack_require__(29);

var _banner = __webpack_require__(1455);

var _banner2 = _interopRequireDefault(_banner);

var _line_chart = __webpack_require__(1578);

var _line_chart2 = _interopRequireDefault(_line_chart);

var _statistic_count = __webpack_require__(1579);

var _statistic_count2 = _interopRequireDefault(_statistic_count);

var _table_chart = __webpack_require__(2689);

var _table_chart2 = _interopRequireDefault(_table_chart);

var _loading_screen = __webpack_require__(792);

var _loading_screen2 = _interopRequireDefault(_loading_screen);

var _format = __webpack_require__(1580);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var LAST_ANALYTICS_TEAM = 'last_analytics_team';

var TeamAnalytics = function (_React$Component) {
    (0, _inherits3.default)(TeamAnalytics, _React$Component);

    function TeamAnalytics(props) {
        (0, _classCallCheck3.default)(this, TeamAnalytics);

        var _this = (0, _possibleConstructorReturn3.default)(this, (TeamAnalytics.__proto__ || (0, _getPrototypeOf2.default)(TeamAnalytics)).call(this, props));

        _initialiseProps.call(_this);

        var teamId = props.initialTeam ? props.initialTeam.id : '';

        _this.state = {
            team: props.initialTeam,
            stats: _analytics_store2.default.getAllTeam(teamId),
            recentlyActiveUsers: [],
            newUsers: []
        };
        return _this;
    }

    (0, _createClass3.default)(TeamAnalytics, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _analytics_store2.default.addChangeListener(this.onChange);

            if (this.state.team) {
                this.getData(this.state.team.id);
            }

            this.props.actions.getTeams(0, 1000);
        }
    }, {
        key: 'componentWillUpdate',
        value: function componentWillUpdate(nextProps, nextState) {
            if (nextState.team && nextState.team !== this.state.team) {
                this.getData(nextState.team.id);
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _analytics_store2.default.removeChangeListener(this.onChange);
        }
    }, {
        key: 'render',
        value: function render() {
            if (this.props.teams.length === 0 || !this.state.team || !this.state.stats) {
                return _react2.default.createElement(_loading_screen2.default, null);
            }

            if (this.state.team == null) {
                return _react2.default.createElement(_banner2.default, {
                    description: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'analytics.team.noTeams',
                        defaultMessage: 'There are no teams on this server for which to view statistics.'
                    })
                });
            }

            var stats = this.state.stats;
            var postCountsDay = (0, _format.formatPostsPerDayData)(stats[_constants2.StatTypes.POST_PER_DAY]);
            var userCountsWithPostsDay = (0, _format.formatUsersWithPostsPerDayData)(stats[_constants2.StatTypes.USERS_WITH_POSTS_PER_DAY]);

            var banner = _react2.default.createElement(
                'div',
                { className: 'banner' },
                _react2.default.createElement(
                    'div',
                    { className: 'banner__content' },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'analytics.system.info',
                        defaultMessage: 'Only data for the chosen team is calculated. Excludes posts made in direct message channels, which are not tied to a team.'
                    })
                )
            );

            var totalPostsCount = void 0;
            var postTotalGraph = void 0;
            var userActiveGraph = void 0;
            if (stats[_constants2.StatTypes.TOTAL_POSTS] === -1) {
                banner = _react2.default.createElement(
                    'div',
                    { className: 'banner' },
                    _react2.default.createElement(
                        'div',
                        { className: 'banner__content' },
                        _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                            id: 'analytics.system.infoAndSkippedIntensiveQueries',
                            defaultMessage: 'Only data for the chosen team is calculated. Excludes posts made in direct message channels, which are not tied to a team. <br><br> Some statistics have been omitted because they put too much load on the system to calculate. See <a href=\'https://docs.mattermost.com/administration/statistics.html\' target=\'_blank\'>https://docs.mattermost.com/administration/statistics.html</a> for more details.'
                        })
                    )
                );
            } else {
                totalPostsCount = _react2.default.createElement(_statistic_count2.default, {
                    title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'analytics.team.totalPosts',
                        defaultMessage: 'Total Posts'
                    }),
                    icon: 'fa-comment',
                    count: stats[_constants2.StatTypes.TOTAL_POSTS]
                });

                postTotalGraph = _react2.default.createElement(
                    'div',
                    { className: 'row' },
                    _react2.default.createElement(_line_chart2.default, {
                        key: this.state.team.id,
                        title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'analytics.team.totalPosts',
                            defaultMessage: 'Total Posts'
                        }),
                        data: postCountsDay,
                        width: 740,
                        height: 225
                    })
                );

                userActiveGraph = _react2.default.createElement(
                    'div',
                    { className: 'row' },
                    _react2.default.createElement(_line_chart2.default, {
                        key: this.state.team.id,
                        title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'analytics.team.activeUsers',
                            defaultMessage: 'Active Users With Posts'
                        }),
                        data: userCountsWithPostsDay,
                        width: 740,
                        height: 225
                    })
                );
            }

            var recentActiveUsers = formatRecentUsersData(this.state.recentlyActiveUsers);
            var newlyCreatedUsers = formatNewUsersData(this.state.newUsers);

            var teams = this.props.teams.map(function (team) {
                return _react2.default.createElement(
                    'option',
                    {
                        key: team.id,
                        value: team.id
                    },
                    team.display_name
                );
            });

            return _react2.default.createElement(
                'div',
                { className: 'wrapper--fixed team_statistics' },
                _react2.default.createElement(
                    'div',
                    { className: 'admin-console-header team-statistics__header-row' },
                    _react2.default.createElement(
                        'div',
                        { className: 'team-statistics__header' },
                        _react2.default.createElement(
                            'h3',
                            null,
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'analytics.team.title',
                                defaultMessage: 'Team Statistics for {team}',
                                values: {
                                    team: this.state.team.display_name
                                }
                            })
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'team-statistics__team-filter' },
                        _react2.default.createElement(
                            'select',
                            {
                                className: 'form-control team-statistics__team-filter__dropdown',
                                onChange: this.handleTeamChange,
                                value: this.state.team.id
                            },
                            teams
                        )
                    )
                ),
                banner,
                _react2.default.createElement(
                    'div',
                    { className: 'row' },
                    _react2.default.createElement(_statistic_count2.default, {
                        title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'analytics.team.totalUsers',
                            defaultMessage: 'Total Users'
                        }),
                        icon: 'fa-user',
                        count: stats[_constants2.StatTypes.TOTAL_USERS]
                    }),
                    _react2.default.createElement(_statistic_count2.default, {
                        title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'analytics.team.publicChannels',
                            defaultMessage: 'Public Channels'
                        }),
                        icon: 'fa-users',
                        count: stats[_constants2.StatTypes.TOTAL_PUBLIC_CHANNELS]
                    }),
                    _react2.default.createElement(_statistic_count2.default, {
                        title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'analytics.team.privateGroups',
                            defaultMessage: 'Private Channels'
                        }),
                        icon: 'fa-globe',
                        count: stats[_constants2.StatTypes.TOTAL_PRIVATE_GROUPS]
                    }),
                    totalPostsCount
                ),
                postTotalGraph,
                userActiveGraph,
                _react2.default.createElement(
                    'div',
                    { className: 'row' },
                    _react2.default.createElement(_table_chart2.default, {
                        title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'analytics.team.recentUsers',
                            defaultMessage: 'Recent Active Users'
                        }),
                        data: recentActiveUsers
                    }),
                    _react2.default.createElement(_table_chart2.default, {
                        title: _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'analytics.team.newlyCreated',
                            defaultMessage: 'Newly Created Users'
                        }),
                        data: newlyCreatedUsers
                    })
                )
            );
        }
    }]);
    return TeamAnalytics;
}(_react2.default.Component);

TeamAnalytics.propTypes = {

    /*
     * Array of team objects
     */
    teams: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,

    /*
     * Initial team to load analytics for
     */
    initialTeam: _propTypes2.default.object,

    actions: _propTypes2.default.shape({

        /*
         * Function to get teams
         */
        getTeams: _propTypes2.default.func.isRequired,

        /*
         * Function to get users in a team
         */
        getProfilesInTeam: _propTypes2.default.func.isRequired
    }).isRequired
};

var _initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this.getData = function () {
        var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(id) {
            var _ref2, recentlyActiveUsers, _ref3, newUsers;

            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            AdminActions.getStandardAnalytics(id);
                            AdminActions.getPostsPerDayAnalytics(id);
                            AdminActions.getUsersPerDayAnalytics(id);
                            _context.next = 5;
                            return _this2.props.actions.getProfilesInTeam(id, 0, _constants.General.PROFILE_CHUNK_SIZE, 'last_activity_at');

                        case 5:
                            _ref2 = _context.sent;
                            recentlyActiveUsers = _ref2.data;
                            _context.next = 9;
                            return _this2.props.actions.getProfilesInTeam(id, 0, _constants.General.PROFILE_CHUNK_SIZE, 'create_at');

                        case 9:
                            _ref3 = _context.sent;
                            newUsers = _ref3.data;


                            _this2.setState({
                                recentlyActiveUsers: recentlyActiveUsers,
                                newUsers: newUsers
                            });

                        case 12:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this2);
        }));

        return function (_x) {
            return _ref.apply(this, arguments);
        };
    }();

    this.onChange = function () {
        var teamId = _this2.state.team ? _this2.state.team.id : '';
        _this2.setState({
            stats: _analytics_store2.default.getAllTeam(teamId)
        });
    };

    this.handleTeamChange = function (e) {
        var teamId = e.target.value;

        var team = void 0;
        _this2.props.teams.forEach(function (t) {
            if (t.id === teamId) {
                team = t;
            }
        });

        _this2.setState({
            team: team
        });

        _browser_store2.default.setGlobalItem(LAST_ANALYTICS_TEAM, teamId);
    };
};

exports.default = TeamAnalytics;
function formatRecentUsersData(data) {
    if (data == null) {
        return [];
    }

    var formattedData = data.map(function (user) {
        var item = {};
        item.name = user.username;
        item.value = _react2.default.createElement(_reactIntl.FormattedDate, {
            value: user.last_activity_at,
            day: 'numeric',
            month: 'long',
            year: 'numeric',
            hour12: true,
            hour: '2-digit',
            minute: '2-digit'
        });
        item.tip = user.email;

        return item;
    });

    return formattedData;
}

function formatNewUsersData(data) {
    if (data == null) {
        return [];
    }

    var formattedData = data.map(function (user) {
        var item = {};
        item.name = user.username;
        item.value = _react2.default.createElement(_reactIntl.FormattedDate, {
            value: user.create_at,
            day: 'numeric',
            month: 'long',
            year: 'numeric',
            hour12: true,
            hour: '2-digit',
            minute: '2-digit'
        });
        item.tip = user.email;

        return item;
    });

    return formattedData;
}

/***/ }),

/***/ 2689:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__(772);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var TableChart = function (_React$PureComponent) {
    (0, _inherits3.default)(TableChart, _React$PureComponent);

    function TableChart() {
        (0, _classCallCheck3.default)(this, TableChart);
        return (0, _possibleConstructorReturn3.default)(this, (TableChart.__proto__ || (0, _getPrototypeOf2.default)(TableChart)).apply(this, arguments));
    }

    (0, _createClass3.default)(TableChart, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'col-sm-6' },
                _react2.default.createElement(
                    'div',
                    { className: 'total-count recent-active-users' },
                    _react2.default.createElement(
                        'div',
                        { className: 'title' },
                        this.props.title
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'content' },
                        _react2.default.createElement(
                            'table',
                            null,
                            _react2.default.createElement(
                                'tbody',
                                null,
                                this.props.data.map(function (item) {
                                    var tooltip = _react2.default.createElement(
                                        _reactBootstrap.Tooltip,
                                        { id: 'tip-table-entry-' + item.name },
                                        item.tip
                                    );

                                    return _react2.default.createElement(
                                        'tr',
                                        { key: 'table-entry-' + item.name },
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            _react2.default.createElement(
                                                _reactBootstrap.OverlayTrigger,
                                                {
                                                    trigger: ['hover', 'focus'],
                                                    delayShow: _constants2.default.OVERLAY_TIME_DELAY,
                                                    placement: 'top',
                                                    overlay: tooltip
                                                },
                                                _react2.default.createElement(
                                                    'time',
                                                    null,
                                                    item.name
                                                )
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'td',
                                            null,
                                            item.value
                                        )
                                    );
                                })
                            )
                        )
                    )
                )
            );
        }
    }]);
    return TableChart;
}(_react2.default.PureComponent);

TableChart.propTypes = {

    /*
     * Table title
     */
    title: _propTypes2.default.node.isRequired,

    /*
     * Table data
     */
    data: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        name: _propTypes2.default.string.isRequired,
        tip: _propTypes2.default.string.isRequired,
        value: _propTypes2.default.node.isRequired
    })).isRequired
};
exports.default = TableChart;

/***/ }),

/***/ 2690:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _redux = __webpack_require__(1);

var _teams = __webpack_require__(816);

var _users = __webpack_require__(786);

var _teams2 = __webpack_require__(274);

var _general = __webpack_require__(113);

var _system_users = __webpack_require__(2691);

var _system_users2 = _interopRequireDefault(_system_users);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state) {
    var license = (0, _general.getLicense)(state);
    var config = (0, _general.getConfig)(state);

    var siteName = config.SiteName;
    var mfaEnabled = license && license.IsLicensed === 'true' && license.MFA === 'true' && config.EnableMultifactorAuthentication === 'true';
    var enableUserAccessTokens = config.EnableUserAccessTokens === 'true';
    var experimentalEnableAuthenticationTransfer = config.ExperimentalEnableAuthenticationTransfer === 'true';

    return {
        teams: (0, _teams2.getTeamsList)(state),
        siteName: siteName,
        mfaEnabled: mfaEnabled,
        enableUserAccessTokens: enableUserAccessTokens,
        experimentalEnableAuthenticationTransfer: experimentalEnableAuthenticationTransfer
    };
} // Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapDispatchToProps(dispatch) {
    return {
        actions: (0, _redux.bindActionCreators)({
            getTeams: _teams.getTeams,
            getTeamStats: _teams.getTeamStats,
            getUser: _users.getUser,
            getUserAccessToken: _users.getUserAccessToken
        }, dispatch)
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_system_users2.default);

/***/ }),

/***/ 2691:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(277);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _regenerator = __webpack_require__(114);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(115);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _users = __webpack_require__(777);

var _admin_actions = __webpack_require__(797);

var _global_actions = __webpack_require__(778);

var _user_actions = __webpack_require__(781);

var _analytics_store = __webpack_require__(964);

var _analytics_store2 = _interopRequireDefault(_analytics_store);

var _redux_store = __webpack_require__(271);

var _redux_store2 = _interopRequireDefault(_redux_store);

var _team_store = __webpack_require__(779);

var _team_store2 = _interopRequireDefault(_team_store);

var _user_store = __webpack_require__(774);

var _user_store2 = _interopRequireDefault(_user_store);

var _constants = __webpack_require__(29);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _system_users_list = __webpack_require__(2692);

var _system_users_list2 = _interopRequireDefault(_system_users_list);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var ALL_USERS = '';
var NO_TEAM = 'no_team';

var USER_ID_LENGTH = 26;
var USERS_PER_PAGE = 50;

var SystemUsers = function (_React$Component) {
    (0, _inherits3.default)(SystemUsers, _React$Component);

    function SystemUsers(props) {
        var _this2 = this;

        (0, _classCallCheck3.default)(this, SystemUsers);

        var _this = (0, _possibleConstructorReturn3.default)(this, (SystemUsers.__proto__ || (0, _getPrototypeOf2.default)(SystemUsers)).call(this, props));

        _this.getUserByTokenOrId = function () {
            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(id) {
                var _ref2, data;

                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (!_this.props.enableUserAccessTokens) {
                                    _context.next = 11;
                                    break;
                                }

                                _context.next = 3;
                                return _this.props.actions.getUserAccessToken(id);

                            case 3:
                                _ref2 = _context.sent;
                                data = _ref2.data;

                                if (!data) {
                                    _context.next = 11;
                                    break;
                                }

                                _this.term = data.user_id;
                                _this.setState({ term: data.user_id });
                                _this.updateUsersFromStore(_this.state.teamId, data.user_id);
                                _this.getUserById(data.user_id);
                                return _context.abrupt('return');

                            case 11:

                                _this.getUserById(id);

                            case 12:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }));

            return function (_x) {
                return _ref.apply(this, arguments);
            };
        }();

        _this.updateTotalUsersFromStore = _this.updateTotalUsersFromStore.bind(_this);
        _this.updateUsersFromStore = _this.updateUsersFromStore.bind(_this);

        _this.loadDataForTeam = _this.loadDataForTeam.bind(_this);
        _this.loadComplete = _this.loadComplete.bind(_this);

        _this.handleTeamChange = _this.handleTeamChange.bind(_this);
        _this.handleTermChange = _this.handleTermChange.bind(_this);
        _this.nextPage = _this.nextPage.bind(_this);

        _this.doSearch = _this.doSearch.bind(_this);
        _this.search = _this.search.bind(_this);
        _this.getUserById = _this.getUserById.bind(_this);

        _this.renderFilterRow = _this.renderFilterRow.bind(_this);

        _this.state = {
            totalUsers: _analytics_store2.default.getAllSystem()[_constants.StatTypes.TOTAL_USERS],
            users: _user_store2.default.getProfileList(),

            teamId: ALL_USERS,
            term: '',
            loading: true,
            searching: false
        };
        return _this;
    }

    (0, _createClass3.default)(SystemUsers, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _analytics_store2.default.addChangeListener(this.updateTotalUsersFromStore);
            _team_store2.default.addStatsChangeListener(this.updateTotalUsersFromStore);

            _user_store2.default.addChangeListener(this.updateUsersFromStore);
            _user_store2.default.addInTeamChangeListener(this.updateUsersFromStore);
            _user_store2.default.addWithoutTeamChangeListener(this.updateUsersFromStore);

            this.loadDataForTeam(this.state.teamId);
            this.props.actions.getTeams(0, 1000).then(_global_actions.reloadIfServerVersionChanged);
        }
    }, {
        key: 'componentWillUpdate',
        value: function componentWillUpdate(nextProps, nextState) {
            var nextTeamId = nextState.teamId;

            if (this.state.teamId !== nextTeamId) {
                this.updateTotalUsersFromStore(nextTeamId);
                this.updateUsersFromStore(nextTeamId, nextState.term);

                this.loadDataForTeam(nextTeamId);
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _analytics_store2.default.removeChangeListener(this.updateTotalUsersFromStore);
            _team_store2.default.removeStatsChangeListener(this.updateTotalUsersFromStore);

            _user_store2.default.removeChangeListener(this.updateUsersFromStore);
            _user_store2.default.removeInTeamChangeListener(this.updateUsersFromStore);
            _user_store2.default.removeWithoutTeamChangeListener(this.updateUsersFromStore);
        }
    }, {
        key: 'updateTotalUsersFromStore',
        value: function updateTotalUsersFromStore() {
            var teamId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state.teamId;

            if (teamId === ALL_USERS) {
                this.setState({
                    totalUsers: _analytics_store2.default.getAllSystem()[_constants.StatTypes.TOTAL_USERS]
                });
            } else if (teamId === NO_TEAM) {
                this.setState({
                    totalUsers: 0
                });
            } else {
                this.setState({
                    totalUsers: _team_store2.default.getStats(teamId).total_member_count
                });
            }
        }
    }, {
        key: 'updateUsersFromStore',
        value: function updateUsersFromStore() {
            var teamId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state.teamId;
            var term = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state.term;

            if (term) {
                var users = void 0;
                if (teamId) {
                    users = (0, _users.searchProfilesInTeam)(_redux_store2.default.getState(), teamId, term);
                } else {
                    users = (0, _users.searchProfiles)(_redux_store2.default.getState(), term);
                }

                if (users.length === 0 && _user_store2.default.hasProfile(term)) {
                    users = [_user_store2.default.getProfile(term)];
                }

                this.setState({ users: users });
                return;
            }

            if (teamId === ALL_USERS) {
                this.setState({ users: _user_store2.default.getProfileList(false, true) });
            } else if (teamId === NO_TEAM) {
                this.setState({ users: _user_store2.default.getProfileListWithoutTeam() });
            } else {
                this.setState({ users: _user_store2.default.getProfileListInTeam(this.state.teamId) });
            }
        }
    }, {
        key: 'loadDataForTeam',
        value: function loadDataForTeam(teamId) {
            if (this.state.term) {
                this.search(this.state.term, teamId);
                return;
            }

            if (teamId === ALL_USERS) {
                (0, _user_actions.loadProfiles)(0, _constants.Constants.PROFILE_CHUNK_SIZE, this.loadComplete);
                (0, _admin_actions.getStandardAnalytics)();
            } else if (teamId === NO_TEAM) {
                (0, _user_actions.loadProfilesWithoutTeam)(0, _constants.Constants.PROFILE_CHUNK_SIZE, this.loadComplete);
            } else {
                (0, _user_actions.loadProfilesAndTeamMembers)(0, _constants.Constants.PROFILE_CHUNK_SIZE, teamId, this.loadComplete);
                this.props.actions.getTeamStats(teamId);
            }
        }
    }, {
        key: 'loadComplete',
        value: function loadComplete() {
            this.setState({ loading: false });
        }
    }, {
        key: 'handleTeamChange',
        value: function handleTeamChange(e) {
            this.setState({ teamId: e.target.value });
        }
    }, {
        key: 'handleTermChange',
        value: function handleTermChange(term) {
            this.setState({ term: term });
        }
    }, {
        key: 'nextPage',
        value: function nextPage(page) {
            // Paging isn't supported while searching

            if (this.state.teamId === ALL_USERS) {
                (0, _user_actions.loadProfiles)(page + 1, USERS_PER_PAGE, this.loadComplete);
            } else if (this.state.teamId === NO_TEAM) {
                (0, _user_actions.loadProfilesWithoutTeam)(page + 1, USERS_PER_PAGE, this.loadComplete);
            } else {
                (0, _user_actions.loadProfilesAndTeamMembers)(page + 1, USERS_PER_PAGE, this.state.teamId, this.loadComplete);
            }
        }
    }, {
        key: 'search',
        value: function search(term) {
            var teamId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state.teamId;

            if (term === '') {
                this.updateUsersFromStore(teamId, term);

                this.setState({
                    loading: false
                });

                this.searchTimeoutId = '';
                return;
            }

            this.doSearch(teamId, term);
        }
    }, {
        key: 'doSearch',
        value: function doSearch(teamId, term) {
            var _this3 = this;

            var now = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

            clearTimeout(this.searchTimeoutId);
            this.term = term;

            this.setState({ loading: true });

            var options = (0, _defineProperty3.default)({}, _constants.UserSearchOptions.ALLOW_INACTIVE, true);
            if (teamId === NO_TEAM) {
                options[_constants.UserSearchOptions.WITHOUT_TEAM] = true;
            }

            this.searchTimeoutId = setTimeout(function () {
                (0, _user_actions.searchUsers)(term, teamId, options, function (users) {
                    if (users.length === 0 && term.length === USER_ID_LENGTH) {
                        // This term didn't match any users name, but it does look like it might be a user's ID
                        _this3.getUserByTokenOrId(term);
                    } else {
                        _this3.setState({ loading: false });
                    }
                }, function () {
                    _this3.setState({ loading: false });
                });
            }, now ? 0 : _constants.Constants.SEARCH_TIMEOUT_MILLISECONDS);
        }
    }, {
        key: 'getUserById',
        value: function getUserById(id) {
            var _this4 = this;

            if (_user_store2.default.hasProfile(id)) {
                this.setState({ loading: false });
                return;
            }

            this.props.actions.getUser(id).then(function () {
                _this4.setState({
                    loading: false
                });
            });
        }
    }, {
        key: 'renderFilterRow',
        value: function renderFilterRow(doSearch) {
            var teams = this.props.teams.map(function (team) {
                return _react2.default.createElement(
                    'option',
                    {
                        key: team.id,
                        value: team.id
                    },
                    team.display_name
                );
            });

            return _react2.default.createElement(
                'div',
                { className: 'system-users__filter-row' },
                _react2.default.createElement(
                    'div',
                    { className: 'system-users__filter' },
                    _react2.default.createElement('input', {
                        id: 'searchUsers',
                        ref: 'filter',
                        className: 'form-control filter-textbox',
                        placeholder: Utils.localizeMessage('filtered_user_list.search', 'Search users'),
                        onInput: doSearch
                    })
                ),
                _react2.default.createElement(
                    'label',
                    null,
                    _react2.default.createElement(
                        'span',
                        { className: 'system-users__team-filter-label' },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'filtered_user_list.show',
                            defaultMessage: 'Filter:'
                        })
                    ),
                    _react2.default.createElement(
                        'select',
                        {
                            className: 'form-control system-users__team-filter',
                            onChange: this.handleTeamChange,
                            value: this.state.teamId
                        },
                        _react2.default.createElement(
                            'option',
                            { value: ALL_USERS },
                            Utils.localizeMessage('admin.system_users.allUsers', 'All Users')
                        ),
                        _react2.default.createElement(
                            'option',
                            { value: NO_TEAM },
                            Utils.localizeMessage('admin.system_users.noTeams', 'No Teams')
                        ),
                        teams
                    )
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var users = null;
            if (!this.state.loading) {
                users = this.state.users;
            }

            return _react2.default.createElement(
                'div',
                { className: 'wrapper--fixed' },
                _react2.default.createElement(
                    'h3',
                    { className: 'admin-console-header' },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.system_users.title',
                        defaultMessage: '{siteName} Users',
                        values: {
                            siteName: this.props.siteName
                        }
                    })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'more-modal__list member-list-holder' },
                    _react2.default.createElement(_system_users_list2.default, {
                        renderFilterRow: this.renderFilterRow,
                        search: this.search,
                        nextPage: this.nextPage,
                        users: users,
                        usersPerPage: USERS_PER_PAGE,
                        total: this.state.totalUsers,
                        teams: this.props.teams,
                        teamId: this.state.teamId,
                        term: this.state.term,
                        onTermChange: this.handleTermChange,
                        mfaEnabled: this.props.mfaEnabled,
                        enableUserAccessTokens: this.props.enableUserAccessTokens,
                        experimentalEnableAuthenticationTransfer: this.props.experimentalEnableAuthenticationTransfer
                    })
                )
            );
        }
    }]);
    return SystemUsers;
}(_react2.default.Component);

SystemUsers.propTypes = {

    /*
     * Array of team objects
     */
    teams: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,

    /**
     * Title of the app or site.
     */
    siteName: _propTypes2.default.string,

    /**
     * Whether or not MFA is licensed and enabled.
     */
    mfaEnabled: _propTypes2.default.bool.isRequired,

    /**
     * Whether or not user access tokens are enabled.
     */
    enableUserAccessTokens: _propTypes2.default.bool.isRequired,

    /**
     * Whether or not the experimental authentication transfer is enabled.
     */
    experimentalEnableAuthenticationTransfer: _propTypes2.default.bool.isRequired,

    actions: _propTypes2.default.shape({

        /*
         * Function to get teams
         */
        getTeams: _propTypes2.default.func.isRequired,

        /*
         * Function to get statistics for a team
         */
        getTeamStats: _propTypes2.default.func.isRequired,

        /*
         * Function to get a user
         */
        getUser: _propTypes2.default.func.isRequired,

        /*
         * Function to get a user access token
         */
        getUserAccessToken: _propTypes2.default.func.isRequired
    }).isRequired
};
exports.default = SystemUsers;

/***/ }),

/***/ 2692:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _getIterator2 = __webpack_require__(782);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _users = __webpack_require__(786);

var _redux_store = __webpack_require__(271);

var _redux_store2 = _interopRequireDefault(_redux_store);

var _constants = __webpack_require__(29);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _manage_roles_modal = __webpack_require__(2693);

var _manage_roles_modal2 = _interopRequireDefault(_manage_roles_modal);

var _manage_teams_modal = __webpack_require__(2695);

var _manage_teams_modal2 = _interopRequireDefault(_manage_teams_modal);

var _manage_tokens_modal = __webpack_require__(2698);

var _manage_tokens_modal2 = _interopRequireDefault(_manage_tokens_modal);

var _reset_password_modal = __webpack_require__(2702);

var _reset_password_modal2 = _interopRequireDefault(_reset_password_modal);

var _searchable_user_list = __webpack_require__(1335);

var _searchable_user_list2 = _interopRequireDefault(_searchable_user_list);

var _user_list_row_with_error = __webpack_require__(2704);

var _user_list_row_with_error2 = _interopRequireDefault(_user_list_row_with_error);

var _system_users_dropdown = __webpack_require__(2705);

var _system_users_dropdown2 = _interopRequireDefault(_system_users_dropdown);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var dispatch = _redux_store2.default.dispatch;
var getState = _redux_store2.default.getState;

var SystemUsersList = function (_React$Component) {
    (0, _inherits3.default)(SystemUsersList, _React$Component);

    function SystemUsersList(props) {
        (0, _classCallCheck3.default)(this, SystemUsersList);

        var _this = (0, _possibleConstructorReturn3.default)(this, (SystemUsersList.__proto__ || (0, _getPrototypeOf2.default)(SystemUsersList)).call(this, props));

        _this.nextPage = function () {
            _this.setState({ page: _this.state.page + 1 });

            _this.props.nextPage(_this.state.page + 1);
        };

        _this.previousPage = function () {
            _this.setState({ page: _this.state.page - 1 });
        };

        _this.search = function (term) {
            _this.props.search(term);

            if (term !== '') {
                _this.setState({ page: 0 });
            }
        };

        _this.doManageTeams = function (user) {
            _this.setState({
                showManageTeamsModal: true,
                user: user
            });
        };

        _this.doManageRoles = function (user) {
            _this.setState({
                showManageRolesModal: true,
                user: user
            });
        };

        _this.doManageTokens = function (user) {
            _this.setState({
                showManageTokensModal: true,
                user: user
            });
        };

        _this.doManageTeamsDismiss = function () {
            _this.setState({
                showManageTeamsModal: false,
                user: null
            });
        };

        _this.doManageRolesDismiss = function () {
            _this.setState({
                showManageRolesModal: false,
                user: null
            });
        };

        _this.doManageTokensDismiss = function () {
            _this.setState({
                showManageTokensModal: false,
                user: null
            });
        };

        _this.doPasswordReset = function (user) {
            _this.setState({
                showPasswordModal: true,
                user: user
            });
        };

        _this.doPasswordResetDismiss = function () {
            _this.setState({
                showPasswordModal: false,
                user: null
            });
        };

        _this.doPasswordResetSubmit = function (user) {
            (0, _users.getUser)(user.id)(dispatch, getState);

            _this.setState({
                showPasswordModal: false,
                user: null
            });
        };

        _this.state = {
            page: 0,

            showManageTeamsModal: false,
            showManageRolesModal: false,
            showManageTokensModal: false,
            showPasswordModal: false,
            user: null
        };
        return _this;
    }

    (0, _createClass3.default)(SystemUsersList, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.teamId !== this.props.teamId) {
                this.setState({ page: 0 });
            }
        }
    }, {
        key: 'getInfoForUser',
        value: function getInfoForUser(user) {
            var info = [];

            if (user.auth_service) {
                var service = void 0;
                if (user.auth_service === _constants.Constants.LDAP_SERVICE || user.auth_service === _constants.Constants.SAML_SERVICE) {
                    service = user.auth_service.toUpperCase();
                } else {
                    service = Utils.toTitleCase(user.auth_service);
                }

                info.push(_react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                    key: 'admin.user_item.authServiceNotEmail',
                    id: 'admin.user_item.authServiceNotEmail',
                    defaultMessage: '<strong>Sign-in Method:</strong> {service}',
                    values: {
                        service: service
                    }
                }));
            } else {
                info.push(_react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                    key: 'admin.user_item.authServiceEmail',
                    id: 'admin.user_item.authServiceEmail',
                    defaultMessage: '<strong>Sign-in Method:</strong> Email'
                }));
            }

            if (this.props.mfaEnabled) {
                info.push(', ');

                if (user.mfa_active) {
                    info.push(_react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                        key: 'admin.user_item.mfaYes',
                        id: 'admin.user_item.mfaYes',
                        defaultMessage: '<strong>MFA</strong>: Yes'
                    }));
                } else {
                    info.push(_react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                        key: 'admin.user_item.mfaNo',
                        id: 'admin.user_item.mfaNo',
                        defaultMessage: '<strong>MFA</strong>: No'
                    }));
                }
            }

            return info;
        }
    }, {
        key: 'renderCount',
        value: function renderCount(count, total, startCount, endCount, isSearch) {
            if (total) {
                if (isSearch) {
                    return _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'system_users_list.countSearch',
                        defaultMessage: '{count, number} {count, plural, one {user} other {users}} of {total, number} total',
                        values: {
                            count: count,
                            total: total
                        }
                    });
                } else if (startCount !== 0 || endCount !== total) {
                    return _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'system_users_list.countPage',
                        defaultMessage: '{startCount, number} - {endCount, number} {count, plural, one {user} other {users}} of {total, number} total',
                        values: {
                            count: count,
                            startCount: startCount + 1,
                            endCount: endCount,
                            total: total
                        }
                    });
                }

                return _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'system_users_list.count',
                    defaultMessage: '{count, number} {count, plural, one {user} other {users}}',
                    values: {
                        count: count
                    }
                });
            }

            return null;
        }
    }, {
        key: 'render',
        value: function render() {
            var extraInfo = {};
            if (this.props.users) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = (0, _getIterator3.default)(this.props.users), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var user = _step.value;

                        extraInfo[user.id] = this.getInfoForUser(user);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_searchable_user_list2.default, (0, _extends3.default)({}, this.props, {
                    renderCount: this.renderCount,
                    extraInfo: extraInfo,
                    actions: [_system_users_dropdown2.default],
                    actionProps: {
                        mfaEnabled: this.props.mfaEnabled,
                        enableUserAccessTokens: this.props.enableUserAccessTokens,
                        experimentalEnableAuthenticationTransfer: this.props.experimentalEnableAuthenticationTransfer,
                        doPasswordReset: this.doPasswordReset,
                        doManageTeams: this.doManageTeams,
                        doManageRoles: this.doManageRoles,
                        doManageTokens: this.doManageTokens
                    },
                    nextPage: this.nextPage,
                    previousPage: this.previousPage,
                    search: this.search,
                    page: this.state.page,
                    term: this.props.term,
                    onTermChange: this.props.onTermChange,
                    rowComponentType: _user_list_row_with_error2.default
                })),
                _react2.default.createElement(_manage_teams_modal2.default, {
                    user: this.state.user,
                    show: this.state.showManageTeamsModal,
                    onModalDismissed: this.doManageTeamsDismiss
                }),
                _react2.default.createElement(_manage_roles_modal2.default, {
                    user: this.state.user,
                    show: this.state.showManageRolesModal,
                    onModalDismissed: this.doManageRolesDismiss
                }),
                _react2.default.createElement(_manage_tokens_modal2.default, {
                    user: this.state.user,
                    show: this.state.showManageTokensModal,
                    onModalDismissed: this.doManageTokensDismiss
                }),
                _react2.default.createElement(_reset_password_modal2.default, {
                    user: this.state.user,
                    show: this.state.showPasswordModal,
                    onModalSubmit: this.doPasswordResetSubmit,
                    onModalDismissed: this.doPasswordResetDismiss
                })
            );
        }
    }]);
    return SystemUsersList;
}(_react2.default.Component);

SystemUsersList.propTypes = {
    users: _propTypes2.default.arrayOf(_propTypes2.default.object),
    usersPerPage: _propTypes2.default.number,
    total: _propTypes2.default.number,
    nextPage: _propTypes2.default.func,
    search: _propTypes2.default.func.isRequired,
    focusOnMount: _propTypes2.default.bool,
    renderFilterRow: _propTypes2.default.func,

    teamId: _propTypes2.default.string.isRequired,
    term: _propTypes2.default.string.isRequired,
    onTermChange: _propTypes2.default.func.isRequired,

    /**
     * Whether MFA is licensed and enabled.
     */
    mfaEnabled: _propTypes2.default.bool.isRequired,

    /**
     * Whether or not user access tokens are enabled.
     */
    enableUserAccessTokens: _propTypes2.default.bool.isRequired,

    /**
     * Whether or not the experimental authentication transfer is enabled.
     */
    experimentalEnableAuthenticationTransfer: _propTypes2.default.bool.isRequired
};
exports.default = SystemUsersList;

/***/ }),

/***/ 2693:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _reactRedux = __webpack_require__(268);

var _redux = __webpack_require__(1);

var _users = __webpack_require__(786);

var _manage_roles_modal = __webpack_require__(2694);

var _manage_roles_modal2 = _interopRequireDefault(_manage_roles_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapStateToProps(state, ownProps) {
    return (0, _extends3.default)({}, ownProps, {
        userAccessTokensEnabled: state.entities.admin.config.ServiceSettings.EnableUserAccessTokens
    });
}

function mapDispatchToProps(dispatch) {
    return {
        actions: (0, _redux.bindActionCreators)({
            updateUserRoles: _users.updateUserRoles
        }, dispatch)
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_manage_roles_modal2.default);

/***/ }),

/***/ 2694:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(114);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(115);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__(772);

var _reactIntl = __webpack_require__(761);

var _client = __webpack_require__(270);

var _constants = __webpack_require__(19);

var _user_utils = __webpack_require__(175);

var UserUtils = _interopRequireWildcard(_user_utils);

var _diagnostics_actions = __webpack_require__(804);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function getStateFromProps(props) {
    var roles = props.user && props.user.roles ? props.user.roles : '';

    return {
        error: null,
        hasPostAllRole: UserUtils.hasPostAllRole(roles),
        hasPostAllPublicRole: UserUtils.hasPostAllPublicRole(roles),
        hasUserAccessTokenRole: UserUtils.hasUserAccessTokenRole(roles),
        isSystemAdmin: UserUtils.isSystemAdmin(roles)
    };
}

var ManageRolesModal = function (_React$PureComponent) {
    (0, _inherits3.default)(ManageRolesModal, _React$PureComponent);

    function ManageRolesModal(props) {
        var _this2 = this;

        (0, _classCallCheck3.default)(this, ManageRolesModal);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ManageRolesModal.__proto__ || (0, _getPrototypeOf2.default)(ManageRolesModal)).call(this, props));

        _this.handleError = function (error) {
            _this.setState({
                error: error
            });
        };

        _this.handleSystemAdminChange = function (e) {
            if (e.target.name === 'systemadmin') {
                _this.setState({ isSystemAdmin: true });
            } else if (e.target.name === 'systemmember') {
                _this.setState({ isSystemAdmin: false });
            }
        };

        _this.handleUserAccessTokenChange = function (e) {
            _this.setState({
                hasUserAccessTokenRole: e.target.checked
            });
        };

        _this.handlePostAllChange = function (e) {
            _this.setState({
                hasPostAllRole: e.target.checked
            });
        };

        _this.handlePostAllPublicChange = function (e) {
            _this.setState({
                hasPostAllPublicRole: e.target.checked
            });
        };

        _this.trackRoleChanges = function (roles, oldRoles) {
            if (UserUtils.hasUserAccessTokenRole(roles) && !UserUtils.hasUserAccessTokenRole(oldRoles)) {
                (0, _diagnostics_actions.trackEvent)('actions', 'add_roles', { role: _constants.General.SYSTEM_USER_ACCESS_TOKEN_ROLE });
            } else if (!UserUtils.hasUserAccessTokenRole(roles) && UserUtils.hasUserAccessTokenRole(oldRoles)) {
                (0, _diagnostics_actions.trackEvent)('actions', 'remove_roles', { role: _constants.General.SYSTEM_USER_ACCESS_TOKEN_ROLE });
            }

            if (UserUtils.hasPostAllRole(roles) && !UserUtils.hasPostAllRole(oldRoles)) {
                (0, _diagnostics_actions.trackEvent)('actions', 'add_roles', { role: _constants.General.SYSTEM_POST_ALL_ROLE });
            } else if (!UserUtils.hasPostAllRole(roles) && UserUtils.hasPostAllRole(oldRoles)) {
                (0, _diagnostics_actions.trackEvent)('actions', 'remove_roles', { role: _constants.General.SYSTEM_POST_ALL_ROLE });
            }

            if (UserUtils.hasPostAllPublicRole(roles) && !UserUtils.hasPostAllPublicRole(oldRoles)) {
                (0, _diagnostics_actions.trackEvent)('actions', 'add_roles', { role: _constants.General.SYSTEM_POST_ALL_PUBLIC_ROLE });
            } else if (!UserUtils.hasPostAllPublicRole(roles) && UserUtils.hasPostAllPublicRole(oldRoles)) {
                (0, _diagnostics_actions.trackEvent)('actions', 'remove_roles', { role: _constants.General.SYSTEM_POST_ALL_PUBLIC_ROLE });
            }
        };

        _this.handleSave = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
            var roles, _ref2, data;

            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _this.setState({ error: null });

                            roles = _constants.General.SYSTEM_USER_ROLE;


                            if (_this.state.isSystemAdmin) {
                                roles += ' ' + _constants.General.SYSTEM_ADMIN_ROLE;
                            } else if (_this.state.hasUserAccessTokenRole) {
                                roles += ' ' + _constants.General.SYSTEM_USER_ACCESS_TOKEN_ROLE;
                                if (_this.state.hasPostAllRole) {
                                    roles += ' ' + _constants.General.SYSTEM_POST_ALL_ROLE;
                                } else if (_this.state.hasPostAllPublicRole) {
                                    roles += ' ' + _constants.General.SYSTEM_POST_ALL_PUBLIC_ROLE;
                                }
                            }

                            _context.next = 5;
                            return _this.props.actions.updateUserRoles(_this.props.user.id, roles);

                        case 5:
                            _ref2 = _context.sent;
                            data = _ref2.data;


                            _this.trackRoleChanges(roles, _this.props.user.roles);

                            if (data) {
                                _this.props.onModalDismissed();
                            } else {
                                _this.handleError(_react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'admin.manage_roles.saveError',
                                    defaultMessage: 'Unable to save roles.'
                                }));
                            }

                        case 9:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this2);
        }));

        _this.renderContents = function () {
            var user = _this.props.user;


            if (user == null) {
                return _react2.default.createElement('div', null);
            }

            var name = UserUtils.getFullName(user);
            if (name) {
                name += ' (@' + user.username + ')';
            } else {
                name = '@' + user.username;
            }

            var additionalRoles = void 0;
            if (_this.state.hasUserAccessTokenRole || _this.state.isSystemAdmin) {
                additionalRoles = _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                            id: 'admin.manage_roles.additionalRoles',
                            defaultMessage: 'Select additional permissions for the account. <a href="https://about.mattermost.com/default-permissions" target="_blank">Read more about roles and permissions</a>.'
                        })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'checkbox' },
                        _react2.default.createElement(
                            'label',
                            null,
                            _react2.default.createElement('input', {
                                type: 'checkbox',
                                ref: 'postall',
                                checked: _this.state.hasPostAllRole || _this.state.isSystemAdmin,
                                disabled: _this.state.isSystemAdmin,
                                onChange: _this.handlePostAllChange
                            }),
                            _react2.default.createElement(
                                'strong',
                                null,
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'admin.manage_roles.postAllRoleTitle',
                                    defaultMessage: 'post:all'
                                })
                            ),
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'admin.manage_roles.postAllRole',
                                defaultMessage: 'Access to post to all Mattermost channels including direct messages.'
                            })
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'checkbox' },
                        _react2.default.createElement(
                            'label',
                            null,
                            _react2.default.createElement('input', {
                                type: 'checkbox',
                                ref: 'postallpublic',
                                checked: _this.state.hasPostAllPublicRole || _this.state.hasPostAllRole || _this.state.isSystemAdmin,
                                disabled: _this.state.hasPostAllRole || _this.state.isSystemAdmin,
                                onChange: _this.handlePostAllPublicChange
                            }),
                            _react2.default.createElement(
                                'strong',
                                null,
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'admin.manage_roles.postAllPublicRoleTitle',
                                    defaultMessage: 'post:channels'
                                })
                            ),
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'admin.manage_roles.postAllPublicRole',
                                defaultMessage: 'Access to post to all Mattermost public channels.'
                            })
                        )
                    )
                );
            }

            var userAccessTokenContent = void 0;
            if (_this.props.userAccessTokensEnabled) {
                userAccessTokenContent = _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'div',
                        { className: 'checkbox' },
                        _react2.default.createElement(
                            'label',
                            null,
                            _react2.default.createElement('input', {
                                type: 'checkbox',
                                ref: 'postall',
                                checked: _this.state.hasUserAccessTokenRole || _this.state.isSystemAdmin,
                                disabled: _this.state.isSystemAdmin,
                                onChange: _this.handleUserAccessTokenChange
                            }),
                            _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                                id: 'admin.manage_roles.allowUserAccessTokens',
                                defaultMessage: 'Allow this account to generate <a href="https://about.mattermost.com/default-user-access-tokens" target="_blank">personal access tokens</a>.'
                            }),
                            _react2.default.createElement(
                                'span',
                                { className: 'd-block padding-top padding-bottom light' },
                                _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                                    id: 'admin.manage_roles.allowUserAccessTokensDesc',
                                    defaultMessage: 'Removing this permission doesn\'t delete existing tokens. To delete them, go to the user\'s Manage Tokens menu.'
                                })
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'member-row--padded' },
                        additionalRoles
                    )
                );
            }

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'manage-teams__user' },
                    _react2.default.createElement('img', {
                        className: 'manage-teams__profile-picture',
                        src: _client.Client4.getProfilePictureUrl(user.id, user.last_picture_update)
                    }),
                    _react2.default.createElement(
                        'div',
                        { className: 'manage-teams__info' },
                        _react2.default.createElement(
                            'div',
                            { className: 'manage-teams__name' },
                            name
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'manage-teams__email' },
                            user.email
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'div',
                        { className: 'manage-row--inner' },
                        _react2.default.createElement(
                            'div',
                            { className: 'radio-inline' },
                            _react2.default.createElement(
                                'label',
                                null,
                                _react2.default.createElement('input', {
                                    name: 'systemadmin',
                                    type: 'radio',
                                    checked: _this.state.isSystemAdmin,
                                    onChange: _this.handleSystemAdminChange
                                }),
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'admin.manage_roles.systemAdmin',
                                    defaultMessage: 'System Admin'
                                })
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'radio-inline' },
                            _react2.default.createElement(
                                'label',
                                null,
                                _react2.default.createElement('input', {
                                    name: 'systemmember',
                                    type: 'radio',
                                    checked: !_this.state.isSystemAdmin,
                                    onChange: _this.handleSystemAdminChange
                                }),
                                _react2.default.createElement(_reactIntl.FormattedMessage, {
                                    id: 'admin.manage_roles.systemMember',
                                    defaultMessage: 'Member'
                                })
                            )
                        )
                    ),
                    userAccessTokenContent
                )
            );
        };

        _this.state = getStateFromProps(props);
        return _this;
    }

    (0, _createClass3.default)(ManageRolesModal, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var user = this.props.user || {};
            var nextUser = nextProps.user || {};
            if (user.id !== nextUser.id) {
                this.setState(getStateFromProps(nextProps));
            }
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                _reactBootstrap.Modal,
                {
                    show: this.props.show,
                    onHide: this.props.onModalDismissed,
                    dialogClassName: 'manage-teams'
                },
                _react2.default.createElement(
                    _reactBootstrap.Modal.Header,
                    { closeButton: true },
                    _react2.default.createElement(
                        _reactBootstrap.Modal.Title,
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'admin.manage_roles.manageRolesTitle',
                            defaultMessage: 'Manage Roles'
                        })
                    )
                ),
                _react2.default.createElement(
                    _reactBootstrap.Modal.Body,
                    null,
                    this.renderContents(),
                    this.state.error
                ),
                _react2.default.createElement(
                    _reactBootstrap.Modal.Footer,
                    null,
                    _react2.default.createElement(
                        'button',
                        {
                            type: 'button',
                            className: 'btn btn-link',
                            onClick: this.props.onModalDismissed
                        },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'admin.manage_roles.cancel',
                            defaultMessage: 'Cancel'
                        })
                    ),
                    _react2.default.createElement(
                        'button',
                        {
                            type: 'button',
                            className: 'btn btn-primary',
                            onClick: this.handleSave
                        },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'admin.manage_roles.save',
                            defaultMessage: 'Save'
                        })
                    )
                )
            );
        }
    }]);
    return ManageRolesModal;
}(_react2.default.PureComponent);

ManageRolesModal.propTypes = {

    /**
     * Set to render the modal
     */
    show: _propTypes2.default.bool.isRequired,

    /**
     * The user the roles are being managed for
     */
    user: _propTypes2.default.object,

    /**
     * Set if user access tokens are enabled
     */
    userAccessTokensEnabled: _propTypes2.default.bool.isRequired,

    /**
     * Function called when modal is dismissed
     */
    onModalDismissed: _propTypes2.default.func.isRequired,

    actions: _propTypes2.default.shape({

        /**
         * Function to update a user's roles
         */
        updateUserRoles: _propTypes2.default.func.isRequired
    }).isRequired
};
exports.default = ManageRolesModal;

/***/ }),

/***/ 2695:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__(772);

var _reactIntl = __webpack_require__(761);

var _client = __webpack_require__(270);

var _team_actions = __webpack_require__(832);

var TeamActions = _interopRequireWildcard(_team_actions);

var _team_utils = __webpack_require__(960);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _loading_screen = __webpack_require__(792);

var _loading_screen2 = _interopRequireDefault(_loading_screen);

var _manage_teams_dropdown = __webpack_require__(2696);

var _manage_teams_dropdown2 = _interopRequireDefault(_manage_teams_dropdown);

var _remove_from_team_button = __webpack_require__(2697);

var _remove_from_team_button2 = _interopRequireDefault(_remove_from_team_button);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ManageTeamsModal = function (_React$Component) {
    (0, _inherits3.default)(ManageTeamsModal, _React$Component);

    function ManageTeamsModal(props) {
        (0, _classCallCheck3.default)(this, ManageTeamsModal);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ManageTeamsModal.__proto__ || (0, _getPrototypeOf2.default)(ManageTeamsModal)).call(this, props));

        _this.loadTeamsAndTeamMembers = function () {
            var user = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props.user;

            TeamActions.getTeamsForUser(user.id, function (teams) {
                _this.setState({
                    teams: (0, _team_utils.filterAndSortTeamsByDisplayName)(teams)
                });
            });

            TeamActions.getTeamMembersForUser(user.id, function (teamMembers) {
                _this.setState({
                    teamMembers: teamMembers
                });
            });
        };

        _this.handleError = function (error) {
            _this.setState({
                error: error
            });
        };

        _this.handleMemberChange = function () {
            TeamActions.getTeamMembersForUser(_this.props.user.id, function (teamMembers) {
                _this.setState({
                    teamMembers: teamMembers
                });
            });
        };

        _this.handleMemberRemove = function (teamId) {
            _this.setState({
                teams: _this.state.teams.filter(function (team) {
                    return team.id !== teamId;
                }),
                teamMembers: _this.state.teamMembers.filter(function (teamMember) {
                    return teamMember.team_id !== teamId;
                })
            });
        };

        _this.renderContents = function () {
            var user = _this.props.user;
            var _this$state = _this.state,
                teams = _this$state.teams,
                teamMembers = _this$state.teamMembers;


            if (!user) {
                return _react2.default.createElement(_loading_screen2.default, null);
            }

            var isSystemAdmin = Utils.isAdmin(user.roles);

            var name = Utils.getFullName(user);
            if (name) {
                name += ' (@' + user.username + ')';
            } else {
                name = '@' + user.username;
            }

            var teamList = void 0;
            if (teams && teamMembers) {
                teamList = teams.map(function (team) {
                    var teamMember = teamMembers.find(function (member) {
                        return member.team_id === team.id;
                    });
                    if (!teamMember) {
                        return null;
                    }

                    var action = void 0;
                    if (isSystemAdmin) {
                        action = _react2.default.createElement(_remove_from_team_button2.default, {
                            user: user,
                            team: team,
                            onError: _this.handleError,
                            onMemberRemove: _this.handleMemberRemove
                        });
                    } else {
                        action = _react2.default.createElement(_manage_teams_dropdown2.default, {
                            user: user,
                            team: team,
                            teamMember: teamMember,
                            onError: _this.handleError,
                            onMemberChange: _this.handleMemberChange,
                            onMemberRemove: _this.handleMemberRemove
                        });
                    }

                    return _react2.default.createElement(
                        'div',
                        {
                            key: team.id,
                            className: 'manage-teams__team'
                        },
                        _react2.default.createElement(
                            'div',
                            { className: 'manage-teams__team-name' },
                            team.display_name
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'manage-teams__team-actions' },
                            action
                        )
                    );
                });
            } else {
                teamList = _react2.default.createElement(_loading_screen2.default, null);
            }

            var systemAdminIndicator = null;
            if (isSystemAdmin) {
                systemAdminIndicator = _react2.default.createElement(
                    'div',
                    { className: 'manage-teams__system-admin' },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.user_item.sysAdmin',
                        defaultMessage: 'System Admin'
                    })
                );
            }

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'manage-teams__user' },
                    _react2.default.createElement('img', {
                        className: 'manage-teams__profile-picture',
                        src: _client.Client4.getProfilePictureUrl(user.id, user.last_picture_update)
                    }),
                    _react2.default.createElement(
                        'div',
                        { className: 'manage-teams__info' },
                        _react2.default.createElement(
                            'div',
                            { className: 'manage-teams__name' },
                            name
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'manage-teams__email' },
                            user.email
                        )
                    ),
                    systemAdminIndicator
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'manage-teams__teams' },
                    teamList
                )
            );
        };

        _this.state = {
            error: null,
            teams: null,
            teamMembers: null
        };
        return _this;
    }

    (0, _createClass3.default)(ManageTeamsModal, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.props.user) {
                this.loadTeamsAndTeamMembers();
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var userId = this.props.user ? this.props.user.id : '';
            var nextUserId = nextProps.user ? nextProps.user.id : '';

            if (userId !== nextUserId) {
                this.setState({
                    teams: null,
                    teamMembers: null
                });

                if (nextProps.user) {
                    this.loadTeamsAndTeamMembers(nextProps.user);
                }
            }
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                _reactBootstrap.Modal,
                {
                    show: this.props.show,
                    onHide: this.props.onModalDismissed,
                    dialogClassName: 'manage-teams'
                },
                _react2.default.createElement(
                    _reactBootstrap.Modal.Header,
                    { closeButton: true },
                    _react2.default.createElement(
                        _reactBootstrap.Modal.Title,
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'admin.user_item.manageTeams',
                            defaultMessage: 'Manage Teams'
                        })
                    )
                ),
                _react2.default.createElement(
                    _reactBootstrap.Modal.Body,
                    null,
                    this.renderContents()
                )
            );
        }
    }]);
    return ManageTeamsModal;
}(_react2.default.Component); // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

ManageTeamsModal.propTypes = {
    onModalDismissed: _propTypes2.default.func.isRequired,
    show: _propTypes2.default.bool.isRequired,
    user: _propTypes2.default.object
};
exports.default = ManageTeamsModal;

/***/ }),

/***/ 2696:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__(772);

var _reactIntl = __webpack_require__(761);

var _team_actions = __webpack_require__(832);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var ManageTeamsDropdown = function (_React$Component) {
    (0, _inherits3.default)(ManageTeamsDropdown, _React$Component);

    function ManageTeamsDropdown(props) {
        (0, _classCallCheck3.default)(this, ManageTeamsDropdown);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ManageTeamsDropdown.__proto__ || (0, _getPrototypeOf2.default)(ManageTeamsDropdown)).call(this, props));

        _this.toggleDropdown = _this.toggleDropdown.bind(_this);

        _this.makeTeamAdmin = _this.makeTeamAdmin.bind(_this);
        _this.makeMember = _this.makeMember.bind(_this);
        _this.removeFromTeam = _this.removeFromTeam.bind(_this);

        _this.handleMemberChange = _this.handleMemberChange.bind(_this);
        _this.handleMemberRemove = _this.handleMemberRemove.bind(_this);

        _this.state = {
            show: false
        };
        return _this;
    }

    (0, _createClass3.default)(ManageTeamsDropdown, [{
        key: 'toggleDropdown',
        value: function toggleDropdown() {
            this.setState(function (prevState) {
                return { show: !prevState.show };
            });
        }
    }, {
        key: 'makeTeamAdmin',
        value: function makeTeamAdmin() {
            (0, _team_actions.updateTeamMemberRoles)(this.props.teamMember.team_id, this.props.user.id, 'team_user team_admin', this.handleMemberChange, this.props.onError);
        }
    }, {
        key: 'makeMember',
        value: function makeMember() {
            (0, _team_actions.updateTeamMemberRoles)(this.props.teamMember.team_id, this.props.user.id, 'team_user', this.handleMemberChange, this.props.onError);
        }
    }, {
        key: 'removeFromTeam',
        value: function removeFromTeam() {
            (0, _team_actions.removeUserFromTeam)(this.props.teamMember.team_id, this.props.user.id, this.handleMemberRemove, this.props.onError);
        }
    }, {
        key: 'handleMemberChange',
        value: function handleMemberChange() {
            this.props.onMemberChange(this.props.teamMember.team_id);
        }
    }, {
        key: 'handleMemberRemove',
        value: function handleMemberRemove() {
            this.props.onMemberRemove(this.props.teamMember.team_id);
        }
    }, {
        key: 'render',
        value: function render() {
            var isTeamAdmin = Utils.isAdmin(this.props.teamMember.roles);

            var title = void 0;
            if (isTeamAdmin) {
                title = Utils.localizeMessage('admin.user_item.teamAdmin', 'Team Admin');
            } else {
                title = Utils.localizeMessage('admin.user_item.teamMember', 'Team Member');
            }

            var makeTeamAdmin = null;
            if (!isTeamAdmin) {
                makeTeamAdmin = _react2.default.createElement(
                    _reactBootstrap.MenuItem,
                    {
                        id: 'makeTeamAdmin',
                        onSelect: this.makeTeamAdmin
                    },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.user_item.makeTeamAdmin',
                        defaultMessage: 'Make Team Admin'
                    })
                );
            }

            var makeMember = null;
            if (isTeamAdmin) {
                makeMember = _react2.default.createElement(
                    _reactBootstrap.MenuItem,
                    {
                        id: 'makeMember',
                        onSelect: this.makeMember
                    },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.user_item.makeMember',
                        defaultMessage: 'Make Member'
                    })
                );
            }

            return _react2.default.createElement(
                _reactBootstrap.Dropdown,
                {
                    id: 'manage-teams-' + this.props.user.id + '-' + this.props.teamMember.team_id,
                    open: this.state.show,
                    onToggle: this.toggleDropdown
                },
                _react2.default.createElement(
                    _reactBootstrap.Dropdown.Toggle,
                    { useAnchor: true },
                    title
                ),
                _react2.default.createElement(
                    _reactBootstrap.Dropdown.Menu,
                    null,
                    makeTeamAdmin,
                    makeMember,
                    _react2.default.createElement(
                        _reactBootstrap.MenuItem,
                        {
                            id: 'removeFromTeam',
                            onSelect: this.removeFromTeam
                        },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'team_members_dropdown.leave_team',
                            defaultMessage: 'Remove from Team'
                        })
                    )
                )
            );
        }
    }]);
    return ManageTeamsDropdown;
}(_react2.default.Component);

ManageTeamsDropdown.propTypes = {
    user: _propTypes2.default.object.isRequired,
    teamMember: _propTypes2.default.object.isRequired,
    onError: _propTypes2.default.func.isRequired,
    onMemberChange: _propTypes2.default.func.isRequired,
    onMemberRemove: _propTypes2.default.func.isRequired
};
exports.default = ManageTeamsDropdown;

/***/ }),

/***/ 2697:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _team_actions = __webpack_require__(832);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var RemoveFromTeamButton = function (_React$PureComponent) {
    (0, _inherits3.default)(RemoveFromTeamButton, _React$PureComponent);

    function RemoveFromTeamButton(props) {
        (0, _classCallCheck3.default)(this, RemoveFromTeamButton);

        var _this = (0, _possibleConstructorReturn3.default)(this, (RemoveFromTeamButton.__proto__ || (0, _getPrototypeOf2.default)(RemoveFromTeamButton)).call(this, props));

        _this.handleClick = _this.handleClick.bind(_this);
        _this.handleMemberRemove = _this.handleMemberRemove.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(RemoveFromTeamButton, [{
        key: 'handleClick',
        value: function handleClick(e) {
            e.preventDefault();

            (0, _team_actions.removeUserFromTeam)(this.props.team.id, this.props.user.id, this.handleMemberRemove, this.props.onError);
        }
    }, {
        key: 'handleMemberRemove',
        value: function handleMemberRemove() {
            this.props.onMemberRemove(this.props.team.id);
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'button',
                {
                    className: 'btn btn-danger',
                    onClick: this.handleClick
                },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'team_members_dropdown.leave_team',
                    defaultMessage: 'Remove from Team'
                })
            );
        }
    }]);
    return RemoveFromTeamButton;
}(_react2.default.PureComponent);

RemoveFromTeamButton.propTypes = {
    onError: _propTypes2.default.func.isRequired,
    onMemberRemove: _propTypes2.default.func.isRequired,
    team: _propTypes2.default.object.isRequired,
    user: _propTypes2.default.object.isRequired
};
exports.default = RemoveFromTeamButton;

/***/ }),

/***/ 2698:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _redux = __webpack_require__(1);

var _users = __webpack_require__(786);

var _manage_tokens_modal = __webpack_require__(2699);

var _manage_tokens_modal2 = _interopRequireDefault(_manage_tokens_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapStateToProps(state, ownProps) {
    var userId = ownProps.user ? ownProps.user.id : '';

    return {
        userAccessTokens: state.entities.admin.userAccessTokensByUser[userId]
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: (0, _redux.bindActionCreators)({
            getUserAccessTokensForUser: _users.getUserAccessTokensForUser
        }, dispatch)
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_manage_tokens_modal2.default);

/***/ }),

/***/ 2699:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _values = __webpack_require__(801);

var _values2 = _interopRequireDefault(_values);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__(772);

var _reactIntl = __webpack_require__(761);

var _client = __webpack_require__(270);

var _user_utils = __webpack_require__(175);

var UserUtils = _interopRequireWildcard(_user_utils);

var _revoke_token_button = __webpack_require__(2700);

var _revoke_token_button2 = _interopRequireDefault(_revoke_token_button);

var _loading_screen = __webpack_require__(792);

var _loading_screen2 = _interopRequireDefault(_loading_screen);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var ManageTokensModal = function (_React$PureComponent) {
    (0, _inherits3.default)(ManageTokensModal, _React$PureComponent);

    function ManageTokensModal(props) {
        (0, _classCallCheck3.default)(this, ManageTokensModal);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ManageTokensModal.__proto__ || (0, _getPrototypeOf2.default)(ManageTokensModal)).call(this, props));

        _this.handleError = function (error) {
            _this.setState({
                error: error
            });
        };

        _this.renderContents = function () {
            var _this$props = _this.props,
                user = _this$props.user,
                userAccessTokens = _this$props.userAccessTokens;


            if (!user) {
                return _react2.default.createElement(_loading_screen2.default, null);
            }

            var name = UserUtils.getFullName(user);
            if (name) {
                name += ' (@' + user.username + ')';
            } else {
                name = '@' + user.username;
            }

            var tokenList = void 0;
            if (userAccessTokens) {
                var userAccessTokensList = (0, _values2.default)(userAccessTokens);

                if (userAccessTokensList.length === 0) {
                    tokenList = _react2.default.createElement(
                        'div',
                        { className: 'manage-row__empty' },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'admin.manage_tokens.userAccessTokensNone',
                            defaultMessage: 'No personal access tokens.'
                        })
                    );
                } else {
                    tokenList = userAccessTokensList.map(function (token) {
                        return _react2.default.createElement(
                            'div',
                            {
                                key: token.id,
                                className: 'manage-teams__team'
                            },
                            _react2.default.createElement(
                                'div',
                                { className: 'manage-teams__team-name' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'whitespace--nowrap overflow--ellipsis' },
                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'admin.manage_tokens.userAccessTokensNameLabel',
                                        defaultMessage: 'Token Description: '
                                    }),
                                    token.description
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'whitespace--nowrap overflow--ellipsis' },
                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'admin.manage_tokens.userAccessTokensIdLabel',
                                        defaultMessage: 'Token ID: '
                                    }),
                                    token.id
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: 'manage-teams__team-actions' },
                                _react2.default.createElement(_revoke_token_button2.default, {
                                    tokenId: token.id,
                                    onError: _this.handleError
                                })
                            )
                        );
                    });
                }
            } else {
                tokenList = _react2.default.createElement(_loading_screen2.default, null);
            }

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'manage-teams__user' },
                    _react2.default.createElement('img', {
                        className: 'manage-teams__profile-picture',
                        src: _client.Client4.getProfilePictureUrl(user.id, user.last_picture_update)
                    }),
                    _react2.default.createElement(
                        'div',
                        { className: 'manage-teams__info' },
                        _react2.default.createElement(
                            'div',
                            { className: 'manage-teams__name' },
                            name
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'manage-teams__email' },
                            user.email
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'padding-top x2' },
                    _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                        id: 'admin.manage_tokens.userAccessTokensDescription',
                        defaultMessage: 'Personal access tokens function similarly to session tokens and can be used by integrations to <a href="https://about.mattermost.com/default-api-authentication" target="_blank">interact with this Mattermost server</a>. Tokens are disabled if the user is deactivated. Learn more about <a href="https://about.mattermost.com/default-user-access-tokens" target="_blank">personal access tokens</a>.'
                    })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'manage-teams__teams' },
                    tokenList
                )
            );
        };

        _this.state = { error: null };
        return _this;
    }

    (0, _createClass3.default)(ManageTokensModal, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var userId = this.props.user ? this.props.user.id : null;
            var nextUserId = nextProps.user ? nextProps.user.id : null;
            if (nextUserId && nextUserId !== userId) {
                this.props.actions.getUserAccessTokensForUser(nextUserId, 0, 200);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                _reactBootstrap.Modal,
                {
                    show: this.props.show,
                    onHide: this.props.onModalDismissed,
                    dialogClassName: 'manage-teams'
                },
                _react2.default.createElement(
                    _reactBootstrap.Modal.Header,
                    { closeButton: true },
                    _react2.default.createElement(
                        _reactBootstrap.Modal.Title,
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'admin.manage_tokens.manageTokensTitle',
                            defaultMessage: 'Manage Personal Access Tokens'
                        })
                    )
                ),
                _react2.default.createElement(
                    _reactBootstrap.Modal.Body,
                    null,
                    this.renderContents(),
                    this.state.error
                )
            );
        }
    }]);
    return ManageTokensModal;
}(_react2.default.PureComponent);

ManageTokensModal.propTypes = {

    /**
     * Set to render the modal
     */
    show: _propTypes2.default.bool.isRequired,

    /**
     * The user the roles are being managed for
     */
    user: _propTypes2.default.object,

    /**
     * The personal access tokens for a user, object with token ids as keys
     */
    userAccessTokens: _propTypes2.default.object,

    /**
     * Function called when modal is dismissed
     */
    onModalDismissed: _propTypes2.default.func.isRequired,

    actions: _propTypes2.default.shape({

        /**
         * Function to get a user's access tokens
         */
        getUserAccessTokensForUser: _propTypes2.default.func.isRequired
    }).isRequired
};
exports.default = ManageTokensModal;

/***/ }),

/***/ 2700:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _reactRedux = __webpack_require__(268);

var _redux = __webpack_require__(1);

var _users = __webpack_require__(786);

var _revoke_token_button = __webpack_require__(2701);

var _revoke_token_button2 = _interopRequireDefault(_revoke_token_button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapStateToProps(state, ownProps) {
    return (0, _extends3.default)({}, ownProps);
}

function mapDispatchToProps(dispatch) {
    return {
        actions: (0, _redux.bindActionCreators)({
            revokeUserAccessToken: _users.revokeUserAccessToken
        }, dispatch)
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_revoke_token_button2.default);

/***/ }),

/***/ 2701:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(114);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(115);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _diagnostics_actions = __webpack_require__(804);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var RevokeTokenButton = function (_React$PureComponent) {
    (0, _inherits3.default)(RevokeTokenButton, _React$PureComponent);

    function RevokeTokenButton() {
        var _ref,
            _this2 = this;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, RevokeTokenButton);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = RevokeTokenButton.__proto__ || (0, _getPrototypeOf2.default)(RevokeTokenButton)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function () {
            var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(e) {
                var _ref3, error;

                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                e.preventDefault();

                                _context.next = 3;
                                return _this.props.actions.revokeUserAccessToken(_this.props.tokenId);

                            case 3:
                                _ref3 = _context.sent;
                                error = _ref3.error;

                                (0, _diagnostics_actions.trackEvent)('system_console', 'revoke_user_access_token');

                                if (error) {
                                    _this.props.onError(error.message);
                                }

                            case 7:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }));

            return function (_x) {
                return _ref2.apply(this, arguments);
            };
        }(), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(RevokeTokenButton, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'button',
                {
                    className: 'btn btn-danger',
                    onClick: this.handleClick
                },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'admin.revoke_token_button.delete',
                    defaultMessage: 'Delete'
                })
            );
        }
    }]);
    return RevokeTokenButton;
}(_react2.default.PureComponent);

RevokeTokenButton.propTypes = {

    /*
     * Token id to revoke
     */
    tokenId: _propTypes2.default.string.isRequired,

    /*
     * Function to call on error
     */
    onError: _propTypes2.default.func.isRequired,

    actions: _propTypes2.default.shape({

        /**
         * Function to revoke a user access token
         */
        revokeUserAccessToken: _propTypes2.default.func.isRequired
    }).isRequired
};
exports.default = RevokeTokenButton;

/***/ }),

/***/ 2702:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _general = __webpack_require__(113);

var _utils = __webpack_require__(762);

var _reset_password_modal = __webpack_require__(2703);

var _reset_password_modal2 = _interopRequireDefault(_reset_password_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapStateToProps(state) {
    var license = (0, _general.getLicense)(state);
    var config = (0, _general.getConfig)(state);

    return {
        passwordConfig: (0, _utils.getPasswordConfig)(license, config)
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_reset_password_modal2.default);

/***/ }),

/***/ 2703:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = __webpack_require__(772);

var _reactIntl = __webpack_require__(761);

var _admin_actions = __webpack_require__(797);

var _user_store = __webpack_require__(774);

var _user_store2 = _interopRequireDefault(_user_store);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ResetPasswordModal = function (_React$Component) {
    (0, _inherits3.default)(ResetPasswordModal, _React$Component);

    function ResetPasswordModal(props) {
        (0, _classCallCheck3.default)(this, ResetPasswordModal);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ResetPasswordModal.__proto__ || (0, _getPrototypeOf2.default)(ResetPasswordModal)).call(this, props));

        _this.doSubmit = _this.doSubmit.bind(_this);
        _this.doCancel = _this.doCancel.bind(_this);

        _this.state = {
            serverErrorNewPass: null,
            serverErrorCurrentPass: null
        };
        return _this;
    }

    (0, _createClass3.default)(ResetPasswordModal, [{
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.setState({
                serverErrorNewPass: null,
                serverErrorCurrentPass: null
            });
        }
    }, {
        key: 'doSubmit',
        value: function doSubmit(e) {
            var _this2 = this;

            e.preventDefault();
            var currentPassword = '';
            if (this.refs.currentPassword) {
                currentPassword = this.refs.currentPassword.value;
                if (currentPassword === '') {
                    var errorMsg = '';
                    errorMsg = _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.reset_password.missing_current',
                        defaultMessage: 'Please enter your current password.'
                    });
                    this.setState({ serverErrorCurrentPass: errorMsg });
                    return;
                }
            }

            var password = this.refs.password.value;

            var passwordErr = Utils.isValidPassword(password, this.props.passwordConfig);
            if (passwordErr) {
                this.setState({ serverErrorNewPass: passwordErr });
                return;
            }

            this.setState({ serverErrorNewPass: null });

            (0, _admin_actions.adminResetPassword)(this.props.user.id, currentPassword, password, function () {
                _this2.props.onModalSubmit(_this2.props.user);
            }, function (err) {
                _this2.setState({ serverErrorCurrentPass: err.message });
            });
        }
    }, {
        key: 'doCancel',
        value: function doCancel() {
            this.setState({
                serverErrorNewPass: null,
                serverErrorCurrentPass: null
            });
            this.props.onModalDismissed();
        }
    }, {
        key: 'render',
        value: function render() {
            var user = this.props.user;
            if (user == null) {
                return _react2.default.createElement('div', null);
            }

            var urlClass = 'input-group input-group--limit';
            var serverErrorNewPass = null;

            if (this.state.serverErrorNewPass) {
                urlClass += ' has-error';
                serverErrorNewPass = _react2.default.createElement(
                    'div',
                    { className: 'has-error' },
                    _react2.default.createElement(
                        'p',
                        { className: 'input__help error' },
                        this.state.serverErrorNewPass
                    )
                );
            }

            var title = void 0;
            if (user.auth_service) {
                title = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'admin.reset_password.titleSwitch',
                    defaultMessage: 'Switch Account to Email/Password'
                });
            } else {
                title = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'admin.reset_password.titleReset',
                    defaultMessage: 'Reset Password'
                });
            }

            var currentUserId = _user_store2.default.getCurrentId();
            var currentPassword = null;
            var serverErrorCurrentPass = null;
            var newPasswordFocus = true;
            if (currentUserId === user.id) {
                newPasswordFocus = false;
                var urlClassCurrentPass = 'input-group input-group--limit';
                if (this.state.serverErrorCurrentPass) {
                    urlClassCurrentPass += ' has-error';
                    serverErrorCurrentPass = _react2.default.createElement(
                        'div',
                        { className: 'has-error' },
                        _react2.default.createElement(
                            'p',
                            { className: 'input__help error' },
                            this.state.serverErrorCurrentPass
                        )
                    );
                }
                currentPassword = _react2.default.createElement(
                    'div',
                    { className: 'col-sm-10 password__group-addon-space' },
                    _react2.default.createElement(
                        'div',
                        { className: urlClassCurrentPass },
                        _react2.default.createElement(
                            'span',
                            {
                                'data-toggle': 'tooltip',
                                title: 'Current Password',
                                className: 'input-group-addon password__group-addon'
                            },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'admin.reset_password.curentPassword',
                                defaultMessage: 'Current Password'
                            })
                        ),
                        _react2.default.createElement('input', {
                            type: 'password',
                            ref: 'currentPassword',
                            className: 'form-control',
                            maxLength: '22',
                            autoFocus: true,
                            tabIndex: '1'
                        })
                    )
                );
            }

            return _react2.default.createElement(
                _reactBootstrap.Modal,
                {
                    show: this.props.show,
                    onHide: this.doCancel
                },
                _react2.default.createElement(
                    _reactBootstrap.Modal.Header,
                    { closeButton: true },
                    _react2.default.createElement(
                        _reactBootstrap.Modal.Title,
                        null,
                        title
                    )
                ),
                _react2.default.createElement(
                    'form',
                    {
                        role: 'form',
                        className: 'form-horizontal'
                    },
                    _react2.default.createElement(
                        _reactBootstrap.Modal.Body,
                        null,
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            currentPassword,
                            _react2.default.createElement(
                                'div',
                                { className: 'col-sm-10' },
                                _react2.default.createElement(
                                    'div',
                                    { className: urlClass },
                                    _react2.default.createElement(
                                        'span',
                                        {
                                            'data-toggle': 'tooltip',
                                            title: 'New Password',
                                            className: 'input-group-addon password__group-addon'
                                        },
                                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                                            id: 'admin.reset_password.newPassword',
                                            defaultMessage: 'New Password'
                                        })
                                    ),
                                    _react2.default.createElement('input', {
                                        type: 'password',
                                        ref: 'password',
                                        className: 'form-control',
                                        maxLength: '22',
                                        autoFocus: newPasswordFocus,
                                        tabIndex: '1'
                                    })
                                ),
                                serverErrorNewPass,
                                serverErrorCurrentPass
                            )
                        )
                    ),
                    _react2.default.createElement(
                        _reactBootstrap.Modal.Footer,
                        null,
                        _react2.default.createElement(
                            'button',
                            {
                                type: 'button',
                                className: 'btn btn-default',
                                onClick: this.doCancel
                            },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'admin.reset_password.cancel',
                                defaultMessage: 'Cancel'
                            })
                        ),
                        _react2.default.createElement(
                            'button',
                            {
                                onClick: this.doSubmit,
                                type: 'submit',
                                className: 'btn btn-primary',
                                tabIndex: '2'
                            },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'admin.reset_password.reset',
                                defaultMessage: 'Reset'
                            })
                        )
                    )
                )
            );
        }
    }]);
    return ResetPasswordModal;
}(_react2.default.Component); // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

ResetPasswordModal.propTypes = {
    user: _propTypes2.default.object,
    show: _propTypes2.default.bool.isRequired,
    onModalSubmit: _propTypes2.default.func,
    onModalDismissed: _propTypes2.default.func,
    passwordConfig: _propTypes2.default.object
};
ResetPasswordModal.defaultProps = {
    show: false
};
exports.default = ResetPasswordModal;

/***/ }),

/***/ 2704:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _client = __webpack_require__(270);

var _user_store = __webpack_require__(774);

var _user_store2 = _interopRequireDefault(_user_store);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _profile_picture = __webpack_require__(837);

var _profile_picture2 = _interopRequireDefault(_profile_picture);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UserListRowWithError = function (_React$Component) {
    (0, _inherits3.default)(UserListRowWithError, _React$Component);

    function UserListRowWithError(props) {
        (0, _classCallCheck3.default)(this, UserListRowWithError);

        var _this = (0, _possibleConstructorReturn3.default)(this, (UserListRowWithError.__proto__ || (0, _getPrototypeOf2.default)(UserListRowWithError)).call(this, props));

        _this.state = {};

        _this.onError = _this.onError.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(UserListRowWithError, [{
        key: 'onError',
        value: function onError(errorObj) {
            this.setState({
                error: errorObj
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var buttons = null;
            if (this.props.actions) {
                buttons = this.props.actions.map(function (Action, index) {
                    return _react2.default.createElement(Action, (0, _extends3.default)({
                        key: index.toString(),
                        user: _this2.props.user
                    }, _this2.props.actionProps, _this2.props.actionUserProps, {
                        onError: _this2.onError
                    }));
                });
            }

            // QUICK HACK, NEEDS A PROP FOR TOGGLING STATUS
            var email = this.props.user.email;
            var emailStyle = 'more-modal__description';
            var status = void 0;
            if (this.props.extraInfo && this.props.extraInfo.length > 0) {
                email = _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                    id: 'admin.user_item.emailTitle',
                    defaultMessage: '<strong>Email:</strong> {email}',
                    values: {
                        email: this.props.user.email
                    }
                });
                emailStyle = '';
            } else if (this.props.user.status) {
                status = this.props.user.status;
            } else {
                status = _user_store2.default.getStatus(this.props.user.id);
            }

            var userCountID = null;
            var userCountEmail = null;
            if (this.props.userCount >= 0) {
                userCountID = Utils.createSafeId('userListRowName' + this.props.userCount);
                userCountEmail = Utils.createSafeId('userListRowEmail' + this.props.userCount);
            }

            var error = null;
            if (this.state.error) {
                error = _react2.default.createElement(
                    'div',
                    { className: 'has-error' },
                    _react2.default.createElement(
                        'label',
                        { className: 'has-error control-label' },
                        this.state.error.message
                    )
                );
            }

            return _react2.default.createElement(
                'div',
                {
                    key: this.props.user.id,
                    className: 'more-modal__row'
                },
                _react2.default.createElement(_profile_picture2.default, {
                    src: _client.Client4.getProfilePictureUrl(this.props.user.id, this.props.user.last_picture_update),
                    status: status,
                    width: '32',
                    height: '32'
                }),
                _react2.default.createElement(
                    'div',
                    { className: 'more-modal__right' },
                    _react2.default.createElement(
                        'div',
                        { className: 'more-modal__top' },
                        _react2.default.createElement(
                            'div',
                            { className: 'more-modal__details' },
                            _react2.default.createElement(
                                'div',
                                {
                                    id: userCountID,
                                    className: 'more-modal__name'
                                },
                                Utils.displayEntireNameForUser(this.props.user)
                            ),
                            _react2.default.createElement(
                                'div',
                                {
                                    id: userCountEmail,
                                    className: emailStyle
                                },
                                email
                            ),
                            this.props.extraInfo
                        ),
                        _react2.default.createElement(
                            'div',
                            {
                                className: 'more-modal__actions'
                            },
                            buttons
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        {
                            className: 'more-modal__bottom'
                        },
                        error
                    )
                )
            );
        }
    }]);
    return UserListRowWithError;
}(_react2.default.Component); // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

UserListRowWithError.propTypes = {
    user: _propTypes2.default.object.isRequired,
    extraInfo: _propTypes2.default.arrayOf(_propTypes2.default.object),
    actions: _propTypes2.default.arrayOf(_propTypes2.default.func),
    actionProps: _propTypes2.default.object,
    actionUserProps: _propTypes2.default.object,
    userCount: _propTypes2.default.number
};
UserListRowWithError.defaultProps = {
    extraInfo: [],
    actions: [],
    actionProps: {},
    actionUserProps: {}
};
exports.default = UserListRowWithError;

/***/ }),

/***/ 2705:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _user_utils = __webpack_require__(175);

var UserUtils = _interopRequireWildcard(_user_utils);

var _constants = __webpack_require__(19);

var _admin_actions = __webpack_require__(797);

var _user_actions = __webpack_require__(781);

var _team_store = __webpack_require__(779);

var _team_store2 = _interopRequireDefault(_team_store);

var _user_store = __webpack_require__(774);

var _user_store2 = _interopRequireDefault(_user_store);

var _constants2 = __webpack_require__(29);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _global_actions = __webpack_require__(778);

var _confirm_modal = __webpack_require__(819);

var _confirm_modal2 = _interopRequireDefault(_confirm_modal);

var _system_permission_gate = __webpack_require__(863);

var _system_permission_gate2 = _interopRequireDefault(_system_permission_gate);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var SystemUsersDropdown = function (_React$Component) {
    (0, _inherits3.default)(SystemUsersDropdown, _React$Component);

    function SystemUsersDropdown(props) {
        (0, _classCallCheck3.default)(this, SystemUsersDropdown);

        var _this = (0, _possibleConstructorReturn3.default)(this, (SystemUsersDropdown.__proto__ || (0, _getPrototypeOf2.default)(SystemUsersDropdown)).call(this, props));

        _this.handleMakeActive = function (e) {
            e.preventDefault();
            (0, _user_actions.updateActive)(_this.props.user.id, true, null, _this.props.onError);
        };

        _this.handleManageTeams = function (e) {
            e.preventDefault();

            _this.props.doManageTeams(_this.props.user);
        };

        _this.handleManageRoles = function (e) {
            e.preventDefault();

            _this.props.doManageRoles(_this.props.user);
        };

        _this.handleManageTokens = function (e) {
            e.preventDefault();

            _this.props.doManageTokens(_this.props.user);
        };

        _this.handleResetPassword = function (e) {
            e.preventDefault();
            _this.props.doPasswordReset(_this.props.user);
        };

        _this.handleResetMfa = function (e) {
            e.preventDefault();
            (0, _admin_actions.adminResetMfa)(_this.props.user.id, null, _this.props.onError);
        };

        _this.handleDemoteSystemAdmin = function (user, role) {
            _this.setState({
                showDemoteModal: true,
                user: user,
                role: role
            });
        };

        _this.handleDemoteCancel = function () {
            _this.setState({
                showDemoteModal: false,
                user: null,
                role: null
            });
            _this.props.onError(null);
        };

        _this.handleDemoteSubmit = function () {
            if (_this.state.role === 'member') {
                _this.doMakeMember();
            }

            var teamUrl = _team_store2.default.getCurrentTeamUrl();
            if (teamUrl) {
                // the channel is added to the URL cause endless loading not being fully fixed
                window.location.href = teamUrl + ('/channels/' + _constants2.Constants.DEFAULT_CHANNEL);
            } else {
                window.location.href = '/';
            }
        };

        _this.handleShowDeactivateMemberModal = function (e) {
            e.preventDefault();
            _this.setState({ showDeactivateMemberModal: true });
        };

        _this.handleDeactivateMember = function () {
            (0, _user_actions.updateActive)(_this.props.user.id, false, null, _this.props.onError);
            _this.setState({ showDeactivateMemberModal: false });
        };

        _this.handleDeactivateCancel = function () {
            _this.setState({ showDeactivateMemberModal: false });
        };

        _this.renderDeactivateMemberModal = function () {
            var user = _this.props.user;

            var title = _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'deactivate_member_modal.title',
                defaultMessage: 'Deactivate {username}',
                values: {
                    username: _this.props.user.username
                }
            });

            var warning = void 0;
            if (user.auth_service !== '' && user.auth_service !== _constants2.Constants.EMAIL_SERVICE) {
                warning = _react2.default.createElement(
                    'strong',
                    null,
                    _react2.default.createElement('br', null),
                    _react2.default.createElement('br', null),
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'deactivate_member_modal.sso_warning',
                        defaultMessage: 'You must also deactivate this user in the SSO provider or they will be reactivated on next login or sync.'
                    })
                );
            }

            var message = _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'deactivate_member_modal.desc',
                    defaultMessage: 'This action deactivates {username}. They will be logged out and not have access to any teams or channels on this system. Are you sure you want to deactivate {username}?',
                    values: {
                        username: user.username
                    }
                }),
                warning
            );

            var confirmButtonClass = 'btn btn-danger';
            var deactivateMemberButton = _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'deactivate_member_modal.deactivate',
                defaultMessage: 'Deactivate'
            });

            return _react2.default.createElement(_confirm_modal2.default, {
                show: _this.state.showDeactivateMemberModal,
                title: title,
                message: message,
                confirmButtonClass: confirmButtonClass,
                confirmButtonText: deactivateMemberButton,
                onConfirm: _this.handleDeactivateMember,
                onCancel: _this.handleDeactivateCancel
            });
        };

        _this.handleShowRevokeSessionsModal = function (e) {
            e.preventDefault();
            _this.setState({ showRevokeSessionsModal: true });
        };

        _this.handleRevokeSessions = function () {
            var me = _user_store2.default.getCurrentUser();
            (0, _user_actions.revokeAllSessions)(_this.props.user.id, function () {
                if (_this.props.user.id === me.id) {
                    (0, _global_actions.clientLogout)();
                }
            }, _this.props.onError);

            _this.setState({ showRevokeSessionsModal: false });
        };

        _this.handleRevokeSessionsCancel = function () {
            _this.setState({ showRevokeSessionsModal: false });
        };

        _this.renderRevokeSessionsModal = function () {
            var title = _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'revoke_user_sessions_modal.title',
                defaultMessage: 'Revoke Sessions for {username}',
                values: {
                    username: _this.props.user.username
                }
            });

            var message = _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'revoke_user_sessions_modal.desc',
                defaultMessage: 'This action revokes all sessions for {username}. They will be logged out from all devices. Are you sure you want to revoke all sessions for {username}?',
                values: {
                    username: _this.props.user.username
                }
            });

            var revokeUserButtonButton = _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'revoke_user_sessions_modal.revoke',
                defaultMessage: 'Revoke'
            });

            return _react2.default.createElement(_confirm_modal2.default, {
                show: _this.state.showRevokeSessionsModal,
                title: title,
                message: message,
                confirmButtonClass: 'btn btn-danger',
                confirmButtonText: revokeUserButtonButton,
                onConfirm: _this.handleRevokeSessions,
                onCancel: _this.handleRevokeSessionsCancel
            });
        };

        _this.renderAccessToken = function () {
            var userAccessTokensEnabled = _this.props.enableUserAccessTokens;
            if (!userAccessTokensEnabled) {
                return null;
            }

            var user = _this.props.user;
            var hasPostAllRole = UserUtils.hasPostAllRole(user.roles);
            var hasPostAllPublicRole = UserUtils.hasPostAllPublicRole(user.roles);
            var hasUserAccessTokenRole = UserUtils.hasUserAccessTokenRole(user.roles);
            var isSystemAdmin = UserUtils.isSystemAdmin(user.roles);

            var messageId = '';
            if (hasUserAccessTokenRole || isSystemAdmin) {
                if (hasPostAllRole) {
                    messageId = 'admin.user_item.userAccessTokenPostAll';
                } else if (hasPostAllPublicRole) {
                    messageId = 'admin.user_item.userAccessTokenPostAllPublic';
                } else {
                    messageId = 'admin.user_item.userAccessTokenYes';
                }
            }

            if (!messageId) {
                return null;
            }

            return _react2.default.createElement(
                'div',
                { className: 'light margin-top half' },
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    key: 'admin.user_item.userAccessToken',
                    id: messageId
                })
            );
        };

        _this.state = {
            showDemoteModal: false,
            showDeactivateMemberModal: false,
            showRevokeSessionsModal: false,
            user: null,
            role: null
        };
        return _this;
    }

    (0, _createClass3.default)(SystemUsersDropdown, [{
        key: 'render',
        value: function render() {
            var user = this.props.user;
            if (!user) {
                return _react2.default.createElement('div', null);
            }
            var currentRoles = _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'admin.user_item.member',
                defaultMessage: 'Member'
            });

            if (user.roles.length > 0 && Utils.isSystemAdmin(user.roles)) {
                currentRoles = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'team_members_dropdown.systemAdmin',
                    defaultMessage: 'System Admin'
                });
            }

            var me = _user_store2.default.getCurrentUser();
            var showMakeActive = false;
            var showMakeNotActive = !Utils.isSystemAdmin(user.roles);
            var showManageTeams = true;
            var showRevokeSessions = true;
            var showMfaReset = this.props.mfaEnabled && user.mfa_active;

            if (user.delete_at > 0) {
                currentRoles = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'admin.user_item.inactive',
                    defaultMessage: 'Inactive'
                });
                showMakeActive = true;
                showMakeNotActive = false;
                showManageTeams = false;
                showRevokeSessions = false;
            }

            var disableActivationToggle = false;
            if (user.auth_service === _constants2.Constants.LDAP_SERVICE) {
                disableActivationToggle = true;
            }

            var menuClass = '';
            if (disableActivationToggle) {
                menuClass = 'disabled';
            }

            var makeActive = null;
            if (showMakeActive) {
                makeActive = _react2.default.createElement(
                    'li',
                    {
                        role: 'presentation',
                        className: menuClass
                    },
                    _react2.default.createElement(
                        'a',
                        {
                            id: 'activate',
                            role: 'menuitem',
                            href: '#',
                            onClick: this.handleMakeActive
                        },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'admin.user_item.makeActive',
                            defaultMessage: 'Activate'
                        })
                    )
                );
            }

            var makeNotActive = null;
            if (showMakeNotActive) {
                makeNotActive = _react2.default.createElement(
                    'li',
                    {
                        role: 'presentation',
                        className: menuClass
                    },
                    _react2.default.createElement(
                        'a',
                        {
                            id: 'deactivate',
                            role: 'menuitem',
                            href: '#',
                            onClick: this.handleShowDeactivateMemberModal
                        },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'admin.user_item.makeInactive',
                            defaultMessage: 'Deactivate'
                        })
                    )
                );
            }

            var manageTeams = null;
            if (showManageTeams) {
                manageTeams = _react2.default.createElement(
                    'li',
                    { role: 'presentation' },
                    _react2.default.createElement(
                        'a',
                        {
                            id: 'manageTeams',
                            role: 'menuitem',
                            href: '#',
                            onClick: this.handleManageTeams
                        },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'admin.user_item.manageTeams',
                            defaultMessage: 'Manage Teams'
                        })
                    )
                );
            }

            var mfaReset = null;
            if (showMfaReset) {
                mfaReset = _react2.default.createElement(
                    'li',
                    { role: 'presentation' },
                    _react2.default.createElement(
                        'a',
                        {
                            id: 'removeMFA',
                            role: 'menuitem',
                            href: '#',
                            onClick: this.handleResetMfa
                        },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'admin.user_item.resetMfa',
                            defaultMessage: 'Remove MFA'
                        })
                    )
                );
            }

            var passwordReset = void 0;
            if (user.auth_service) {
                if (this.props.experimentalEnableAuthenticationTransfer) {
                    passwordReset = _react2.default.createElement(
                        'li',
                        { role: 'presentation' },
                        _react2.default.createElement(
                            'a',
                            {
                                id: 'switchEmailPassword',
                                role: 'menuitem',
                                href: '#',
                                onClick: this.handleResetPassword
                            },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'admin.user_item.switchToEmail',
                                defaultMessage: 'Switch to Email/Password'
                            })
                        )
                    );
                }
            } else {
                passwordReset = _react2.default.createElement(
                    'li',
                    { role: 'presentation' },
                    _react2.default.createElement(
                        'a',
                        {
                            id: 'resetPassword',
                            role: 'menuitem',
                            href: '#',
                            onClick: this.handleResetPassword
                        },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'admin.user_item.resetPwd',
                            defaultMessage: 'Reset Password'
                        })
                    )
                );
            }

            var revokeSessions = void 0;
            if (showRevokeSessions) {
                revokeSessions = _react2.default.createElement(
                    _system_permission_gate2.default,
                    { permissions: [_constants.Permissions.REVOKE_USER_ACCESS_TOKEN] },
                    _react2.default.createElement(
                        'li',
                        { role: 'presentation' },
                        _react2.default.createElement(
                            'a',
                            {
                                id: 'revokeSessions',
                                role: 'menuItem',
                                href: '#',
                                onClick: this.handleShowRevokeSessionsModal
                            },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'admin.user_item.revokeSessions',
                                defaultMessage: 'Revoke Sessions'
                            })
                        )
                    )
                );
            }

            var manageTokens = void 0;
            if (this.props.enableUserAccessTokens) {
                manageTokens = _react2.default.createElement(
                    'li',
                    { role: 'presentation' },
                    _react2.default.createElement(
                        'a',
                        {
                            id: 'manageTokens',
                            role: 'menuitem',
                            href: '#',
                            onClick: this.handleManageTokens
                        },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'admin.user_item.manageTokens',
                            defaultMessage: 'Manage Tokens'
                        })
                    )
                );
            }

            var makeDemoteModal = null;
            if (this.props.user.id === me.id) {
                var title = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'admin.user_item.confirmDemoteRoleTitle',
                    defaultMessage: 'Confirm demotion from System Admin role'
                });

                var message = _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.user_item.confirmDemoteDescription',
                        defaultMessage: 'If you demote yourself from the System Admin role and there is not another user with System Admin privileges, you\'ll need to re-assign a System Admin by accessing the Mattermost server through a terminal and running the following command.'
                    }),
                    _react2.default.createElement('br', null),
                    _react2.default.createElement('br', null),
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.user_item.confirmDemotionCmd',
                        defaultMessage: 'platform roles system_admin {username}',
                        values: {
                            username: me.username
                        }
                    })
                );

                var confirmButton = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'admin.user_item.confirmDemotion',
                    defaultMessage: 'Confirm Demotion'
                });

                makeDemoteModal = _react2.default.createElement(_confirm_modal2.default, {
                    show: this.state.showDemoteModal,
                    title: title,
                    message: message,
                    confirmButtonText: confirmButton,
                    onConfirm: this.handleDemoteSubmit,
                    onCancel: this.handleDemoteCancel
                });
            }

            var deactivateMemberModal = this.renderDeactivateMemberModal();
            var revokeSessionsModal = this.renderRevokeSessionsModal();

            return _react2.default.createElement(
                'div',
                { className: 'dropdown member-drop text-right' },
                _react2.default.createElement(
                    'a',
                    {
                        id: 'memberDropdown',
                        href: '#',
                        className: 'dropdown-toggle theme',
                        type: 'button',
                        'data-toggle': 'dropdown',
                        'aria-expanded': 'true'
                    },
                    _react2.default.createElement(
                        'span',
                        null,
                        currentRoles,
                        ' '
                    ),
                    _react2.default.createElement('span', { className: 'caret' })
                ),
                this.renderAccessToken(),
                _react2.default.createElement(
                    'ul',
                    {
                        className: 'dropdown-menu member-menu',
                        role: 'menu'
                    },
                    makeActive,
                    makeNotActive,
                    _react2.default.createElement(
                        'li',
                        { role: 'presentation' },
                        _react2.default.createElement(
                            'a',
                            {
                                id: 'manageRoles',
                                role: 'menuitem',
                                href: '#',
                                onClick: this.handleManageRoles
                            },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'admin.user_item.manageRoles',
                                defaultMessage: 'Manage Roles'
                            })
                        )
                    ),
                    manageTeams,
                    manageTokens,
                    mfaReset,
                    passwordReset,
                    revokeSessions
                ),
                makeDemoteModal,
                deactivateMemberModal,
                revokeSessionsModal
            );
        }
    }]);
    return SystemUsersDropdown;
}(_react2.default.Component);

SystemUsersDropdown.propTypes = {

    /*
     * User to manage with dropdown
     */
    user: _propTypes2.default.object.isRequired,

    /**
     * Whether MFA is licensed and enabled.
     */
    mfaEnabled: _propTypes2.default.bool.isRequired,

    /**
     * Whether or not user access tokens are enabled.
     */
    enableUserAccessTokens: _propTypes2.default.bool.isRequired,

    /**
     * Whether or not the experimental authentication transfer is enabled.
     */
    experimentalEnableAuthenticationTransfer: _propTypes2.default.bool.isRequired,

    /*
     * Function to open password reset, takes user as an argument
     */
    doPasswordReset: _propTypes2.default.func.isRequired,

    /*
     * Function to open manage teams, takes user as an argument
     */
    doManageTeams: _propTypes2.default.func.isRequired,

    /*
     * Function to open manage roles, takes user as an argument
     */
    doManageRoles: _propTypes2.default.func.isRequired,

    /*
     * Function to open manage tokens, takes user as an argument
     */
    doManageTokens: _propTypes2.default.func.isRequired,

    /*
     * The function to call when an error occurs
     */
    onError: _propTypes2.default.func.isRequired
};
exports.default = SystemUsersDropdown;

/***/ }),

/***/ 2706:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _reactRedux = __webpack_require__(268);

var _redux = __webpack_require__(1);

var _admin = __webpack_require__(855);

var _admin2 = __webpack_require__(995);

var Selectors = _interopRequireWildcard(_admin2);

var _logs = __webpack_require__(2707);

var _logs2 = _interopRequireDefault(_logs);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state, ownProps) {
    return (0, _extends3.default)({}, ownProps, {
        logs: Selectors.getLogs(state)
    });
} // Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapDispatchToProps(dispatch) {
    return {
        actions: (0, _redux.bindActionCreators)({
            getLogs: _admin.getLogs
        }, dispatch)
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_logs2.default);

/***/ }),

/***/ 2707:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _loading_screen = __webpack_require__(792);

var _loading_screen2 = _interopRequireDefault(_loading_screen);

var _log_list = __webpack_require__(2708);

var _log_list2 = _interopRequireDefault(_log_list);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Logs = function (_React$Component) {
    (0, _inherits3.default)(Logs, _React$Component);

    function Logs(props) {
        (0, _classCallCheck3.default)(this, Logs);

        var _this = (0, _possibleConstructorReturn3.default)(this, (Logs.__proto__ || (0, _getPrototypeOf2.default)(Logs)).call(this, props));

        _this.nextPage = function () {
            _this.setState({ page: _this.state.page + 1 });
        };

        _this.previousPage = function () {
            _this.setState({ page: _this.state.page - 1 });
        };

        _this.reload = function () {
            _this.setState({ loadingLogs: true });
            _this.props.actions.getLogs(_this.state.page, _this.state.perPage).then(function () {
                return _this.setState({ loadingLogs: false });
            });
        };

        _this.state = {
            loadingLogs: true,
            page: 0,
            perPage: 1000
        };
        return _this;
    }

    (0, _createClass3.default)(Logs, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            this.props.actions.getLogs(this.state.page, this.state.perPage).then(function () {
                return _this2.setState({ loadingLogs: false });
            });
        }
    }, {
        key: 'componentWillUpdate',
        value: function componentWillUpdate(nextProps, nextState) {
            var _this3 = this;

            if (this.state.page !== nextState.page) {
                this.props.actions.getLogs(nextState.page, nextState.perPage).then(function () {
                    return _this3.setState({ loadingLogs: false });
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var content = null;

            if (this.state.loadingLogs) {
                content = _react2.default.createElement(_loading_screen2.default, null);
            } else {
                content = _react2.default.createElement(_log_list2.default, (0, _extends3.default)({}, this.props, {
                    nextPage: this.nextPage,
                    previousPage: this.previousPage,
                    page: this.state.page,
                    perPage: this.state.perPage
                }));
            }

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'h3',
                    { className: 'admin-console-header' },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.logs.title',
                        defaultMessage: 'Server Logs'
                    })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'banner' },
                    _react2.default.createElement(
                        'div',
                        { className: 'banner__content' },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'admin.logs.bannerDesc',
                            defaultMessage: 'To look up users by User ID or Token ID, go to Reporting > Users and paste the ID into the search filter.'
                        })
                    )
                ),
                _react2.default.createElement(
                    'button',
                    {
                        type: 'submit',
                        className: 'btn btn-primary',
                        onClick: this.reload
                    },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.logs.reload',
                        defaultMessage: 'Reload'
                    })
                ),
                content
            );
        }
    }]);
    return Logs;
}(_react2.default.Component); // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

Logs.propTypes = {

    /*
     * Array of logs to render
     */
    logs: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
    nextPage: _propTypes2.default.func,

    actions: _propTypes2.default.shape({

        /*
         * Function to fetch logs
         */
        getLogs: _propTypes2.default.func.isRequired
    }).isRequired
};
exports.default = Logs;

/***/ }),

/***/ 2708:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NEXT_BUTTON_TIMEOUT = 500; // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var Logs = function (_React$PureComponent) {
    (0, _inherits3.default)(Logs, _React$PureComponent);

    function Logs(props) {
        (0, _classCallCheck3.default)(this, Logs);

        var _this = (0, _possibleConstructorReturn3.default)(this, (Logs.__proto__ || (0, _getPrototypeOf2.default)(Logs)).call(this, props));

        _this.nextPage = _this.nextPage.bind(_this);
        _this.previousPage = _this.previousPage.bind(_this);
        _this.state = {
            nextDisabled: false
        };
        return _this;
    }

    (0, _createClass3.default)(Logs, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            // Scroll Down to get the latest logs
            var node = this.refs.logPanel;
            node.scrollTop = node.scrollHeight;
            node.focus();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            // Scroll Down to get the latest logs
            var node = this.refs.logPanel;
            node.scrollTop = node.scrollHeight;
            node.focus();
        }
    }, {
        key: 'nextPage',
        value: function nextPage(e) {
            var _this2 = this;

            e.preventDefault();

            this.setState({ nextDisabled: true });
            this.nextTimeoutId = setTimeout(function () {
                return _this2.setState({ nextDisabled: false });
            }, NEXT_BUTTON_TIMEOUT);

            this.props.nextPage();
        }
    }, {
        key: 'previousPage',
        value: function previousPage(e) {
            e.preventDefault();

            this.props.previousPage();
        }
    }, {
        key: 'render',
        value: function render() {
            var content = null;
            var nextButton = void 0;
            var previousButton = void 0;

            if (this.props.logs.length >= this.props.perPage) {
                nextButton = _react2.default.createElement(
                    'button',
                    {
                        className: 'btn btn-default filter-control filter-control__next pull-right',
                        onClick: this.nextPage,
                        disabled: this.state.nextDisabled
                    },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.logs.next',
                        defaultMessage: 'Next'
                    }),
                    _react2.default.createElement('i', { className: 'fa fa-chevron-right margin-left' })
                );
            }

            if (this.props.page > 0) {
                previousButton = _react2.default.createElement(
                    'button',
                    {
                        className: 'btn btn-default filter-control filter-control__prev',
                        onClick: this.previousPage
                    },
                    _react2.default.createElement('i', { className: 'fa fa-angle-left' }),
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.logs.prev',
                        defaultMessage: 'Previous'
                    })
                );
            }

            content = [];

            for (var i = 0; i < this.props.logs.length; i++) {
                var style = {
                    whiteSpace: 'nowrap',
                    fontFamily: 'monospace'
                };

                if (this.props.logs[i].indexOf('[EROR]') > 0) {
                    style.color = 'red';
                }

                content.push(_react2.default.createElement('br', { key: 'br_' + i }));
                content.push(_react2.default.createElement(
                    'span',
                    {
                        key: 'log_' + i,
                        style: style
                    },
                    this.props.logs[i]
                ));
            }

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    {
                        tabIndex: '-1',
                        ref: 'logPanel',
                        className: 'log__panel'
                    },
                    content
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'padding-top padding-bottom x2 filter-controls' },
                    previousButton,
                    nextButton
                )
            );
        }
    }]);
    return Logs;
}(_react2.default.PureComponent);

Logs.propTypes = {

    /*
     * Array of logs to render
     */
    logs: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
    page: _propTypes2.default.number.isRequired,
    perPage: _propTypes2.default.number.isRequired,
    nextPage: _propTypes2.default.func.isRequired,
    previousPage: _propTypes2.default.func.isRequired
};
exports.default = Logs;

/***/ }),

/***/ 2709:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _values = __webpack_require__(801);

var _values2 = _interopRequireDefault(_values);

var _reactRedux = __webpack_require__(268);

var _redux = __webpack_require__(1);

var _admin = __webpack_require__(855);

var _admin2 = __webpack_require__(995);

var Selectors = _interopRequireWildcard(_admin2);

var _general = __webpack_require__(113);

var _audits = __webpack_require__(2710);

var _audits2 = _interopRequireDefault(_audits);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapStateToProps(state) {
    var license = (0, _general.getLicense)(state);
    var isLicensed = license.IsLicensed === 'true';

    return {
        isLicensed: isLicensed,
        audits: (0, _values2.default)(Selectors.getAudits(state))
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: (0, _redux.bindActionCreators)({
            getAudits: _admin.getAudits
        }, dispatch)
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_audits2.default);

/***/ }),

/***/ 2710:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _compliance_reports = __webpack_require__(2711);

var _compliance_reports2 = _interopRequireDefault(_compliance_reports);

var _audit_table = __webpack_require__(1404);

var _audit_table2 = _interopRequireDefault(_audit_table);

var _loading_screen = __webpack_require__(792);

var _loading_screen2 = _interopRequireDefault(_loading_screen);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var Audits = function (_React$PureComponent) {
    (0, _inherits3.default)(Audits, _React$PureComponent);

    function Audits(props) {
        (0, _classCallCheck3.default)(this, Audits);

        var _this = (0, _possibleConstructorReturn3.default)(this, (Audits.__proto__ || (0, _getPrototypeOf2.default)(Audits)).call(this, props));

        _this.reload = function () {
            _this.setState({ loadingAudits: true });
            _this.props.actions.getAudits().then(function () {
                return _this.setState({ loadingAudits: false });
            });
        };

        _this.state = {
            loadingAudits: true
        };
        return _this;
    }

    (0, _createClass3.default)(Audits, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            this.props.actions.getAudits().then(function () {
                return _this2.setState({ loadingAudits: false });
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var content = null;

            if (!this.props.isLicensed) {
                return _react2.default.createElement('div', null);
            }

            if (this.state.loadingAudits) {
                content = _react2.default.createElement(_loading_screen2.default, null);
            } else {
                content = _react2.default.createElement(
                    'div',
                    { style: style.auditTable },
                    _react2.default.createElement(_audit_table2.default, {
                        audits: this.props.audits,
                        showUserId: true,
                        showIp: true,
                        showSession: true
                    })
                );
            }

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_compliance_reports2.default, null),
                _react2.default.createElement(
                    'div',
                    { className: 'panel audit-panel' },
                    _react2.default.createElement(
                        'h3',
                        { className: 'admin-console-header' },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'admin.audits.title',
                            defaultMessage: 'User Activity Logs'
                        }),
                        _react2.default.createElement(
                            'button',
                            {
                                type: 'submit',
                                className: 'btn btn-link pull-right',
                                onClick: this.reload
                            },
                            _react2.default.createElement('i', { className: 'fa fa-refresh' }),
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'admin.audits.reload',
                                defaultMessage: 'Reload User Activity Logs'
                            })
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'audit-panel__table' },
                        content
                    )
                )
            );
        }
    }]);
    return Audits;
}(_react2.default.PureComponent);

Audits.propTypes = {
    isLicensed: _propTypes2.default.bool.isRequired,

    /*
     * Array of audits to render
     */
    audits: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,

    actions: _propTypes2.default.shape({

        /*
         * Function to fetch audits
         */
        getAudits: _propTypes2.default.func.isRequired
    }).isRequired
};
exports.default = Audits;


var style = {
    auditTable: { margin: 10 }
};

/***/ }),

/***/ 2711:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _values = __webpack_require__(801);

var _values2 = _interopRequireDefault(_values);

var _reactRedux = __webpack_require__(268);

var _redux = __webpack_require__(1);

var _admin = __webpack_require__(855);

var _admin2 = __webpack_require__(995);

var _general = __webpack_require__(113);

var _compliance_reports = __webpack_require__(2712);

var _compliance_reports2 = _interopRequireDefault(_compliance_reports);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapStateToProps(state) {
    var license = (0, _general.getLicense)(state);
    var isLicensed = license.IsLicensed === 'true';

    var enabled = false;
    var config = (0, _admin2.getConfig)(state);
    if (config && config.ComplianceSettings) {
        enabled = config.ComplianceSettings.Enable;
    }

    var serverError = void 0;
    var error = state.requests.admin.createCompliance.error;
    if (error) {
        serverError = error.message;
    }

    var reports = (0, _values2.default)((0, _admin2.getComplianceReports)(state)).sort(function (a, b) {
        return b.create_at - a.create_at;
    });

    return {
        isLicensed: isLicensed,
        enabled: enabled,
        reports: reports,
        serverError: serverError
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: (0, _redux.bindActionCreators)({
            getComplianceReports: _admin.getComplianceReports,
            createComplianceReport: _admin.createComplianceReport
        }, dispatch)
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_compliance_reports2.default);

/***/ }),

/***/ 2712:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _client = __webpack_require__(270);

var _user_store = __webpack_require__(774);

var _user_store2 = _interopRequireDefault(_user_store);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _loading_screen = __webpack_require__(792);

var _loading_screen2 = _interopRequireDefault(_loading_screen);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ComplianceReports = function (_React$PureComponent) {
    (0, _inherits3.default)(ComplianceReports, _React$PureComponent);

    function ComplianceReports(props) {
        (0, _classCallCheck3.default)(this, ComplianceReports);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ComplianceReports.__proto__ || (0, _getPrototypeOf2.default)(ComplianceReports)).call(this, props));

        _this.reload = function () {
            _this.setState({ loadingReports: true });

            _this.props.actions.getComplianceReports().then(function () {
                return _this.setState({ loadingReports: false });
            });
        };

        _this.runReport = function (e) {
            e.preventDefault();

            _this.setState({ runningReport: true });

            var job = {};
            job.desc = _this.refs.desc.value;
            job.emails = _this.refs.emails.value;
            job.keywords = _this.refs.keywords.value;
            job.start_at = Date.parse(_this.refs.from.value);
            job.end_at = Date.parse(_this.refs.to.value);

            _this.props.actions.createComplianceReport(job).then(function (_ref) {
                var data = _ref.data;

                if (data) {
                    _this.refs.emails.value = '';
                    _this.refs.keywords.value = '';
                    _this.refs.desc.value = '';
                    _this.refs.from.value = '';
                    _this.refs.to.value = '';
                }
                _this.setState({ runningReport: false });
            });
        };

        _this.state = {
            loadingReports: true
        };
        return _this;
    }

    (0, _createClass3.default)(ComplianceReports, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            if (!this.props.isLicensed || !this.props.enabled) {
                return;
            }

            this.props.actions.getComplianceReports().then(function () {
                return _this2.setState({ loadingReports: false });
            });
        }
    }, {
        key: 'getDateTime',
        value: function getDateTime(millis) {
            var date = new Date(millis);
            return _react2.default.createElement(
                'span',
                { style: style.date },
                _react2.default.createElement(_reactIntl.FormattedDate, {
                    value: date,
                    day: '2-digit',
                    month: 'short',
                    year: 'numeric'
                }),
                ' - ',
                _react2.default.createElement(_reactIntl.FormattedTime, {
                    value: date,
                    hour: '2-digit',
                    minute: '2-digit'
                })
            );
        }
    }, {
        key: 'render',
        value: function render() {
            if (!this.props.isLicensed || !this.props.enabled) {
                return _react2.default.createElement('div', null);
            }

            var content = null;
            if (this.state.loadingReports) {
                content = _react2.default.createElement(_loading_screen2.default, null);
            } else {
                var list = [];

                for (var i = 0; i < this.props.reports.length; i++) {
                    var report = this.props.reports[i];

                    var params = '';
                    if (report.type === 'adhoc') {
                        params = _react2.default.createElement(
                            'span',
                            null,
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'admin.compliance_reports.from',
                                defaultMessage: 'From:'
                            }),
                            ' ',
                            this.getDateTime(report.start_at),
                            _react2.default.createElement('br', null),
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'admin.compliance_reports.to',
                                defaultMessage: 'To:'
                            }),
                            ' ',
                            this.getDateTime(report.end_at),
                            _react2.default.createElement('br', null),
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'admin.compliance_reports.emails',
                                defaultMessage: 'Emails:'
                            }),
                            ' ',
                            report.emails,
                            _react2.default.createElement('br', null),
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'admin.compliance_reports.keywords',
                                defaultMessage: 'Keywords:'
                            }),
                            ' ',
                            report.keywords
                        );
                    }

                    var download = '';
                    var status = '';
                    if (report.status === 'finished') {
                        download = _react2.default.createElement(
                            'a',
                            { href: _client.Client4.getBaseRoute() + '/compliance/reports/' + report.id + '/download' },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'admin.compliance_table.download',
                                defaultMessage: 'Download'
                            })
                        );

                        status = _react2.default.createElement(
                            'span',
                            { style: style.greenStatus },
                            report.status
                        );
                    } else if (report.status === 'failed') {
                        status = _react2.default.createElement(
                            'span',
                            { style: style.redStatus },
                            report.status
                        );
                    }

                    var user = report.user_id;
                    var profile = _user_store2.default.getProfile(report.user_id);
                    if (profile) {
                        user = profile.email;
                    }

                    list[i] = _react2.default.createElement(
                        'tr',
                        { key: report.id },
                        _react2.default.createElement(
                            'td',
                            { style: style.dataCell },
                            download
                        ),
                        _react2.default.createElement(
                            'td',
                            null,
                            this.getDateTime(report.create_at)
                        ),
                        _react2.default.createElement(
                            'td',
                            null,
                            status
                        ),
                        _react2.default.createElement(
                            'td',
                            null,
                            report.count
                        ),
                        _react2.default.createElement(
                            'td',
                            null,
                            report.type
                        ),
                        _react2.default.createElement(
                            'td',
                            { style: style.dataCell },
                            report.desc
                        ),
                        _react2.default.createElement(
                            'td',
                            null,
                            user
                        ),
                        _react2.default.createElement(
                            'td',
                            { style: style.dataCell },
                            params
                        )
                    );
                }

                content = _react2.default.createElement(
                    'div',
                    { style: style.content },
                    _react2.default.createElement(
                        'table',
                        { className: 'table' },
                        _react2.default.createElement(
                            'thead',
                            null,
                            _react2.default.createElement(
                                'tr',
                                null,
                                _react2.default.createElement('th', null),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'admin.compliance_table.timestamp',
                                        defaultMessage: 'Timestamp'
                                    })
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'admin.compliance_table.status',
                                        defaultMessage: 'Status'
                                    })
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'admin.compliance_table.records',
                                        defaultMessage: 'Records'
                                    })
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'admin.compliance_table.type',
                                        defaultMessage: 'Type'
                                    })
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'admin.compliance_table.desc',
                                        defaultMessage: 'Description'
                                    })
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'admin.compliance_table.userId',
                                        defaultMessage: 'Requested By'
                                    })
                                ),
                                _react2.default.createElement(
                                    'th',
                                    null,
                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'admin.compliance_table.params',
                                        defaultMessage: 'Params'
                                    })
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'tbody',
                            null,
                            list
                        )
                    )
                );
            }

            var serverError = '';
            if (this.props.serverError) {
                serverError = _react2.default.createElement(
                    'div',
                    {
                        className: 'form-group has-error',
                        style: style.serverError
                    },
                    _react2.default.createElement(
                        'label',
                        { className: 'control-label' },
                        this.props.serverError
                    )
                );
            }

            return _react2.default.createElement(
                'div',
                { className: 'panel compliance-panel' },
                _react2.default.createElement(
                    'h3',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.compliance_reports.title',
                        defaultMessage: 'Compliance Reports'
                    })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'row' },
                    _react2.default.createElement(
                        'div',
                        { className: 'col-sm-6 col-md-4 form-group' },
                        _react2.default.createElement(
                            'label',
                            null,
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'admin.compliance_reports.desc',
                                defaultMessage: 'Job Name:'
                            })
                        ),
                        _react2.default.createElement('input', {
                            type: 'text',
                            className: 'form-control',
                            id: 'desc',
                            ref: 'desc',
                            placeholder: Utils.localizeMessage('admin.compliance_reports.desc_placeholder', 'E.g. "Audit 445 for HR"')
                        })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'col-sm-3 col-md-2 form-group' },
                        _react2.default.createElement(
                            'label',
                            null,
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'admin.compliance_reports.from',
                                defaultMessage: 'From:'
                            })
                        ),
                        _react2.default.createElement('input', {
                            type: 'text',
                            className: 'form-control',
                            id: 'from',
                            ref: 'from',
                            placeholder: Utils.localizeMessage('admin.compliance_reports.from_placeholder', 'E.g. "2016-03-11"')
                        })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'col-sm-3 col-md-2 form-group' },
                        _react2.default.createElement(
                            'label',
                            null,
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'admin.compliance_reports.to',
                                defaultMessage: 'To:'
                            })
                        ),
                        _react2.default.createElement('input', {
                            type: 'text',
                            className: 'form-control',
                            id: 'to',
                            ref: 'to',
                            placeholder: Utils.localizeMessage('admin.compliance_reports.to_placeholder', 'E.g. "2016-03-15"')
                        })
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'row' },
                    _react2.default.createElement(
                        'div',
                        { className: 'col-sm-6 col-md-4 form-group' },
                        _react2.default.createElement(
                            'label',
                            null,
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'admin.compliance_reports.emails',
                                defaultMessage: 'Emails:'
                            })
                        ),
                        _react2.default.createElement('input', {
                            type: 'text',
                            className: 'form-control',
                            id: 'emails',
                            ref: 'emails',
                            placeholder: Utils.localizeMessage('admin.compliance_reports.emails_placeholder', 'E.g. "bill@example.com, bob@example.com"')
                        })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'col-sm-6 col-md-4 form-group' },
                        _react2.default.createElement(
                            'label',
                            null,
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'admin.compliance_reports.keywords',
                                defaultMessage: 'Keywords:'
                            })
                        ),
                        _react2.default.createElement('input', {
                            type: 'text',
                            className: 'form-control',
                            id: 'keywords',
                            ref: 'keywords',
                            placeholder: Utils.localizeMessage('admin.compliance_reports.keywords_placeholder', 'E.g. "shorting stock"')
                        })
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'clearfix' },
                    _react2.default.createElement(
                        'button',
                        {
                            id: 'run-button',
                            type: 'submit',
                            className: 'btn btn-primary',
                            onClick: this.runReport
                        },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'admin.compliance_reports.run',
                            defaultMessage: 'Run Compliance Report'
                        })
                    )
                ),
                serverError,
                _react2.default.createElement(
                    'div',
                    { className: 'text-right' },
                    _react2.default.createElement(
                        'button',
                        {
                            type: 'submit',
                            className: 'btn btn-link',
                            disabled: this.state.runningReport,
                            onClick: this.reload
                        },
                        _react2.default.createElement('i', { className: 'fa fa-refresh' }),
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'admin.compliance_reports.reload',
                            defaultMessage: 'Reload Completed Compliance Reports'
                        })
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'compliance-panel__table' },
                    content
                )
            );
        }
    }]);
    return ComplianceReports;
}(_react2.default.PureComponent); // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

ComplianceReports.propTypes = {

    /*
     * Set if compliance reports are licensed
     */
    isLicensed: _propTypes2.default.bool.isRequired,

    /*
     * Set if compliance reports are enabled in the config
     */
    enabled: _propTypes2.default.bool.isRequired,

    /*
     * Array of reports to render
     */
    reports: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,

    /*
     * Error message to display
     */
    serverError: _propTypes2.default.string,

    actions: _propTypes2.default.shape({

        /*
         * Function to get compliance reports
         */
        getComplianceReports: _propTypes2.default.func.isRequired,

        /*
         * Function to save compliance reports
         */
        createComplianceReport: _propTypes2.default.func.isRequired
    }).isRequired
};
exports.default = ComplianceReports;


var style = {
    content: { margin: 10 },
    greenStatus: { color: 'green' },
    redStatus: { color: 'red' },
    dataCell: { whiteSpace: 'nowrap' },
    date: { whiteSpace: 'nowrap' },
    serverError: { marginTop: '10px' }
};

/***/ }),

/***/ 2713:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _jquery = __webpack_require__(773);

var _jquery2 = _interopRequireDefault(_jquery);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(272);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactIntl = __webpack_require__(761);

var _admin_actions = __webpack_require__(797);

var _error_store = __webpack_require__(847);

var _error_store2 = _interopRequireDefault(_error_store);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var holders = (0, _reactIntl.defineMessages)({
    removing: {
        id: 'admin.license.removing',
        defaultMessage: 'Removing License...'
    },
    uploading: {
        id: 'admin.license.uploading',
        defaultMessage: 'Uploading License...'
    }
});

var LicenseSettings = function (_React$Component) {
    (0, _inherits3.default)(LicenseSettings, _React$Component);

    function LicenseSettings(props) {
        (0, _classCallCheck3.default)(this, LicenseSettings);

        var _this = (0, _possibleConstructorReturn3.default)(this, (LicenseSettings.__proto__ || (0, _getPrototypeOf2.default)(LicenseSettings)).call(this, props));

        _this.handleChange = _this.handleChange.bind(_this);
        _this.handleSubmit = _this.handleSubmit.bind(_this);
        _this.handleRemove = _this.handleRemove.bind(_this);

        _this.state = {
            fileSelected: false,
            fileName: null,
            serverError: null
        };
        return _this;
    }

    (0, _createClass3.default)(LicenseSettings, [{
        key: 'handleChange',
        value: function handleChange() {
            var element = (0, _jquery2.default)(_reactDom2.default.findDOMNode(this.refs.fileInput));
            if (element.prop('files').length > 0) {
                this.setState({ fileSelected: true, fileName: element.prop('files')[0].name });
            }
        }
    }, {
        key: 'handleSubmit',
        value: function handleSubmit(e) {
            var _this2 = this;

            e.preventDefault();

            var element = (0, _jquery2.default)(_reactDom2.default.findDOMNode(this.refs.fileInput));
            if (element.prop('files').length === 0) {
                return;
            }
            var file = element.prop('files')[0];

            (0, _jquery2.default)('#upload-button').button('loading');

            (0, _admin_actions.uploadLicenseFile)(file, function () {
                Utils.clearFileInput(element[0]);
                (0, _jquery2.default)('#upload-button').button('reset');
                _this2.setState({ fileSelected: false, fileName: null, serverError: null });
                window.location.reload(true);
            }, function (error) {
                Utils.clearFileInput(element[0]);
                (0, _jquery2.default)('#upload-button').button('reset');
                _this2.setState({ fileSelected: false, fileName: null, serverError: error.message });
            });
        }
    }, {
        key: 'handleRemove',
        value: function handleRemove(e) {
            var _this3 = this;

            e.preventDefault();

            (0, _jquery2.default)('#remove-button').button('loading');

            (0, _admin_actions.removeLicenseFile)(function () {
                (0, _jquery2.default)('#remove-button').button('reset');
                _this3.setState({ fileSelected: false, fileName: null, serverError: null });
                _error_store2.default.clearLastError(true);
                window.location.reload(true);
            }, function (error) {
                (0, _jquery2.default)('#remove-button').button('reset');
                _this3.setState({ fileSelected: false, fileName: null, serverError: error.message });
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var serverError = '';
            if (this.state.serverError) {
                serverError = _react2.default.createElement(
                    'div',
                    { className: 'col-sm-12' },
                    _react2.default.createElement(
                        'div',
                        { className: 'form-group has-error' },
                        _react2.default.createElement(
                            'label',
                            { className: 'control-label' },
                            this.state.serverError
                        )
                    )
                );
            }

            var btnClass = 'btn';
            if (this.state.fileSelected) {
                btnClass = 'btn btn-primary';
            }

            var edition = void 0;
            var licenseType = void 0;
            var licenseKey = void 0;

            var issued = Utils.displayDate(parseInt(this.props.license.IssuedAt, 10)) + ' ' + Utils.displayTime(parseInt(this.props.license.IssuedAt, 10), true);
            var startsAt = Utils.displayDate(parseInt(this.props.license.StartsAt, 10));
            var expiresAt = Utils.displayDate(parseInt(this.props.license.ExpiresAt, 10));

            if (this.props.license.IsLicensed === 'true') {
                // Note: DO NOT LOCALISE THESE STRINGS. Legally we can not since the license is in English.
                edition = 'Mattermost Enterprise Edition. Enterprise features on this server have been unlocked with a license key and a valid subscription.';
                licenseType = _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'p',
                        null,
                        'This software is offered under a commercial license.\n\nSee ENTERPRISE-EDITION-LICENSE.txt in your root install directory for details. See NOTICE.txt for information about open source software used in this system.\n\nYour subscription details are as follows:'
                    ),
                    'Name: ' + this.props.license.Name,
                    _react2.default.createElement('br', null),
                    'Company or organization name: ' + this.props.license.Company,
                    _react2.default.createElement('br', null),
                    'Number of users: ' + this.props.license.Users,
                    _react2.default.createElement('br', null),
                    'License issued: ' + issued,
                    _react2.default.createElement('br', null),
                    'Start date of license: ' + startsAt,
                    _react2.default.createElement('br', null),
                    'Expiry date of license: ' + expiresAt,
                    _react2.default.createElement('br', null),
                    _react2.default.createElement('br', null),
                    'See also ',
                    _react2.default.createElement(
                        'a',
                        { href: 'https://about.mattermost.com/enterprise-edition-terms/' },
                        'Enterprise Edition Terms of Service'
                    ),
                    ' and ',
                    _react2.default.createElement(
                        'a',
                        { href: 'https://about.mattermost.com/privacy/' },
                        'Privacy Policy.'
                    )
                );

                licenseKey = _react2.default.createElement(
                    'div',
                    { className: 'col-sm-8' },
                    _react2.default.createElement(
                        'button',
                        {
                            className: 'btn btn-danger',
                            onClick: this.handleRemove,
                            id: 'remove-button',
                            'data-loading-text': '<span class=\'fa fa-refresh icon--rotate\'></span> ' + this.props.intl.formatMessage(holders.removing)
                        },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'admin.license.keyRemove',
                            defaultMessage: 'Remove Enterprise License and Downgrade Server'
                        })
                    ),
                    _react2.default.createElement('br', null),
                    _react2.default.createElement('br', null),
                    _react2.default.createElement(
                        'p',
                        { className: 'help-text' },
                        'If you migrate servers you may need to remove your license key to install it elsewhere. You can remove the key here, which will revert functionality to that of Team Edition.'
                    )
                );
            } else {
                // Note: DO NOT LOCALISE THESE STRINGS. Legally we can not since the license is in English.
                edition = _react2.default.createElement(
                    'p',
                    null,
                    'Mattermost Enterprise Edition. Unlock enterprise features in this software through the purchase of a subscription from ',
                    _react2.default.createElement(
                        'a',
                        {
                            target: '_blank',
                            rel: 'noopener noreferrer',
                            href: 'https://mattermost.com/'
                        },
                        'https://mattermost.com/'
                    )
                );

                licenseType = 'This software is offered under a commercial license.\n\nSee ENTERPRISE-EDITION-LICENSE.txt in your root install directory for details. See NOTICE.txt for information about open source software used in this system.';

                var fileName = void 0;
                if (this.state.fileName) {
                    fileName = this.state.fileName;
                } else {
                    fileName = _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.license.noFile',
                        defaultMessage: 'No file uploaded'
                    });
                }

                licenseKey = _react2.default.createElement(
                    'div',
                    { className: 'col-sm-8' },
                    _react2.default.createElement(
                        'div',
                        { className: 'file__upload' },
                        _react2.default.createElement(
                            'button',
                            { className: 'btn btn-primary' },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'admin.license.choose',
                                defaultMessage: 'Choose File'
                            })
                        ),
                        _react2.default.createElement('input', {
                            ref: 'fileInput',
                            type: 'file',
                            accept: '.mattermost-license',
                            onChange: this.handleChange
                        })
                    ),
                    _react2.default.createElement(
                        'button',
                        {
                            className: btnClass,
                            disabled: !this.state.fileSelected,
                            onClick: this.handleSubmit,
                            id: 'upload-button',
                            'data-loading-text': '<span class=\'fa fa-refresh icon--rotate\'></span> ' + this.props.intl.formatMessage(holders.uploading)
                        },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'admin.license.upload',
                            defaultMessage: 'Upload'
                        })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'help-text no-margin' },
                        fileName
                    ),
                    _react2.default.createElement('br', null),
                    serverError,
                    _react2.default.createElement(
                        'p',
                        { className: 'help-text no-margin' },
                        _react2.default.createElement(_reactIntl.FormattedHTMLMessage, {
                            id: 'admin.license.uploadDesc',
                            defaultMessage: 'Upload a license key for Mattermost Enterprise Edition to upgrade this server. <a href="http://mattermost.com" target="_blank">Visit us online</a> to learn more about the benefits of Enterprise Edition or to purchase a key.'
                        })
                    )
                );
            }

            return _react2.default.createElement(
                'div',
                { className: 'wrapper--fixed' },
                _react2.default.createElement(
                    'h3',
                    { className: 'admin-console-header' },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'admin.license.title',
                        defaultMessage: 'Edition and License'
                    })
                ),
                _react2.default.createElement(
                    'form',
                    {
                        className: 'form-horizontal',
                        role: 'form'
                    },
                    _react2.default.createElement(
                        'div',
                        { className: 'form-group' },
                        _react2.default.createElement(
                            'label',
                            {
                                className: 'control-label col-sm-4'
                            },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'admin.license.edition',
                                defaultMessage: 'Edition: '
                            })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-8' },
                            edition
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'form-group' },
                        _react2.default.createElement(
                            'label',
                            {
                                className: 'control-label col-sm-4'
                            },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'admin.license.type',
                                defaultMessage: 'License: '
                            })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-8' },
                            licenseType
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'form-group' },
                        _react2.default.createElement(
                            'label',
                            {
                                className: 'control-label col-sm-4'
                            },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'admin.license.key',
                                defaultMessage: 'License Key: '
                            })
                        ),
                        licenseKey
                    )
                )
            );
        }
    }]);
    return LicenseSettings;
}(_react2.default.Component);

LicenseSettings.propTypes = {
    license: _propTypes2.default.object.isRequired,
    intl: _reactIntl.intlShape.isRequired,
    config: _propTypes2.default.object
};

exports.default = (0, _reactIntl.injectIntl)(LicenseSettings);

/***/ }),

/***/ 764:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
//! version : 2.18.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

var hookCallback;

function hooks () {
    return hookCallback.apply(null, arguments);
}

// This is done to register the method called with moment()
// without creating circular dependencies.
function setHookCallback (callback) {
    hookCallback = callback;
}

function isArray(input) {
    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
}

function isObject(input) {
    // IE8 will treat undefined and null as object if it wasn't for
    // input != null
    return input != null && Object.prototype.toString.call(input) === '[object Object]';
}

function isObjectEmpty(obj) {
    var k;
    for (k in obj) {
        // even if its not own property I'd still call it non-empty
        return false;
    }
    return true;
}

function isUndefined(input) {
    return input === void 0;
}

function isNumber(input) {
    return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
}

function isDate(input) {
    return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
}

function map(arr, fn) {
    var res = [], i;
    for (i = 0; i < arr.length; ++i) {
        res.push(fn(arr[i], i));
    }
    return res;
}

function hasOwnProp(a, b) {
    return Object.prototype.hasOwnProperty.call(a, b);
}

function extend(a, b) {
    for (var i in b) {
        if (hasOwnProp(b, i)) {
            a[i] = b[i];
        }
    }

    if (hasOwnProp(b, 'toString')) {
        a.toString = b.toString;
    }

    if (hasOwnProp(b, 'valueOf')) {
        a.valueOf = b.valueOf;
    }

    return a;
}

function createUTC (input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, true).utc();
}

function defaultParsingFlags() {
    // We need to deep clone this object.
    return {
        empty           : false,
        unusedTokens    : [],
        unusedInput     : [],
        overflow        : -2,
        charsLeftOver   : 0,
        nullInput       : false,
        invalidMonth    : null,
        invalidFormat   : false,
        userInvalidated : false,
        iso             : false,
        parsedDateParts : [],
        meridiem        : null,
        rfc2822         : false,
        weekdayMismatch : false
    };
}

function getParsingFlags(m) {
    if (m._pf == null) {
        m._pf = defaultParsingFlags();
    }
    return m._pf;
}

var some;
if (Array.prototype.some) {
    some = Array.prototype.some;
} else {
    some = function (fun) {
        var t = Object(this);
        var len = t.length >>> 0;

        for (var i = 0; i < len; i++) {
            if (i in t && fun.call(this, t[i], i, t)) {
                return true;
            }
        }

        return false;
    };
}

var some$1 = some;

function isValid(m) {
    if (m._isValid == null) {
        var flags = getParsingFlags(m);
        var parsedParts = some$1.call(flags.parsedDateParts, function (i) {
            return i != null;
        });
        var isNowValid = !isNaN(m._d.getTime()) &&
            flags.overflow < 0 &&
            !flags.empty &&
            !flags.invalidMonth &&
            !flags.invalidWeekday &&
            !flags.nullInput &&
            !flags.invalidFormat &&
            !flags.userInvalidated &&
            (!flags.meridiem || (flags.meridiem && parsedParts));

        if (m._strict) {
            isNowValid = isNowValid &&
                flags.charsLeftOver === 0 &&
                flags.unusedTokens.length === 0 &&
                flags.bigHour === undefined;
        }

        if (Object.isFrozen == null || !Object.isFrozen(m)) {
            m._isValid = isNowValid;
        }
        else {
            return isNowValid;
        }
    }
    return m._isValid;
}

function createInvalid (flags) {
    var m = createUTC(NaN);
    if (flags != null) {
        extend(getParsingFlags(m), flags);
    }
    else {
        getParsingFlags(m).userInvalidated = true;
    }

    return m;
}

// Plugins that add properties should also add the key here (null value),
// so we can properly clone ourselves.
var momentProperties = hooks.momentProperties = [];

function copyConfig(to, from) {
    var i, prop, val;

    if (!isUndefined(from._isAMomentObject)) {
        to._isAMomentObject = from._isAMomentObject;
    }
    if (!isUndefined(from._i)) {
        to._i = from._i;
    }
    if (!isUndefined(from._f)) {
        to._f = from._f;
    }
    if (!isUndefined(from._l)) {
        to._l = from._l;
    }
    if (!isUndefined(from._strict)) {
        to._strict = from._strict;
    }
    if (!isUndefined(from._tzm)) {
        to._tzm = from._tzm;
    }
    if (!isUndefined(from._isUTC)) {
        to._isUTC = from._isUTC;
    }
    if (!isUndefined(from._offset)) {
        to._offset = from._offset;
    }
    if (!isUndefined(from._pf)) {
        to._pf = getParsingFlags(from);
    }
    if (!isUndefined(from._locale)) {
        to._locale = from._locale;
    }

    if (momentProperties.length > 0) {
        for (i = 0; i < momentProperties.length; i++) {
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) {
                to[prop] = val;
            }
        }
    }

    return to;
}

var updateInProgress = false;

// Moment prototype object
function Moment(config) {
    copyConfig(this, config);
    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
    if (!this.isValid()) {
        this._d = new Date(NaN);
    }
    // Prevent infinite loop in case updateOffset creates new moment
    // objects.
    if (updateInProgress === false) {
        updateInProgress = true;
        hooks.updateOffset(this);
        updateInProgress = false;
    }
}

function isMoment (obj) {
    return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
}

function absFloor (number) {
    if (number < 0) {
        // -0 -> 0
        return Math.ceil(number) || 0;
    } else {
        return Math.floor(number);
    }
}

function toInt(argumentForCoercion) {
    var coercedNumber = +argumentForCoercion,
        value = 0;

    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
        value = absFloor(coercedNumber);
    }

    return value;
}

// compare two arrays, return the number of differences
function compareArrays(array1, array2, dontConvert) {
    var len = Math.min(array1.length, array2.length),
        lengthDiff = Math.abs(array1.length - array2.length),
        diffs = 0,
        i;
    for (i = 0; i < len; i++) {
        if ((dontConvert && array1[i] !== array2[i]) ||
            (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
            diffs++;
        }
    }
    return diffs + lengthDiff;
}

function warn(msg) {
    if (hooks.suppressDeprecationWarnings === false &&
            (typeof console !==  'undefined') && console.warn) {
        console.warn('Deprecation warning: ' + msg);
    }
}

function deprecate(msg, fn) {
    var firstTime = true;

    return extend(function () {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(null, msg);
        }
        if (firstTime) {
            var args = [];
            var arg;
            for (var i = 0; i < arguments.length; i++) {
                arg = '';
                if (typeof arguments[i] === 'object') {
                    arg += '\n[' + i + '] ';
                    for (var key in arguments[0]) {
                        arg += key + ': ' + arguments[0][key] + ', ';
                    }
                    arg = arg.slice(0, -2); // Remove trailing comma and space
                } else {
                    arg = arguments[i];
                }
                args.push(arg);
            }
            warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
            firstTime = false;
        }
        return fn.apply(this, arguments);
    }, fn);
}

var deprecations = {};

function deprecateSimple(name, msg) {
    if (hooks.deprecationHandler != null) {
        hooks.deprecationHandler(name, msg);
    }
    if (!deprecations[name]) {
        warn(msg);
        deprecations[name] = true;
    }
}

hooks.suppressDeprecationWarnings = false;
hooks.deprecationHandler = null;

function isFunction(input) {
    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
}

function set (config) {
    var prop, i;
    for (i in config) {
        prop = config[i];
        if (isFunction(prop)) {
            this[i] = prop;
        } else {
            this['_' + i] = prop;
        }
    }
    this._config = config;
    // Lenient ordinal parsing accepts just a number in addition to
    // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
    // TODO: Remove "ordinalParse" fallback in next major release.
    this._dayOfMonthOrdinalParseLenient = new RegExp(
        (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
            '|' + (/\d{1,2}/).source);
}

function mergeConfigs(parentConfig, childConfig) {
    var res = extend({}, parentConfig), prop;
    for (prop in childConfig) {
        if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) {
                res[prop] = childConfig[prop];
            } else {
                delete res[prop];
            }
        }
    }
    for (prop in parentConfig) {
        if (hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])) {
            // make sure changes to properties don't modify parent config
            res[prop] = extend({}, res[prop]);
        }
    }
    return res;
}

function Locale(config) {
    if (config != null) {
        this.set(config);
    }
}

var keys;

if (Object.keys) {
    keys = Object.keys;
} else {
    keys = function (obj) {
        var i, res = [];
        for (i in obj) {
            if (hasOwnProp(obj, i)) {
                res.push(i);
            }
        }
        return res;
    };
}

var keys$1 = keys;

var defaultCalendar = {
    sameDay : '[Today at] LT',
    nextDay : '[Tomorrow at] LT',
    nextWeek : 'dddd [at] LT',
    lastDay : '[Yesterday at] LT',
    lastWeek : '[Last] dddd [at] LT',
    sameElse : 'L'
};

function calendar (key, mom, now) {
    var output = this._calendar[key] || this._calendar['sameElse'];
    return isFunction(output) ? output.call(mom, now) : output;
}

var defaultLongDateFormat = {
    LTS  : 'h:mm:ss A',
    LT   : 'h:mm A',
    L    : 'MM/DD/YYYY',
    LL   : 'MMMM D, YYYY',
    LLL  : 'MMMM D, YYYY h:mm A',
    LLLL : 'dddd, MMMM D, YYYY h:mm A'
};

function longDateFormat (key) {
    var format = this._longDateFormat[key],
        formatUpper = this._longDateFormat[key.toUpperCase()];

    if (format || !formatUpper) {
        return format;
    }

    this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
        return val.slice(1);
    });

    return this._longDateFormat[key];
}

var defaultInvalidDate = 'Invalid date';

function invalidDate () {
    return this._invalidDate;
}

var defaultOrdinal = '%d';
var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

function ordinal (number) {
    return this._ordinal.replace('%d', number);
}

var defaultRelativeTime = {
    future : 'in %s',
    past   : '%s ago',
    s  : 'a few seconds',
    ss : '%d seconds',
    m  : 'a minute',
    mm : '%d minutes',
    h  : 'an hour',
    hh : '%d hours',
    d  : 'a day',
    dd : '%d days',
    M  : 'a month',
    MM : '%d months',
    y  : 'a year',
    yy : '%d years'
};

function relativeTime (number, withoutSuffix, string, isFuture) {
    var output = this._relativeTime[string];
    return (isFunction(output)) ?
        output(number, withoutSuffix, string, isFuture) :
        output.replace(/%d/i, number);
}

function pastFuture (diff, output) {
    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
}

var aliases = {};

function addUnitAlias (unit, shorthand) {
    var lowerCase = unit.toLowerCase();
    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
}

function normalizeUnits(units) {
    return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
}

function normalizeObjectUnits(inputObject) {
    var normalizedInput = {},
        normalizedProp,
        prop;

    for (prop in inputObject) {
        if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) {
                normalizedInput[normalizedProp] = inputObject[prop];
            }
        }
    }

    return normalizedInput;
}

var priorities = {};

function addUnitPriority(unit, priority) {
    priorities[unit] = priority;
}

function getPrioritizedUnits(unitsObj) {
    var units = [];
    for (var u in unitsObj) {
        units.push({unit: u, priority: priorities[u]});
    }
    units.sort(function (a, b) {
        return a.priority - b.priority;
    });
    return units;
}

function makeGetSet (unit, keepTime) {
    return function (value) {
        if (value != null) {
            set$1(this, unit, value);
            hooks.updateOffset(this, keepTime);
            return this;
        } else {
            return get(this, unit);
        }
    };
}

function get (mom, unit) {
    return mom.isValid() ?
        mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
}

function set$1 (mom, unit, value) {
    if (mom.isValid()) {
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
    }
}

// MOMENTS

function stringGet (units) {
    units = normalizeUnits(units);
    if (isFunction(this[units])) {
        return this[units]();
    }
    return this;
}


function stringSet (units, value) {
    if (typeof units === 'object') {
        units = normalizeObjectUnits(units);
        var prioritized = getPrioritizedUnits(units);
        for (var i = 0; i < prioritized.length; i++) {
            this[prioritized[i].unit](units[prioritized[i].unit]);
        }
    } else {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units](value);
        }
    }
    return this;
}

function zeroFill(number, targetLength, forceSign) {
    var absNumber = '' + Math.abs(number),
        zerosToFill = targetLength - absNumber.length,
        sign = number >= 0;
    return (sign ? (forceSign ? '+' : '') : '-') +
        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
}

var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

var formatFunctions = {};

var formatTokenFunctions = {};

// token:    'M'
// padded:   ['MM', 2]
// ordinal:  'Mo'
// callback: function () { this.month() + 1 }
function addFormatToken (token, padded, ordinal, callback) {
    var func = callback;
    if (typeof callback === 'string') {
        func = function () {
            return this[callback]();
        };
    }
    if (token) {
        formatTokenFunctions[token] = func;
    }
    if (padded) {
        formatTokenFunctions[padded[0]] = function () {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
    }
    if (ordinal) {
        formatTokenFunctions[ordinal] = function () {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
}

function removeFormattingTokens(input) {
    if (input.match(/\[[\s\S]/)) {
        return input.replace(/^\[|\]$/g, '');
    }
    return input.replace(/\\/g, '');
}

function makeFormatFunction(format) {
    var array = format.match(formattingTokens), i, length;

    for (i = 0, length = array.length; i < length; i++) {
        if (formatTokenFunctions[array[i]]) {
            array[i] = formatTokenFunctions[array[i]];
        } else {
            array[i] = removeFormattingTokens(array[i]);
        }
    }

    return function (mom) {
        var output = '', i;
        for (i = 0; i < length; i++) {
            output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
        }
        return output;
    };
}

// format date using native date object
function formatMoment(m, format) {
    if (!m.isValid()) {
        return m.localeData().invalidDate();
    }

    format = expandFormat(format, m.localeData());
    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

    return formatFunctions[format](m);
}

function expandFormat(format, locale) {
    var i = 5;

    function replaceLongDateFormatTokens(input) {
        return locale.longDateFormat(input) || input;
    }

    localFormattingTokens.lastIndex = 0;
    while (i >= 0 && localFormattingTokens.test(format)) {
        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
        localFormattingTokens.lastIndex = 0;
        i -= 1;
    }

    return format;
}

var match1         = /\d/;            //       0 - 9
var match2         = /\d\d/;          //      00 - 99
var match3         = /\d{3}/;         //     000 - 999
var match4         = /\d{4}/;         //    0000 - 9999
var match6         = /[+-]?\d{6}/;    // -999999 - 999999
var match1to2      = /\d\d?/;         //       0 - 99
var match3to4      = /\d\d\d\d?/;     //     999 - 9999
var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
var match1to3      = /\d{1,3}/;       //       0 - 999
var match1to4      = /\d{1,4}/;       //       0 - 9999
var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

var matchUnsigned  = /\d+/;           //       0 - inf
var matchSigned    = /[+-]?\d+/;      //    -inf - inf

var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

// any word (or two) characters or numbers including two/three word month in arabic.
// includes scottish gaelic two word and hyphenated months
var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;


var regexes = {};

function addRegexToken (token, regex, strictRegex) {
    regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
        return (isStrict && strictRegex) ? strictRegex : regex;
    };
}

function getParseRegexForToken (token, config) {
    if (!hasOwnProp(regexes, token)) {
        return new RegExp(unescapeFormat(token));
    }

    return regexes[token](config._strict, config._locale);
}

// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
function unescapeFormat(s) {
    return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
        return p1 || p2 || p3 || p4;
    }));
}

function regexEscape(s) {
    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
}

var tokens = {};

function addParseToken (token, callback) {
    var i, func = callback;
    if (typeof token === 'string') {
        token = [token];
    }
    if (isNumber(callback)) {
        func = function (input, array) {
            array[callback] = toInt(input);
        };
    }
    for (i = 0; i < token.length; i++) {
        tokens[token[i]] = func;
    }
}

function addWeekParseToken (token, callback) {
    addParseToken(token, function (input, array, config, token) {
        config._w = config._w || {};
        callback(input, config._w, config, token);
    });
}

function addTimeToArrayFromToken(token, input, config) {
    if (input != null && hasOwnProp(tokens, token)) {
        tokens[token](input, config._a, config, token);
    }
}

var YEAR = 0;
var MONTH = 1;
var DATE = 2;
var HOUR = 3;
var MINUTE = 4;
var SECOND = 5;
var MILLISECOND = 6;
var WEEK = 7;
var WEEKDAY = 8;

var indexOf;

if (Array.prototype.indexOf) {
    indexOf = Array.prototype.indexOf;
} else {
    indexOf = function (o) {
        // I know
        var i;
        for (i = 0; i < this.length; ++i) {
            if (this[i] === o) {
                return i;
            }
        }
        return -1;
    };
}

var indexOf$1 = indexOf;

function daysInMonth(year, month) {
    return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
}

// FORMATTING

addFormatToken('M', ['MM', 2], 'Mo', function () {
    return this.month() + 1;
});

addFormatToken('MMM', 0, 0, function (format) {
    return this.localeData().monthsShort(this, format);
});

addFormatToken('MMMM', 0, 0, function (format) {
    return this.localeData().months(this, format);
});

// ALIASES

addUnitAlias('month', 'M');

// PRIORITY

addUnitPriority('month', 8);

// PARSING

addRegexToken('M',    match1to2);
addRegexToken('MM',   match1to2, match2);
addRegexToken('MMM',  function (isStrict, locale) {
    return locale.monthsShortRegex(isStrict);
});
addRegexToken('MMMM', function (isStrict, locale) {
    return locale.monthsRegex(isStrict);
});

addParseToken(['M', 'MM'], function (input, array) {
    array[MONTH] = toInt(input) - 1;
});

addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
    var month = config._locale.monthsParse(input, token, config._strict);
    // if we didn't find a month name, mark the date as invalid.
    if (month != null) {
        array[MONTH] = month;
    } else {
        getParsingFlags(config).invalidMonth = input;
    }
});

// LOCALES

var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
function localeMonths (m, format) {
    if (!m) {
        return isArray(this._months) ? this._months :
            this._months['standalone'];
    }
    return isArray(this._months) ? this._months[m.month()] :
        this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
}

var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
function localeMonthsShort (m, format) {
    if (!m) {
        return isArray(this._monthsShort) ? this._monthsShort :
            this._monthsShort['standalone'];
    }
    return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
        this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
}

function handleStrictParse(monthName, format, strict) {
    var i, ii, mom, llc = monthName.toLocaleLowerCase();
    if (!this._monthsParse) {
        // this is not used
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
        for (i = 0; i < 12; ++i) {
            mom = createUTC([2000, i]);
            this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
            this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
        }
    }

    if (strict) {
        if (format === 'MMM') {
            ii = indexOf$1.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf$1.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    } else {
        if (format === 'MMM') {
            ii = indexOf$1.call(this._shortMonthsParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf$1.call(this._longMonthsParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}

function localeMonthsParse (monthName, format, strict) {
    var i, mom, regex;

    if (this._monthsParseExact) {
        return handleStrictParse.call(this, monthName, format, strict);
    }

    if (!this._monthsParse) {
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
    }

    // TODO: add sorting
    // Sorting makes sure if one month (or abbr) is a prefix of another
    // see sorting in computeMonthsParse
    for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        if (strict && !this._longMonthsParse[i]) {
            this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
            this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
        }
        if (!strict && !this._monthsParse[i]) {
            regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
            this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
            return i;
        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
            return i;
        } else if (!strict && this._monthsParse[i].test(monthName)) {
            return i;
        }
    }
}

// MOMENTS

function setMonth (mom, value) {
    var dayOfMonth;

    if (!mom.isValid()) {
        // No op
        return mom;
    }

    if (typeof value === 'string') {
        if (/^\d+$/.test(value)) {
            value = toInt(value);
        } else {
            value = mom.localeData().monthsParse(value);
            // TODO: Another silent failure?
            if (!isNumber(value)) {
                return mom;
            }
        }
    }

    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
    return mom;
}

function getSetMonth (value) {
    if (value != null) {
        setMonth(this, value);
        hooks.updateOffset(this, true);
        return this;
    } else {
        return get(this, 'Month');
    }
}

function getDaysInMonth () {
    return daysInMonth(this.year(), this.month());
}

var defaultMonthsShortRegex = matchWord;
function monthsShortRegex (isStrict) {
    if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
            computeMonthsParse.call(this);
        }
        if (isStrict) {
            return this._monthsShortStrictRegex;
        } else {
            return this._monthsShortRegex;
        }
    } else {
        if (!hasOwnProp(this, '_monthsShortRegex')) {
            this._monthsShortRegex = defaultMonthsShortRegex;
        }
        return this._monthsShortStrictRegex && isStrict ?
            this._monthsShortStrictRegex : this._monthsShortRegex;
    }
}

var defaultMonthsRegex = matchWord;
function monthsRegex (isStrict) {
    if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
            computeMonthsParse.call(this);
        }
        if (isStrict) {
            return this._monthsStrictRegex;
        } else {
            return this._monthsRegex;
        }
    } else {
        if (!hasOwnProp(this, '_monthsRegex')) {
            this._monthsRegex = defaultMonthsRegex;
        }
        return this._monthsStrictRegex && isStrict ?
            this._monthsStrictRegex : this._monthsRegex;
    }
}

function computeMonthsParse () {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }

    var shortPieces = [], longPieces = [], mixedPieces = [],
        i, mom;
    for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        shortPieces.push(this.monthsShort(mom, ''));
        longPieces.push(this.months(mom, ''));
        mixedPieces.push(this.months(mom, ''));
        mixedPieces.push(this.monthsShort(mom, ''));
    }
    // Sorting makes sure if one month (or abbr) is a prefix of another it
    // will match the longer piece.
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 12; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
    }
    for (i = 0; i < 24; i++) {
        mixedPieces[i] = regexEscape(mixedPieces[i]);
    }

    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._monthsShortRegex = this._monthsRegex;
    this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
}

// FORMATTING

addFormatToken('Y', 0, 0, function () {
    var y = this.year();
    return y <= 9999 ? '' + y : '+' + y;
});

addFormatToken(0, ['YY', 2], 0, function () {
    return this.year() % 100;
});

addFormatToken(0, ['YYYY',   4],       0, 'year');
addFormatToken(0, ['YYYYY',  5],       0, 'year');
addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

// ALIASES

addUnitAlias('year', 'y');

// PRIORITIES

addUnitPriority('year', 1);

// PARSING

addRegexToken('Y',      matchSigned);
addRegexToken('YY',     match1to2, match2);
addRegexToken('YYYY',   match1to4, match4);
addRegexToken('YYYYY',  match1to6, match6);
addRegexToken('YYYYYY', match1to6, match6);

addParseToken(['YYYYY', 'YYYYYY'], YEAR);
addParseToken('YYYY', function (input, array) {
    array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
});
addParseToken('YY', function (input, array) {
    array[YEAR] = hooks.parseTwoDigitYear(input);
});
addParseToken('Y', function (input, array) {
    array[YEAR] = parseInt(input, 10);
});

// HELPERS

function daysInYear(year) {
    return isLeapYear(year) ? 366 : 365;
}

function isLeapYear(year) {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
}

// HOOKS

hooks.parseTwoDigitYear = function (input) {
    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
};

// MOMENTS

var getSetYear = makeGetSet('FullYear', true);

function getIsLeapYear () {
    return isLeapYear(this.year());
}

function createDate (y, m, d, h, M, s, ms) {
    // can't just apply() to create a date:
    // https://stackoverflow.com/q/181348
    var date = new Date(y, m, d, h, M, s, ms);

    // the date constructor remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
        date.setFullYear(y);
    }
    return date;
}

function createUTCDate (y) {
    var date = new Date(Date.UTC.apply(null, arguments));

    // the Date.UTC function remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
        date.setUTCFullYear(y);
    }
    return date;
}

// start-of-first-week - start-of-year
function firstWeekOffset(year, dow, doy) {
    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
        fwd = 7 + dow - doy,
        // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

    return -fwdlw + fwd - 1;
}

// https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
    var localWeekday = (7 + weekday - dow) % 7,
        weekOffset = firstWeekOffset(year, dow, doy),
        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
        resYear, resDayOfYear;

    if (dayOfYear <= 0) {
        resYear = year - 1;
        resDayOfYear = daysInYear(resYear) + dayOfYear;
    } else if (dayOfYear > daysInYear(year)) {
        resYear = year + 1;
        resDayOfYear = dayOfYear - daysInYear(year);
    } else {
        resYear = year;
        resDayOfYear = dayOfYear;
    }

    return {
        year: resYear,
        dayOfYear: resDayOfYear
    };
}

function weekOfYear(mom, dow, doy) {
    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
        resWeek, resYear;

    if (week < 1) {
        resYear = mom.year() - 1;
        resWeek = week + weeksInYear(resYear, dow, doy);
    } else if (week > weeksInYear(mom.year(), dow, doy)) {
        resWeek = week - weeksInYear(mom.year(), dow, doy);
        resYear = mom.year() + 1;
    } else {
        resYear = mom.year();
        resWeek = week;
    }

    return {
        week: resWeek,
        year: resYear
    };
}

function weeksInYear(year, dow, doy) {
    var weekOffset = firstWeekOffset(year, dow, doy),
        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
}

// FORMATTING

addFormatToken('w', ['ww', 2], 'wo', 'week');
addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

// ALIASES

addUnitAlias('week', 'w');
addUnitAlias('isoWeek', 'W');

// PRIORITIES

addUnitPriority('week', 5);
addUnitPriority('isoWeek', 5);

// PARSING

addRegexToken('w',  match1to2);
addRegexToken('ww', match1to2, match2);
addRegexToken('W',  match1to2);
addRegexToken('WW', match1to2, match2);

addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
    week[token.substr(0, 1)] = toInt(input);
});

// HELPERS

// LOCALES

function localeWeek (mom) {
    return weekOfYear(mom, this._week.dow, this._week.doy).week;
}

var defaultLocaleWeek = {
    dow : 0, // Sunday is the first day of the week.
    doy : 6  // The week that contains Jan 1st is the first week of the year.
};

function localeFirstDayOfWeek () {
    return this._week.dow;
}

function localeFirstDayOfYear () {
    return this._week.doy;
}

// MOMENTS

function getSetWeek (input) {
    var week = this.localeData().week(this);
    return input == null ? week : this.add((input - week) * 7, 'd');
}

function getSetISOWeek (input) {
    var week = weekOfYear(this, 1, 4).week;
    return input == null ? week : this.add((input - week) * 7, 'd');
}

// FORMATTING

addFormatToken('d', 0, 'do', 'day');

addFormatToken('dd', 0, 0, function (format) {
    return this.localeData().weekdaysMin(this, format);
});

addFormatToken('ddd', 0, 0, function (format) {
    return this.localeData().weekdaysShort(this, format);
});

addFormatToken('dddd', 0, 0, function (format) {
    return this.localeData().weekdays(this, format);
});

addFormatToken('e', 0, 0, 'weekday');
addFormatToken('E', 0, 0, 'isoWeekday');

// ALIASES

addUnitAlias('day', 'd');
addUnitAlias('weekday', 'e');
addUnitAlias('isoWeekday', 'E');

// PRIORITY
addUnitPriority('day', 11);
addUnitPriority('weekday', 11);
addUnitPriority('isoWeekday', 11);

// PARSING

addRegexToken('d',    match1to2);
addRegexToken('e',    match1to2);
addRegexToken('E',    match1to2);
addRegexToken('dd',   function (isStrict, locale) {
    return locale.weekdaysMinRegex(isStrict);
});
addRegexToken('ddd',   function (isStrict, locale) {
    return locale.weekdaysShortRegex(isStrict);
});
addRegexToken('dddd',   function (isStrict, locale) {
    return locale.weekdaysRegex(isStrict);
});

addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
    var weekday = config._locale.weekdaysParse(input, token, config._strict);
    // if we didn't get a weekday name, mark the date as invalid
    if (weekday != null) {
        week.d = weekday;
    } else {
        getParsingFlags(config).invalidWeekday = input;
    }
});

addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
    week[token] = toInt(input);
});

// HELPERS

function parseWeekday(input, locale) {
    if (typeof input !== 'string') {
        return input;
    }

    if (!isNaN(input)) {
        return parseInt(input, 10);
    }

    input = locale.weekdaysParse(input);
    if (typeof input === 'number') {
        return input;
    }

    return null;
}

function parseIsoWeekday(input, locale) {
    if (typeof input === 'string') {
        return locale.weekdaysParse(input) % 7 || 7;
    }
    return isNaN(input) ? null : input;
}

// LOCALES

var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
function localeWeekdays (m, format) {
    if (!m) {
        return isArray(this._weekdays) ? this._weekdays :
            this._weekdays['standalone'];
    }
    return isArray(this._weekdays) ? this._weekdays[m.day()] :
        this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
}

var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
function localeWeekdaysShort (m) {
    return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
}

var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
function localeWeekdaysMin (m) {
    return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
}

function handleStrictParse$1(weekdayName, format, strict) {
    var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._minWeekdaysParse = [];

        for (i = 0; i < 7; ++i) {
            mom = createUTC([2000, 1]).day(i);
            this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
            this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
            this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
        }
    }

    if (strict) {
        if (format === 'dddd') {
            ii = indexOf$1.call(this._weekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf$1.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    } else {
        if (format === 'dddd') {
            ii = indexOf$1.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf$1.call(this._minWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}

function localeWeekdaysParse (weekdayName, format, strict) {
    var i, mom, regex;

    if (this._weekdaysParseExact) {
        return handleStrictParse$1.call(this, weekdayName, format, strict);
    }

    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._minWeekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._fullWeekdaysParse = [];
    }

    for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already

        mom = createUTC([2000, 1]).day(i);
        if (strict && !this._fullWeekdaysParse[i]) {
            this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
            this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
            this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
        }
        if (!this._weekdaysParse[i]) {
            regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
            this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
            return i;
        }
    }
}

// MOMENTS

function getSetDayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
    if (input != null) {
        input = parseWeekday(input, this.localeData());
        return this.add(input - day, 'd');
    } else {
        return day;
    }
}

function getSetLocaleDayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
    return input == null ? weekday : this.add(input - weekday, 'd');
}

function getSetISODayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }

    // behaves the same as moment#day except
    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
    // as a setter, sunday should belong to the previous week.

    if (input != null) {
        var weekday = parseIsoWeekday(input, this.localeData());
        return this.day(this.day() % 7 ? weekday : weekday - 7);
    } else {
        return this.day() || 7;
    }
}

var defaultWeekdaysRegex = matchWord;
function weekdaysRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysStrictRegex;
        } else {
            return this._weekdaysRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            this._weekdaysRegex = defaultWeekdaysRegex;
        }
        return this._weekdaysStrictRegex && isStrict ?
            this._weekdaysStrictRegex : this._weekdaysRegex;
    }
}

var defaultWeekdaysShortRegex = matchWord;
function weekdaysShortRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysShortStrictRegex;
        } else {
            return this._weekdaysShortRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
            this._weekdaysShortRegex = defaultWeekdaysShortRegex;
        }
        return this._weekdaysShortStrictRegex && isStrict ?
            this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
    }
}

var defaultWeekdaysMinRegex = matchWord;
function weekdaysMinRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysMinStrictRegex;
        } else {
            return this._weekdaysMinRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
            this._weekdaysMinRegex = defaultWeekdaysMinRegex;
        }
        return this._weekdaysMinStrictRegex && isStrict ?
            this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
    }
}


function computeWeekdaysParse () {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }

    var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
        i, mom, minp, shortp, longp;
    for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, 1]).day(i);
        minp = this.weekdaysMin(mom, '');
        shortp = this.weekdaysShort(mom, '');
        longp = this.weekdays(mom, '');
        minPieces.push(minp);
        shortPieces.push(shortp);
        longPieces.push(longp);
        mixedPieces.push(minp);
        mixedPieces.push(shortp);
        mixedPieces.push(longp);
    }
    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
    // will match the longer piece.
    minPieces.sort(cmpLenRev);
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 7; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
        mixedPieces[i] = regexEscape(mixedPieces[i]);
    }

    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._weekdaysShortRegex = this._weekdaysRegex;
    this._weekdaysMinRegex = this._weekdaysRegex;

    this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
}

// FORMATTING

function hFormat() {
    return this.hours() % 12 || 12;
}

function kFormat() {
    return this.hours() || 24;
}

addFormatToken('H', ['HH', 2], 0, 'hour');
addFormatToken('h', ['hh', 2], 0, hFormat);
addFormatToken('k', ['kk', 2], 0, kFormat);

addFormatToken('hmm', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
});

addFormatToken('hmmss', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2);
});

addFormatToken('Hmm', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2);
});

addFormatToken('Hmmss', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2);
});

function meridiem (token, lowercase) {
    addFormatToken(token, 0, 0, function () {
        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
    });
}

meridiem('a', true);
meridiem('A', false);

// ALIASES

addUnitAlias('hour', 'h');

// PRIORITY
addUnitPriority('hour', 13);

// PARSING

function matchMeridiem (isStrict, locale) {
    return locale._meridiemParse;
}

addRegexToken('a',  matchMeridiem);
addRegexToken('A',  matchMeridiem);
addRegexToken('H',  match1to2);
addRegexToken('h',  match1to2);
addRegexToken('k',  match1to2);
addRegexToken('HH', match1to2, match2);
addRegexToken('hh', match1to2, match2);
addRegexToken('kk', match1to2, match2);

addRegexToken('hmm', match3to4);
addRegexToken('hmmss', match5to6);
addRegexToken('Hmm', match3to4);
addRegexToken('Hmmss', match5to6);

addParseToken(['H', 'HH'], HOUR);
addParseToken(['k', 'kk'], function (input, array, config) {
    var kInput = toInt(input);
    array[HOUR] = kInput === 24 ? 0 : kInput;
});
addParseToken(['a', 'A'], function (input, array, config) {
    config._isPm = config._locale.isPM(input);
    config._meridiem = input;
});
addParseToken(['h', 'hh'], function (input, array, config) {
    array[HOUR] = toInt(input);
    getParsingFlags(config).bigHour = true;
});
addParseToken('hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
    getParsingFlags(config).bigHour = true;
});
addParseToken('hmmss', function (input, array, config) {
    var pos1 = input.length - 4;
    var pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
    getParsingFlags(config).bigHour = true;
});
addParseToken('Hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
});
addParseToken('Hmmss', function (input, array, config) {
    var pos1 = input.length - 4;
    var pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
});

// LOCALES

function localeIsPM (input) {
    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
    // Using charAt should be more compatible.
    return ((input + '').toLowerCase().charAt(0) === 'p');
}

var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
function localeMeridiem (hours, minutes, isLower) {
    if (hours > 11) {
        return isLower ? 'pm' : 'PM';
    } else {
        return isLower ? 'am' : 'AM';
    }
}


// MOMENTS

// Setting the hour should keep the time, because the user explicitly
// specified which hour he wants. So trying to maintain the same hour (in
// a new timezone) makes sense. Adding/subtracting hours does not follow
// this rule.
var getSetHour = makeGetSet('Hours', true);

// months
// week
// weekdays
// meridiem
var baseConfig = {
    calendar: defaultCalendar,
    longDateFormat: defaultLongDateFormat,
    invalidDate: defaultInvalidDate,
    ordinal: defaultOrdinal,
    dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
    relativeTime: defaultRelativeTime,

    months: defaultLocaleMonths,
    monthsShort: defaultLocaleMonthsShort,

    week: defaultLocaleWeek,

    weekdays: defaultLocaleWeekdays,
    weekdaysMin: defaultLocaleWeekdaysMin,
    weekdaysShort: defaultLocaleWeekdaysShort,

    meridiemParse: defaultLocaleMeridiemParse
};

// internal storage for locale config files
var locales = {};
var localeFamilies = {};
var globalLocale;

function normalizeLocale(key) {
    return key ? key.toLowerCase().replace('_', '-') : key;
}

// pick the locale from the array
// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
function chooseLocale(names) {
    var i = 0, j, next, locale, split;

    while (i < names.length) {
        split = normalizeLocale(names[i]).split('-');
        j = split.length;
        next = normalizeLocale(names[i + 1]);
        next = next ? next.split('-') : null;
        while (j > 0) {
            locale = loadLocale(split.slice(0, j).join('-'));
            if (locale) {
                return locale;
            }
            if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                //the next array item is better than a shallower substring of this one
                break;
            }
            j--;
        }
        i++;
    }
    return null;
}

function loadLocale(name) {
    var oldLocale = null;
    // TODO: Find a better way to register and load all the locales in Node
    if (!locales[name] && (typeof module !== 'undefined') &&
            module && module.exports) {
        try {
            oldLocale = globalLocale._abbr;
            __webpack_require__(2669)("./" + name);
            // because defineLocale currently also sets the global locale, we
            // want to undo that for lazy loaded locales
            getSetGlobalLocale(oldLocale);
        } catch (e) { }
    }
    return locales[name];
}

// This function will load locale and then set the global locale.  If
// no arguments are passed in, it will simply return the current global
// locale key.
function getSetGlobalLocale (key, values) {
    var data;
    if (key) {
        if (isUndefined(values)) {
            data = getLocale(key);
        }
        else {
            data = defineLocale(key, values);
        }

        if (data) {
            // moment.duration._locale = moment._locale = data;
            globalLocale = data;
        }
    }

    return globalLocale._abbr;
}

function defineLocale (name, config) {
    if (config !== null) {
        var parentConfig = baseConfig;
        config.abbr = name;
        if (locales[name] != null) {
            deprecateSimple('defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                    'an existing locale. moment.defineLocale(localeName, ' +
                    'config) should only be used for creating a new locale ' +
                    'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
            parentConfig = locales[name]._config;
        } else if (config.parentLocale != null) {
            if (locales[config.parentLocale] != null) {
                parentConfig = locales[config.parentLocale]._config;
            } else {
                if (!localeFamilies[config.parentLocale]) {
                    localeFamilies[config.parentLocale] = [];
                }
                localeFamilies[config.parentLocale].push({
                    name: name,
                    config: config
                });
                return null;
            }
        }
        locales[name] = new Locale(mergeConfigs(parentConfig, config));

        if (localeFamilies[name]) {
            localeFamilies[name].forEach(function (x) {
                defineLocale(x.name, x.config);
            });
        }

        // backwards compat for now: also set the locale
        // make sure we set the locale AFTER all child locales have been
        // created, so we won't end up with the child locale set.
        getSetGlobalLocale(name);


        return locales[name];
    } else {
        // useful for testing
        delete locales[name];
        return null;
    }
}

function updateLocale(name, config) {
    if (config != null) {
        var locale, parentConfig = baseConfig;
        // MERGE
        if (locales[name] != null) {
            parentConfig = locales[name]._config;
        }
        config = mergeConfigs(parentConfig, config);
        locale = new Locale(config);
        locale.parentLocale = locales[name];
        locales[name] = locale;

        // backwards compat for now: also set the locale
        getSetGlobalLocale(name);
    } else {
        // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
            } else if (locales[name] != null) {
                delete locales[name];
            }
        }
    }
    return locales[name];
}

// returns locale data
function getLocale (key) {
    var locale;

    if (key && key._locale && key._locale._abbr) {
        key = key._locale._abbr;
    }

    if (!key) {
        return globalLocale;
    }

    if (!isArray(key)) {
        //short-circuit everything else
        locale = loadLocale(key);
        if (locale) {
            return locale;
        }
        key = [key];
    }

    return chooseLocale(key);
}

function listLocales() {
    return keys$1(locales);
}

function checkOverflow (m) {
    var overflow;
    var a = m._a;

    if (a && getParsingFlags(m).overflow === -2) {
        overflow =
            a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
            a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
            a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
            a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
            a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
            a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
            -1;

        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
            overflow = DATE;
        }
        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
            overflow = WEEK;
        }
        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
            overflow = WEEKDAY;
        }

        getParsingFlags(m).overflow = overflow;
    }

    return m;
}

// iso 8601 regex
// 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

var isoDates = [
    ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
    ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
    ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
    ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
    ['YYYY-DDD', /\d{4}-\d{3}/],
    ['YYYY-MM', /\d{4}-\d\d/, false],
    ['YYYYYYMMDD', /[+-]\d{10}/],
    ['YYYYMMDD', /\d{8}/],
    // YYYYMM is NOT allowed by the standard
    ['GGGG[W]WWE', /\d{4}W\d{3}/],
    ['GGGG[W]WW', /\d{4}W\d{2}/, false],
    ['YYYYDDD', /\d{7}/]
];

// iso time formats and regexes
var isoTimes = [
    ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
    ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
    ['HH:mm:ss', /\d\d:\d\d:\d\d/],
    ['HH:mm', /\d\d:\d\d/],
    ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
    ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
    ['HHmmss', /\d\d\d\d\d\d/],
    ['HHmm', /\d\d\d\d/],
    ['HH', /\d\d/]
];

var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

// date from iso format
function configFromISO(config) {
    var i, l,
        string = config._i,
        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
        allowTime, dateFormat, timeFormat, tzFormat;

    if (match) {
        getParsingFlags(config).iso = true;

        for (i = 0, l = isoDates.length; i < l; i++) {
            if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
        }
        if (dateFormat == null) {
            config._isValid = false;
            return;
        }
        if (match[3]) {
            for (i = 0, l = isoTimes.length; i < l; i++) {
                if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
            }
            if (timeFormat == null) {
                config._isValid = false;
                return;
            }
        }
        if (!allowTime && timeFormat != null) {
            config._isValid = false;
            return;
        }
        if (match[4]) {
            if (tzRegex.exec(match[4])) {
                tzFormat = 'Z';
            } else {
                config._isValid = false;
                return;
            }
        }
        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
        configFromStringAndFormat(config);
    } else {
        config._isValid = false;
    }
}

// RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
var basicRfcRegex = /^((?:Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d?\d\s(?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(?:\d\d)?\d\d\s)(\d\d:\d\d)(\:\d\d)?(\s(?:UT|GMT|[ECMP][SD]T|[A-IK-Za-ik-z]|[+-]\d{4}))$/;

// date and time from ref 2822 format
function configFromRFC2822(config) {
    var string, match, dayFormat,
        dateFormat, timeFormat, tzFormat;
    var timezones = {
        ' GMT': ' +0000',
        ' EDT': ' -0400',
        ' EST': ' -0500',
        ' CDT': ' -0500',
        ' CST': ' -0600',
        ' MDT': ' -0600',
        ' MST': ' -0700',
        ' PDT': ' -0700',
        ' PST': ' -0800'
    };
    var military = 'YXWVUTSRQPONZABCDEFGHIKLM';
    var timezone, timezoneIndex;

    string = config._i
        .replace(/\([^\)]*\)|[\n\t]/g, ' ') // Remove comments and folding whitespace
        .replace(/(\s\s+)/g, ' ') // Replace multiple-spaces with a single space
        .replace(/^\s|\s$/g, ''); // Remove leading and trailing spaces
    match = basicRfcRegex.exec(string);

    if (match) {
        dayFormat = match[1] ? 'ddd' + ((match[1].length === 5) ? ', ' : ' ') : '';
        dateFormat = 'D MMM ' + ((match[2].length > 10) ? 'YYYY ' : 'YY ');
        timeFormat = 'HH:mm' + (match[4] ? ':ss' : '');

        // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
        if (match[1]) { // day of week given
            var momentDate = new Date(match[2]);
            var momentDay = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'][momentDate.getDay()];

            if (match[1].substr(0,3) !== momentDay) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return;
            }
        }

        switch (match[5].length) {
            case 2: // military
                if (timezoneIndex === 0) {
                    timezone = ' +0000';
                } else {
                    timezoneIndex = military.indexOf(match[5][1].toUpperCase()) - 12;
                    timezone = ((timezoneIndex < 0) ? ' -' : ' +') +
                        (('' + timezoneIndex).replace(/^-?/, '0')).match(/..$/)[0] + '00';
                }
                break;
            case 4: // Zone
                timezone = timezones[match[5]];
                break;
            default: // UT or +/-9999
                timezone = timezones[' GMT'];
        }
        match[5] = timezone;
        config._i = match.splice(1).join('');
        tzFormat = ' ZZ';
        config._f = dayFormat + dateFormat + timeFormat + tzFormat;
        configFromStringAndFormat(config);
        getParsingFlags(config).rfc2822 = true;
    } else {
        config._isValid = false;
    }
}

// date from iso format or fallback
function configFromString(config) {
    var matched = aspNetJsonRegex.exec(config._i);

    if (matched !== null) {
        config._d = new Date(+matched[1]);
        return;
    }

    configFromISO(config);
    if (config._isValid === false) {
        delete config._isValid;
    } else {
        return;
    }

    configFromRFC2822(config);
    if (config._isValid === false) {
        delete config._isValid;
    } else {
        return;
    }

    // Final attempt, use Input Fallback
    hooks.createFromInputFallback(config);
}

hooks.createFromInputFallback = deprecate(
    'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
    'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
    'discouraged and will be removed in an upcoming major release. Please refer to ' +
    'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
    function (config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    }
);

// Pick the first defined of two or three arguments.
function defaults(a, b, c) {
    if (a != null) {
        return a;
    }
    if (b != null) {
        return b;
    }
    return c;
}

function currentDateArray(config) {
    // hooks is actually the exported moment object
    var nowValue = new Date(hooks.now());
    if (config._useUTC) {
        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
    }
    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
}

// convert an array to a date.
// the array should mirror the parameters below
// note: all values past the year are optional and will default to the lowest possible value.
// [year, month, day , hour, minute, second, millisecond]
function configFromArray (config) {
    var i, date, input = [], currentDate, yearToUse;

    if (config._d) {
        return;
    }

    currentDate = currentDateArray(config);

    //compute day of the year from weeks and weekdays
    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
        dayOfYearFromWeekInfo(config);
    }

    //if the day of the year is set, figure out what it is
    if (config._dayOfYear != null) {
        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

        if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
            getParsingFlags(config)._overflowDayOfYear = true;
        }

        date = createUTCDate(yearToUse, 0, config._dayOfYear);
        config._a[MONTH] = date.getUTCMonth();
        config._a[DATE] = date.getUTCDate();
    }

    // Default to current date.
    // * if no year, month, day of month are given, default to today
    // * if day of month is given, default month and year
    // * if month is given, default only year
    // * if year is given, don't default anything
    for (i = 0; i < 3 && config._a[i] == null; ++i) {
        config._a[i] = input[i] = currentDate[i];
    }

    // Zero out whatever was not defaulted, including time
    for (; i < 7; i++) {
        config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
    }

    // Check for 24:00:00.000
    if (config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0) {
        config._nextDay = true;
        config._a[HOUR] = 0;
    }

    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
    // Apply timezone offset from input. The actual utcOffset can be changed
    // with parseZone.
    if (config._tzm != null) {
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
    }

    if (config._nextDay) {
        config._a[HOUR] = 24;
    }
}

function dayOfYearFromWeekInfo(config) {
    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

    w = config._w;
    if (w.GG != null || w.W != null || w.E != null) {
        dow = 1;
        doy = 4;

        // TODO: We need to take the current isoWeekYear, but that depends on
        // how we interpret now (local, utc, fixed offset). So create
        // a now version of current config (take local/utc/offset flags, and
        // create now).
        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
        week = defaults(w.W, 1);
        weekday = defaults(w.E, 1);
        if (weekday < 1 || weekday > 7) {
            weekdayOverflow = true;
        }
    } else {
        dow = config._locale._week.dow;
        doy = config._locale._week.doy;

        var curWeek = weekOfYear(createLocal(), dow, doy);

        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

        // Default to current week.
        week = defaults(w.w, curWeek.week);

        if (w.d != null) {
            // weekday -- low day numbers are considered next week
            weekday = w.d;
            if (weekday < 0 || weekday > 6) {
                weekdayOverflow = true;
            }
        } else if (w.e != null) {
            // local weekday -- counting starts from begining of week
            weekday = w.e + dow;
            if (w.e < 0 || w.e > 6) {
                weekdayOverflow = true;
            }
        } else {
            // default to begining of week
            weekday = dow;
        }
    }
    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
        getParsingFlags(config)._overflowWeeks = true;
    } else if (weekdayOverflow != null) {
        getParsingFlags(config)._overflowWeekday = true;
    } else {
        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
        config._a[YEAR] = temp.year;
        config._dayOfYear = temp.dayOfYear;
    }
}

// constant that refers to the ISO standard
hooks.ISO_8601 = function () {};

// constant that refers to the RFC 2822 form
hooks.RFC_2822 = function () {};

// date from string and format string
function configFromStringAndFormat(config) {
    // TODO: Move this to another part of the creation flow to prevent circular deps
    if (config._f === hooks.ISO_8601) {
        configFromISO(config);
        return;
    }
    if (config._f === hooks.RFC_2822) {
        configFromRFC2822(config);
        return;
    }
    config._a = [];
    getParsingFlags(config).empty = true;

    // This array is used to make a Date, either with `new Date` or `Date.UTC`
    var string = '' + config._i,
        i, parsedInput, tokens, token, skipped,
        stringLength = string.length,
        totalParsedInputLength = 0;

    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

    for (i = 0; i < tokens.length; i++) {
        token = tokens[i];
        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
        // console.log('token', token, 'parsedInput', parsedInput,
        //         'regex', getParseRegexForToken(token, config));
        if (parsedInput) {
            skipped = string.substr(0, string.indexOf(parsedInput));
            if (skipped.length > 0) {
                getParsingFlags(config).unusedInput.push(skipped);
            }
            string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
            totalParsedInputLength += parsedInput.length;
        }
        // don't parse if it's not a known token
        if (formatTokenFunctions[token]) {
            if (parsedInput) {
                getParsingFlags(config).empty = false;
            }
            else {
                getParsingFlags(config).unusedTokens.push(token);
            }
            addTimeToArrayFromToken(token, parsedInput, config);
        }
        else if (config._strict && !parsedInput) {
            getParsingFlags(config).unusedTokens.push(token);
        }
    }

    // add remaining unparsed input length to the string
    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
    if (string.length > 0) {
        getParsingFlags(config).unusedInput.push(string);
    }

    // clear _12h flag if hour is <= 12
    if (config._a[HOUR] <= 12 &&
        getParsingFlags(config).bigHour === true &&
        config._a[HOUR] > 0) {
        getParsingFlags(config).bigHour = undefined;
    }

    getParsingFlags(config).parsedDateParts = config._a.slice(0);
    getParsingFlags(config).meridiem = config._meridiem;
    // handle meridiem
    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

    configFromArray(config);
    checkOverflow(config);
}


function meridiemFixWrap (locale, hour, meridiem) {
    var isPm;

    if (meridiem == null) {
        // nothing to do
        return hour;
    }
    if (locale.meridiemHour != null) {
        return locale.meridiemHour(hour, meridiem);
    } else if (locale.isPM != null) {
        // Fallback
        isPm = locale.isPM(meridiem);
        if (isPm && hour < 12) {
            hour += 12;
        }
        if (!isPm && hour === 12) {
            hour = 0;
        }
        return hour;
    } else {
        // this is not supposed to happen
        return hour;
    }
}

// date from string and array of format strings
function configFromStringAndArray(config) {
    var tempConfig,
        bestMoment,

        scoreToBeat,
        i,
        currentScore;

    if (config._f.length === 0) {
        getParsingFlags(config).invalidFormat = true;
        config._d = new Date(NaN);
        return;
    }

    for (i = 0; i < config._f.length; i++) {
        currentScore = 0;
        tempConfig = copyConfig({}, config);
        if (config._useUTC != null) {
            tempConfig._useUTC = config._useUTC;
        }
        tempConfig._f = config._f[i];
        configFromStringAndFormat(tempConfig);

        if (!isValid(tempConfig)) {
            continue;
        }

        // if there is any input that was not parsed add a penalty for that format
        currentScore += getParsingFlags(tempConfig).charsLeftOver;

        //or tokens
        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

        getParsingFlags(tempConfig).score = currentScore;

        if (scoreToBeat == null || currentScore < scoreToBeat) {
            scoreToBeat = currentScore;
            bestMoment = tempConfig;
        }
    }

    extend(config, bestMoment || tempConfig);
}

function configFromObject(config) {
    if (config._d) {
        return;
    }

    var i = normalizeObjectUnits(config._i);
    config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
        return obj && parseInt(obj, 10);
    });

    configFromArray(config);
}

function createFromConfig (config) {
    var res = new Moment(checkOverflow(prepareConfig(config)));
    if (res._nextDay) {
        // Adding is smart enough around DST
        res.add(1, 'd');
        res._nextDay = undefined;
    }

    return res;
}

function prepareConfig (config) {
    var input = config._i,
        format = config._f;

    config._locale = config._locale || getLocale(config._l);

    if (input === null || (format === undefined && input === '')) {
        return createInvalid({nullInput: true});
    }

    if (typeof input === 'string') {
        config._i = input = config._locale.preparse(input);
    }

    if (isMoment(input)) {
        return new Moment(checkOverflow(input));
    } else if (isDate(input)) {
        config._d = input;
    } else if (isArray(format)) {
        configFromStringAndArray(config);
    } else if (format) {
        configFromStringAndFormat(config);
    }  else {
        configFromInput(config);
    }

    if (!isValid(config)) {
        config._d = null;
    }

    return config;
}

function configFromInput(config) {
    var input = config._i;
    if (isUndefined(input)) {
        config._d = new Date(hooks.now());
    } else if (isDate(input)) {
        config._d = new Date(input.valueOf());
    } else if (typeof input === 'string') {
        configFromString(config);
    } else if (isArray(input)) {
        config._a = map(input.slice(0), function (obj) {
            return parseInt(obj, 10);
        });
        configFromArray(config);
    } else if (isObject(input)) {
        configFromObject(config);
    } else if (isNumber(input)) {
        // from milliseconds
        config._d = new Date(input);
    } else {
        hooks.createFromInputFallback(config);
    }
}

function createLocalOrUTC (input, format, locale, strict, isUTC) {
    var c = {};

    if (locale === true || locale === false) {
        strict = locale;
        locale = undefined;
    }

    if ((isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)) {
        input = undefined;
    }
    // object construction must be done this way.
    // https://github.com/moment/moment/issues/1423
    c._isAMomentObject = true;
    c._useUTC = c._isUTC = isUTC;
    c._l = locale;
    c._i = input;
    c._f = format;
    c._strict = strict;

    return createFromConfig(c);
}

function createLocal (input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, false);
}

var prototypeMin = deprecate(
    'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
    function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other < this ? this : other;
        } else {
            return createInvalid();
        }
    }
);

var prototypeMax = deprecate(
    'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
    function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other > this ? this : other;
        } else {
            return createInvalid();
        }
    }
);

// Pick a moment m from moments so that m[fn](other) is true for all
// other. This relies on the function fn to be transitive.
//
// moments should either be an array of moment objects or an array, whose
// first element is an array of moment objects.
function pickBy(fn, moments) {
    var res, i;
    if (moments.length === 1 && isArray(moments[0])) {
        moments = moments[0];
    }
    if (!moments.length) {
        return createLocal();
    }
    res = moments[0];
    for (i = 1; i < moments.length; ++i) {
        if (!moments[i].isValid() || moments[i][fn](res)) {
            res = moments[i];
        }
    }
    return res;
}

// TODO: Use [].sort instead?
function min () {
    var args = [].slice.call(arguments, 0);

    return pickBy('isBefore', args);
}

function max () {
    var args = [].slice.call(arguments, 0);

    return pickBy('isAfter', args);
}

var now = function () {
    return Date.now ? Date.now() : +(new Date());
};

var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

function isDurationValid(m) {
    for (var key in m) {
        if (!(ordering.indexOf(key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
            return false;
        }
    }

    var unitHasDecimal = false;
    for (var i = 0; i < ordering.length; ++i) {
        if (m[ordering[i]]) {
            if (unitHasDecimal) {
                return false; // only allow non-integers for smallest unit
            }
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                unitHasDecimal = true;
            }
        }
    }

    return true;
}

function isValid$1() {
    return this._isValid;
}

function createInvalid$1() {
    return createDuration(NaN);
}

function Duration (duration) {
    var normalizedInput = normalizeObjectUnits(duration),
        years = normalizedInput.year || 0,
        quarters = normalizedInput.quarter || 0,
        months = normalizedInput.month || 0,
        weeks = normalizedInput.week || 0,
        days = normalizedInput.day || 0,
        hours = normalizedInput.hour || 0,
        minutes = normalizedInput.minute || 0,
        seconds = normalizedInput.second || 0,
        milliseconds = normalizedInput.millisecond || 0;

    this._isValid = isDurationValid(normalizedInput);

    // representation for dateAddRemove
    this._milliseconds = +milliseconds +
        seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
    // Because of dateAddRemove treats 24 hours as different from a
    // day when working around DST, we need to store them separately
    this._days = +days +
        weeks * 7;
    // It is impossible translate months into days without knowing
    // which months you are are talking about, so we have to store
    // it separately.
    this._months = +months +
        quarters * 3 +
        years * 12;

    this._data = {};

    this._locale = getLocale();

    this._bubble();
}

function isDuration (obj) {
    return obj instanceof Duration;
}

function absRound (number) {
    if (number < 0) {
        return Math.round(-1 * number) * -1;
    } else {
        return Math.round(number);
    }
}

// FORMATTING

function offset (token, separator) {
    addFormatToken(token, 0, 0, function () {
        var offset = this.utcOffset();
        var sign = '+';
        if (offset < 0) {
            offset = -offset;
            sign = '-';
        }
        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
    });
}

offset('Z', ':');
offset('ZZ', '');

// PARSING

addRegexToken('Z',  matchShortOffset);
addRegexToken('ZZ', matchShortOffset);
addParseToken(['Z', 'ZZ'], function (input, array, config) {
    config._useUTC = true;
    config._tzm = offsetFromString(matchShortOffset, input);
});

// HELPERS

// timezone chunker
// '+10:00' > ['10',  '00']
// '-1530'  > ['-15', '30']
var chunkOffset = /([\+\-]|\d\d)/gi;

function offsetFromString(matcher, string) {
    var matches = (string || '').match(matcher);

    if (matches === null) {
        return null;
    }

    var chunk   = matches[matches.length - 1] || [];
    var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
    var minutes = +(parts[1] * 60) + toInt(parts[2]);

    return minutes === 0 ?
      0 :
      parts[0] === '+' ? minutes : -minutes;
}

// Return a moment from input, that is local/utc/zone equivalent to model.
function cloneWithOffset(input, model) {
    var res, diff;
    if (model._isUTC) {
        res = model.clone();
        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
        // Use low-level api, because this fn is low-level api.
        res._d.setTime(res._d.valueOf() + diff);
        hooks.updateOffset(res, false);
        return res;
    } else {
        return createLocal(input).local();
    }
}

function getDateOffset (m) {
    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
    // https://github.com/moment/moment/pull/1871
    return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
}

// HOOKS

// This function will be called whenever a moment is mutated.
// It is intended to keep the offset in sync with the timezone.
hooks.updateOffset = function () {};

// MOMENTS

// keepLocalTime = true means only change the timezone, without
// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
// +0200, so we adjust the time as needed, to be valid.
//
// Keeping the time actually adds/subtracts (one hour)
// from the actual represented time. That is why we call updateOffset
// a second time. In case it wants us to change the offset again
// _changeInProgress == true case, then we have to adjust, because
// there is no such time in the given timezone.
function getSetOffset (input, keepLocalTime, keepMinutes) {
    var offset = this._offset || 0,
        localAdjust;
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    if (input != null) {
        if (typeof input === 'string') {
            input = offsetFromString(matchShortOffset, input);
            if (input === null) {
                return this;
            }
        } else if (Math.abs(input) < 16 && !keepMinutes) {
            input = input * 60;
        }
        if (!this._isUTC && keepLocalTime) {
            localAdjust = getDateOffset(this);
        }
        this._offset = input;
        this._isUTC = true;
        if (localAdjust != null) {
            this.add(localAdjust, 'm');
        }
        if (offset !== input) {
            if (!keepLocalTime || this._changeInProgress) {
                addSubtract(this, createDuration(input - offset, 'm'), 1, false);
            } else if (!this._changeInProgress) {
                this._changeInProgress = true;
                hooks.updateOffset(this, true);
                this._changeInProgress = null;
            }
        }
        return this;
    } else {
        return this._isUTC ? offset : getDateOffset(this);
    }
}

function getSetZone (input, keepLocalTime) {
    if (input != null) {
        if (typeof input !== 'string') {
            input = -input;
        }

        this.utcOffset(input, keepLocalTime);

        return this;
    } else {
        return -this.utcOffset();
    }
}

function setOffsetToUTC (keepLocalTime) {
    return this.utcOffset(0, keepLocalTime);
}

function setOffsetToLocal (keepLocalTime) {
    if (this._isUTC) {
        this.utcOffset(0, keepLocalTime);
        this._isUTC = false;

        if (keepLocalTime) {
            this.subtract(getDateOffset(this), 'm');
        }
    }
    return this;
}

function setOffsetToParsedOffset () {
    if (this._tzm != null) {
        this.utcOffset(this._tzm, false, true);
    } else if (typeof this._i === 'string') {
        var tZone = offsetFromString(matchOffset, this._i);
        if (tZone != null) {
            this.utcOffset(tZone);
        }
        else {
            this.utcOffset(0, true);
        }
    }
    return this;
}

function hasAlignedHourOffset (input) {
    if (!this.isValid()) {
        return false;
    }
    input = input ? createLocal(input).utcOffset() : 0;

    return (this.utcOffset() - input) % 60 === 0;
}

function isDaylightSavingTime () {
    return (
        this.utcOffset() > this.clone().month(0).utcOffset() ||
        this.utcOffset() > this.clone().month(5).utcOffset()
    );
}

function isDaylightSavingTimeShifted () {
    if (!isUndefined(this._isDSTShifted)) {
        return this._isDSTShifted;
    }

    var c = {};

    copyConfig(c, this);
    c = prepareConfig(c);

    if (c._a) {
        var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
        this._isDSTShifted = this.isValid() &&
            compareArrays(c._a, other.toArray()) > 0;
    } else {
        this._isDSTShifted = false;
    }

    return this._isDSTShifted;
}

function isLocal () {
    return this.isValid() ? !this._isUTC : false;
}

function isUtcOffset () {
    return this.isValid() ? this._isUTC : false;
}

function isUtc () {
    return this.isValid() ? this._isUTC && this._offset === 0 : false;
}

// ASP.NET json date format regex
var aspNetRegex = /^(\-)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

// from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
// somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
// and further modified to allow for strings containing both week and day
var isoRegex = /^(-)?P(?:(-?[0-9,.]*)Y)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)W)?(?:(-?[0-9,.]*)D)?(?:T(?:(-?[0-9,.]*)H)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)S)?)?$/;

function createDuration (input, key) {
    var duration = input,
        // matching against regexp is expensive, do it on demand
        match = null,
        sign,
        ret,
        diffRes;

    if (isDuration(input)) {
        duration = {
            ms : input._milliseconds,
            d  : input._days,
            M  : input._months
        };
    } else if (isNumber(input)) {
        duration = {};
        if (key) {
            duration[key] = input;
        } else {
            duration.milliseconds = input;
        }
    } else if (!!(match = aspNetRegex.exec(input))) {
        sign = (match[1] === '-') ? -1 : 1;
        duration = {
            y  : 0,
            d  : toInt(match[DATE])                         * sign,
            h  : toInt(match[HOUR])                         * sign,
            m  : toInt(match[MINUTE])                       * sign,
            s  : toInt(match[SECOND])                       * sign,
            ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
        };
    } else if (!!(match = isoRegex.exec(input))) {
        sign = (match[1] === '-') ? -1 : 1;
        duration = {
            y : parseIso(match[2], sign),
            M : parseIso(match[3], sign),
            w : parseIso(match[4], sign),
            d : parseIso(match[5], sign),
            h : parseIso(match[6], sign),
            m : parseIso(match[7], sign),
            s : parseIso(match[8], sign)
        };
    } else if (duration == null) {// checks for null or undefined
        duration = {};
    } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

        duration = {};
        duration.ms = diffRes.milliseconds;
        duration.M = diffRes.months;
    }

    ret = new Duration(duration);

    if (isDuration(input) && hasOwnProp(input, '_locale')) {
        ret._locale = input._locale;
    }

    return ret;
}

createDuration.fn = Duration.prototype;
createDuration.invalid = createInvalid$1;

function parseIso (inp, sign) {
    // We'd normally use ~~inp for this, but unfortunately it also
    // converts floats to ints.
    // inp may be undefined, so careful calling replace on it.
    var res = inp && parseFloat(inp.replace(',', '.'));
    // apply sign while we're at it
    return (isNaN(res) ? 0 : res) * sign;
}

function positiveMomentsDifference(base, other) {
    var res = {milliseconds: 0, months: 0};

    res.months = other.month() - base.month() +
        (other.year() - base.year()) * 12;
    if (base.clone().add(res.months, 'M').isAfter(other)) {
        --res.months;
    }

    res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

    return res;
}

function momentsDifference(base, other) {
    var res;
    if (!(base.isValid() && other.isValid())) {
        return {milliseconds: 0, months: 0};
    }

    other = cloneWithOffset(other, base);
    if (base.isBefore(other)) {
        res = positiveMomentsDifference(base, other);
    } else {
        res = positiveMomentsDifference(other, base);
        res.milliseconds = -res.milliseconds;
        res.months = -res.months;
    }

    return res;
}

// TODO: remove 'name' arg after deprecation is removed
function createAdder(direction, name) {
    return function (val, period) {
        var dur, tmp;
        //invert the arguments, but complain about it
        if (period !== null && !isNaN(+period)) {
            deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
            'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
            tmp = val; val = period; period = tmp;
        }

        val = typeof val === 'string' ? +val : val;
        dur = createDuration(val, period);
        addSubtract(this, dur, direction);
        return this;
    };
}

function addSubtract (mom, duration, isAdding, updateOffset) {
    var milliseconds = duration._milliseconds,
        days = absRound(duration._days),
        months = absRound(duration._months);

    if (!mom.isValid()) {
        // No op
        return;
    }

    updateOffset = updateOffset == null ? true : updateOffset;

    if (milliseconds) {
        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
    }
    if (days) {
        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
    }
    if (months) {
        setMonth(mom, get(mom, 'Month') + months * isAdding);
    }
    if (updateOffset) {
        hooks.updateOffset(mom, days || months);
    }
}

var add      = createAdder(1, 'add');
var subtract = createAdder(-1, 'subtract');

function getCalendarFormat(myMoment, now) {
    var diff = myMoment.diff(now, 'days', true);
    return diff < -6 ? 'sameElse' :
            diff < -1 ? 'lastWeek' :
            diff < 0 ? 'lastDay' :
            diff < 1 ? 'sameDay' :
            diff < 2 ? 'nextDay' :
            diff < 7 ? 'nextWeek' : 'sameElse';
}

function calendar$1 (time, formats) {
    // We want to compare the start of today, vs this.
    // Getting start-of-today depends on whether we're local/utc/offset or not.
    var now = time || createLocal(),
        sod = cloneWithOffset(now, this).startOf('day'),
        format = hooks.calendarFormat(this, sod) || 'sameElse';

    var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

    return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
}

function clone () {
    return new Moment(this);
}

function isAfter (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() > localInput.valueOf();
    } else {
        return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
}

function isBefore (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() < localInput.valueOf();
    } else {
        return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
}

function isBetween (from, to, units, inclusivity) {
    inclusivity = inclusivity || '()';
    return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
        (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
}

function isSame (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input),
        inputMs;
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(units || 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() === localInput.valueOf();
    } else {
        inputMs = localInput.valueOf();
        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
    }
}

function isSameOrAfter (input, units) {
    return this.isSame(input, units) || this.isAfter(input,units);
}

function isSameOrBefore (input, units) {
    return this.isSame(input, units) || this.isBefore(input,units);
}

function diff (input, units, asFloat) {
    var that,
        zoneDelta,
        delta, output;

    if (!this.isValid()) {
        return NaN;
    }

    that = cloneWithOffset(input, this);

    if (!that.isValid()) {
        return NaN;
    }

    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

    units = normalizeUnits(units);

    if (units === 'year' || units === 'month' || units === 'quarter') {
        output = monthDiff(this, that);
        if (units === 'quarter') {
            output = output / 3;
        } else if (units === 'year') {
            output = output / 12;
        }
    } else {
        delta = this - that;
        output = units === 'second' ? delta / 1e3 : // 1000
            units === 'minute' ? delta / 6e4 : // 1000 * 60
            units === 'hour' ? delta / 36e5 : // 1000 * 60 * 60
            units === 'day' ? (delta - zoneDelta) / 864e5 : // 1000 * 60 * 60 * 24, negate dst
            units === 'week' ? (delta - zoneDelta) / 6048e5 : // 1000 * 60 * 60 * 24 * 7, negate dst
            delta;
    }
    return asFloat ? output : absFloor(output);
}

function monthDiff (a, b) {
    // difference in months
    var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
        // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'),
        anchor2, adjust;

    if (b - anchor < 0) {
        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor - anchor2);
    } else {
        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor2 - anchor);
    }

    //check for negative zero, return zero if negative zero
    return -(wholeMonthDiff + adjust) || 0;
}

hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

function toString () {
    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
}

function toISOString() {
    if (!this.isValid()) {
        return null;
    }
    var m = this.clone().utc();
    if (m.year() < 0 || m.year() > 9999) {
        return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
    }
    if (isFunction(Date.prototype.toISOString)) {
        // native implementation is ~50x faster, use it when we can
        return this.toDate().toISOString();
    }
    return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
}

/**
 * Return a human readable representation of a moment that can
 * also be evaluated to get a new moment which is the same
 *
 * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
 */
function inspect () {
    if (!this.isValid()) {
        return 'moment.invalid(/* ' + this._i + ' */)';
    }
    var func = 'moment';
    var zone = '';
    if (!this.isLocal()) {
        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
        zone = 'Z';
    }
    var prefix = '[' + func + '("]';
    var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
    var datetime = '-MM-DD[T]HH:mm:ss.SSS';
    var suffix = zone + '[")]';

    return this.format(prefix + year + datetime + suffix);
}

function format (inputString) {
    if (!inputString) {
        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
    }
    var output = formatMoment(this, inputString);
    return this.localeData().postformat(output);
}

function from (time, withoutSuffix) {
    if (this.isValid() &&
            ((isMoment(time) && time.isValid()) ||
             createLocal(time).isValid())) {
        return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
    } else {
        return this.localeData().invalidDate();
    }
}

function fromNow (withoutSuffix) {
    return this.from(createLocal(), withoutSuffix);
}

function to (time, withoutSuffix) {
    if (this.isValid() &&
            ((isMoment(time) && time.isValid()) ||
             createLocal(time).isValid())) {
        return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
    } else {
        return this.localeData().invalidDate();
    }
}

function toNow (withoutSuffix) {
    return this.to(createLocal(), withoutSuffix);
}

// If passed a locale key, it will set the locale for this
// instance.  Otherwise, it will return the locale configuration
// variables for this instance.
function locale (key) {
    var newLocaleData;

    if (key === undefined) {
        return this._locale._abbr;
    } else {
        newLocaleData = getLocale(key);
        if (newLocaleData != null) {
            this._locale = newLocaleData;
        }
        return this;
    }
}

var lang = deprecate(
    'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
    function (key) {
        if (key === undefined) {
            return this.localeData();
        } else {
            return this.locale(key);
        }
    }
);

function localeData () {
    return this._locale;
}

function startOf (units) {
    units = normalizeUnits(units);
    // the following switch intentionally omits break keywords
    // to utilize falling through the cases.
    switch (units) {
        case 'year':
            this.month(0);
            /* falls through */
        case 'quarter':
        case 'month':
            this.date(1);
            /* falls through */
        case 'week':
        case 'isoWeek':
        case 'day':
        case 'date':
            this.hours(0);
            /* falls through */
        case 'hour':
            this.minutes(0);
            /* falls through */
        case 'minute':
            this.seconds(0);
            /* falls through */
        case 'second':
            this.milliseconds(0);
    }

    // weeks are a special case
    if (units === 'week') {
        this.weekday(0);
    }
    if (units === 'isoWeek') {
        this.isoWeekday(1);
    }

    // quarters are also special
    if (units === 'quarter') {
        this.month(Math.floor(this.month() / 3) * 3);
    }

    return this;
}

function endOf (units) {
    units = normalizeUnits(units);
    if (units === undefined || units === 'millisecond') {
        return this;
    }

    // 'date' is an alias for 'day', so it should be considered as such.
    if (units === 'date') {
        units = 'day';
    }

    return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
}

function valueOf () {
    return this._d.valueOf() - ((this._offset || 0) * 60000);
}

function unix () {
    return Math.floor(this.valueOf() / 1000);
}

function toDate () {
    return new Date(this.valueOf());
}

function toArray () {
    var m = this;
    return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
}

function toObject () {
    var m = this;
    return {
        years: m.year(),
        months: m.month(),
        date: m.date(),
        hours: m.hours(),
        minutes: m.minutes(),
        seconds: m.seconds(),
        milliseconds: m.milliseconds()
    };
}

function toJSON () {
    // new Date(NaN).toJSON() === null
    return this.isValid() ? this.toISOString() : null;
}

function isValid$2 () {
    return isValid(this);
}

function parsingFlags () {
    return extend({}, getParsingFlags(this));
}

function invalidAt () {
    return getParsingFlags(this).overflow;
}

function creationData() {
    return {
        input: this._i,
        format: this._f,
        locale: this._locale,
        isUTC: this._isUTC,
        strict: this._strict
    };
}

// FORMATTING

addFormatToken(0, ['gg', 2], 0, function () {
    return this.weekYear() % 100;
});

addFormatToken(0, ['GG', 2], 0, function () {
    return this.isoWeekYear() % 100;
});

function addWeekYearFormatToken (token, getter) {
    addFormatToken(0, [token, token.length], 0, getter);
}

addWeekYearFormatToken('gggg',     'weekYear');
addWeekYearFormatToken('ggggg',    'weekYear');
addWeekYearFormatToken('GGGG',  'isoWeekYear');
addWeekYearFormatToken('GGGGG', 'isoWeekYear');

// ALIASES

addUnitAlias('weekYear', 'gg');
addUnitAlias('isoWeekYear', 'GG');

// PRIORITY

addUnitPriority('weekYear', 1);
addUnitPriority('isoWeekYear', 1);


// PARSING

addRegexToken('G',      matchSigned);
addRegexToken('g',      matchSigned);
addRegexToken('GG',     match1to2, match2);
addRegexToken('gg',     match1to2, match2);
addRegexToken('GGGG',   match1to4, match4);
addRegexToken('gggg',   match1to4, match4);
addRegexToken('GGGGG',  match1to6, match6);
addRegexToken('ggggg',  match1to6, match6);

addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
    week[token.substr(0, 2)] = toInt(input);
});

addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
    week[token] = hooks.parseTwoDigitYear(input);
});

// MOMENTS

function getSetWeekYear (input) {
    return getSetWeekYearHelper.call(this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy);
}

function getSetISOWeekYear (input) {
    return getSetWeekYearHelper.call(this,
            input, this.isoWeek(), this.isoWeekday(), 1, 4);
}

function getISOWeeksInYear () {
    return weeksInYear(this.year(), 1, 4);
}

function getWeeksInYear () {
    var weekInfo = this.localeData()._week;
    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
}

function getSetWeekYearHelper(input, week, weekday, dow, doy) {
    var weeksTarget;
    if (input == null) {
        return weekOfYear(this, dow, doy).year;
    } else {
        weeksTarget = weeksInYear(input, dow, doy);
        if (week > weeksTarget) {
            week = weeksTarget;
        }
        return setWeekAll.call(this, input, week, weekday, dow, doy);
    }
}

function setWeekAll(weekYear, week, weekday, dow, doy) {
    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

    this.year(date.getUTCFullYear());
    this.month(date.getUTCMonth());
    this.date(date.getUTCDate());
    return this;
}

// FORMATTING

addFormatToken('Q', 0, 'Qo', 'quarter');

// ALIASES

addUnitAlias('quarter', 'Q');

// PRIORITY

addUnitPriority('quarter', 7);

// PARSING

addRegexToken('Q', match1);
addParseToken('Q', function (input, array) {
    array[MONTH] = (toInt(input) - 1) * 3;
});

// MOMENTS

function getSetQuarter (input) {
    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
}

// FORMATTING

addFormatToken('D', ['DD', 2], 'Do', 'date');

// ALIASES

addUnitAlias('date', 'D');

// PRIOROITY
addUnitPriority('date', 9);

// PARSING

addRegexToken('D',  match1to2);
addRegexToken('DD', match1to2, match2);
addRegexToken('Do', function (isStrict, locale) {
    // TODO: Remove "ordinalParse" fallback in next major release.
    return isStrict ?
      (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
      locale._dayOfMonthOrdinalParseLenient;
});

addParseToken(['D', 'DD'], DATE);
addParseToken('Do', function (input, array) {
    array[DATE] = toInt(input.match(match1to2)[0], 10);
});

// MOMENTS

var getSetDayOfMonth = makeGetSet('Date', true);

// FORMATTING

addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

// ALIASES

addUnitAlias('dayOfYear', 'DDD');

// PRIORITY
addUnitPriority('dayOfYear', 4);

// PARSING

addRegexToken('DDD',  match1to3);
addRegexToken('DDDD', match3);
addParseToken(['DDD', 'DDDD'], function (input, array, config) {
    config._dayOfYear = toInt(input);
});

// HELPERS

// MOMENTS

function getSetDayOfYear (input) {
    var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
    return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
}

// FORMATTING

addFormatToken('m', ['mm', 2], 0, 'minute');

// ALIASES

addUnitAlias('minute', 'm');

// PRIORITY

addUnitPriority('minute', 14);

// PARSING

addRegexToken('m',  match1to2);
addRegexToken('mm', match1to2, match2);
addParseToken(['m', 'mm'], MINUTE);

// MOMENTS

var getSetMinute = makeGetSet('Minutes', false);

// FORMATTING

addFormatToken('s', ['ss', 2], 0, 'second');

// ALIASES

addUnitAlias('second', 's');

// PRIORITY

addUnitPriority('second', 15);

// PARSING

addRegexToken('s',  match1to2);
addRegexToken('ss', match1to2, match2);
addParseToken(['s', 'ss'], SECOND);

// MOMENTS

var getSetSecond = makeGetSet('Seconds', false);

// FORMATTING

addFormatToken('S', 0, 0, function () {
    return ~~(this.millisecond() / 100);
});

addFormatToken(0, ['SS', 2], 0, function () {
    return ~~(this.millisecond() / 10);
});

addFormatToken(0, ['SSS', 3], 0, 'millisecond');
addFormatToken(0, ['SSSS', 4], 0, function () {
    return this.millisecond() * 10;
});
addFormatToken(0, ['SSSSS', 5], 0, function () {
    return this.millisecond() * 100;
});
addFormatToken(0, ['SSSSSS', 6], 0, function () {
    return this.millisecond() * 1000;
});
addFormatToken(0, ['SSSSSSS', 7], 0, function () {
    return this.millisecond() * 10000;
});
addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
    return this.millisecond() * 100000;
});
addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
    return this.millisecond() * 1000000;
});


// ALIASES

addUnitAlias('millisecond', 'ms');

// PRIORITY

addUnitPriority('millisecond', 16);

// PARSING

addRegexToken('S',    match1to3, match1);
addRegexToken('SS',   match1to3, match2);
addRegexToken('SSS',  match1to3, match3);

var token;
for (token = 'SSSS'; token.length <= 9; token += 'S') {
    addRegexToken(token, matchUnsigned);
}

function parseMs(input, array) {
    array[MILLISECOND] = toInt(('0.' + input) * 1000);
}

for (token = 'S'; token.length <= 9; token += 'S') {
    addParseToken(token, parseMs);
}
// MOMENTS

var getSetMillisecond = makeGetSet('Milliseconds', false);

// FORMATTING

addFormatToken('z',  0, 0, 'zoneAbbr');
addFormatToken('zz', 0, 0, 'zoneName');

// MOMENTS

function getZoneAbbr () {
    return this._isUTC ? 'UTC' : '';
}

function getZoneName () {
    return this._isUTC ? 'Coordinated Universal Time' : '';
}

var proto = Moment.prototype;

proto.add               = add;
proto.calendar          = calendar$1;
proto.clone             = clone;
proto.diff              = diff;
proto.endOf             = endOf;
proto.format            = format;
proto.from              = from;
proto.fromNow           = fromNow;
proto.to                = to;
proto.toNow             = toNow;
proto.get               = stringGet;
proto.invalidAt         = invalidAt;
proto.isAfter           = isAfter;
proto.isBefore          = isBefore;
proto.isBetween         = isBetween;
proto.isSame            = isSame;
proto.isSameOrAfter     = isSameOrAfter;
proto.isSameOrBefore    = isSameOrBefore;
proto.isValid           = isValid$2;
proto.lang              = lang;
proto.locale            = locale;
proto.localeData        = localeData;
proto.max               = prototypeMax;
proto.min               = prototypeMin;
proto.parsingFlags      = parsingFlags;
proto.set               = stringSet;
proto.startOf           = startOf;
proto.subtract          = subtract;
proto.toArray           = toArray;
proto.toObject          = toObject;
proto.toDate            = toDate;
proto.toISOString       = toISOString;
proto.inspect           = inspect;
proto.toJSON            = toJSON;
proto.toString          = toString;
proto.unix              = unix;
proto.valueOf           = valueOf;
proto.creationData      = creationData;

// Year
proto.year       = getSetYear;
proto.isLeapYear = getIsLeapYear;

// Week Year
proto.weekYear    = getSetWeekYear;
proto.isoWeekYear = getSetISOWeekYear;

// Quarter
proto.quarter = proto.quarters = getSetQuarter;

// Month
proto.month       = getSetMonth;
proto.daysInMonth = getDaysInMonth;

// Week
proto.week           = proto.weeks        = getSetWeek;
proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
proto.weeksInYear    = getWeeksInYear;
proto.isoWeeksInYear = getISOWeeksInYear;

// Day
proto.date       = getSetDayOfMonth;
proto.day        = proto.days             = getSetDayOfWeek;
proto.weekday    = getSetLocaleDayOfWeek;
proto.isoWeekday = getSetISODayOfWeek;
proto.dayOfYear  = getSetDayOfYear;

// Hour
proto.hour = proto.hours = getSetHour;

// Minute
proto.minute = proto.minutes = getSetMinute;

// Second
proto.second = proto.seconds = getSetSecond;

// Millisecond
proto.millisecond = proto.milliseconds = getSetMillisecond;

// Offset
proto.utcOffset            = getSetOffset;
proto.utc                  = setOffsetToUTC;
proto.local                = setOffsetToLocal;
proto.parseZone            = setOffsetToParsedOffset;
proto.hasAlignedHourOffset = hasAlignedHourOffset;
proto.isDST                = isDaylightSavingTime;
proto.isLocal              = isLocal;
proto.isUtcOffset          = isUtcOffset;
proto.isUtc                = isUtc;
proto.isUTC                = isUtc;

// Timezone
proto.zoneAbbr = getZoneAbbr;
proto.zoneName = getZoneName;

// Deprecations
proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

function createUnix (input) {
    return createLocal(input * 1000);
}

function createInZone () {
    return createLocal.apply(null, arguments).parseZone();
}

function preParsePostFormat (string) {
    return string;
}

var proto$1 = Locale.prototype;

proto$1.calendar        = calendar;
proto$1.longDateFormat  = longDateFormat;
proto$1.invalidDate     = invalidDate;
proto$1.ordinal         = ordinal;
proto$1.preparse        = preParsePostFormat;
proto$1.postformat      = preParsePostFormat;
proto$1.relativeTime    = relativeTime;
proto$1.pastFuture      = pastFuture;
proto$1.set             = set;

// Month
proto$1.months            =        localeMonths;
proto$1.monthsShort       =        localeMonthsShort;
proto$1.monthsParse       =        localeMonthsParse;
proto$1.monthsRegex       = monthsRegex;
proto$1.monthsShortRegex  = monthsShortRegex;

// Week
proto$1.week = localeWeek;
proto$1.firstDayOfYear = localeFirstDayOfYear;
proto$1.firstDayOfWeek = localeFirstDayOfWeek;

// Day of Week
proto$1.weekdays       =        localeWeekdays;
proto$1.weekdaysMin    =        localeWeekdaysMin;
proto$1.weekdaysShort  =        localeWeekdaysShort;
proto$1.weekdaysParse  =        localeWeekdaysParse;

proto$1.weekdaysRegex       =        weekdaysRegex;
proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

// Hours
proto$1.isPM = localeIsPM;
proto$1.meridiem = localeMeridiem;

function get$1 (format, index, field, setter) {
    var locale = getLocale();
    var utc = createUTC().set(setter, index);
    return locale[field](utc, format);
}

function listMonthsImpl (format, index, field) {
    if (isNumber(format)) {
        index = format;
        format = undefined;
    }

    format = format || '';

    if (index != null) {
        return get$1(format, index, field, 'month');
    }

    var i;
    var out = [];
    for (i = 0; i < 12; i++) {
        out[i] = get$1(format, i, field, 'month');
    }
    return out;
}

// ()
// (5)
// (fmt, 5)
// (fmt)
// (true)
// (true, 5)
// (true, fmt, 5)
// (true, fmt)
function listWeekdaysImpl (localeSorted, format, index, field) {
    if (typeof localeSorted === 'boolean') {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';
    } else {
        format = localeSorted;
        index = format;
        localeSorted = false;

        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';
    }

    var locale = getLocale(),
        shift = localeSorted ? locale._week.dow : 0;

    if (index != null) {
        return get$1(format, (index + shift) % 7, field, 'day');
    }

    var i;
    var out = [];
    for (i = 0; i < 7; i++) {
        out[i] = get$1(format, (i + shift) % 7, field, 'day');
    }
    return out;
}

function listMonths (format, index) {
    return listMonthsImpl(format, index, 'months');
}

function listMonthsShort (format, index) {
    return listMonthsImpl(format, index, 'monthsShort');
}

function listWeekdays (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
}

function listWeekdaysShort (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
}

function listWeekdaysMin (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
}

getSetGlobalLocale('en', {
    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (toInt(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    }
});

// Side effect imports
hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

var mathAbs = Math.abs;

function abs () {
    var data           = this._data;

    this._milliseconds = mathAbs(this._milliseconds);
    this._days         = mathAbs(this._days);
    this._months       = mathAbs(this._months);

    data.milliseconds  = mathAbs(data.milliseconds);
    data.seconds       = mathAbs(data.seconds);
    data.minutes       = mathAbs(data.minutes);
    data.hours         = mathAbs(data.hours);
    data.months        = mathAbs(data.months);
    data.years         = mathAbs(data.years);

    return this;
}

function addSubtract$1 (duration, input, value, direction) {
    var other = createDuration(input, value);

    duration._milliseconds += direction * other._milliseconds;
    duration._days         += direction * other._days;
    duration._months       += direction * other._months;

    return duration._bubble();
}

// supports only 2.0-style add(1, 's') or add(duration)
function add$1 (input, value) {
    return addSubtract$1(this, input, value, 1);
}

// supports only 2.0-style subtract(1, 's') or subtract(duration)
function subtract$1 (input, value) {
    return addSubtract$1(this, input, value, -1);
}

function absCeil (number) {
    if (number < 0) {
        return Math.floor(number);
    } else {
        return Math.ceil(number);
    }
}

function bubble () {
    var milliseconds = this._milliseconds;
    var days         = this._days;
    var months       = this._months;
    var data         = this._data;
    var seconds, minutes, hours, years, monthsFromDays;

    // if we have a mix of positive and negative values, bubble down first
    // check: https://github.com/moment/moment/issues/2166
    if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
            (milliseconds <= 0 && days <= 0 && months <= 0))) {
        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
        days = 0;
        months = 0;
    }

    // The following code bubbles up values, see the tests for
    // examples of what that means.
    data.milliseconds = milliseconds % 1000;

    seconds           = absFloor(milliseconds / 1000);
    data.seconds      = seconds % 60;

    minutes           = absFloor(seconds / 60);
    data.minutes      = minutes % 60;

    hours             = absFloor(minutes / 60);
    data.hours        = hours % 24;

    days += absFloor(hours / 24);

    // convert days to months
    monthsFromDays = absFloor(daysToMonths(days));
    months += monthsFromDays;
    days -= absCeil(monthsToDays(monthsFromDays));

    // 12 months -> 1 year
    years = absFloor(months / 12);
    months %= 12;

    data.days   = days;
    data.months = months;
    data.years  = years;

    return this;
}

function daysToMonths (days) {
    // 400 years have 146097 days (taking into account leap year rules)
    // 400 years have 12 months === 4800
    return days * 4800 / 146097;
}

function monthsToDays (months) {
    // the reverse of daysToMonths
    return months * 146097 / 4800;
}

function as (units) {
    if (!this.isValid()) {
        return NaN;
    }
    var days;
    var months;
    var milliseconds = this._milliseconds;

    units = normalizeUnits(units);

    if (units === 'month' || units === 'year') {
        days   = this._days   + milliseconds / 864e5;
        months = this._months + daysToMonths(days);
        return units === 'month' ? months : months / 12;
    } else {
        // handle milliseconds separately because of floating point math errors (issue #1867)
        days = this._days + Math.round(monthsToDays(this._months));
        switch (units) {
            case 'week'   : return days / 7     + milliseconds / 6048e5;
            case 'day'    : return days         + milliseconds / 864e5;
            case 'hour'   : return days * 24    + milliseconds / 36e5;
            case 'minute' : return days * 1440  + milliseconds / 6e4;
            case 'second' : return days * 86400 + milliseconds / 1000;
            // Math.floor prevents floating point math errors here
            case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
            default: throw new Error('Unknown unit ' + units);
        }
    }
}

// TODO: Use this.as('ms')?
function valueOf$1 () {
    if (!this.isValid()) {
        return NaN;
    }
    return (
        this._milliseconds +
        this._days * 864e5 +
        (this._months % 12) * 2592e6 +
        toInt(this._months / 12) * 31536e6
    );
}

function makeAs (alias) {
    return function () {
        return this.as(alias);
    };
}

var asMilliseconds = makeAs('ms');
var asSeconds      = makeAs('s');
var asMinutes      = makeAs('m');
var asHours        = makeAs('h');
var asDays         = makeAs('d');
var asWeeks        = makeAs('w');
var asMonths       = makeAs('M');
var asYears        = makeAs('y');

function get$2 (units) {
    units = normalizeUnits(units);
    return this.isValid() ? this[units + 's']() : NaN;
}

function makeGetter(name) {
    return function () {
        return this.isValid() ? this._data[name] : NaN;
    };
}

var milliseconds = makeGetter('milliseconds');
var seconds      = makeGetter('seconds');
var minutes      = makeGetter('minutes');
var hours        = makeGetter('hours');
var days         = makeGetter('days');
var months       = makeGetter('months');
var years        = makeGetter('years');

function weeks () {
    return absFloor(this.days() / 7);
}

var round = Math.round;
var thresholds = {
    ss: 44,         // a few seconds to seconds
    s : 45,         // seconds to minute
    m : 45,         // minutes to hour
    h : 22,         // hours to day
    d : 26,         // days to month
    M : 11          // months to year
};

// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
}

function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
    var duration = createDuration(posNegDuration).abs();
    var seconds  = round(duration.as('s'));
    var minutes  = round(duration.as('m'));
    var hours    = round(duration.as('h'));
    var days     = round(duration.as('d'));
    var months   = round(duration.as('M'));
    var years    = round(duration.as('y'));

    var a = seconds <= thresholds.ss && ['s', seconds]  ||
            seconds < thresholds.s   && ['ss', seconds] ||
            minutes <= 1             && ['m']           ||
            minutes < thresholds.m   && ['mm', minutes] ||
            hours   <= 1             && ['h']           ||
            hours   < thresholds.h   && ['hh', hours]   ||
            days    <= 1             && ['d']           ||
            days    < thresholds.d   && ['dd', days]    ||
            months  <= 1             && ['M']           ||
            months  < thresholds.M   && ['MM', months]  ||
            years   <= 1             && ['y']           || ['yy', years];

    a[2] = withoutSuffix;
    a[3] = +posNegDuration > 0;
    a[4] = locale;
    return substituteTimeAgo.apply(null, a);
}

// This function allows you to set the rounding function for relative time strings
function getSetRelativeTimeRounding (roundingFunction) {
    if (roundingFunction === undefined) {
        return round;
    }
    if (typeof(roundingFunction) === 'function') {
        round = roundingFunction;
        return true;
    }
    return false;
}

// This function allows you to set a threshold for relative time strings
function getSetRelativeTimeThreshold (threshold, limit) {
    if (thresholds[threshold] === undefined) {
        return false;
    }
    if (limit === undefined) {
        return thresholds[threshold];
    }
    thresholds[threshold] = limit;
    if (threshold === 's') {
        thresholds.ss = limit - 1;
    }
    return true;
}

function humanize (withSuffix) {
    if (!this.isValid()) {
        return this.localeData().invalidDate();
    }

    var locale = this.localeData();
    var output = relativeTime$1(this, !withSuffix, locale);

    if (withSuffix) {
        output = locale.pastFuture(+this, output);
    }

    return locale.postformat(output);
}

var abs$1 = Math.abs;

function toISOString$1() {
    // for ISO strings we do not use the normal bubbling rules:
    //  * milliseconds bubble up until they become hours
    //  * days do not bubble at all
    //  * months bubble up until they become years
    // This is because there is no context-free conversion between hours and days
    // (think of clock changes)
    // and also not between days and months (28-31 days per month)
    if (!this.isValid()) {
        return this.localeData().invalidDate();
    }

    var seconds = abs$1(this._milliseconds) / 1000;
    var days         = abs$1(this._days);
    var months       = abs$1(this._months);
    var minutes, hours, years;

    // 3600 seconds -> 60 minutes -> 1 hour
    minutes           = absFloor(seconds / 60);
    hours             = absFloor(minutes / 60);
    seconds %= 60;
    minutes %= 60;

    // 12 months -> 1 year
    years  = absFloor(months / 12);
    months %= 12;


    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
    var Y = years;
    var M = months;
    var D = days;
    var h = hours;
    var m = minutes;
    var s = seconds;
    var total = this.asSeconds();

    if (!total) {
        // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
    }

    return (total < 0 ? '-' : '') +
        'P' +
        (Y ? Y + 'Y' : '') +
        (M ? M + 'M' : '') +
        (D ? D + 'D' : '') +
        ((h || m || s) ? 'T' : '') +
        (h ? h + 'H' : '') +
        (m ? m + 'M' : '') +
        (s ? s + 'S' : '');
}

var proto$2 = Duration.prototype;

proto$2.isValid        = isValid$1;
proto$2.abs            = abs;
proto$2.add            = add$1;
proto$2.subtract       = subtract$1;
proto$2.as             = as;
proto$2.asMilliseconds = asMilliseconds;
proto$2.asSeconds      = asSeconds;
proto$2.asMinutes      = asMinutes;
proto$2.asHours        = asHours;
proto$2.asDays         = asDays;
proto$2.asWeeks        = asWeeks;
proto$2.asMonths       = asMonths;
proto$2.asYears        = asYears;
proto$2.valueOf        = valueOf$1;
proto$2._bubble        = bubble;
proto$2.get            = get$2;
proto$2.milliseconds   = milliseconds;
proto$2.seconds        = seconds;
proto$2.minutes        = minutes;
proto$2.hours          = hours;
proto$2.days           = days;
proto$2.weeks          = weeks;
proto$2.months         = months;
proto$2.years          = years;
proto$2.humanize       = humanize;
proto$2.toISOString    = toISOString$1;
proto$2.toString       = toISOString$1;
proto$2.toJSON         = toISOString$1;
proto$2.locale         = locale;
proto$2.localeData     = localeData;

// Deprecations
proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
proto$2.lang = lang;

// Side effect imports

// FORMATTING

addFormatToken('X', 0, 0, 'unix');
addFormatToken('x', 0, 0, 'valueOf');

// PARSING

addRegexToken('x', matchSigned);
addRegexToken('X', matchTimestamp);
addParseToken('X', function (input, array, config) {
    config._d = new Date(parseFloat(input, 10) * 1000);
});
addParseToken('x', function (input, array, config) {
    config._d = new Date(toInt(input));
});

// Side effect imports


hooks.version = '2.18.1';

setHookCallback(createLocal);

hooks.fn                    = proto;
hooks.min                   = min;
hooks.max                   = max;
hooks.now                   = now;
hooks.utc                   = createUTC;
hooks.unix                  = createUnix;
hooks.months                = listMonths;
hooks.isDate                = isDate;
hooks.locale                = getSetGlobalLocale;
hooks.invalid               = createInvalid;
hooks.duration              = createDuration;
hooks.isMoment              = isMoment;
hooks.weekdays              = listWeekdays;
hooks.parseZone             = createInZone;
hooks.localeData            = getLocale;
hooks.isDuration            = isDuration;
hooks.monthsShort           = listMonthsShort;
hooks.weekdaysMin           = listWeekdaysMin;
hooks.defineLocale          = defineLocale;
hooks.updateLocale          = updateLocale;
hooks.locales               = listLocales;
hooks.weekdaysShort         = listWeekdaysShort;
hooks.normalizeUnits        = normalizeUnits;
hooks.relativeTimeRounding = getSetRelativeTimeRounding;
hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
hooks.calendarFormat        = getCalendarFormat;
hooks.prototype             = proto;

return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(177)(module)))

/***/ }),

/***/ 787:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = __webpack_require__(172);

var _assign2 = _interopRequireDefault(_assign);

var _stringify = __webpack_require__(275);

var _stringify2 = _interopRequireDefault(_stringify);

var _defineProperty2 = __webpack_require__(277);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _admin_actions = __webpack_require__(797);

var _utils = __webpack_require__(762);

var _save_button = __webpack_require__(925);

var _save_button2 = _interopRequireDefault(_save_button);

var _form_error = __webpack_require__(822);

var _form_error2 = _interopRequireDefault(_form_error);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var AdminSettings = function (_React$Component) {
    (0, _inherits3.default)(AdminSettings, _React$Component);

    function AdminSettings(props) {
        (0, _classCallCheck3.default)(this, AdminSettings);

        var _this = (0, _possibleConstructorReturn3.default)(this, (AdminSettings.__proto__ || (0, _getPrototypeOf2.default)(AdminSettings)).call(this, props));

        _this.handleChange = function (id, value) {
            _this.setState((0, _defineProperty3.default)({
                saveNeeded: true
            }, id, value));

            _this.props.setNavigationBlocked(true);
        };

        _this.handleSubmit = function (e) {
            e.preventDefault();

            _this.doSubmit();
        };

        _this.doSubmit = function (callback) {
            _this.setState({
                saving: true,
                serverError: null
            });

            // clone config so that we aren't modifying data in the stores
            var config = JSON.parse((0, _stringify2.default)(_this.props.config));
            config = _this.getConfigFromState(config);

            (0, _admin_actions.saveConfig)(config, function (savedConfig) {
                _this.setState(_this.getStateFromConfig(savedConfig));

                _this.setState({
                    saveNeeded: false,
                    saving: false
                });

                _this.props.setNavigationBlocked(false);

                if (callback) {
                    callback();
                }

                if (_this.handleSaved) {
                    _this.handleSaved(config);
                }
            }, function (err) {
                _this.setState({
                    saving: false,
                    serverError: err.message,
                    serverErrorId: err.id
                });

                if (callback) {
                    callback();
                }

                if (_this.handleSaved) {
                    _this.handleSaved(config);
                }
            });
        };

        _this.parseInt = function (str, defaultValue) {
            var n = parseInt(str, 10);

            if (isNaN(n)) {
                if (defaultValue) {
                    return defaultValue;
                }
                return 0;
            }

            return n;
        };

        _this.parseIntNonZero = function (str, defaultValue) {
            var n = parseInt(str, 10);

            if (isNaN(n) || n < 1) {
                if (defaultValue) {
                    return defaultValue;
                }
                return 1;
            }

            return n;
        };

        _this.state = (0, _assign2.default)(_this.getStateFromConfig(props.config), {
            saveNeeded: false,
            saving: false,
            serverError: null
        });
        return _this;
    }

    (0, _createClass3.default)(AdminSettings, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'wrapper--fixed' },
                _react2.default.createElement(
                    'h3',
                    { className: 'admin-console-header' },
                    this.renderTitle()
                ),
                _react2.default.createElement(
                    'form',
                    {
                        className: 'form-horizontal',
                        role: 'form',
                        onSubmit: this.handleSubmit
                    },
                    this.renderSettings(),
                    _react2.default.createElement(
                        'div',
                        { className: 'form-group' },
                        _react2.default.createElement(_form_error2.default, { error: this.state.serverError })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'form-group' },
                        _react2.default.createElement(
                            'div',
                            { className: 'col-sm-12' },
                            _react2.default.createElement(_save_button2.default, {
                                saving: this.state.saving,
                                disabled: !this.state.saveNeeded || this.canSave && !this.canSave(),
                                onClick: this.handleSubmit,
                                savingMessage: (0, _utils.localizeMessage)('admin.saving', 'Saving Config...')
                            })
                        )
                    )
                )
            );
        }
    }]);
    return AdminSettings;
}(_react2.default.Component);

AdminSettings.propTypes = {

    /*
     * Object representing the config file
     */
    config: _propTypes2.default.object,

    /*
     * Action for whether a save is needed
     */
    setNavigationBlocked: _propTypes2.default.func
};
exports.default = AdminSettings;

/***/ }),

/***/ 788:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var SettingsGroup = function (_React$Component) {
    (0, _inherits3.default)(SettingsGroup, _React$Component);

    function SettingsGroup() {
        (0, _classCallCheck3.default)(this, SettingsGroup);
        return (0, _possibleConstructorReturn3.default)(this, (SettingsGroup.__proto__ || (0, _getPrototypeOf2.default)(SettingsGroup)).apply(this, arguments));
    }

    (0, _createClass3.default)(SettingsGroup, [{
        key: 'render',
        value: function render() {
            if (!this.props.show) {
                return null;
            }

            var header = null;
            if (this.props.header) {
                header = _react2.default.createElement(
                    'h4',
                    null,
                    this.props.header
                );
            }

            return _react2.default.createElement(
                'div',
                { className: 'admin-settings__group' },
                header,
                this.props.children
            );
        }
    }], [{
        key: 'propTypes',
        get: function get() {
            return {
                show: _propTypes2.default.bool.isRequired,
                header: _propTypes2.default.node,
                children: _propTypes2.default.node
            };
        }
    }, {
        key: 'defaultProps',
        get: function get() {
            return {
                show: true
            };
        }
    }]);
    return SettingsGroup;
}(_react2.default.Component);

exports.default = SettingsGroup;

/***/ }),

/***/ 789:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(999);
module.exports.easing = __webpack_require__(2641);
module.exports.canvas = __webpack_require__(2642);
module.exports.options = __webpack_require__(2643);


/***/ }),

/***/ 794:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _setting = __webpack_require__(841);

var _setting2 = _interopRequireDefault(_setting);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TextSetting = function (_React$Component) {
    (0, _inherits3.default)(TextSetting, _React$Component);

    function TextSetting() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, TextSetting);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TextSetting.__proto__ || (0, _getPrototypeOf2.default)(TextSetting)).call.apply(_ref, [this].concat(args))), _this), _this.handleChange = function (e) {
            if (_this.props.type === 'number') {
                _this.props.onChange(_this.props.id, parseInt(e.target.value, 10));
            } else {
                _this.props.onChange(_this.props.id, e.target.value);
            }
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(TextSetting, [{
        key: 'render',
        value: function render() {
            var input = null;
            if (this.props.type === 'input') {
                input = _react2.default.createElement('input', {
                    id: this.props.id,
                    className: 'form-control',
                    type: 'text',
                    placeholder: this.props.placeholder,
                    value: this.props.value,
                    maxLength: this.props.maxLength,
                    onChange: this.handleChange,
                    disabled: this.props.disabled
                });
            } else if (this.props.type === 'number') {
                input = _react2.default.createElement('input', {
                    id: this.props.id,
                    className: 'form-control',
                    type: 'number',
                    placeholder: this.props.placeholder,
                    value: this.props.value,
                    maxLength: this.props.maxLength,
                    onChange: this.handleChange,
                    disabled: this.props.disabled
                });
            } else if (this.props.type === 'textarea') {
                input = _react2.default.createElement('textarea', {
                    id: this.props.id,
                    className: 'form-control',
                    rows: '5',
                    placeholder: this.props.placeholder,
                    value: this.props.value,
                    maxLength: this.props.maxLength,
                    onChange: this.handleChange,
                    disabled: this.props.disabled
                });
            }

            return _react2.default.createElement(
                _setting2.default,
                {
                    label: this.props.label,
                    helpText: this.props.helpText,
                    inputId: this.props.id
                },
                input
            );
        }
    }], [{
        key: 'propTypes',
        get: function get() {
            return {
                id: _propTypes2.default.string.isRequired,
                label: _propTypes2.default.node.isRequired,
                placeholder: _propTypes2.default.string,
                helpText: _propTypes2.default.node,
                value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
                maxLength: _propTypes2.default.number,
                onChange: _propTypes2.default.func,
                disabled: _propTypes2.default.bool,
                type: _propTypes2.default.oneOf(['number', 'input', 'textarea'])
            };
        }
    }, {
        key: 'defaultProps',
        get: function get() {
            return {
                type: 'input',
                maxLength: null
            };
        }
    }]);
    return TextSetting;
}(_react2.default.Component); // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = TextSetting;

/***/ }),

/***/ 796:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var helpers = __webpack_require__(789);

module.exports = {
	/**
	 * @private
	 */
	_set: function(scope, values) {
		return helpers.merge(this[scope] || (this[scope] = {}), values);
	}
};


/***/ }),

/***/ 800:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _setting = __webpack_require__(841);

var _setting2 = _interopRequireDefault(_setting);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BooleanSetting = function (_React$Component) {
    (0, _inherits3.default)(BooleanSetting, _React$Component);

    function BooleanSetting(props) {
        (0, _classCallCheck3.default)(this, BooleanSetting);

        var _this = (0, _possibleConstructorReturn3.default)(this, (BooleanSetting.__proto__ || (0, _getPrototypeOf2.default)(BooleanSetting)).call(this, props));

        _this.handleChange = _this.handleChange.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(BooleanSetting, [{
        key: 'handleChange',
        value: function handleChange(e) {
            this.props.onChange(this.props.id, e.target.value === 'true');
        }
    }, {
        key: 'render',
        value: function render() {
            var helpText = void 0;
            if (this.props.disabled && this.props.disabledText) {
                helpText = _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'span',
                        { className: 'admin-console__disabled-text' },
                        this.props.disabledText
                    ),
                    this.props.helpText
                );
            } else {
                helpText = this.props.helpText;
            }

            return _react2.default.createElement(
                _setting2.default,
                {
                    label: this.props.label,
                    helpText: helpText
                },
                _react2.default.createElement('a', { name: this.props.id }),
                _react2.default.createElement(
                    'label',
                    { className: 'radio-inline' },
                    _react2.default.createElement('input', {
                        type: 'radio',
                        value: 'true',
                        id: Utils.createSafeId(this.props.id) + 'true',
                        name: this.props.id,
                        checked: this.props.value,
                        onChange: this.handleChange,
                        disabled: this.props.disabled
                    }),
                    this.props.trueText
                ),
                _react2.default.createElement(
                    'label',
                    { className: 'radio-inline' },
                    _react2.default.createElement('input', {
                        type: 'radio',
                        value: 'false',
                        id: Utils.createSafeId(this.props.id) + 'false',
                        name: this.props.id,
                        checked: !this.props.value,
                        onChange: this.handleChange,
                        disabled: this.props.disabled
                    }),
                    this.props.falseText
                )
            );
        }
    }]);
    return BooleanSetting;
}(_react2.default.Component); // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = BooleanSetting;

BooleanSetting.defaultProps = {
    trueText: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'admin.true',
        defaultMessage: 'true'
    }),
    falseText: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'admin.false',
        defaultMessage: 'false'
    }),
    disabled: false
};

BooleanSetting.propTypes = {
    id: _propTypes2.default.string.isRequired,
    label: _propTypes2.default.node.isRequired,
    value: _propTypes2.default.bool.isRequired,
    onChange: _propTypes2.default.func.isRequired,
    trueText: _propTypes2.default.node,
    falseText: _propTypes2.default.node,
    disabled: _propTypes2.default.bool.isRequired,
    disabledText: _propTypes2.default.node,
    helpText: _propTypes2.default.node.isRequired
};

/***/ }),

/***/ 841:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var Settings = function (_PureComponent) {
    (0, _inherits3.default)(Settings, _PureComponent);

    function Settings() {
        (0, _classCallCheck3.default)(this, Settings);
        return (0, _possibleConstructorReturn3.default)(this, (Settings.__proto__ || (0, _getPrototypeOf2.default)(Settings)).apply(this, arguments));
    }

    (0, _createClass3.default)(Settings, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                children = _props.children,
                helpText = _props.helpText,
                inputId = _props.inputId,
                label = _props.label;


            return _react2.default.createElement(
                'div',
                { className: 'form-group' },
                _react2.default.createElement(
                    'label',
                    {
                        className: 'control-label col-sm-4',
                        htmlFor: inputId
                    },
                    label
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'col-sm-8' },
                    children,
                    _react2.default.createElement(
                        'div',
                        { className: 'help-text' },
                        helpText
                    )
                )
            );
        }
    }]);
    return Settings;
}(_react.PureComponent);

Settings.propTypes = {
    inputId: _propTypes2.default.string,
    label: _propTypes2.default.node.isRequired,
    children: _propTypes2.default.node.isRequired,
    helpText: _propTypes2.default.node
};
exports.default = Settings;

/***/ }),

/***/ 842:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = __webpack_require__(782);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _setting = __webpack_require__(841);

var _setting2 = _interopRequireDefault(_setting);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DropdownSetting = function (_React$Component) {
    (0, _inherits3.default)(DropdownSetting, _React$Component);

    function DropdownSetting() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, DropdownSetting);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DropdownSetting.__proto__ || (0, _getPrototypeOf2.default)(DropdownSetting)).call.apply(_ref, [this].concat(args))), _this), _this.handleChange = function (e) {
            _this.props.onChange(_this.props.id, e.target.value);
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(DropdownSetting, [{
        key: 'render',
        value: function render() {
            var options = [];
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = (0, _getIterator3.default)(this.props.values), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var _ref3 = _step.value;
                    var value = _ref3.value,
                        text = _ref3.text;

                    options.push(_react2.default.createElement(
                        'option',
                        {
                            value: value,
                            key: value
                        },
                        text
                    ));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            return _react2.default.createElement(
                _setting2.default,
                {
                    label: this.props.label,
                    inputId: this.props.id,
                    helpText: this.props.helpText
                },
                _react2.default.createElement(
                    'select',
                    {
                        className: 'form-control',
                        id: this.props.id,
                        value: this.props.value,
                        onChange: this.handleChange,
                        disabled: this.props.disabled
                    },
                    options
                )
            );
        }
    }]);
    return DropdownSetting;
}(_react2.default.Component); // Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

DropdownSetting.propTypes = {
    id: _propTypes2.default.string.isRequired,
    values: _propTypes2.default.array.isRequired,
    label: _propTypes2.default.node.isRequired,
    value: _propTypes2.default.string.isRequired,
    onChange: _propTypes2.default.func.isRequired,
    disabled: _propTypes2.default.bool,
    helpText: _propTypes2.default.node
};
DropdownSetting.defaultProps = {
    isDisabled: false
};
exports.default = DropdownSetting;

/***/ }),

/***/ 843:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var color = __webpack_require__(1460);
var helpers = __webpack_require__(789);

function interpolate(start, view, model, ease) {
	var keys = Object.keys(model);
	var i, ilen, key, actual, origin, target, type, c0, c1;

	for (i = 0, ilen = keys.length; i < ilen; ++i) {
		key = keys[i];

		target = model[key];

		// if a value is added to the model after pivot() has been called, the view
		// doesn't contain it, so let's initialize the view to the target value.
		if (!view.hasOwnProperty(key)) {
			view[key] = target;
		}

		actual = view[key];

		if (actual === target || key[0] === '_') {
			continue;
		}

		if (!start.hasOwnProperty(key)) {
			start[key] = actual;
		}

		origin = start[key];

		type = typeof target;

		if (type === typeof origin) {
			if (type === 'string') {
				c0 = color(origin);
				if (c0.valid) {
					c1 = color(target);
					if (c1.valid) {
						view[key] = c1.mix(c0, ease).rgbString();
						continue;
					}
				}
			} else if (type === 'number' && isFinite(origin) && isFinite(target)) {
				view[key] = origin + (target - origin) * ease;
				continue;
			}
		}

		view[key] = target;
	}
}

var Element = function(configuration) {
	helpers.extend(this, configuration);
	this.initialize.apply(this, arguments);
};

helpers.extend(Element.prototype, {

	initialize: function() {
		this.hidden = false;
	},

	pivot: function() {
		var me = this;
		if (!me._view) {
			me._view = helpers.clone(me._model);
		}
		me._start = {};
		return me;
	},

	transition: function(ease) {
		var me = this;
		var model = me._model;
		var start = me._start;
		var view = me._view;

		// No animation -> No Transition
		if (!model || ease === 1) {
			me._view = model;
			me._start = null;
			return me;
		}

		if (!view) {
			view = me._view = {};
		}

		if (!start) {
			start = me._start = {};
		}

		interpolate(start, view, model, ease);

		return me;
	},

	tooltipPosition: function() {
		return {
			x: this._model.x,
			y: this._model.y
		};
	},

	hasValue: function() {
		return helpers.isNumber(this._model.x) && helpers.isNumber(this._model.y);
	}
});

Element.extend = helpers.inherits;

module.exports = Element;


/***/ }),

/***/ 871:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {};
module.exports.Arc = __webpack_require__(2649);
module.exports.Line = __webpack_require__(2650);
module.exports.Point = __webpack_require__(2651);
module.exports.Rectangle = __webpack_require__(2652);


/***/ }),

/***/ 942:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var helpers = __webpack_require__(789);

/**
 * Namespace to hold static tick generation functions
 * @namespace Chart.Ticks
 */
module.exports = {
	/**
	 * Namespace to hold generators for different types of ticks
	 * @namespace Chart.Ticks.generators
	 */
	generators: {
		/**
		 * Interface for the options provided to the numeric tick generator
		 * @interface INumericTickGenerationOptions
		 */
		/**
		 * The maximum number of ticks to display
		 * @name INumericTickGenerationOptions#maxTicks
		 * @type Number
		 */
		/**
		 * The distance between each tick.
		 * @name INumericTickGenerationOptions#stepSize
		 * @type Number
		 * @optional
		 */
		/**
		 * Forced minimum for the ticks. If not specified, the minimum of the data range is used to calculate the tick minimum
		 * @name INumericTickGenerationOptions#min
		 * @type Number
		 * @optional
		 */
		/**
		 * The maximum value of the ticks. If not specified, the maximum of the data range is used to calculate the tick maximum
		 * @name INumericTickGenerationOptions#max
		 * @type Number
		 * @optional
		 */

		/**
		 * Generate a set of linear ticks
		 * @method Chart.Ticks.generators.linear
		 * @param generationOptions {INumericTickGenerationOptions} the options used to generate the ticks
		 * @param dataRange {IRange} the range of the data
		 * @returns {Array<Number>} array of tick values
		 */
		linear: function(generationOptions, dataRange) {
			var ticks = [];
			// To get a "nice" value for the tick spacing, we will use the appropriately named
			// "nice number" algorithm. See http://stackoverflow.com/questions/8506881/nice-label-algorithm-for-charts-with-minimum-ticks
			// for details.

			var spacing;
			if (generationOptions.stepSize && generationOptions.stepSize > 0) {
				spacing = generationOptions.stepSize;
			} else {
				var niceRange = helpers.niceNum(dataRange.max - dataRange.min, false);
				spacing = helpers.niceNum(niceRange / (generationOptions.maxTicks - 1), true);
			}
			var niceMin = Math.floor(dataRange.min / spacing) * spacing;
			var niceMax = Math.ceil(dataRange.max / spacing) * spacing;

			// If min, max and stepSize is set and they make an evenly spaced scale use it.
			if (generationOptions.min && generationOptions.max && generationOptions.stepSize) {
				// If very close to our whole number, use it.
				if (helpers.almostWhole((generationOptions.max - generationOptions.min) / generationOptions.stepSize, spacing / 1000)) {
					niceMin = generationOptions.min;
					niceMax = generationOptions.max;
				}
			}

			var numSpaces = (niceMax - niceMin) / spacing;
			// If very close to our rounded value, use it.
			if (helpers.almostEquals(numSpaces, Math.round(numSpaces), spacing / 1000)) {
				numSpaces = Math.round(numSpaces);
			} else {
				numSpaces = Math.ceil(numSpaces);
			}

			// Put the values into the ticks array
			ticks.push(generationOptions.min !== undefined ? generationOptions.min : niceMin);
			for (var j = 1; j < numSpaces; ++j) {
				ticks.push(niceMin + (j * spacing));
			}
			ticks.push(generationOptions.max !== undefined ? generationOptions.max : niceMax);

			return ticks;
		},

		/**
		 * Generate a set of logarithmic ticks
		 * @method Chart.Ticks.generators.logarithmic
		 * @param generationOptions {INumericTickGenerationOptions} the options used to generate the ticks
		 * @param dataRange {IRange} the range of the data
		 * @returns {Array<Number>} array of tick values
		 */
		logarithmic: function(generationOptions, dataRange) {
			var ticks = [];
			var valueOrDefault = helpers.valueOrDefault;

			// Figure out what the max number of ticks we can support it is based on the size of
			// the axis area. For now, we say that the minimum tick spacing in pixels must be 50
			// We also limit the maximum number of ticks to 11 which gives a nice 10 squares on
			// the graph
			var tickVal = valueOrDefault(generationOptions.min, Math.pow(10, Math.floor(helpers.log10(dataRange.min))));

			var endExp = Math.floor(helpers.log10(dataRange.max));
			var endSignificand = Math.ceil(dataRange.max / Math.pow(10, endExp));
			var exp, significand;

			if (tickVal === 0) {
				exp = Math.floor(helpers.log10(dataRange.minNotZero));
				significand = Math.floor(dataRange.minNotZero / Math.pow(10, exp));

				ticks.push(tickVal);
				tickVal = significand * Math.pow(10, exp);
			} else {
				exp = Math.floor(helpers.log10(tickVal));
				significand = Math.floor(tickVal / Math.pow(10, exp));
			}

			do {
				ticks.push(tickVal);

				++significand;
				if (significand === 10) {
					significand = 1;
					++exp;
				}

				tickVal = significand * Math.pow(10, exp);
			} while (exp < endExp || (exp === endExp && significand < endSignificand));

			var lastTick = valueOrDefault(generationOptions.max, tickVal);
			ticks.push(lastTick);

			return ticks;
		}
	},

	/**
	 * Namespace to hold formatters for different types of ticks
	 * @namespace Chart.Ticks.formatters
	 */
	formatters: {
		/**
		 * Formatter for value labels
		 * @method Chart.Ticks.formatters.values
		 * @param value the value to display
		 * @return {String|Array} the label to display
		 */
		values: function(value) {
			return helpers.isArray(value) ? value : '' + value;
		},

		/**
		 * Formatter for linear numeric ticks
		 * @method Chart.Ticks.formatters.linear
		 * @param tickValue {Number} the value to be formatted
		 * @param index {Number} the position of the tickValue parameter in the ticks array
		 * @param ticks {Array<Number>} the list of ticks being converted
		 * @return {String} string representation of the tickValue parameter
		 */
		linear: function(tickValue, index, ticks) {
			// If we have lots of ticks, don't use the ones
			var delta = ticks.length > 3 ? ticks[2] - ticks[1] : ticks[1] - ticks[0];

			// If we have a number like 2.5 as the delta, figure out how many decimal places we need
			if (Math.abs(delta) > 1) {
				if (tickValue !== Math.floor(tickValue)) {
					// not an integer
					delta = tickValue - Math.floor(tickValue);
				}
			}

			var logDelta = helpers.log10(Math.abs(delta));
			var tickString = '';

			if (tickValue !== 0) {
				var numDecimal = -1 * Math.floor(logDelta);
				numDecimal = Math.max(Math.min(numDecimal, 20), 0); // toFixed has a max of 20 decimal places
				tickString = tickValue.toFixed(numDecimal);
			} else {
				tickString = '0'; // never show decimal places for 0
			}

			return tickString;
		},

		logarithmic: function(tickValue, index, ticks) {
			var remain = tickValue / (Math.pow(10, Math.floor(helpers.log10(tickValue))));

			if (tickValue === 0) {
				return '0';
			} else if (remain === 1 || remain === 2 || remain === 5 || index === 0 || index === ticks.length - 1) {
				return tickValue.toExponential();
			}
			return '';
		}
	}
};


/***/ }),

/***/ 995:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getLogs = getLogs;
exports.getAudits = getAudits;
exports.getConfig = getConfig;
exports.getComplianceReports = getComplianceReports;
exports.getClusterInfo = getClusterInfo;
exports.getUserAccessTokens = getUserAccessTokens;
// Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function getLogs(state) {
    return state.entities.admin.logs;
}

function getAudits(state) {
    return state.entities.admin.audits;
}

function getConfig(state) {
    return state.entities.admin.config;
}

function getComplianceReports(state) {
    return state.entities.admin.complianceReports;
}

function getClusterInfo(state) {
    return state.entities.admin.clusterInfo;
}

function getUserAccessTokens(state) {
    return state.entities.admin.userAccessTokens;
}

/***/ }),

/***/ 996:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(44);

var _extends3 = _interopRequireDefault(_extends2);

var _reactRedux = __webpack_require__(268);

var _redux = __webpack_require__(1);

var _jobs = __webpack_require__(1452);

var _jobs2 = __webpack_require__(2581);

var Selectors = _interopRequireWildcard(_jobs2);

var _table = __webpack_require__(2582);

var _table2 = _interopRequireDefault(_table);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state, ownProps) {
    return (0, _extends3.default)({}, ownProps, {
        jobs: Selectors.makeGetJobsByType(ownProps.jobType)(state)
    });
} // Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapDispatchToProps(dispatch) {
    return {
        actions: (0, _redux.bindActionCreators)({
            getJobsByType: _jobs.getJobsByType
        }, dispatch)
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_table2.default);

/***/ }),

/***/ 997:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _crypto = __webpack_require__(1422);

var _crypto2 = _interopRequireDefault(_crypto);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var GeneratedSetting = function (_React$Component) {
    (0, _inherits3.default)(GeneratedSetting, _React$Component);
    (0, _createClass3.default)(GeneratedSetting, null, [{
        key: 'propTypes',
        get: function get() {
            return {
                id: _propTypes2.default.string.isRequired,
                label: _propTypes2.default.node.isRequired,
                placeholder: _propTypes2.default.string,
                value: _propTypes2.default.string.isRequired,
                onChange: _propTypes2.default.func.isRequired,
                disabled: _propTypes2.default.bool.isRequired,
                disabledText: _propTypes2.default.node,
                helpText: _propTypes2.default.node.isRequired,
                regenerateText: _propTypes2.default.node,
                regenerateHelpText: _propTypes2.default.node
            };
        }
    }, {
        key: 'defaultProps',
        get: function get() {
            return {
                disabled: false,
                regenerateText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'admin.regenerate',
                    defaultMessage: 'Regenerate'
                })
            };
        }
    }]);

    function GeneratedSetting(props) {
        (0, _classCallCheck3.default)(this, GeneratedSetting);

        var _this = (0, _possibleConstructorReturn3.default)(this, (GeneratedSetting.__proto__ || (0, _getPrototypeOf2.default)(GeneratedSetting)).call(this, props));

        _this.regenerate = _this.regenerate.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(GeneratedSetting, [{
        key: 'regenerate',
        value: function regenerate(e) {
            e.preventDefault();

            this.props.onChange(this.props.id, _crypto2.default.randomBytes(256).toString('base64').substring(0, 32));
        }
    }, {
        key: 'render',
        value: function render() {
            var disabledText = null;
            if (this.props.disabled && this.props.disabledText) {
                disabledText = _react2.default.createElement(
                    'div',
                    { className: 'admin-console__disabled-text' },
                    this.props.disabledText
                );
            }

            var regenerateHelpText = null;
            if (this.props.regenerateHelpText) {
                regenerateHelpText = _react2.default.createElement(
                    'div',
                    { className: 'help-text' },
                    this.props.regenerateHelpText
                );
            }

            return _react2.default.createElement(
                'div',
                { className: 'form-group' },
                _react2.default.createElement(
                    'label',
                    {
                        className: 'control-label col-sm-4',
                        htmlFor: this.props.id
                    },
                    this.props.label
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'col-sm-8' },
                    _react2.default.createElement('input', {
                        type: 'text',
                        className: 'form-control',
                        id: this.props.id,
                        placeholder: this.props.placeholder,
                        value: this.props.value,
                        disabled: true
                    }),
                    disabledText,
                    _react2.default.createElement(
                        'div',
                        { className: 'help-text' },
                        this.props.helpText
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'help-text' },
                        _react2.default.createElement(
                            'button',
                            {
                                className: 'btn btn-default',
                                onClick: this.regenerate,
                                disabled: this.props.disabled
                            },
                            this.props.regenerateText
                        )
                    ),
                    regenerateHelpText
                )
            );
        }
    }]);
    return GeneratedSetting;
}(_react2.default.Component);

exports.default = GeneratedSetting;

/***/ }),

/***/ 998:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * A button which, when clicked, performs an action and displays
 * its outcome as either success, or failure accompanied by the
 * `message` property of the `err` object.
 */
// Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var RequestButton = function (_React$Component) {
    (0, _inherits3.default)(RequestButton, _React$Component);

    function RequestButton(props) {
        (0, _classCallCheck3.default)(this, RequestButton);

        var _this = (0, _possibleConstructorReturn3.default)(this, (RequestButton.__proto__ || (0, _getPrototypeOf2.default)(RequestButton)).call(this, props));

        _this.handleRequest = _this.handleRequest.bind(_this);

        _this.state = {
            busy: false,
            fail: null,
            success: false
        };
        return _this;
    }

    (0, _createClass3.default)(RequestButton, [{
        key: 'handleRequest',
        value: function handleRequest(e) {
            var _this2 = this;

            e.preventDefault();

            this.setState({
                busy: true,
                fail: null,
                success: false
            });

            var doRequest = function doRequest() {
                //eslint-disable-line func-style
                _this2.props.requestAction(function () {
                    _this2.setState({
                        busy: false,
                        success: true
                    });
                }, function (err) {
                    var errMsg = err.message;
                    if (_this2.props.includeDetailedError) {
                        errMsg += ' - ' + err.detailed_error;
                    }

                    _this2.setState({
                        busy: false,
                        fail: errMsg
                    });
                });
            };

            if (this.props.saveNeeded) {
                this.props.saveConfigAction(doRequest);
            } else {
                doRequest();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var message = null;
            if (this.state.fail) {
                message = _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'div',
                        { className: 'alert alert-warning' },
                        _react2.default.createElement('i', { className: 'fa fa-warning' }),
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: this.props.errorMessage.id,
                            defaultMessage: this.props.errorMessage.defaultMessage,
                            values: {
                                error: this.state.fail
                            }
                        })
                    )
                );
            } else if (this.state.success && this.props.showSuccessMessage) {
                message = _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'div',
                        { className: 'alert alert-success' },
                        _react2.default.createElement('i', { className: 'fa fa-success' }),
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: this.props.successMessage.id,
                            defaultMessage: this.props.successMessage.defaultMessage
                        })
                    )
                );
            }

            var contents = null;
            if (this.state.busy) {
                contents = _react2.default.createElement(
                    'span',
                    null,
                    _react2.default.createElement('span', { className: 'fa fa-refresh icon--rotate' }),
                    Utils.localizeMessage('admin.requestButton.loading', ' Loading...')
                );
            } else {
                contents = this.props.buttonText;
            }

            var widgetClassNames = 'col-sm-8';
            var label = null;
            if (this.props.label) {
                label = _react2.default.createElement(
                    'label',
                    {
                        className: 'control-label col-sm-4'
                    },
                    this.props.label
                );
            } else {
                widgetClassNames = 'col-sm-offset-4 ' + widgetClassNames;
            }

            return _react2.default.createElement(
                'div',
                { className: 'form-group' },
                label,
                _react2.default.createElement(
                    'div',
                    { className: widgetClassNames },
                    _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                            'button',
                            {
                                className: 'btn btn-default',
                                onClick: this.handleRequest,
                                disabled: this.props.disabled
                            },
                            contents
                        ),
                        this.props.alternativeActionElement,
                        message
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'help-text' },
                        this.props.helpText
                    )
                )
            );
        }
    }]);
    return RequestButton;
}(_react2.default.Component);

RequestButton.propTypes = {

    /**
     * The action to be called to carry out the request.
     */
    requestAction: _propTypes2.default.func.isRequired,

    /**
     * A component that displays help text for the request button.
     *
     * Typically, this will be a <FormattedMessage/>.
     */
    helpText: _propTypes2.default.element.isRequired,

    /**
     * A component to be displayed on the button.
     *
     * Typically, this will be a <FormattedMessage/>
     */
    buttonText: _propTypes2.default.element.isRequired,

    /**
     * The element to display as the field label.
     *
     * Typically, this will be a <FormattedMessage/>
     */
    label: _propTypes2.default.element,

    /**
     * True if the button form control should be disabled, otherwise false.
     */
    disabled: _propTypes2.default.bool,

    /**
     * True if the config needs to be saved before running the request, otherwise false.
     *
     * If set to true, the action provided in the `saveConfigAction` property will be
     * called before the action provided in the `requestAction` property, with the later
     * only being called if the former is successful.
     */
    saveNeeded: _propTypes2.default.bool,

    /**
     * Action to be called to save the config, if saveNeeded is set to true.
     */
    saveConfigAction: _propTypes2.default.func,

    /**
     * True if the success message should be show when the request completes successfully,
     * otherwise false.
     */
    showSuccessMessage: _propTypes2.default.bool,

    /**
     * The message to show when the request completes successfully.
     */
    successMessage: _propTypes2.default.shape({

        /**
         * The i18n string ID for the success message.
         */
        id: _propTypes2.default.string.isRequired,

        /**
         * The i18n default value for the success message.
         */
        defaultMessage: _propTypes2.default.string.isRequired
    }),

    /**
     * The message to show when the request returns an error.
     */
    errorMessage: _propTypes2.default.shape({

        /**
         * The i18n string ID for the error message.
         */
        id: _propTypes2.default.string.isRequired,

        /**
         * The i18n default value for the error message.
         *
         * The placeholder {error} may be used to include the error message returned
         * by the server in response to the failed request.
         */
        defaultMessage: _propTypes2.default.string.isRequired
    }),

    /**
     * True if the {error} placeholder for the `errorMessage` property should include both
     * the `message` and `detailed_error` properties of the error returned from the server,
     * otherwise false to include only the `message` property.
     */
    includeDetailedError: _propTypes2.default.bool,

    /**
     * An element to display adjacent to the request button.
     */
    alternativeActionElement: _propTypes2.default.element
};
RequestButton.defaultProps = {
    disabled: false,
    saveNeeded: false,
    showSuccessMessage: true,
    includeDetailedError: false,
    successMessage: {
        id: 'admin.requestButton.requestSuccess',
        defaultMessage: 'Test Successful'
    },
    errorMessage: {
        id: 'admin.requestButton.requestFailure',
        defaultMessage: 'Test Failure: {error}'
    }
};
exports.default = RequestButton;

/***/ }),

/***/ 999:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * @namespace Chart.helpers
 */
var helpers = {
	/**
	 * An empty function that can be used, for example, for optional callback.
	 */
	noop: function() {},

	/**
	 * Returns a unique id, sequentially generated from a global variable.
	 * @returns {Number}
	 * @function
	 */
	uid: (function() {
		var id = 0;
		return function() {
			return id++;
		};
	}()),

	/**
	 * Returns true if `value` is neither null nor undefined, else returns false.
	 * @param {*} value - The value to test.
	 * @returns {Boolean}
	 * @since 2.7.0
	 */
	isNullOrUndef: function(value) {
		return value === null || typeof value === 'undefined';
	},

	/**
	 * Returns true if `value` is an array, else returns false.
	 * @param {*} value - The value to test.
	 * @returns {Boolean}
	 * @function
	 */
	isArray: Array.isArray ? Array.isArray : function(value) {
		return Object.prototype.toString.call(value) === '[object Array]';
	},

	/**
	 * Returns true if `value` is an object (excluding null), else returns false.
	 * @param {*} value - The value to test.
	 * @returns {Boolean}
	 * @since 2.7.0
	 */
	isObject: function(value) {
		return value !== null && Object.prototype.toString.call(value) === '[object Object]';
	},

	/**
	 * Returns `value` if defined, else returns `defaultValue`.
	 * @param {*} value - The value to return if defined.
	 * @param {*} defaultValue - The value to return if `value` is undefined.
	 * @returns {*}
	 */
	valueOrDefault: function(value, defaultValue) {
		return typeof value === 'undefined' ? defaultValue : value;
	},

	/**
	 * Returns value at the given `index` in array if defined, else returns `defaultValue`.
	 * @param {Array} value - The array to lookup for value at `index`.
	 * @param {Number} index - The index in `value` to lookup for value.
	 * @param {*} defaultValue - The value to return if `value[index]` is undefined.
	 * @returns {*}
	 */
	valueAtIndexOrDefault: function(value, index, defaultValue) {
		return helpers.valueOrDefault(helpers.isArray(value) ? value[index] : value, defaultValue);
	},

	/**
	 * Calls `fn` with the given `args` in the scope defined by `thisArg` and returns the
	 * value returned by `fn`. If `fn` is not a function, this method returns undefined.
	 * @param {Function} fn - The function to call.
	 * @param {Array|undefined|null} args - The arguments with which `fn` should be called.
	 * @param {Object} [thisArg] - The value of `this` provided for the call to `fn`.
	 * @returns {*}
	 */
	callback: function(fn, args, thisArg) {
		if (fn && typeof fn.call === 'function') {
			return fn.apply(thisArg, args);
		}
	},

	/**
	 * Note(SB) for performance sake, this method should only be used when loopable type
	 * is unknown or in none intensive code (not called often and small loopable). Else
	 * it's preferable to use a regular for() loop and save extra function calls.
	 * @param {Object|Array} loopable - The object or array to be iterated.
	 * @param {Function} fn - The function to call for each item.
	 * @param {Object} [thisArg] - The value of `this` provided for the call to `fn`.
	 * @param {Boolean} [reverse] - If true, iterates backward on the loopable.
	 */
	each: function(loopable, fn, thisArg, reverse) {
		var i, len, keys;
		if (helpers.isArray(loopable)) {
			len = loopable.length;
			if (reverse) {
				for (i = len - 1; i >= 0; i--) {
					fn.call(thisArg, loopable[i], i);
				}
			} else {
				for (i = 0; i < len; i++) {
					fn.call(thisArg, loopable[i], i);
				}
			}
		} else if (helpers.isObject(loopable)) {
			keys = Object.keys(loopable);
			len = keys.length;
			for (i = 0; i < len; i++) {
				fn.call(thisArg, loopable[keys[i]], keys[i]);
			}
		}
	},

	/**
	 * Returns true if the `a0` and `a1` arrays have the same content, else returns false.
	 * @see http://stackoverflow.com/a/14853974
	 * @param {Array} a0 - The array to compare
	 * @param {Array} a1 - The array to compare
	 * @returns {Boolean}
	 */
	arrayEquals: function(a0, a1) {
		var i, ilen, v0, v1;

		if (!a0 || !a1 || a0.length !== a1.length) {
			return false;
		}

		for (i = 0, ilen = a0.length; i < ilen; ++i) {
			v0 = a0[i];
			v1 = a1[i];

			if (v0 instanceof Array && v1 instanceof Array) {
				if (!helpers.arrayEquals(v0, v1)) {
					return false;
				}
			} else if (v0 !== v1) {
				// NOTE: two different object instances will never be equal: {x:20} != {x:20}
				return false;
			}
		}

		return true;
	},

	/**
	 * Returns a deep copy of `source` without keeping references on objects and arrays.
	 * @param {*} source - The value to clone.
	 * @returns {*}
	 */
	clone: function(source) {
		if (helpers.isArray(source)) {
			return source.map(helpers.clone);
		}

		if (helpers.isObject(source)) {
			var target = {};
			var keys = Object.keys(source);
			var klen = keys.length;
			var k = 0;

			for (; k < klen; ++k) {
				target[keys[k]] = helpers.clone(source[keys[k]]);
			}

			return target;
		}

		return source;
	},

	/**
	 * The default merger when Chart.helpers.merge is called without merger option.
	 * Note(SB): this method is also used by configMerge and scaleMerge as fallback.
	 * @private
	 */
	_merger: function(key, target, source, options) {
		var tval = target[key];
		var sval = source[key];

		if (helpers.isObject(tval) && helpers.isObject(sval)) {
			helpers.merge(tval, sval, options);
		} else {
			target[key] = helpers.clone(sval);
		}
	},

	/**
	 * Merges source[key] in target[key] only if target[key] is undefined.
	 * @private
	 */
	_mergerIf: function(key, target, source) {
		var tval = target[key];
		var sval = source[key];

		if (helpers.isObject(tval) && helpers.isObject(sval)) {
			helpers.mergeIf(tval, sval);
		} else if (!target.hasOwnProperty(key)) {
			target[key] = helpers.clone(sval);
		}
	},

	/**
	 * Recursively deep copies `source` properties into `target` with the given `options`.
	 * IMPORTANT: `target` is not cloned and will be updated with `source` properties.
	 * @param {Object} target - The target object in which all sources are merged into.
	 * @param {Object|Array(Object)} source - Object(s) to merge into `target`.
	 * @param {Object} [options] - Merging options:
	 * @param {Function} [options.merger] - The merge method (key, target, source, options)
	 * @returns {Object} The `target` object.
	 */
	merge: function(target, source, options) {
		var sources = helpers.isArray(source) ? source : [source];
		var ilen = sources.length;
		var merge, i, keys, klen, k;

		if (!helpers.isObject(target)) {
			return target;
		}

		options = options || {};
		merge = options.merger || helpers._merger;

		for (i = 0; i < ilen; ++i) {
			source = sources[i];
			if (!helpers.isObject(source)) {
				continue;
			}

			keys = Object.keys(source);
			for (k = 0, klen = keys.length; k < klen; ++k) {
				merge(keys[k], target, source, options);
			}
		}

		return target;
	},

	/**
	 * Recursively deep copies `source` properties into `target` *only* if not defined in target.
	 * IMPORTANT: `target` is not cloned and will be updated with `source` properties.
	 * @param {Object} target - The target object in which all sources are merged into.
	 * @param {Object|Array(Object)} source - Object(s) to merge into `target`.
	 * @returns {Object} The `target` object.
	 */
	mergeIf: function(target, source) {
		return helpers.merge(target, source, {merger: helpers._mergerIf});
	},

	/**
	 * Applies the contents of two or more objects together into the first object.
	 * @param {Object} target - The target object in which all objects are merged into.
	 * @param {Object} arg1 - Object containing additional properties to merge in target.
	 * @param {Object} argN - Additional objects containing properties to merge in target.
	 * @returns {Object} The `target` object.
	 */
	extend: function(target) {
		var setFn = function(value, key) {
			target[key] = value;
		};
		for (var i = 1, ilen = arguments.length; i < ilen; ++i) {
			helpers.each(arguments[i], setFn);
		}
		return target;
	},

	/**
	 * Basic javascript inheritance based on the model created in Backbone.js
	 */
	inherits: function(extensions) {
		var me = this;
		var ChartElement = (extensions && extensions.hasOwnProperty('constructor')) ? extensions.constructor : function() {
			return me.apply(this, arguments);
		};

		var Surrogate = function() {
			this.constructor = ChartElement;
		};

		Surrogate.prototype = me.prototype;
		ChartElement.prototype = new Surrogate();
		ChartElement.extend = helpers.inherits;

		if (extensions) {
			helpers.extend(ChartElement.prototype, extensions);
		}

		ChartElement.__super__ = me.prototype;
		return ChartElement;
	}
};

module.exports = helpers;

// DEPRECATIONS

/**
 * Provided for backward compatibility, use Chart.helpers.callback instead.
 * @function Chart.helpers.callCallback
 * @deprecated since version 2.6.0
 * @todo remove at version 3
 * @private
 */
helpers.callCallback = helpers.callback;

/**
 * Provided for backward compatibility, use Array.prototype.indexOf instead.
 * Array.prototype.indexOf compatibility: Chrome, Opera, Safari, FF1.5+, IE9+
 * @function Chart.helpers.indexOf
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.indexOf = function(array, item, fromIndex) {
	return Array.prototype.indexOf.call(array, item, fromIndex);
};

/**
 * Provided for backward compatibility, use Chart.helpers.valueOrDefault instead.
 * @function Chart.helpers.getValueOrDefault
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.getValueOrDefault = helpers.valueOrDefault;

/**
 * Provided for backward compatibility, use Chart.helpers.valueAtIndexOrDefault instead.
 * @function Chart.helpers.getValueAtIndexOrDefault
 * @deprecated since version 2.7.0
 * @todo remove at version 3
 * @private
 */
helpers.getValueAtIndexOrDefault = helpers.valueAtIndexOrDefault;


/***/ })

});


// WEBPACK FOOTER //
// 2.06c2b12b32dfc25cbb52.js